(function(){"use strict";try{if(typeof document<"u"){var r=document.createElement("style");r.appendChild(document.createTextNode("._wrapper_1lmim_1{margin-bottom:var(--dixa-size-spacer-300)}._wrapperBox_1lmim_4{border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-300)}._wrapperBoxErrorBorder_1lmim_9{border-color:var(--dixa-typography-color-error)}")),document.head.appendChild(r)}}catch(e){console.error("vite-plugin-css-injected-by-js",e)}})();
import { isRunningLocalPartnerApi as BS, getPartnerDevApiHeaders as qS, WidgetContextProvider as HS, makeExecuteQuery as WS, makeUseLazyQuery as KS, makeUseQuery as GS, makeUseMutation as YS, validateApiHostName as Ib, useTracking as bn, useWidgetContext as mn, hasDownstreamApiForbiddenError as Fm, hasDownstreamApiAuthorizationError as Im, DisplayErrors as Fn, useCopyWithDelay as nr, defaultDateFormat as yt, displayAttributeValue as Xa, OAuthSettings as vi, useData as Em, useWidgetSettingsMutations as Tm, useWidgetSettingsQuery as $m, PartnerSettingsWrapper as Dm, handleWidgetSubmit as Rm, MisconfigurationBanner as Om, PartnerHookFormSecretText as Eb, WidgetSettingsFormFooter as Pm, isDownstreamApiNotFoundError as QS, isDownstreamApiAuthorizationError as Tb, KlaviyoSubscribeSetting as JS, isDownstreamApiPermissionError as XS, capitalizeFirstCharacter as $b, humanizeKey as ZS, hasDownstreamApiTooManyRequestsError as e0, hasDownstreamApiPermissionError as Db, hasDownstreamApiNotFoundError as io, getCountryNameFromCountryCode as n0, IntegrationModal as Rb, useInboundOAuthContext as t0, getWidgetConfigurationByIdQuery as r0, createWidgetConfigurationMutation as i0, updateWidgetConfigurationMutation as a0, deleteWidgetConfigurationMutation as o0 } from "lib-integrations-partner-support";
export * from "lib-integrations-partner-support";
import je, { useMemo as Bn, useState as se, useEffect as He, useRef as mi, useCallback as tt, useReducer as s0, useLayoutEffect as l0, useContext as Am, createContext as Ob, isValidElement as c0, createElement as d0, Fragment as u0 } from "react";
import { Text as A, FlexBox as b, Spinner as cn, Icon as me, Tooltip as Ge, List as Ke, Badge as Pn, Button as Wn, IconButton as Qt, Tag as An, NavigationButton as jt, Select as Sr, CollapseCard as lr, Box as Zn, Modal as wt, ModalHead as Ct, ModalBody as Ft, FormGrid as vt, FormField as ze, FieldWrapper as En, ModalFoot as Tt, InputText as _r, Textarea as Ku, TagsInput as Ds, Switch as Gu, FieldLabel as m0, InputSelectionList as Qr, Image as Wi, Banner as Rs, Divider as Lm, SelectionList as st, FieldText as cr, FieldTextarea as p0, CopyToClipboardButton as f0, getSelectionListContext as h0, Avatar as Vm, Timestamp as y0, Attachment as g0, EmptyState as us, Table as Jn, Checkbox as tf, TextWithHighlight as v0, ErrorBoundaryContext as Pb, FieldSwitch as Ab } from "@dixa/lib-shared-habla";
import { ApolloLink as zm, Observable as Lb, ApolloClient as k0, InMemoryCache as b0, createHttpLink as _0, ApolloProvider as x0, useApolloClient as S0, ApolloConsumer as N0, NetworkStatus as Yt, isApolloError as Vb, ApolloError as zb, gql as Os, useQuery as j0, useMutation as rf } from "@apollo/client";
import w0 from "cross-fetch";
import { config as Za } from "lib-shared-backend-config";
import rt from "classnames";
import Ln from "moment";
import "moment-timezone";
import { __rest as C0, __assign as rl } from "tslib";
import { useLocation as F0 } from "react-router-dom";
function Um(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var ko = { exports: {} }, na = {};
var af;
function I0() {
  if (af) return na;
  af = 1;
  var e = je, n = Symbol.for("react.element"), r = Symbol.for("react.fragment"), i = Object.prototype.hasOwnProperty, a = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, o = { key: !0, ref: !0, __self: !0, __source: !0 };
  function s(l, d, m) {
    var u, f = {}, h = null, v = null;
    m !== void 0 && (h = "" + m), d.key !== void 0 && (h = "" + d.key), d.ref !== void 0 && (v = d.ref);
    for (u in d) i.call(d, u) && !o.hasOwnProperty(u) && (f[u] = d[u]);
    if (l && l.defaultProps) for (u in d = l.defaultProps, d) f[u] === void 0 && (f[u] = d[u]);
    return { $$typeof: n, type: l, key: h, ref: v, props: f, _owner: a.current };
  }
  return na.Fragment = r, na.jsx = s, na.jsxs = s, na;
}
var ta = {};
var of;
function E0() {
  return of || (of = 1, process.env.NODE_ENV !== "production" && (function() {
    var e = je, n = Symbol.for("react.element"), r = Symbol.for("react.portal"), i = Symbol.for("react.fragment"), a = Symbol.for("react.strict_mode"), o = Symbol.for("react.profiler"), s = Symbol.for("react.provider"), l = Symbol.for("react.context"), d = Symbol.for("react.forward_ref"), m = Symbol.for("react.suspense"), u = Symbol.for("react.suspense_list"), f = Symbol.for("react.memo"), h = Symbol.for("react.lazy"), v = Symbol.for("react.offscreen"), C = Symbol.iterator, S = "@@iterator";
    function j(t) {
      if (t === null || typeof t != "object")
        return null;
      var c = C && t[C] || t[S];
      return typeof c == "function" ? c : null;
    }
    var F = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function y(t) {
      {
        for (var c = arguments.length, p = new Array(c > 1 ? c - 1 : 0), g = 1; g < c; g++)
          p[g - 1] = arguments[g];
        q("error", t, p);
      }
    }
    function q(t, c, p) {
      {
        var g = F.ReactDebugCurrentFrame, P = g.getStackAddendum();
        P !== "" && (c += "%s", p = p.concat([P]));
        var L = p.map(function(I) {
          return String(I);
        });
        L.unshift("Warning: " + c), Function.prototype.apply.call(console[t], console, L);
      }
    }
    var T = !1, E = !1, D = !1, B = !1, ee = !1, J;
    J = Symbol.for("react.module.reference");
    function ae(t) {
      return !!(typeof t == "string" || typeof t == "function" || t === i || t === o || ee || t === a || t === m || t === u || B || t === v || T || E || D || typeof t == "object" && t !== null && (t.$$typeof === h || t.$$typeof === f || t.$$typeof === s || t.$$typeof === l || t.$$typeof === d || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      t.$$typeof === J || t.getModuleId !== void 0));
    }
    function Q(t, c, p) {
      var g = t.displayName;
      if (g)
        return g;
      var P = c.displayName || c.name || "";
      return P !== "" ? p + "(" + P + ")" : p;
    }
    function U(t) {
      return t.displayName || "Context";
    }
    function O(t) {
      if (t == null)
        return null;
      if (typeof t.tag == "number" && y("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof t == "function")
        return t.displayName || t.name || null;
      if (typeof t == "string")
        return t;
      switch (t) {
        case i:
          return "Fragment";
        case r:
          return "Portal";
        case o:
          return "Profiler";
        case a:
          return "StrictMode";
        case m:
          return "Suspense";
        case u:
          return "SuspenseList";
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case l:
            var c = t;
            return U(c) + ".Consumer";
          case s:
            var p = t;
            return U(p._context) + ".Provider";
          case d:
            return Q(t, t.render, "ForwardRef");
          case f:
            var g = t.displayName || null;
            return g !== null ? g : O(t.type) || "Memo";
          case h: {
            var P = t, L = P._payload, I = P._init;
            try {
              return O(I(L));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var H = Object.assign, Z = 0, ye, ce, le, ue, W, ke, Ee;
    function K() {
    }
    K.__reactDisabledLog = !0;
    function qe() {
      {
        if (Z === 0) {
          ye = console.log, ce = console.info, le = console.warn, ue = console.error, W = console.group, ke = console.groupCollapsed, Ee = console.groupEnd;
          var t = {
            configurable: !0,
            enumerable: !0,
            value: K,
            writable: !0
          };
          Object.defineProperties(console, {
            info: t,
            log: t,
            warn: t,
            error: t,
            group: t,
            groupCollapsed: t,
            groupEnd: t
          });
        }
        Z++;
      }
    }
    function Be() {
      {
        if (Z--, Z === 0) {
          var t = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: H({}, t, {
              value: ye
            }),
            info: H({}, t, {
              value: ce
            }),
            warn: H({}, t, {
              value: le
            }),
            error: H({}, t, {
              value: ue
            }),
            group: H({}, t, {
              value: W
            }),
            groupCollapsed: H({}, t, {
              value: ke
            }),
            groupEnd: H({}, t, {
              value: Ee
            })
          });
        }
        Z < 0 && y("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var Pe = F.ReactCurrentDispatcher, Me;
    function Fe(t, c, p) {
      {
        if (Me === void 0)
          try {
            throw Error();
          } catch (P) {
            var g = P.stack.trim().match(/\n( *(at )?)/);
            Me = g && g[1] || "";
          }
        return `
` + Me + t;
      }
    }
    var Ae = !1, $e;
    {
      var tn = typeof WeakMap == "function" ? WeakMap : Map;
      $e = new tn();
    }
    function Ie(t, c) {
      if (!t || Ae)
        return "";
      {
        var p = $e.get(t);
        if (p !== void 0)
          return p;
      }
      var g;
      Ae = !0;
      var P = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var L;
      L = Pe.current, Pe.current = null, qe();
      try {
        if (c) {
          var I = function() {
            throw Error();
          };
          if (Object.defineProperty(I.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(I, []);
            } catch (ne) {
              g = ne;
            }
            Reflect.construct(t, [], I);
          } else {
            try {
              I.call();
            } catch (ne) {
              g = ne;
            }
            t.call(I.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (ne) {
            g = ne;
          }
          t();
        }
      } catch (ne) {
        if (ne && g && typeof ne.stack == "string") {
          for (var N = ne.stack.split(`
`), te = g.stack.split(`
`), x = N.length - 1, V = te.length - 1; x >= 1 && V >= 0 && N[x] !== te[V]; )
            V--;
          for (; x >= 1 && V >= 0; x--, V--)
            if (N[x] !== te[V]) {
              if (x !== 1 || V !== 1)
                do
                  if (x--, V--, V < 0 || N[x] !== te[V]) {
                    var X = `
` + N[x].replace(" at new ", " at ");
                    return t.displayName && X.includes("<anonymous>") && (X = X.replace("<anonymous>", t.displayName)), typeof t == "function" && $e.set(t, X), X;
                  }
                while (x >= 1 && V >= 0);
              break;
            }
        }
      } finally {
        Ae = !1, Pe.current = L, Be(), Error.prepareStackTrace = P;
      }
      var we = t ? t.displayName || t.name : "", Se = we ? Fe(we) : "";
      return typeof t == "function" && $e.set(t, Se), Se;
    }
    function We(t, c, p) {
      return Ie(t, !1);
    }
    function Ze(t) {
      var c = t.prototype;
      return !!(c && c.isReactComponent);
    }
    function de(t, c, p) {
      if (t == null)
        return "";
      if (typeof t == "function")
        return Ie(t, Ze(t));
      if (typeof t == "string")
        return Fe(t);
      switch (t) {
        case m:
          return Fe("Suspense");
        case u:
          return Fe("SuspenseList");
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case d:
            return We(t.render);
          case f:
            return de(t.type, c, p);
          case h: {
            var g = t, P = g._payload, L = g._init;
            try {
              return de(L(P), c, p);
            } catch {
            }
          }
        }
      return "";
    }
    var fe = Object.prototype.hasOwnProperty, Te = {}, Le = F.ReactDebugCurrentFrame;
    function Re(t) {
      if (t) {
        var c = t._owner, p = de(t.type, t._source, c ? c.type : null);
        Le.setExtraStackFrame(p);
      } else
        Le.setExtraStackFrame(null);
    }
    function sn(t, c, p, g, P) {
      {
        var L = Function.call.bind(fe);
        for (var I in t)
          if (L(t, I)) {
            var N = void 0;
            try {
              if (typeof t[I] != "function") {
                var te = Error((g || "React class") + ": " + p + " type `" + I + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof t[I] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw te.name = "Invariant Violation", te;
              }
              N = t[I](c, I, g, p, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (x) {
              N = x;
            }
            N && !(N instanceof Error) && (Re(P), y("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", g || "React class", p, I, typeof N), Re(null)), N instanceof Error && !(N.message in Te) && (Te[N.message] = !0, Re(P), y("Failed %s type: %s", p, N.message), Re(null));
          }
      }
    }
    var w = Array.isArray;
    function _(t) {
      return w(t);
    }
    function $(t) {
      {
        var c = typeof Symbol == "function" && Symbol.toStringTag, p = c && t[Symbol.toStringTag] || t.constructor.name || "Object";
        return p;
      }
    }
    function G(t) {
      try {
        return Y(t), !1;
      } catch {
        return !0;
      }
    }
    function Y(t) {
      return "" + t;
    }
    function R(t) {
      if (G(t))
        return y("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", $(t)), Y(t);
    }
    var z = F.ReactCurrentOwner, ie = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, pe, _e;
    function en(t) {
      if (fe.call(t, "ref")) {
        var c = Object.getOwnPropertyDescriptor(t, "ref").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.ref !== void 0;
    }
    function un(t) {
      if (fe.call(t, "key")) {
        var c = Object.getOwnPropertyDescriptor(t, "key").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.key !== void 0;
    }
    function rn(t, c) {
      typeof t.ref == "string" && z.current;
    }
    function dn(t, c) {
      {
        var p = function() {
          pe || (pe = !0, y("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "key", {
          get: p,
          configurable: !0
        });
      }
    }
    function pn(t, c) {
      {
        var p = function() {
          _e || (_e = !0, y("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "ref", {
          get: p,
          configurable: !0
        });
      }
    }
    var ln = function(t, c, p, g, P, L, I) {
      var N = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: n,
        // Built-in properties that belong on the element
        type: t,
        key: c,
        ref: p,
        props: I,
        // Record the component responsible for creating this element.
        _owner: L
      };
      return N._store = {}, Object.defineProperty(N._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(N, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: g
      }), Object.defineProperty(N, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: P
      }), Object.freeze && (Object.freeze(N.props), Object.freeze(N)), N;
    };
    function kn(t, c, p, g, P) {
      {
        var L, I = {}, N = null, te = null;
        p !== void 0 && (R(p), N = "" + p), un(c) && (R(c.key), N = "" + c.key), en(c) && (te = c.ref, rn(c, P));
        for (L in c)
          fe.call(c, L) && !ie.hasOwnProperty(L) && (I[L] = c[L]);
        if (t && t.defaultProps) {
          var x = t.defaultProps;
          for (L in x)
            I[L] === void 0 && (I[L] = x[L]);
        }
        if (N || te) {
          var V = typeof t == "function" ? t.displayName || t.name || "Unknown" : t;
          N && dn(I, V), te && pn(I, V);
        }
        return ln(t, N, te, P, g, z.current, I);
      }
    }
    var Xe = F.ReactCurrentOwner, Sn = F.ReactDebugCurrentFrame;
    function Oe(t) {
      if (t) {
        var c = t._owner, p = de(t.type, t._source, c ? c.type : null);
        Sn.setExtraStackFrame(p);
      } else
        Sn.setExtraStackFrame(null);
    }
    var an;
    an = !1;
    function on(t) {
      return typeof t == "object" && t !== null && t.$$typeof === n;
    }
    function yn() {
      {
        if (Xe.current) {
          var t = O(Xe.current.type);
          if (t)
            return `

Check the render method of \`` + t + "`.";
        }
        return "";
      }
    }
    function qn(t) {
      return "";
    }
    var Nn = {};
    function gn(t) {
      {
        var c = yn();
        if (!c) {
          var p = typeof t == "string" ? t : t.displayName || t.name;
          p && (c = `

Check the top-level render call using <` + p + ">.");
        }
        return c;
      }
    }
    function hn(t, c) {
      {
        if (!t._store || t._store.validated || t.key != null)
          return;
        t._store.validated = !0;
        var p = gn(c);
        if (Nn[p])
          return;
        Nn[p] = !0;
        var g = "";
        t && t._owner && t._owner !== Xe.current && (g = " It was passed a child from " + O(t._owner.type) + "."), Oe(t), y('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', p, g), Oe(null);
      }
    }
    function jn(t, c) {
      {
        if (typeof t != "object")
          return;
        if (_(t))
          for (var p = 0; p < t.length; p++) {
            var g = t[p];
            on(g) && hn(g, c);
          }
        else if (on(t))
          t._store && (t._store.validated = !0);
        else if (t) {
          var P = j(t);
          if (typeof P == "function" && P !== t.entries)
            for (var L = P.call(t), I; !(I = L.next()).done; )
              on(I.value) && hn(I.value, c);
        }
      }
    }
    function Un(t) {
      {
        var c = t.type;
        if (c == null || typeof c == "string")
          return;
        var p;
        if (typeof c == "function")
          p = c.propTypes;
        else if (typeof c == "object" && (c.$$typeof === d || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        c.$$typeof === f))
          p = c.propTypes;
        else
          return;
        if (p) {
          var g = O(c);
          sn(p, t.props, "prop", g, t);
        } else if (c.PropTypes !== void 0 && !an) {
          an = !0;
          var P = O(c);
          y("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", P || "Unknown");
        }
        typeof c.getDefaultProps == "function" && !c.getDefaultProps.isReactClassApproved && y("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function Vn(t) {
      {
        for (var c = Object.keys(t.props), p = 0; p < c.length; p++) {
          var g = c[p];
          if (g !== "children" && g !== "key") {
            Oe(t), y("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", g), Oe(null);
            break;
          }
        }
        t.ref !== null && (Oe(t), y("Invalid attribute `ref` supplied to `React.Fragment`."), Oe(null));
      }
    }
    var _n = {};
    function xn(t, c, p, g, P, L) {
      {
        var I = ae(t);
        if (!I) {
          var N = "";
          (t === void 0 || typeof t == "object" && t !== null && Object.keys(t).length === 0) && (N += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var te = qn();
          te ? N += te : N += yn();
          var x;
          t === null ? x = "null" : _(t) ? x = "array" : t !== void 0 && t.$$typeof === n ? (x = "<" + (O(t.type) || "Unknown") + " />", N = " Did you accidentally export a JSX literal instead of a component?") : x = typeof t, y("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", x, N);
        }
        var V = kn(t, c, p, P, L);
        if (V == null)
          return V;
        if (I) {
          var X = c.children;
          if (X !== void 0)
            if (g)
              if (_(X)) {
                for (var we = 0; we < X.length; we++)
                  jn(X[we], t);
                Object.freeze && Object.freeze(X);
              } else
                y("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              jn(X, t);
        }
        if (fe.call(c, "key")) {
          var Se = O(t), ne = Object.keys(c).filter(function(wn) {
            return wn !== "key";
          }), nn = ne.length > 0 ? "{key: someKey, " + ne.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!_n[Se + nn]) {
            var Tn = ne.length > 0 ? "{" + ne.join(": ..., ") + ": ...}" : "{}";
            y(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, nn, Se, Tn, Se), _n[Se + nn] = !0;
          }
        }
        return t === i ? Vn(V) : Un(V), V;
      }
    }
    function Hn(t, c, p) {
      return xn(t, c, p, !0);
    }
    function Dn(t, c, p) {
      return xn(t, c, p, !1);
    }
    var Rn = Dn, Mn = Hn;
    ta.Fragment = i, ta.jsx = Rn, ta.jsxs = Mn;
  })()), ta;
}
var sf;
function T0() {
  return sf || (sf = 1, process.env.NODE_ENV === "production" ? ko.exports = I0() : ko.exports = E0()), ko.exports;
}
var Ue = T0();
function Ub(e, n) {
  return function() {
    return e.apply(n, arguments);
  };
}
const { toString: $0 } = Object.prototype, { getPrototypeOf: Ps } = Object, { iterator: As, toStringTag: Mb } = Symbol, Ls = /* @__PURE__ */ ((e) => (n) => {
  const r = $0.call(n);
  return e[r] || (e[r] = r.slice(8, -1).toLowerCase());
})(/* @__PURE__ */ Object.create(null)), Nr = (e) => (e = e.toLowerCase(), (n) => Ls(n) === e), Vs = (e) => (n) => typeof n === e, { isArray: Ki } = Array, Ui = Vs("undefined");
function ao(e) {
  return e !== null && !Ui(e) && e.constructor !== null && !Ui(e.constructor) && Wt(e.constructor.isBuffer) && e.constructor.isBuffer(e);
}
const Bb = Nr("ArrayBuffer");
function D0(e) {
  let n;
  return typeof ArrayBuffer < "u" && ArrayBuffer.isView ? n = ArrayBuffer.isView(e) : n = e && e.buffer && Bb(e.buffer), n;
}
const R0 = Vs("string"), Wt = Vs("function"), qb = Vs("number"), oo = (e) => e !== null && typeof e == "object", O0 = (e) => e === !0 || e === !1, Yo = (e) => {
  if (Ls(e) !== "object")
    return !1;
  const n = Ps(e);
  return (n === null || n === Object.prototype || Object.getPrototypeOf(n) === null) && !(Mb in e) && !(As in e);
}, P0 = (e) => {
  if (!oo(e) || ao(e))
    return !1;
  try {
    return Object.keys(e).length === 0 && Object.getPrototypeOf(e) === Object.prototype;
  } catch {
    return !1;
  }
}, A0 = Nr("Date"), L0 = Nr("File"), V0 = (e) => !!(e && typeof e.uri < "u"), z0 = (e) => e && typeof e.getParts < "u", U0 = Nr("Blob"), M0 = Nr("FileList"), B0 = (e) => oo(e) && Wt(e.pipe);
function q0() {
  return typeof globalThis < "u" ? globalThis : typeof self < "u" ? self : typeof window < "u" ? window : typeof global < "u" ? global : {};
}
const lf = q0(), cf = typeof lf.FormData < "u" ? lf.FormData : void 0, H0 = (e) => {
  if (!e) return !1;
  if (cf && e instanceof cf) return !0;
  const n = Ps(e);
  if (!n || n === Object.prototype || !Wt(e.append)) return !1;
  const r = Ls(e);
  return r === "formdata" || // detect form-data instance
  r === "object" && Wt(e.toString) && e.toString() === "[object FormData]";
}, W0 = Nr("URLSearchParams"), [K0, G0, Y0, Q0] = [
  "ReadableStream",
  "Request",
  "Response",
  "Headers"
].map(Nr), J0 = (e) => e.trim ? e.trim() : e.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, "");
function so(e, n, { allOwnKeys: r = !1 } = {}) {
  if (e === null || typeof e > "u")
    return;
  let i, a;
  if (typeof e != "object" && (e = [e]), Ki(e))
    for (i = 0, a = e.length; i < a; i++)
      n.call(null, e[i], i, e);
  else {
    if (ao(e))
      return;
    const o = r ? Object.getOwnPropertyNames(e) : Object.keys(e), s = o.length;
    let l;
    for (i = 0; i < s; i++)
      l = o[i], n.call(null, e[l], l, e);
  }
}
function Hb(e, n) {
  if (ao(e))
    return null;
  n = n.toLowerCase();
  const r = Object.keys(e);
  let i = r.length, a;
  for (; i-- > 0; )
    if (a = r[i], n === a.toLowerCase())
      return a;
  return null;
}
const li = typeof globalThis < "u" ? globalThis : typeof self < "u" ? self : typeof window < "u" ? window : global, Wb = (e) => !Ui(e) && e !== li;
function Yu() {
  const { caseless: e, skipUndefined: n } = Wb(this) && this || {}, r = {}, i = (a, o) => {
    if (o === "__proto__" || o === "constructor" || o === "prototype")
      return;
    const s = e && Hb(r, o) || o;
    Yo(r[s]) && Yo(a) ? r[s] = Yu(r[s], a) : Yo(a) ? r[s] = Yu({}, a) : Ki(a) ? r[s] = a.slice() : (!n || !Ui(a)) && (r[s] = a);
  };
  for (let a = 0, o = arguments.length; a < o; a++)
    arguments[a] && so(arguments[a], i);
  return r;
}
const X0 = (e, n, r, { allOwnKeys: i } = {}) => (so(
  n,
  (a, o) => {
    r && Wt(a) ? Object.defineProperty(e, o, {
      value: Ub(a, r),
      writable: !0,
      enumerable: !0,
      configurable: !0
    }) : Object.defineProperty(e, o, {
      value: a,
      writable: !0,
      enumerable: !0,
      configurable: !0
    });
  },
  { allOwnKeys: i }
), e), Z0 = (e) => (e.charCodeAt(0) === 65279 && (e = e.slice(1)), e), eN = (e, n, r, i) => {
  e.prototype = Object.create(n.prototype, i), Object.defineProperty(e.prototype, "constructor", {
    value: e,
    writable: !0,
    enumerable: !1,
    configurable: !0
  }), Object.defineProperty(e, "super", {
    value: n.prototype
  }), r && Object.assign(e.prototype, r);
}, nN = (e, n, r, i) => {
  let a, o, s;
  const l = {};
  if (n = n || {}, e == null) return n;
  do {
    for (a = Object.getOwnPropertyNames(e), o = a.length; o-- > 0; )
      s = a[o], (!i || i(s, e, n)) && !l[s] && (n[s] = e[s], l[s] = !0);
    e = r !== !1 && Ps(e);
  } while (e && (!r || r(e, n)) && e !== Object.prototype);
  return n;
}, tN = (e, n, r) => {
  e = String(e), (r === void 0 || r > e.length) && (r = e.length), r -= n.length;
  const i = e.indexOf(n, r);
  return i !== -1 && i === r;
}, rN = (e) => {
  if (!e) return null;
  if (Ki(e)) return e;
  let n = e.length;
  if (!qb(n)) return null;
  const r = new Array(n);
  for (; n-- > 0; )
    r[n] = e[n];
  return r;
}, iN = /* @__PURE__ */ ((e) => (n) => e && n instanceof e)(typeof Uint8Array < "u" && Ps(Uint8Array)), aN = (e, n) => {
  const i = (e && e[As]).call(e);
  let a;
  for (; (a = i.next()) && !a.done; ) {
    const o = a.value;
    n.call(e, o[0], o[1]);
  }
}, oN = (e, n) => {
  let r;
  const i = [];
  for (; (r = e.exec(n)) !== null; )
    i.push(r);
  return i;
}, sN = Nr("HTMLFormElement"), lN = (e) => e.toLowerCase().replace(/[-_\s]([a-z\d])(\w*)/g, function(r, i, a) {
  return i.toUpperCase() + a;
}), df = (({ hasOwnProperty: e }) => (n, r) => e.call(n, r))(Object.prototype), cN = Nr("RegExp"), Kb = (e, n) => {
  const r = Object.getOwnPropertyDescriptors(e), i = {};
  so(r, (a, o) => {
    let s;
    (s = n(a, o, e)) !== !1 && (i[o] = s || a);
  }), Object.defineProperties(e, i);
}, dN = (e) => {
  Kb(e, (n, r) => {
    if (Wt(e) && ["arguments", "caller", "callee"].indexOf(r) !== -1)
      return !1;
    const i = e[r];
    if (Wt(i)) {
      if (n.enumerable = !1, "writable" in n) {
        n.writable = !1;
        return;
      }
      n.set || (n.set = () => {
        throw Error("Can not rewrite read-only method '" + r + "'");
      });
    }
  });
}, uN = (e, n) => {
  const r = {}, i = (a) => {
    a.forEach((o) => {
      r[o] = !0;
    });
  };
  return Ki(e) ? i(e) : i(String(e).split(n)), r;
}, mN = () => {
}, pN = (e, n) => e != null && Number.isFinite(e = +e) ? e : n;
function fN(e) {
  return !!(e && Wt(e.append) && e[Mb] === "FormData" && e[As]);
}
const hN = (e) => {
  const n = new Array(10), r = (i, a) => {
    if (oo(i)) {
      if (n.indexOf(i) >= 0)
        return;
      if (ao(i))
        return i;
      if (!("toJSON" in i)) {
        n[a] = i;
        const o = Ki(i) ? [] : {};
        return so(i, (s, l) => {
          const d = r(s, a + 1);
          !Ui(d) && (o[l] = d);
        }), n[a] = void 0, o;
      }
    }
    return i;
  };
  return r(e, 0);
}, yN = Nr("AsyncFunction"), gN = (e) => e && (oo(e) || Wt(e)) && Wt(e.then) && Wt(e.catch), Gb = ((e, n) => e ? setImmediate : n ? ((r, i) => (li.addEventListener(
  "message",
  ({ source: a, data: o }) => {
    a === li && o === r && i.length && i.shift()();
  },
  !1
), (a) => {
  i.push(a), li.postMessage(r, "*");
}))(`axios@${Math.random()}`, []) : (r) => setTimeout(r))(typeof setImmediate == "function", Wt(li.postMessage)), vN = typeof queueMicrotask < "u" ? queueMicrotask.bind(li) : typeof process < "u" && process.nextTick || Gb, kN = (e) => e != null && Wt(e[As]), ge = {
  isArray: Ki,
  isArrayBuffer: Bb,
  isBuffer: ao,
  isFormData: H0,
  isArrayBufferView: D0,
  isString: R0,
  isNumber: qb,
  isBoolean: O0,
  isObject: oo,
  isPlainObject: Yo,
  isEmptyObject: P0,
  isReadableStream: K0,
  isRequest: G0,
  isResponse: Y0,
  isHeaders: Q0,
  isUndefined: Ui,
  isDate: A0,
  isFile: L0,
  isReactNativeBlob: V0,
  isReactNative: z0,
  isBlob: U0,
  isRegExp: cN,
  isFunction: Wt,
  isStream: B0,
  isURLSearchParams: W0,
  isTypedArray: iN,
  isFileList: M0,
  forEach: so,
  merge: Yu,
  extend: X0,
  trim: J0,
  stripBOM: Z0,
  inherits: eN,
  toFlatObject: nN,
  kindOf: Ls,
  kindOfTest: Nr,
  endsWith: tN,
  toArray: rN,
  forEachEntry: aN,
  matchAll: oN,
  isHTMLForm: sN,
  hasOwnProperty: df,
  hasOwnProp: df,
  // an alias to avoid ESLint no-prototype-builtins detection
  reduceDescriptors: Kb,
  freezeMethods: dN,
  toObjectSet: uN,
  toCamelCase: lN,
  noop: mN,
  toFiniteNumber: pN,
  findKey: Hb,
  global: li,
  isContextDefined: Wb,
  isSpecCompliantForm: fN,
  toJSONObject: hN,
  isAsyncFn: yN,
  isThenable: gN,
  setImmediate: Gb,
  asap: vN,
  isIterable: kN
};
let fn = class Yb extends Error {
  static from(n, r, i, a, o, s) {
    const l = new Yb(n.message, r || n.code, i, a, o);
    return l.cause = n, l.name = n.name, n.status != null && l.status == null && (l.status = n.status), s && Object.assign(l, s), l;
  }
  /**
   * Create an Error with the specified message, config, error code, request and response.
   *
   * @param {string} message The error message.
   * @param {string} [code] The error code (for example, 'ECONNABORTED').
   * @param {Object} [config] The config.
   * @param {Object} [request] The request.
   * @param {Object} [response] The response.
   *
   * @returns {Error} The created error.
   */
  constructor(n, r, i, a, o) {
    super(n), Object.defineProperty(this, "message", {
      value: n,
      enumerable: !0,
      writable: !0,
      configurable: !0
    }), this.name = "AxiosError", this.isAxiosError = !0, r && (this.code = r), i && (this.config = i), a && (this.request = a), o && (this.response = o, this.status = o.status);
  }
  toJSON() {
    return {
      // Standard
      message: this.message,
      name: this.name,
      // Microsoft
      description: this.description,
      number: this.number,
      // Mozilla
      fileName: this.fileName,
      lineNumber: this.lineNumber,
      columnNumber: this.columnNumber,
      stack: this.stack,
      // Axios
      config: ge.toJSONObject(this.config),
      code: this.code,
      status: this.status
    };
  }
};
fn.ERR_BAD_OPTION_VALUE = "ERR_BAD_OPTION_VALUE";
fn.ERR_BAD_OPTION = "ERR_BAD_OPTION";
fn.ECONNABORTED = "ECONNABORTED";
fn.ETIMEDOUT = "ETIMEDOUT";
fn.ERR_NETWORK = "ERR_NETWORK";
fn.ERR_FR_TOO_MANY_REDIRECTS = "ERR_FR_TOO_MANY_REDIRECTS";
fn.ERR_DEPRECATED = "ERR_DEPRECATED";
fn.ERR_BAD_RESPONSE = "ERR_BAD_RESPONSE";
fn.ERR_BAD_REQUEST = "ERR_BAD_REQUEST";
fn.ERR_CANCELED = "ERR_CANCELED";
fn.ERR_NOT_SUPPORT = "ERR_NOT_SUPPORT";
fn.ERR_INVALID_URL = "ERR_INVALID_URL";
fn.ERR_FORM_DATA_DEPTH_EXCEEDED = "ERR_FORM_DATA_DEPTH_EXCEEDED";
const bN = null;
function Qu(e) {
  return ge.isPlainObject(e) || ge.isArray(e);
}
function Qb(e) {
  return ge.endsWith(e, "[]") ? e.slice(0, -2) : e;
}
function il(e, n, r) {
  return e ? e.concat(n).map(function(a, o) {
    return a = Qb(a), !r && o ? "[" + a + "]" : a;
  }).join(r ? "." : "") : n;
}
function _N(e) {
  return ge.isArray(e) && !e.some(Qu);
}
const xN = ge.toFlatObject(ge, {}, null, function(n) {
  return /^is[A-Z]/.test(n);
});
function zs(e, n, r) {
  if (!ge.isObject(e))
    throw new TypeError("target must be an object");
  n = n || new FormData(), r = ge.toFlatObject(
    r,
    {
      metaTokens: !0,
      dots: !1,
      indexes: !1
    },
    !1,
    function(j, F) {
      return !ge.isUndefined(F[j]);
    }
  );
  const i = r.metaTokens, a = r.visitor || f, o = r.dots, s = r.indexes, l = r.Blob || typeof Blob < "u" && Blob, d = r.maxDepth === void 0 ? 100 : r.maxDepth, m = l && ge.isSpecCompliantForm(n);
  if (!ge.isFunction(a))
    throw new TypeError("visitor must be a function");
  function u(S) {
    if (S === null) return "";
    if (ge.isDate(S))
      return S.toISOString();
    if (ge.isBoolean(S))
      return S.toString();
    if (!m && ge.isBlob(S))
      throw new fn("Blob is not supported. Use a Buffer instead.");
    return ge.isArrayBuffer(S) || ge.isTypedArray(S) ? m && typeof Blob == "function" ? new Blob([S]) : Buffer.from(S) : S;
  }
  function f(S, j, F) {
    let y = S;
    if (ge.isReactNative(n) && ge.isReactNativeBlob(S))
      return n.append(il(F, j, o), u(S)), !1;
    if (S && !F && typeof S == "object") {
      if (ge.endsWith(j, "{}"))
        j = i ? j : j.slice(0, -2), S = JSON.stringify(S);
      else if (ge.isArray(S) && _N(S) || (ge.isFileList(S) || ge.endsWith(j, "[]")) && (y = ge.toArray(S)))
        return j = Qb(j), y.forEach(function(T, E) {
          !(ge.isUndefined(T) || T === null) && n.append(
            // eslint-disable-next-line no-nested-ternary
            s === !0 ? il([j], E, o) : s === null ? j : j + "[]",
            u(T)
          );
        }), !1;
    }
    return Qu(S) ? !0 : (n.append(il(F, j, o), u(S)), !1);
  }
  const h = [], v = Object.assign(xN, {
    defaultVisitor: f,
    convertValue: u,
    isVisitable: Qu
  });
  function C(S, j, F = 0) {
    if (!ge.isUndefined(S)) {
      if (F > d)
        throw new fn(
          "Object is too deeply nested (" + F + " levels). Max depth: " + d,
          fn.ERR_FORM_DATA_DEPTH_EXCEEDED
        );
      if (h.indexOf(S) !== -1)
        throw Error("Circular reference detected in " + j.join("."));
      h.push(S), ge.forEach(S, function(q, T) {
        (!(ge.isUndefined(q) || q === null) && a.call(n, q, ge.isString(T) ? T.trim() : T, j, v)) === !0 && C(q, j ? j.concat(T) : [T], F + 1);
      }), h.pop();
    }
  }
  if (!ge.isObject(e))
    throw new TypeError("data must be an object");
  return C(e), n;
}
function uf(e) {
  const n = {
    "!": "%21",
    "'": "%27",
    "(": "%28",
    ")": "%29",
    "~": "%7E",
    "%20": "+"
  };
  return encodeURIComponent(e).replace(/[!'()~]|%20/g, function(i) {
    return n[i];
  });
}
function Mm(e, n) {
  this._pairs = [], e && zs(e, this, n);
}
const Jb = Mm.prototype;
Jb.append = function(n, r) {
  this._pairs.push([n, r]);
};
Jb.toString = function(n) {
  const r = n ? function(i) {
    return n.call(this, i, uf);
  } : uf;
  return this._pairs.map(function(a) {
    return r(a[0]) + "=" + r(a[1]);
  }, "").join("&");
};
function SN(e) {
  return encodeURIComponent(e).replace(/%3A/gi, ":").replace(/%24/g, "$").replace(/%2C/gi, ",").replace(/%20/g, "+");
}
function Xb(e, n, r) {
  if (!n)
    return e;
  const i = r && r.encode || SN, a = ge.isFunction(r) ? {
    serialize: r
  } : r, o = a && a.serialize;
  let s;
  if (o ? s = o(n, a) : s = ge.isURLSearchParams(n) ? n.toString() : new Mm(n, a).toString(i), s) {
    const l = e.indexOf("#");
    l !== -1 && (e = e.slice(0, l)), e += (e.indexOf("?") === -1 ? "?" : "&") + s;
  }
  return e;
}
class mf {
  constructor() {
    this.handlers = [];
  }
  /**
   * Add a new interceptor to the stack
   *
   * @param {Function} fulfilled The function to handle `then` for a `Promise`
   * @param {Function} rejected The function to handle `reject` for a `Promise`
   * @param {Object} options The options for the interceptor, synchronous and runWhen
   *
   * @return {Number} An ID used to remove interceptor later
   */
  use(n, r, i) {
    return this.handlers.push({
      fulfilled: n,
      rejected: r,
      synchronous: i ? i.synchronous : !1,
      runWhen: i ? i.runWhen : null
    }), this.handlers.length - 1;
  }
  /**
   * Remove an interceptor from the stack
   *
   * @param {Number} id The ID that was returned by `use`
   *
   * @returns {void}
   */
  eject(n) {
    this.handlers[n] && (this.handlers[n] = null);
  }
  /**
   * Clear all interceptors from the stack
   *
   * @returns {void}
   */
  clear() {
    this.handlers && (this.handlers = []);
  }
  /**
   * Iterate over all the registered interceptors
   *
   * This method is particularly useful for skipping over any
   * interceptors that may have become `null` calling `eject`.
   *
   * @param {Function} fn The function to call for each interceptor
   *
   * @returns {void}
   */
  forEach(n) {
    ge.forEach(this.handlers, function(i) {
      i !== null && n(i);
    });
  }
}
const Bm = {
  silentJSONParsing: !0,
  forcedJSONParsing: !0,
  clarifyTimeoutError: !1,
  legacyInterceptorReqResOrdering: !0
}, NN = typeof URLSearchParams < "u" ? URLSearchParams : Mm, jN = typeof FormData < "u" ? FormData : null, wN = typeof Blob < "u" ? Blob : null, CN = {
  isBrowser: !0,
  classes: {
    URLSearchParams: NN,
    FormData: jN,
    Blob: wN
  },
  protocols: ["http", "https", "file", "blob", "url", "data"]
}, qm = typeof window < "u" && typeof document < "u", Ju = typeof navigator == "object" && navigator || void 0, FN = qm && (!Ju || ["ReactNative", "NativeScript", "NS"].indexOf(Ju.product) < 0), IN = typeof WorkerGlobalScope < "u" && // eslint-disable-next-line no-undef
self instanceof WorkerGlobalScope && typeof self.importScripts == "function", EN = qm && window.location.href || "http://localhost", TN = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  hasBrowserEnv: qm,
  hasStandardBrowserEnv: FN,
  hasStandardBrowserWebWorkerEnv: IN,
  navigator: Ju,
  origin: EN
}, Symbol.toStringTag, { value: "Module" })), It = {
  ...TN,
  ...CN
};
function $N(e, n) {
  return zs(e, new It.classes.URLSearchParams(), {
    visitor: function(r, i, a, o) {
      return It.isNode && ge.isBuffer(r) ? (this.append(i, r.toString("base64")), !1) : o.defaultVisitor.apply(this, arguments);
    },
    ...n
  });
}
function DN(e) {
  return ge.matchAll(/\w+|\[(\w*)]/g, e).map((n) => n[0] === "[]" ? "" : n[1] || n[0]);
}
function RN(e) {
  const n = {}, r = Object.keys(e);
  let i;
  const a = r.length;
  let o;
  for (i = 0; i < a; i++)
    o = r[i], n[o] = e[o];
  return n;
}
function Zb(e) {
  function n(r, i, a, o) {
    let s = r[o++];
    if (s === "__proto__") return !0;
    const l = Number.isFinite(+s), d = o >= r.length;
    return s = !s && ge.isArray(a) ? a.length : s, d ? (ge.hasOwnProp(a, s) ? a[s] = ge.isArray(a[s]) ? a[s].concat(i) : [a[s], i] : a[s] = i, !l) : ((!a[s] || !ge.isObject(a[s])) && (a[s] = []), n(r, i, a[s], o) && ge.isArray(a[s]) && (a[s] = RN(a[s])), !l);
  }
  if (ge.isFormData(e) && ge.isFunction(e.entries)) {
    const r = {};
    return ge.forEachEntry(e, (i, a) => {
      n(DN(i), a, r, 0);
    }), r;
  }
  return null;
}
const Ni = (e, n) => e != null && ge.hasOwnProp(e, n) ? e[n] : void 0;
function ON(e, n, r) {
  if (ge.isString(e))
    try {
      return (n || JSON.parse)(e), ge.trim(e);
    } catch (i) {
      if (i.name !== "SyntaxError")
        throw i;
    }
  return (r || JSON.stringify)(e);
}
const lo = {
  transitional: Bm,
  adapter: ["xhr", "http", "fetch"],
  transformRequest: [
    function(n, r) {
      const i = r.getContentType() || "", a = i.indexOf("application/json") > -1, o = ge.isObject(n);
      if (o && ge.isHTMLForm(n) && (n = new FormData(n)), ge.isFormData(n))
        return a ? JSON.stringify(Zb(n)) : n;
      if (ge.isArrayBuffer(n) || ge.isBuffer(n) || ge.isStream(n) || ge.isFile(n) || ge.isBlob(n) || ge.isReadableStream(n))
        return n;
      if (ge.isArrayBufferView(n))
        return n.buffer;
      if (ge.isURLSearchParams(n))
        return r.setContentType("application/x-www-form-urlencoded;charset=utf-8", !1), n.toString();
      let l;
      if (o) {
        const d = Ni(this, "formSerializer");
        if (i.indexOf("application/x-www-form-urlencoded") > -1)
          return $N(n, d).toString();
        if ((l = ge.isFileList(n)) || i.indexOf("multipart/form-data") > -1) {
          const m = Ni(this, "env"), u = m && m.FormData;
          return zs(
            l ? { "files[]": n } : n,
            u && new u(),
            d
          );
        }
      }
      return o || a ? (r.setContentType("application/json", !1), ON(n)) : n;
    }
  ],
  transformResponse: [
    function(n) {
      const r = Ni(this, "transitional") || lo.transitional, i = r && r.forcedJSONParsing, a = Ni(this, "responseType"), o = a === "json";
      if (ge.isResponse(n) || ge.isReadableStream(n))
        return n;
      if (n && ge.isString(n) && (i && !a || o)) {
        const l = !(r && r.silentJSONParsing) && o;
        try {
          return JSON.parse(n, Ni(this, "parseReviver"));
        } catch (d) {
          if (l)
            throw d.name === "SyntaxError" ? fn.from(d, fn.ERR_BAD_RESPONSE, this, null, Ni(this, "response")) : d;
        }
      }
      return n;
    }
  ],
  /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */
  timeout: 0,
  xsrfCookieName: "XSRF-TOKEN",
  xsrfHeaderName: "X-XSRF-TOKEN",
  maxContentLength: -1,
  maxBodyLength: -1,
  env: {
    FormData: It.classes.FormData,
    Blob: It.classes.Blob
  },
  validateStatus: function(n) {
    return n >= 200 && n < 300;
  },
  headers: {
    common: {
      Accept: "application/json, text/plain, */*",
      "Content-Type": void 0
    }
  }
};
ge.forEach(["delete", "get", "head", "post", "put", "patch"], (e) => {
  lo.headers[e] = {};
});
const PN = ge.toObjectSet([
  "age",
  "authorization",
  "content-length",
  "content-type",
  "etag",
  "expires",
  "from",
  "host",
  "if-modified-since",
  "if-unmodified-since",
  "last-modified",
  "location",
  "max-forwards",
  "proxy-authorization",
  "referer",
  "retry-after",
  "user-agent"
]), AN = (e) => {
  const n = {};
  let r, i, a;
  return e && e.split(`
`).forEach(function(s) {
    a = s.indexOf(":"), r = s.substring(0, a).trim().toLowerCase(), i = s.substring(a + 1).trim(), !(!r || n[r] && PN[r]) && (r === "set-cookie" ? n[r] ? n[r].push(i) : n[r] = [i] : n[r] = n[r] ? n[r] + ", " + i : i);
  }), n;
}, pf = Symbol("internals"), LN = /[^\x09\x20-\x7E\x80-\xFF]/g;
function VN(e) {
  let n = 0, r = e.length;
  for (; n < r; ) {
    const i = e.charCodeAt(n);
    if (i !== 9 && i !== 32)
      break;
    n += 1;
  }
  for (; r > n; ) {
    const i = e.charCodeAt(r - 1);
    if (i !== 9 && i !== 32)
      break;
    r -= 1;
  }
  return n === 0 && r === e.length ? e : e.slice(n, r);
}
function ra(e) {
  return e && String(e).trim().toLowerCase();
}
function zN(e) {
  return VN(e.replace(LN, ""));
}
function Qo(e) {
  return e === !1 || e == null ? e : ge.isArray(e) ? e.map(Qo) : zN(String(e));
}
function UN(e) {
  const n = /* @__PURE__ */ Object.create(null), r = /([^\s,;=]+)\s*(?:=\s*([^,;]+))?/g;
  let i;
  for (; i = r.exec(e); )
    n[i[1]] = i[2];
  return n;
}
const MN = (e) => /^[-_a-zA-Z0-9^`|~,!#$%&'*+.]+$/.test(e.trim());
function al(e, n, r, i, a) {
  if (ge.isFunction(i))
    return i.call(this, n, r);
  if (a && (n = r), !!ge.isString(n)) {
    if (ge.isString(i))
      return n.indexOf(i) !== -1;
    if (ge.isRegExp(i))
      return i.test(n);
  }
}
function BN(e) {
  return e.trim().toLowerCase().replace(/([a-z\d])(\w*)/g, (n, r, i) => r.toUpperCase() + i);
}
function qN(e, n) {
  const r = ge.toCamelCase(" " + n);
  ["get", "set", "has"].forEach((i) => {
    Object.defineProperty(e, i + r, {
      value: function(a, o, s) {
        return this[i].call(this, n, a, o, s);
      },
      configurable: !0
    });
  });
}
let Kt = class {
  constructor(n) {
    n && this.set(n);
  }
  set(n, r, i) {
    const a = this;
    function o(l, d, m) {
      const u = ra(d);
      if (!u)
        throw new Error("header name must be a non-empty string");
      const f = ge.findKey(a, u);
      (!f || a[f] === void 0 || m === !0 || m === void 0 && a[f] !== !1) && (a[f || d] = Qo(l));
    }
    const s = (l, d) => ge.forEach(l, (m, u) => o(m, u, d));
    if (ge.isPlainObject(n) || n instanceof this.constructor)
      s(n, r);
    else if (ge.isString(n) && (n = n.trim()) && !MN(n))
      s(AN(n), r);
    else if (ge.isObject(n) && ge.isIterable(n)) {
      let l = {}, d, m;
      for (const u of n) {
        if (!ge.isArray(u))
          throw TypeError("Object iterator must return a key-value pair");
        l[m = u[0]] = (d = l[m]) ? ge.isArray(d) ? [...d, u[1]] : [d, u[1]] : u[1];
      }
      s(l, r);
    } else
      n != null && o(r, n, i);
    return this;
  }
  get(n, r) {
    if (n = ra(n), n) {
      const i = ge.findKey(this, n);
      if (i) {
        const a = this[i];
        if (!r)
          return a;
        if (r === !0)
          return UN(a);
        if (ge.isFunction(r))
          return r.call(this, a, i);
        if (ge.isRegExp(r))
          return r.exec(a);
        throw new TypeError("parser must be boolean|regexp|function");
      }
    }
  }
  has(n, r) {
    if (n = ra(n), n) {
      const i = ge.findKey(this, n);
      return !!(i && this[i] !== void 0 && (!r || al(this, this[i], i, r)));
    }
    return !1;
  }
  delete(n, r) {
    const i = this;
    let a = !1;
    function o(s) {
      if (s = ra(s), s) {
        const l = ge.findKey(i, s);
        l && (!r || al(i, i[l], l, r)) && (delete i[l], a = !0);
      }
    }
    return ge.isArray(n) ? n.forEach(o) : o(n), a;
  }
  clear(n) {
    const r = Object.keys(this);
    let i = r.length, a = !1;
    for (; i--; ) {
      const o = r[i];
      (!n || al(this, this[o], o, n, !0)) && (delete this[o], a = !0);
    }
    return a;
  }
  normalize(n) {
    const r = this, i = {};
    return ge.forEach(this, (a, o) => {
      const s = ge.findKey(i, o);
      if (s) {
        r[s] = Qo(a), delete r[o];
        return;
      }
      const l = n ? BN(o) : String(o).trim();
      l !== o && delete r[o], r[l] = Qo(a), i[l] = !0;
    }), this;
  }
  concat(...n) {
    return this.constructor.concat(this, ...n);
  }
  toJSON(n) {
    const r = /* @__PURE__ */ Object.create(null);
    return ge.forEach(this, (i, a) => {
      i != null && i !== !1 && (r[a] = n && ge.isArray(i) ? i.join(", ") : i);
    }), r;
  }
  [Symbol.iterator]() {
    return Object.entries(this.toJSON())[Symbol.iterator]();
  }
  toString() {
    return Object.entries(this.toJSON()).map(([n, r]) => n + ": " + r).join(`
`);
  }
  getSetCookie() {
    return this.get("set-cookie") || [];
  }
  get [Symbol.toStringTag]() {
    return "AxiosHeaders";
  }
  static from(n) {
    return n instanceof this ? n : new this(n);
  }
  static concat(n, ...r) {
    const i = new this(n);
    return r.forEach((a) => i.set(a)), i;
  }
  static accessor(n) {
    const i = (this[pf] = this[pf] = {
      accessors: {}
    }).accessors, a = this.prototype;
    function o(s) {
      const l = ra(s);
      i[l] || (qN(a, s), i[l] = !0);
    }
    return ge.isArray(n) ? n.forEach(o) : o(n), this;
  }
};
Kt.accessor([
  "Content-Type",
  "Content-Length",
  "Accept",
  "Accept-Encoding",
  "User-Agent",
  "Authorization"
]);
ge.reduceDescriptors(Kt.prototype, ({ value: e }, n) => {
  let r = n[0].toUpperCase() + n.slice(1);
  return {
    get: () => e,
    set(i) {
      this[r] = i;
    }
  };
});
ge.freezeMethods(Kt);
function ol(e, n) {
  const r = this || lo, i = n || r, a = Kt.from(i.headers);
  let o = i.data;
  return ge.forEach(e, function(l) {
    o = l.call(r, o, a.normalize(), n ? n.status : void 0);
  }), a.normalize(), o;
}
function e_(e) {
  return !!(e && e.__CANCEL__);
}
let co = class extends fn {
  /**
   * A `CanceledError` is an object that is thrown when an operation is canceled.
   *
   * @param {string=} message The message.
   * @param {Object=} config The config.
   * @param {Object=} request The request.
   *
   * @returns {CanceledError} The created error.
   */
  constructor(n, r, i) {
    super(n ?? "canceled", fn.ERR_CANCELED, r, i), this.name = "CanceledError", this.__CANCEL__ = !0;
  }
};
function n_(e, n, r) {
  const i = r.config.validateStatus;
  !r.status || !i || i(r.status) ? e(r) : n(
    new fn(
      "Request failed with status code " + r.status,
      [fn.ERR_BAD_REQUEST, fn.ERR_BAD_RESPONSE][Math.floor(r.status / 100) - 4],
      r.config,
      r.request,
      r
    )
  );
}
function HN(e) {
  const n = /^([-+\w]{1,25})(:?\/\/|:)/.exec(e);
  return n && n[1] || "";
}
function WN(e, n) {
  e = e || 10;
  const r = new Array(e), i = new Array(e);
  let a = 0, o = 0, s;
  return n = n !== void 0 ? n : 1e3, function(d) {
    const m = Date.now(), u = i[o];
    s || (s = m), r[a] = d, i[a] = m;
    let f = o, h = 0;
    for (; f !== a; )
      h += r[f++], f = f % e;
    if (a = (a + 1) % e, a === o && (o = (o + 1) % e), m - s < n)
      return;
    const v = u && m - u;
    return v ? Math.round(h * 1e3 / v) : void 0;
  };
}
function KN(e, n) {
  let r = 0, i = 1e3 / n, a, o;
  const s = (m, u = Date.now()) => {
    r = u, a = null, o && (clearTimeout(o), o = null), e(...m);
  };
  return [(...m) => {
    const u = Date.now(), f = u - r;
    f >= i ? s(m, u) : (a = m, o || (o = setTimeout(() => {
      o = null, s(a);
    }, i - f)));
  }, () => a && s(a)];
}
const ms = (e, n, r = 3) => {
  let i = 0;
  const a = WN(50, 250);
  return KN((o) => {
    const s = o.loaded, l = o.lengthComputable ? o.total : void 0, d = l != null ? Math.min(s, l) : s, m = Math.max(0, d - i), u = a(m);
    i = Math.max(i, d);
    const f = {
      loaded: d,
      total: l,
      progress: l ? d / l : void 0,
      bytes: m,
      rate: u || void 0,
      estimated: u && l ? (l - d) / u : void 0,
      event: o,
      lengthComputable: l != null,
      [n ? "download" : "upload"]: !0
    };
    e(f);
  }, r);
}, ff = (e, n) => {
  const r = e != null;
  return [
    (i) => n[0]({
      lengthComputable: r,
      total: e,
      loaded: i
    }),
    n[1]
  ];
}, hf = (e) => (...n) => ge.asap(() => e(...n)), GN = It.hasStandardBrowserEnv ? /* @__PURE__ */ ((e, n) => (r) => (r = new URL(r, It.origin), e.protocol === r.protocol && e.host === r.host && (n || e.port === r.port)))(
  new URL(It.origin),
  It.navigator && /(msie|trident)/i.test(It.navigator.userAgent)
) : () => !0, YN = It.hasStandardBrowserEnv ? (
  // Standard browser envs support document.cookie
  {
    write(e, n, r, i, a, o, s) {
      if (typeof document > "u") return;
      const l = [`${e}=${encodeURIComponent(n)}`];
      ge.isNumber(r) && l.push(`expires=${new Date(r).toUTCString()}`), ge.isString(i) && l.push(`path=${i}`), ge.isString(a) && l.push(`domain=${a}`), o === !0 && l.push("secure"), ge.isString(s) && l.push(`SameSite=${s}`), document.cookie = l.join("; ");
    },
    read(e) {
      if (typeof document > "u") return null;
      const n = document.cookie.match(new RegExp("(?:^|; )" + e + "=([^;]*)"));
      return n ? decodeURIComponent(n[1]) : null;
    },
    remove(e) {
      this.write(e, "", Date.now() - 864e5, "/");
    }
  }
) : (
  // Non-standard browser env (web workers, react-native) lack needed support.
  {
    write() {
    },
    read() {
      return null;
    },
    remove() {
    }
  }
);
function QN(e) {
  return typeof e != "string" ? !1 : /^([a-z][a-z\d+\-.]*:)?\/\//i.test(e);
}
function JN(e, n) {
  return n ? e.replace(/\/?\/$/, "") + "/" + n.replace(/^\/+/, "") : e;
}
function t_(e, n, r) {
  let i = !QN(n);
  return e && (i || r === !1) ? JN(e, n) : n;
}
const yf = (e) => e instanceof Kt ? { ...e } : e;
function gi(e, n) {
  n = n || {};
  const r = /* @__PURE__ */ Object.create(null);
  Object.defineProperty(r, "hasOwnProperty", {
    value: Object.prototype.hasOwnProperty,
    enumerable: !1,
    writable: !0,
    configurable: !0
  });
  function i(m, u, f, h) {
    return ge.isPlainObject(m) && ge.isPlainObject(u) ? ge.merge.call({ caseless: h }, m, u) : ge.isPlainObject(u) ? ge.merge({}, u) : ge.isArray(u) ? u.slice() : u;
  }
  function a(m, u, f, h) {
    if (ge.isUndefined(u)) {
      if (!ge.isUndefined(m))
        return i(void 0, m, f, h);
    } else return i(m, u, f, h);
  }
  function o(m, u) {
    if (!ge.isUndefined(u))
      return i(void 0, u);
  }
  function s(m, u) {
    if (ge.isUndefined(u)) {
      if (!ge.isUndefined(m))
        return i(void 0, m);
    } else return i(void 0, u);
  }
  function l(m, u, f) {
    if (ge.hasOwnProp(n, f))
      return i(m, u);
    if (ge.hasOwnProp(e, f))
      return i(void 0, m);
  }
  const d = {
    url: o,
    method: o,
    data: o,
    baseURL: s,
    transformRequest: s,
    transformResponse: s,
    paramsSerializer: s,
    timeout: s,
    timeoutMessage: s,
    withCredentials: s,
    withXSRFToken: s,
    adapter: s,
    responseType: s,
    xsrfCookieName: s,
    xsrfHeaderName: s,
    onUploadProgress: s,
    onDownloadProgress: s,
    decompress: s,
    maxContentLength: s,
    maxBodyLength: s,
    beforeRedirect: s,
    transport: s,
    httpAgent: s,
    httpsAgent: s,
    cancelToken: s,
    socketPath: s,
    allowedSocketPaths: s,
    responseEncoding: s,
    validateStatus: l,
    headers: (m, u, f) => a(yf(m), yf(u), f, !0)
  };
  return ge.forEach(Object.keys({ ...e, ...n }), function(u) {
    if (u === "__proto__" || u === "constructor" || u === "prototype") return;
    const f = ge.hasOwnProp(d, u) ? d[u] : a, h = ge.hasOwnProp(e, u) ? e[u] : void 0, v = ge.hasOwnProp(n, u) ? n[u] : void 0, C = f(h, v, u);
    ge.isUndefined(C) && f !== l || (r[u] = C);
  }), r;
}
const r_ = (e) => {
  const n = gi({}, e), r = (h) => ge.hasOwnProp(n, h) ? n[h] : void 0, i = r("data");
  let a = r("withXSRFToken");
  const o = r("xsrfHeaderName"), s = r("xsrfCookieName");
  let l = r("headers");
  const d = r("auth"), m = r("baseURL"), u = r("allowAbsoluteUrls"), f = r("url");
  if (n.headers = l = Kt.from(l), n.url = Xb(
    t_(m, f, u),
    e.params,
    e.paramsSerializer
  ), d && l.set(
    "Authorization",
    "Basic " + btoa(
      (d.username || "") + ":" + (d.password ? unescape(encodeURIComponent(d.password)) : "")
    )
  ), ge.isFormData(i)) {
    if (It.hasStandardBrowserEnv || It.hasStandardBrowserWebWorkerEnv)
      l.setContentType(void 0);
    else if (ge.isFunction(i.getHeaders)) {
      const h = i.getHeaders(), v = ["content-type", "content-length"];
      Object.entries(h).forEach(([C, S]) => {
        v.includes(C.toLowerCase()) && l.set(C, S);
      });
    }
  }
  if (It.hasStandardBrowserEnv && (ge.isFunction(a) && (a = a(n)), a === !0 || a == null && GN(n.url))) {
    const v = o && s && YN.read(s);
    v && l.set(o, v);
  }
  return n;
}, XN = typeof XMLHttpRequest < "u", ZN = XN && function(e) {
  return new Promise(function(r, i) {
    const a = r_(e);
    let o = a.data;
    const s = Kt.from(a.headers).normalize();
    let { responseType: l, onUploadProgress: d, onDownloadProgress: m } = a, u, f, h, v, C;
    function S() {
      v && v(), C && C(), a.cancelToken && a.cancelToken.unsubscribe(u), a.signal && a.signal.removeEventListener("abort", u);
    }
    let j = new XMLHttpRequest();
    j.open(a.method.toUpperCase(), a.url, !0), j.timeout = a.timeout;
    function F() {
      if (!j)
        return;
      const q = Kt.from(
        "getAllResponseHeaders" in j && j.getAllResponseHeaders()
      ), E = {
        data: !l || l === "text" || l === "json" ? j.responseText : j.response,
        status: j.status,
        statusText: j.statusText,
        headers: q,
        config: e,
        request: j
      };
      n_(
        function(B) {
          r(B), S();
        },
        function(B) {
          i(B), S();
        },
        E
      ), j = null;
    }
    "onloadend" in j ? j.onloadend = F : j.onreadystatechange = function() {
      !j || j.readyState !== 4 || j.status === 0 && !(j.responseURL && j.responseURL.indexOf("file:") === 0) || setTimeout(F);
    }, j.onabort = function() {
      j && (i(new fn("Request aborted", fn.ECONNABORTED, e, j)), j = null);
    }, j.onerror = function(T) {
      const E = T && T.message ? T.message : "Network Error", D = new fn(E, fn.ERR_NETWORK, e, j);
      D.event = T || null, i(D), j = null;
    }, j.ontimeout = function() {
      let T = a.timeout ? "timeout of " + a.timeout + "ms exceeded" : "timeout exceeded";
      const E = a.transitional || Bm;
      a.timeoutErrorMessage && (T = a.timeoutErrorMessage), i(
        new fn(
          T,
          E.clarifyTimeoutError ? fn.ETIMEDOUT : fn.ECONNABORTED,
          e,
          j
        )
      ), j = null;
    }, o === void 0 && s.setContentType(null), "setRequestHeader" in j && ge.forEach(s.toJSON(), function(T, E) {
      j.setRequestHeader(E, T);
    }), ge.isUndefined(a.withCredentials) || (j.withCredentials = !!a.withCredentials), l && l !== "json" && (j.responseType = a.responseType), m && ([h, C] = ms(m, !0), j.addEventListener("progress", h)), d && j.upload && ([f, v] = ms(d), j.upload.addEventListener("progress", f), j.upload.addEventListener("loadend", v)), (a.cancelToken || a.signal) && (u = (q) => {
      j && (i(!q || q.type ? new co(null, e, j) : q), j.abort(), j = null);
    }, a.cancelToken && a.cancelToken.subscribe(u), a.signal && (a.signal.aborted ? u() : a.signal.addEventListener("abort", u)));
    const y = HN(a.url);
    if (y && It.protocols.indexOf(y) === -1) {
      i(
        new fn(
          "Unsupported protocol " + y + ":",
          fn.ERR_BAD_REQUEST,
          e
        )
      );
      return;
    }
    j.send(o || null);
  });
}, ej = (e, n) => {
  const { length: r } = e = e ? e.filter(Boolean) : [];
  if (n || r) {
    let i = new AbortController(), a;
    const o = function(m) {
      if (!a) {
        a = !0, l();
        const u = m instanceof Error ? m : this.reason;
        i.abort(
          u instanceof fn ? u : new co(u instanceof Error ? u.message : u)
        );
      }
    };
    let s = n && setTimeout(() => {
      s = null, o(new fn(`timeout of ${n}ms exceeded`, fn.ETIMEDOUT));
    }, n);
    const l = () => {
      e && (s && clearTimeout(s), s = null, e.forEach((m) => {
        m.unsubscribe ? m.unsubscribe(o) : m.removeEventListener("abort", o);
      }), e = null);
    };
    e.forEach((m) => m.addEventListener("abort", o));
    const { signal: d } = i;
    return d.unsubscribe = () => ge.asap(l), d;
  }
}, nj = function* (e, n) {
  let r = e.byteLength;
  if (r < n) {
    yield e;
    return;
  }
  let i = 0, a;
  for (; i < r; )
    a = i + n, yield e.slice(i, a), i = a;
}, tj = async function* (e, n) {
  for await (const r of rj(e))
    yield* nj(r, n);
}, rj = async function* (e) {
  if (e[Symbol.asyncIterator]) {
    yield* e;
    return;
  }
  const n = e.getReader();
  try {
    for (; ; ) {
      const { done: r, value: i } = await n.read();
      if (r)
        break;
      yield i;
    }
  } finally {
    await n.cancel();
  }
}, gf = (e, n, r, i) => {
  const a = tj(e, n);
  let o = 0, s, l = (d) => {
    s || (s = !0, i && i(d));
  };
  return new ReadableStream(
    {
      async pull(d) {
        try {
          const { done: m, value: u } = await a.next();
          if (m) {
            l(), d.close();
            return;
          }
          let f = u.byteLength;
          if (r) {
            let h = o += f;
            r(h);
          }
          d.enqueue(new Uint8Array(u));
        } catch (m) {
          throw l(m), m;
        }
      },
      cancel(d) {
        return l(d), a.return();
      }
    },
    {
      highWaterMark: 2
    }
  );
}, vf = 64 * 1024, { isFunction: bo } = ge, ij = (({ Request: e, Response: n }) => ({
  Request: e,
  Response: n
}))(ge.global), { ReadableStream: kf, TextEncoder: bf } = ge.global, _f = (e, ...n) => {
  try {
    return !!e(...n);
  } catch {
    return !1;
  }
}, aj = (e) => {
  e = ge.merge.call(
    {
      skipUndefined: !0
    },
    ij,
    e
  );
  const { fetch: n, Request: r, Response: i } = e, a = n ? bo(n) : typeof fetch == "function", o = bo(r), s = bo(i);
  if (!a)
    return !1;
  const l = a && bo(kf), d = a && (typeof bf == "function" ? /* @__PURE__ */ ((C) => (S) => C.encode(S))(new bf()) : async (C) => new Uint8Array(await new r(C).arrayBuffer())), m = o && l && _f(() => {
    let C = !1;
    const S = new r(It.origin, {
      body: new kf(),
      method: "POST",
      get duplex() {
        return C = !0, "half";
      }
    }), j = S.headers.has("Content-Type");
    return S.body != null && S.body.cancel(), C && !j;
  }), u = s && l && _f(() => ge.isReadableStream(new i("").body)), f = {
    stream: u && ((C) => C.body)
  };
  a && ["text", "arrayBuffer", "blob", "formData", "stream"].forEach((C) => {
    !f[C] && (f[C] = (S, j) => {
      let F = S && S[C];
      if (F)
        return F.call(S);
      throw new fn(
        `Response type '${C}' is not supported`,
        fn.ERR_NOT_SUPPORT,
        j
      );
    });
  });
  const h = async (C) => {
    if (C == null)
      return 0;
    if (ge.isBlob(C))
      return C.size;
    if (ge.isSpecCompliantForm(C))
      return (await new r(It.origin, {
        method: "POST",
        body: C
      }).arrayBuffer()).byteLength;
    if (ge.isArrayBufferView(C) || ge.isArrayBuffer(C))
      return C.byteLength;
    if (ge.isURLSearchParams(C) && (C = C + ""), ge.isString(C))
      return (await d(C)).byteLength;
  }, v = async (C, S) => {
    const j = ge.toFiniteNumber(C.getContentLength());
    return j ?? h(S);
  };
  return async (C) => {
    let {
      url: S,
      method: j,
      data: F,
      signal: y,
      cancelToken: q,
      timeout: T,
      onDownloadProgress: E,
      onUploadProgress: D,
      responseType: B,
      headers: ee,
      withCredentials: J = "same-origin",
      fetchOptions: ae
    } = r_(C), Q = n || fetch;
    B = B ? (B + "").toLowerCase() : "text";
    let U = ej(
      [y, q && q.toAbortSignal()],
      T
    ), O = null;
    const H = U && U.unsubscribe && (() => {
      U.unsubscribe();
    });
    let Z;
    try {
      if (D && m && j !== "get" && j !== "head" && (Z = await v(ee, F)) !== 0) {
        let ke = new r(S, {
          method: "POST",
          body: F,
          duplex: "half"
        }), Ee;
        if (ge.isFormData(F) && (Ee = ke.headers.get("content-type")) && ee.setContentType(Ee), ke.body) {
          const [K, qe] = ff(
            Z,
            ms(hf(D))
          );
          F = gf(ke.body, vf, K, qe);
        }
      }
      ge.isString(J) || (J = J ? "include" : "omit");
      const ye = o && "credentials" in r.prototype;
      if (ge.isFormData(F)) {
        const ke = ee.getContentType();
        ke && /^multipart\/form-data/i.test(ke) && !/boundary=/i.test(ke) && ee.delete("content-type");
      }
      const ce = {
        ...ae,
        signal: U,
        method: j.toUpperCase(),
        headers: ee.normalize().toJSON(),
        body: F,
        duplex: "half",
        credentials: ye ? J : void 0
      };
      O = o && new r(S, ce);
      let le = await (o ? Q(O, ae) : Q(S, ce));
      const ue = u && (B === "stream" || B === "response");
      if (u && (E || ue && H)) {
        const ke = {};
        ["status", "statusText", "headers"].forEach((Be) => {
          ke[Be] = le[Be];
        });
        const Ee = ge.toFiniteNumber(le.headers.get("content-length")), [K, qe] = E && ff(
          Ee,
          ms(hf(E), !0)
        ) || [];
        le = new i(
          gf(le.body, vf, K, () => {
            qe && qe(), H && H();
          }),
          ke
        );
      }
      B = B || "text";
      let W = await f[ge.findKey(f, B) || "text"](
        le,
        C
      );
      return !ue && H && H(), await new Promise((ke, Ee) => {
        n_(ke, Ee, {
          data: W,
          headers: Kt.from(le.headers),
          status: le.status,
          statusText: le.statusText,
          config: C,
          request: O
        });
      });
    } catch (ye) {
      throw H && H(), ye && ye.name === "TypeError" && /Load failed|fetch/i.test(ye.message) ? Object.assign(
        new fn(
          "Network Error",
          fn.ERR_NETWORK,
          C,
          O,
          ye && ye.response
        ),
        {
          cause: ye.cause || ye
        }
      ) : fn.from(ye, ye && ye.code, C, O, ye && ye.response);
    }
  };
}, oj = /* @__PURE__ */ new Map(), i_ = (e) => {
  let n = e && e.env || {};
  const { fetch: r, Request: i, Response: a } = n, o = [i, a, r];
  let s = o.length, l = s, d, m, u = oj;
  for (; l--; )
    d = o[l], m = u.get(d), m === void 0 && u.set(d, m = l ? /* @__PURE__ */ new Map() : aj(n)), u = m;
  return m;
};
i_();
const Hm = {
  http: bN,
  xhr: ZN,
  fetch: {
    get: i_
  }
};
ge.forEach(Hm, (e, n) => {
  if (e) {
    try {
      Object.defineProperty(e, "name", { value: n });
    } catch {
    }
    Object.defineProperty(e, "adapterName", { value: n });
  }
});
const xf = (e) => `- ${e}`, sj = (e) => ge.isFunction(e) || e === null || e === !1;
function lj(e, n) {
  e = ge.isArray(e) ? e : [e];
  const { length: r } = e;
  let i, a;
  const o = {};
  for (let s = 0; s < r; s++) {
    i = e[s];
    let l;
    if (a = i, !sj(i) && (a = Hm[(l = String(i)).toLowerCase()], a === void 0))
      throw new fn(`Unknown adapter '${l}'`);
    if (a && (ge.isFunction(a) || (a = a.get(n))))
      break;
    o[l || "#" + s] = a;
  }
  if (!a) {
    const s = Object.entries(o).map(
      ([d, m]) => `adapter ${d} ` + (m === !1 ? "is not supported by the environment" : "is not available in the build")
    );
    let l = r ? s.length > 1 ? `since :
` + s.map(xf).join(`
`) : " " + xf(s[0]) : "as no adapter specified";
    throw new fn(
      "There is no suitable adapter to dispatch the request " + l,
      "ERR_NOT_SUPPORT"
    );
  }
  return a;
}
const a_ = {
  /**
   * Resolve an adapter from a list of adapter names or functions.
   * @type {Function}
   */
  getAdapter: lj,
  /**
   * Exposes all known adapters
   * @type {Object<string, Function|Object>}
   */
  adapters: Hm
};
function sl(e) {
  if (e.cancelToken && e.cancelToken.throwIfRequested(), e.signal && e.signal.aborted)
    throw new co(null, e);
}
function Sf(e) {
  return sl(e), e.headers = Kt.from(e.headers), e.data = ol.call(e, e.transformRequest), ["post", "put", "patch"].indexOf(e.method) !== -1 && e.headers.setContentType("application/x-www-form-urlencoded", !1), a_.getAdapter(e.adapter || lo.adapter, e)(e).then(
    function(i) {
      return sl(e), i.data = ol.call(e, e.transformResponse, i), i.headers = Kt.from(i.headers), i;
    },
    function(i) {
      return e_(i) || (sl(e), i && i.response && (i.response.data = ol.call(
        e,
        e.transformResponse,
        i.response
      ), i.response.headers = Kt.from(i.response.headers))), Promise.reject(i);
    }
  );
}
const o_ = "1.15.2", Us = {};
["object", "boolean", "number", "function", "string", "symbol"].forEach((e, n) => {
  Us[e] = function(i) {
    return typeof i === e || "a" + (n < 1 ? "n " : " ") + e;
  };
});
const Nf = {};
Us.transitional = function(n, r, i) {
  function a(o, s) {
    return "[Axios v" + o_ + "] Transitional option '" + o + "'" + s + (i ? ". " + i : "");
  }
  return (o, s, l) => {
    if (n === !1)
      throw new fn(
        a(s, " has been removed" + (r ? " in " + r : "")),
        fn.ERR_DEPRECATED
      );
    return r && !Nf[s] && (Nf[s] = !0, console.warn(
      a(
        s,
        " has been deprecated since v" + r + " and will be removed in the near future"
      )
    )), n ? n(o, s, l) : !0;
  };
};
Us.spelling = function(n) {
  return (r, i) => (console.warn(`${i} is likely a misspelling of ${n}`), !0);
};
function cj(e, n, r) {
  if (typeof e != "object")
    throw new fn("options must be an object", fn.ERR_BAD_OPTION_VALUE);
  const i = Object.keys(e);
  let a = i.length;
  for (; a-- > 0; ) {
    const o = i[a], s = Object.prototype.hasOwnProperty.call(n, o) ? n[o] : void 0;
    if (s) {
      const l = e[o], d = l === void 0 || s(l, o, e);
      if (d !== !0)
        throw new fn(
          "option " + o + " must be " + d,
          fn.ERR_BAD_OPTION_VALUE
        );
      continue;
    }
    if (r !== !0)
      throw new fn("Unknown option " + o, fn.ERR_BAD_OPTION);
  }
}
const Jo = {
  assertOptions: cj,
  validators: Us
}, rr = Jo.validators;
let pi = class {
  constructor(n) {
    this.defaults = n || {}, this.interceptors = {
      request: new mf(),
      response: new mf()
    };
  }
  /**
   * Dispatch a request
   *
   * @param {String|Object} configOrUrl The config specific for this request (merged with this.defaults)
   * @param {?Object} config
   *
   * @returns {Promise} The Promise to be fulfilled
   */
  async request(n, r) {
    try {
      return await this._request(n, r);
    } catch (i) {
      if (i instanceof Error) {
        let a = {};
        Error.captureStackTrace ? Error.captureStackTrace(a) : a = new Error();
        const o = (() => {
          if (!a.stack)
            return "";
          const s = a.stack.indexOf(`
`);
          return s === -1 ? "" : a.stack.slice(s + 1);
        })();
        try {
          if (!i.stack)
            i.stack = o;
          else if (o) {
            const s = o.indexOf(`
`), l = s === -1 ? -1 : o.indexOf(`
`, s + 1), d = l === -1 ? "" : o.slice(l + 1);
            String(i.stack).endsWith(d) || (i.stack += `
` + o);
          }
        } catch {
        }
      }
      throw i;
    }
  }
  _request(n, r) {
    typeof n == "string" ? (r = r || {}, r.url = n) : r = n || {}, r = gi(this.defaults, r);
    const { transitional: i, paramsSerializer: a, headers: o } = r;
    i !== void 0 && Jo.assertOptions(
      i,
      {
        silentJSONParsing: rr.transitional(rr.boolean),
        forcedJSONParsing: rr.transitional(rr.boolean),
        clarifyTimeoutError: rr.transitional(rr.boolean),
        legacyInterceptorReqResOrdering: rr.transitional(rr.boolean)
      },
      !1
    ), a != null && (ge.isFunction(a) ? r.paramsSerializer = {
      serialize: a
    } : Jo.assertOptions(
      a,
      {
        encode: rr.function,
        serialize: rr.function
      },
      !0
    )), r.allowAbsoluteUrls !== void 0 || (this.defaults.allowAbsoluteUrls !== void 0 ? r.allowAbsoluteUrls = this.defaults.allowAbsoluteUrls : r.allowAbsoluteUrls = !0), Jo.assertOptions(
      r,
      {
        baseUrl: rr.spelling("baseURL"),
        withXsrfToken: rr.spelling("withXSRFToken")
      },
      !0
    ), r.method = (r.method || this.defaults.method || "get").toLowerCase();
    let s = o && ge.merge(o.common, o[r.method]);
    o && ge.forEach(["delete", "get", "head", "post", "put", "patch", "common"], (C) => {
      delete o[C];
    }), r.headers = Kt.concat(s, o);
    const l = [];
    let d = !0;
    this.interceptors.request.forEach(function(S) {
      if (typeof S.runWhen == "function" && S.runWhen(r) === !1)
        return;
      d = d && S.synchronous;
      const j = r.transitional || Bm;
      j && j.legacyInterceptorReqResOrdering ? l.unshift(S.fulfilled, S.rejected) : l.push(S.fulfilled, S.rejected);
    });
    const m = [];
    this.interceptors.response.forEach(function(S) {
      m.push(S.fulfilled, S.rejected);
    });
    let u, f = 0, h;
    if (!d) {
      const C = [Sf.bind(this), void 0];
      for (C.unshift(...l), C.push(...m), h = C.length, u = Promise.resolve(r); f < h; )
        u = u.then(C[f++], C[f++]);
      return u;
    }
    h = l.length;
    let v = r;
    for (; f < h; ) {
      const C = l[f++], S = l[f++];
      try {
        v = C(v);
      } catch (j) {
        S.call(this, j);
        break;
      }
    }
    try {
      u = Sf.call(this, v);
    } catch (C) {
      return Promise.reject(C);
    }
    for (f = 0, h = m.length; f < h; )
      u = u.then(m[f++], m[f++]);
    return u;
  }
  getUri(n) {
    n = gi(this.defaults, n);
    const r = t_(n.baseURL, n.url, n.allowAbsoluteUrls);
    return Xb(r, n.params, n.paramsSerializer);
  }
};
ge.forEach(["delete", "get", "head", "options"], function(n) {
  pi.prototype[n] = function(r, i) {
    return this.request(
      gi(i || {}, {
        method: n,
        url: r,
        data: (i || {}).data
      })
    );
  };
});
ge.forEach(["post", "put", "patch"], function(n) {
  function r(i) {
    return function(o, s, l) {
      return this.request(
        gi(l || {}, {
          method: n,
          headers: i ? {
            "Content-Type": "multipart/form-data"
          } : {},
          url: o,
          data: s
        })
      );
    };
  }
  pi.prototype[n] = r(), pi.prototype[n + "Form"] = r(!0);
});
let dj = class s_ {
  constructor(n) {
    if (typeof n != "function")
      throw new TypeError("executor must be a function.");
    let r;
    this.promise = new Promise(function(o) {
      r = o;
    });
    const i = this;
    this.promise.then((a) => {
      if (!i._listeners) return;
      let o = i._listeners.length;
      for (; o-- > 0; )
        i._listeners[o](a);
      i._listeners = null;
    }), this.promise.then = (a) => {
      let o;
      const s = new Promise((l) => {
        i.subscribe(l), o = l;
      }).then(a);
      return s.cancel = function() {
        i.unsubscribe(o);
      }, s;
    }, n(function(o, s, l) {
      i.reason || (i.reason = new co(o, s, l), r(i.reason));
    });
  }
  /**
   * Throws a `CanceledError` if cancellation has been requested.
   */
  throwIfRequested() {
    if (this.reason)
      throw this.reason;
  }
  /**
   * Subscribe to the cancel signal
   */
  subscribe(n) {
    if (this.reason) {
      n(this.reason);
      return;
    }
    this._listeners ? this._listeners.push(n) : this._listeners = [n];
  }
  /**
   * Unsubscribe from the cancel signal
   */
  unsubscribe(n) {
    if (!this._listeners)
      return;
    const r = this._listeners.indexOf(n);
    r !== -1 && this._listeners.splice(r, 1);
  }
  toAbortSignal() {
    const n = new AbortController(), r = (i) => {
      n.abort(i);
    };
    return this.subscribe(r), n.signal.unsubscribe = () => this.unsubscribe(r), n.signal;
  }
  /**
   * Returns an object that contains a new `CancelToken` and a function that, when called,
   * cancels the `CancelToken`.
   */
  static source() {
    let n;
    return {
      token: new s_(function(a) {
        n = a;
      }),
      cancel: n
    };
  }
};
function uj(e) {
  return function(r) {
    return e.apply(null, r);
  };
}
function mj(e) {
  return ge.isObject(e) && e.isAxiosError === !0;
}
const Xu = {
  Continue: 100,
  SwitchingProtocols: 101,
  Processing: 102,
  EarlyHints: 103,
  Ok: 200,
  Created: 201,
  Accepted: 202,
  NonAuthoritativeInformation: 203,
  NoContent: 204,
  ResetContent: 205,
  PartialContent: 206,
  MultiStatus: 207,
  AlreadyReported: 208,
  ImUsed: 226,
  MultipleChoices: 300,
  MovedPermanently: 301,
  Found: 302,
  SeeOther: 303,
  NotModified: 304,
  UseProxy: 305,
  Unused: 306,
  TemporaryRedirect: 307,
  PermanentRedirect: 308,
  BadRequest: 400,
  Unauthorized: 401,
  PaymentRequired: 402,
  Forbidden: 403,
  NotFound: 404,
  MethodNotAllowed: 405,
  NotAcceptable: 406,
  ProxyAuthenticationRequired: 407,
  RequestTimeout: 408,
  Conflict: 409,
  Gone: 410,
  LengthRequired: 411,
  PreconditionFailed: 412,
  PayloadTooLarge: 413,
  UriTooLong: 414,
  UnsupportedMediaType: 415,
  RangeNotSatisfiable: 416,
  ExpectationFailed: 417,
  ImATeapot: 418,
  MisdirectedRequest: 421,
  UnprocessableEntity: 422,
  Locked: 423,
  FailedDependency: 424,
  TooEarly: 425,
  UpgradeRequired: 426,
  PreconditionRequired: 428,
  TooManyRequests: 429,
  RequestHeaderFieldsTooLarge: 431,
  UnavailableForLegalReasons: 451,
  InternalServerError: 500,
  NotImplemented: 501,
  BadGateway: 502,
  ServiceUnavailable: 503,
  GatewayTimeout: 504,
  HttpVersionNotSupported: 505,
  VariantAlsoNegotiates: 506,
  InsufficientStorage: 507,
  LoopDetected: 508,
  NotExtended: 510,
  NetworkAuthenticationRequired: 511,
  WebServerIsDown: 521,
  ConnectionTimedOut: 522,
  OriginIsUnreachable: 523,
  TimeoutOccurred: 524,
  SslHandshakeFailed: 525,
  InvalidSslCertificate: 526
};
Object.entries(Xu).forEach(([e, n]) => {
  Xu[n] = e;
});
function l_(e) {
  const n = new pi(e), r = Ub(pi.prototype.request, n);
  return ge.extend(r, pi.prototype, n, { allOwnKeys: !0 }), ge.extend(r, n, null, { allOwnKeys: !0 }), r.create = function(a) {
    return l_(gi(e, a));
  }, r;
}
const ut = l_(lo);
ut.Axios = pi;
ut.CanceledError = co;
ut.CancelToken = dj;
ut.isCancel = e_;
ut.VERSION = o_;
ut.toFormData = zs;
ut.AxiosError = fn;
ut.Cancel = ut.CanceledError;
ut.all = function(n) {
  return Promise.all(n);
};
ut.spread = uj;
ut.isAxiosError = mj;
ut.mergeConfig = gi;
ut.AxiosHeaders = Kt;
ut.formToJSON = (e) => Zb(ge.isHTMLForm(e) ? new FormData(e) : e);
ut.getAdapter = a_.getAdapter;
ut.HttpStatusCode = Xu;
ut.default = ut;
const {
  Axios: tB,
  AxiosError: rB,
  CanceledError: iB,
  isCancel: aB,
  CancelToken: oB,
  VERSION: sB,
  all: lB,
  Cancel: cB,
  isAxiosError: pj,
  spread: dB,
  toFormData: uB,
  AxiosHeaders: mB,
  HttpStatusCode: pB,
  formToJSON: fB,
  getAdapter: hB,
  mergeConfig: yB
} = ut;
class fj {
  /** Checks whether the app is running as an electron application. */
  isElectron() {
    return window.electron ? !!window.electron : !!process?.versions?.electron || /electron/i.test(navigator.userAgent);
  }
  /**
   * Gets the electron version.
   *
   * version 0.0.0 represents a unsupported version
   */
  async getVersion() {
    return window.electron ? (await window.electron.getVersion()).split("-")[0] : "0.0.0";
  }
  /** Checks if the running Electron build is a standalone (non auto-updating windows version) */
  async isStandaloneBuild() {
    return window.electron?.isStandaloneBuild ? await window.electron.isStandaloneBuild() : null;
  }
  /** Checks if the running Electron build is installed from an windows MSI installer */
  async isMsiBuild() {
    return window.electron?.isMsiBuild ? await window.electron.isMsiBuild() : null;
  }
}
const jf = new fj();
function hj(e, n) {
  return wf(e), wf(n), e.localeCompare(n, void 0, {
    numeric: !0
  });
}
function wf(e) {
  if (e.split(".").length !== 3)
    throw Error(`The version '${e}' must be in the format 'x.x.x'.`);
}
const yj = Object.prototype.toString;
function gj(e, n) {
  return yj.call(e) === `[object ${n}]`;
}
function vj(e) {
  return gj(e, "Object");
}
function kj(e) {
  return !!(e && e.then && typeof e.then == "function");
}
const Ua = "8.36.0", Hr = globalThis;
function Wm(e, n, r) {
  const i = r || Hr, a = i.__SENTRY__ = i.__SENTRY__ || {}, o = a[Ua] = a[Ua] || {};
  return o[e] || (o[e] = n());
}
const c_ = typeof __SENTRY_DEBUG__ > "u" || __SENTRY_DEBUG__, bj = "Sentry Logger ", Cf = [
  "debug",
  "info",
  "warn",
  "error",
  "log",
  "assert",
  "trace"
], Ff = {};
function d_(e) {
  if (!("console" in Hr))
    return e();
  const n = Hr.console, r = {}, i = Object.keys(Ff);
  i.forEach((a) => {
    const o = Ff[a];
    r[a] = n[a], n[a] = o;
  });
  try {
    return e();
  } finally {
    i.forEach((a) => {
      n[a] = r[a];
    });
  }
}
function _j() {
  let e = !1;
  const n = {
    enable: () => {
      e = !0;
    },
    disable: () => {
      e = !1;
    },
    isEnabled: () => e
  };
  return c_ ? Cf.forEach((r) => {
    n[r] = (...i) => {
      e && d_(() => {
        Hr.console[r](`${bj}[${r}]:`, ...i);
      });
    };
  }) : Cf.forEach((r) => {
    n[r] = () => {
    };
  }), n;
}
const Xo = Wm("logger", _j);
function xj(e, n, r) {
  try {
    Object.defineProperty(e, n, {
      // enumerable: false, // the default, so we can save on bundle size by not explicitly setting it
      value: r,
      writable: !0,
      configurable: !0
    });
  } catch {
    c_ && Xo.log(`Failed to add non-enumerable property "${n}" to object`, e);
  }
}
const u_ = 1e3;
function Km() {
  return Date.now() / u_;
}
function Sj() {
  const { performance: e } = Hr;
  if (!e || !e.now)
    return Km;
  const n = Date.now() - e.now(), r = e.timeOrigin == null ? n : e.timeOrigin;
  return () => (r + e.now()) / u_;
}
const Nj = Sj();
(() => {
  const { performance: e } = Hr;
  if (!e || !e.now)
    return;
  const n = 3600 * 1e3, r = e.now(), i = Date.now(), a = e.timeOrigin ? Math.abs(e.timeOrigin + r - i) : n, o = a < n, s = e.timing && e.timing.navigationStart, d = typeof s == "number" ? Math.abs(s + r - i) : n, m = d < n;
  return o || m ? a <= d ? e.timeOrigin : s : i;
})();
function Pi() {
  const e = Hr, n = e.crypto || e.msCrypto;
  let r = () => Math.random() * 16;
  try {
    if (n && n.randomUUID)
      return n.randomUUID().replace(/-/g, "");
    n && n.getRandomValues && (r = () => {
      const i = new Uint8Array(1);
      return n.getRandomValues(i), i[0];
    });
  } catch {
  }
  return ("10000000100040008000" + 1e11).replace(
    /[018]/g,
    (i) => (
      // eslint-disable-next-line no-bitwise
      (i ^ (r() & 15) >> i / 4).toString(16)
    )
  );
}
function If() {
  return {
    traceId: Pi(),
    spanId: Pi().substring(16)
  };
}
function Gm() {
  return Ym(Hr), Hr;
}
function Ym(e) {
  const n = e.__SENTRY__ = e.__SENTRY__ || {};
  return n.version = n.version || Ua, n[Ua] = n[Ua] || {};
}
function jj(e, n = {}) {
  if (n.user && (!e.ipAddress && n.user.ip_address && (e.ipAddress = n.user.ip_address), !e.did && !n.did && (e.did = n.user.id || n.user.email || n.user.username)), e.timestamp = n.timestamp || Nj(), n.abnormal_mechanism && (e.abnormal_mechanism = n.abnormal_mechanism), n.ignoreDuration && (e.ignoreDuration = n.ignoreDuration), n.sid && (e.sid = n.sid.length === 32 ? n.sid : Pi()), n.init !== void 0 && (e.init = n.init), !e.did && n.did && (e.did = `${n.did}`), typeof n.started == "number" && (e.started = n.started), e.ignoreDuration)
    e.duration = void 0;
  else if (typeof n.duration == "number")
    e.duration = n.duration;
  else {
    const r = e.timestamp - e.started;
    e.duration = r >= 0 ? r : 0;
  }
  n.release && (e.release = n.release), n.environment && (e.environment = n.environment), !e.ipAddress && n.ipAddress && (e.ipAddress = n.ipAddress), !e.userAgent && n.userAgent && (e.userAgent = n.userAgent), typeof n.errors == "number" && (e.errors = n.errors), n.status && (e.status = n.status);
}
const Zu = "_sentrySpan";
function Ef(e, n) {
  n ? xj(e, Zu, n) : delete e[Zu];
}
function Tf(e) {
  return e[Zu];
}
const wj = 100;
class Qm {
  /** Flag if notifying is happening. */
  /** Callback for client to receive scope changes. */
  /** Callback list that will be called during event processing. */
  /** Array of breadcrumbs. */
  /** User */
  /** Tags */
  /** Extra */
  /** Contexts */
  /** Attachments */
  /** Propagation Context for distributed tracing */
  /**
   * A place to stash data which is needed at some point in the SDK's event processing pipeline but which shouldn't get
   * sent to Sentry
   */
  /** Fingerprint */
  /** Severity */
  /**
   * Transaction Name
   *
   * IMPORTANT: The transaction name on the scope has nothing to do with root spans/transaction objects.
   * It's purpose is to assign a transaction to the scope that's added to non-transaction events.
   */
  /** Session */
  /** Request Mode Session Status */
  /** The client on this scope */
  /** Contains the last event id of a captured event.  */
  // NOTE: Any field which gets added here should get added not only to the constructor but also to the `clone` method.
  constructor() {
    this._notifyingListeners = !1, this._scopeListeners = [], this._eventProcessors = [], this._breadcrumbs = [], this._attachments = [], this._user = {}, this._tags = {}, this._extra = {}, this._contexts = {}, this._sdkProcessingMetadata = {}, this._propagationContext = If();
  }
  /**
   * @inheritDoc
   */
  clone() {
    const n = new Qm();
    return n._breadcrumbs = [...this._breadcrumbs], n._tags = { ...this._tags }, n._extra = { ...this._extra }, n._contexts = { ...this._contexts }, n._user = this._user, n._level = this._level, n._session = this._session, n._transactionName = this._transactionName, n._fingerprint = this._fingerprint, n._eventProcessors = [...this._eventProcessors], n._requestSession = this._requestSession, n._attachments = [...this._attachments], n._sdkProcessingMetadata = { ...this._sdkProcessingMetadata }, n._propagationContext = { ...this._propagationContext }, n._client = this._client, n._lastEventId = this._lastEventId, Ef(n, Tf(this)), n;
  }
  /**
   * @inheritDoc
   */
  setClient(n) {
    this._client = n;
  }
  /**
   * @inheritDoc
   */
  setLastEventId(n) {
    this._lastEventId = n;
  }
  /**
   * @inheritDoc
   */
  getClient() {
    return this._client;
  }
  /**
   * @inheritDoc
   */
  lastEventId() {
    return this._lastEventId;
  }
  /**
   * @inheritDoc
   */
  addScopeListener(n) {
    this._scopeListeners.push(n);
  }
  /**
   * @inheritDoc
   */
  addEventProcessor(n) {
    return this._eventProcessors.push(n), this;
  }
  /**
   * @inheritDoc
   */
  setUser(n) {
    return this._user = n || {
      email: void 0,
      id: void 0,
      ip_address: void 0,
      username: void 0
    }, this._session && jj(this._session, { user: n }), this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  getUser() {
    return this._user;
  }
  /**
   * @inheritDoc
   */
  getRequestSession() {
    return this._requestSession;
  }
  /**
   * @inheritDoc
   */
  setRequestSession(n) {
    return this._requestSession = n, this;
  }
  /**
   * @inheritDoc
   */
  setTags(n) {
    return this._tags = {
      ...this._tags,
      ...n
    }, this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  setTag(n, r) {
    return this._tags = { ...this._tags, [n]: r }, this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  setExtras(n) {
    return this._extra = {
      ...this._extra,
      ...n
    }, this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  setExtra(n, r) {
    return this._extra = { ...this._extra, [n]: r }, this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  setFingerprint(n) {
    return this._fingerprint = n, this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  setLevel(n) {
    return this._level = n, this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  setTransactionName(n) {
    return this._transactionName = n, this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  setContext(n, r) {
    return r === null ? delete this._contexts[n] : this._contexts[n] = r, this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  setSession(n) {
    return n ? this._session = n : delete this._session, this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  getSession() {
    return this._session;
  }
  /**
   * @inheritDoc
   */
  update(n) {
    if (!n)
      return this;
    const r = typeof n == "function" ? n(this) : n, [i, a] = r instanceof Mi ? [r.getScopeData(), r.getRequestSession()] : vj(r) ? [n, n.requestSession] : [], { tags: o, extra: s, user: l, contexts: d, level: m, fingerprint: u = [], propagationContext: f } = i || {};
    return this._tags = { ...this._tags, ...o }, this._extra = { ...this._extra, ...s }, this._contexts = { ...this._contexts, ...d }, l && Object.keys(l).length && (this._user = l), m && (this._level = m), u.length && (this._fingerprint = u), f && (this._propagationContext = f), a && (this._requestSession = a), this;
  }
  /**
   * @inheritDoc
   */
  clear() {
    return this._breadcrumbs = [], this._tags = {}, this._extra = {}, this._user = {}, this._contexts = {}, this._level = void 0, this._transactionName = void 0, this._fingerprint = void 0, this._requestSession = void 0, this._session = void 0, Ef(this, void 0), this._attachments = [], this._propagationContext = If(), this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  addBreadcrumb(n, r) {
    const i = typeof r == "number" ? r : wj;
    if (i <= 0)
      return this;
    const a = {
      timestamp: Km(),
      ...n
    }, o = this._breadcrumbs;
    return o.push(a), this._breadcrumbs = o.length > i ? o.slice(-i) : o, this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  getLastBreadcrumb() {
    return this._breadcrumbs[this._breadcrumbs.length - 1];
  }
  /**
   * @inheritDoc
   */
  clearBreadcrumbs() {
    return this._breadcrumbs = [], this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  addAttachment(n) {
    return this._attachments.push(n), this;
  }
  /**
   * @inheritDoc
   */
  clearAttachments() {
    return this._attachments = [], this;
  }
  /** @inheritDoc */
  getScopeData() {
    return {
      breadcrumbs: this._breadcrumbs,
      attachments: this._attachments,
      contexts: this._contexts,
      tags: this._tags,
      extra: this._extra,
      user: this._user,
      level: this._level,
      fingerprint: this._fingerprint || [],
      eventProcessors: this._eventProcessors,
      propagationContext: this._propagationContext,
      sdkProcessingMetadata: this._sdkProcessingMetadata,
      transactionName: this._transactionName,
      span: Tf(this)
    };
  }
  /**
   * @inheritDoc
   */
  setSDKProcessingMetadata(n) {
    return this._sdkProcessingMetadata = { ...this._sdkProcessingMetadata, ...n }, this;
  }
  /**
   * @inheritDoc
   */
  setPropagationContext(n) {
    return this._propagationContext = n, this;
  }
  /**
   * @inheritDoc
   */
  getPropagationContext() {
    return this._propagationContext;
  }
  /**
   * @inheritDoc
   */
  captureException(n, r) {
    const i = r && r.event_id ? r.event_id : Pi();
    if (!this._client)
      return Xo.warn("No client configured on scope - will not capture exception!"), i;
    const a = new Error("Sentry syntheticException");
    return this._client.captureException(
      n,
      {
        originalException: n,
        syntheticException: a,
        ...r,
        event_id: i
      },
      this
    ), i;
  }
  /**
   * @inheritDoc
   */
  captureMessage(n, r, i) {
    const a = i && i.event_id ? i.event_id : Pi();
    if (!this._client)
      return Xo.warn("No client configured on scope - will not capture message!"), a;
    const o = new Error(n);
    return this._client.captureMessage(
      n,
      r,
      {
        originalException: n,
        syntheticException: o,
        ...i,
        event_id: a
      },
      this
    ), a;
  }
  /**
   * @inheritDoc
   */
  captureEvent(n, r) {
    const i = r && r.event_id ? r.event_id : Pi();
    return this._client ? (this._client.captureEvent(n, { ...r, event_id: i }, this), i) : (Xo.warn("No client configured on scope - will not capture event!"), i);
  }
  /**
   * This will be called on every set call.
   */
  _notifyScopeListeners() {
    this._notifyingListeners || (this._notifyingListeners = !0, this._scopeListeners.forEach((n) => {
      n(this);
    }), this._notifyingListeners = !1);
  }
}
const Mi = Qm;
function Cj() {
  return Wm("defaultCurrentScope", () => new Mi());
}
function Fj() {
  return Wm("defaultIsolationScope", () => new Mi());
}
class Ij {
  constructor(n, r) {
    let i;
    n ? i = n : i = new Mi();
    let a;
    r ? a = r : a = new Mi(), this._stack = [{ scope: i }], this._isolationScope = a;
  }
  /**
   * Fork a scope for the stack.
   */
  withScope(n) {
    const r = this._pushScope();
    let i;
    try {
      i = n(r);
    } catch (a) {
      throw this._popScope(), a;
    }
    return kj(i) ? i.then(
      (a) => (this._popScope(), a),
      (a) => {
        throw this._popScope(), a;
      }
    ) : (this._popScope(), i);
  }
  /**
   * Get the client of the stack.
   */
  getClient() {
    return this.getStackTop().client;
  }
  /**
   * Returns the scope of the top stack.
   */
  getScope() {
    return this.getStackTop().scope;
  }
  /**
   * Get the isolation scope for the stack.
   */
  getIsolationScope() {
    return this._isolationScope;
  }
  /**
   * Returns the topmost scope layer in the order domain > local > process.
   */
  getStackTop() {
    return this._stack[this._stack.length - 1];
  }
  /**
   * Push a scope to the stack.
   */
  _pushScope() {
    const n = this.getScope().clone();
    return this._stack.push({
      client: this.getClient(),
      scope: n
    }), n;
  }
  /**
   * Pop a scope from the stack.
   */
  _popScope() {
    return this._stack.length <= 1 ? !1 : !!this._stack.pop();
  }
}
function Bi() {
  const e = Gm(), n = Ym(e);
  return n.stack = n.stack || new Ij(Cj(), Fj());
}
function Ej(e) {
  return Bi().withScope(e);
}
function Tj(e, n) {
  const r = Bi();
  return r.withScope(() => (r.getStackTop().scope = e, n(e)));
}
function $f(e) {
  return Bi().withScope(() => e(Bi().getIsolationScope()));
}
function $j() {
  return {
    withIsolationScope: $f,
    withScope: Ej,
    withSetScope: Tj,
    withSetIsolationScope: (e, n) => $f(n),
    getCurrentScope: () => Bi().getScope(),
    getIsolationScope: () => Bi().getIsolationScope()
  };
}
function m_(e) {
  const n = Ym(e);
  return n.acs ? n.acs : $j();
}
function Jm() {
  const e = Gm();
  return m_(e).getCurrentScope();
}
function p_() {
  const e = Gm();
  return m_(e).getIsolationScope();
}
function Dj() {
  return Jm().getClient();
}
function Rj(e) {
  if (e)
    return Oj(e) ? { captureContext: e } : Aj(e) ? {
      captureContext: e
    } : e;
}
function Oj(e) {
  return e instanceof Mi || typeof e == "function";
}
const Pj = [
  "user",
  "level",
  "extra",
  "contexts",
  "tags",
  "fingerprint",
  "requestSession",
  "propagationContext"
];
function Aj(e) {
  return Object.keys(e).some((n) => Pj.includes(n));
}
function Df(e, n) {
  return Jm().captureException(e, Rj(n));
}
function Lj(e, n) {
  const r = typeof n == "string" ? n : void 0, i = typeof n != "string" ? { captureContext: n } : void 0;
  return Jm().captureMessage(e, r, i);
}
function Vj(e, n) {
  p_().setContext(e, n);
}
const zj = 100;
function ai(e, n) {
  const r = Dj(), i = p_();
  if (!r) return;
  const { beforeBreadcrumb: a = null, maxBreadcrumbs: o = zj } = r.getOptions();
  if (o <= 0) return;
  const l = { timestamp: Km(), ...e }, d = a ? d_(() => a(l, n)) : l;
  d !== null && (r.emit && r.emit("beforeAddBreadcrumb", d, n), i.addBreadcrumb(d, o));
}
var eo;
(function(e) {
  e.Unknown = "unknown", e.Core = "core", e.Routing = "routing-and-presence", e.Insights = "insights", e.Ecosystem = "ecosystem", e.Partners = "partners", e.Channels = "channels", e.Messaging = "messaging", e.Platform = "platform", e.AI = "ai", e.Conversations = "conversations", e.Automation = "automation";
})(eo || (eo = {}));
function Ai(e) {
  const n = e.split(".")[1];
  if (!n)
    throw Error("Invalid token");
  const r = n.replace(/-/g, "+").replace(/_/g, "/");
  try {
    return JSON.parse(Buffer.from(r, "base64").toString());
  } catch (i) {
    throw Error(`Failed to parse the JSON Web Token with the following error: ${i}`);
  }
}
const Uj = Za.backendDomain ? {
  "backend-domain": Za.backendDomain
} : void 0;
function Zo() {
  const e = new URLSearchParams({
    noToken: "true",
    ...Uj
  }).toString();
  document.location.href = `${Za.url.logIn}?${e}`;
}
const ll = "authData", cl = 30, Mj = 600, dl = 5;
class Bj {
  authData = null;
  /** The (server) time when the access token expires, in seconds. */
  accessTokenExpiresAt = 0;
  /**
   * The difference between client- and server-time, in seconds. Negative if
   * client is ahead of server, positive if server is ahead of client
   */
  clientServerTimeDiff = 0;
  /**
   * Returns an estimated server time (unix epoch in seconds) by adding the
   * client-server time difference to the current client time.
   *
   * The time-diff is stored whenever a new access token is saved.
   *
   * @returns {number} The estimated server time in seconds.
   */
  estimatedServerTime() {
    const n = Date.now() / 1e3;
    return this.clientServerTimeDiff >= dl || this.clientServerTimeDiff <= -dl ? Math.ceil(n + this.clientServerTimeDiff) : Math.ceil(n);
  }
  /**
   * Sets the auth data in localStorage.
   *
   * @param authData The auth data.
   */
  setAuthData(n) {
    this.authData = n;
    const i = Math.ceil(Date.now() / 1e3) + Mj, a = Ai(n.access_token).exp;
    if (this.clientServerTimeDiff = a - i, process.env.NODE_ENV !== "test" && Math.abs(this.clientServerTimeDiff) > dl) {
      const o = this.clientServerTimeDiff > 0 ? "behind" : "ahead";
      console.info(`Client time is ${o} by significant amount. (${Math.abs(this.clientServerTimeDiff)}s)`);
    }
    this.accessTokenExpiresAt = a, localStorage.setItem(ll, JSON.stringify(n));
  }
  /** Gets the auth data from memory or localStorage. */
  getAuthData() {
    if (this.authData)
      return this.authData;
    const n = localStorage.getItem(ll), r = n ? JSON.parse(n) : null;
    return this.validateAuthDataComplete(r) && (this.authData = r), r;
  }
  /** Removes the auth data from localStorage. */
  removeAuthData() {
    this.authData = null, localStorage.removeItem(ll);
  }
  getAccessToken() {
    return this.authData?.access_token || null;
  }
  getRefreshToken() {
    return this.authData?.refresh_token || null;
  }
  /**
   * Validates that the auth data is complete - i.e not fragmented.
   *
   * @param authData The auth data.
   */
  validateAuthDataComplete(n) {
    return n ? [
      "access_token",
      "refresh_token",
      "expires_in"
    ].every((i) => typeof n[i] < "u") : !1;
  }
  isAccessTokenExpired() {
    if (!this.getAccessToken())
      return !0;
    const r = this.accessTokenExpiresAt - cl;
    return this.estimatedServerTime() >= r;
  }
  isRefreshTokenExpired(n) {
    if (!n)
      return !0;
    const r = Ai(n), i = r.exp - cl;
    return !r || this.estimatedServerTime() >= i;
  }
  accessTokenExpiresInMs() {
    return (this.accessTokenExpiresAt - cl - this.estimatedServerTime()) * 1e3;
  }
}
const bt = new Bj();
async function qj(e) {
  const n = window.location.origin.replace(/^https?:\/\//, ""), r = ["localhost:8080", "uptrends-monitor"];
  if (!(!e.response || r.some((i) => n.includes(i)))) {
    try {
      const i = e.response.config.headers.Authorization ?? "", a = i ? i.toString()?.split("Basic ")[1] : "", o = a ? atob(a).split("token:")[1] : "", s = o ? Ai(o).exp : "None", l = await Ms.getAuthData({ localStorageOnly: !0 }), d = Math.floor(Date.now() / 1e3), m = l?.access_token, u = l?.refresh_token, f = m ? Ai(m).exp : "None", h = u ? Ai(u).exp : "None", v = typeof s == "number" ? d - s : "Unknown", C = typeof f == "number" ? d - f : "Unknown", S = typeof h == "number" ? d - h : "Unknown", j = e.response.headers["x-dixa-rid"];
      Vj("Expires", {
        currentTimestamp: d,
        accessTokenFromHeader: s,
        accessTokenFromHeaderDiff: v,
        accessTokenFromLocalStorage: f,
        accessTokenFromLocalStorageDiff: C,
        refreshTokenFromLocalStorage: h,
        refreshTokenFromLocalStorageDiff: S,
        xDixaRid: j,
        navigatorOnline: navigator.onLine
      });
    } catch (i) {
      console.error("Error adding Sentry error context", i);
    }
    Lj("401 unauthorized interceptor", {
      level: "debug",
      tags: {
        team: eo.Platform,
        domain: n
      }
    });
  }
}
const ul = /* @__PURE__ */ new Map(), Hj = 3;
function Wj(e) {
  e.interceptors.response.use((n) => (ul.delete(n.config.url), n), (n) => {
    if (n.response) {
      const { status: r } = n.response;
      switch (r) {
        case em.Unauthorized:
          if (!Ms.isRefreshTokenExpired() && n.config) {
            ai({
              category: "errorInterceptor",
              message: "Access token expired after request",
              level: "debug"
            });
            const i = ul.get(n.config.url) ?? 0;
            if (console.log(`Retrying request (${i + 1}): ${n.config.url}`), i <= Hj)
              return ul.set(n.config.url, i + 1), e(n.config);
          }
          qj(n), console.error("401 unauthorized interceptor"), Zo();
          break;
      }
    }
    return Promise.reject(n);
  });
}
const f_ = ut.create();
Wj(f_);
const Ar = console.log;
async function Rf(e) {
  return new Promise((n) => setTimeout(n, e * 1e3));
}
class Kj extends Error {
  constructor(n, r) {
    super(n, r);
  }
}
function Gj(e = 0) {
  return Math.min(Math.round((Math.random() + 1) * Math.pow(1.5, e)), 30);
}
const Yj = 5;
class Qj {
  authDataPromise = null;
  retryCount = 0;
  async init(n) {
    const r = await this.refresh(n);
    if (r)
      bt.setAuthData(r);
    else {
      const i = bt.isRefreshTokenExpired(n) ? "expired" : "unknown";
      throw new Kj("Failed to init refresh token", {
        cause: i
      });
    }
  }
  getDebugInfo() {
    const n = bt.getAccessToken();
    if (!n)
      return {};
    const r = Ai(n), { exp: i } = r;
    return {
      expire: i ? new Date(i * 1e3).toISOString() : null,
      now: (/* @__PURE__ */ new Date()).toISOString()
    };
  }
  /**
   * Gets auth data from LocalStorage, or fetches new auth data if the current
   * token is expired or is about to expire.
   */
  async getAuthData({ localStorageOnly: n = !1 } = {}) {
    if (n)
      return bt.getAuthData();
    if (this.authDataPromise)
      return await this.authDataPromise;
    const r = bt.getAuthData();
    return r ? bt.isAccessTokenExpired() ? (ai({
      category: "refreshToken",
      // Cannot include "token" in the message, as it will be redacted
      message: "expired or about to expire",
      level: "debug",
      data: this.getDebugInfo()
    }), this.authDataPromise = this.refresh(r.refresh_token).then((i) => (i && bt.setAuthData(i), this.authDataPromise = null, i)), await this.authDataPromise) : r : null;
  }
  removeAuthData() {
    return bt.removeAuthData();
  }
  validateAuthDataComplete(n) {
    return bt.validateAuthDataComplete(n);
  }
  isAccessTokenExpired() {
    return bt.isAccessTokenExpired();
  }
  isRefreshTokenExpired() {
    const n = bt.getAuthData();
    return n ? bt.isRefreshTokenExpired(n.refresh_token) : !0;
  }
  /** Checks whether refresh token is supported. */
  async isSupported() {
    if (!jf.isElectron())
      return !0;
    const n = await jf.getVersion();
    return hj(n, "3.7.0") === 1;
  }
  /**
   * Gets refreshed tokens from the API
   *
   * @param refreshToken The refresh token.
   * @param retriesLeft The number of retries left.
   */
  async refresh(n, r = Yj) {
    try {
      return await f_.post(`${Za.url.rest}/v2/login/refresh`, {
        refreshToken: n
      }).then((i) => (this.retryCount = 0, i.data.data));
    } catch (i) {
      return await this.handleRefreshError(i, n, r);
    }
  }
  async waitUntilOnline() {
    const n = navigator.onLine === !1;
    for (n && (Ar("AUTH", "Network connection offline - waiting..."), ai({
      category: "refreshToken",
      message: "Network connection offline - waiting...",
      level: "debug"
    })); navigator.onLine === !1; )
      await Rf(5);
    n && (Ar("AUTH", "Network connection restored"), ai({
      category: "refreshToken",
      message: "Network connection restored",
      level: "debug"
    }));
  }
  async retryRefresh(n, r) {
    await this.waitUntilOnline(), this.retryCount++;
    const i = Gj(this.retryCount);
    return Ar("AUTH", `Retrying in ${i} seconds`), await Rf(i), await this.refresh(n, r);
  }
  async handleRefreshError(n, r, i) {
    if (bt.isRefreshTokenExpired(r))
      return Ar("AUTH", "Refresh token expired"), ai({
        category: "refreshToken",
        message: "Refresh token expired",
        level: "debug"
      }), bt.removeAuthData(), Zo(), null;
    if (pj(n)) {
      if (n.message === "timeout exceeded")
        return Ar("AUTH", "Timeout exceeded"), ai({
          category: "refreshToken",
          message: "Timeout exceeded",
          level: "debug"
        }), await this.retryRefresh(r, i);
      if (n.message === "Network Error")
        return Ar("AUTH", "Network error"), ai({
          category: "refreshToken",
          message: "Network error",
          level: "debug"
        }), await this.retryRefresh(r, i);
      if (n.response?.status === 401)
        return Ar("AUTH", "Refresh token invalid (401)"), bt.removeAuthData(), Zo(), null;
      Df(n, {
        level: "error",
        tags: {
          team: eo.Platform,
          errorSource: "authManager.refresh"
        }
      });
    }
    return i <= 0 ? (Ar("AUTH", "Retries exhausted, logging out"), Df(n, {
      level: "error",
      tags: {
        team: eo.Platform,
        errorSource: "authManager.refresh"
      }
    }), bt.removeAuthData(), Zo(), null) : (Ar("AUTH", `Retrying ${i} more times`), await this.retryRefresh(r, i - 1));
  }
  accessTokenExpiresInMs() {
    return bt.accessTokenExpiresInMs();
  }
}
const Ms = new Qj();
var em;
(function(e) {
  e[e.BadRequest = 400] = "BadRequest", e[e.Unauthorized = 401] = "Unauthorized", e[e.Forbidden = 403] = "Forbidden", e[e.NotFound = 404] = "NotFound", e[e.Conflict = 409] = "Conflict", e[e.InternalServerError = 500] = "InternalServerError", e[e.BadGateway = 502] = "BadGateway", e[e.ServiceUnavailable = 503] = "ServiceUnavailable";
})(em || (em = {}));
const Jj = new zm((e, n) => new Lb((r) => {
  Ms.getAuthData().then((i) => {
    const a = i?.access_token, o = e.getContext().headers;
    return e.setContext({
      ...o,
      headers: {
        Authorization: a ? `Bearer ${a}` : ""
      }
    }), n(e).subscribe(r);
  }).catch((i) => r.error(i));
})), Xj = new zm(
  (e, n) => new Lb((r) => {
    const i = e.getContext(), { headers: a, widgetId: o, widgetType: s, operationName: l } = i;
    Ms.getAuthData().then((d) => (e.setContext({
      ...i,
      headers: {
        ...a,
        ...o && { "x-integration-widget-id": o },
        ...s && { "x-integration-widget-type": s },
        ...l && {
          "x-integration-widget-operation": l
        },
        ...BS(Za.url.partnerIntegrations) && d?.access_token && qS(d.access_token)
      }
    }), n(e).subscribe(r))).catch((d) => r.error(d));
  })
), Zj = new AbortController(), h_ = (e) => new k0({
  queryDeduplication: !1,
  cache: new b0(),
  link: zm.from([
    Jj,
    Xj,
    _0({
      uri: `${e}/graphql`,
      fetch: w0,
      fetchOptions: {
        mode: "cors",
        // The `AbortSignal` object instance is used to communicate with a
        // fetch request and abort it if desired via an `AbortController`.
        // This prevents abandoned abort errors spiral up to Sentry.
        signal: Zj.signal
      }
    })
  ]),
  defaultOptions: {
    watchQuery: {
      fetchPolicy: "no-cache",
      errorPolicy: "all"
    },
    query: {
      fetchPolicy: "no-cache",
      errorPolicy: "all"
    },
    mutate: {
      fetchPolicy: "no-cache",
      errorPolicy: "all"
    }
  }
}), ew = ({
  configuration: e,
  children: n
}) => {
  const r = Bn(
    () => h_(e.baseUrl),
    [e.baseUrl]
  );
  return /* @__PURE__ */ Ue.jsx(x0, { client: r, children: n });
};
function nw() {
  try {
    return S0(), !0;
  } catch {
    return !1;
  }
}
const tw = ({
  configuration: e,
  children: n
}) => nw() ? n : /* @__PURE__ */ Ue.jsx(ew, { configuration: e, children: n }), rw = ({
  integrationId: e,
  type: n,
  showNotification: r,
  showModal: i,
  children: a
}) => /* @__PURE__ */ Ue.jsx(N0, { children: (o) => /* @__PURE__ */ Ue.jsx(
  HS,
  {
    value: {
      useMutation: YS(e, n),
      useQuery: GS(e, n),
      useLazyQuery: KS(e, n),
      executeQuery: WS(e, n, o),
      showNotification: r,
      showModal: i ?? (() => null)
    },
    children: a
  }
) }), y_ = ({
  integrationId: e,
  type: n,
  configuration: r,
  showNotification: i,
  showModal: a,
  children: o
}) => {
  const s = !!e && !!n;
  return /* @__PURE__ */ Ue.jsx(tw, { configuration: r, children: s ? /* @__PURE__ */ Ue.jsx(
    rw,
    {
      integrationId: e,
      type: n,
      showNotification: i,
      showModal: a,
      children: o
    }
  ) : o });
};
(function() {
  try {
    if (typeof document < "u") {
      var e = document.createElement("style");
      e.appendChild(document.createTextNode("._copyIcon_1wjfs_48{cursor:pointer;color:var(--dixa-typography-color-secondary)}._list_1wjfs_53{padding:0;max-height:250px;overflow-y:auto;background:linear-gradient(var(--dixa-color-neutral-000) 33%,rgba(255,255,255,0)),linear-gradient(rgba(255,255,255,0),var(--dixa-color-neutral-000) 66%) 0 100%,radial-gradient(farthest-side at 50% 0,var(--dixa-color-neutral-200),rgba(0,0,0,0)),radial-gradient(farthest-side at 50% 100%,var(--dixa-color-neutral-200),rgba(0,0,0,0)) 0 100%;background-color:var(--dixa-color-neutral-000);background-repeat:no-repeat;background-attachment:local,local,scroll,scroll;background-size:100% var(--dixa-size-spacer-400),100% var(--dixa-size-spacer-400),100% var(--dixa-size-spacer-200),100% var(--dixa-size-spacer-200)}._listItem_1wjfs_63{background-color:transparent;padding:var(--dixa-size-spacer-100);border-bottom:var(--dixa-size-border-100) solid var(--dixa-color-neutral-200)}._listItem_1wjfs_63:last-child:not(:only-child){border-bottom:none}._collapsible_1wjfs_72{border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-250)}._collapsible_1wjfs_72:hover,._collapsibleIsOpen_1wjfs_80{border-color:var(--dixa-color-neutral-400)}._collapsibleHeader_1wjfs_83{cursor:pointer}._collapsibleIconTrue_1wjfs_86{color:var(--dixa-color-green-500)}._collapsibleIconFalse_1wjfs_89{color:var(--dixa-color-red-500)}._wrapper_1xucg_1{border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-300);background-color:var(--dixa-color-neutral-100)}._externalLink_1xucg_7{color:var(--dixa-typography-color-primary);font-size:var(--dixa-typography-size-200)}")), document.head.appendChild(e);
    }
  } catch (n) {
    console.error("vite-plugin-css-injected-by-js", n);
  }
})();
var ml = { exports: {} }, ia = {}, Of;
function iw() {
  if (Of) return ia;
  Of = 1;
  var e = je, n = Symbol.for("react.element"), r = Symbol.for("react.fragment"), i = Object.prototype.hasOwnProperty, a = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, o = { key: !0, ref: !0, __self: !0, __source: !0 };
  function s(l, d, m) {
    var u, f = {}, h = null, v = null;
    m !== void 0 && (h = "" + m), d.key !== void 0 && (h = "" + d.key), d.ref !== void 0 && (v = d.ref);
    for (u in d) i.call(d, u) && !o.hasOwnProperty(u) && (f[u] = d[u]);
    if (l && l.defaultProps) for (u in d = l.defaultProps, d) f[u] === void 0 && (f[u] = d[u]);
    return { $$typeof: n, type: l, key: h, ref: v, props: f, _owner: a.current };
  }
  return ia.Fragment = r, ia.jsx = s, ia.jsxs = s, ia;
}
var _o = {}, Pf;
function aw() {
  return Pf || (Pf = 1, process.env.NODE_ENV !== "production" && (function() {
    var e = je, n = Symbol.for("react.element"), r = Symbol.for("react.portal"), i = Symbol.for("react.fragment"), a = Symbol.for("react.strict_mode"), o = Symbol.for("react.profiler"), s = Symbol.for("react.provider"), l = Symbol.for("react.context"), d = Symbol.for("react.forward_ref"), m = Symbol.for("react.suspense"), u = Symbol.for("react.suspense_list"), f = Symbol.for("react.memo"), h = Symbol.for("react.lazy"), v = Symbol.for("react.offscreen"), C = Symbol.iterator, S = "@@iterator";
    function j(t) {
      if (t === null || typeof t != "object")
        return null;
      var c = C && t[C] || t[S];
      return typeof c == "function" ? c : null;
    }
    var F = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function y(t) {
      {
        for (var c = arguments.length, p = new Array(c > 1 ? c - 1 : 0), g = 1; g < c; g++)
          p[g - 1] = arguments[g];
        q("error", t, p);
      }
    }
    function q(t, c, p) {
      {
        var g = F.ReactDebugCurrentFrame, P = g.getStackAddendum();
        P !== "" && (c += "%s", p = p.concat([P]));
        var L = p.map(function(I) {
          return String(I);
        });
        L.unshift("Warning: " + c), Function.prototype.apply.call(console[t], console, L);
      }
    }
    var T = !1, E = !1, D = !1, B = !1, ee = !1, J;
    J = Symbol.for("react.module.reference");
    function ae(t) {
      return !!(typeof t == "string" || typeof t == "function" || t === i || t === o || ee || t === a || t === m || t === u || B || t === v || T || E || D || typeof t == "object" && t !== null && (t.$$typeof === h || t.$$typeof === f || t.$$typeof === s || t.$$typeof === l || t.$$typeof === d || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      t.$$typeof === J || t.getModuleId !== void 0));
    }
    function Q(t, c, p) {
      var g = t.displayName;
      if (g)
        return g;
      var P = c.displayName || c.name || "";
      return P !== "" ? p + "(" + P + ")" : p;
    }
    function U(t) {
      return t.displayName || "Context";
    }
    function O(t) {
      if (t == null)
        return null;
      if (typeof t.tag == "number" && y("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof t == "function")
        return t.displayName || t.name || null;
      if (typeof t == "string")
        return t;
      switch (t) {
        case i:
          return "Fragment";
        case r:
          return "Portal";
        case o:
          return "Profiler";
        case a:
          return "StrictMode";
        case m:
          return "Suspense";
        case u:
          return "SuspenseList";
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case l:
            var c = t;
            return U(c) + ".Consumer";
          case s:
            var p = t;
            return U(p._context) + ".Provider";
          case d:
            return Q(t, t.render, "ForwardRef");
          case f:
            var g = t.displayName || null;
            return g !== null ? g : O(t.type) || "Memo";
          case h: {
            var P = t, L = P._payload, I = P._init;
            try {
              return O(I(L));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var H = Object.assign, Z = 0, ye, ce, le, ue, W, ke, Ee;
    function K() {
    }
    K.__reactDisabledLog = !0;
    function qe() {
      {
        if (Z === 0) {
          ye = console.log, ce = console.info, le = console.warn, ue = console.error, W = console.group, ke = console.groupCollapsed, Ee = console.groupEnd;
          var t = {
            configurable: !0,
            enumerable: !0,
            value: K,
            writable: !0
          };
          Object.defineProperties(console, {
            info: t,
            log: t,
            warn: t,
            error: t,
            group: t,
            groupCollapsed: t,
            groupEnd: t
          });
        }
        Z++;
      }
    }
    function Be() {
      {
        if (Z--, Z === 0) {
          var t = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: H({}, t, {
              value: ye
            }),
            info: H({}, t, {
              value: ce
            }),
            warn: H({}, t, {
              value: le
            }),
            error: H({}, t, {
              value: ue
            }),
            group: H({}, t, {
              value: W
            }),
            groupCollapsed: H({}, t, {
              value: ke
            }),
            groupEnd: H({}, t, {
              value: Ee
            })
          });
        }
        Z < 0 && y("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var Pe = F.ReactCurrentDispatcher, Me;
    function Fe(t, c, p) {
      {
        if (Me === void 0)
          try {
            throw Error();
          } catch (P) {
            var g = P.stack.trim().match(/\n( *(at )?)/);
            Me = g && g[1] || "";
          }
        return `
` + Me + t;
      }
    }
    var Ae = !1, $e;
    {
      var tn = typeof WeakMap == "function" ? WeakMap : Map;
      $e = new tn();
    }
    function Ie(t, c) {
      if (!t || Ae)
        return "";
      {
        var p = $e.get(t);
        if (p !== void 0)
          return p;
      }
      var g;
      Ae = !0;
      var P = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var L;
      L = Pe.current, Pe.current = null, qe();
      try {
        if (c) {
          var I = function() {
            throw Error();
          };
          if (Object.defineProperty(I.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(I, []);
            } catch (ne) {
              g = ne;
            }
            Reflect.construct(t, [], I);
          } else {
            try {
              I.call();
            } catch (ne) {
              g = ne;
            }
            t.call(I.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (ne) {
            g = ne;
          }
          t();
        }
      } catch (ne) {
        if (ne && g && typeof ne.stack == "string") {
          for (var N = ne.stack.split(`
`), te = g.stack.split(`
`), x = N.length - 1, V = te.length - 1; x >= 1 && V >= 0 && N[x] !== te[V]; )
            V--;
          for (; x >= 1 && V >= 0; x--, V--)
            if (N[x] !== te[V]) {
              if (x !== 1 || V !== 1)
                do
                  if (x--, V--, V < 0 || N[x] !== te[V]) {
                    var X = `
` + N[x].replace(" at new ", " at ");
                    return t.displayName && X.includes("<anonymous>") && (X = X.replace("<anonymous>", t.displayName)), typeof t == "function" && $e.set(t, X), X;
                  }
                while (x >= 1 && V >= 0);
              break;
            }
        }
      } finally {
        Ae = !1, Pe.current = L, Be(), Error.prepareStackTrace = P;
      }
      var we = t ? t.displayName || t.name : "", Se = we ? Fe(we) : "";
      return typeof t == "function" && $e.set(t, Se), Se;
    }
    function We(t, c, p) {
      return Ie(t, !1);
    }
    function Ze(t) {
      var c = t.prototype;
      return !!(c && c.isReactComponent);
    }
    function de(t, c, p) {
      if (t == null)
        return "";
      if (typeof t == "function")
        return Ie(t, Ze(t));
      if (typeof t == "string")
        return Fe(t);
      switch (t) {
        case m:
          return Fe("Suspense");
        case u:
          return Fe("SuspenseList");
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case d:
            return We(t.render);
          case f:
            return de(t.type, c, p);
          case h: {
            var g = t, P = g._payload, L = g._init;
            try {
              return de(L(P), c, p);
            } catch {
            }
          }
        }
      return "";
    }
    var fe = Object.prototype.hasOwnProperty, Te = {}, Le = F.ReactDebugCurrentFrame;
    function Re(t) {
      if (t) {
        var c = t._owner, p = de(t.type, t._source, c ? c.type : null);
        Le.setExtraStackFrame(p);
      } else
        Le.setExtraStackFrame(null);
    }
    function sn(t, c, p, g, P) {
      {
        var L = Function.call.bind(fe);
        for (var I in t)
          if (L(t, I)) {
            var N = void 0;
            try {
              if (typeof t[I] != "function") {
                var te = Error((g || "React class") + ": " + p + " type `" + I + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof t[I] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw te.name = "Invariant Violation", te;
              }
              N = t[I](c, I, g, p, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (x) {
              N = x;
            }
            N && !(N instanceof Error) && (Re(P), y("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", g || "React class", p, I, typeof N), Re(null)), N instanceof Error && !(N.message in Te) && (Te[N.message] = !0, Re(P), y("Failed %s type: %s", p, N.message), Re(null));
          }
      }
    }
    var w = Array.isArray;
    function _(t) {
      return w(t);
    }
    function $(t) {
      {
        var c = typeof Symbol == "function" && Symbol.toStringTag, p = c && t[Symbol.toStringTag] || t.constructor.name || "Object";
        return p;
      }
    }
    function G(t) {
      try {
        return Y(t), !1;
      } catch {
        return !0;
      }
    }
    function Y(t) {
      return "" + t;
    }
    function R(t) {
      if (G(t))
        return y("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", $(t)), Y(t);
    }
    var z = F.ReactCurrentOwner, ie = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, pe, _e;
    function en(t) {
      if (fe.call(t, "ref")) {
        var c = Object.getOwnPropertyDescriptor(t, "ref").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.ref !== void 0;
    }
    function un(t) {
      if (fe.call(t, "key")) {
        var c = Object.getOwnPropertyDescriptor(t, "key").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.key !== void 0;
    }
    function rn(t, c) {
      typeof t.ref == "string" && z.current;
    }
    function dn(t, c) {
      {
        var p = function() {
          pe || (pe = !0, y("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "key", {
          get: p,
          configurable: !0
        });
      }
    }
    function pn(t, c) {
      {
        var p = function() {
          _e || (_e = !0, y("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "ref", {
          get: p,
          configurable: !0
        });
      }
    }
    var ln = function(t, c, p, g, P, L, I) {
      var N = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: n,
        // Built-in properties that belong on the element
        type: t,
        key: c,
        ref: p,
        props: I,
        // Record the component responsible for creating this element.
        _owner: L
      };
      return N._store = {}, Object.defineProperty(N._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(N, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: g
      }), Object.defineProperty(N, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: P
      }), Object.freeze && (Object.freeze(N.props), Object.freeze(N)), N;
    };
    function kn(t, c, p, g, P) {
      {
        var L, I = {}, N = null, te = null;
        p !== void 0 && (R(p), N = "" + p), un(c) && (R(c.key), N = "" + c.key), en(c) && (te = c.ref, rn(c));
        for (L in c)
          fe.call(c, L) && !ie.hasOwnProperty(L) && (I[L] = c[L]);
        if (t && t.defaultProps) {
          var x = t.defaultProps;
          for (L in x)
            I[L] === void 0 && (I[L] = x[L]);
        }
        if (N || te) {
          var V = typeof t == "function" ? t.displayName || t.name || "Unknown" : t;
          N && dn(I, V), te && pn(I, V);
        }
        return ln(t, N, te, P, g, z.current, I);
      }
    }
    var Xe = F.ReactCurrentOwner, Sn = F.ReactDebugCurrentFrame;
    function Oe(t) {
      if (t) {
        var c = t._owner, p = de(t.type, t._source, c ? c.type : null);
        Sn.setExtraStackFrame(p);
      } else
        Sn.setExtraStackFrame(null);
    }
    var an;
    an = !1;
    function on(t) {
      return typeof t == "object" && t !== null && t.$$typeof === n;
    }
    function yn() {
      {
        if (Xe.current) {
          var t = O(Xe.current.type);
          if (t)
            return `

Check the render method of \`` + t + "`.";
        }
        return "";
      }
    }
    function qn(t) {
      return "";
    }
    var Nn = {};
    function gn(t) {
      {
        var c = yn();
        if (!c) {
          var p = typeof t == "string" ? t : t.displayName || t.name;
          p && (c = `

Check the top-level render call using <` + p + ">.");
        }
        return c;
      }
    }
    function hn(t, c) {
      {
        if (!t._store || t._store.validated || t.key != null)
          return;
        t._store.validated = !0;
        var p = gn(c);
        if (Nn[p])
          return;
        Nn[p] = !0;
        var g = "";
        t && t._owner && t._owner !== Xe.current && (g = " It was passed a child from " + O(t._owner.type) + "."), Oe(t), y('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', p, g), Oe(null);
      }
    }
    function jn(t, c) {
      {
        if (typeof t != "object")
          return;
        if (_(t))
          for (var p = 0; p < t.length; p++) {
            var g = t[p];
            on(g) && hn(g, c);
          }
        else if (on(t))
          t._store && (t._store.validated = !0);
        else if (t) {
          var P = j(t);
          if (typeof P == "function" && P !== t.entries)
            for (var L = P.call(t), I; !(I = L.next()).done; )
              on(I.value) && hn(I.value, c);
        }
      }
    }
    function Un(t) {
      {
        var c = t.type;
        if (c == null || typeof c == "string")
          return;
        var p;
        if (typeof c == "function")
          p = c.propTypes;
        else if (typeof c == "object" && (c.$$typeof === d || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        c.$$typeof === f))
          p = c.propTypes;
        else
          return;
        if (p) {
          var g = O(c);
          sn(p, t.props, "prop", g, t);
        } else if (c.PropTypes !== void 0 && !an) {
          an = !0;
          var P = O(c);
          y("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", P || "Unknown");
        }
        typeof c.getDefaultProps == "function" && !c.getDefaultProps.isReactClassApproved && y("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function Vn(t) {
      {
        for (var c = Object.keys(t.props), p = 0; p < c.length; p++) {
          var g = c[p];
          if (g !== "children" && g !== "key") {
            Oe(t), y("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", g), Oe(null);
            break;
          }
        }
        t.ref !== null && (Oe(t), y("Invalid attribute `ref` supplied to `React.Fragment`."), Oe(null));
      }
    }
    var _n = {};
    function xn(t, c, p, g, P, L) {
      {
        var I = ae(t);
        if (!I) {
          var N = "";
          (t === void 0 || typeof t == "object" && t !== null && Object.keys(t).length === 0) && (N += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var te = qn();
          te ? N += te : N += yn();
          var x;
          t === null ? x = "null" : _(t) ? x = "array" : t !== void 0 && t.$$typeof === n ? (x = "<" + (O(t.type) || "Unknown") + " />", N = " Did you accidentally export a JSX literal instead of a component?") : x = typeof t, y("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", x, N);
        }
        var V = kn(t, c, p, P, L);
        if (V == null)
          return V;
        if (I) {
          var X = c.children;
          if (X !== void 0)
            if (g)
              if (_(X)) {
                for (var we = 0; we < X.length; we++)
                  jn(X[we], t);
                Object.freeze && Object.freeze(X);
              } else
                y("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              jn(X, t);
        }
        if (fe.call(c, "key")) {
          var Se = O(t), ne = Object.keys(c).filter(function(wn) {
            return wn !== "key";
          }), nn = ne.length > 0 ? "{key: someKey, " + ne.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!_n[Se + nn]) {
            var Tn = ne.length > 0 ? "{" + ne.join(": ..., ") + ": ...}" : "{}";
            y(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, nn, Se, Tn, Se), _n[Se + nn] = !0;
          }
        }
        return t === i ? Vn(V) : Un(V), V;
      }
    }
    function Hn(t, c, p) {
      return xn(t, c, p, !0);
    }
    function Dn(t, c, p) {
      return xn(t, c, p, !1);
    }
    var Rn = Dn, Mn = Hn;
    _o.Fragment = i, _o.jsx = Rn, _o.jsxs = Mn;
  })()), _o;
}
var Af;
function ow() {
  return Af || (Af = 1, process.env.NODE_ENV === "production" ? ml.exports = iw() : ml.exports = aw()), ml.exports;
}
var oe = ow();
const sw = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "getCustomerDetails" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "input" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Braze_exportUserDetails_request_Input" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Braze" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "exportUserDetails" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "input" }, value: { kind: "Variable", name: { kind: "Name", value: "input" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Braze_exportUserDetails_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Braze_ExportedUserDetails" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }, { kind: "Field", name: { kind: "Name", value: "users" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "external_id" } }, { kind: "Field", name: { kind: "Name", value: "braze_id" } }, { kind: "Field", name: { kind: "Name", value: "created_at" } }, { kind: "Field", name: { kind: "Name", value: "email" } }, { kind: "Field", name: { kind: "Name", value: "first_name" } }, { kind: "Field", name: { kind: "Name", value: "last_name" } }, { kind: "Field", name: { kind: "Name", value: "dob" } }, { kind: "Field", name: { kind: "Name", value: "home_city" } }, { kind: "Field", name: { kind: "Name", value: "country" } }, { kind: "Field", name: { kind: "Name", value: "phone" } }, { kind: "Field", name: { kind: "Name", value: "language" } }, { kind: "Field", name: { kind: "Name", value: "time_zone" } }, { kind: "Field", name: { kind: "Name", value: "total_revenue" } }, { kind: "Field", name: { kind: "Name", value: "push_subscribe" } }, { kind: "Field", name: { kind: "Name", value: "email_subscribe" } }, { kind: "Field", name: { kind: "Name", value: "custom_attributes" } }, { kind: "Field", name: { kind: "Name", value: "apps" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "platform" } }, { kind: "Field", name: { kind: "Name", value: "version" } }, { kind: "Field", name: { kind: "Name", value: "sessions" } }, { kind: "Field", name: { kind: "Name", value: "first_used" } }, { kind: "Field", name: { kind: "Name", value: "last_used" } }] } }, { kind: "Field", name: { kind: "Name", value: "devices" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "model" } }, { kind: "Field", name: { kind: "Name", value: "os" } }, { kind: "Field", name: { kind: "Name", value: "carrier" } }, { kind: "Field", name: { kind: "Name", value: "idfv" } }, { kind: "Field", name: { kind: "Name", value: "idfa" } }, { kind: "Field", name: { kind: "Name", value: "google_ad_id" } }, { kind: "Field", name: { kind: "Name", value: "roku_ad_id" } }, { kind: "Field", name: { kind: "Name", value: "ad_tracking_enabled" } }] } }, { kind: "Field", name: { kind: "Name", value: "custom_events" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "first" } }, { kind: "Field", name: { kind: "Name", value: "last" } }, { kind: "Field", name: { kind: "Name", value: "count" } }] } }, { kind: "Field", name: { kind: "Name", value: "purchases" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "first" } }, { kind: "Field", name: { kind: "Name", value: "last" } }, { kind: "Field", name: { kind: "Name", value: "count" } }] } }] } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Braze_BasicResponse" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }] } }] } }] } }] } }] }, lw = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "updateEmailSubscriptionStatus" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "input" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Braze_updateEmailSubscriptionStatus_request_Input" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Braze" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "updateEmailSubscriptionStatus" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "input" }, value: { kind: "Variable", name: { kind: "Name", value: "input" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }] } }] } }] }, cw = {
  "\n  mutation getCustomerDetails($input: Braze_exportUserDetails_request_Input!) {\n    Braze {\n      exportUserDetails(input: $input) {\n        ... on Braze_exportUserDetails_response {\n          ... on Braze_ExportedUserDetails {\n            message\n            users {\n              external_id\n              braze_id\n              created_at\n              email\n              first_name\n              last_name\n              dob\n              home_city\n              country\n              phone\n              language\n              time_zone\n              total_revenue\n              push_subscribe\n              email_subscribe\n              custom_attributes\n              apps {\n                name\n                platform\n                version\n                sessions\n                first_used\n                last_used\n              }\n              devices {\n                model\n                os\n                carrier\n                idfv\n                idfa\n                google_ad_id\n                roku_ad_id\n                ad_tracking_enabled\n              }\n              custom_events {\n                name\n                first\n                last\n                count\n              }\n              purchases {\n                name\n                first\n                last\n                count\n              }\n            }\n          }\n\n          ... on Braze_BasicResponse {\n            message\n          }\n        }\n      }\n    }\n  }\n": sw,
  "\n  mutation updateEmailSubscriptionStatus(\n    $input: Braze_updateEmailSubscriptionStatus_request_Input!\n  ) {\n    Braze {\n      updateEmailSubscriptionStatus(input: $input) {\n        message\n      }\n    }\n  }\n": lw
};
function g_(e) {
  return cw[e] ?? {};
}
const dw = g_(
  /* GraphQL */
  `
  mutation getCustomerDetails($input: Braze_exportUserDetails_request_Input!) {
    Braze {
      exportUserDetails(input: $input) {
        ... on Braze_exportUserDetails_response {
          ... on Braze_ExportedUserDetails {
            message
            users {
              external_id
              braze_id
              created_at
              email
              first_name
              last_name
              dob
              home_city
              country
              phone
              language
              time_zone
              total_revenue
              push_subscribe
              email_subscribe
              custom_attributes
              apps {
                name
                platform
                version
                sessions
                first_used
                last_used
              }
              devices {
                model
                os
                carrier
                idfv
                idfa
                google_ad_id
                roku_ad_id
                ad_tracking_enabled
              }
              custom_events {
                name
                first
                last
                count
              }
              purchases {
                name
                first
                last
                count
              }
            }
          }

          ... on Braze_BasicResponse {
            message
          }
        }
      }
    }
  }
`
), uw = g_(
  /* GraphQL */
  `
  mutation updateEmailSubscriptionStatus(
    $input: Braze_updateEmailSubscriptionStatus_request_Input!
  ) {
    Braze {
      updateEmailSubscriptionStatus(input: $input) {
        message
      }
    }
  }
`
), mw = "_copyIcon_1wjfs_48", pw = "_list_1wjfs_53", fw = "_listItem_1wjfs_63", hw = "_collapsible_1wjfs_72", yw = "_collapsibleIsOpen_1wjfs_80", gw = "_collapsibleHeader_1wjfs_83", vw = "_collapsibleIconTrue_1wjfs_86", kw = "_collapsibleIconFalse_1wjfs_89", On = {
  copyIcon: mw,
  list: pw,
  listItem: fw,
  collapsible: hw,
  collapsibleIsOpen: yw,
  collapsibleHeader: gw,
  collapsibleIconTrue: vw,
  collapsibleIconFalse: kw
}, bw = ({
  app: e,
  openByDefault: n
}) => {
  const [r, i] = se(n);
  if (!e)
    return null;
  const {
    name: a,
    platform: o,
    version: s,
    sessions: l,
    first_used: d,
    last_used: m
  } = e;
  return /* @__PURE__ */ oe.jsxs(
    b,
    {
      className: rt(On.collapsible, {
        [On.collapsibleIsOpen]: r
      }),
      gap: "200",
      flexDirection: "column",
      children: [
        /* @__PURE__ */ oe.jsxs(
          b,
          {
            justifyContent: "space-between",
            alignItems: "center",
            className: On.collapsibleHeader,
            onClick: () => i(!r),
            children: [
              /* @__PURE__ */ oe.jsx(A.Paragraph, { variant: "1", children: a }),
              /* @__PURE__ */ oe.jsx(
                Qt,
                {
                  variant: "tertiary",
                  icon: r ? "angle-down" : "angle-right"
                }
              )
            ]
          }
        ),
        r && /* @__PURE__ */ oe.jsxs(Ke, { className: On.list, children: [
          /* @__PURE__ */ oe.jsx(Ke.Text, { variant: "dense", className: On.listItem, children: /* @__PURE__ */ oe.jsxs(b, { gap: "200", justifyContent: "space-between", width: "100%", children: [
            /* @__PURE__ */ oe.jsx(A.Paragraph, { variant: "3", children: "Platform" }),
            /* @__PURE__ */ oe.jsx(A.Paragraph, { variant: "5", color: "secondary", children: o })
          ] }) }),
          /* @__PURE__ */ oe.jsx(Ke.Text, { variant: "dense", className: On.listItem, children: /* @__PURE__ */ oe.jsxs(b, { gap: "200", justifyContent: "space-between", width: "100%", children: [
            /* @__PURE__ */ oe.jsx(A.Paragraph, { variant: "3", children: "Version" }),
            /* @__PURE__ */ oe.jsx(A.Paragraph, { variant: "5", color: "secondary", children: s })
          ] }) }),
          /* @__PURE__ */ oe.jsx(Ke.Text, { variant: "dense", className: On.listItem, children: /* @__PURE__ */ oe.jsxs(b, { gap: "200", justifyContent: "space-between", width: "100%", children: [
            /* @__PURE__ */ oe.jsx(A.Paragraph, { variant: "3", children: "Sessions" }),
            /* @__PURE__ */ oe.jsx(A.Paragraph, { variant: "5", color: "secondary", children: l })
          ] }) }),
          /* @__PURE__ */ oe.jsx(Ke.Text, { variant: "dense", className: On.listItem, children: /* @__PURE__ */ oe.jsxs(b, { gap: "200", justifyContent: "space-between", width: "100%", children: [
            /* @__PURE__ */ oe.jsx(A.Paragraph, { variant: "3", children: "First used" }),
            /* @__PURE__ */ oe.jsx(A.Paragraph, { variant: "5", color: "secondary", children: Ln(d).format(yt) })
          ] }) }),
          /* @__PURE__ */ oe.jsx(Ke.Text, { variant: "dense", className: On.listItem, children: /* @__PURE__ */ oe.jsxs(b, { gap: "200", justifyContent: "space-between", width: "100%", children: [
            /* @__PURE__ */ oe.jsx(A.Paragraph, { variant: "3", children: "Last used" }),
            /* @__PURE__ */ oe.jsx(A.Paragraph, { variant: "5", color: "secondary", children: Ln(m).format(yt) })
          ] }) })
        ] })
      ]
    }
  );
}, _w = ({ apps: e }) => {
  const n = e && e?.length > 0;
  return /* @__PURE__ */ oe.jsxs(b, { gap: "200", flexDirection: "column", margin: "200 0 0", children: [
    /* @__PURE__ */ oe.jsxs(b, { gap: "200", flexDirection: "row", alignItems: "center", children: [
      /* @__PURE__ */ oe.jsx(A.Heading, { variant: "heading-3", children: "Apps" }),
      n && /* @__PURE__ */ oe.jsx(Pn, { size: "small", variant: "success", children: e.length })
    ] }),
    !n && /* @__PURE__ */ oe.jsx(
      A.Paragraph,
      {
        variant: "4",
        margin: "200 0 300 0",
        color: "secondary",
        align: "center",
        children: "There are no apps associated with this customer"
      }
    ),
    e?.map((r, i) => /* @__PURE__ */ oe.jsx(bw, { app: r, openByDefault: i === 0 }, i))
  ] });
}, xw = ({
  customerDetails: e
}) => {
  if (!e)
    return null;
  const { custom_attributes: n } = e, r = !!n && Object.keys(n).length > 0;
  return /* @__PURE__ */ oe.jsx(oe.Fragment, { children: /* @__PURE__ */ oe.jsxs(b, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ oe.jsx(A.Heading, { variant: "heading-3", children: "Custom attributes" }),
    !r && /* @__PURE__ */ oe.jsx(A.Paragraph, { variant: "4", color: "secondary", align: "center", children: "No custom attributes available" }),
    r && /* @__PURE__ */ oe.jsx(Ke, { className: On.list, children: Object.entries(
      n
    ).map(([i, a], o) => (typeof a == "boolean" || typeof a == "string" || typeof a == "number") && /* @__PURE__ */ oe.jsx(
      Ke.Text,
      {
        variant: "dense",
        className: On.listItem,
        children: /* @__PURE__ */ oe.jsxs(b, { justifyContent: "space-between", alignItems: "center", children: [
          /* @__PURE__ */ oe.jsx(A.Paragraph, { variant: "4", children: i }),
          Xa(a)
        ] })
      },
      o
    )) })
  ] }) });
}, Sw = ({
  customerDetails: e
}) => {
  if (!e)
    return null;
  const { custom_events: n } = e, r = n?.sort(
    (a, o) => o?.count - a?.count
  ), i = r && r.length > 0;
  return /* @__PURE__ */ oe.jsx(oe.Fragment, { children: /* @__PURE__ */ oe.jsxs(b, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ oe.jsx(A.Heading, { variant: "heading-3", children: "Custom events" }),
    !i && /* @__PURE__ */ oe.jsx(A.Paragraph, { variant: "4", color: "secondary", align: "center", children: "No custom events available" }),
    i && /* @__PURE__ */ oe.jsx(Ke, { className: On.list, children: r.map((a, o) => /* @__PURE__ */ oe.jsx(
      Ke.Text,
      {
        variant: "dense",
        className: On.listItem,
        children: /* @__PURE__ */ oe.jsxs(b, { justifyContent: "space-between", children: [
          /* @__PURE__ */ oe.jsx(
            Ge,
            {
              content: /* @__PURE__ */ oe.jsxs(b, { flexDirection: "column", children: [
                /* @__PURE__ */ oe.jsx(b, { children: `First ${Ln(a?.first).format(
                  yt
                )}` }),
                /* @__PURE__ */ oe.jsx(b, { children: `Last ${Ln(a?.last).format(
                  yt
                )}` })
              ] }),
              children: /* @__PURE__ */ oe.jsx(A.Paragraph, { variant: "4", children: a?.name })
            }
          ),
          /* @__PURE__ */ oe.jsx(A.Paragraph, { variant: "5", children: a?.count })
        ] })
      },
      o
    )) })
  ] }) });
}, ps = ({
  state: e,
  noTooltip: n = !1,
  isPush: r = !1
}) => {
  if (!e) return null;
  const i = e === "subscribed", a = e === "unsubscribed", o = () => i ? "exclamation" : a ? "close-circle-filled" : "check-circle-filled", s = () => i ? "neutral.500" : a ? "red.500" : "green.500", l = () => {
    const d = r ? "push notifications" : "emails";
    return i ? `Default case "subscribed": The user has neither unsubscribed nor explicitly opted-in to receive ${d}. This is the default subscription state when a user profile is created.` : a ? `Unsubscribed: The user has explicitly unsubscribed from receiving ${d}.` : `Opted in: The user has explicitly confirmed they want to receive ${d}.`;
  };
  return /* @__PURE__ */ oe.jsx(Ge, { content: n ? null : l(), children: /* @__PURE__ */ oe.jsx(b, { alignItems: "center", children: /* @__PURE__ */ oe.jsx(me, { size: 14, name: o(), color: s() }) }) });
}, Nw = "_wrapper_1xucg_1", jw = "_externalLink_1xucg_7", pl = {
  wrapper: Nw,
  externalLink: jw
}, ww = ({
  customerDetails: e
}) => {
  const { isCopied: n, copy: r } = nr(), { isCopied: i, copy: a } = nr(), { isCopied: o, copy: s } = nr(), { isCopied: l, copy: d } = nr(), { isCopied: m, copy: u } = nr();
  if (!e)
    return null;
  const {
    external_id: f,
    braze_id: h,
    first_name: v,
    last_name: C,
    home_city: S,
    country: j,
    email: F,
    phone: y,
    dob: q,
    created_at: T,
    email_subscribe: E,
    push_subscribe: D
  } = e, B = 14, ee = `${v || ""} ${C || ""}`.trim() || "A customer has no name", J = `${S ? `${S} /` : ""} ${j || ""}`.trim(), ae = q ? Ln(q).isSame(Date.now(), "day") : !1;
  return /* @__PURE__ */ oe.jsx(b, { gap: "300", flexDirection: "column", children: /* @__PURE__ */ oe.jsxs(b, { className: pl.wrapper, gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ oe.jsxs(
      b,
      {
        justifyContent: "space-between",
        className: pl.block,
        alignItems: "center",
        children: [
          /* @__PURE__ */ oe.jsx(A.Heading, { variant: "heading-2", children: ee }),
          ae && /* @__PURE__ */ oe.jsx(A.Paragraph, { variant: "4", color: "secondary", children: "... has birthday today 🥳" })
        ]
      }
    ),
    T && /* @__PURE__ */ oe.jsxs(b, { gap: "200", justifyContent: "space-between", margin: "0 0 200", children: [
      /* @__PURE__ */ oe.jsx(A.Paragraph, { variant: "4", children: "Member since" }),
      /* @__PURE__ */ oe.jsx(A.Paragraph, { variant: "4", children: Ln(T).format(yt) })
    ] }),
    J && /* @__PURE__ */ oe.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
      /* @__PURE__ */ oe.jsxs(b, { gap: "200", alignItems: "center", children: [
        /* @__PURE__ */ oe.jsx(me, { size: B, name: "map-pin" }),
        /* @__PURE__ */ oe.jsx(A.Paragraph, { variant: "4", children: J })
      ] }),
      /* @__PURE__ */ oe.jsx(Ge, { content: "Copy location", children: /* @__PURE__ */ oe.jsx(b, { alignItems: "center", children: /* @__PURE__ */ oe.jsx(
        me,
        {
          size: B,
          name: o ? "done" : "copy",
          onClick: () => s(J),
          className: On.copyIcon
        }
      ) }) })
    ] }),
    F && /* @__PURE__ */ oe.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
      /* @__PURE__ */ oe.jsxs(b, { gap: "200", alignItems: "center", children: [
        /* @__PURE__ */ oe.jsx(me, { size: B, name: "mail" }),
        /* @__PURE__ */ oe.jsx("span", { className: pl.externalLink, children: F })
      ] }),
      /* @__PURE__ */ oe.jsx(Ge, { content: "Copy email", children: /* @__PURE__ */ oe.jsx(b, { alignItems: "center", children: /* @__PURE__ */ oe.jsx(
        me,
        {
          size: B,
          name: n ? "done" : "copy",
          onClick: () => r(F),
          className: On.copyIcon
        }
      ) }) })
    ] }),
    y && /* @__PURE__ */ oe.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
      /* @__PURE__ */ oe.jsxs(b, { gap: "200", alignItems: "center", children: [
        /* @__PURE__ */ oe.jsx(me, { size: B, name: "phone" }),
        /* @__PURE__ */ oe.jsx(A.Paragraph, { variant: "4", children: y })
      ] }),
      /* @__PURE__ */ oe.jsx(Ge, { content: "Copy phone number", children: /* @__PURE__ */ oe.jsx(b, { alignItems: "center", children: /* @__PURE__ */ oe.jsx(
        me,
        {
          size: B,
          name: i ? "done" : "copy",
          onClick: () => a(y),
          className: On.copyIcon
        }
      ) }) })
    ] }),
    h && /* @__PURE__ */ oe.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
      /* @__PURE__ */ oe.jsxs(b, { gap: "200", alignItems: "center", children: [
        /* @__PURE__ */ oe.jsx(me, { size: B, name: "user" }),
        /* @__PURE__ */ oe.jsx(A.Paragraph, { variant: "4", children: "Braze ID" }),
        /* @__PURE__ */ oe.jsxs(A.Paragraph, { variant: "5", subdued: !0, color: "tertiary", children: [
          "(",
          h,
          ")"
        ] })
      ] }),
      /* @__PURE__ */ oe.jsx(Ge, { content: "Copy Braze ID", children: /* @__PURE__ */ oe.jsx(b, { alignItems: "center", children: /* @__PURE__ */ oe.jsx(
        me,
        {
          size: B,
          name: l ? "done" : "copy",
          onClick: () => d(h),
          className: On.copyIcon
        }
      ) }) })
    ] }),
    f && /* @__PURE__ */ oe.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
      /* @__PURE__ */ oe.jsxs(b, { gap: "200", alignItems: "center", children: [
        /* @__PURE__ */ oe.jsx(me, { size: B, name: "tag" }),
        /* @__PURE__ */ oe.jsx(A.Paragraph, { variant: "4", children: "External ID" }),
        /* @__PURE__ */ oe.jsxs(A.Paragraph, { variant: "5", subdued: !0, color: "tertiary", children: [
          "(",
          f,
          ")"
        ] })
      ] }),
      /* @__PURE__ */ oe.jsx(Ge, { content: "Copy External ID", children: /* @__PURE__ */ oe.jsx(b, { alignItems: "center", children: /* @__PURE__ */ oe.jsx(
        me,
        {
          size: B,
          name: m ? "done" : "copy",
          onClick: () => u(f),
          className: On.copyIcon
        }
      ) }) })
    ] }),
    E && /* @__PURE__ */ oe.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
      /* @__PURE__ */ oe.jsxs(b, { gap: "200", alignItems: "center", children: [
        /* @__PURE__ */ oe.jsx(me, { size: B, name: "sync" }),
        /* @__PURE__ */ oe.jsx(A.Paragraph, { variant: "4", children: "Email subscription state" })
      ] }),
      /* @__PURE__ */ oe.jsx(ps, { state: E })
    ] }),
    D && /* @__PURE__ */ oe.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
      /* @__PURE__ */ oe.jsxs(b, { gap: "200", alignItems: "center", children: [
        /* @__PURE__ */ oe.jsx(me, { size: B, name: "bell" }),
        /* @__PURE__ */ oe.jsx(A.Paragraph, { variant: "4", children: "Push notification subscription state" })
      ] }),
      /* @__PURE__ */ oe.jsx(ps, { isPush: !0, state: D })
    ] })
  ] }) });
}, Cw = ({
  device: e,
  openByDefault: n
}) => {
  const [r, i] = se(n);
  if (!e)
    return null;
  const a = 14, {
    model: o,
    os: s,
    carrier: l,
    ad_tracking_enabled: d,
    idfa: m,
    idfv: u,
    google_ad_id: f,
    roku_ad_id: h
  } = e;
  return /* @__PURE__ */ oe.jsxs(
    b,
    {
      className: rt(On.collapsible, {
        [On.collapsibleIsOpen]: r
      }),
      gap: "200",
      flexDirection: "column",
      children: [
        /* @__PURE__ */ oe.jsxs(
          b,
          {
            justifyContent: "space-between",
            alignItems: "center",
            className: On.collapsibleHeader,
            onClick: () => i(!r),
            children: [
              /* @__PURE__ */ oe.jsx(A.Paragraph, { variant: "1", children: o }),
              /* @__PURE__ */ oe.jsx(
                Qt,
                {
                  variant: "tertiary",
                  icon: r ? "angle-down" : "angle-right"
                }
              )
            ]
          }
        ),
        r && /* @__PURE__ */ oe.jsxs(Ke, { className: On.list, children: [
          /* @__PURE__ */ oe.jsx(Ke.Text, { variant: "dense", className: On.listItem, children: /* @__PURE__ */ oe.jsxs(b, { gap: "200", justifyContent: "space-between", width: "100%", children: [
            /* @__PURE__ */ oe.jsx(A.Paragraph, { variant: "3", children: "OS" }),
            /* @__PURE__ */ oe.jsx(A.Paragraph, { variant: "5", color: "secondary", children: s })
          ] }) }),
          /* @__PURE__ */ oe.jsx(Ke.Text, { variant: "dense", className: On.listItem, children: /* @__PURE__ */ oe.jsxs(b, { gap: "200", justifyContent: "space-between", width: "100%", children: [
            /* @__PURE__ */ oe.jsx(A.Paragraph, { variant: "3", children: "Carrier" }),
            /* @__PURE__ */ oe.jsx(A.Paragraph, { variant: "5", color: "secondary", children: l })
          ] }) }),
          /* @__PURE__ */ oe.jsx(Ke.Text, { variant: "dense", className: On.listItem, children: /* @__PURE__ */ oe.jsxs(b, { gap: "200", justifyContent: "space-between", width: "100%", children: [
            /* @__PURE__ */ oe.jsx(A.Paragraph, { variant: "3", children: "Ad tracking enabled" }),
            /* @__PURE__ */ oe.jsx(
              me,
              {
                size: a,
                className: rt({
                  [On.collapsibleIconTrue]: d,
                  [On.collapsibleIconFalse]: !d
                }),
                name: d ? "check-circle-filled" : "close-circle-filled"
              }
            )
          ] }) }),
          /* @__PURE__ */ oe.jsx(Ge, { content: "The Apple Identifier for Vendor (iOS)", children: /* @__PURE__ */ oe.jsx(Ke.Text, { variant: "dense", className: On.listItem, children: /* @__PURE__ */ oe.jsxs(
            b,
            {
              gap: "200",
              justifyContent: "space-between",
              width: "100%",
              flexWrap: "wrap",
              children: [
                /* @__PURE__ */ oe.jsx(A.Paragraph, { variant: "3", children: "Braze device identifier" }),
                /* @__PURE__ */ oe.jsx(A.Paragraph, { variant: "5", color: "secondary", children: u })
              ]
            }
          ) }) }),
          /* @__PURE__ */ oe.jsx(Ge, { content: "For iOS", children: /* @__PURE__ */ oe.jsx(Ke.Text, { variant: "dense", className: On.listItem, children: /* @__PURE__ */ oe.jsxs(
            b,
            {
              gap: "200",
              justifyContent: "space-between",
              width: "100%",
              flexWrap: "wrap",
              children: [
                /* @__PURE__ */ oe.jsx(A.Paragraph, { variant: "3", children: "Identifier for Advertising" }),
                /* @__PURE__ */ oe.jsx(A.Paragraph, { variant: "5", color: "secondary", children: m })
              ]
            }
          ) }) }),
          /* @__PURE__ */ oe.jsx(Ke.Text, { variant: "dense", className: On.listItem, children: /* @__PURE__ */ oe.jsxs(
            b,
            {
              gap: "200",
              justifyContent: "space-between",
              width: "100%",
              flexWrap: "wrap",
              children: [
                /* @__PURE__ */ oe.jsx(A.Paragraph, { variant: "3", children: "Roku Advertising id" }),
                /* @__PURE__ */ oe.jsx(A.Paragraph, { variant: "5", color: "secondary", children: h })
              ]
            }
          ) }),
          /* @__PURE__ */ oe.jsx(Ke.Text, { variant: "dense", className: On.listItem, children: /* @__PURE__ */ oe.jsxs(
            b,
            {
              gap: "200",
              justifyContent: "space-between",
              width: "100%",
              flexWrap: "wrap",
              children: [
                /* @__PURE__ */ oe.jsx(A.Paragraph, { variant: "3", children: "Google Play Advertising id" }),
                /* @__PURE__ */ oe.jsx(A.Paragraph, { variant: "5", color: "secondary", children: f })
              ]
            }
          ) })
        ] })
      ]
    }
  );
}, Fw = ({ devices: e }) => {
  const n = e && e?.length > 0;
  return /* @__PURE__ */ oe.jsxs(b, { gap: "200", flexDirection: "column", margin: "200 0 0", children: [
    /* @__PURE__ */ oe.jsxs(b, { gap: "200", flexDirection: "row", alignItems: "center", children: [
      /* @__PURE__ */ oe.jsx(A.Heading, { variant: "heading-3", children: "Devices" }),
      n && /* @__PURE__ */ oe.jsx(Pn, { size: "small", variant: "success", children: e.length })
    ] }),
    !n && /* @__PURE__ */ oe.jsx(
      A.Paragraph,
      {
        variant: "4",
        margin: "200 0 300 0",
        color: "secondary",
        align: "center",
        children: "There are no devices associated with this customer"
      }
    ),
    e?.map((r, i) => /* @__PURE__ */ oe.jsx(Cw, { device: r, openByDefault: i === 0 }, i))
  ] });
}, aa = {
  optIn: {
    label: "Opt in",
    icon: "check-circle-filled",
    color: "var(--dixa-color-green-500)",
    tooltipContent: "Opt in to receive emails",
    parameter: "opted_in"
  },
  unsubscribe: {
    label: "Unsubscribe",
    icon: "close-circle-filled",
    color: "var(--dixa-color-red-500)",
    tooltipContent: "Unsubscribe from emails",
    parameter: "unsubscribed"
  }
}, xo = ({
  email: e,
  updateTo: n,
  refetchCustomerDetails: r
}) => {
  const { track: i } = bn(), { useMutation: a } = mn(), [o, s] = se(!1), [l] = a(
    uw,
    {
      onCompleted: (m) => {
        m?.Braze?.updateEmailSubscriptionStatus?.message === "success" && i(n === "optIn" ? "braze:email:subscription:opt-in:succeeded" : "braze:email:subscription:unsubscribe:succeeded");
      }
    }
  ), d = async () => {
    s(!0), await l({
      variables: {
        input: {
          email: e,
          // eslint-disable-next-line camelcase
          subscription_state: aa[n].parameter
        }
      }
    }), setTimeout(async () => {
      await r().finally(() => s(!1));
    }, 500);
  };
  return /* @__PURE__ */ oe.jsx(Ge, { content: aa[n].tooltipContent, children: /* @__PURE__ */ oe.jsx(
    Wn,
    {
      variant: "secondary",
      color: aa[n].color,
      isLoading: o,
      onClick: () => d(),
      "data-testid": "braze-subscription-button",
      children: /* @__PURE__ */ oe.jsxs(b, { gap: "100", alignItems: "center", children: [
        /* @__PURE__ */ oe.jsx(
          ps,
          {
            noTooltip: !0,
            state: aa[n].parameter
          }
        ),
        aa[n].label
      ] })
    }
  ) });
}, Iw = ({
  customerDetails: e,
  showCustomerDetails: n,
  refetchCustomerDetails: r
}) => {
  if (!e)
    return null;
  const { email: i, email_subscribe: a } = e;
  if (!i)
    return null;
  const o = a === "subscribed", s = a === "unsubscribed", l = a === "opted_in";
  return /* @__PURE__ */ oe.jsx(b, { gap: "300", flexDirection: "column", children: /* @__PURE__ */ oe.jsxs(b, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ oe.jsx(A.Heading, { variant: "heading-3", children: "Update Email subscription state" }),
    !n && /* @__PURE__ */ oe.jsx(Ke, { className: On.list, children: /* @__PURE__ */ oe.jsx(Ke.Text, { variant: "dense", className: On.listItem, children: /* @__PURE__ */ oe.jsxs(b, { justifyContent: "space-between", children: [
      /* @__PURE__ */ oe.jsxs(b, { gap: "200", alignItems: "center", children: [
        /* @__PURE__ */ oe.jsx(me, { size: 14, name: "sync" }),
        /* @__PURE__ */ oe.jsx(A.Paragraph, { variant: "4", children: "Email subscription state" })
      ] }),
      /* @__PURE__ */ oe.jsx(ps, { state: a })
    ] }) }) }),
    /* @__PURE__ */ oe.jsxs(b, { gap: "200", alignItems: "center", children: [
      o && /* @__PURE__ */ oe.jsxs(oe.Fragment, { children: [
        /* @__PURE__ */ oe.jsx(
          xo,
          {
            email: i,
            updateTo: "optIn",
            refetchCustomerDetails: r
          }
        ),
        /* @__PURE__ */ oe.jsx(
          xo,
          {
            email: i,
            updateTo: "unsubscribe",
            refetchCustomerDetails: r
          }
        )
      ] }),
      s && /* @__PURE__ */ oe.jsx(
        xo,
        {
          email: i,
          updateTo: "optIn",
          refetchCustomerDetails: r
        }
      ),
      l && /* @__PURE__ */ oe.jsx(
        xo,
        {
          email: i,
          updateTo: "unsubscribe",
          refetchCustomerDetails: r
        }
      )
    ] })
  ] }) });
}, Ew = ({
  customerDetails: e
}) => {
  if (!e)
    return null;
  const { purchases: n } = e, r = n?.sort(
    (a, o) => o?.count - a?.count
  ), i = r && r.length > 0;
  return /* @__PURE__ */ oe.jsx(oe.Fragment, { children: /* @__PURE__ */ oe.jsxs(b, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ oe.jsx(A.Heading, { variant: "heading-3", children: "Purchases" }),
    !i && /* @__PURE__ */ oe.jsx(A.Paragraph, { variant: "4", color: "secondary", align: "center", children: "No purchases available" }),
    i && /* @__PURE__ */ oe.jsx(Ke, { className: On.list, children: r.map((a, o) => /* @__PURE__ */ oe.jsx(
      Ke.Text,
      {
        variant: "dense",
        className: On.listItem,
        children: /* @__PURE__ */ oe.jsxs(b, { justifyContent: "space-between", children: [
          /* @__PURE__ */ oe.jsx(
            Ge,
            {
              content: /* @__PURE__ */ oe.jsxs(b, { flexDirection: "column", children: [
                /* @__PURE__ */ oe.jsx(b, { children: `First ${Ln(a?.first).format(
                  yt
                )}` }),
                /* @__PURE__ */ oe.jsx(b, { children: `Last ${Ln(a?.last).format(
                  yt
                )}` })
              ] }),
              children: /* @__PURE__ */ oe.jsx(A.Paragraph, { variant: "4", children: a?.name })
            }
          ),
          /* @__PURE__ */ oe.jsx(A.Paragraph, { variant: "5", children: a?.count })
        ] })
      },
      o
    )) })
  ] }) });
}, Tw = ({
  conversationContext: e,
  settings: n
}) => {
  const { track: r } = bn(), { useMutation: i } = mn(), [a, o] = se(), [s, l] = se(!1), [d, m] = se(!1), u = e?.customer?.email, f = e?.customer?.phone_number, h = n.displayCustomerDetails ?? !1, v = n.updateEmailSubscriptionState ?? !1, C = n.displayCustomAttributes ?? !1, S = n.displayCustomEvents ?? !1, j = n.displayPuchases ?? !1, F = n.displayDevices ?? !1, y = n.displayApps ?? !1, q = !h && !v && !C && !S && !j, [T, { error: E }] = i(
    dw,
    {
      onError: () => {
      },
      onCompleted: (B) => {
        const ee = B?.Braze?.exportUserDetails?.users?.[0];
        ee ? (o(ee), l(!1), r("braze:profile:received")) : (o(void 0), l(!0));
      }
    }
  ), D = async () => {
    u || f ? await T({
      variables: {
        input: {
          // Use the email if exists. Otherwise use the phone number. We decided
          // to not search for both together, because we receive a customer
          // entity for each input parameter and we only want one.
          /* eslint-disable camelcase */
          ...u ? { email_address: u } : { phone: f },
          fields_to_export: [
            "external_id",
            "braze_id",
            "created_at",
            "email",
            "first_name",
            "last_name",
            "dob",
            "home_city",
            "country",
            "phone",
            "language",
            "time_zone",
            "total_revenue",
            "push_subscribe",
            "email_subscribe",
            "custom_attributes",
            "custom_events",
            "purchases",
            "apps",
            "devices"
          ]
          /* eslint-enable camelcase */
        }
      }
    }) : l(!0);
  };
  if (He(() => {
    async function B() {
      m(!0), await D();
    }
    B().finally(() => m(!1));
  }, [u, f]), E) {
    const B = E.graphQLErrors;
    return Fm({ errors: B }) ? /* @__PURE__ */ oe.jsx(
      A.Paragraph,
      {
        margin: "200 0 300 0",
        color: "secondary",
        "data-testid": "widget-downstream-api-forbidden-error",
        children: "The API key used for the integration does not have the necessary access rights. Please contact your administrator."
      }
    ) : Im({ errors: B }) ? /* @__PURE__ */ oe.jsx(
      A.Paragraph,
      {
        margin: "200 0 300 0",
        color: "secondary",
        "data-testid": "widget-downstream-api-authorization-error",
        children: "The integration could not authorize against Braze. Please contact your administrator."
      }
    ) : /* @__PURE__ */ oe.jsx(Fn, { error: E });
  }
  return d ? /* @__PURE__ */ oe.jsx(b, { justifyContent: "center", margin: "300", children: /* @__PURE__ */ oe.jsx(cn, {}) }) : q ? /* @__PURE__ */ oe.jsx(
    A.Paragraph,
    {
      margin: "200 0 300 0",
      color: "secondary",
      align: "center",
      "data-testid": "widget-no-features",
      children: "All features toggles in the settings are disabled."
    }
  ) : s ? /* @__PURE__ */ oe.jsx(
    A.Paragraph,
    {
      margin: "200 0 300 0",
      color: "secondary",
      align: "center",
      "data-testid": "widget-no-customer-found",
      children: "No customer found with this email or phone number."
    }
  ) : /* @__PURE__ */ oe.jsxs(
    b,
    {
      gap: "300",
      flexDirection: "column",
      margin: "0 0 300 0",
      "data-testid": "widget-wrapper",
      children: [
        h && /* @__PURE__ */ oe.jsx(ww, { customerDetails: a }),
        v && !!a && /* @__PURE__ */ oe.jsx(
          Iw,
          {
            customerDetails: a,
            showCustomerDetails: h,
            refetchCustomerDetails: async () => await D()
          }
        ),
        C && !!a && /* @__PURE__ */ oe.jsx(xw, { customerDetails: a }),
        S && !!a && /* @__PURE__ */ oe.jsx(Sw, { customerDetails: a }),
        j && !!a && /* @__PURE__ */ oe.jsx(Ew, { customerDetails: a }),
        F && !!a && /* @__PURE__ */ oe.jsx(Fw, { devices: a?.devices }),
        y && !!a && /* @__PURE__ */ oe.jsx(_w, { apps: a?.apps })
      ]
    }
  );
}, $w = [
  {
    key: "apiHostName",
    label: "API endpoint",
    placeholder: "REST API endpoint for your region, e.g. rest.iad-01.braze.com",
    required: !0,
    secret: !1,
    type: "input",
    prefix: "https://",
    customValidation: (e) => Ib(e)
  },
  {
    key: "brazeApiKey",
    label: "API key",
    placeholder: "Insert your API key",
    required: !0,
    secret: !0,
    type: "input"
  },
  {
    key: "displayCustomerDetails",
    label: "Display customer details",
    secret: !1,
    defaultValue: !0,
    type: "switch"
  },
  {
    key: "updateEmailSubscriptionState",
    label: "Display the button to change the email subscription state",
    secret: !1,
    defaultValue: !0,
    type: "switch"
  },
  {
    key: "displayCustomAttributes",
    label: "Display a list of custom attributes",
    secret: !1,
    defaultValue: !0,
    type: "switch"
  },
  {
    key: "displayCustomEvents",
    label: "Display a list of custom events",
    secret: !1,
    defaultValue: !0,
    type: "switch"
  },
  {
    key: "displayPuchases",
    label: "Display a list of purchases",
    secret: !1,
    defaultValue: !0,
    type: "switch"
  },
  {
    key: "displayDevices",
    label: "Display customer devices",
    secret: !1,
    defaultValue: !0,
    type: "switch"
  },
  {
    key: "displayApps",
    label: "Display customer apps",
    secret: !1,
    defaultValue: !0,
    type: "switch"
  }
];
function Dw() {
  var e = mi(!1), n = tt(function() {
    return e.current;
  }, []);
  return He(function() {
    return e.current = !0, function() {
      e.current = !1;
    };
  }, []), n;
}
var Rw = function(e) {
  e === void 0 && (e = {});
  var n = se(e), r = n[0], i = n[1], a = tt(function(o) {
    i(function(s) {
      return Object.assign({}, s, o instanceof Function ? o(s) : o);
    });
  }, []);
  return [r, a];
}, Ow = function(e, n) {
  return typeof n == "boolean" ? n : !e;
}, Lf = function(e) {
  return s0(Ow, e);
}, fl, Vf;
function Pw() {
  return Vf || (Vf = 1, fl = function() {
    var e = document.getSelection();
    if (!e.rangeCount)
      return function() {
      };
    for (var n = document.activeElement, r = [], i = 0; i < e.rangeCount; i++)
      r.push(e.getRangeAt(i));
    switch (n.tagName.toUpperCase()) {
      // .toUpperCase handles XHTML
      case "INPUT":
      case "TEXTAREA":
        n.blur();
        break;
      default:
        n = null;
        break;
    }
    return e.removeAllRanges(), function() {
      e.type === "Caret" && e.removeAllRanges(), e.rangeCount || r.forEach(function(a) {
        e.addRange(a);
      }), n && n.focus();
    };
  }), fl;
}
var hl, zf;
function Aw() {
  if (zf) return hl;
  zf = 1;
  var e = Pw(), n = {
    "text/plain": "Text",
    "text/html": "Url",
    default: "Text"
  }, r = "Copy to clipboard: #{key}, Enter";
  function i(o) {
    var s = (/mac os x/i.test(navigator.userAgent) ? "⌘" : "Ctrl") + "+C";
    return o.replace(/#{\s*key\s*}/g, s);
  }
  function a(o, s) {
    var l, d, m, u, f, h, v = !1;
    s || (s = {}), l = s.debug || !1;
    try {
      m = e(), u = document.createRange(), f = document.getSelection(), h = document.createElement("span"), h.textContent = o, h.ariaHidden = "true", h.style.all = "unset", h.style.position = "fixed", h.style.top = 0, h.style.clip = "rect(0, 0, 0, 0)", h.style.whiteSpace = "pre", h.style.webkitUserSelect = "text", h.style.MozUserSelect = "text", h.style.msUserSelect = "text", h.style.userSelect = "text", h.addEventListener("copy", function(S) {
        if (S.stopPropagation(), s.format)
          if (S.preventDefault(), typeof S.clipboardData > "u") {
            l && console.warn("unable to use e.clipboardData"), l && console.warn("trying IE specific stuff"), window.clipboardData.clearData();
            var j = n[s.format] || n.default;
            window.clipboardData.setData(j, o);
          } else
            S.clipboardData.clearData(), S.clipboardData.setData(s.format, o);
        s.onCopy && (S.preventDefault(), s.onCopy(S.clipboardData));
      }), document.body.appendChild(h), u.selectNodeContents(h), f.addRange(u);
      var C = document.execCommand("copy");
      if (!C)
        throw new Error("copy command was unsuccessful");
      v = !0;
    } catch (S) {
      l && console.error("unable to copy using execCommand: ", S), l && console.warn("trying IE specific stuff");
      try {
        window.clipboardData.setData(s.format || "text", o), s.onCopy && s.onCopy(window.clipboardData), v = !0;
      } catch (j) {
        l && console.error("unable to copy using clipboardData: ", j), l && console.error("falling back to prompt"), d = i("message" in s ? s.message : r), window.prompt(d, o);
      }
    } finally {
      f && (typeof f.removeRange == "function" ? f.removeRange(u) : f.removeAllRanges()), h && document.body.removeChild(h), m();
    }
    return v;
  }
  return hl = a, hl;
}
var Lw = Aw();
const Vw = /* @__PURE__ */ Um(Lw);
var v_ = function() {
  var e = Dw(), n = Rw({
    value: void 0,
    error: void 0,
    noUserInteraction: !0
  }), r = n[0], i = n[1], a = tt(function(o) {
    if (e()) {
      var s, l;
      try {
        if (typeof o != "string" && typeof o != "number") {
          var d = new Error("Cannot copy typeof " + typeof o + " to clipboard, must be a string");
          process.env.NODE_ENV === "development" && console.error(d), i({
            value: o,
            error: d,
            noUserInteraction: !0
          });
          return;
        } else if (o === "") {
          var d = new Error("Cannot copy empty string to clipboard.");
          process.env.NODE_ENV === "development" && console.error(d), i({
            value: o,
            error: d,
            noUserInteraction: !0
          });
          return;
        }
        l = o.toString(), s = Vw(l), i({
          value: l,
          error: void 0,
          noUserInteraction: s
        });
      } catch (m) {
        i({
          value: l,
          error: m,
          noUserInteraction: s
        });
      }
    }
  }, []);
  return [r, a];
};
function zw(e, n) {
  n === void 0 && (n = 0);
  var r = mi(!1), i = mi(), a = mi(e), o = tt(function() {
    return r.current;
  }, []), s = tt(function() {
    r.current = !1, i.current && clearTimeout(i.current), i.current = setTimeout(function() {
      r.current = !0, a.current();
    }, n);
  }, [n]), l = tt(function() {
    r.current = null, i.current && clearTimeout(i.current);
  }, []);
  return He(function() {
    a.current = e;
  }, [e]), He(function() {
    return s(), l;
  }, [n]), [o, l, s];
}
function ki(e, n, r) {
  n === void 0 && (n = 0), r === void 0 && (r = []);
  var i = zw(e, n), a = i[0], o = i[1], s = i[2];
  return He(s, r), [a, o];
}
var Uw = function(e) {
  He(e, []);
}, Mw = function(e, n) {
  var r = mi(function() {
  });
  He(function() {
    r.current = e;
  }), He(function() {
    if (n !== null) {
      var i = setInterval(function() {
        return r.current();
      }, n || 0);
      return function() {
        return clearInterval(i);
      };
    }
  }, [n]);
}, Bw = function(e) {
  e === void 0 && (e = {});
  var n = se(e), r = n[0], i = n[1], a = Bn(function() {
    return {
      set: function(s, l) {
        i(function(d) {
          var m;
          return rl(rl({}, d), (m = {}, m[s] = l, m));
        });
      },
      setAll: function(s) {
        i(s);
      },
      remove: function(s) {
        i(function(l) {
          var d = l, m = s;
          d[m];
          var u = C0(d, [typeof m == "symbol" ? m : m + ""]);
          return u;
        });
      },
      reset: function() {
        return i(e);
      }
    };
  }, [i]), o = rl({ get: tt(function(s) {
    return r[s];
  }, [r]) }, a);
  return [r, o];
}, qw = function(e) {
  var n = mi(e);
  n.current = e, Uw(function() {
    return function() {
      return n.current();
    };
  });
}, uo = (e) => e.type === "checkbox", ci = (e) => e instanceof Date, At = (e) => e == null;
const k_ = (e) => typeof e == "object";
var lt = (e) => !At(e) && !Array.isArray(e) && k_(e) && !ci(e), b_ = (e) => lt(e) && e.target ? uo(e.target) ? e.target.checked : e.target.value : e, Hw = (e) => e.substring(0, e.search(/\.\d+(\.|$)/)) || e, __ = (e, n) => e.has(Hw(n)), Ww = (e) => {
  const n = e.constructor && e.constructor.prototype;
  return lt(n) && n.hasOwnProperty("isPrototypeOf");
}, Xm = typeof window < "u" && typeof window.HTMLElement < "u" && typeof document < "u";
function xt(e) {
  let n;
  const r = Array.isArray(e), i = typeof FileList < "u" ? e instanceof FileList : !1;
  if (e instanceof Date)
    n = new Date(e);
  else if (e instanceof Set)
    n = new Set(e);
  else if (!(Xm && (e instanceof Blob || i)) && (r || lt(e)))
    if (n = r ? [] : {}, !r && !Ww(e))
      n = e;
    else
      for (const a in e)
        e.hasOwnProperty(a) && (n[a] = xt(e[a]));
  else
    return e;
  return n;
}
var Bs = (e) => Array.isArray(e) ? e.filter(Boolean) : [], it = (e) => e === void 0, Ye = (e, n, r) => {
  if (!n || !lt(e))
    return r;
  const i = Bs(n.split(/[,[\].]+?/)).reduce((a, o) => At(a) ? a : a[o], e);
  return it(i) || i === e ? it(e[n]) ? r : e[n] : i;
}, Xt = (e) => typeof e == "boolean", Zm = (e) => /^\w*$/.test(e), x_ = (e) => Bs(e.replace(/["|']|\]/g, "").split(/\.|\[/)), Gn = (e, n, r) => {
  let i = -1;
  const a = Zm(n) ? [n] : x_(n), o = a.length, s = o - 1;
  for (; ++i < o; ) {
    const l = a[i];
    let d = r;
    if (i !== s) {
      const m = e[l];
      d = lt(m) || Array.isArray(m) ? m : isNaN(+a[i + 1]) ? {} : [];
    }
    if (l === "__proto__" || l === "constructor" || l === "prototype")
      return;
    e[l] = d, e = e[l];
  }
};
const fs = {
  BLUR: "blur",
  FOCUS_OUT: "focusout",
  CHANGE: "change"
}, hr = {
  onBlur: "onBlur",
  onChange: "onChange",
  onSubmit: "onSubmit",
  onTouched: "onTouched",
  all: "all"
}, Lr = {
  max: "max",
  min: "min",
  maxLength: "maxLength",
  minLength: "minLength",
  pattern: "pattern",
  required: "required",
  validate: "validate"
}, S_ = je.createContext(null), Or = () => je.useContext(S_), ep = (e) => {
  const { children: n, ...r } = e;
  return je.createElement(S_.Provider, { value: r }, n);
};
var N_ = (e, n, r, i = !0) => {
  const a = {
    defaultValues: n._defaultValues
  };
  for (const o in e)
    Object.defineProperty(a, o, {
      get: () => {
        const s = o;
        return n._proxyFormState[s] !== hr.all && (n._proxyFormState[s] = !i || hr.all), r && (r[s] = !0), e[s];
      }
    });
  return a;
};
function Kw(e) {
  const n = Or(), { control: r = n.control, disabled: i, name: a, exact: o } = e || {}, [s, l] = je.useState(r._formState), d = je.useRef({
    isDirty: !1,
    isLoading: !1,
    dirtyFields: !1,
    touchedFields: !1,
    validatingFields: !1,
    isValidating: !1,
    isValid: !1,
    errors: !1
  }), m = je.useRef(a);
  return m.current = a, je.useEffect(() => r._subscribe({
    name: m.current,
    formState: d.current,
    exact: o,
    callback: (u) => {
      !i && l({
        ...r._formState,
        ...u
      });
    }
  }), [r, i, o]), je.useEffect(() => {
    d.current.isValid && r._setValid(!0);
  }, [r]), je.useMemo(() => N_(s, r, d.current, !1), [s, r]);
}
var Tr = (e) => typeof e == "string", j_ = (e, n, r, i, a) => Tr(e) ? (i && n.watch.add(e), Ye(r, e, a)) : Array.isArray(e) ? e.map((o) => (i && n.watch.add(o), Ye(r, o))) : (i && (n.watchAll = !0), r);
function es(e) {
  const n = Or(), { control: r = n.control, name: i, defaultValue: a, disabled: o, exact: s } = e || {}, l = je.useRef(i), d = je.useRef(a);
  l.current = i, je.useEffect(() => r._subscribe({
    name: l.current,
    formState: {
      values: !0
    },
    exact: s,
    callback: (f) => !o && u(j_(l.current, r._names, f.values || r._formValues, !1, d.current))
  }), [r, o, s]);
  const [m, u] = je.useState(r._getWatch(i, a));
  return je.useEffect(() => r._removeUnmounted()), m;
}
function np(e) {
  const n = Or(), { name: r, disabled: i, control: a = n.control, shouldUnregister: o } = e, s = __(a._names.array, r), l = es({
    control: a,
    name: r,
    defaultValue: Ye(a._formValues, r, Ye(a._defaultValues, r, e.defaultValue)),
    exact: !0
  }), d = Kw({
    control: a,
    name: r,
    exact: !0
  }), m = je.useRef(e), u = je.useRef(a.register(r, {
    ...e.rules,
    value: l,
    ...Xt(e.disabled) ? { disabled: e.disabled } : {}
  })), f = je.useMemo(() => Object.defineProperties({}, {
    invalid: {
      enumerable: !0,
      get: () => !!Ye(d.errors, r)
    },
    isDirty: {
      enumerable: !0,
      get: () => !!Ye(d.dirtyFields, r)
    },
    isTouched: {
      enumerable: !0,
      get: () => !!Ye(d.touchedFields, r)
    },
    isValidating: {
      enumerable: !0,
      get: () => !!Ye(d.validatingFields, r)
    },
    error: {
      enumerable: !0,
      get: () => Ye(d.errors, r)
    }
  }), [d, r]), h = je.useCallback((j) => u.current.onChange({
    target: {
      value: b_(j),
      name: r
    },
    type: fs.CHANGE
  }), [r]), v = je.useCallback(() => u.current.onBlur({
    target: {
      value: Ye(a._formValues, r),
      name: r
    },
    type: fs.BLUR
  }), [r, a._formValues]), C = je.useCallback((j) => {
    const F = Ye(a._fields, r);
    F && j && (F._f.ref = {
      focus: () => j.focus(),
      select: () => j.select(),
      setCustomValidity: (y) => j.setCustomValidity(y),
      reportValidity: () => j.reportValidity()
    });
  }, [a._fields, r]), S = je.useMemo(() => ({
    name: r,
    value: l,
    ...Xt(i) || d.disabled ? { disabled: d.disabled || i } : {},
    onChange: h,
    onBlur: v,
    ref: C
  }), [r, i, d.disabled, h, v, C, l]);
  return je.useEffect(() => {
    const j = a._options.shouldUnregister || o;
    a.register(r, {
      ...m.current.rules,
      ...Xt(m.current.disabled) ? { disabled: m.current.disabled } : {}
    });
    const F = (y, q) => {
      const T = Ye(a._fields, y);
      T && T._f && (T._f.mount = q);
    };
    if (F(r, !0), j) {
      const y = xt(Ye(a._options.defaultValues, r));
      Gn(a._defaultValues, r, y), it(Ye(a._formValues, r)) && Gn(a._formValues, r, y);
    }
    return !s && a.register(r), () => {
      (s ? j && !a._state.action : j) ? a.unregister(r) : F(r, !1);
    };
  }, [r, a, s, o]), je.useEffect(() => {
    a._setDisabledField({
      disabled: i,
      name: r
    });
  }, [i, r, a]), je.useMemo(() => ({
    field: S,
    formState: d,
    fieldState: f
  }), [S, d, f]);
}
const zt = (e) => e.render(np(e));
var Gw = (e, n, r, i, a) => n ? {
  ...r[e],
  types: {
    ...r[e] && r[e].types ? r[e].types : {},
    [i]: a || !0
  }
} : {}, Ma = (e) => Array.isArray(e) ? e : [e], Uf = () => {
  let e = [];
  return {
    get observers() {
      return e;
    },
    next: (a) => {
      for (const o of e)
        o.next && o.next(a);
    },
    subscribe: (a) => (e.push(a), {
      unsubscribe: () => {
        e = e.filter((o) => o !== a);
      }
    }),
    unsubscribe: () => {
      e = [];
    }
  };
}, nm = (e) => At(e) || !k_(e);
function Jr(e, n) {
  if (nm(e) || nm(n))
    return e === n;
  if (ci(e) && ci(n))
    return e.getTime() === n.getTime();
  const r = Object.keys(e), i = Object.keys(n);
  if (r.length !== i.length)
    return !1;
  for (const a of r) {
    const o = e[a];
    if (!i.includes(a))
      return !1;
    if (a !== "ref") {
      const s = n[a];
      if (ci(o) && ci(s) || lt(o) && lt(s) || Array.isArray(o) && Array.isArray(s) ? !Jr(o, s) : o !== s)
        return !1;
    }
  }
  return !0;
}
var Rt = (e) => lt(e) && !Object.keys(e).length, tp = (e) => e.type === "file", yr = (e) => typeof e == "function", hs = (e) => {
  if (!Xm)
    return !1;
  const n = e ? e.ownerDocument : 0;
  return e instanceof (n && n.defaultView ? n.defaultView.HTMLElement : HTMLElement);
}, w_ = (e) => e.type === "select-multiple", rp = (e) => e.type === "radio", Yw = (e) => rp(e) || uo(e), yl = (e) => hs(e) && e.isConnected;
function Qw(e, n) {
  const r = n.slice(0, -1).length;
  let i = 0;
  for (; i < r; )
    e = it(e) ? i++ : e[n[i++]];
  return e;
}
function Jw(e) {
  for (const n in e)
    if (e.hasOwnProperty(n) && !it(e[n]))
      return !1;
  return !0;
}
function pt(e, n) {
  const r = Array.isArray(n) ? n : Zm(n) ? [n] : x_(n), i = r.length === 1 ? e : Qw(e, r), a = r.length - 1, o = r[a];
  return i && delete i[o], a !== 0 && (lt(i) && Rt(i) || Array.isArray(i) && Jw(i)) && pt(e, r.slice(0, -1)), e;
}
var C_ = (e) => {
  for (const n in e)
    if (yr(e[n]))
      return !0;
  return !1;
};
function ys(e, n = {}) {
  const r = Array.isArray(e);
  if (lt(e) || r)
    for (const i in e)
      Array.isArray(e[i]) || lt(e[i]) && !C_(e[i]) ? (n[i] = Array.isArray(e[i]) ? [] : {}, ys(e[i], n[i])) : At(e[i]) || (n[i] = !0);
  return n;
}
function F_(e, n, r) {
  const i = Array.isArray(e);
  if (lt(e) || i)
    for (const a in e)
      Array.isArray(e[a]) || lt(e[a]) && !C_(e[a]) ? it(n) || nm(r[a]) ? r[a] = Array.isArray(e[a]) ? ys(e[a], []) : { ...ys(e[a]) } : F_(e[a], At(n) ? {} : n[a], r[a]) : r[a] = !Jr(e[a], n[a]);
  return r;
}
var oa = (e, n) => F_(e, n, ys(n));
const Mf = {
  value: !1,
  isValid: !1
}, Bf = { value: !0, isValid: !0 };
var I_ = (e) => {
  if (Array.isArray(e)) {
    if (e.length > 1) {
      const n = e.filter((r) => r && r.checked && !r.disabled).map((r) => r.value);
      return { value: n, isValid: !!n.length };
    }
    return e[0].checked && !e[0].disabled ? (
      // @ts-expect-error expected to work in the browser
      e[0].attributes && !it(e[0].attributes.value) ? it(e[0].value) || e[0].value === "" ? Bf : { value: e[0].value, isValid: !0 } : Bf
    ) : Mf;
  }
  return Mf;
}, E_ = (e, { valueAsNumber: n, valueAsDate: r, setValueAs: i }) => it(e) ? e : n ? e === "" ? NaN : e && +e : r && Tr(e) ? new Date(e) : i ? i(e) : e;
const qf = {
  isValid: !1,
  value: null
};
var T_ = (e) => Array.isArray(e) ? e.reduce((n, r) => r && r.checked && !r.disabled ? {
  isValid: !0,
  value: r.value
} : n, qf) : qf;
function Hf(e) {
  const n = e.ref;
  return tp(n) ? n.files : rp(n) ? T_(e.refs).value : w_(n) ? [...n.selectedOptions].map(({ value: r }) => r) : uo(n) ? I_(e.refs).value : E_(it(n.value) ? e.ref.value : n.value, e);
}
var Xw = (e, n, r, i) => {
  const a = {};
  for (const o of e) {
    const s = Ye(n, o);
    s && Gn(a, o, s._f);
  }
  return {
    criteriaMode: r,
    names: [...e],
    fields: a,
    shouldUseNativeValidation: i
  };
}, gs = (e) => e instanceof RegExp, sa = (e) => it(e) ? e : gs(e) ? e.source : lt(e) ? gs(e.value) ? e.value.source : e.value : e, Wf = (e) => ({
  isOnSubmit: !e || e === hr.onSubmit,
  isOnBlur: e === hr.onBlur,
  isOnChange: e === hr.onChange,
  isOnAll: e === hr.all,
  isOnTouch: e === hr.onTouched
});
const Kf = "AsyncFunction";
var Zw = (e) => !!e && !!e.validate && !!(yr(e.validate) && e.validate.constructor.name === Kf || lt(e.validate) && Object.values(e.validate).find((n) => n.constructor.name === Kf)), eC = (e) => e.mount && (e.required || e.min || e.max || e.maxLength || e.minLength || e.pattern || e.validate), Gf = (e, n, r) => !r && (n.watchAll || n.watch.has(e) || [...n.watch].some((i) => e.startsWith(i) && /^\.\w+/.test(e.slice(i.length))));
const Ba = (e, n, r, i) => {
  for (const a of r || Object.keys(e)) {
    const o = Ye(e, a);
    if (o) {
      const { _f: s, ...l } = o;
      if (s) {
        if (s.refs && s.refs[0] && n(s.refs[0], a) && !i)
          return !0;
        if (s.ref && n(s.ref, s.name) && !i)
          return !0;
        if (Ba(l, n))
          break;
      } else if (lt(l) && Ba(l, n))
        break;
    }
  }
};
function Yf(e, n, r) {
  const i = Ye(e, r);
  if (i || Zm(r))
    return {
      error: i,
      name: r
    };
  const a = r.split(".");
  for (; a.length; ) {
    const o = a.join("."), s = Ye(n, o), l = Ye(e, o);
    if (s && !Array.isArray(s) && r !== o)
      return { name: r };
    if (l && l.type)
      return {
        name: o,
        error: l
      };
    a.pop();
  }
  return {
    name: r
  };
}
var nC = (e, n, r, i) => {
  r(e);
  const { name: a, ...o } = e;
  return Rt(o) || Object.keys(o).length >= Object.keys(n).length || Object.keys(o).find((s) => n[s] === (!i || hr.all));
}, tC = (e, n, r) => !e || !n || e === n || Ma(e).some((i) => i && (r ? i === n : i.startsWith(n) || n.startsWith(i))), rC = (e, n, r, i, a) => a.isOnAll ? !1 : !r && a.isOnTouch ? !(n || e) : (r ? i.isOnBlur : a.isOnBlur) ? !e : (r ? i.isOnChange : a.isOnChange) ? e : !0, iC = (e, n) => !Bs(Ye(e, n)).length && pt(e, n), aC = (e, n, r) => {
  const i = Ma(Ye(e, r));
  return Gn(i, "root", n[r]), Gn(e, r, i), e;
}, ns = (e) => Tr(e);
function Qf(e, n, r = "validate") {
  if (ns(e) || Array.isArray(e) && e.every(ns) || Xt(e) && !e)
    return {
      type: r,
      message: ns(e) ? e : "",
      ref: n
    };
}
var ji = (e) => lt(e) && !gs(e) ? e : {
  value: e,
  message: ""
}, Jf = async (e, n, r, i, a, o) => {
  const { ref: s, refs: l, required: d, maxLength: m, minLength: u, min: f, max: h, pattern: v, validate: C, name: S, valueAsNumber: j, mount: F } = e._f, y = Ye(r, S);
  if (!F || n.has(S))
    return {};
  const q = l ? l[0] : s, T = (U) => {
    a && q.reportValidity && (q.setCustomValidity(Xt(U) ? "" : U || ""), q.reportValidity());
  }, E = {}, D = rp(s), B = uo(s), ee = D || B, J = (j || tp(s)) && it(s.value) && it(y) || hs(s) && s.value === "" || y === "" || Array.isArray(y) && !y.length, ae = Gw.bind(null, S, i, E), Q = (U, O, H, Z = Lr.maxLength, ye = Lr.minLength) => {
    const ce = U ? O : H;
    E[S] = {
      type: U ? Z : ye,
      message: ce,
      ref: s,
      ...ae(U ? Z : ye, ce)
    };
  };
  if (o ? !Array.isArray(y) || !y.length : d && (!ee && (J || At(y)) || Xt(y) && !y || B && !I_(l).isValid || D && !T_(l).isValid)) {
    const { value: U, message: O } = ns(d) ? { value: !!d, message: d } : ji(d);
    if (U && (E[S] = {
      type: Lr.required,
      message: O,
      ref: q,
      ...ae(Lr.required, O)
    }, !i))
      return T(O), E;
  }
  if (!J && (!At(f) || !At(h))) {
    let U, O;
    const H = ji(h), Z = ji(f);
    if (!At(y) && !isNaN(y)) {
      const ye = s.valueAsNumber || y && +y;
      At(H.value) || (U = ye > H.value), At(Z.value) || (O = ye < Z.value);
    } else {
      const ye = s.valueAsDate || new Date(y), ce = (W) => /* @__PURE__ */ new Date((/* @__PURE__ */ new Date()).toDateString() + " " + W), le = s.type == "time", ue = s.type == "week";
      Tr(H.value) && y && (U = le ? ce(y) > ce(H.value) : ue ? y > H.value : ye > new Date(H.value)), Tr(Z.value) && y && (O = le ? ce(y) < ce(Z.value) : ue ? y < Z.value : ye < new Date(Z.value));
    }
    if ((U || O) && (Q(!!U, H.message, Z.message, Lr.max, Lr.min), !i))
      return T(E[S].message), E;
  }
  if ((m || u) && !J && (Tr(y) || o && Array.isArray(y))) {
    const U = ji(m), O = ji(u), H = !At(U.value) && y.length > +U.value, Z = !At(O.value) && y.length < +O.value;
    if ((H || Z) && (Q(H, U.message, O.message), !i))
      return T(E[S].message), E;
  }
  if (v && !J && Tr(y)) {
    const { value: U, message: O } = ji(v);
    if (gs(U) && !y.match(U) && (E[S] = {
      type: Lr.pattern,
      message: O,
      ref: s,
      ...ae(Lr.pattern, O)
    }, !i))
      return T(O), E;
  }
  if (C) {
    if (yr(C)) {
      const U = await C(y, r), O = Qf(U, q);
      if (O && (E[S] = {
        ...O,
        ...ae(Lr.validate, O.message)
      }, !i))
        return T(O.message), E;
    } else if (lt(C)) {
      let U = {};
      for (const O in C) {
        if (!Rt(U) && !i)
          break;
        const H = Qf(await C[O](y, r), q, O);
        H && (U = {
          ...H,
          ...ae(O, H.message)
        }, T(H.message), i && (E[S] = U));
      }
      if (!Rt(U) && (E[S] = {
        ref: q,
        ...U
      }, !i))
        return E;
    }
  }
  return T(!0), E;
};
const oC = {
  mode: hr.onSubmit,
  reValidateMode: hr.onChange,
  shouldFocusError: !0
};
function sC(e = {}) {
  let n = {
    ...oC,
    ...e
  }, r = {
    submitCount: 0,
    isDirty: !1,
    isLoading: yr(n.defaultValues),
    isValidating: !1,
    isSubmitted: !1,
    isSubmitting: !1,
    isSubmitSuccessful: !1,
    isValid: !1,
    touchedFields: {},
    dirtyFields: {},
    validatingFields: {},
    errors: n.errors || {},
    disabled: n.disabled || !1
  };
  const i = {};
  let a = lt(n.defaultValues) || lt(n.values) ? xt(n.values || n.defaultValues) || {} : {}, o = n.shouldUnregister ? {} : xt(a), s = {
    action: !1,
    mount: !1,
    watch: !1
  }, l = {
    mount: /* @__PURE__ */ new Set(),
    disabled: /* @__PURE__ */ new Set(),
    unMount: /* @__PURE__ */ new Set(),
    array: /* @__PURE__ */ new Set(),
    watch: /* @__PURE__ */ new Set()
  }, d, m = 0;
  const u = {
    isDirty: !1,
    dirtyFields: !1,
    validatingFields: !1,
    touchedFields: !1,
    isValidating: !1,
    isValid: !1,
    errors: !1
  };
  let f = {
    ...u
  };
  const h = {
    array: Uf(),
    state: Uf()
  }, v = Wf(n.mode), C = Wf(n.reValidateMode), S = n.criteriaMode === hr.all, j = (_) => ($) => {
    clearTimeout(m), m = setTimeout(_, $);
  }, F = async (_) => {
    if (!n.disabled && (u.isValid || f.isValid || _)) {
      const $ = n.resolver ? Rt((await J()).errors) : await Q(i, !0);
      $ !== r.isValid && h.state.next({
        isValid: $
      });
    }
  }, y = (_, $) => {
    !n.disabled && (u.isValidating || u.validatingFields || f.isValidating || f.validatingFields) && ((_ || Array.from(l.mount)).forEach((G) => {
      G && ($ ? Gn(r.validatingFields, G, $) : pt(r.validatingFields, G));
    }), h.state.next({
      validatingFields: r.validatingFields,
      isValidating: !Rt(r.validatingFields)
    }));
  }, q = (_, $ = [], G, Y, R = !0, z = !0) => {
    if (Y && G && !n.disabled) {
      if (s.action = !0, z && Array.isArray(Ye(i, _))) {
        const ie = G(Ye(i, _), Y.argA, Y.argB);
        R && Gn(i, _, ie);
      }
      if (z && Array.isArray(Ye(r.errors, _))) {
        const ie = G(Ye(r.errors, _), Y.argA, Y.argB);
        R && Gn(r.errors, _, ie), iC(r.errors, _);
      }
      if ((u.touchedFields || f.touchedFields) && z && Array.isArray(Ye(r.touchedFields, _))) {
        const ie = G(Ye(r.touchedFields, _), Y.argA, Y.argB);
        R && Gn(r.touchedFields, _, ie);
      }
      (u.dirtyFields || f.dirtyFields) && (r.dirtyFields = oa(a, o)), h.state.next({
        name: _,
        isDirty: O(_, $),
        dirtyFields: r.dirtyFields,
        errors: r.errors,
        isValid: r.isValid
      });
    } else
      Gn(o, _, $);
  }, T = (_, $) => {
    Gn(r.errors, _, $), h.state.next({
      errors: r.errors
    });
  }, E = (_) => {
    r.errors = _, h.state.next({
      errors: r.errors,
      isValid: !1
    });
  }, D = (_, $, G, Y) => {
    const R = Ye(i, _);
    if (R) {
      const z = Ye(o, _, it(G) ? Ye(a, _) : G);
      it(z) || Y && Y.defaultChecked || $ ? Gn(o, _, $ ? z : Hf(R._f)) : ye(_, z), s.mount && F();
    }
  }, B = (_, $, G, Y, R) => {
    let z = !1, ie = !1;
    const pe = {
      name: _
    };
    if (!n.disabled) {
      if (!G || Y) {
        (u.isDirty || f.isDirty) && (ie = r.isDirty, r.isDirty = pe.isDirty = O(), z = ie !== pe.isDirty);
        const _e = Jr(Ye(a, _), $);
        ie = !!Ye(r.dirtyFields, _), _e ? pt(r.dirtyFields, _) : Gn(r.dirtyFields, _, !0), pe.dirtyFields = r.dirtyFields, z = z || (u.dirtyFields || f.dirtyFields) && ie !== !_e;
      }
      if (G) {
        const _e = Ye(r.touchedFields, _);
        _e || (Gn(r.touchedFields, _, G), pe.touchedFields = r.touchedFields, z = z || (u.touchedFields || f.touchedFields) && _e !== G);
      }
      z && R && h.state.next(pe);
    }
    return z ? pe : {};
  }, ee = (_, $, G, Y) => {
    const R = Ye(r.errors, _), z = (u.isValid || f.isValid) && Xt($) && r.isValid !== $;
    if (n.delayError && G ? (d = j(() => T(_, G)), d(n.delayError)) : (clearTimeout(m), d = null, G ? Gn(r.errors, _, G) : pt(r.errors, _)), (G ? !Jr(R, G) : R) || !Rt(Y) || z) {
      const ie = {
        ...Y,
        ...z && Xt($) ? { isValid: $ } : {},
        errors: r.errors,
        name: _
      };
      r = {
        ...r,
        ...ie
      }, h.state.next(ie);
    }
  }, J = async (_) => {
    y(_, !0);
    const $ = await n.resolver(o, n.context, Xw(_ || l.mount, i, n.criteriaMode, n.shouldUseNativeValidation));
    return y(_), $;
  }, ae = async (_) => {
    const { errors: $ } = await J(_);
    if (_)
      for (const G of _) {
        const Y = Ye($, G);
        Y ? Gn(r.errors, G, Y) : pt(r.errors, G);
      }
    else
      r.errors = $;
    return $;
  }, Q = async (_, $, G = {
    valid: !0
  }) => {
    for (const Y in _) {
      const R = _[Y];
      if (R) {
        const { _f: z, ...ie } = R;
        if (z) {
          const pe = l.array.has(z.name), _e = R._f && Zw(R._f);
          _e && u.validatingFields && y([Y], !0);
          const en = await Jf(R, l.disabled, o, S, n.shouldUseNativeValidation && !$, pe);
          if (_e && u.validatingFields && y([Y]), en[z.name] && (G.valid = !1, $))
            break;
          !$ && (Ye(en, z.name) ? pe ? aC(r.errors, en, z.name) : Gn(r.errors, z.name, en[z.name]) : pt(r.errors, z.name));
        }
        !Rt(ie) && await Q(ie, $, G);
      }
    }
    return G.valid;
  }, U = () => {
    for (const _ of l.unMount) {
      const $ = Ye(i, _);
      $ && ($._f.refs ? $._f.refs.every((G) => !yl(G)) : !yl($._f.ref)) && Ae(_);
    }
    l.unMount = /* @__PURE__ */ new Set();
  }, O = (_, $) => !n.disabled && (_ && $ && Gn(o, _, $), !Jr(Ee(), a)), H = (_, $, G) => j_(_, l, {
    ...s.mount ? o : it($) ? a : Tr(_) ? { [_]: $ } : $
  }, G, $), Z = (_) => Bs(Ye(s.mount ? o : a, _, n.shouldUnregister ? Ye(a, _, []) : [])), ye = (_, $, G = {}) => {
    const Y = Ye(i, _);
    let R = $;
    if (Y) {
      const z = Y._f;
      z && (!z.disabled && Gn(o, _, E_($, z)), R = hs(z.ref) && At($) ? "" : $, w_(z.ref) ? [...z.ref.options].forEach((ie) => ie.selected = R.includes(ie.value)) : z.refs ? uo(z.ref) ? z.refs.length > 1 ? z.refs.forEach((ie) => (!ie.defaultChecked || !ie.disabled) && (ie.checked = Array.isArray(R) ? !!R.find((pe) => pe === ie.value) : R === ie.value)) : z.refs[0] && (z.refs[0].checked = !!R) : z.refs.forEach((ie) => ie.checked = ie.value === R) : tp(z.ref) ? z.ref.value = "" : (z.ref.value = R, z.ref.type || h.state.next({
        name: _,
        values: xt(o)
      })));
    }
    (G.shouldDirty || G.shouldTouch) && B(_, R, G.shouldTouch, G.shouldDirty, !0), G.shouldValidate && ke(_);
  }, ce = (_, $, G) => {
    for (const Y in $) {
      const R = $[Y], z = `${_}.${Y}`, ie = Ye(i, z);
      (l.array.has(_) || lt(R) || ie && !ie._f) && !ci(R) ? ce(z, R, G) : ye(z, R, G);
    }
  }, le = (_, $, G = {}) => {
    const Y = Ye(i, _), R = l.array.has(_), z = xt($);
    Gn(o, _, z), R ? (h.array.next({
      name: _,
      values: xt(o)
    }), (u.isDirty || u.dirtyFields || f.isDirty || f.dirtyFields) && G.shouldDirty && h.state.next({
      name: _,
      dirtyFields: oa(a, o),
      isDirty: O(_, z)
    })) : Y && !Y._f && !At(z) ? ce(_, z, G) : ye(_, z, G), Gf(_, l) && h.state.next({ ...r }), h.state.next({
      name: s.mount ? _ : void 0,
      values: xt(o)
    });
  }, ue = async (_) => {
    s.mount = !0;
    const $ = _.target;
    let G = $.name, Y = !0;
    const R = Ye(i, G), z = (ie) => {
      Y = Number.isNaN(ie) || ci(ie) && isNaN(ie.getTime()) || Jr(ie, Ye(o, G, ie));
    };
    if (R) {
      let ie, pe;
      const _e = $.type ? Hf(R._f) : b_(_), en = _.type === fs.BLUR || _.type === fs.FOCUS_OUT, un = !eC(R._f) && !n.resolver && !Ye(r.errors, G) && !R._f.deps || rC(en, Ye(r.touchedFields, G), r.isSubmitted, C, v), rn = Gf(G, l, en);
      Gn(o, G, _e), en ? (R._f.onBlur && R._f.onBlur(_), d && d(0)) : R._f.onChange && R._f.onChange(_);
      const dn = B(G, _e, en), pn = !Rt(dn) || rn;
      if (!en && h.state.next({
        name: G,
        type: _.type,
        values: xt(o)
      }), un)
        return (u.isValid || f.isValid) && (n.mode === "onBlur" ? en && F() : en || F()), pn && h.state.next({ name: G, ...rn ? {} : dn });
      if (!en && rn && h.state.next({ ...r }), n.resolver) {
        const { errors: ln } = await J([G]);
        if (z(_e), Y) {
          const kn = Yf(r.errors, i, G), Xe = Yf(ln, i, kn.name || G);
          ie = Xe.error, G = Xe.name, pe = Rt(ln);
        }
      } else
        y([G], !0), ie = (await Jf(R, l.disabled, o, S, n.shouldUseNativeValidation))[G], y([G]), z(_e), Y && (ie ? pe = !1 : (u.isValid || f.isValid) && (pe = await Q(i, !0)));
      Y && (R._f.deps && ke(R._f.deps), ee(G, pe, ie, dn));
    }
  }, W = (_, $) => {
    if (Ye(r.errors, $) && _.focus)
      return _.focus(), 1;
  }, ke = async (_, $ = {}) => {
    let G, Y;
    const R = Ma(_);
    if (n.resolver) {
      const z = await ae(it(_) ? _ : R);
      G = Rt(z), Y = _ ? !R.some((ie) => Ye(z, ie)) : G;
    } else _ ? (Y = (await Promise.all(R.map(async (z) => {
      const ie = Ye(i, z);
      return await Q(ie && ie._f ? { [z]: ie } : ie);
    }))).every(Boolean), !(!Y && !r.isValid) && F()) : Y = G = await Q(i);
    return h.state.next({
      ...!Tr(_) || (u.isValid || f.isValid) && G !== r.isValid ? {} : { name: _ },
      ...n.resolver || !_ ? { isValid: G } : {},
      errors: r.errors
    }), $.shouldFocus && !Y && Ba(i, W, _ ? R : l.mount), Y;
  }, Ee = (_) => {
    const $ = {
      ...s.mount ? o : a
    };
    return it(_) ? $ : Tr(_) ? Ye($, _) : _.map((G) => Ye($, G));
  }, K = (_, $) => ({
    invalid: !!Ye(($ || r).errors, _),
    isDirty: !!Ye(($ || r).dirtyFields, _),
    error: Ye(($ || r).errors, _),
    isValidating: !!Ye(r.validatingFields, _),
    isTouched: !!Ye(($ || r).touchedFields, _)
  }), qe = (_) => {
    _ && Ma(_).forEach(($) => pt(r.errors, $)), h.state.next({
      errors: _ ? r.errors : {}
    });
  }, Be = (_, $, G) => {
    const Y = (Ye(i, _, { _f: {} })._f || {}).ref, R = Ye(r.errors, _) || {}, { ref: z, message: ie, type: pe, ..._e } = R;
    Gn(r.errors, _, {
      ..._e,
      ...$,
      ref: Y
    }), h.state.next({
      name: _,
      errors: r.errors,
      isValid: !1
    }), G && G.shouldFocus && Y && Y.focus && Y.focus();
  }, Pe = (_, $) => yr(_) ? h.state.subscribe({
    next: (G) => _(H(void 0, $), G)
  }) : H(_, $, !0), Me = (_) => h.state.subscribe({
    next: ($) => {
      tC(_.name, $.name, _.exact) && nC($, _.formState || u, Re, _.reRenderRoot) && _.callback({
        values: { ...o },
        ...r,
        ...$
      });
    }
  }).unsubscribe, Fe = (_) => (s.mount = !0, f = {
    ...f,
    ..._.formState
  }, Me({
    ..._,
    formState: f
  })), Ae = (_, $ = {}) => {
    for (const G of _ ? Ma(_) : l.mount)
      l.mount.delete(G), l.array.delete(G), $.keepValue || (pt(i, G), pt(o, G)), !$.keepError && pt(r.errors, G), !$.keepDirty && pt(r.dirtyFields, G), !$.keepTouched && pt(r.touchedFields, G), !$.keepIsValidating && pt(r.validatingFields, G), !n.shouldUnregister && !$.keepDefaultValue && pt(a, G);
    h.state.next({
      values: xt(o)
    }), h.state.next({
      ...r,
      ...$.keepDirty ? { isDirty: O() } : {}
    }), !$.keepIsValid && F();
  }, $e = ({ disabled: _, name: $ }) => {
    (Xt(_) && s.mount || _ || l.disabled.has($)) && (_ ? l.disabled.add($) : l.disabled.delete($));
  }, tn = (_, $ = {}) => {
    let G = Ye(i, _);
    const Y = Xt($.disabled) || Xt(n.disabled);
    return Gn(i, _, {
      ...G || {},
      _f: {
        ...G && G._f ? G._f : { ref: { name: _ } },
        name: _,
        mount: !0,
        ...$
      }
    }), l.mount.add(_), G ? $e({
      disabled: Xt($.disabled) ? $.disabled : n.disabled,
      name: _
    }) : D(_, !0, $.value), {
      ...Y ? { disabled: $.disabled || n.disabled } : {},
      ...n.progressive ? {
        required: !!$.required,
        min: sa($.min),
        max: sa($.max),
        minLength: sa($.minLength),
        maxLength: sa($.maxLength),
        pattern: sa($.pattern)
      } : {},
      name: _,
      onChange: ue,
      onBlur: ue,
      ref: (R) => {
        if (R) {
          tn(_, $), G = Ye(i, _);
          const z = it(R.value) && R.querySelectorAll && R.querySelectorAll("input,select,textarea")[0] || R, ie = Yw(z), pe = G._f.refs || [];
          if (ie ? pe.find((_e) => _e === z) : z === G._f.ref)
            return;
          Gn(i, _, {
            _f: {
              ...G._f,
              ...ie ? {
                refs: [
                  ...pe.filter(yl),
                  z,
                  ...Array.isArray(Ye(a, _)) ? [{}] : []
                ],
                ref: { type: z.type, name: _ }
              } : { ref: z }
            }
          }), D(_, !1, void 0, z);
        } else
          G = Ye(i, _, {}), G._f && (G._f.mount = !1), (n.shouldUnregister || $.shouldUnregister) && !(__(l.array, _) && s.action) && l.unMount.add(_);
      }
    };
  }, Ie = () => n.shouldFocusError && Ba(i, W, l.mount), We = (_) => {
    Xt(_) && (h.state.next({ disabled: _ }), Ba(i, ($, G) => {
      const Y = Ye(i, G);
      Y && ($.disabled = Y._f.disabled || _, Array.isArray(Y._f.refs) && Y._f.refs.forEach((R) => {
        R.disabled = Y._f.disabled || _;
      }));
    }, 0, !1));
  }, Ze = (_, $) => async (G) => {
    let Y;
    G && (G.preventDefault && G.preventDefault(), G.persist && G.persist());
    let R = xt(o);
    if (h.state.next({
      isSubmitting: !0
    }), n.resolver) {
      const { errors: z, values: ie } = await J();
      r.errors = z, R = ie;
    } else
      await Q(i);
    if (l.disabled.size)
      for (const z of l.disabled)
        Gn(R, z, void 0);
    if (pt(r.errors, "root"), Rt(r.errors)) {
      h.state.next({
        errors: {}
      });
      try {
        await _(R, G);
      } catch (z) {
        Y = z;
      }
    } else
      $ && await $({ ...r.errors }, G), Ie(), setTimeout(Ie);
    if (h.state.next({
      isSubmitted: !0,
      isSubmitting: !1,
      isSubmitSuccessful: Rt(r.errors) && !Y,
      submitCount: r.submitCount + 1,
      errors: r.errors
    }), Y)
      throw Y;
  }, de = (_, $ = {}) => {
    Ye(i, _) && (it($.defaultValue) ? le(_, xt(Ye(a, _))) : (le(_, $.defaultValue), Gn(a, _, xt($.defaultValue))), $.keepTouched || pt(r.touchedFields, _), $.keepDirty || (pt(r.dirtyFields, _), r.isDirty = $.defaultValue ? O(_, xt(Ye(a, _))) : O()), $.keepError || (pt(r.errors, _), u.isValid && F()), h.state.next({ ...r }));
  }, fe = (_, $ = {}) => {
    const G = _ ? xt(_) : a, Y = xt(G), R = Rt(_), z = R ? a : Y;
    if ($.keepDefaultValues || (a = G), !$.keepValues) {
      if ($.keepDirtyValues) {
        const ie = /* @__PURE__ */ new Set([
          ...l.mount,
          ...Object.keys(oa(a, o))
        ]);
        for (const pe of Array.from(ie))
          Ye(r.dirtyFields, pe) ? Gn(z, pe, Ye(o, pe)) : le(pe, Ye(z, pe));
      } else {
        if (Xm && it(_))
          for (const ie of l.mount) {
            const pe = Ye(i, ie);
            if (pe && pe._f) {
              const _e = Array.isArray(pe._f.refs) ? pe._f.refs[0] : pe._f.ref;
              if (hs(_e)) {
                const en = _e.closest("form");
                if (en) {
                  en.reset();
                  break;
                }
              }
            }
          }
        for (const ie of l.mount)
          le(ie, Ye(z, ie));
      }
      o = xt(z), h.array.next({
        values: { ...z }
      }), h.state.next({
        values: { ...z }
      });
    }
    l = {
      mount: $.keepDirtyValues ? l.mount : /* @__PURE__ */ new Set(),
      unMount: /* @__PURE__ */ new Set(),
      array: /* @__PURE__ */ new Set(),
      disabled: /* @__PURE__ */ new Set(),
      watch: /* @__PURE__ */ new Set(),
      watchAll: !1,
      focus: ""
    }, s.mount = !u.isValid || !!$.keepIsValid || !!$.keepDirtyValues, s.watch = !!n.shouldUnregister, h.state.next({
      submitCount: $.keepSubmitCount ? r.submitCount : 0,
      isDirty: R ? !1 : $.keepDirty ? r.isDirty : !!($.keepDefaultValues && !Jr(_, a)),
      isSubmitted: $.keepIsSubmitted ? r.isSubmitted : !1,
      dirtyFields: R ? {} : $.keepDirtyValues ? $.keepDefaultValues && o ? oa(a, o) : r.dirtyFields : $.keepDefaultValues && _ ? oa(a, _) : $.keepDirty ? r.dirtyFields : {},
      touchedFields: $.keepTouched ? r.touchedFields : {},
      errors: $.keepErrors ? r.errors : {},
      isSubmitSuccessful: $.keepIsSubmitSuccessful ? r.isSubmitSuccessful : !1,
      isSubmitting: !1
    });
  }, Te = (_, $) => fe(yr(_) ? _(o) : _, $), Le = (_, $ = {}) => {
    const G = Ye(i, _), Y = G && G._f;
    if (Y) {
      const R = Y.refs ? Y.refs[0] : Y.ref;
      R.focus && (R.focus(), $.shouldSelect && yr(R.select) && R.select());
    }
  }, Re = (_) => {
    r = {
      ...r,
      ..._
    };
  }, w = {
    control: {
      register: tn,
      unregister: Ae,
      getFieldState: K,
      handleSubmit: Ze,
      setError: Be,
      _subscribe: Me,
      _runSchema: J,
      _getWatch: H,
      _getDirty: O,
      _setValid: F,
      _setFieldArray: q,
      _setDisabledField: $e,
      _setErrors: E,
      _getFieldArray: Z,
      _reset: fe,
      _resetDefaultValues: () => yr(n.defaultValues) && n.defaultValues().then((_) => {
        Te(_, n.resetOptions), h.state.next({
          isLoading: !1
        });
      }),
      _removeUnmounted: U,
      _disableForm: We,
      _subjects: h,
      _proxyFormState: u,
      get _fields() {
        return i;
      },
      get _formValues() {
        return o;
      },
      get _state() {
        return s;
      },
      set _state(_) {
        s = _;
      },
      get _defaultValues() {
        return a;
      },
      get _names() {
        return l;
      },
      set _names(_) {
        l = _;
      },
      get _formState() {
        return r;
      },
      get _options() {
        return n;
      },
      set _options(_) {
        n = {
          ...n,
          ..._
        };
      }
    },
    subscribe: Fe,
    trigger: ke,
    register: tn,
    handleSubmit: Ze,
    watch: Pe,
    setValue: le,
    getValues: Ee,
    reset: Te,
    resetField: de,
    clearErrors: qe,
    unregister: Ae,
    setError: Be,
    setFocus: Le,
    getFieldState: K
  };
  return {
    ...w,
    formControl: w
  };
}
function Bt(e = {}) {
  const n = je.useRef(void 0), r = je.useRef(void 0), [i, a] = je.useState({
    isDirty: !1,
    isValidating: !1,
    isLoading: yr(e.defaultValues),
    isSubmitted: !1,
    isSubmitting: !1,
    isSubmitSuccessful: !1,
    isValid: !1,
    submitCount: 0,
    dirtyFields: {},
    touchedFields: {},
    validatingFields: {},
    errors: e.errors || {},
    disabled: e.disabled || !1,
    defaultValues: yr(e.defaultValues) ? void 0 : e.defaultValues
  });
  n.current || (n.current = {
    ...e.formControl ? e.formControl : sC(e),
    formState: i
  }, e.formControl && e.defaultValues && !yr(e.defaultValues) && e.formControl.reset(e.defaultValues, e.resetOptions));
  const o = n.current.control;
  return o._options = e, je.useLayoutEffect(() => o._subscribe({
    formState: o._proxyFormState,
    callback: () => a({ ...o._formState }),
    reRenderRoot: !0
  }), [o]), je.useEffect(() => o._disableForm(e.disabled), [o, e.disabled]), je.useEffect(() => {
    if (o._proxyFormState.isDirty) {
      const s = o._getDirty();
      s !== i.isDirty && o._subjects.state.next({
        isDirty: s
      });
    }
  }, [o, i.isDirty]), je.useEffect(() => {
    e.values && !Jr(e.values, r.current) ? (o._reset(e.values, o._options.resetOptions), r.current = e.values, a((s) => ({ ...s }))) : o._resetDefaultValues();
  }, [e.values, o]), je.useEffect(() => {
    e.errors && !Rt(e.errors) && o._setErrors(e.errors);
  }, [e.errors, o]), je.useEffect(() => {
    o._state.mount || (o._setValid(), o._state.mount = !0), o._state.watch && (o._state.watch = !1, o._subjects.state.next({ ...o._formState })), o._removeUnmounted();
  }), je.useEffect(() => {
    e.shouldUnregister && o._subjects.state.next({
      values: o._getWatch()
    });
  }, [e.shouldUnregister, o]), n.current.formState = N_(i, o), n.current;
}
(function() {
  try {
    if (typeof document < "u") {
      var e = document.createElement("style");
      e.appendChild(document.createTextNode("._contentWrapper_1vx3c_1{margin-bottom:var(--dixa-size-spacer-300)}._contentWrapperHeadline_1vx3c_4{font-weight:var(--dixa-typography-weight-semibold);font-size:var(--dixa-typography-size-100);line-height:var(--dixa-typography-line-height-200);color:var(--dixa-typography-color-tertiary);margin-bottom:var(--dixa-size-spacer-100)}._contentWrapperBody_1vx3c_11{max-height:75vh;overflow-y:auto}._contentWrapperAssigneeIcon_1vx3c_15{border-radius:50%;width:var(--dixa-size-spacer-300);vertical-align:middle}._contentWrapperStatusTag_1vx3c_20{margin-right:var(--dixa-size-spacer-200)}._collapse_1bdjy_1{border:1px solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);font-size:var(--dixa-typography-size-200);line-height:var(--dixa-typography-line-height-200);padding:0}._collapseHeader_1bdjy_10>div{padding:var(--dixa-size-spacer-300) 0!important}._collapseHeader_1bdjy_10>div>div>p{white-space:unset!important}._collapseHeader_1bdjy_10>div:first-child{width:100%}._collapseHeader_1bdjy_10>div:first-child div:first-child{width:100%}._collapseHeader_1bdjy_10>div:first-child div:first-child p{width:calc(100% - 20px)}._collapseHeader_1bdjy_10{background-color:transparent!important;padding:0 var(--dixa-size-spacer-300) 0 0;letter-spacing:-.08px;color:var(--dixa-color-neutral-500)}._collapseHeaderKey_1bdjy_31{font-size:var(--dixa-typography-size-200);line-height:var(--dixa-typography-line-height-200);color:var(--dixa-color-neutral-700)}._collapseHeaderKeyIcon_1bdjy_36{margin-top:-2px;margin-right:var(--dixa-size-spacer-100);vertical-align:middle}._collapseHeaderKeyLink_1bdjy_41{text-decoration:none}._collapseHeaderIcon_1bdjy_44{padding-top:.35em;margin-left:var(--dixa-size-spacer-100);vertical-align:text-bottom}._collapseHeaderTitle_1bdjy_49{font-weight:var(--dixa-typography-weight-semibold);font-size:var(--dixa-typography-size-300);line-height:var(--dixa-typography-line-height-300);letter-spacing:-.16px;color:var(--dixa-typography-color-primary);width:100%}._collapseContent_1bdjy_57{padding:var(--dixa-size-spacer-200) var(--dixa-size-spacer-300)!important}._collapseContentButtonSpacer_1bdjy_60{margin-top:var(--dixa-size-spacer-250)}._collapseContentButtonLink_1bdjy_63{color:var(--dixa-typography-color-link)}._result_1uaom_1{padding:0 var(--dixa-size-spacer-200);margin:0;outline:0;border:0;color:var(--dixa-typography-color-primary);background-color:var(--dixa-color-neutral-000);box-sizing:border-box;display:flex;align-items:center;position:relative;font-size:12px;line-height:32px;height:48px;width:100%;cursor:pointer}._result_1uaom_1:hover,._result_1uaom_1:focus{background-color:var(--dixa-color-neutral-100)}._resultName_1uaom_21{width:100%;text-align:left;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;font-weight:var(--dixa-typography-weight-semibold)}._resultItemIcon_1uaom_29{margin-top:-2px;margin-right:var(--dixa-size-spacer-100);vertical-align:middle}._resultDescription_1uaom_34{width:100%;text-align:left;font-size:var(--dixa-typography-size-200);line-height:var(--dixa-typography-line-height-200);color:var(--dixa-typography-color-secondary);white-space:nowrap;overflow:hidden;text-overflow:ellipsis;margin-top:-.5em;margin-bottom:.5em}._resultLinkIcon_1uaom_46{position:absolute;right:5px;background-color:var(--dixa-color-neutral-000);border:1px solid var(--dixa-color-neutral-300);border-radius:5px;color:var(--dixa-color-neutral-500)}._tooltip_1uaom_55{width:500px;max-height:60vh;overflow:hidden;text-overflow:ellipsis}._tooltipName_1uaom_61{text-align:left;white-space:nowrap;font-weight:var(--dixa-typography-weight-semibold)}._tooltipNameIcon_1uaom_66{height:var(--dixa-typography-line-height-300);padding-right:var(--dixa-size-spacer-100);margin-top:-2px}._tooltipTag_1uaom_71{width:fit-content;max-width:15em}._itemButton_3sxfy_1{border:none;padding:0}._result_3sxfy_6{padding:0 var(--dixa-size-spacer-200);margin:0;outline:0;border:0;color:var(--dixa-typography-color-primary);background-color:var(--dixa-color-neutral-000);box-sizing:border-box;display:flex;align-items:center;position:relative;font-size:var(--dixa-typography-size-200);line-height:32px;height:48px;width:100%;cursor:pointer}._result_3sxfy_6:hover,._result_3sxfy_6:focus{background-color:var(--dixa-color-neutral-100)}._resultIcon_3sxfy_26{height:var(--dixa-size-spacer-400);padding-right:var(--dixa-size-spacer-250)}._resultName_3sxfy_30{width:100%;text-align:left;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;font-weight:var(--dixa-typography-weight-normal)}._resultCheckIcon_3sxfy_38{height:var(--dixa-size-spacer-400)}._resultAssigneeIcon_3sxfy_41{border-radius:50%;width:var(--dixa-size-spacer-300);vertical-align:middle;margin-right:var(--dixa-size-spacer-200)}._modalBody_1hk1o_1{width:600px}._modalBodyFormFields_1hk1o_4{display:grid;gap:var(--dixa-size-spacer-300) var(--dixa-size-spacer-400)}._wrapper_19v8w_1{gap:var(--dixa-size-spacer-250);margin-bottom:var(--dixa-size-spacer-300)}._inputWrapper_19v8w_6{background-color:var(--dixa-color-neutral-100);border-radius:var(--dixa-size-border-radius-100);margin:var(--dixa-size-spacer-300) 0;gap:var(--dixa-size-spacer-250);padding:var(--dixa-size-spacer-300);text-align:center}._inputField_19v8w_15{text-align:center}._buttonLink_19v8w_19{color:var(--dixa-typography-color-link)}._noItemsFound_19v8w_23{color:var(--dixa-color-neutral-400);font-size:var(--dixa-typography-size-200)}._createIssueButton_19v8w_28{min-height:38px}")), document.head.appendChild(e);
    }
  } catch (n) {
    console.error("vite-plugin-css-injected-by-js", n);
  }
})();
var gl = { exports: {} }, la = {}, Xf;
function lC() {
  if (Xf) return la;
  Xf = 1;
  var e = je, n = Symbol.for("react.element"), r = Symbol.for("react.fragment"), i = Object.prototype.hasOwnProperty, a = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, o = { key: !0, ref: !0, __self: !0, __source: !0 };
  function s(l, d, m) {
    var u, f = {}, h = null, v = null;
    m !== void 0 && (h = "" + m), d.key !== void 0 && (h = "" + d.key), d.ref !== void 0 && (v = d.ref);
    for (u in d) i.call(d, u) && !o.hasOwnProperty(u) && (f[u] = d[u]);
    if (l && l.defaultProps) for (u in d = l.defaultProps, d) f[u] === void 0 && (f[u] = d[u]);
    return { $$typeof: n, type: l, key: h, ref: v, props: f, _owner: a.current };
  }
  return la.Fragment = r, la.jsx = s, la.jsxs = s, la;
}
var So = {}, Zf;
function cC() {
  return Zf || (Zf = 1, process.env.NODE_ENV !== "production" && (function() {
    var e = je, n = Symbol.for("react.element"), r = Symbol.for("react.portal"), i = Symbol.for("react.fragment"), a = Symbol.for("react.strict_mode"), o = Symbol.for("react.profiler"), s = Symbol.for("react.provider"), l = Symbol.for("react.context"), d = Symbol.for("react.forward_ref"), m = Symbol.for("react.suspense"), u = Symbol.for("react.suspense_list"), f = Symbol.for("react.memo"), h = Symbol.for("react.lazy"), v = Symbol.for("react.offscreen"), C = Symbol.iterator, S = "@@iterator";
    function j(t) {
      if (t === null || typeof t != "object")
        return null;
      var c = C && t[C] || t[S];
      return typeof c == "function" ? c : null;
    }
    var F = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function y(t) {
      {
        for (var c = arguments.length, p = new Array(c > 1 ? c - 1 : 0), g = 1; g < c; g++)
          p[g - 1] = arguments[g];
        q("error", t, p);
      }
    }
    function q(t, c, p) {
      {
        var g = F.ReactDebugCurrentFrame, P = g.getStackAddendum();
        P !== "" && (c += "%s", p = p.concat([P]));
        var L = p.map(function(I) {
          return String(I);
        });
        L.unshift("Warning: " + c), Function.prototype.apply.call(console[t], console, L);
      }
    }
    var T = !1, E = !1, D = !1, B = !1, ee = !1, J;
    J = Symbol.for("react.module.reference");
    function ae(t) {
      return !!(typeof t == "string" || typeof t == "function" || t === i || t === o || ee || t === a || t === m || t === u || B || t === v || T || E || D || typeof t == "object" && t !== null && (t.$$typeof === h || t.$$typeof === f || t.$$typeof === s || t.$$typeof === l || t.$$typeof === d || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      t.$$typeof === J || t.getModuleId !== void 0));
    }
    function Q(t, c, p) {
      var g = t.displayName;
      if (g)
        return g;
      var P = c.displayName || c.name || "";
      return P !== "" ? p + "(" + P + ")" : p;
    }
    function U(t) {
      return t.displayName || "Context";
    }
    function O(t) {
      if (t == null)
        return null;
      if (typeof t.tag == "number" && y("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof t == "function")
        return t.displayName || t.name || null;
      if (typeof t == "string")
        return t;
      switch (t) {
        case i:
          return "Fragment";
        case r:
          return "Portal";
        case o:
          return "Profiler";
        case a:
          return "StrictMode";
        case m:
          return "Suspense";
        case u:
          return "SuspenseList";
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case l:
            var c = t;
            return U(c) + ".Consumer";
          case s:
            var p = t;
            return U(p._context) + ".Provider";
          case d:
            return Q(t, t.render, "ForwardRef");
          case f:
            var g = t.displayName || null;
            return g !== null ? g : O(t.type) || "Memo";
          case h: {
            var P = t, L = P._payload, I = P._init;
            try {
              return O(I(L));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var H = Object.assign, Z = 0, ye, ce, le, ue, W, ke, Ee;
    function K() {
    }
    K.__reactDisabledLog = !0;
    function qe() {
      {
        if (Z === 0) {
          ye = console.log, ce = console.info, le = console.warn, ue = console.error, W = console.group, ke = console.groupCollapsed, Ee = console.groupEnd;
          var t = {
            configurable: !0,
            enumerable: !0,
            value: K,
            writable: !0
          };
          Object.defineProperties(console, {
            info: t,
            log: t,
            warn: t,
            error: t,
            group: t,
            groupCollapsed: t,
            groupEnd: t
          });
        }
        Z++;
      }
    }
    function Be() {
      {
        if (Z--, Z === 0) {
          var t = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: H({}, t, {
              value: ye
            }),
            info: H({}, t, {
              value: ce
            }),
            warn: H({}, t, {
              value: le
            }),
            error: H({}, t, {
              value: ue
            }),
            group: H({}, t, {
              value: W
            }),
            groupCollapsed: H({}, t, {
              value: ke
            }),
            groupEnd: H({}, t, {
              value: Ee
            })
          });
        }
        Z < 0 && y("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var Pe = F.ReactCurrentDispatcher, Me;
    function Fe(t, c, p) {
      {
        if (Me === void 0)
          try {
            throw Error();
          } catch (P) {
            var g = P.stack.trim().match(/\n( *(at )?)/);
            Me = g && g[1] || "";
          }
        return `
` + Me + t;
      }
    }
    var Ae = !1, $e;
    {
      var tn = typeof WeakMap == "function" ? WeakMap : Map;
      $e = new tn();
    }
    function Ie(t, c) {
      if (!t || Ae)
        return "";
      {
        var p = $e.get(t);
        if (p !== void 0)
          return p;
      }
      var g;
      Ae = !0;
      var P = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var L;
      L = Pe.current, Pe.current = null, qe();
      try {
        if (c) {
          var I = function() {
            throw Error();
          };
          if (Object.defineProperty(I.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(I, []);
            } catch (ne) {
              g = ne;
            }
            Reflect.construct(t, [], I);
          } else {
            try {
              I.call();
            } catch (ne) {
              g = ne;
            }
            t.call(I.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (ne) {
            g = ne;
          }
          t();
        }
      } catch (ne) {
        if (ne && g && typeof ne.stack == "string") {
          for (var N = ne.stack.split(`
`), te = g.stack.split(`
`), x = N.length - 1, V = te.length - 1; x >= 1 && V >= 0 && N[x] !== te[V]; )
            V--;
          for (; x >= 1 && V >= 0; x--, V--)
            if (N[x] !== te[V]) {
              if (x !== 1 || V !== 1)
                do
                  if (x--, V--, V < 0 || N[x] !== te[V]) {
                    var X = `
` + N[x].replace(" at new ", " at ");
                    return t.displayName && X.includes("<anonymous>") && (X = X.replace("<anonymous>", t.displayName)), typeof t == "function" && $e.set(t, X), X;
                  }
                while (x >= 1 && V >= 0);
              break;
            }
        }
      } finally {
        Ae = !1, Pe.current = L, Be(), Error.prepareStackTrace = P;
      }
      var we = t ? t.displayName || t.name : "", Se = we ? Fe(we) : "";
      return typeof t == "function" && $e.set(t, Se), Se;
    }
    function We(t, c, p) {
      return Ie(t, !1);
    }
    function Ze(t) {
      var c = t.prototype;
      return !!(c && c.isReactComponent);
    }
    function de(t, c, p) {
      if (t == null)
        return "";
      if (typeof t == "function")
        return Ie(t, Ze(t));
      if (typeof t == "string")
        return Fe(t);
      switch (t) {
        case m:
          return Fe("Suspense");
        case u:
          return Fe("SuspenseList");
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case d:
            return We(t.render);
          case f:
            return de(t.type, c, p);
          case h: {
            var g = t, P = g._payload, L = g._init;
            try {
              return de(L(P), c, p);
            } catch {
            }
          }
        }
      return "";
    }
    var fe = Object.prototype.hasOwnProperty, Te = {}, Le = F.ReactDebugCurrentFrame;
    function Re(t) {
      if (t) {
        var c = t._owner, p = de(t.type, t._source, c ? c.type : null);
        Le.setExtraStackFrame(p);
      } else
        Le.setExtraStackFrame(null);
    }
    function sn(t, c, p, g, P) {
      {
        var L = Function.call.bind(fe);
        for (var I in t)
          if (L(t, I)) {
            var N = void 0;
            try {
              if (typeof t[I] != "function") {
                var te = Error((g || "React class") + ": " + p + " type `" + I + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof t[I] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw te.name = "Invariant Violation", te;
              }
              N = t[I](c, I, g, p, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (x) {
              N = x;
            }
            N && !(N instanceof Error) && (Re(P), y("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", g || "React class", p, I, typeof N), Re(null)), N instanceof Error && !(N.message in Te) && (Te[N.message] = !0, Re(P), y("Failed %s type: %s", p, N.message), Re(null));
          }
      }
    }
    var w = Array.isArray;
    function _(t) {
      return w(t);
    }
    function $(t) {
      {
        var c = typeof Symbol == "function" && Symbol.toStringTag, p = c && t[Symbol.toStringTag] || t.constructor.name || "Object";
        return p;
      }
    }
    function G(t) {
      try {
        return Y(t), !1;
      } catch {
        return !0;
      }
    }
    function Y(t) {
      return "" + t;
    }
    function R(t) {
      if (G(t))
        return y("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", $(t)), Y(t);
    }
    var z = F.ReactCurrentOwner, ie = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, pe, _e;
    function en(t) {
      if (fe.call(t, "ref")) {
        var c = Object.getOwnPropertyDescriptor(t, "ref").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.ref !== void 0;
    }
    function un(t) {
      if (fe.call(t, "key")) {
        var c = Object.getOwnPropertyDescriptor(t, "key").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.key !== void 0;
    }
    function rn(t, c) {
      typeof t.ref == "string" && z.current;
    }
    function dn(t, c) {
      {
        var p = function() {
          pe || (pe = !0, y("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "key", {
          get: p,
          configurable: !0
        });
      }
    }
    function pn(t, c) {
      {
        var p = function() {
          _e || (_e = !0, y("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "ref", {
          get: p,
          configurable: !0
        });
      }
    }
    var ln = function(t, c, p, g, P, L, I) {
      var N = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: n,
        // Built-in properties that belong on the element
        type: t,
        key: c,
        ref: p,
        props: I,
        // Record the component responsible for creating this element.
        _owner: L
      };
      return N._store = {}, Object.defineProperty(N._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(N, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: g
      }), Object.defineProperty(N, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: P
      }), Object.freeze && (Object.freeze(N.props), Object.freeze(N)), N;
    };
    function kn(t, c, p, g, P) {
      {
        var L, I = {}, N = null, te = null;
        p !== void 0 && (R(p), N = "" + p), un(c) && (R(c.key), N = "" + c.key), en(c) && (te = c.ref, rn(c));
        for (L in c)
          fe.call(c, L) && !ie.hasOwnProperty(L) && (I[L] = c[L]);
        if (t && t.defaultProps) {
          var x = t.defaultProps;
          for (L in x)
            I[L] === void 0 && (I[L] = x[L]);
        }
        if (N || te) {
          var V = typeof t == "function" ? t.displayName || t.name || "Unknown" : t;
          N && dn(I, V), te && pn(I, V);
        }
        return ln(t, N, te, P, g, z.current, I);
      }
    }
    var Xe = F.ReactCurrentOwner, Sn = F.ReactDebugCurrentFrame;
    function Oe(t) {
      if (t) {
        var c = t._owner, p = de(t.type, t._source, c ? c.type : null);
        Sn.setExtraStackFrame(p);
      } else
        Sn.setExtraStackFrame(null);
    }
    var an;
    an = !1;
    function on(t) {
      return typeof t == "object" && t !== null && t.$$typeof === n;
    }
    function yn() {
      {
        if (Xe.current) {
          var t = O(Xe.current.type);
          if (t)
            return `

Check the render method of \`` + t + "`.";
        }
        return "";
      }
    }
    function qn(t) {
      return "";
    }
    var Nn = {};
    function gn(t) {
      {
        var c = yn();
        if (!c) {
          var p = typeof t == "string" ? t : t.displayName || t.name;
          p && (c = `

Check the top-level render call using <` + p + ">.");
        }
        return c;
      }
    }
    function hn(t, c) {
      {
        if (!t._store || t._store.validated || t.key != null)
          return;
        t._store.validated = !0;
        var p = gn(c);
        if (Nn[p])
          return;
        Nn[p] = !0;
        var g = "";
        t && t._owner && t._owner !== Xe.current && (g = " It was passed a child from " + O(t._owner.type) + "."), Oe(t), y('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', p, g), Oe(null);
      }
    }
    function jn(t, c) {
      {
        if (typeof t != "object")
          return;
        if (_(t))
          for (var p = 0; p < t.length; p++) {
            var g = t[p];
            on(g) && hn(g, c);
          }
        else if (on(t))
          t._store && (t._store.validated = !0);
        else if (t) {
          var P = j(t);
          if (typeof P == "function" && P !== t.entries)
            for (var L = P.call(t), I; !(I = L.next()).done; )
              on(I.value) && hn(I.value, c);
        }
      }
    }
    function Un(t) {
      {
        var c = t.type;
        if (c == null || typeof c == "string")
          return;
        var p;
        if (typeof c == "function")
          p = c.propTypes;
        else if (typeof c == "object" && (c.$$typeof === d || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        c.$$typeof === f))
          p = c.propTypes;
        else
          return;
        if (p) {
          var g = O(c);
          sn(p, t.props, "prop", g, t);
        } else if (c.PropTypes !== void 0 && !an) {
          an = !0;
          var P = O(c);
          y("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", P || "Unknown");
        }
        typeof c.getDefaultProps == "function" && !c.getDefaultProps.isReactClassApproved && y("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function Vn(t) {
      {
        for (var c = Object.keys(t.props), p = 0; p < c.length; p++) {
          var g = c[p];
          if (g !== "children" && g !== "key") {
            Oe(t), y("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", g), Oe(null);
            break;
          }
        }
        t.ref !== null && (Oe(t), y("Invalid attribute `ref` supplied to `React.Fragment`."), Oe(null));
      }
    }
    var _n = {};
    function xn(t, c, p, g, P, L) {
      {
        var I = ae(t);
        if (!I) {
          var N = "";
          (t === void 0 || typeof t == "object" && t !== null && Object.keys(t).length === 0) && (N += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var te = qn();
          te ? N += te : N += yn();
          var x;
          t === null ? x = "null" : _(t) ? x = "array" : t !== void 0 && t.$$typeof === n ? (x = "<" + (O(t.type) || "Unknown") + " />", N = " Did you accidentally export a JSX literal instead of a component?") : x = typeof t, y("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", x, N);
        }
        var V = kn(t, c, p, P, L);
        if (V == null)
          return V;
        if (I) {
          var X = c.children;
          if (X !== void 0)
            if (g)
              if (_(X)) {
                for (var we = 0; we < X.length; we++)
                  jn(X[we], t);
                Object.freeze && Object.freeze(X);
              } else
                y("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              jn(X, t);
        }
        if (fe.call(c, "key")) {
          var Se = O(t), ne = Object.keys(c).filter(function(wn) {
            return wn !== "key";
          }), nn = ne.length > 0 ? "{key: someKey, " + ne.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!_n[Se + nn]) {
            var Tn = ne.length > 0 ? "{" + ne.join(": ..., ") + ": ...}" : "{}";
            y(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, nn, Se, Tn, Se), _n[Se + nn] = !0;
          }
        }
        return t === i ? Vn(V) : Un(V), V;
      }
    }
    function Hn(t, c, p) {
      return xn(t, c, p, !0);
    }
    function Dn(t, c, p) {
      return xn(t, c, p, !1);
    }
    var Rn = Dn, Mn = Hn;
    So.Fragment = i, So.jsx = Rn, So.jsxs = Mn;
  })()), So;
}
var eh;
function dC() {
  return eh || (eh = 1, process.env.NODE_ENV === "production" ? gl.exports = lC() : gl.exports = cC()), gl.exports;
}
var xe = dC();
const uC = { kind: "Document", definitions: [{ kind: "FragmentDefinition", name: { kind: "Name", value: "IssueFields" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "GitHub_Issue" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "number" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "body" } }, { kind: "Field", name: { kind: "Name", value: "bodyText" } }, { kind: "Field", name: { kind: "Name", value: "author" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "avatarUrl" } }, { kind: "Field", name: { kind: "Name", value: "login" } }] } }, { kind: "Field", alias: { kind: "Name", value: "issueState" }, name: { kind: "Name", value: "state" } }, { kind: "Field", name: { kind: "Name", value: "assignees" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "10" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "avatarUrl" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "labels" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "10" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "color" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "repository" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "owner" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "login" } }] } }] } }] } }] }, mC = { kind: "Document", definitions: [{ kind: "FragmentDefinition", name: { kind: "Name", value: "PullRequestFields" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "GitHub_PullRequest" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "number" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "body" } }, { kind: "Field", name: { kind: "Name", value: "bodyText" } }, { kind: "Field", name: { kind: "Name", value: "author" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "avatarUrl" } }, { kind: "Field", name: { kind: "Name", value: "login" } }] } }, { kind: "Field", alias: { kind: "Name", value: "prState" }, name: { kind: "Name", value: "state" } }, { kind: "Field", name: { kind: "Name", value: "assignees" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "10" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "avatarUrl" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "labels" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "10" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "color" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "repository" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "owner" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "login" } }] } }] } }] } }] }, pC = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getGithubOrganizationMembersByName" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "organizationQuery" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "usersQuery" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "maxResults" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "GitHub" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "organization" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "login" }, value: { kind: "Variable", name: { kind: "Name", value: "organizationQuery" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "teams" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "Variable", name: { kind: "Name", value: "maxResults" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "edges" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "node" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "members" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "Variable", name: { kind: "Name", value: "maxResults" } } }, { kind: "Argument", name: { kind: "Name", value: "query" }, value: { kind: "Variable", name: { kind: "Name", value: "usersQuery" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "edges" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "node" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "login" } }, { kind: "Field", name: { kind: "Name", value: "avatarUrl" } }] } }] } }] } }] } }] } }] } }] } }] } }] } }] }, fC = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "createGithubIssue" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "input" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "GitHub_CreateIssueInput" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "GitHub" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "createIssue" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "input" }, value: { kind: "Variable", name: { kind: "Name", value: "input" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "issue" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "number" } }, { kind: "Field", name: { kind: "Name", value: "repository" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }] } }] } }] } }] }, hC = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getGithubRepositoriesByName" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "query" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "maxResults" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "GitHub" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "search" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "query" }, value: { kind: "Variable", name: { kind: "Name", value: "query" } } }, { kind: "Argument", name: { kind: "Name", value: "type" }, value: { kind: "EnumValue", value: "REPOSITORY" } }, { kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "Variable", name: { kind: "Name", value: "maxResults" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "repositoryCount" } }, { kind: "Field", name: { kind: "Name", value: "edges" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "node" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "GitHub_Repository" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }] } }] } }] } }] } }] }, yC = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "searchItems" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "issueQuery" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "prQuery" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "maxIssueResults" } }, type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "maxPRResults" } }, type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "GitHub" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", alias: { kind: "Name", value: "issues" }, name: { kind: "Name", value: "search" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "query" }, value: { kind: "Variable", name: { kind: "Name", value: "issueQuery" } } }, { kind: "Argument", name: { kind: "Name", value: "type" }, value: { kind: "EnumValue", value: "ISSUE" } }, { kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "Variable", name: { kind: "Name", value: "maxIssueResults" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "issueCount" } }, { kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "GitHub_Issue" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "number" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "body" } }, { kind: "Field", name: { kind: "Name", value: "bodyText" } }, { kind: "Field", name: { kind: "Name", value: "author" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "avatarUrl" } }, { kind: "Field", name: { kind: "Name", value: "login" } }] } }, { kind: "Field", name: { kind: "Name", value: "state" } }, { kind: "Field", name: { kind: "Name", value: "assignees" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "10" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "avatarUrl" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "labels" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "10" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "color" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "repository" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "owner" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "login" } }] } }] } }] } }] } }] } }, { kind: "Field", alias: { kind: "Name", value: "pullRequests" }, name: { kind: "Name", value: "search" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "query" }, value: { kind: "Variable", name: { kind: "Name", value: "prQuery" } } }, { kind: "Argument", name: { kind: "Name", value: "type" }, value: { kind: "EnumValue", value: "ISSUE" } }, { kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "Variable", name: { kind: "Name", value: "maxPRResults" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "issueCount" } }, { kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "GitHub_PullRequest" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "number" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "body" } }, { kind: "Field", name: { kind: "Name", value: "bodyText" } }, { kind: "Field", name: { kind: "Name", value: "author" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "avatarUrl" } }, { kind: "Field", name: { kind: "Name", value: "login" } }] } }, { kind: "Field", name: { kind: "Name", value: "state" } }, { kind: "Field", name: { kind: "Name", value: "assignees" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "10" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "avatarUrl" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "labels" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "10" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "color" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "repository" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "owner" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "login" } }] } }] } }] } }] } }] } }] } }] } }] }, gC = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getIssue" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "owner" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "repositoryName" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "issueNumber" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "GitHub" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "repository" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "owner" }, value: { kind: "Variable", name: { kind: "Name", value: "owner" } } }, { kind: "Argument", name: { kind: "Name", value: "name" }, value: { kind: "Variable", name: { kind: "Name", value: "repositoryName" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "issue" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "number" }, value: { kind: "Variable", name: { kind: "Name", value: "issueNumber" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "number" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "body" } }, { kind: "Field", name: { kind: "Name", value: "bodyText" } }, { kind: "Field", name: { kind: "Name", value: "author" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "avatarUrl" } }, { kind: "Field", name: { kind: "Name", value: "login" } }] } }, { kind: "Field", name: { kind: "Name", value: "state" } }, { kind: "Field", name: { kind: "Name", value: "assignees" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "10" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "avatarUrl" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "labels" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "10" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "color" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "repository" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "owner" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "login" } }] } }] } }] } }] } }] } }] } }] }, vC = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getPullRequest" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "owner" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "repositoryName" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "prNumber" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "GitHub" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "repository" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "owner" }, value: { kind: "Variable", name: { kind: "Name", value: "owner" } } }, { kind: "Argument", name: { kind: "Name", value: "name" }, value: { kind: "Variable", name: { kind: "Name", value: "repositoryName" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pullRequest" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "number" }, value: { kind: "Variable", name: { kind: "Name", value: "prNumber" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "number" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "body" } }, { kind: "Field", name: { kind: "Name", value: "bodyText" } }, { kind: "Field", name: { kind: "Name", value: "author" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "avatarUrl" } }, { kind: "Field", name: { kind: "Name", value: "login" } }] } }, { kind: "Field", name: { kind: "Name", value: "state" } }, { kind: "Field", name: { kind: "Name", value: "assignees" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "10" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "avatarUrl" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "labels" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "10" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "color" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "repository" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "owner" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "login" } }] } }] } }] } }] } }] } }] } }] }, kC = {
  "\n  query getGithubOrganizationMembersByName(\n    $organizationQuery: String!\n    $usersQuery: String!\n    $maxResults: Int!\n  ) {\n    GitHub {\n      organization(login: $organizationQuery) {\n        teams(first: $maxResults) {\n          edges {\n            node {\n              id\n              name\n              members(first: $maxResults, query: $usersQuery) {\n                edges {\n                  node {\n                    id\n                    name\n                    login\n                    avatarUrl\n                  }\n                }\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n": pC,
  "\n  mutation createGithubIssue($input: GitHub_CreateIssueInput!) {\n    GitHub {\n      createIssue(input: $input) {\n        issue {\n          id\n          number\n          repository {\n            name\n          }\n        }\n      }\n    }\n  }\n": fC,
  "\n  query getGithubRepositoriesByName($query: String!, $maxResults: Int!) {\n    GitHub {\n      search(query: $query, type: REPOSITORY, first: $maxResults) {\n        repositoryCount\n        edges {\n          node {\n            ... on GitHub_Repository {\n              id\n              name\n            }\n          }\n        }\n      }\n    }\n  }\n": hC,
  "\n  fragment IssueFields on GitHub_Issue {\n    id\n    number\n    title\n    body\n    bodyText\n    author {\n      avatarUrl\n      login\n    }\n    issueState: state\n    assignees(first: 10) {\n      nodes {\n        avatarUrl\n        name\n      }\n    }\n    labels(first: 10) {\n      nodes {\n        color\n        name\n      }\n    }\n    repository {\n      name\n      owner {\n        login\n      }\n    }\n  }\n": uC,
  "\n  fragment PullRequestFields on GitHub_PullRequest {\n    id\n    number\n    title\n    body\n    bodyText\n    author {\n      avatarUrl\n      login\n    }\n    prState: state\n    assignees(first: 10) {\n      nodes {\n        avatarUrl\n        name\n      }\n    }\n    labels(first: 10) {\n      nodes {\n        color\n        name\n      }\n    }\n    repository {\n      name\n      owner {\n        login\n      }\n    }\n  }\n": mC,
  "\n  query searchItems(\n    $issueQuery: String!\n    $prQuery: String!\n    $maxIssueResults: Int\n    $maxPRResults: Int\n  ) {\n    GitHub {\n      issues: search(query: $issueQuery, type: ISSUE, first: $maxIssueResults) {\n        issueCount\n        nodes {\n          ... on GitHub_Issue {\n            id\n            number\n            title\n            body\n            bodyText\n            author {\n              avatarUrl\n              login\n            }\n            state\n            assignees(first: 10) {\n              nodes {\n                avatarUrl\n                name\n              }\n            }\n            labels(first: 10) {\n              nodes {\n                color\n                name\n              }\n            }\n            repository {\n              name\n              owner {\n                login\n              }\n            }\n          }\n        }\n      }\n      pullRequests: search(query: $prQuery, type: ISSUE, first: $maxPRResults) {\n        issueCount\n        nodes {\n          ... on GitHub_PullRequest {\n            id\n            number\n            title\n            body\n            bodyText\n            author {\n              avatarUrl\n              login\n            }\n            state\n            assignees(first: 10) {\n              nodes {\n                avatarUrl\n                name\n              }\n            }\n            labels(first: 10) {\n              nodes {\n                color\n                name\n              }\n            }\n            repository {\n              name\n              owner {\n                login\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n": yC,
  "\n  query getIssue(\n    $owner: String!\n    $repositoryName: String!\n    $issueNumber: Int!\n  ) {\n    GitHub {\n      repository(owner: $owner, name: $repositoryName) {\n        issue(number: $issueNumber) {\n          id\n          number\n          title\n          body\n          bodyText\n          author {\n            avatarUrl\n            login\n          }\n          state\n          assignees(first: 10) {\n            nodes {\n              avatarUrl\n              name\n            }\n          }\n          labels(first: 10) {\n            nodes {\n              color\n              name\n            }\n          }\n          repository {\n            name\n            owner {\n              login\n            }\n          }\n        }\n      }\n    }\n  }\n": gC,
  "\n  query getPullRequest(\n    $owner: String!\n    $repositoryName: String!\n    $prNumber: Int!\n  ) {\n    GitHub {\n      repository(owner: $owner, name: $repositoryName) {\n        pullRequest(number: $prNumber) {\n          id\n          number\n          title\n          body\n          bodyText\n          author {\n            avatarUrl\n            login\n          }\n          state\n          assignees(first: 10) {\n            nodes {\n              avatarUrl\n              name\n            }\n          }\n          labels(first: 10) {\n            nodes {\n              color\n              name\n            }\n          }\n          repository {\n            name\n            owner {\n              login\n            }\n          }\n        }\n      }\n    }\n  }\n": vC
};
function Gi(e) {
  return kC[e] ?? {};
}
const bC = Gi(
  /* GraphQL */
  `
  query searchItems(
    $issueQuery: String!
    $prQuery: String!
    $maxIssueResults: Int
    $maxPRResults: Int
  ) {
    GitHub {
      issues: search(query: $issueQuery, type: ISSUE, first: $maxIssueResults) {
        issueCount
        nodes {
          ... on GitHub_Issue {
            id
            number
            title
            body
            bodyText
            author {
              avatarUrl
              login
            }
            state
            assignees(first: 10) {
              nodes {
                avatarUrl
                name
              }
            }
            labels(first: 10) {
              nodes {
                color
                name
              }
            }
            repository {
              name
              owner {
                login
              }
            }
          }
        }
      }
      pullRequests: search(query: $prQuery, type: ISSUE, first: $maxPRResults) {
        issueCount
        nodes {
          ... on GitHub_PullRequest {
            id
            number
            title
            body
            bodyText
            author {
              avatarUrl
              login
            }
            state
            assignees(first: 10) {
              nodes {
                avatarUrl
                name
              }
            }
            labels(first: 10) {
              nodes {
                color
                name
              }
            }
            repository {
              name
              owner {
                login
              }
            }
          }
        }
      }
    }
  }
`
), _C = Gi(
  /* GraphQL */
  `
  query getIssue(
    $owner: String!
    $repositoryName: String!
    $issueNumber: Int!
  ) {
    GitHub {
      repository(owner: $owner, name: $repositoryName) {
        issue(number: $issueNumber) {
          id
          number
          title
          body
          bodyText
          author {
            avatarUrl
            login
          }
          state
          assignees(first: 10) {
            nodes {
              avatarUrl
              name
            }
          }
          labels(first: 10) {
            nodes {
              color
              name
            }
          }
          repository {
            name
            owner {
              login
            }
          }
        }
      }
    }
  }
`
), xC = Gi(
  /* GraphQL */
  `
  query getPullRequest(
    $owner: String!
    $repositoryName: String!
    $prNumber: Int!
  ) {
    GitHub {
      repository(owner: $owner, name: $repositoryName) {
        pullRequest(number: $prNumber) {
          id
          number
          title
          body
          bodyText
          author {
            avatarUrl
            login
          }
          state
          assignees(first: 10) {
            nodes {
              avatarUrl
              name
            }
          }
          labels(first: 10) {
            nodes {
              color
              name
            }
          }
          repository {
            name
            owner {
              login
            }
          }
        }
      }
    }
  }
`
), nh = ({
  owner: e,
  repository: n,
  number: r
}) => `https://github.com/${e}/${n}/issues/${r}`, ar = ({
  owner: e,
  repository: n,
  number: r
}) => `${e}/${n} #${r}`, SC = ({
  number: e,
  repository: n
}) => ({
  number: e,
  repository: n.name,
  owner: n.owner.login
}), th = (e) => {
  switch (e) {
    case "ISSUE":
      return "issue";
    case "PR":
      return "pull request";
    default:
      return e;
  }
}, tm = (e, n, r) => e === "ISSUE" ? {
  OPEN: /* @__PURE__ */ xe.jsxs(
    "svg",
    {
      className: r,
      fill: "#3fb950",
      height: "16",
      width: "16",
      "aria-hidden": "true",
      children: [
        /* @__PURE__ */ xe.jsx("path", { d: "M8 9.5a1.5 1.5 0 100-3 1.5 1.5 0 000 3z" }),
        /* @__PURE__ */ xe.jsx("path", { d: "M8 0a8 8 0 100 16A8 8 0 008 0zM1.5 8a6.5 6.5 0 1113 0 6.5 6.5 0 01-13 0z" })
      ]
    }
  ),
  CLOSED: /* @__PURE__ */ xe.jsxs(
    "svg",
    {
      className: r,
      fill: "#a371f7",
      width: "16",
      height: "16",
      "aria-hidden": "true",
      children: [
        /* @__PURE__ */ xe.jsx("path", { d: "M11.28 6.78a.75.75 0 00-1.06-1.06L7.25 8.69 5.78 7.22a.75.75 0 00-1.06 1.06l2 2a.75.75 0 001.06 0l3.5-3.5z" }),
        /* @__PURE__ */ xe.jsx(
          "path",
          {
            fillRule: "evenodd",
            d: "M16 8A8 8 0 110 8a8 8 0 0116 0zm-1.5 0a6.5 6.5 0 11-13 0 6.5 6.5 0 0113 0z"
          }
        )
      ]
    }
  )
}[n] : {
  OPEN: /* @__PURE__ */ xe.jsx(
    "svg",
    {
      className: r,
      fill: "#3fb950",
      width: "16",
      height: "16",
      "aria-hidden": "true",
      children: /* @__PURE__ */ xe.jsx("path", { d: "M7.177 3.073L9.573.677A.25.25 0 0110 .854v4.792a.25.25 0 01-.427.177L7.177 3.427a.25.25 0 010-.354zM3.75 2.5a.75.75 0 100 1.5.75.75 0 000-1.5zm-2.25.75a2.25 2.25 0 113 2.122v5.256a2.251 2.251 0 11-1.5 0V5.372A2.25 2.25 0 011.5 3.25zM11 2.5h-1V4h1a1 1 0 011 1v5.628a2.251 2.251 0 101.5 0V5A2.5 2.5 0 0011 2.5zm1 10.25a.75.75 0 111.5 0 .75.75 0 01-1.5 0zM3.75 12a.75.75 0 100 1.5.75.75 0 000-1.5z" })
    }
  ),
  MERGED: /* @__PURE__ */ xe.jsx(
    "svg",
    {
      className: r,
      fill: "#a371f7",
      width: "16",
      height: "16",
      "aria-hidden": "true",
      children: /* @__PURE__ */ xe.jsx("path", { d: "M5 3.254V3.25v.005a.75.75 0 110-.005v.004zm.45 1.9a2.25 2.25 0 10-1.95.218v5.256a2.25 2.25 0 101.5 0V7.123A5.735 5.735 0 009.25 9h1.378a2.251 2.251 0 100-1.5H9.25a4.25 4.25 0 01-3.8-2.346zM12.75 9a.75.75 0 100-1.5.75.75 0 000 1.5zm-8.5 4.5a.75.75 0 100-1.5.75.75 0 000 1.5z" })
    }
  ),
  CLOSED: /* @__PURE__ */ xe.jsx(
    "svg",
    {
      className: r,
      fill: "#f85149",
      width: "16",
      height: "16",
      "aria-hidden": "true",
      children: /* @__PURE__ */ xe.jsx("path", { d: "M10.72 1.227a.75.75 0 011.06 0l.97.97.97-.97a.75.75 0 111.06 1.061l-.97.97.97.97a.75.75 0 01-1.06 1.06l-.97-.97-.97.97a.75.75 0 11-1.06-1.06l.97-.97-.97-.97a.75.75 0 010-1.06zM12.75 6.5a.75.75 0 00-.75.75v3.378a2.251 2.251 0 101.5 0V7.25a.75.75 0 00-.75-.75zm0 5.5a.75.75 0 100 1.5.75.75 0 000-1.5zM2.5 3.25a.75.75 0 111.5 0 .75.75 0 01-1.5 0zM3.25 1a2.25 2.25 0 00-.75 4.372v5.256a2.251 2.251 0 101.5 0V5.372A2.25 2.25 0 003.25 1zm0 11a.75.75 0 100 1.5.75.75 0 000-1.5z" })
    }
  )
}[n];
function NC({
  conversationId: e,
  githubOrganization: n
}) {
  const r = {
    github: { issues: [], pullRequests: [] }
  }, [i, a] = se(
    []
  ), [o, s] = se([]), [l, d] = se([]), [m, u] = se([]), [f, h] = se(), { showNotification: v, showModal: C, executeQuery: S } = mn(), { track: j } = bn(), {
    loading: F,
    data: y,
    error: q,
    store: T
  } = Em(e ?? null), E = y?.github?.issues || [], D = y?.github?.pullRequests || [], [B, ee] = se(!1), [J, ae] = se();
  He(
    () => h(q || J || void 0),
    [q, J]
  ), He(
    () => {
      !F && (E?.length || D?.length) ? (a(E), s(D), U(E, D)) : (a([]), s([]), d([]), u([]));
    },
    // Only trigger when data is loaded, not when the loading status changes.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [y]
  );
  const Q = async (ue, W) => {
    await T(ue).then(() => {
      v({
        icon: "check-circle-filled",
        severity: "success",
        title: W.success.title,
        text: W.success.text
      });
    }).catch((ke) => {
      v({
        title: W.error.title,
        text: `${W.error.text} ${ke.message && " (" + ke.message + ")"}`,
        icon: "exclamation-triangle-filled",
        severity: "warning"
      });
    });
  }, U = (ue, W) => {
    if (!ue?.length && !W?.length) {
      d([]), u([]);
      return;
    }
    const ke = (ue || []).map(
      (qe) => S(_C, {
        owner: qe.owner,
        repositoryName: qe.repository,
        issueNumber: qe.number
      })
    ), Ee = (W || []).map(
      (qe) => S(xC, {
        owner: qe.owner,
        repositoryName: qe.repository,
        prNumber: qe.number
      })
    ), K = [...ke, ...Ee];
    ee(!0), Promise.all(K).then((qe) => {
      const Be = [], Pe = [];
      qe.forEach((Me) => {
        const Fe = Me?.data?.GitHub;
        if (!Fe) {
          d([]), u([]);
          return;
        }
        Object.keys(Fe).forEach((Ae) => {
          if (Ae.startsWith("repository")) {
            const $e = Fe[Ae];
            Object.keys($e).forEach((tn) => {
              const Ie = $e[tn], We = {
                number: Ie?.number,
                owner: Ie?.repository?.owner?.login,
                repository: Ie?.repository?.name
              };
              tn.startsWith("issue") && Be.push({
                ...Ie,
                type: "ISSUE",
                key: We
              }), tn.startsWith("pullRequest") && Pe.push({
                ...Ie,
                type: "PR",
                key: We
              });
            });
          }
        });
      }), d(Be), u(Pe);
    }).catch(ae).finally(() => {
      ee(!1);
    });
  }, O = ({ key: ue, type: W }) => {
    j("github:link:issue:clicked", {
      githubOrganization: n
    });
    const ke = y && (E.length || D.length) ? y : r, Ee = W === "ISSUE" ? "issues" : "pullRequests";
    ke.github[Ee] = Array.from(
      new Set(ke.github[Ee]).add(ue)
    ), Q(ke, {
      success: {
        title: "GitHub issue linked",
        text: `You linked the GitHub issue ${ar(
          ue
        )} to this conversation.`
      },
      error: {
        title: "Linking failed",
        text: `Linking ${ar(ue)} failed. Please try again.`
      }
    });
  }, H = async ({ key: ue, type: W }) => {
    j("github:link:issue:clicked", {
      githubOrganization: n
    });
    const ke = y && (E.length || D.length) ? y : r, Ee = W === "ISSUE" ? "issues" : "pullRequests";
    ke.github[Ee] = Array.from(
      new Set(ke.github[Ee]).add(ue)
    ), await T(ke).catch((K) => {
      v({
        title: "Linking failed",
        text: `Linking ${ue} failed. Please try again. ${K.message && " (" + K.message + ")"}`,
        icon: "exclamation-triangle-filled",
        severity: "warning"
      });
    });
  }, Z = ({ key: ue, type: W }) => {
    j("github:unlink:issue:clicked", {
      githubOrganization: n
    });
    const ke = W === "ISSUE" ? "issue" : "pull request";
    C({
      headline: `Unlink ${ke} ${ar(ue)}?`,
      text: `You are about to unlink the ${ke} ${ar(
        ue
      )}. Do you want to proceed?`,
      confirmLabel: `Unlink GitHub ${ke}`,
      confirmVariant: "danger",
      cancelLabel: "Cancel",
      onConfirm: () => {
        const Ee = W === "ISSUE" ? "issues" : "pullRequests";
        if (!y)
          return;
        const K = {
          ...y,
          github: {
            ...y?.github,
            [Ee]: y?.github?.[Ee].filter(
              (qe) => qe.number !== ue.number || qe.owner !== ue.owner || qe.repository !== ue.repository
            )
          }
        };
        j("github:unlink:issue:confirmed", {
          githubOrganization: n
        }), Q(K, {
          success: {
            title: `GitHub ${ke} unlinked`,
            text: `You unlinked the GitHub ${ke} ${ar(
              ue
            )}`
          },
          error: {
            title: "Unlinking failed",
            text: `Unlinking ${ar(ue)} failed.`
          }
        });
      },
      onCancel: () => {
        j("github:unlink:issue:canceled", {
          githubOrganization: n
        });
      }
    });
  }, ye = () => {
    j("github:unlink:all:clicked", {
      githubOrganization: n
    }), C({
      headline: "Unlink all GitHub issues/pull requests?",
      text: "You are about to unlink the all GitHub issues/pull requests from the conversation. Do you want to proceed?",
      confirmLabel: "Unlink ALL issues/pull requests",
      confirmVariant: "danger",
      cancelLabel: "Cancel",
      onConfirm: () => {
        j("github:unlink:all:confirmed", {
          githubOrganization: n
        }), Q(r, {
          success: {
            title: "Unlinking successful",
            text: "All GitHub issues/pull requests were unlinked"
          },
          error: {
            title: "Unlinking failed",
            text: "Unlinking all issues/pull requests failed."
          }
        });
      },
      onCancel: () => {
        j("github:unlink:all:canceled", {
          githubOrganization: n
        });
      }
    });
  }, ce = E.filter(
    (ue) => !i?.includes(ue)
  ) || [], le = D.filter(
    (ue) => !o?.includes(ue)
  ) || [];
  return {
    linkGithubItem: O,
    linkGithubItemQuietly: H,
    unlinkGithubItem: Z,
    loadGithubItems: U,
    removeDanglingGithubItemLinks: () => {
      const ue = {
        ...y,
        github: {
          ...y?.github,
          issues: E.filter(
            (W) => !ce.includes(W)
          ) || [],
          pullRequests: D.filter(
            (W) => !le.includes(W)
          ) || []
        }
      };
      T(ue);
    },
    unlinkAllGithubItems: ye,
    isLoadingGithubItemLinks: F,
    danglingIssueLinks: ce,
    danglingPullRequestLinks: le,
    isLoadingGithubItems: B,
    issues: l,
    pullRequests: m,
    error: f
  };
}
const jC = "_contentWrapper_1vx3c_1", wC = "_contentWrapperHeadline_1vx3c_4", CC = "_contentWrapperBody_1vx3c_11", FC = "_contentWrapperAssigneeIcon_1vx3c_15", IC = "_contentWrapperStatusTag_1vx3c_20", Vr = {
  contentWrapper: jC,
  contentWrapperHeadline: wC,
  contentWrapperBody: CC,
  contentWrapperAssigneeIcon: FC,
  contentWrapperStatusTag: IC
}, $_ = ({
  description: e,
  assignees: n,
  labels: r
}) => /* @__PURE__ */ xe.jsxs(xe.Fragment, { children: [
  e && /* @__PURE__ */ xe.jsxs(Zn, { className: Vr.contentWrapper, children: [
    /* @__PURE__ */ xe.jsx(Zn, { className: Vr.contentWrapperHeadline, children: "Description" }),
    /* @__PURE__ */ xe.jsx(Zn, { className: Vr.contentWrapperBody, children: e })
  ] }),
  n?.nodes && n.nodes.length > 0 && /* @__PURE__ */ xe.jsxs(Zn, { className: Vr.contentWrapper, children: [
    /* @__PURE__ */ xe.jsx(Zn, { className: Vr.contentWrapperHeadline, children: "Assignees" }),
    /* @__PURE__ */ xe.jsx(Zn, { className: Vr.contentWrapperBody, children: n.nodes.map(
      (i) => i && /* @__PURE__ */ xe.jsxs(Zn, { margin: "100 0", children: [
        /* @__PURE__ */ xe.jsx(
          "img",
          {
            className: Vr.contentWrapperAssigneeIcon,
            src: i.avatarUrl,
            alt: i.name || ""
          }
        ),
        " ",
        i.name
      ] }, i.name)
    ) })
  ] }),
  r?.nodes && r?.nodes.length > 0 && /* @__PURE__ */ xe.jsx(Zn, { className: Vr.contentWrapper, children: r.nodes.map(
    (i) => i && /* @__PURE__ */ xe.jsx(
      An,
      {
        className: Vr.contentWrapperStatusTag,
        children: i.name
      },
      i.name
    )
  ) })
] }), EC = "_collapse_1bdjy_1", TC = "_collapseHeader_1bdjy_10", $C = "_collapseHeaderKey_1bdjy_31", DC = "_collapseHeaderKeyIcon_1bdjy_36", RC = "_collapseHeaderKeyLink_1bdjy_41", OC = "_collapseHeaderIcon_1bdjy_44", PC = "_collapseHeaderTitle_1bdjy_49", AC = "_collapseContent_1bdjy_57", LC = "_collapseContentButtonSpacer_1bdjy_60", VC = "_collapseContentButtonLink_1bdjy_63", jr = {
  collapse: EC,
  collapseHeader: TC,
  collapseHeaderKey: $C,
  collapseHeaderKeyIcon: DC,
  collapseHeaderKeyLink: RC,
  collapseHeaderIcon: OC,
  collapseHeaderTitle: PC,
  collapseContent: AC,
  collapseContentButtonSpacer: LC,
  collapseContentButtonLink: VC
}, zC = ({
  items: e,
  unlinkGithubItem: n,
  githubOrganization: r
}) => {
  const i = e.reduce(
    (d, m) => ({ ...d, [m.id]: !1 }),
    {}
  ), [a, o] = se(i), { track: s } = bn(), l = (d, m) => {
    o({ ...a, [d]: m });
  };
  return /* @__PURE__ */ xe.jsx(b, { flexDirection: "column", gap: "250", children: e?.length ? e.map((d) => {
    const {
      id: m,
      number: u,
      key: f,
      title: h,
      bodyText: v,
      repository: C,
      type: S,
      state: j,
      assignees: F,
      labels: y
    } = d, q = a[m];
    return /* @__PURE__ */ xe.jsxs(
      lr,
      {
        onToggle: () => l(m, !a[m]),
        isOpen: q,
        className: jr.collapse,
        children: [
          /* @__PURE__ */ xe.jsx(lr.Header, { className: jr.collapseHeader, children: /* @__PURE__ */ xe.jsxs(
            b,
            {
              flexDirection: "column",
              gap: "200",
              justifyContent: "space-between",
              children: [
                /* @__PURE__ */ xe.jsx(Zn, { children: /* @__PURE__ */ xe.jsxs(Zn, { as: "span", className: jr.collapseHeaderKey, children: [
                  tm(
                    S,
                    j,
                    jr.collapseHeaderKeyIcon
                  ),
                  /* @__PURE__ */ xe.jsxs(
                    "a",
                    {
                      href: nh(f),
                      className: jr.collapseHeaderKeyLink,
                      target: "_blank",
                      rel: "noreferrer",
                      onClick: (T) => {
                        T.stopPropagation();
                      },
                      children: [
                        ar(f),
                        /* @__PURE__ */ xe.jsx(
                          me,
                          {
                            className: jr.collapseHeaderIcon,
                            name: "external-link",
                            size: 16
                          }
                        )
                      ]
                    }
                  )
                ] }) }),
                /* @__PURE__ */ xe.jsx(Zn, { className: jr.collapseHeaderTitle, children: h })
              ]
            }
          ) }),
          /* @__PURE__ */ xe.jsx(lr.Content, { className: jr.collapseContent, children: /* @__PURE__ */ xe.jsxs(b, { flexDirection: "column", margin: "0 0 200 0", children: [
            /* @__PURE__ */ xe.jsx(
              $_,
              {
                description: v,
                assignees: F,
                labels: y
              }
            ),
            /* @__PURE__ */ xe.jsxs(
              Wn,
              {
                icon: "link-slash",
                variant: "secondary",
                className: jr.collapseContentButtonSpacer,
                onClick: () => n({
                  key: {
                    number: u,
                    owner: C?.owner.login,
                    repository: d.repository.name
                  },
                  type: S
                }),
                children: [
                  "Unlink ",
                  th(S)
                ]
              }
            ),
            /* @__PURE__ */ xe.jsxs(
              jt,
              {
                slotEnd: /* @__PURE__ */ xe.jsx(me, { name: "external-link" }),
                variant: "tertiary",
                className: jr.collapseContentButtonLink,
                navigate: () => {
                  s("github:view:link:clicked", {
                    githubOrganization: r
                  }), window.open(nh(f), "_blank")?.focus();
                },
                children: [
                  "View ",
                  th(S),
                  " in GitHub"
                ]
              }
            )
          ] }) })
        ]
      },
      m
    );
  }) : /* @__PURE__ */ xe.jsx(xe.Fragment, {}) });
}, UC = "_result_1uaom_1", MC = "_resultName_1uaom_21", BC = "_resultItemIcon_1uaom_29", qC = "_resultDescription_1uaom_34", HC = "_resultLinkIcon_1uaom_46", WC = "_tooltip_1uaom_55", KC = "_tooltipName_1uaom_61", GC = "_tooltipTag_1uaom_71", zr = {
  result: UC,
  resultName: MC,
  resultItemIcon: BC,
  resultDescription: qC,
  resultLinkIcon: HC,
  tooltip: WC,
  tooltipName: KC,
  tooltipTag: GC
}, YC = ({
  item: e,
  onSelect: n
}) => {
  const { key: r, title: i, type: a, state: o, labels: s, bodyText: l, assignees: d } = e, [m, u] = se(!1);
  return /* @__PURE__ */ xe.jsx(
    Ge,
    {
      className: zr.tooltip,
      content: /* @__PURE__ */ xe.jsxs(b, { flexDirection: "column", justifyContent: "center", width: "100%", children: [
        /* @__PURE__ */ xe.jsxs(
          b,
          {
            flexDirection: "row",
            justifyContent: "space-between",
            width: "100%",
            alignItems: "center",
            margin: "0 0 300 0",
            children: [
              /* @__PURE__ */ xe.jsxs(Zn, { as: "span", className: zr.tooltipName, children: [
                tm(a, o, zr.resultItemIcon),
                i
              ] }),
              /* @__PURE__ */ xe.jsx(An, { className: zr.tooltipTag, children: o })
            ]
          }
        ),
        /* @__PURE__ */ xe.jsx(
          $_,
          {
            description: l,
            assignees: d,
            labels: s
          }
        )
      ] }),
      side: "left",
      light: !0,
      children: /* @__PURE__ */ xe.jsxs(
        "button",
        {
          className: zr.result,
          type: "button",
          onClick: () => {
            n(e);
          },
          onMouseEnter: () => u(!0),
          onMouseLeave: () => u(!1),
          children: [
            /* @__PURE__ */ xe.jsxs(
              b,
              {
                flexDirection: "column",
                justifyContent: "center",
                width: "100%",
                style: {
                  width: m ? "calc(100% - 32px)" : "100%"
                },
                children: [
                  /* @__PURE__ */ xe.jsx(b, { flexDirection: "row", children: /* @__PURE__ */ xe.jsxs(Zn, { as: "span", className: zr.resultName, children: [
                    tm(a, o, zr.resultItemIcon),
                    ar(r)
                  ] }) }),
                  /* @__PURE__ */ xe.jsx(Zn, { className: zr.resultDescription, children: i })
                ]
              }
            ),
            m && /* @__PURE__ */ xe.jsx(
              me,
              {
                className: zr.resultLinkIcon,
                name: "plus",
                size: 32
              }
            )
          ]
        }
      )
    }
  );
}, QC = ({
  className: e,
  searched: n,
  githubOrganization: r
}) => /* @__PURE__ */ xe.jsx(
  jt,
  {
    slotEnd: /* @__PURE__ */ xe.jsx(me, { name: "external-link" }),
    variant: "tertiary",
    style: { width: "100%" },
    className: e,
    navigate: () => {
      window.open(
        `https://github.com/search?q=is:issue+org:${r}+${n}`,
        "_blank"
      )?.focus();
    },
    children: "View matching items on GitHub"
  }
), vs = "[a-zA-z0-9_.-]+", D_ = "[0-9]+", JC = new RegExp(
  `(${vs})/(${vs})/(?:issues|pull)/(${D_})`,
  "i"
), rh = new RegExp(`^${JC.source}$`), ih = new RegExp(
  `https://github.com/(${vs})/(${vs})/(?:issues|pull)/(${D_})`,
  "i"
), XC = ({
  onSelectItem: e,
  githubOrganization: n,
  linkedIssues: r,
  linkedPullRequests: i
}) => {
  const a = Bn(() => r?.map((D) => D.id) || [], [r]), o = Bn(() => i?.map((D) => D.id) || [], [i]), [s, l] = se([]), { useLazyQuery: d } = mn(), [m, u] = se(), [f, { loading: h, error: v, data: C, networkStatus: S }] = d(bC, {
    notifyOnNetworkStatusChange: !0
  });
  ki(
    () => {
      !h && m && S === Yt.ready ? f({
        variables: {
          issueQuery: `${m} type:issue`,
          prQuery: `${m} type:pr`,
          maxIssueResults: 12,
          maxPRResults: 12
        }
      }) : l([]);
    },
    500,
    [m]
  ), He(() => {
    let D = C?.GitHub?.issues?.nodes || [], B = C?.GitHub?.pullRequests.nodes || [];
    a.length > 0 && (D = D.filter((ee) => !a.includes(ee.id))), o.length > 0 && (B = B.filter(
      (ee) => !o.includes(ee.id)
    )), l([
      ...D.map((ee) => ({
        ...ee,
        type: "ISSUE",
        key: {
          number: ee.number,
          owner: ee.repository.owner.login,
          repository: ee.repository.name
        }
      })),
      ...B.map((ee) => ({
        ...ee,
        type: "PR",
        key: {
          number: ee.number,
          owner: ee.repository.owner.login,
          repository: ee.repository.name
        }
      }))
    ]);
  }, [C, a, o]);
  function j(D) {
    const B = D?.trim();
    if (rh.test(B)) {
      const [ee, J, ae, Q] = B.match(rh) || [];
      return J !== n ? void 0 : {
        owner: n,
        repository: ae,
        number: parseInt(Q)
      };
    }
    if (ih.test(B)) {
      const [ee, J, ae, Q] = B.match(ih) || [];
      return J !== n ? void 0 : {
        owner: n,
        repository: ae,
        number: parseInt(Q)
      };
    }
  }
  const F = (D) => {
    e({
      key: SC(D),
      type: D.type
    }), u(void 0);
  }, y = (D) => {
    const B = j(D);
    u(
      B ? `org:${B.owner} repo:${B.repository} ${B.number}` : `org:${n} ${D}`
    );
  }, q = () => {
    u(void 0);
  }, T = ({ className: D, searched: B }) => /* @__PURE__ */ xe.jsx(
    QC,
    {
      className: D,
      searched: B,
      githubOrganization: n
    }
  ), E = ({ item: D, onSelect: B }) => /* @__PURE__ */ xe.jsx(YC, { item: D, onSelect: B });
  return !h && v ? /* @__PURE__ */ xe.jsx(Fn, { error: v }) : /* @__PURE__ */ xe.jsx(
    Sr,
    {
      items: s?.map((D) => ({ name: D.title, ...D })),
      loading: h,
      onSearch: y,
      onSelect: F,
      onClear: q,
      emptyMessage: m ? h ? "" : "No GitHub items found" : "Enter GitHub item key, link or search terms",
      suggestionComponent: T,
      itemComponent: E,
      placeholder: "Search GitHub items",
      searchable: !0,
      clearable: !0
    }
  );
}, ZC = "_itemButton_3sxfy_1", e1 = "_result_3sxfy_6", n1 = "_resultName_3sxfy_30", t1 = "_resultCheckIcon_3sxfy_38", r1 = "_resultAssigneeIcon_3sxfy_41", ca = {
  itemButton: ZC,
  result: e1,
  resultName: n1,
  resultCheckIcon: t1,
  resultAssigneeIcon: r1
}, R_ = ({
  item: e,
  checked: n = !1,
  onSelectItem: r
}) => /* @__PURE__ */ xe.jsx(
  b,
  {
    flexDirection: "column",
    justifyContent: "center",
    width: "100%",
    "data-testid": "github-select-item-component",
    children: /* @__PURE__ */ xe.jsx(
      "button",
      {
        onClick: () => {
          r(e);
        },
        className: ca.itemButton,
        children: /* @__PURE__ */ xe.jsxs(b, { className: ca.result, flexDirection: "row", width: "100%", children: [
          e.iconUrl && /* @__PURE__ */ xe.jsx(Zn, { margin: "100 0", children: /* @__PURE__ */ xe.jsx(
            "img",
            {
              className: ca.resultAssigneeIcon,
              src: e.iconUrl,
              alt: e.name
            }
          ) }, e.name),
          /* @__PURE__ */ xe.jsx(Zn, { className: ca.resultName, children: e.name }),
          n && /* @__PURE__ */ xe.jsx(Zn, { className: ca.resultCheckIcon, children: /* @__PURE__ */ xe.jsx(me, { name: "done" }) })
        ] })
      }
    )
  }
), i1 = Gi(
  /* GraphQL */
  `
  query getGithubOrganizationMembersByName(
    $organizationQuery: String!
    $usersQuery: String!
    $maxResults: Int!
  ) {
    GitHub {
      organization(login: $organizationQuery) {
        teams(first: $maxResults) {
          edges {
            node {
              id
              name
              members(first: $maxResults, query: $usersQuery) {
                edges {
                  node {
                    id
                    name
                    login
                    avatarUrl
                  }
                }
              }
            }
          }
        }
      }
    }
  }
`
), a1 = ({
  githubOrganization: e,
  selectedItems: n,
  onChange: r,
  multiple: i = !1
}) => {
  const { useLazyQuery: a } = mn(), [o, s] = se([]), [l, d] = se(""), m = 2, [u, { loading: f, error: h, data: v, networkStatus: C }] = a(
    i1,
    {
      notifyOnNetworkStatusChange: !0
    }
  );
  return ki(
    () => {
      !f && l && l.length >= m && C === Yt.ready ? u({
        variables: {
          usersQuery: l,
          organizationQuery: e,
          maxResults: 10
        }
      }) : s([]);
    },
    500,
    [l]
  ), He(() => {
    const S = v?.GitHub?.organization?.teams || { edges: [] }, j = [];
    S?.edges?.forEach((F) => {
      const y = F?.node?.members?.edges;
      (y?.length || 0) > 0 && y?.forEach((q) => {
        const T = q?.node;
        T && (T?.id && j.find((E) => E.id === T.id) || j.push(T));
      });
    }), s(
      j.sort((F, y) => {
        const q = F.name?.toLowerCase() || F.login?.toLowerCase(), T = y.name?.toLowerCase() || y.login?.toLowerCase();
        return q.localeCompare(T, void 0, {
          sensitivity: "base"
        });
      })
    );
  }, [v]), !f && h ? /* @__PURE__ */ xe.jsx(Fn, { error: h }) : /* @__PURE__ */ xe.jsx(
    Sr,
    {
      clearable: !0,
      searchable: !0,
      multiple: i,
      items: o?.map(({ id: S, name: j, login: F, avatarUrl: y }) => ({
        id: S,
        name: j || F,
        iconUrl: y
      })) || [],
      loading: f,
      onSearch: (S) => d(S),
      onChange: (S, j) => {
        const F = S.id;
        i ? (j && !n.find(
          (y) => y.id === F
        ) && n.push(S), j || (n = n.filter(
          (y) => y.id !== F
        ))) : n = j ? [S] : [], r(n);
      },
      onClear: () => d(""),
      selectedItems: n,
      emptyMessage: l ? f ? "" : "No user found" : "Search users",
      itemComponent: ({ item: S, onSelect: j, checked: F }) => /* @__PURE__ */ xe.jsx(
        R_,
        {
          item: S,
          checked: F,
          onSelectItem: j
        }
      ),
      placeholder: "Search GitHub users"
    }
  );
}, o1 = ({
  field: e,
  value: n,
  onChange: r,
  githubOrganization: i
}) => {
  const { multiple: a, type: o } = e;
  switch (o) {
    case "any":
      return /* @__PURE__ */ xe.jsx(_r, { onChange: r, value: n });
    case "array":
      return e?.allowedValues ? /* @__PURE__ */ xe.jsx(
        Sr,
        {
          onSelect: r,
          selectedItems: Array.isArray(n) ? n : [],
          items: e?.allowedValues.map(({ id: s, name: l, value: d }) => ({
            id: s,
            name: l || d
          }))
        }
      ) : /* @__PURE__ */ xe.jsx(
        Ds,
        {
          onChange: r,
          selectedTags: Array.isArray(n) ? n : []
        }
      );
    case "number":
      return /* @__PURE__ */ xe.jsx(_r, { type: "number", onChange: r, value: n });
    case "option":
      return /* @__PURE__ */ xe.jsx(
        Sr,
        {
          onSelect: r,
          selectedItems: Array.isArray(n) ? n : [],
          items: e?.allowedValues?.map(
            ({ id: s, name: l, value: d }) => ({
              id: s,
              name: l || d
            })
          ) || []
        }
      );
    case "string":
      return /* @__PURE__ */ xe.jsx(_r, { onChange: r, value: n || "" });
    case "textarea":
      return /* @__PURE__ */ xe.jsx(Ku, { onChange: r, value: n || "" });
    case "user":
      return /* @__PURE__ */ xe.jsx(
        a1,
        {
          githubOrganization: i,
          onChange: r,
          selectedItems: Array.isArray(n) ? n : [],
          multiple: a
        }
      );
    default:
      return /* @__PURE__ */ xe.jsx(xe.Fragment, { children: "Your organizations GitHub configuration is currently not fully supported by Dixa. Please reach out so we can have a look at this field." });
  }
}, s1 = ({
  issueTypeFields: e,
  control: n,
  githubOrganization: r,
  conversationContext: i,
  errors: a
}) => /* @__PURE__ */ xe.jsx(xe.Fragment, { children: e.filter(({ key: o }) => o !== "repository").map((o) => /* @__PURE__ */ xe.jsx(
  zt,
  {
    control: n,
    render: ({ field: { onChange: s, value: l } }) => /* @__PURE__ */ xe.jsx(
      En,
      {
        meta: {
          error: a && o.key in a ? a[o.key].message : null
        },
        label: o.name,
        required: o.required,
        children: o1({
          field: o,
          value: l,
          onChange: s,
          githubOrganization: r
        })
      },
      o.key
    ),
    name: o.key,
    rules: {
      required: o.required ? "This field is required" : !1
    }
  },
  o.key
)) }), l1 = ({
  createdIssue: e,
  issueBaseLink: n,
  issueLinkCopied: r,
  setIssueLinkCopied: i,
  copyToClipboard: a
}) => {
  const o = `${n}/${e.repository.name}/issues/${e.number}`;
  return /* @__PURE__ */ xe.jsxs(
    b,
    {
      flexDirection: "column",
      gap: "400",
      "data-testid": "github-create-issue-success-message",
      children: [
        /* @__PURE__ */ xe.jsxs(A.Paragraph, { children: [
          "You can visit your new issue by following",
          " ",
          /* @__PURE__ */ xe.jsxs(A.ExternalLink, { href: o, target: "_blank", children: [
            "this link ",
            /* @__PURE__ */ xe.jsx(me, { name: "external-link" })
          ] }),
          " ",
          "or copy it from the field below."
        ] }),
        /* @__PURE__ */ xe.jsx(En, { label: "GitHub issue link", children: /* @__PURE__ */ xe.jsx(
          _r,
          {
            readOnly: !0,
            value: o,
            suffix: {
              type: "button",
              button: {
                icon: r ? "done" : "copy",
                onClick: () => {
                  i(!0), a(o);
                }
              }
            }
          }
        ) })
      ]
    }
  );
}, c1 = "_modalBody_1hk1o_1", d1 = "_modalBodyFormFields_1hk1o_4", vl = {
  modalBody: c1,
  modalBodyFormFields: d1
}, u1 = Gi(
  /* GraphQL */
  `
  query getGithubRepositoriesByName($query: String!, $maxResults: Int!) {
    GitHub {
      search(query: $query, type: REPOSITORY, first: $maxResults) {
        repositoryCount
        edges {
          node {
            ... on GitHub_Repository {
              id
              name
            }
          }
        }
      }
    }
  }
`
), m1 = Gi(
  /* GraphQL */
  `
  mutation createGithubIssue($input: GitHub_CreateIssueInput!) {
    GitHub {
      createIssue(input: $input) {
        issue {
          id
          number
          repository {
            name
          }
        }
      }
    }
  }
`
), p1 = [
  {
    key: "title",
    name: "Title",
    type: "string",
    required: !0
  },
  {
    key: "assignees",
    name: "Assignees",
    type: "user",
    required: !1,
    multiple: !0
  },
  {
    key: "body",
    name: "Description",
    type: "textarea",
    required: !1
  }
], f1 = ({
  isOpen: e,
  onClose: n,
  linkGithubIssueQuietly: r,
  conversationContext: i,
  githubOrganization: a
}) => {
  const { showNotification: o, useLazyQuery: s, useMutation: l } = mn(), { track: d } = bn(), {
    control: m,
    handleSubmit: u,
    formState: { errors: f },
    reset: h,
    getValues: v
  } = Bt(), [C, S] = se(""), [j, F] = se([]), [y, q] = se(), [T, E] = se(!1), [D, B] = se(!1), [ee, J] = v_(), [
    ae,
    {
      loading: Q,
      error: U,
      networkStatus: O
    }
  ] = s(u1, {
    fetchPolicy: "no-cache",
    notifyOnNetworkStatusChange: !0,
    onCompleted: (Ee) => {
      F(
        Ee.GitHub.search?.edges?.map((K) => K?.node)
      );
    },
    onError: () => {
      o({
        title: "Could not get repository list",
        text: "We could not fetch the list of your repositories. Please try again later.",
        icon: "exclamation-triangle-filled",
        severity: "warning"
      }), F([]);
    }
  });
  ki(
    () => {
      !Q && C && O === Yt.ready ? ae({
        variables: {
          query: C,
          maxResults: 10
        }
      }) : F([]);
    },
    500,
    [C]
  );
  const [H, { error: Z }] = l(
    m1,
    {
      onError: (Ee) => {
        E(!1), o({
          title: "Creation was not successful",
          text: "Please try again later or contact your admin.",
          icon: "exclamation-triangle-filled",
          severity: "warning"
        }), console.warn("Error in createMutation", Ee);
      },
      onCompleted: (Ee) => {
        E(!1);
        const K = Ee.GitHub.createIssue?.issue;
        q(K), o({
          title: "Success",
          text: `GitHub issue '${K.number}' created`,
          icon: "check-circle-filled",
          severity: "success"
        }), r({
          owner: a,
          repository: K.repository.name,
          number: K.number
        });
      }
    }
  ), ye = (Ee) => {
    S(`org:${a} ${Ee}`);
  }, ce = (Ee, K) => {
    K(Ee), S("");
  }, le = () => {
    S("");
  }, ue = (Ee) => {
    d("github:create:issue:confirmed", {
      githubOrganization: a
    }), E(!0), H({
      variables: {
        input: {
          repositoryId: Ee.repository.id,
          title: Ee.title,
          body: Ee.body,
          assigneeIds: Ee.assignees?.length > 0 ? Ee.assignees.map((K) => K.id) : void 0
        }
      }
    });
  };
  He(() => {
    const Ee = D ? window.setTimeout(() => B(!1), 2e3) : void 0;
    return () => window.clearTimeout(Ee);
  }, [D]);
  const W = () => {
    S(""), F([]), q(void 0), E(!1), B(!1);
  }, ke = () => {
    d("github:create:issue:canceled", {
      githubOrganization: a
    }), W(), h(), n();
  };
  return /* @__PURE__ */ xe.jsxs(
    wt,
    {
      isOpen: e,
      "data-testid": "github-create-issue-modal",
      onClose: ke,
      children: [
        /* @__PURE__ */ xe.jsx(
          Ct,
          {
            title: y ? "Issue creation successful" : "Create new GitHub issue",
            onClose: ke
          }
        ),
        /* @__PURE__ */ xe.jsxs(Ft, { className: vl.modalBody, children: [
          !Q && U && /* @__PURE__ */ xe.jsx(Fn, { error: U }),
          !T && Z && /* @__PURE__ */ xe.jsx(Fn, { error: Z }),
          y ? /* @__PURE__ */ xe.jsx(
            l1,
            {
              createdIssue: y,
              issueBaseLink: `https://github.com/${a}`,
              issueLinkCopied: D,
              setIssueLinkCopied: B,
              copyToClipboard: J
            }
          ) : /* @__PURE__ */ xe.jsx(
            "form",
            {
              "data-testid": "github-create-issue-form",
              onSubmit: u(ue),
              children: /* @__PURE__ */ xe.jsxs(vt, { children: [
                /* @__PURE__ */ xe.jsx(ze, { children: /* @__PURE__ */ xe.jsx(En, { label: "Repository", required: !0, children: /* @__PURE__ */ xe.jsx(
                  zt,
                  {
                    control: m,
                    name: "repository",
                    rules: { required: "Please select a repository" },
                    render: ({ field: { onChange: Ee, value: K } }) => /* @__PURE__ */ xe.jsx(
                      Sr,
                      {
                        className: vl.modalBodyRepository,
                        searchable: !0,
                        clearable: !0,
                        loading: Q,
                        onSearch: ye,
                        onSelect: (qe) => ce(qe, Ee),
                        onClear: le,
                        selectedItems: [K],
                        placeholder: "Search GitHub repositories",
                        emptyMessage: U ? "No repositories found" : "No repositories available",
                        items: j || [],
                        itemComponent: ({ item: qe, onSelect: Be, checked: Pe }) => /* @__PURE__ */ xe.jsx(
                          R_,
                          {
                            item: qe,
                            checked: Pe,
                            onSelectItem: Be
                          }
                        )
                      }
                    )
                  }
                ) }) }),
                /* @__PURE__ */ xe.jsx(ze, { className: vl.modalBodyFormFields, children: /* @__PURE__ */ xe.jsx(
                  s1,
                  {
                    control: m,
                    errors: f,
                    getValues: v,
                    githubOrganization: a,
                    conversationContext: i,
                    issueTypeFields: p1
                  }
                ) })
              ] })
            }
          )
        ] }),
        /* @__PURE__ */ xe.jsx(
          Tt,
          {
            confirmOnClick: y ? ke : u(ue),
            confirmProps: {
              isLoading: T,
              loadingIndicator: /* @__PURE__ */ xe.jsx(cn, { size: 16 })
            },
            confirmName: y ? "Close" : "Save",
            cancelOnClick: y ? void 0 : ke
          }
        )
      ]
    }
  );
}, h1 = "_wrapper_19v8w_1", y1 = "_inputWrapper_19v8w_6", g1 = "_buttonLink_19v8w_19", v1 = "_noItemsFound_19v8w_23", k1 = "_createIssueButton_19v8w_28", wi = {
  wrapper: h1,
  inputWrapper: y1,
  buttonLink: g1,
  noItemsFound: v1,
  createIssueButton: k1
}, b1 = ({
  conversationContext: e,
  settings: n
}) => {
  const [r, i] = se(!1), { track: a } = bn(), o = n?.githubOrganization, s = !!n?.enableRemoveAllLinks, {
    linkGithubItem: l,
    linkGithubItemQuietly: d,
    unlinkGithubItem: m,
    loadGithubItems: u,
    removeDanglingGithubItemLinks: f,
    unlinkAllGithubItems: h,
    isLoadingGithubItemLinks: v,
    danglingIssueLinks: C,
    danglingPullRequestLinks: S,
    isLoadingGithubItems: j,
    issues: F,
    pullRequests: y,
    error: q
  } = NC({
    conversationId: e?.conversationId || null,
    githubOrganization: o
  }), T = (J) => d({ key: J, type: "ISSUE" }), E = !(!!F?.length).valueOf() && !(!!y?.length).valueOf() && !(!!C?.length).valueOf() && !(!!S?.length).valueOf(), D = !v && !j && !!C?.length && !!S?.length && !!n?.showDanglingLinks, B = n?.enableCreateIssue, ee = !!F?.length || !!y?.length;
  return !j && q ? /* @__PURE__ */ xe.jsx(Fn, { error: q, retry: () => u() }) : /* @__PURE__ */ xe.jsxs(xe.Fragment, { children: [
    /* @__PURE__ */ xe.jsxs(b, { className: wi.wrapper, flexDirection: "column", children: [
      /* @__PURE__ */ xe.jsxs(b, { className: wi.inputWrapper, flexDirection: "column", children: [
        B && /* @__PURE__ */ xe.jsxs(xe.Fragment, { children: [
          /* @__PURE__ */ xe.jsx(
            Wn,
            {
              variant: "primary",
              onClick: () => {
                a("github:create:issue:clicked", {
                  githubOrganization: n?.githubOrganization
                }), i(!0);
              },
              className: wi.createIssueButton,
              children: "Create new issue"
            }
          ),
          /* @__PURE__ */ xe.jsx("div", { className: wi.inputSeparator, children: "or" })
        ] }),
        /* @__PURE__ */ xe.jsx(
          XC,
          {
            onSelectItem: l,
            githubOrganization: o,
            linkedIssues: F,
            linkedPullRequests: y
          }
        )
      ] }),
      j ? /* @__PURE__ */ xe.jsx(b, { justifyContent: "center", children: /* @__PURE__ */ xe.jsx(cn, { "data-testid": "github-widget-item-spinner" }) }) : ee ? /* @__PURE__ */ xe.jsx(
        zC,
        {
          items: [...F, ...y],
          unlinkGithubItem: m,
          githubOrganization: o
        }
      ) : /* @__PURE__ */ xe.jsx(A.Paragraph, { align: "center", className: wi.noItemsFound, children: "No linked items found." }),
      D && /* @__PURE__ */ xe.jsxs(
        b,
        {
          background: "neutral.100",
          padding: "300",
          borderRadius: "100",
          flexDirection: "column",
          gap: "200",
          children: [
            /* @__PURE__ */ xe.jsx(A.Heading, { variant: "heading-3", children: "Unresolved linked issues and/or pull requests" }),
            /* @__PURE__ */ xe.jsxs(b, { flexDirection: "row", flexWrap: "wrap", gap: "100", children: [
              C.map((J) => /* @__PURE__ */ xe.jsx(
                An,
                {
                  onDelete: () => m({
                    key: J,
                    type: "ISSUE"
                  }),
                  children: ar(J)
                },
                ar(J)
              )),
              S.map((J) => /* @__PURE__ */ xe.jsx(
                An,
                {
                  onDelete: () => m({ key: J, type: "PR" }),
                  children: ar(J)
                },
                ar(J)
              ))
            ] }),
            /* @__PURE__ */ xe.jsx(
              Wn,
              {
                variant: "secondary",
                onClick: () => f(),
                icon: "link-slash",
                children: "Remove all"
              }
            )
          ]
        }
      ),
      s && ee && /* @__PURE__ */ xe.jsx(
        Wn,
        {
          variant: "secondary",
          disabled: E,
          onClick: h,
          children: "Remove all links"
        }
      ),
      /* @__PURE__ */ xe.jsx(
        jt,
        {
          slotEnd: /* @__PURE__ */ xe.jsx(me, { name: "external-link" }),
          variant: "tertiary",
          className: wi.buttonLink,
          navigate: () => {
            window.open(`https://github.com/${o}`, "_blank")?.focus();
          },
          children: "Open GitHub"
        }
      )
    ] }),
    /* @__PURE__ */ xe.jsx(
      f1,
      {
        isOpen: r,
        onClose: () => i(!1),
        linkGithubIssueQuietly: T,
        conversationContext: e,
        githubOrganization: o
      }
    )
  ] });
}, _1 = [
  {
    key: "githubOrganization",
    label: "GitHub organization or user",
    placeholder: "Insert your GitHub organization or user name, e.g. dixahq",
    secret: !1,
    type: "input",
    required: !0
  },
  {
    key: "enableRemoveAllLinks",
    label: 'Enable the "Remove all links" button',
    secret: !1,
    type: "switch",
    defaultValue: !1
  },
  {
    key: "showDanglingLinks",
    label: "Show unresolved links to GitHub items",
    secret: !1,
    type: "switch",
    defaultValue: !1
  },
  {
    key: "enableCreateIssue",
    label: 'Enable the "Create issue" button',
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "authorizeWithOauth",
    label: "Authorize with OAuth",
    secret: !1,
    type: "custom",
    hideOnCreate: !0,
    component: vi
  }
];
var No = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function O_(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var kl = { exports: {} }, da = {}, ah;
function x1() {
  if (ah) return da;
  ah = 1;
  var e = je, n = Symbol.for("react.element"), r = Symbol.for("react.fragment"), i = Object.prototype.hasOwnProperty, a = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, o = { key: !0, ref: !0, __self: !0, __source: !0 };
  function s(l, d, m) {
    var u, f = {}, h = null, v = null;
    m !== void 0 && (h = "" + m), d.key !== void 0 && (h = "" + d.key), d.ref !== void 0 && (v = d.ref);
    for (u in d) i.call(d, u) && !o.hasOwnProperty(u) && (f[u] = d[u]);
    if (l && l.defaultProps) for (u in d = l.defaultProps, d) f[u] === void 0 && (f[u] = d[u]);
    return { $$typeof: n, type: l, key: h, ref: v, props: f, _owner: a.current };
  }
  return da.Fragment = r, da.jsx = s, da.jsxs = s, da;
}
var jo = {}, oh;
function S1() {
  return oh || (oh = 1, process.env.NODE_ENV !== "production" && (function() {
    var e = je, n = Symbol.for("react.element"), r = Symbol.for("react.portal"), i = Symbol.for("react.fragment"), a = Symbol.for("react.strict_mode"), o = Symbol.for("react.profiler"), s = Symbol.for("react.provider"), l = Symbol.for("react.context"), d = Symbol.for("react.forward_ref"), m = Symbol.for("react.suspense"), u = Symbol.for("react.suspense_list"), f = Symbol.for("react.memo"), h = Symbol.for("react.lazy"), v = Symbol.for("react.offscreen"), C = Symbol.iterator, S = "@@iterator";
    function j(t) {
      if (t === null || typeof t != "object")
        return null;
      var c = C && t[C] || t[S];
      return typeof c == "function" ? c : null;
    }
    var F = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function y(t) {
      {
        for (var c = arguments.length, p = new Array(c > 1 ? c - 1 : 0), g = 1; g < c; g++)
          p[g - 1] = arguments[g];
        q("error", t, p);
      }
    }
    function q(t, c, p) {
      {
        var g = F.ReactDebugCurrentFrame, P = g.getStackAddendum();
        P !== "" && (c += "%s", p = p.concat([P]));
        var L = p.map(function(I) {
          return String(I);
        });
        L.unshift("Warning: " + c), Function.prototype.apply.call(console[t], console, L);
      }
    }
    var T = !1, E = !1, D = !1, B = !1, ee = !1, J;
    J = Symbol.for("react.module.reference");
    function ae(t) {
      return !!(typeof t == "string" || typeof t == "function" || t === i || t === o || ee || t === a || t === m || t === u || B || t === v || T || E || D || typeof t == "object" && t !== null && (t.$$typeof === h || t.$$typeof === f || t.$$typeof === s || t.$$typeof === l || t.$$typeof === d || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      t.$$typeof === J || t.getModuleId !== void 0));
    }
    function Q(t, c, p) {
      var g = t.displayName;
      if (g)
        return g;
      var P = c.displayName || c.name || "";
      return P !== "" ? p + "(" + P + ")" : p;
    }
    function U(t) {
      return t.displayName || "Context";
    }
    function O(t) {
      if (t == null)
        return null;
      if (typeof t.tag == "number" && y("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof t == "function")
        return t.displayName || t.name || null;
      if (typeof t == "string")
        return t;
      switch (t) {
        case i:
          return "Fragment";
        case r:
          return "Portal";
        case o:
          return "Profiler";
        case a:
          return "StrictMode";
        case m:
          return "Suspense";
        case u:
          return "SuspenseList";
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case l:
            var c = t;
            return U(c) + ".Consumer";
          case s:
            var p = t;
            return U(p._context) + ".Provider";
          case d:
            return Q(t, t.render, "ForwardRef");
          case f:
            var g = t.displayName || null;
            return g !== null ? g : O(t.type) || "Memo";
          case h: {
            var P = t, L = P._payload, I = P._init;
            try {
              return O(I(L));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var H = Object.assign, Z = 0, ye, ce, le, ue, W, ke, Ee;
    function K() {
    }
    K.__reactDisabledLog = !0;
    function qe() {
      {
        if (Z === 0) {
          ye = console.log, ce = console.info, le = console.warn, ue = console.error, W = console.group, ke = console.groupCollapsed, Ee = console.groupEnd;
          var t = {
            configurable: !0,
            enumerable: !0,
            value: K,
            writable: !0
          };
          Object.defineProperties(console, {
            info: t,
            log: t,
            warn: t,
            error: t,
            group: t,
            groupCollapsed: t,
            groupEnd: t
          });
        }
        Z++;
      }
    }
    function Be() {
      {
        if (Z--, Z === 0) {
          var t = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: H({}, t, {
              value: ye
            }),
            info: H({}, t, {
              value: ce
            }),
            warn: H({}, t, {
              value: le
            }),
            error: H({}, t, {
              value: ue
            }),
            group: H({}, t, {
              value: W
            }),
            groupCollapsed: H({}, t, {
              value: ke
            }),
            groupEnd: H({}, t, {
              value: Ee
            })
          });
        }
        Z < 0 && y("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var Pe = F.ReactCurrentDispatcher, Me;
    function Fe(t, c, p) {
      {
        if (Me === void 0)
          try {
            throw Error();
          } catch (P) {
            var g = P.stack.trim().match(/\n( *(at )?)/);
            Me = g && g[1] || "";
          }
        return `
` + Me + t;
      }
    }
    var Ae = !1, $e;
    {
      var tn = typeof WeakMap == "function" ? WeakMap : Map;
      $e = new tn();
    }
    function Ie(t, c) {
      if (!t || Ae)
        return "";
      {
        var p = $e.get(t);
        if (p !== void 0)
          return p;
      }
      var g;
      Ae = !0;
      var P = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var L;
      L = Pe.current, Pe.current = null, qe();
      try {
        if (c) {
          var I = function() {
            throw Error();
          };
          if (Object.defineProperty(I.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(I, []);
            } catch (ne) {
              g = ne;
            }
            Reflect.construct(t, [], I);
          } else {
            try {
              I.call();
            } catch (ne) {
              g = ne;
            }
            t.call(I.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (ne) {
            g = ne;
          }
          t();
        }
      } catch (ne) {
        if (ne && g && typeof ne.stack == "string") {
          for (var N = ne.stack.split(`
`), te = g.stack.split(`
`), x = N.length - 1, V = te.length - 1; x >= 1 && V >= 0 && N[x] !== te[V]; )
            V--;
          for (; x >= 1 && V >= 0; x--, V--)
            if (N[x] !== te[V]) {
              if (x !== 1 || V !== 1)
                do
                  if (x--, V--, V < 0 || N[x] !== te[V]) {
                    var X = `
` + N[x].replace(" at new ", " at ");
                    return t.displayName && X.includes("<anonymous>") && (X = X.replace("<anonymous>", t.displayName)), typeof t == "function" && $e.set(t, X), X;
                  }
                while (x >= 1 && V >= 0);
              break;
            }
        }
      } finally {
        Ae = !1, Pe.current = L, Be(), Error.prepareStackTrace = P;
      }
      var we = t ? t.displayName || t.name : "", Se = we ? Fe(we) : "";
      return typeof t == "function" && $e.set(t, Se), Se;
    }
    function We(t, c, p) {
      return Ie(t, !1);
    }
    function Ze(t) {
      var c = t.prototype;
      return !!(c && c.isReactComponent);
    }
    function de(t, c, p) {
      if (t == null)
        return "";
      if (typeof t == "function")
        return Ie(t, Ze(t));
      if (typeof t == "string")
        return Fe(t);
      switch (t) {
        case m:
          return Fe("Suspense");
        case u:
          return Fe("SuspenseList");
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case d:
            return We(t.render);
          case f:
            return de(t.type, c, p);
          case h: {
            var g = t, P = g._payload, L = g._init;
            try {
              return de(L(P), c, p);
            } catch {
            }
          }
        }
      return "";
    }
    var fe = Object.prototype.hasOwnProperty, Te = {}, Le = F.ReactDebugCurrentFrame;
    function Re(t) {
      if (t) {
        var c = t._owner, p = de(t.type, t._source, c ? c.type : null);
        Le.setExtraStackFrame(p);
      } else
        Le.setExtraStackFrame(null);
    }
    function sn(t, c, p, g, P) {
      {
        var L = Function.call.bind(fe);
        for (var I in t)
          if (L(t, I)) {
            var N = void 0;
            try {
              if (typeof t[I] != "function") {
                var te = Error((g || "React class") + ": " + p + " type `" + I + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof t[I] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw te.name = "Invariant Violation", te;
              }
              N = t[I](c, I, g, p, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (x) {
              N = x;
            }
            N && !(N instanceof Error) && (Re(P), y("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", g || "React class", p, I, typeof N), Re(null)), N instanceof Error && !(N.message in Te) && (Te[N.message] = !0, Re(P), y("Failed %s type: %s", p, N.message), Re(null));
          }
      }
    }
    var w = Array.isArray;
    function _(t) {
      return w(t);
    }
    function $(t) {
      {
        var c = typeof Symbol == "function" && Symbol.toStringTag, p = c && t[Symbol.toStringTag] || t.constructor.name || "Object";
        return p;
      }
    }
    function G(t) {
      try {
        return Y(t), !1;
      } catch {
        return !0;
      }
    }
    function Y(t) {
      return "" + t;
    }
    function R(t) {
      if (G(t))
        return y("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", $(t)), Y(t);
    }
    var z = F.ReactCurrentOwner, ie = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, pe, _e;
    function en(t) {
      if (fe.call(t, "ref")) {
        var c = Object.getOwnPropertyDescriptor(t, "ref").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.ref !== void 0;
    }
    function un(t) {
      if (fe.call(t, "key")) {
        var c = Object.getOwnPropertyDescriptor(t, "key").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.key !== void 0;
    }
    function rn(t, c) {
      typeof t.ref == "string" && z.current;
    }
    function dn(t, c) {
      {
        var p = function() {
          pe || (pe = !0, y("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "key", {
          get: p,
          configurable: !0
        });
      }
    }
    function pn(t, c) {
      {
        var p = function() {
          _e || (_e = !0, y("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "ref", {
          get: p,
          configurable: !0
        });
      }
    }
    var ln = function(t, c, p, g, P, L, I) {
      var N = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: n,
        // Built-in properties that belong on the element
        type: t,
        key: c,
        ref: p,
        props: I,
        // Record the component responsible for creating this element.
        _owner: L
      };
      return N._store = {}, Object.defineProperty(N._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(N, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: g
      }), Object.defineProperty(N, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: P
      }), Object.freeze && (Object.freeze(N.props), Object.freeze(N)), N;
    };
    function kn(t, c, p, g, P) {
      {
        var L, I = {}, N = null, te = null;
        p !== void 0 && (R(p), N = "" + p), un(c) && (R(c.key), N = "" + c.key), en(c) && (te = c.ref, rn(c));
        for (L in c)
          fe.call(c, L) && !ie.hasOwnProperty(L) && (I[L] = c[L]);
        if (t && t.defaultProps) {
          var x = t.defaultProps;
          for (L in x)
            I[L] === void 0 && (I[L] = x[L]);
        }
        if (N || te) {
          var V = typeof t == "function" ? t.displayName || t.name || "Unknown" : t;
          N && dn(I, V), te && pn(I, V);
        }
        return ln(t, N, te, P, g, z.current, I);
      }
    }
    var Xe = F.ReactCurrentOwner, Sn = F.ReactDebugCurrentFrame;
    function Oe(t) {
      if (t) {
        var c = t._owner, p = de(t.type, t._source, c ? c.type : null);
        Sn.setExtraStackFrame(p);
      } else
        Sn.setExtraStackFrame(null);
    }
    var an;
    an = !1;
    function on(t) {
      return typeof t == "object" && t !== null && t.$$typeof === n;
    }
    function yn() {
      {
        if (Xe.current) {
          var t = O(Xe.current.type);
          if (t)
            return `

Check the render method of \`` + t + "`.";
        }
        return "";
      }
    }
    function qn(t) {
      return "";
    }
    var Nn = {};
    function gn(t) {
      {
        var c = yn();
        if (!c) {
          var p = typeof t == "string" ? t : t.displayName || t.name;
          p && (c = `

Check the top-level render call using <` + p + ">.");
        }
        return c;
      }
    }
    function hn(t, c) {
      {
        if (!t._store || t._store.validated || t.key != null)
          return;
        t._store.validated = !0;
        var p = gn(c);
        if (Nn[p])
          return;
        Nn[p] = !0;
        var g = "";
        t && t._owner && t._owner !== Xe.current && (g = " It was passed a child from " + O(t._owner.type) + "."), Oe(t), y('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', p, g), Oe(null);
      }
    }
    function jn(t, c) {
      {
        if (typeof t != "object")
          return;
        if (_(t))
          for (var p = 0; p < t.length; p++) {
            var g = t[p];
            on(g) && hn(g, c);
          }
        else if (on(t))
          t._store && (t._store.validated = !0);
        else if (t) {
          var P = j(t);
          if (typeof P == "function" && P !== t.entries)
            for (var L = P.call(t), I; !(I = L.next()).done; )
              on(I.value) && hn(I.value, c);
        }
      }
    }
    function Un(t) {
      {
        var c = t.type;
        if (c == null || typeof c == "string")
          return;
        var p;
        if (typeof c == "function")
          p = c.propTypes;
        else if (typeof c == "object" && (c.$$typeof === d || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        c.$$typeof === f))
          p = c.propTypes;
        else
          return;
        if (p) {
          var g = O(c);
          sn(p, t.props, "prop", g, t);
        } else if (c.PropTypes !== void 0 && !an) {
          an = !0;
          var P = O(c);
          y("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", P || "Unknown");
        }
        typeof c.getDefaultProps == "function" && !c.getDefaultProps.isReactClassApproved && y("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function Vn(t) {
      {
        for (var c = Object.keys(t.props), p = 0; p < c.length; p++) {
          var g = c[p];
          if (g !== "children" && g !== "key") {
            Oe(t), y("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", g), Oe(null);
            break;
          }
        }
        t.ref !== null && (Oe(t), y("Invalid attribute `ref` supplied to `React.Fragment`."), Oe(null));
      }
    }
    var _n = {};
    function xn(t, c, p, g, P, L) {
      {
        var I = ae(t);
        if (!I) {
          var N = "";
          (t === void 0 || typeof t == "object" && t !== null && Object.keys(t).length === 0) && (N += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var te = qn();
          te ? N += te : N += yn();
          var x;
          t === null ? x = "null" : _(t) ? x = "array" : t !== void 0 && t.$$typeof === n ? (x = "<" + (O(t.type) || "Unknown") + " />", N = " Did you accidentally export a JSX literal instead of a component?") : x = typeof t, y("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", x, N);
        }
        var V = kn(t, c, p, P, L);
        if (V == null)
          return V;
        if (I) {
          var X = c.children;
          if (X !== void 0)
            if (g)
              if (_(X)) {
                for (var we = 0; we < X.length; we++)
                  jn(X[we], t);
                Object.freeze && Object.freeze(X);
              } else
                y("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              jn(X, t);
        }
        if (fe.call(c, "key")) {
          var Se = O(t), ne = Object.keys(c).filter(function(wn) {
            return wn !== "key";
          }), nn = ne.length > 0 ? "{key: someKey, " + ne.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!_n[Se + nn]) {
            var Tn = ne.length > 0 ? "{" + ne.join(": ..., ") + ": ...}" : "{}";
            y(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, nn, Se, Tn, Se), _n[Se + nn] = !0;
          }
        }
        return t === i ? Vn(V) : Un(V), V;
      }
    }
    function Hn(t, c, p) {
      return xn(t, c, p, !0);
    }
    function Dn(t, c, p) {
      return xn(t, c, p, !1);
    }
    var Rn = Dn, Mn = Hn;
    jo.Fragment = i, jo.jsx = Rn, jo.jsxs = Mn;
  })()), jo;
}
var sh;
function N1() {
  return sh || (sh = 1, process.env.NODE_ENV === "production" ? kl.exports = x1() : kl.exports = S1()), kl.exports;
}
var fi = N1();
function j1(e) {
  return !e || typeof e == "boolean" || typeof e == "string" ? !!e : e.value;
}
var bl, lh;
function ei() {
  if (lh) return bl;
  lh = 1;
  var e = Array.isArray;
  return bl = e, bl;
}
var _l, ch;
function P_() {
  if (ch) return _l;
  ch = 1;
  var e = typeof No == "object" && No && No.Object === Object && No;
  return _l = e, _l;
}
var xl, dh;
function Pr() {
  if (dh) return xl;
  dh = 1;
  var e = P_(), n = typeof self == "object" && self && self.Object === Object && self, r = e || n || Function("return this")();
  return xl = r, xl;
}
var Sl, uh;
function mo() {
  if (uh) return Sl;
  uh = 1;
  var e = Pr(), n = e.Symbol;
  return Sl = n, Sl;
}
var Nl, mh;
function w1() {
  if (mh) return Nl;
  mh = 1;
  var e = mo(), n = Object.prototype, r = n.hasOwnProperty, i = n.toString, a = e ? e.toStringTag : void 0;
  function o(s) {
    var l = r.call(s, a), d = s[a];
    try {
      s[a] = void 0;
      var m = !0;
    } catch {
    }
    var u = i.call(s);
    return m && (l ? s[a] = d : delete s[a]), u;
  }
  return Nl = o, Nl;
}
var jl, ph;
function C1() {
  if (ph) return jl;
  ph = 1;
  var e = Object.prototype, n = e.toString;
  function r(i) {
    return n.call(i);
  }
  return jl = r, jl;
}
var wl, fh;
function Yi() {
  if (fh) return wl;
  fh = 1;
  var e = mo(), n = w1(), r = C1(), i = "[object Null]", a = "[object Undefined]", o = e ? e.toStringTag : void 0;
  function s(l) {
    return l == null ? l === void 0 ? a : i : o && o in Object(l) ? n(l) : r(l);
  }
  return wl = s, wl;
}
var Cl, hh;
function bi() {
  if (hh) return Cl;
  hh = 1;
  function e(n) {
    return n != null && typeof n == "object";
  }
  return Cl = e, Cl;
}
var Fl, yh;
function ip() {
  if (yh) return Fl;
  yh = 1;
  var e = Yi(), n = bi(), r = "[object Symbol]";
  function i(a) {
    return typeof a == "symbol" || n(a) && e(a) == r;
  }
  return Fl = i, Fl;
}
var Il, gh;
function F1() {
  if (gh) return Il;
  gh = 1;
  var e = ei(), n = ip(), r = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, i = /^\w*$/;
  function a(o, s) {
    if (e(o))
      return !1;
    var l = typeof o;
    return l == "number" || l == "symbol" || l == "boolean" || o == null || n(o) ? !0 : i.test(o) || !r.test(o) || s != null && o in Object(s);
  }
  return Il = a, Il;
}
var El, vh;
function Qi() {
  if (vh) return El;
  vh = 1;
  function e(n) {
    var r = typeof n;
    return n != null && (r == "object" || r == "function");
  }
  return El = e, El;
}
var Tl, kh;
function A_() {
  if (kh) return Tl;
  kh = 1;
  var e = Yi(), n = Qi(), r = "[object AsyncFunction]", i = "[object Function]", a = "[object GeneratorFunction]", o = "[object Proxy]";
  function s(l) {
    if (!n(l))
      return !1;
    var d = e(l);
    return d == i || d == a || d == r || d == o;
  }
  return Tl = s, Tl;
}
var $l, bh;
function I1() {
  if (bh) return $l;
  bh = 1;
  var e = Pr(), n = e["__core-js_shared__"];
  return $l = n, $l;
}
var Dl, _h;
function E1() {
  if (_h) return Dl;
  _h = 1;
  var e = I1(), n = (function() {
    var i = /[^.]+$/.exec(e && e.keys && e.keys.IE_PROTO || "");
    return i ? "Symbol(src)_1." + i : "";
  })();
  function r(i) {
    return !!n && n in i;
  }
  return Dl = r, Dl;
}
var Rl, xh;
function L_() {
  if (xh) return Rl;
  xh = 1;
  var e = Function.prototype, n = e.toString;
  function r(i) {
    if (i != null) {
      try {
        return n.call(i);
      } catch {
      }
      try {
        return i + "";
      } catch {
      }
    }
    return "";
  }
  return Rl = r, Rl;
}
var Ol, Sh;
function T1() {
  if (Sh) return Ol;
  Sh = 1;
  var e = A_(), n = E1(), r = Qi(), i = L_(), a = /[\\^$.*+?()[\]{}|]/g, o = /^\[object .+?Constructor\]$/, s = Function.prototype, l = Object.prototype, d = s.toString, m = l.hasOwnProperty, u = RegExp(
    "^" + d.call(m).replace(a, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
  );
  function f(h) {
    if (!r(h) || n(h))
      return !1;
    var v = e(h) ? u : o;
    return v.test(i(h));
  }
  return Ol = f, Ol;
}
var Pl, Nh;
function $1() {
  if (Nh) return Pl;
  Nh = 1;
  function e(n, r) {
    return n?.[r];
  }
  return Pl = e, Pl;
}
var Al, jh;
function _i() {
  if (jh) return Al;
  jh = 1;
  var e = T1(), n = $1();
  function r(i, a) {
    var o = n(i, a);
    return e(o) ? o : void 0;
  }
  return Al = r, Al;
}
var Ll, wh;
function qs() {
  if (wh) return Ll;
  wh = 1;
  var e = _i(), n = e(Object, "create");
  return Ll = n, Ll;
}
var Vl, Ch;
function D1() {
  if (Ch) return Vl;
  Ch = 1;
  var e = qs();
  function n() {
    this.__data__ = e ? e(null) : {}, this.size = 0;
  }
  return Vl = n, Vl;
}
var zl, Fh;
function R1() {
  if (Fh) return zl;
  Fh = 1;
  function e(n) {
    var r = this.has(n) && delete this.__data__[n];
    return this.size -= r ? 1 : 0, r;
  }
  return zl = e, zl;
}
var Ul, Ih;
function O1() {
  if (Ih) return Ul;
  Ih = 1;
  var e = qs(), n = "__lodash_hash_undefined__", r = Object.prototype, i = r.hasOwnProperty;
  function a(o) {
    var s = this.__data__;
    if (e) {
      var l = s[o];
      return l === n ? void 0 : l;
    }
    return i.call(s, o) ? s[o] : void 0;
  }
  return Ul = a, Ul;
}
var Ml, Eh;
function P1() {
  if (Eh) return Ml;
  Eh = 1;
  var e = qs(), n = Object.prototype, r = n.hasOwnProperty;
  function i(a) {
    var o = this.__data__;
    return e ? o[a] !== void 0 : r.call(o, a);
  }
  return Ml = i, Ml;
}
var Bl, Th;
function A1() {
  if (Th) return Bl;
  Th = 1;
  var e = qs(), n = "__lodash_hash_undefined__";
  function r(i, a) {
    var o = this.__data__;
    return this.size += this.has(i) ? 0 : 1, o[i] = e && a === void 0 ? n : a, this;
  }
  return Bl = r, Bl;
}
var ql, $h;
function L1() {
  if ($h) return ql;
  $h = 1;
  var e = D1(), n = R1(), r = O1(), i = P1(), a = A1();
  function o(s) {
    var l = -1, d = s == null ? 0 : s.length;
    for (this.clear(); ++l < d; ) {
      var m = s[l];
      this.set(m[0], m[1]);
    }
  }
  return o.prototype.clear = e, o.prototype.delete = n, o.prototype.get = r, o.prototype.has = i, o.prototype.set = a, ql = o, ql;
}
var Hl, Dh;
function V1() {
  if (Dh) return Hl;
  Dh = 1;
  function e() {
    this.__data__ = [], this.size = 0;
  }
  return Hl = e, Hl;
}
var Wl, Rh;
function V_() {
  if (Rh) return Wl;
  Rh = 1;
  function e(n, r) {
    return n === r || n !== n && r !== r;
  }
  return Wl = e, Wl;
}
var Kl, Oh;
function Hs() {
  if (Oh) return Kl;
  Oh = 1;
  var e = V_();
  function n(r, i) {
    for (var a = r.length; a--; )
      if (e(r[a][0], i))
        return a;
    return -1;
  }
  return Kl = n, Kl;
}
var Gl, Ph;
function z1() {
  if (Ph) return Gl;
  Ph = 1;
  var e = Hs(), n = Array.prototype, r = n.splice;
  function i(a) {
    var o = this.__data__, s = e(o, a);
    if (s < 0)
      return !1;
    var l = o.length - 1;
    return s == l ? o.pop() : r.call(o, s, 1), --this.size, !0;
  }
  return Gl = i, Gl;
}
var Yl, Ah;
function U1() {
  if (Ah) return Yl;
  Ah = 1;
  var e = Hs();
  function n(r) {
    var i = this.__data__, a = e(i, r);
    return a < 0 ? void 0 : i[a][1];
  }
  return Yl = n, Yl;
}
var Ql, Lh;
function M1() {
  if (Lh) return Ql;
  Lh = 1;
  var e = Hs();
  function n(r) {
    return e(this.__data__, r) > -1;
  }
  return Ql = n, Ql;
}
var Jl, Vh;
function B1() {
  if (Vh) return Jl;
  Vh = 1;
  var e = Hs();
  function n(r, i) {
    var a = this.__data__, o = e(a, r);
    return o < 0 ? (++this.size, a.push([r, i])) : a[o][1] = i, this;
  }
  return Jl = n, Jl;
}
var Xl, zh;
function Ws() {
  if (zh) return Xl;
  zh = 1;
  var e = V1(), n = z1(), r = U1(), i = M1(), a = B1();
  function o(s) {
    var l = -1, d = s == null ? 0 : s.length;
    for (this.clear(); ++l < d; ) {
      var m = s[l];
      this.set(m[0], m[1]);
    }
  }
  return o.prototype.clear = e, o.prototype.delete = n, o.prototype.get = r, o.prototype.has = i, o.prototype.set = a, Xl = o, Xl;
}
var Zl, Uh;
function ap() {
  if (Uh) return Zl;
  Uh = 1;
  var e = _i(), n = Pr(), r = e(n, "Map");
  return Zl = r, Zl;
}
var ec, Mh;
function q1() {
  if (Mh) return ec;
  Mh = 1;
  var e = L1(), n = Ws(), r = ap();
  function i() {
    this.size = 0, this.__data__ = {
      hash: new e(),
      map: new (r || n)(),
      string: new e()
    };
  }
  return ec = i, ec;
}
var nc, Bh;
function H1() {
  if (Bh) return nc;
  Bh = 1;
  function e(n) {
    var r = typeof n;
    return r == "string" || r == "number" || r == "symbol" || r == "boolean" ? n !== "__proto__" : n === null;
  }
  return nc = e, nc;
}
var tc, qh;
function Ks() {
  if (qh) return tc;
  qh = 1;
  var e = H1();
  function n(r, i) {
    var a = r.__data__;
    return e(i) ? a[typeof i == "string" ? "string" : "hash"] : a.map;
  }
  return tc = n, tc;
}
var rc, Hh;
function W1() {
  if (Hh) return rc;
  Hh = 1;
  var e = Ks();
  function n(r) {
    var i = e(this, r).delete(r);
    return this.size -= i ? 1 : 0, i;
  }
  return rc = n, rc;
}
var ic, Wh;
function K1() {
  if (Wh) return ic;
  Wh = 1;
  var e = Ks();
  function n(r) {
    return e(this, r).get(r);
  }
  return ic = n, ic;
}
var ac, Kh;
function G1() {
  if (Kh) return ac;
  Kh = 1;
  var e = Ks();
  function n(r) {
    return e(this, r).has(r);
  }
  return ac = n, ac;
}
var oc, Gh;
function Y1() {
  if (Gh) return oc;
  Gh = 1;
  var e = Ks();
  function n(r, i) {
    var a = e(this, r), o = a.size;
    return a.set(r, i), this.size += a.size == o ? 0 : 1, this;
  }
  return oc = n, oc;
}
var sc, Yh;
function z_() {
  if (Yh) return sc;
  Yh = 1;
  var e = q1(), n = W1(), r = K1(), i = G1(), a = Y1();
  function o(s) {
    var l = -1, d = s == null ? 0 : s.length;
    for (this.clear(); ++l < d; ) {
      var m = s[l];
      this.set(m[0], m[1]);
    }
  }
  return o.prototype.clear = e, o.prototype.delete = n, o.prototype.get = r, o.prototype.has = i, o.prototype.set = a, sc = o, sc;
}
var lc, Qh;
function Q1() {
  if (Qh) return lc;
  Qh = 1;
  var e = z_(), n = "Expected a function";
  function r(i, a) {
    if (typeof i != "function" || a != null && typeof a != "function")
      throw new TypeError(n);
    var o = function() {
      var s = arguments, l = a ? a.apply(this, s) : s[0], d = o.cache;
      if (d.has(l))
        return d.get(l);
      var m = i.apply(this, s);
      return o.cache = d.set(l, m) || d, m;
    };
    return o.cache = new (r.Cache || e)(), o;
  }
  return r.Cache = e, lc = r, lc;
}
var cc, Jh;
function J1() {
  if (Jh) return cc;
  Jh = 1;
  var e = Q1(), n = 500;
  function r(i) {
    var a = e(i, function(s) {
      return o.size === n && o.clear(), s;
    }), o = a.cache;
    return a;
  }
  return cc = r, cc;
}
var dc, Xh;
function X1() {
  if (Xh) return dc;
  Xh = 1;
  var e = J1(), n = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, r = /\\(\\)?/g, i = e(function(a) {
    var o = [];
    return a.charCodeAt(0) === 46 && o.push(""), a.replace(n, function(s, l, d, m) {
      o.push(d ? m.replace(r, "$1") : l || s);
    }), o;
  });
  return dc = i, dc;
}
var uc, Zh;
function U_() {
  if (Zh) return uc;
  Zh = 1;
  function e(n, r) {
    for (var i = -1, a = n == null ? 0 : n.length, o = Array(a); ++i < a; )
      o[i] = r(n[i], i, n);
    return o;
  }
  return uc = e, uc;
}
var mc, ey;
function Z1() {
  if (ey) return mc;
  ey = 1;
  var e = mo(), n = U_(), r = ei(), i = ip(), a = e ? e.prototype : void 0, o = a ? a.toString : void 0;
  function s(l) {
    if (typeof l == "string")
      return l;
    if (r(l))
      return n(l, s) + "";
    if (i(l))
      return o ? o.call(l) : "";
    var d = l + "";
    return d == "0" && 1 / l == -1 / 0 ? "-0" : d;
  }
  return mc = s, mc;
}
var pc, ny;
function eF() {
  if (ny) return pc;
  ny = 1;
  var e = Z1();
  function n(r) {
    return r == null ? "" : e(r);
  }
  return pc = n, pc;
}
var fc, ty;
function Ji() {
  if (ty) return fc;
  ty = 1;
  var e = ei(), n = F1(), r = X1(), i = eF();
  function a(o, s) {
    return e(o) ? o : n(o, s) ? [o] : r(i(o));
  }
  return fc = a, fc;
}
var hc, ry;
function Gs() {
  if (ry) return hc;
  ry = 1;
  var e = ip();
  function n(r) {
    if (typeof r == "string" || e(r))
      return r;
    var i = r + "";
    return i == "0" && 1 / r == -1 / 0 ? "-0" : i;
  }
  return hc = n, hc;
}
var yc, iy;
function M_() {
  if (iy) return yc;
  iy = 1;
  var e = Ji(), n = Gs();
  function r(i, a) {
    a = e(a, i);
    for (var o = 0, s = a.length; i != null && o < s; )
      i = i[n(a[o++])];
    return o && o == s ? i : void 0;
  }
  return yc = r, yc;
}
var gc, ay;
function B_() {
  if (ay) return gc;
  ay = 1;
  var e = _i(), n = (function() {
    try {
      var r = e(Object, "defineProperty");
      return r({}, "", {}), r;
    } catch {
    }
  })();
  return gc = n, gc;
}
var vc, oy;
function q_() {
  if (oy) return vc;
  oy = 1;
  var e = B_();
  function n(r, i, a) {
    i == "__proto__" && e ? e(r, i, {
      configurable: !0,
      enumerable: !0,
      value: a,
      writable: !0
    }) : r[i] = a;
  }
  return vc = n, vc;
}
var kc, sy;
function op() {
  if (sy) return kc;
  sy = 1;
  var e = q_(), n = V_(), r = Object.prototype, i = r.hasOwnProperty;
  function a(o, s, l) {
    var d = o[s];
    (!(i.call(o, s) && n(d, l)) || l === void 0 && !(s in o)) && e(o, s, l);
  }
  return kc = a, kc;
}
var bc, ly;
function sp() {
  if (ly) return bc;
  ly = 1;
  var e = 9007199254740991, n = /^(?:0|[1-9]\d*)$/;
  function r(i, a) {
    var o = typeof i;
    return a = a ?? e, !!a && (o == "number" || o != "symbol" && n.test(i)) && i > -1 && i % 1 == 0 && i < a;
  }
  return bc = r, bc;
}
var _c, cy;
function nF() {
  if (cy) return _c;
  cy = 1;
  var e = op(), n = Ji(), r = sp(), i = Qi(), a = Gs();
  function o(s, l, d, m) {
    if (!i(s))
      return s;
    l = n(l, s);
    for (var u = -1, f = l.length, h = f - 1, v = s; v != null && ++u < f; ) {
      var C = a(l[u]), S = d;
      if (C === "__proto__" || C === "constructor" || C === "prototype")
        return s;
      if (u != h) {
        var j = v[C];
        S = m ? m(j, C, v) : void 0, S === void 0 && (S = i(j) ? j : r(l[u + 1]) ? [] : {});
      }
      e(v, C, S), v = v[C];
    }
    return s;
  }
  return _c = o, _c;
}
var xc, dy;
function tF() {
  if (dy) return xc;
  dy = 1;
  var e = M_(), n = nF(), r = Ji();
  function i(a, o, s) {
    for (var l = -1, d = o.length, m = {}; ++l < d; ) {
      var u = o[l], f = e(a, u);
      s(f, u) && n(m, r(u, a), f);
    }
    return m;
  }
  return xc = i, xc;
}
var Sc, uy;
function rF() {
  if (uy) return Sc;
  uy = 1;
  function e(n, r) {
    return n != null && r in Object(n);
  }
  return Sc = e, Sc;
}
var Nc, my;
function iF() {
  if (my) return Nc;
  my = 1;
  var e = Yi(), n = bi(), r = "[object Arguments]";
  function i(a) {
    return n(a) && e(a) == r;
  }
  return Nc = i, Nc;
}
var jc, py;
function lp() {
  if (py) return jc;
  py = 1;
  var e = iF(), n = bi(), r = Object.prototype, i = r.hasOwnProperty, a = r.propertyIsEnumerable, o = e(/* @__PURE__ */ (function() {
    return arguments;
  })()) ? e : function(s) {
    return n(s) && i.call(s, "callee") && !a.call(s, "callee");
  };
  return jc = o, jc;
}
var wc, fy;
function cp() {
  if (fy) return wc;
  fy = 1;
  var e = 9007199254740991;
  function n(r) {
    return typeof r == "number" && r > -1 && r % 1 == 0 && r <= e;
  }
  return wc = n, wc;
}
var Cc, hy;
function aF() {
  if (hy) return Cc;
  hy = 1;
  var e = Ji(), n = lp(), r = ei(), i = sp(), a = cp(), o = Gs();
  function s(l, d, m) {
    d = e(d, l);
    for (var u = -1, f = d.length, h = !1; ++u < f; ) {
      var v = o(d[u]);
      if (!(h = l != null && m(l, v)))
        break;
      l = l[v];
    }
    return h || ++u != f ? h : (f = l == null ? 0 : l.length, !!f && a(f) && i(v, f) && (r(l) || n(l)));
  }
  return Cc = s, Cc;
}
var Fc, yy;
function oF() {
  if (yy) return Fc;
  yy = 1;
  var e = rF(), n = aF();
  function r(i, a) {
    return i != null && n(i, a, e);
  }
  return Fc = r, Fc;
}
var Ic, gy;
function sF() {
  if (gy) return Ic;
  gy = 1;
  var e = tF(), n = oF();
  function r(i, a) {
    return e(i, a, function(o, s) {
      return n(i, s);
    });
  }
  return Ic = r, Ic;
}
var Ec, vy;
function dp() {
  if (vy) return Ec;
  vy = 1;
  function e(n, r) {
    for (var i = -1, a = r.length, o = n.length; ++i < a; )
      n[o + i] = r[i];
    return n;
  }
  return Ec = e, Ec;
}
var Tc, ky;
function lF() {
  if (ky) return Tc;
  ky = 1;
  var e = mo(), n = lp(), r = ei(), i = e ? e.isConcatSpreadable : void 0;
  function a(o) {
    return r(o) || n(o) || !!(i && o && o[i]);
  }
  return Tc = a, Tc;
}
var $c, by;
function cF() {
  if (by) return $c;
  by = 1;
  var e = dp(), n = lF();
  function r(i, a, o, s, l) {
    var d = -1, m = i.length;
    for (o || (o = n), l || (l = []); ++d < m; ) {
      var u = i[d];
      a > 0 && o(u) ? a > 1 ? r(u, a - 1, o, s, l) : e(l, u) : s || (l[l.length] = u);
    }
    return l;
  }
  return $c = r, $c;
}
var Dc, _y;
function dF() {
  if (_y) return Dc;
  _y = 1;
  var e = cF();
  function n(r) {
    var i = r == null ? 0 : r.length;
    return i ? e(r, 1) : [];
  }
  return Dc = n, Dc;
}
var Rc, xy;
function uF() {
  if (xy) return Rc;
  xy = 1;
  function e(n, r, i) {
    switch (i.length) {
      case 0:
        return n.call(r);
      case 1:
        return n.call(r, i[0]);
      case 2:
        return n.call(r, i[0], i[1]);
      case 3:
        return n.call(r, i[0], i[1], i[2]);
    }
    return n.apply(r, i);
  }
  return Rc = e, Rc;
}
var Oc, Sy;
function mF() {
  if (Sy) return Oc;
  Sy = 1;
  var e = uF(), n = Math.max;
  function r(i, a, o) {
    return a = n(a === void 0 ? i.length - 1 : a, 0), function() {
      for (var s = arguments, l = -1, d = n(s.length - a, 0), m = Array(d); ++l < d; )
        m[l] = s[a + l];
      l = -1;
      for (var u = Array(a + 1); ++l < a; )
        u[l] = s[l];
      return u[a] = o(m), e(i, this, u);
    };
  }
  return Oc = r, Oc;
}
var Pc, Ny;
function pF() {
  if (Ny) return Pc;
  Ny = 1;
  function e(n) {
    return function() {
      return n;
    };
  }
  return Pc = e, Pc;
}
var Ac, jy;
function H_() {
  if (jy) return Ac;
  jy = 1;
  function e(n) {
    return n;
  }
  return Ac = e, Ac;
}
var Lc, wy;
function fF() {
  if (wy) return Lc;
  wy = 1;
  var e = pF(), n = B_(), r = H_(), i = n ? function(a, o) {
    return n(a, "toString", {
      configurable: !0,
      enumerable: !1,
      value: e(o),
      writable: !0
    });
  } : r;
  return Lc = i, Lc;
}
var Vc, Cy;
function hF() {
  if (Cy) return Vc;
  Cy = 1;
  var e = 800, n = 16, r = Date.now;
  function i(a) {
    var o = 0, s = 0;
    return function() {
      var l = r(), d = n - (l - s);
      if (s = l, d > 0) {
        if (++o >= e)
          return arguments[0];
      } else
        o = 0;
      return a.apply(void 0, arguments);
    };
  }
  return Vc = i, Vc;
}
var zc, Fy;
function yF() {
  if (Fy) return zc;
  Fy = 1;
  var e = fF(), n = hF(), r = n(e);
  return zc = r, zc;
}
var Uc, Iy;
function W_() {
  if (Iy) return Uc;
  Iy = 1;
  var e = dF(), n = mF(), r = yF();
  function i(a) {
    return r(n(a, void 0, e), a + "");
  }
  return Uc = i, Uc;
}
var Mc, Ey;
function gF() {
  if (Ey) return Mc;
  Ey = 1;
  var e = sF(), n = W_(), r = n(function(i, a) {
    return i == null ? {} : e(i, a);
  });
  return Mc = r, Mc;
}
var vF = gF();
const K_ = /* @__PURE__ */ O_(vF), kF = [
  "control",
  "defaultValue",
  "name",
  "rules",
  "shouldUnregister"
];
function G_(e) {
  const n = K_(e, kF);
  return {
    controller: np(n),
    controllerProps: n
  };
}
const bF = [
  "className",
  "description",
  "disabled",
  "helpIcon",
  "label",
  "noAlert",
  "noLabel",
  "style"
];
function Y_(e) {
  const { controller: n, controllerProps: r } = G_(e), i = {
    ...K_(e, bF),
    required: j1(r.rules?.required),
    meta: {
      touched: n.fieldState.isTouched,
      error: n.fieldState.error?.message,
      success: e.meta?.success,
      warning: e.meta?.warning
    },
    labelFor: r.name,
    noLabel: e.noLabel,
    noAlert: e.noAlert
  };
  return {
    controller: n,
    controllerProps: r,
    fieldWrapperProps: i
  };
}
var Bc, Ty;
function _F() {
  if (Ty) return Bc;
  Ty = 1;
  var e = Ws();
  function n() {
    this.__data__ = new e(), this.size = 0;
  }
  return Bc = n, Bc;
}
var qc, $y;
function xF() {
  if ($y) return qc;
  $y = 1;
  function e(n) {
    var r = this.__data__, i = r.delete(n);
    return this.size = r.size, i;
  }
  return qc = e, qc;
}
var Hc, Dy;
function SF() {
  if (Dy) return Hc;
  Dy = 1;
  function e(n) {
    return this.__data__.get(n);
  }
  return Hc = e, Hc;
}
var Wc, Ry;
function NF() {
  if (Ry) return Wc;
  Ry = 1;
  function e(n) {
    return this.__data__.has(n);
  }
  return Wc = e, Wc;
}
var Kc, Oy;
function jF() {
  if (Oy) return Kc;
  Oy = 1;
  var e = Ws(), n = ap(), r = z_(), i = 200;
  function a(o, s) {
    var l = this.__data__;
    if (l instanceof e) {
      var d = l.__data__;
      if (!n || d.length < i - 1)
        return d.push([o, s]), this.size = ++l.size, this;
      l = this.__data__ = new r(d);
    }
    return l.set(o, s), this.size = l.size, this;
  }
  return Kc = a, Kc;
}
var Gc, Py;
function wF() {
  if (Py) return Gc;
  Py = 1;
  var e = Ws(), n = _F(), r = xF(), i = SF(), a = NF(), o = jF();
  function s(l) {
    var d = this.__data__ = new e(l);
    this.size = d.size;
  }
  return s.prototype.clear = n, s.prototype.delete = r, s.prototype.get = i, s.prototype.has = a, s.prototype.set = o, Gc = s, Gc;
}
var Yc, Ay;
function CF() {
  if (Ay) return Yc;
  Ay = 1;
  function e(n, r) {
    for (var i = -1, a = n == null ? 0 : n.length; ++i < a && r(n[i], i, n) !== !1; )
      ;
    return n;
  }
  return Yc = e, Yc;
}
var Qc, Ly;
function po() {
  if (Ly) return Qc;
  Ly = 1;
  var e = op(), n = q_();
  function r(i, a, o, s) {
    var l = !o;
    o || (o = {});
    for (var d = -1, m = a.length; ++d < m; ) {
      var u = a[d], f = s ? s(o[u], i[u], u, o, i) : void 0;
      f === void 0 && (f = i[u]), l ? n(o, u, f) : e(o, u, f);
    }
    return o;
  }
  return Qc = r, Qc;
}
var Jc, Vy;
function FF() {
  if (Vy) return Jc;
  Vy = 1;
  function e(n, r) {
    for (var i = -1, a = Array(n); ++i < n; )
      a[i] = r(i);
    return a;
  }
  return Jc = e, Jc;
}
var ts = { exports: {} }, Xc, zy;
function IF() {
  if (zy) return Xc;
  zy = 1;
  function e() {
    return !1;
  }
  return Xc = e, Xc;
}
ts.exports;
var Uy;
function Q_() {
  return Uy || (Uy = 1, (function(e, n) {
    var r = Pr(), i = IF(), a = n && !n.nodeType && n, o = a && !0 && e && !e.nodeType && e, s = o && o.exports === a, l = s ? r.Buffer : void 0, d = l ? l.isBuffer : void 0, m = d || i;
    e.exports = m;
  })(ts, ts.exports)), ts.exports;
}
var Zc, My;
function EF() {
  if (My) return Zc;
  My = 1;
  var e = Yi(), n = cp(), r = bi(), i = "[object Arguments]", a = "[object Array]", o = "[object Boolean]", s = "[object Date]", l = "[object Error]", d = "[object Function]", m = "[object Map]", u = "[object Number]", f = "[object Object]", h = "[object RegExp]", v = "[object Set]", C = "[object String]", S = "[object WeakMap]", j = "[object ArrayBuffer]", F = "[object DataView]", y = "[object Float32Array]", q = "[object Float64Array]", T = "[object Int8Array]", E = "[object Int16Array]", D = "[object Int32Array]", B = "[object Uint8Array]", ee = "[object Uint8ClampedArray]", J = "[object Uint16Array]", ae = "[object Uint32Array]", Q = {};
  Q[y] = Q[q] = Q[T] = Q[E] = Q[D] = Q[B] = Q[ee] = Q[J] = Q[ae] = !0, Q[i] = Q[a] = Q[j] = Q[o] = Q[F] = Q[s] = Q[l] = Q[d] = Q[m] = Q[u] = Q[f] = Q[h] = Q[v] = Q[C] = Q[S] = !1;
  function U(O) {
    return r(O) && n(O.length) && !!Q[e(O)];
  }
  return Zc = U, Zc;
}
var ed, By;
function up() {
  if (By) return ed;
  By = 1;
  function e(n) {
    return function(r) {
      return n(r);
    };
  }
  return ed = e, ed;
}
var rs = { exports: {} };
rs.exports;
var qy;
function mp() {
  return qy || (qy = 1, (function(e, n) {
    var r = P_(), i = n && !n.nodeType && n, a = i && !0 && e && !e.nodeType && e, o = a && a.exports === i, s = o && r.process, l = (function() {
      try {
        var d = a && a.require && a.require("util").types;
        return d || s && s.binding && s.binding("util");
      } catch {
      }
    })();
    e.exports = l;
  })(rs, rs.exports)), rs.exports;
}
var nd, Hy;
function TF() {
  if (Hy) return nd;
  Hy = 1;
  var e = EF(), n = up(), r = mp(), i = r && r.isTypedArray, a = i ? n(i) : e;
  return nd = a, nd;
}
var td, Wy;
function J_() {
  if (Wy) return td;
  Wy = 1;
  var e = FF(), n = lp(), r = ei(), i = Q_(), a = sp(), o = TF(), s = Object.prototype, l = s.hasOwnProperty;
  function d(m, u) {
    var f = r(m), h = !f && n(m), v = !f && !h && i(m), C = !f && !h && !v && o(m), S = f || h || v || C, j = S ? e(m.length, String) : [], F = j.length;
    for (var y in m)
      (u || l.call(m, y)) && !(S && // Safari 9 has enumerable `arguments.length` in strict mode.
      (y == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
      v && (y == "offset" || y == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
      C && (y == "buffer" || y == "byteLength" || y == "byteOffset") || // Skip index properties.
      a(y, F))) && j.push(y);
    return j;
  }
  return td = d, td;
}
var rd, Ky;
function pp() {
  if (Ky) return rd;
  Ky = 1;
  var e = Object.prototype;
  function n(r) {
    var i = r && r.constructor, a = typeof i == "function" && i.prototype || e;
    return r === a;
  }
  return rd = n, rd;
}
var id, Gy;
function X_() {
  if (Gy) return id;
  Gy = 1;
  function e(n, r) {
    return function(i) {
      return n(r(i));
    };
  }
  return id = e, id;
}
var ad, Yy;
function $F() {
  if (Yy) return ad;
  Yy = 1;
  var e = X_(), n = e(Object.keys, Object);
  return ad = n, ad;
}
var od, Qy;
function DF() {
  if (Qy) return od;
  Qy = 1;
  var e = pp(), n = $F(), r = Object.prototype, i = r.hasOwnProperty;
  function a(o) {
    if (!e(o))
      return n(o);
    var s = [];
    for (var l in Object(o))
      i.call(o, l) && l != "constructor" && s.push(l);
    return s;
  }
  return od = a, od;
}
var sd, Jy;
function Z_() {
  if (Jy) return sd;
  Jy = 1;
  var e = A_(), n = cp();
  function r(i) {
    return i != null && n(i.length) && !e(i);
  }
  return sd = r, sd;
}
var ld, Xy;
function fp() {
  if (Xy) return ld;
  Xy = 1;
  var e = J_(), n = DF(), r = Z_();
  function i(a) {
    return r(a) ? e(a) : n(a);
  }
  return ld = i, ld;
}
var cd, Zy;
function RF() {
  if (Zy) return cd;
  Zy = 1;
  var e = po(), n = fp();
  function r(i, a) {
    return i && e(a, n(a), i);
  }
  return cd = r, cd;
}
var dd, eg;
function OF() {
  if (eg) return dd;
  eg = 1;
  function e(n) {
    var r = [];
    if (n != null)
      for (var i in Object(n))
        r.push(i);
    return r;
  }
  return dd = e, dd;
}
var ud, ng;
function PF() {
  if (ng) return ud;
  ng = 1;
  var e = Qi(), n = pp(), r = OF(), i = Object.prototype, a = i.hasOwnProperty;
  function o(s) {
    if (!e(s))
      return r(s);
    var l = n(s), d = [];
    for (var m in s)
      m == "constructor" && (l || !a.call(s, m)) || d.push(m);
    return d;
  }
  return ud = o, ud;
}
var md, tg;
function hp() {
  if (tg) return md;
  tg = 1;
  var e = J_(), n = PF(), r = Z_();
  function i(a) {
    return r(a) ? e(a, !0) : n(a);
  }
  return md = i, md;
}
var pd, rg;
function AF() {
  if (rg) return pd;
  rg = 1;
  var e = po(), n = hp();
  function r(i, a) {
    return i && e(a, n(a), i);
  }
  return pd = r, pd;
}
var is = { exports: {} };
is.exports;
var ig;
function LF() {
  return ig || (ig = 1, (function(e, n) {
    var r = Pr(), i = n && !n.nodeType && n, a = i && !0 && e && !e.nodeType && e, o = a && a.exports === i, s = o ? r.Buffer : void 0, l = s ? s.allocUnsafe : void 0;
    function d(m, u) {
      if (u)
        return m.slice();
      var f = m.length, h = l ? l(f) : new m.constructor(f);
      return m.copy(h), h;
    }
    e.exports = d;
  })(is, is.exports)), is.exports;
}
var fd, ag;
function VF() {
  if (ag) return fd;
  ag = 1;
  function e(n, r) {
    var i = -1, a = n.length;
    for (r || (r = Array(a)); ++i < a; )
      r[i] = n[i];
    return r;
  }
  return fd = e, fd;
}
var hd, og;
function zF() {
  if (og) return hd;
  og = 1;
  function e(n, r) {
    for (var i = -1, a = n == null ? 0 : n.length, o = 0, s = []; ++i < a; ) {
      var l = n[i];
      r(l, i, n) && (s[o++] = l);
    }
    return s;
  }
  return hd = e, hd;
}
var yd, sg;
function ex() {
  if (sg) return yd;
  sg = 1;
  function e() {
    return [];
  }
  return yd = e, yd;
}
var gd, lg;
function yp() {
  if (lg) return gd;
  lg = 1;
  var e = zF(), n = ex(), r = Object.prototype, i = r.propertyIsEnumerable, a = Object.getOwnPropertySymbols, o = a ? function(s) {
    return s == null ? [] : (s = Object(s), e(a(s), function(l) {
      return i.call(s, l);
    }));
  } : n;
  return gd = o, gd;
}
var vd, cg;
function UF() {
  if (cg) return vd;
  cg = 1;
  var e = po(), n = yp();
  function r(i, a) {
    return e(i, n(i), a);
  }
  return vd = r, vd;
}
var kd, dg;
function gp() {
  if (dg) return kd;
  dg = 1;
  var e = X_(), n = e(Object.getPrototypeOf, Object);
  return kd = n, kd;
}
var bd, ug;
function nx() {
  if (ug) return bd;
  ug = 1;
  var e = dp(), n = gp(), r = yp(), i = ex(), a = Object.getOwnPropertySymbols, o = a ? function(s) {
    for (var l = []; s; )
      e(l, r(s)), s = n(s);
    return l;
  } : i;
  return bd = o, bd;
}
var _d, mg;
function MF() {
  if (mg) return _d;
  mg = 1;
  var e = po(), n = nx();
  function r(i, a) {
    return e(i, n(i), a);
  }
  return _d = r, _d;
}
var xd, pg;
function tx() {
  if (pg) return xd;
  pg = 1;
  var e = dp(), n = ei();
  function r(i, a, o) {
    var s = a(i);
    return n(i) ? s : e(s, o(i));
  }
  return xd = r, xd;
}
var Sd, fg;
function BF() {
  if (fg) return Sd;
  fg = 1;
  var e = tx(), n = yp(), r = fp();
  function i(a) {
    return e(a, r, n);
  }
  return Sd = i, Sd;
}
var Nd, hg;
function rx() {
  if (hg) return Nd;
  hg = 1;
  var e = tx(), n = nx(), r = hp();
  function i(a) {
    return e(a, r, n);
  }
  return Nd = i, Nd;
}
var jd, yg;
function qF() {
  if (yg) return jd;
  yg = 1;
  var e = _i(), n = Pr(), r = e(n, "DataView");
  return jd = r, jd;
}
var wd, gg;
function HF() {
  if (gg) return wd;
  gg = 1;
  var e = _i(), n = Pr(), r = e(n, "Promise");
  return wd = r, wd;
}
var Cd, vg;
function WF() {
  if (vg) return Cd;
  vg = 1;
  var e = _i(), n = Pr(), r = e(n, "Set");
  return Cd = r, Cd;
}
var Fd, kg;
function KF() {
  if (kg) return Fd;
  kg = 1;
  var e = _i(), n = Pr(), r = e(n, "WeakMap");
  return Fd = r, Fd;
}
var Id, bg;
function vp() {
  if (bg) return Id;
  bg = 1;
  var e = qF(), n = ap(), r = HF(), i = WF(), a = KF(), o = Yi(), s = L_(), l = "[object Map]", d = "[object Object]", m = "[object Promise]", u = "[object Set]", f = "[object WeakMap]", h = "[object DataView]", v = s(e), C = s(n), S = s(r), j = s(i), F = s(a), y = o;
  return (e && y(new e(new ArrayBuffer(1))) != h || n && y(new n()) != l || r && y(r.resolve()) != m || i && y(new i()) != u || a && y(new a()) != f) && (y = function(q) {
    var T = o(q), E = T == d ? q.constructor : void 0, D = E ? s(E) : "";
    if (D)
      switch (D) {
        case v:
          return h;
        case C:
          return l;
        case S:
          return m;
        case j:
          return u;
        case F:
          return f;
      }
    return T;
  }), Id = y, Id;
}
var Ed, _g;
function GF() {
  if (_g) return Ed;
  _g = 1;
  var e = Object.prototype, n = e.hasOwnProperty;
  function r(i) {
    var a = i.length, o = new i.constructor(a);
    return a && typeof i[0] == "string" && n.call(i, "index") && (o.index = i.index, o.input = i.input), o;
  }
  return Ed = r, Ed;
}
var Td, xg;
function YF() {
  if (xg) return Td;
  xg = 1;
  var e = Pr(), n = e.Uint8Array;
  return Td = n, Td;
}
var $d, Sg;
function kp() {
  if (Sg) return $d;
  Sg = 1;
  var e = YF();
  function n(r) {
    var i = new r.constructor(r.byteLength);
    return new e(i).set(new e(r)), i;
  }
  return $d = n, $d;
}
var Dd, Ng;
function QF() {
  if (Ng) return Dd;
  Ng = 1;
  var e = kp();
  function n(r, i) {
    var a = i ? e(r.buffer) : r.buffer;
    return new r.constructor(a, r.byteOffset, r.byteLength);
  }
  return Dd = n, Dd;
}
var Rd, jg;
function JF() {
  if (jg) return Rd;
  jg = 1;
  var e = /\w*$/;
  function n(r) {
    var i = new r.constructor(r.source, e.exec(r));
    return i.lastIndex = r.lastIndex, i;
  }
  return Rd = n, Rd;
}
var Od, wg;
function XF() {
  if (wg) return Od;
  wg = 1;
  var e = mo(), n = e ? e.prototype : void 0, r = n ? n.valueOf : void 0;
  function i(a) {
    return r ? Object(r.call(a)) : {};
  }
  return Od = i, Od;
}
var Pd, Cg;
function ZF() {
  if (Cg) return Pd;
  Cg = 1;
  var e = kp();
  function n(r, i) {
    var a = i ? e(r.buffer) : r.buffer;
    return new r.constructor(a, r.byteOffset, r.length);
  }
  return Pd = n, Pd;
}
var Ad, Fg;
function eI() {
  if (Fg) return Ad;
  Fg = 1;
  var e = kp(), n = QF(), r = JF(), i = XF(), a = ZF(), o = "[object Boolean]", s = "[object Date]", l = "[object Map]", d = "[object Number]", m = "[object RegExp]", u = "[object Set]", f = "[object String]", h = "[object Symbol]", v = "[object ArrayBuffer]", C = "[object DataView]", S = "[object Float32Array]", j = "[object Float64Array]", F = "[object Int8Array]", y = "[object Int16Array]", q = "[object Int32Array]", T = "[object Uint8Array]", E = "[object Uint8ClampedArray]", D = "[object Uint16Array]", B = "[object Uint32Array]";
  function ee(J, ae, Q) {
    var U = J.constructor;
    switch (ae) {
      case v:
        return e(J);
      case o:
      case s:
        return new U(+J);
      case C:
        return n(J, Q);
      case S:
      case j:
      case F:
      case y:
      case q:
      case T:
      case E:
      case D:
      case B:
        return a(J, Q);
      case l:
        return new U();
      case d:
      case f:
        return new U(J);
      case m:
        return r(J);
      case u:
        return new U();
      case h:
        return i(J);
    }
  }
  return Ad = ee, Ad;
}
var Ld, Ig;
function nI() {
  if (Ig) return Ld;
  Ig = 1;
  var e = Qi(), n = Object.create, r = /* @__PURE__ */ (function() {
    function i() {
    }
    return function(a) {
      if (!e(a))
        return {};
      if (n)
        return n(a);
      i.prototype = a;
      var o = new i();
      return i.prototype = void 0, o;
    };
  })();
  return Ld = r, Ld;
}
var Vd, Eg;
function tI() {
  if (Eg) return Vd;
  Eg = 1;
  var e = nI(), n = gp(), r = pp();
  function i(a) {
    return typeof a.constructor == "function" && !r(a) ? e(n(a)) : {};
  }
  return Vd = i, Vd;
}
var zd, Tg;
function rI() {
  if (Tg) return zd;
  Tg = 1;
  var e = vp(), n = bi(), r = "[object Map]";
  function i(a) {
    return n(a) && e(a) == r;
  }
  return zd = i, zd;
}
var Ud, $g;
function iI() {
  if ($g) return Ud;
  $g = 1;
  var e = rI(), n = up(), r = mp(), i = r && r.isMap, a = i ? n(i) : e;
  return Ud = a, Ud;
}
var Md, Dg;
function aI() {
  if (Dg) return Md;
  Dg = 1;
  var e = vp(), n = bi(), r = "[object Set]";
  function i(a) {
    return n(a) && e(a) == r;
  }
  return Md = i, Md;
}
var Bd, Rg;
function oI() {
  if (Rg) return Bd;
  Rg = 1;
  var e = aI(), n = up(), r = mp(), i = r && r.isSet, a = i ? n(i) : e;
  return Bd = a, Bd;
}
var qd, Og;
function sI() {
  if (Og) return qd;
  Og = 1;
  var e = wF(), n = CF(), r = op(), i = RF(), a = AF(), o = LF(), s = VF(), l = UF(), d = MF(), m = BF(), u = rx(), f = vp(), h = GF(), v = eI(), C = tI(), S = ei(), j = Q_(), F = iI(), y = Qi(), q = oI(), T = fp(), E = hp(), D = 1, B = 2, ee = 4, J = "[object Arguments]", ae = "[object Array]", Q = "[object Boolean]", U = "[object Date]", O = "[object Error]", H = "[object Function]", Z = "[object GeneratorFunction]", ye = "[object Map]", ce = "[object Number]", le = "[object Object]", ue = "[object RegExp]", W = "[object Set]", ke = "[object String]", Ee = "[object Symbol]", K = "[object WeakMap]", qe = "[object ArrayBuffer]", Be = "[object DataView]", Pe = "[object Float32Array]", Me = "[object Float64Array]", Fe = "[object Int8Array]", Ae = "[object Int16Array]", $e = "[object Int32Array]", tn = "[object Uint8Array]", Ie = "[object Uint8ClampedArray]", We = "[object Uint16Array]", Ze = "[object Uint32Array]", de = {};
  de[J] = de[ae] = de[qe] = de[Be] = de[Q] = de[U] = de[Pe] = de[Me] = de[Fe] = de[Ae] = de[$e] = de[ye] = de[ce] = de[le] = de[ue] = de[W] = de[ke] = de[Ee] = de[tn] = de[Ie] = de[We] = de[Ze] = !0, de[O] = de[H] = de[K] = !1;
  function fe(Te, Le, Re, sn, w, _) {
    var $, G = Le & D, Y = Le & B, R = Le & ee;
    if (Re && ($ = w ? Re(Te, sn, w, _) : Re(Te)), $ !== void 0)
      return $;
    if (!y(Te))
      return Te;
    var z = S(Te);
    if (z) {
      if ($ = h(Te), !G)
        return s(Te, $);
    } else {
      var ie = f(Te), pe = ie == H || ie == Z;
      if (j(Te))
        return o(Te, G);
      if (ie == le || ie == J || pe && !w) {
        if ($ = Y || pe ? {} : C(Te), !G)
          return Y ? d(Te, a($, Te)) : l(Te, i($, Te));
      } else {
        if (!de[ie])
          return w ? Te : {};
        $ = v(Te, ie, G);
      }
    }
    _ || (_ = new e());
    var _e = _.get(Te);
    if (_e)
      return _e;
    _.set(Te, $), q(Te) ? Te.forEach(function(rn) {
      $.add(fe(rn, Le, Re, rn, Te, _));
    }) : F(Te) && Te.forEach(function(rn, dn) {
      $.set(dn, fe(rn, Le, Re, dn, Te, _));
    });
    var en = R ? Y ? u : m : Y ? E : T, un = z ? void 0 : en(Te);
    return n(un || Te, function(rn, dn) {
      un && (dn = rn, rn = Te[dn]), r($, dn, fe(rn, Le, Re, dn, Te, _));
    }), $;
  }
  return qd = fe, qd;
}
var Hd, Pg;
function lI() {
  if (Pg) return Hd;
  Pg = 1;
  function e(n) {
    var r = n == null ? 0 : n.length;
    return r ? n[r - 1] : void 0;
  }
  return Hd = e, Hd;
}
var Wd, Ag;
function cI() {
  if (Ag) return Wd;
  Ag = 1;
  function e(n, r, i) {
    var a = -1, o = n.length;
    r < 0 && (r = -r > o ? 0 : o + r), i = i > o ? o : i, i < 0 && (i += o), o = r > i ? 0 : i - r >>> 0, r >>>= 0;
    for (var s = Array(o); ++a < o; )
      s[a] = n[a + r];
    return s;
  }
  return Wd = e, Wd;
}
var Kd, Lg;
function dI() {
  if (Lg) return Kd;
  Lg = 1;
  var e = M_(), n = cI();
  function r(i, a) {
    return a.length < 2 ? i : e(i, n(a, 0, -1));
  }
  return Kd = r, Kd;
}
var Gd, Vg;
function uI() {
  if (Vg) return Gd;
  Vg = 1;
  var e = Ji(), n = lI(), r = dI(), i = Gs(), a = Object.prototype, o = a.hasOwnProperty;
  function s(l, d) {
    d = e(d, l);
    var m = -1, u = d.length;
    if (!u)
      return !0;
    for (; ++m < u; ) {
      var f = i(d[m]);
      if (f === "__proto__" && !o.call(l, "__proto__") || (f === "constructor" || f === "prototype") && m < u - 1)
        return !1;
    }
    var h = r(l, d);
    return h == null || delete h[i(n(d))];
  }
  return Gd = s, Gd;
}
var Yd, zg;
function mI() {
  if (zg) return Yd;
  zg = 1;
  var e = Yi(), n = gp(), r = bi(), i = "[object Object]", a = Function.prototype, o = Object.prototype, s = a.toString, l = o.hasOwnProperty, d = s.call(Object);
  function m(u) {
    if (!r(u) || e(u) != i)
      return !1;
    var f = n(u);
    if (f === null)
      return !0;
    var h = l.call(f, "constructor") && f.constructor;
    return typeof h == "function" && h instanceof h && s.call(h) == d;
  }
  return Yd = m, Yd;
}
var Qd, Ug;
function pI() {
  if (Ug) return Qd;
  Ug = 1;
  var e = mI();
  function n(r) {
    return e(r) ? void 0 : r;
  }
  return Qd = n, Qd;
}
var Jd, Mg;
function fI() {
  if (Mg) return Jd;
  Mg = 1;
  var e = U_(), n = sI(), r = uI(), i = Ji(), a = po(), o = pI(), s = W_(), l = rx(), d = 1, m = 2, u = 4, f = s(function(h, v) {
    var C = {};
    if (h == null)
      return C;
    var S = !1;
    v = e(v, function(F) {
      return F = i(F, h), S || (S = F.length > 1), F;
    }), a(h, l(h), C), S && (C = n(C, d | m | u, o));
    for (var j = v.length; j--; )
      r(C, v[j]);
    return C;
  });
  return Jd = f, Jd;
}
fI();
const xr = ({
  children: e,
  ...n
}) => {
  const { controller: r, controllerProps: i, fieldWrapperProps: a } = Y_(n), {
    name: o,
    onBlur: s,
    onChange: l,
    ...d
  } = r.field;
  return /* @__PURE__ */ fi.jsx(En, { ...a, children: /* @__PURE__ */ fi.jsx(
    Qr,
    {
      ...n.componentProps,
      ...d,
      multiple: !1,
      value: d.value ? [d.value] : [],
      onBlur: (m) => {
        n.componentProps?.onBlur?.(m), s();
      },
      onChange: (m) => {
        n.componentProps?.onChange?.(m), l(m.selectedValues[0] ?? null);
      },
      id: i.name,
      "aria-disabled": a.disabled,
      disabled: a.disabled,
      "aria-required": a.required,
      required: a.required,
      status: En.getStatus(a.meta),
      children: e
    }
  ) });
};
var hI = H_();
const yI = /* @__PURE__ */ O_(hI), sr = ({
  transformValue: e = yI,
  label: n,
  helpIcon: r,
  className: i,
  ...a
}) => {
  const {
    controller: { field: o },
    controllerProps: { name: s }
  } = G_(a);
  return /* @__PURE__ */ fi.jsxs(b, { gap: "200", alignItems: "center", className: i, children: [
    /* @__PURE__ */ fi.jsx(
      Gu,
      {
        ...o,
        id: s,
        checked: e(o.value),
        disabled: a.componentProps?.disabled,
        onChange: (l) => {
          a.componentProps?.onChange?.(l), o.onChange(e(l.target.checked));
        }
      }
    ),
    n && /* @__PURE__ */ fi.jsx(m0, { htmlFor: s, helpIcon: r, children: n })
  ] });
}, gt = (e) => {
  const { controller: n, controllerProps: r, fieldWrapperProps: i } = Y_(e);
  return /* @__PURE__ */ fi.jsx(En, { ...i, children: /* @__PURE__ */ fi.jsx(
    _r,
    {
      ...e.componentProps,
      ...n.field,
      value: e.componentProps?.type === "number" && isNaN(n.field.value) ? "" : n.field.value ?? "",
      onBlur: (a) => {
        e.componentProps?.onBlur?.(a), n.field.onBlur();
      },
      onChange: (a) => {
        e.componentProps?.onChange?.(a), n.field.onChange(
          e.componentProps?.type === "number" ? a.target.valueAsNumber : a
        );
      },
      id: r.name,
      "aria-disabled": i.disabled,
      disabled: i.disabled,
      "aria-required": i.required,
      required: i.required,
      status: En.getStatus(i.meta)
    }
  ) });
};
(function() {
  try {
    if (typeof document < "u") {
      var e = document.createElement("style");
      e.appendChild(document.createTextNode("._list_16pij_1{padding:0}._listItem_16pij_4{padding:var(--dixa-size-spacer-100);border-bottom:var(--dixa-size-border-100) solid var(--dixa-color-neutral-200)}._listItem_16pij_4:last-child{border-bottom:none}._listItemEdit_16pij_11{cursor:pointer}._clickableIcon_16pij_15{cursor:pointer;color:var(--dixa-typography-color-secondary)}._boxWrapper_89s7l_1{border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-200);border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-300)}._boxWrapper_89s7l_1:hover{border-color:var(--dixa-color-neutral-300)}._trackButton_89s7l_10{color:var(--dixa-typography-color-link)}._order_135ze_1{border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-250)}._order_135ze_1:hover,._orderIsOpen_135ze_9{border-color:var(--dixa-color-neutral-400)}._orderHeader_135ze_12{cursor:pointer}")), document.head.appendChild(e);
    }
  } catch (n) {
    console.error("vite-plugin-css-injected-by-js", n);
  }
})();
var Xd = { exports: {} }, ua = {}, Bg;
function gI() {
  if (Bg) return ua;
  Bg = 1;
  var e = je, n = Symbol.for("react.element"), r = Symbol.for("react.fragment"), i = Object.prototype.hasOwnProperty, a = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, o = { key: !0, ref: !0, __self: !0, __source: !0 };
  function s(l, d, m) {
    var u, f = {}, h = null, v = null;
    m !== void 0 && (h = "" + m), d.key !== void 0 && (h = "" + d.key), d.ref !== void 0 && (v = d.ref);
    for (u in d) i.call(d, u) && !o.hasOwnProperty(u) && (f[u] = d[u]);
    if (l && l.defaultProps) for (u in d = l.defaultProps, d) f[u] === void 0 && (f[u] = d[u]);
    return { $$typeof: n, type: l, key: h, ref: v, props: f, _owner: a.current };
  }
  return ua.Fragment = r, ua.jsx = s, ua.jsxs = s, ua;
}
var wo = {}, qg;
function vI() {
  return qg || (qg = 1, process.env.NODE_ENV !== "production" && (function() {
    var e = je, n = Symbol.for("react.element"), r = Symbol.for("react.portal"), i = Symbol.for("react.fragment"), a = Symbol.for("react.strict_mode"), o = Symbol.for("react.profiler"), s = Symbol.for("react.provider"), l = Symbol.for("react.context"), d = Symbol.for("react.forward_ref"), m = Symbol.for("react.suspense"), u = Symbol.for("react.suspense_list"), f = Symbol.for("react.memo"), h = Symbol.for("react.lazy"), v = Symbol.for("react.offscreen"), C = Symbol.iterator, S = "@@iterator";
    function j(t) {
      if (t === null || typeof t != "object")
        return null;
      var c = C && t[C] || t[S];
      return typeof c == "function" ? c : null;
    }
    var F = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function y(t) {
      {
        for (var c = arguments.length, p = new Array(c > 1 ? c - 1 : 0), g = 1; g < c; g++)
          p[g - 1] = arguments[g];
        q("error", t, p);
      }
    }
    function q(t, c, p) {
      {
        var g = F.ReactDebugCurrentFrame, P = g.getStackAddendum();
        P !== "" && (c += "%s", p = p.concat([P]));
        var L = p.map(function(I) {
          return String(I);
        });
        L.unshift("Warning: " + c), Function.prototype.apply.call(console[t], console, L);
      }
    }
    var T = !1, E = !1, D = !1, B = !1, ee = !1, J;
    J = Symbol.for("react.module.reference");
    function ae(t) {
      return !!(typeof t == "string" || typeof t == "function" || t === i || t === o || ee || t === a || t === m || t === u || B || t === v || T || E || D || typeof t == "object" && t !== null && (t.$$typeof === h || t.$$typeof === f || t.$$typeof === s || t.$$typeof === l || t.$$typeof === d || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      t.$$typeof === J || t.getModuleId !== void 0));
    }
    function Q(t, c, p) {
      var g = t.displayName;
      if (g)
        return g;
      var P = c.displayName || c.name || "";
      return P !== "" ? p + "(" + P + ")" : p;
    }
    function U(t) {
      return t.displayName || "Context";
    }
    function O(t) {
      if (t == null)
        return null;
      if (typeof t.tag == "number" && y("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof t == "function")
        return t.displayName || t.name || null;
      if (typeof t == "string")
        return t;
      switch (t) {
        case i:
          return "Fragment";
        case r:
          return "Portal";
        case o:
          return "Profiler";
        case a:
          return "StrictMode";
        case m:
          return "Suspense";
        case u:
          return "SuspenseList";
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case l:
            var c = t;
            return U(c) + ".Consumer";
          case s:
            var p = t;
            return U(p._context) + ".Provider";
          case d:
            return Q(t, t.render, "ForwardRef");
          case f:
            var g = t.displayName || null;
            return g !== null ? g : O(t.type) || "Memo";
          case h: {
            var P = t, L = P._payload, I = P._init;
            try {
              return O(I(L));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var H = Object.assign, Z = 0, ye, ce, le, ue, W, ke, Ee;
    function K() {
    }
    K.__reactDisabledLog = !0;
    function qe() {
      {
        if (Z === 0) {
          ye = console.log, ce = console.info, le = console.warn, ue = console.error, W = console.group, ke = console.groupCollapsed, Ee = console.groupEnd;
          var t = {
            configurable: !0,
            enumerable: !0,
            value: K,
            writable: !0
          };
          Object.defineProperties(console, {
            info: t,
            log: t,
            warn: t,
            error: t,
            group: t,
            groupCollapsed: t,
            groupEnd: t
          });
        }
        Z++;
      }
    }
    function Be() {
      {
        if (Z--, Z === 0) {
          var t = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: H({}, t, {
              value: ye
            }),
            info: H({}, t, {
              value: ce
            }),
            warn: H({}, t, {
              value: le
            }),
            error: H({}, t, {
              value: ue
            }),
            group: H({}, t, {
              value: W
            }),
            groupCollapsed: H({}, t, {
              value: ke
            }),
            groupEnd: H({}, t, {
              value: Ee
            })
          });
        }
        Z < 0 && y("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var Pe = F.ReactCurrentDispatcher, Me;
    function Fe(t, c, p) {
      {
        if (Me === void 0)
          try {
            throw Error();
          } catch (P) {
            var g = P.stack.trim().match(/\n( *(at )?)/);
            Me = g && g[1] || "";
          }
        return `
` + Me + t;
      }
    }
    var Ae = !1, $e;
    {
      var tn = typeof WeakMap == "function" ? WeakMap : Map;
      $e = new tn();
    }
    function Ie(t, c) {
      if (!t || Ae)
        return "";
      {
        var p = $e.get(t);
        if (p !== void 0)
          return p;
      }
      var g;
      Ae = !0;
      var P = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var L;
      L = Pe.current, Pe.current = null, qe();
      try {
        if (c) {
          var I = function() {
            throw Error();
          };
          if (Object.defineProperty(I.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(I, []);
            } catch (ne) {
              g = ne;
            }
            Reflect.construct(t, [], I);
          } else {
            try {
              I.call();
            } catch (ne) {
              g = ne;
            }
            t.call(I.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (ne) {
            g = ne;
          }
          t();
        }
      } catch (ne) {
        if (ne && g && typeof ne.stack == "string") {
          for (var N = ne.stack.split(`
`), te = g.stack.split(`
`), x = N.length - 1, V = te.length - 1; x >= 1 && V >= 0 && N[x] !== te[V]; )
            V--;
          for (; x >= 1 && V >= 0; x--, V--)
            if (N[x] !== te[V]) {
              if (x !== 1 || V !== 1)
                do
                  if (x--, V--, V < 0 || N[x] !== te[V]) {
                    var X = `
` + N[x].replace(" at new ", " at ");
                    return t.displayName && X.includes("<anonymous>") && (X = X.replace("<anonymous>", t.displayName)), typeof t == "function" && $e.set(t, X), X;
                  }
                while (x >= 1 && V >= 0);
              break;
            }
        }
      } finally {
        Ae = !1, Pe.current = L, Be(), Error.prepareStackTrace = P;
      }
      var we = t ? t.displayName || t.name : "", Se = we ? Fe(we) : "";
      return typeof t == "function" && $e.set(t, Se), Se;
    }
    function We(t, c, p) {
      return Ie(t, !1);
    }
    function Ze(t) {
      var c = t.prototype;
      return !!(c && c.isReactComponent);
    }
    function de(t, c, p) {
      if (t == null)
        return "";
      if (typeof t == "function")
        return Ie(t, Ze(t));
      if (typeof t == "string")
        return Fe(t);
      switch (t) {
        case m:
          return Fe("Suspense");
        case u:
          return Fe("SuspenseList");
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case d:
            return We(t.render);
          case f:
            return de(t.type, c, p);
          case h: {
            var g = t, P = g._payload, L = g._init;
            try {
              return de(L(P), c, p);
            } catch {
            }
          }
        }
      return "";
    }
    var fe = Object.prototype.hasOwnProperty, Te = {}, Le = F.ReactDebugCurrentFrame;
    function Re(t) {
      if (t) {
        var c = t._owner, p = de(t.type, t._source, c ? c.type : null);
        Le.setExtraStackFrame(p);
      } else
        Le.setExtraStackFrame(null);
    }
    function sn(t, c, p, g, P) {
      {
        var L = Function.call.bind(fe);
        for (var I in t)
          if (L(t, I)) {
            var N = void 0;
            try {
              if (typeof t[I] != "function") {
                var te = Error((g || "React class") + ": " + p + " type `" + I + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof t[I] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw te.name = "Invariant Violation", te;
              }
              N = t[I](c, I, g, p, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (x) {
              N = x;
            }
            N && !(N instanceof Error) && (Re(P), y("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", g || "React class", p, I, typeof N), Re(null)), N instanceof Error && !(N.message in Te) && (Te[N.message] = !0, Re(P), y("Failed %s type: %s", p, N.message), Re(null));
          }
      }
    }
    var w = Array.isArray;
    function _(t) {
      return w(t);
    }
    function $(t) {
      {
        var c = typeof Symbol == "function" && Symbol.toStringTag, p = c && t[Symbol.toStringTag] || t.constructor.name || "Object";
        return p;
      }
    }
    function G(t) {
      try {
        return Y(t), !1;
      } catch {
        return !0;
      }
    }
    function Y(t) {
      return "" + t;
    }
    function R(t) {
      if (G(t))
        return y("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", $(t)), Y(t);
    }
    var z = F.ReactCurrentOwner, ie = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, pe, _e;
    function en(t) {
      if (fe.call(t, "ref")) {
        var c = Object.getOwnPropertyDescriptor(t, "ref").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.ref !== void 0;
    }
    function un(t) {
      if (fe.call(t, "key")) {
        var c = Object.getOwnPropertyDescriptor(t, "key").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.key !== void 0;
    }
    function rn(t, c) {
      typeof t.ref == "string" && z.current;
    }
    function dn(t, c) {
      {
        var p = function() {
          pe || (pe = !0, y("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "key", {
          get: p,
          configurable: !0
        });
      }
    }
    function pn(t, c) {
      {
        var p = function() {
          _e || (_e = !0, y("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "ref", {
          get: p,
          configurable: !0
        });
      }
    }
    var ln = function(t, c, p, g, P, L, I) {
      var N = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: n,
        // Built-in properties that belong on the element
        type: t,
        key: c,
        ref: p,
        props: I,
        // Record the component responsible for creating this element.
        _owner: L
      };
      return N._store = {}, Object.defineProperty(N._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(N, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: g
      }), Object.defineProperty(N, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: P
      }), Object.freeze && (Object.freeze(N.props), Object.freeze(N)), N;
    };
    function kn(t, c, p, g, P) {
      {
        var L, I = {}, N = null, te = null;
        p !== void 0 && (R(p), N = "" + p), un(c) && (R(c.key), N = "" + c.key), en(c) && (te = c.ref, rn(c));
        for (L in c)
          fe.call(c, L) && !ie.hasOwnProperty(L) && (I[L] = c[L]);
        if (t && t.defaultProps) {
          var x = t.defaultProps;
          for (L in x)
            I[L] === void 0 && (I[L] = x[L]);
        }
        if (N || te) {
          var V = typeof t == "function" ? t.displayName || t.name || "Unknown" : t;
          N && dn(I, V), te && pn(I, V);
        }
        return ln(t, N, te, P, g, z.current, I);
      }
    }
    var Xe = F.ReactCurrentOwner, Sn = F.ReactDebugCurrentFrame;
    function Oe(t) {
      if (t) {
        var c = t._owner, p = de(t.type, t._source, c ? c.type : null);
        Sn.setExtraStackFrame(p);
      } else
        Sn.setExtraStackFrame(null);
    }
    var an;
    an = !1;
    function on(t) {
      return typeof t == "object" && t !== null && t.$$typeof === n;
    }
    function yn() {
      {
        if (Xe.current) {
          var t = O(Xe.current.type);
          if (t)
            return `

Check the render method of \`` + t + "`.";
        }
        return "";
      }
    }
    function qn(t) {
      return "";
    }
    var Nn = {};
    function gn(t) {
      {
        var c = yn();
        if (!c) {
          var p = typeof t == "string" ? t : t.displayName || t.name;
          p && (c = `

Check the top-level render call using <` + p + ">.");
        }
        return c;
      }
    }
    function hn(t, c) {
      {
        if (!t._store || t._store.validated || t.key != null)
          return;
        t._store.validated = !0;
        var p = gn(c);
        if (Nn[p])
          return;
        Nn[p] = !0;
        var g = "";
        t && t._owner && t._owner !== Xe.current && (g = " It was passed a child from " + O(t._owner.type) + "."), Oe(t), y('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', p, g), Oe(null);
      }
    }
    function jn(t, c) {
      {
        if (typeof t != "object")
          return;
        if (_(t))
          for (var p = 0; p < t.length; p++) {
            var g = t[p];
            on(g) && hn(g, c);
          }
        else if (on(t))
          t._store && (t._store.validated = !0);
        else if (t) {
          var P = j(t);
          if (typeof P == "function" && P !== t.entries)
            for (var L = P.call(t), I; !(I = L.next()).done; )
              on(I.value) && hn(I.value, c);
        }
      }
    }
    function Un(t) {
      {
        var c = t.type;
        if (c == null || typeof c == "string")
          return;
        var p;
        if (typeof c == "function")
          p = c.propTypes;
        else if (typeof c == "object" && (c.$$typeof === d || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        c.$$typeof === f))
          p = c.propTypes;
        else
          return;
        if (p) {
          var g = O(c);
          sn(p, t.props, "prop", g, t);
        } else if (c.PropTypes !== void 0 && !an) {
          an = !0;
          var P = O(c);
          y("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", P || "Unknown");
        }
        typeof c.getDefaultProps == "function" && !c.getDefaultProps.isReactClassApproved && y("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function Vn(t) {
      {
        for (var c = Object.keys(t.props), p = 0; p < c.length; p++) {
          var g = c[p];
          if (g !== "children" && g !== "key") {
            Oe(t), y("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", g), Oe(null);
            break;
          }
        }
        t.ref !== null && (Oe(t), y("Invalid attribute `ref` supplied to `React.Fragment`."), Oe(null));
      }
    }
    var _n = {};
    function xn(t, c, p, g, P, L) {
      {
        var I = ae(t);
        if (!I) {
          var N = "";
          (t === void 0 || typeof t == "object" && t !== null && Object.keys(t).length === 0) && (N += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var te = qn();
          te ? N += te : N += yn();
          var x;
          t === null ? x = "null" : _(t) ? x = "array" : t !== void 0 && t.$$typeof === n ? (x = "<" + (O(t.type) || "Unknown") + " />", N = " Did you accidentally export a JSX literal instead of a component?") : x = typeof t, y("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", x, N);
        }
        var V = kn(t, c, p, P, L);
        if (V == null)
          return V;
        if (I) {
          var X = c.children;
          if (X !== void 0)
            if (g)
              if (_(X)) {
                for (var we = 0; we < X.length; we++)
                  jn(X[we], t);
                Object.freeze && Object.freeze(X);
              } else
                y("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              jn(X, t);
        }
        if (fe.call(c, "key")) {
          var Se = O(t), ne = Object.keys(c).filter(function(wn) {
            return wn !== "key";
          }), nn = ne.length > 0 ? "{key: someKey, " + ne.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!_n[Se + nn]) {
            var Tn = ne.length > 0 ? "{" + ne.join(": ..., ") + ": ...}" : "{}";
            y(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, nn, Se, Tn, Se), _n[Se + nn] = !0;
          }
        }
        return t === i ? Vn(V) : Un(V), V;
      }
    }
    function Hn(t, c, p) {
      return xn(t, c, p, !0);
    }
    function Dn(t, c, p) {
      return xn(t, c, p, !1);
    }
    var Rn = Dn, Mn = Hn;
    wo.Fragment = i, wo.jsx = Rn, wo.jsxs = Mn;
  })()), wo;
}
var Hg;
function kI() {
  return Hg || (Hg = 1, process.env.NODE_ENV === "production" ? Xd.exports = gI() : Xd.exports = vI()), Xd.exports;
}
var ve = kI(), Va = /* @__PURE__ */ ((e) => (e.Outbound = "OUTBOUND", e.Return = "RETURN", e.UnknownDirectionType = "UNKNOWN_DIRECTION_TYPE", e.Unspecified = "UNSPECIFIED", e))(Va || {}), oi = /* @__PURE__ */ ((e) => (e.Delivery = "DELIVERY", e.Instore = "INSTORE", e.Inwarehouse = "INWAREHOUSE", e.Mailbox = "MAILBOX", e.Pickup = "PICKUP", e.Unknown = "UNKNOWN", e))(oi || {}), qt = /* @__PURE__ */ ((e) => (e.StepAwaitingSupplier = "STEP_AWAITING_SUPPLIER", e.StepConfirmedByMerchant = "STEP_CONFIRMED_BY_MERCHANT", e.StepDeliveredToConsumer = "STEP_DELIVERED_TO_CONSUMER", e.StepDeliveredToMerchant = "STEP_DELIVERED_TO_MERCHANT", e.StepDeliveredToPickupPoint = "STEP_DELIVERED_TO_PICKUP_POINT", e.StepLinehaulToCarrier = "STEP_LINEHAUL_TO_CARRIER", e.StepOnRoute = "STEP_ON_ROUTE", e.StepPreparedByMerchant = "STEP_PREPARED_BY_MERCHANT", e.StepReturnRequested = "STEP_RETURN_REQUESTED", e.StepSentBack = "STEP_SENT_BACK", e.StepSubmittedToCarrier = "STEP_SUBMITTED_TO_CARRIER", e.StepTerminated = "STEP_TERMINATED", e.StepUnknown = "STEP_UNKNOWN", e))(qt || {});
const bI = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getOrders" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "email" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "locale" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Ingrid" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "DeliveryTracking_GetTrackingOrders" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "email" }, value: { kind: "Variable", name: { kind: "Name", value: "email" } } }, { kind: "Argument", name: { kind: "Name", value: "locale" }, value: { kind: "Variable", name: { kind: "Name", value: "locale" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Ingrid_GetTrackingOrdersResponse" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "orders" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "analytics_id" } }, { kind: "Field", name: { kind: "Name", value: "external_id" } }, { kind: "Field", name: { kind: "Name", value: "preselected_parcel_index" } }, { kind: "Field", name: { kind: "Name", value: "sender_name" } }, { kind: "Field", name: { kind: "Name", value: "site_name" } }, { kind: "Field", name: { kind: "Name", value: "tos_id" } }, { kind: "Field", name: { kind: "Name", value: "tracking_links" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "links" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "type" } }, { kind: "Field", name: { kind: "Name", value: "url" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "items" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "discount" } }, { kind: "Field", name: { kind: "Name", value: "image" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "quantity" } }, { kind: "Field", name: { kind: "Name", value: "sku" } }, { kind: "Field", name: { kind: "Name", value: "total_price" } }] } }, { kind: "Field", name: { kind: "Name", value: "cart" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "currency" } }, { kind: "Field", name: { kind: "Name", value: "items" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "attributes" } }, { kind: "Field", name: { kind: "Name", value: "cancelled_quantity" } }, { kind: "Field", name: { kind: "Name", value: "cancelled_total_price" } }, { kind: "Field", name: { kind: "Name", value: "discount" } }, { kind: "Field", name: { kind: "Name", value: "image" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "quantity" } }, { kind: "Field", name: { kind: "Name", value: "sku" } }, { kind: "Field", name: { kind: "Name", value: "total_price" } }, { kind: "Field", name: { kind: "Name", value: "variant" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "color" } }, { kind: "Field", name: { kind: "Name", value: "size" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "prices" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "shipping_components" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "discount" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "price" } }] } }, { kind: "Field", name: { kind: "Name", value: "total" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "discount" } }, { kind: "Field", name: { kind: "Name", value: "items_discount" } }, { kind: "Field", name: { kind: "Name", value: "items_price" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "shipping_discount" } }, { kind: "Field", name: { kind: "Name", value: "shipping_price" } }, { kind: "Field", name: { kind: "Name", value: "tax" } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "parcels" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "alerts" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "created_at" } }, { kind: "Field", name: { kind: "Name", value: "type" } }, { kind: "Field", name: { kind: "Name", value: "awaiting_supplier" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "estimated_time" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "earliest" } }, { kind: "Field", name: { kind: "Name", value: "latest" } }] } }, { kind: "Field", name: { kind: "Name", value: "estimated_time_range" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "end" } }, { kind: "Field", name: { kind: "Name", value: "start" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "delivery_attempt_failed" } }, { kind: "Field", name: { kind: "Name", value: "delivery_delayed" } }, { kind: "Field", name: { kind: "Name", value: "delivery_delayed_from_carrier" } }, { kind: "Field", name: { kind: "Name", value: "estimated_delivery_time_updated" } }, { kind: "Field", name: { kind: "Name", value: "linehaul" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "estimated_time" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "earliest" } }, { kind: "Field", name: { kind: "Name", value: "latest" } }] } }, { kind: "Field", name: { kind: "Name", value: "estimated_time_range" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "end" } }, { kind: "Field", name: { kind: "Name", value: "start" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "out_for_delivery" } }, { kind: "Field", name: { kind: "Name", value: "submission_delayed" } }] } }, { kind: "Field", name: { kind: "Name", value: "carrier" } }, { kind: "Field", name: { kind: "Name", value: "carrier_fallback_enabled" } }, { kind: "Field", name: { kind: "Name", value: "carrier_link" } }, { kind: "Field", name: { kind: "Name", value: "carrier_logo_pattern" } }, { kind: "Field", name: { kind: "Name", value: "carrier_product_id" } }, { kind: "Field", name: { kind: "Name", value: "carrier_product_ref" } }, { kind: "Field", name: { kind: "Name", value: "delivery_type" } }, { kind: "Field", name: { kind: "Name", value: "direction_type" } }, { kind: "Field", name: { kind: "Name", value: "display_carrier_name" } }, { kind: "Field", name: { kind: "Name", value: "estimated_delivery_time" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "end" } }, { kind: "Field", name: { kind: "Name", value: "start" } }] } }, { kind: "Field", name: { kind: "Name", value: "exceptions" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "created_at" } }, { kind: "Field", name: { kind: "Name", value: "status" } }] } }, { kind: "Field", name: { kind: "Name", value: "index" } }, { kind: "Field", name: { kind: "Name", value: "line_items" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "currency" } }, { kind: "Field", name: { kind: "Name", value: "discount" } }, { kind: "Field", name: { kind: "Name", value: "image" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "properties" } }, { kind: "Field", name: { kind: "Name", value: "quantity" } }, { kind: "Field", name: { kind: "Name", value: "sku" } }, { kind: "Field", name: { kind: "Name", value: "total_price" } }] } }, { kind: "Field", name: { kind: "Name", value: "location" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "address" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "address_lines" } }, { kind: "Field", name: { kind: "Name", value: "apartment_number" } }, { kind: "Field", name: { kind: "Name", value: "attn" } }, { kind: "Field", name: { kind: "Name", value: "building_name" } }, { kind: "Field", name: { kind: "Name", value: "care_of" } }, { kind: "Field", name: { kind: "Name", value: "city" } }, { kind: "Field", name: { kind: "Name", value: "coordinates" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "lat" } }, { kind: "Field", name: { kind: "Name", value: "lng" } }] } }, { kind: "Field", name: { kind: "Name", value: "country" } }, { kind: "Field", name: { kind: "Name", value: "door_code" } }, { kind: "Field", name: { kind: "Name", value: "floor_number" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "po_box_id" } }, { kind: "Field", name: { kind: "Name", value: "postal_code" } }, { kind: "Field", name: { kind: "Name", value: "region" } }, { kind: "Field", name: { kind: "Name", value: "street" } }, { kind: "Field", name: { kind: "Name", value: "street_number" } }, { kind: "Field", name: { kind: "Name", value: "subregion" } }] } }, { kind: "Field", name: { kind: "Name", value: "location_external_id" } }, { kind: "Field", name: { kind: "Name", value: "location_type" } }, { kind: "Field", name: { kind: "Name", value: "operational_hours" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "free_text" } }, { kind: "Field", name: { kind: "Name", value: "fri" } }, { kind: "Field", name: { kind: "Name", value: "mon" } }, { kind: "Field", name: { kind: "Name", value: "sat" } }, { kind: "Field", name: { kind: "Name", value: "sun" } }, { kind: "Field", name: { kind: "Name", value: "thu" } }, { kind: "Field", name: { kind: "Name", value: "tue" } }, { kind: "Field", name: { kind: "Name", value: "wed" } }] } }, { kind: "Field", name: { kind: "Name", value: "pickup_instructions" } }] } }, { kind: "Field", name: { kind: "Name", value: "progress" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "estimated_time" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "end" } }, { kind: "Field", name: { kind: "Name", value: "start" } }] } }, { kind: "Field", name: { kind: "Name", value: "step" } }, { kind: "Field", name: { kind: "Name", value: "time" } }] } }, { kind: "Field", name: { kind: "Name", value: "requested_shipping_method" } }, { kind: "Field", name: { kind: "Name", value: "sender_name" } }, { kind: "Field", name: { kind: "Name", value: "tracking_link" } }, { kind: "Field", name: { kind: "Name", value: "tracking_number" } }] } }] } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Ingrid_Error" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "details" } }, { kind: "Field", name: { kind: "Name", value: "message" } }] } }] } }] } }] } }] }, _I = {
  "\n  query getOrders($email: String!, $locale: String!) {\n    Ingrid {\n      DeliveryTracking_GetTrackingOrders(\n        email: $email\n        locale: $locale\n      ) {\n        ... on Ingrid_GetTrackingOrdersResponse {\n          orders {\n            analytics_id\n            external_id\n            preselected_parcel_index\n            sender_name\n            site_name\n            tos_id\n            tracking_links {\n              links {\n                type\n                url\n              }\n            }\n            items {\n              discount\n              image\n              name\n              price\n              quantity\n              sku\n              total_price\n            }\n            cart {\n              currency\n              items {\n                attributes\n                cancelled_quantity\n                cancelled_total_price\n                discount\n                image\n                name\n                price\n                quantity\n                sku\n                total_price\n                variant {\n                  color\n                  size\n                }\n              }\n              prices {\n                shipping_components {\n                  discount\n                  name\n                  price\n                }\n                total {\n                  discount\n                  items_discount\n                  items_price\n                  price\n                  shipping_discount\n                  shipping_price\n                  tax\n                }\n              }\n            }\n            parcels {\n              alerts {\n                created_at\n                type\n                awaiting_supplier {\n                  estimated_time {\n                    earliest\n                    latest\n                  }\n                  estimated_time_range {\n                    end\n                    start\n                  }\n                }\n                delivery_attempt_failed\n                delivery_delayed\n                delivery_delayed_from_carrier\n                estimated_delivery_time_updated\n                linehaul {\n                  estimated_time {\n                    earliest\n                    latest\n                  }\n                  estimated_time_range {\n                    end\n                    start\n                  }\n                }\n                out_for_delivery\n                submission_delayed\n              }\n              carrier\n              carrier_fallback_enabled\n              carrier_link\n              carrier_logo_pattern\n              carrier_product_id\n              carrier_product_ref\n              delivery_type\n              direction_type\n              display_carrier_name\n              estimated_delivery_time {\n                end\n                start\n              }\n              exceptions {\n                created_at\n                status\n              }\n              index\n              line_items {\n                currency\n                discount\n                image\n                name\n                price\n                properties\n                quantity\n                sku\n                total_price\n              }\n              location {\n                address {\n                  address_lines\n                  apartment_number\n                  attn\n                  building_name\n                  care_of\n                  city\n                  coordinates {\n                    lat\n                    lng\n                  }\n                  country\n                  door_code\n                  floor_number\n                  name\n                  po_box_id\n                  postal_code\n                  region\n                  street\n                  street_number\n                  subregion\n                }\n                location_external_id\n                location_type\n                operational_hours {\n                  free_text\n                  fri\n                  mon\n                  sat\n                  sun\n                  thu\n                  tue\n                  wed\n                }\n                pickup_instructions\n              }\n              progress {\n                estimated_time {\n                  end\n                  start\n                }\n                step\n                time\n              }\n              requested_shipping_method\n              sender_name\n              tracking_link\n              tracking_number\n            }\n          }\n        }\n\n        ... on Ingrid_Error {\n          code\n          details\n          message\n        }\n      }\n    }\n  }\n": bI
};
function xI(e) {
  return _I[e] ?? {};
}
const SI = xI(
  /* GraphQL */
  `
  query getOrders($email: String!, $locale: String!) {
    Ingrid {
      DeliveryTracking_GetTrackingOrders(
        email: $email
        locale: $locale
      ) {
        ... on Ingrid_GetTrackingOrdersResponse {
          orders {
            analytics_id
            external_id
            preselected_parcel_index
            sender_name
            site_name
            tos_id
            tracking_links {
              links {
                type
                url
              }
            }
            items {
              discount
              image
              name
              price
              quantity
              sku
              total_price
            }
            cart {
              currency
              items {
                attributes
                cancelled_quantity
                cancelled_total_price
                discount
                image
                name
                price
                quantity
                sku
                total_price
                variant {
                  color
                  size
                }
              }
              prices {
                shipping_components {
                  discount
                  name
                  price
                }
                total {
                  discount
                  items_discount
                  items_price
                  price
                  shipping_discount
                  shipping_price
                  tax
                }
              }
            }
            parcels {
              alerts {
                created_at
                type
                awaiting_supplier {
                  estimated_time {
                    earliest
                    latest
                  }
                  estimated_time_range {
                    end
                    start
                  }
                }
                delivery_attempt_failed
                delivery_delayed
                delivery_delayed_from_carrier
                estimated_delivery_time_updated
                linehaul {
                  estimated_time {
                    earliest
                    latest
                  }
                  estimated_time_range {
                    end
                    start
                  }
                }
                out_for_delivery
                submission_delayed
              }
              carrier
              carrier_fallback_enabled
              carrier_link
              carrier_logo_pattern
              carrier_product_id
              carrier_product_ref
              delivery_type
              direction_type
              display_carrier_name
              estimated_delivery_time {
                end
                start
              }
              exceptions {
                created_at
                status
              }
              index
              line_items {
                currency
                discount
                image
                name
                price
                properties
                quantity
                sku
                total_price
              }
              location {
                address {
                  address_lines
                  apartment_number
                  attn
                  building_name
                  care_of
                  city
                  coordinates {
                    lat
                    lng
                  }
                  country
                  door_code
                  floor_number
                  name
                  po_box_id
                  postal_code
                  region
                  street
                  street_number
                  subregion
                }
                location_external_id
                location_type
                operational_hours {
                  free_text
                  fri
                  mon
                  sat
                  sun
                  thu
                  tue
                  wed
                }
                pickup_instructions
              }
              progress {
                estimated_time {
                  end
                  start
                }
                step
                time
              }
              requested_shipping_method
              sender_name
              tracking_link
              tracking_number
            }
          }
        }

        ... on Ingrid_Error {
          code
          details
          message
        }
      }
    }
  }
`
), Wg = (e) => {
  if (!e) return "";
  try {
    return new Intl.DateTimeFormat(void 0, {
      dateStyle: "medium",
      timeStyle: "short"
    }).format(new Date(e));
  } catch {
    return e;
  }
}, ix = (e, n) => {
  try {
    return new Intl.NumberFormat(void 0, {
      style: "currency",
      currency: n
    }).format(e);
  } catch {
    return e.toString();
  }
}, NI = "_listItem_16pij_4", jI = "_clickableIcon_16pij_15", no = {
  listItem: NI,
  clickableIcon: jI
}, ax = ({
  items: e,
  title: n,
  currency: r,
  openByDefault: i = !1
}) => {
  const [a, o] = se(i);
  return !e || e.length === 0 ? null : /* @__PURE__ */ ve.jsx(b, { gap: "100", flexDirection: "column", children: /* @__PURE__ */ ve.jsxs(b, { gap: "250", flexDirection: "column", children: [
    /* @__PURE__ */ ve.jsxs(b, { gap: "250", flexDirection: "row", children: [
      /* @__PURE__ */ ve.jsx(me, { size: 14, name: "list-ul", color: "blue.900" }),
      /* @__PURE__ */ ve.jsx(b, { gap: "200", flexDirection: "column", children: /* @__PURE__ */ ve.jsxs(
        b,
        {
          gap: "100",
          flexDirection: "row",
          onClick: () => o(!a),
          className: no.clickableIcon,
          alignItems: "center",
          children: [
            /* @__PURE__ */ ve.jsx(A.Paragraph, { variant: "3", children: n }),
            /* @__PURE__ */ ve.jsx(
              me,
              {
                size: 14,
                name: a ? "angle-down" : "angle-right"
              }
            )
          ]
        }
      ) })
    ] }),
    a && /* @__PURE__ */ ve.jsx(Ke, { children: e.map((l, d) => {
      if (!l) return null;
      const { name: m, quantity: u, price: f, image: h, sku: v } = l, C = l.currency ?? r;
      return /* @__PURE__ */ ve.jsx(
        Ke.Item,
        {
          contentLeft: /* @__PURE__ */ ve.jsxs(b, { gap: "200", children: [
            /* @__PURE__ */ ve.jsx(A.Paragraph, { children: u }),
            /* @__PURE__ */ ve.jsx(A.Paragraph, { children: "×" })
          ] }),
          title: /* @__PURE__ */ ve.jsxs(b, { flexDirection: "column", gap: "050", children: [
            /* @__PURE__ */ ve.jsx(A.Paragraph, { variant: "4", children: m }),
            f != null && /* @__PURE__ */ ve.jsx(A.Paragraph, { variant: "4", color: "tertiary", children: ix(f / 100, C) })
          ] }),
          contentRight: h && /* @__PURE__ */ ve.jsx(Wi, { src: h, alt: m ?? "Product image" }),
          className: no.listItem
        },
        `item-${d}-${v}`
      );
    }) })
  ] }) });
}, wI = "_boxWrapper_89s7l_1", CI = "_trackButton_89s7l_10", Kg = {
  boxWrapper: wI,
  trackButton: CI
}, FI = {
  [qt.StepUnknown]: "Unknown",
  [qt.StepConfirmedByMerchant]: "Confirmed by merchant",
  [qt.StepPreparedByMerchant]: "Prepared by merchant",
  [qt.StepSubmittedToCarrier]: "Submitted to carrier",
  [qt.StepLinehaulToCarrier]: "Linehaul to carrier",
  [qt.StepOnRoute]: "On route",
  [qt.StepDeliveredToPickupPoint]: "At pickup point",
  [qt.StepDeliveredToConsumer]: "Delivered to customer",
  [qt.StepDeliveredToMerchant]: "Returned to merchant",
  [qt.StepReturnRequested]: "Return requested",
  [qt.StepSentBack]: "Sent back",
  [qt.StepTerminated]: "Terminated",
  [qt.StepAwaitingSupplier]: "Awaiting supplier"
}, II = {
  [oi.Delivery]: "Home delivery",
  [oi.Pickup]: "Pickup point",
  [oi.Instore]: "In-store pickup",
  [oi.Mailbox]: "Mailbox",
  [oi.Inwarehouse]: "Warehouse",
  [oi.Unknown]: "Unknown"
}, EI = {
  [Va.Outbound]: "From merchant to customer",
  [Va.Return]: "Return from customer to merchant",
  [Va.Unspecified]: "Unspecified",
  [Va.UnknownDirectionType]: "Unknown"
}, TI = (e) => e ? FI[e] ?? e : "", $I = (e) => e ? II[e] ?? e : "", DI = (e) => e ? EI[e] ?? e : "", RI = (e) => {
  if (!e) return null;
  const n = [e.street, e.street_number].filter(Boolean).join(" ");
  return [
    e.name,
    n,
    e.postal_code,
    e.city,
    e.country
  ].filter(Boolean).join(`
`);
}, OI = ({
  parcel: e
}) => {
  const { isCopied: n, copy: r } = nr();
  if (!e)
    return null;
  const {
    carrier: i,
    progress: a,
    tracking_number: o,
    line_items: s,
    carrier_product_ref: l,
    carrier_link: d,
    display_carrier_name: m,
    delivery_type: u,
    direction_type: f,
    estimated_delivery_time: h
  } = e, v = m || l || i, C = a?.filter((T) => T?.time !== ""), S = TI(C?.[0]?.step), j = $I(u), F = DI(f), y = RI(e.location?.address), q = 14;
  return /* @__PURE__ */ ve.jsxs(
    b,
    {
      gap: "300",
      flexDirection: "column",
      padding: "250",
      className: Kg.boxWrapper,
      children: [
        /* @__PURE__ */ ve.jsx(A.Heading, { variant: "heading-4", children: v }),
        /* @__PURE__ */ ve.jsxs(b, { justifyContent: "space-between", children: [
          /* @__PURE__ */ ve.jsxs(b, { gap: "250", flexDirection: "row", children: [
            /* @__PURE__ */ ve.jsx(
              me,
              {
                size: q,
                name: "magnifying-glass-chart",
                color: "blue.900"
              }
            ),
            /* @__PURE__ */ ve.jsxs(b, { gap: "100", flexDirection: "column", children: [
              /* @__PURE__ */ ve.jsx(A.Paragraph, { variant: "3", children: "Carrier tracking ID" }),
              /* @__PURE__ */ ve.jsxs(b, { gap: "100", flexDirection: "row", flexWrap: "wrap", children: [
                !o && /* @__PURE__ */ ve.jsx(A.Paragraph, { variant: "4", color: "tertiary", children: "No tracking ID here yet" }),
                o && /* @__PURE__ */ ve.jsx(A.Paragraph, { variant: "4", color: "secondary", children: o })
              ] })
            ] })
          ] }),
          o && /* @__PURE__ */ ve.jsx(b, { flexDirection: "row", children: /* @__PURE__ */ ve.jsx(Ge, { content: "Copy tracking ID", children: /* @__PURE__ */ ve.jsx(
            me,
            {
              size: q,
              name: n ? "done" : "copy",
              className: no.clickableIcon,
              onClick: () => r(o)
            }
          ) }) })
        ] }),
        S && /* @__PURE__ */ ve.jsxs(b, { gap: "250", flexDirection: "row", children: [
          /* @__PURE__ */ ve.jsx(me, { size: q, name: "chart-donut", color: "blue.900" }),
          /* @__PURE__ */ ve.jsxs(b, { gap: "100", flexDirection: "column", children: [
            /* @__PURE__ */ ve.jsx(A.Paragraph, { variant: "3", children: "Status" }),
            /* @__PURE__ */ ve.jsx(A.Paragraph, { variant: "4", color: "secondary", children: S })
          ] })
        ] }),
        F && /* @__PURE__ */ ve.jsxs(b, { gap: "250", flexDirection: "row", children: [
          /* @__PURE__ */ ve.jsx(me, { size: q, name: "arrow-right", color: "blue.900" }),
          /* @__PURE__ */ ve.jsxs(b, { gap: "100", flexDirection: "column", children: [
            /* @__PURE__ */ ve.jsx(A.Paragraph, { variant: "3", children: "Direction" }),
            /* @__PURE__ */ ve.jsx(A.Paragraph, { variant: "4", color: "secondary", children: F })
          ] })
        ] }),
        h && /* @__PURE__ */ ve.jsxs(b, { gap: "250", flexDirection: "row", children: [
          /* @__PURE__ */ ve.jsx(me, { size: q, name: "calendar", color: "blue.900" }),
          /* @__PURE__ */ ve.jsxs(b, { gap: "100", flexDirection: "column", children: [
            /* @__PURE__ */ ve.jsx(A.Paragraph, { variant: "3", children: "Estimated delivery" }),
            /* @__PURE__ */ ve.jsxs(A.Paragraph, { variant: "4", color: "secondary", children: [
              Wg(h.start),
              " ",
              h.end && " until"
            ] }),
            h.end && /* @__PURE__ */ ve.jsx(A.Paragraph, { variant: "4", color: "secondary", children: Wg(h.end) })
          ] })
        ] }),
        u && /* @__PURE__ */ ve.jsxs(b, { gap: "250", flexDirection: "row", children: [
          /* @__PURE__ */ ve.jsx(me, { size: q, name: "info", color: "blue.900" }),
          /* @__PURE__ */ ve.jsxs(b, { gap: "100", flexDirection: "column", children: [
            /* @__PURE__ */ ve.jsx(A.Paragraph, { variant: "3", children: "Delivery type" }),
            /* @__PURE__ */ ve.jsx(A.Paragraph, { variant: "4", color: "secondary", children: j })
          ] })
        ] }),
        y && /* @__PURE__ */ ve.jsxs(b, { gap: "250", flexDirection: "row", children: [
          /* @__PURE__ */ ve.jsx(me, { size: q, name: "map-pin", color: "blue.900" }),
          /* @__PURE__ */ ve.jsxs(b, { gap: "100", flexDirection: "column", children: [
            /* @__PURE__ */ ve.jsx(A.Paragraph, { variant: "3", children: "Pickup location" }),
            /* @__PURE__ */ ve.jsx(A.Paragraph, { variant: "4", color: "secondary", children: y })
          ] })
        ] }),
        /* @__PURE__ */ ve.jsx(ax, { title: "Parcel items", items: s }),
        d && /* @__PURE__ */ ve.jsxs(
          jt,
          {
            variant: "secondary",
            className: Kg.trackButton,
            navigate: () => window.open(d, "_blank")?.focus(),
            slotStart: /* @__PURE__ */ ve.jsx(me, { name: "external-link" }),
            children: [
              "Track on ",
              v ?? "carrier",
              " website"
            ]
          }
        )
      ]
    }
  );
}, PI = "_order_135ze_1", AI = "_orderIsOpen_135ze_9", LI = "_orderHeader_135ze_12", Zd = {
  order: PI,
  orderIsOpen: AI,
  orderHeader: LI
}, Gg = "No order number found", VI = ({
  order: e,
  openByDefault: n
}) => {
  const [r, i] = se(n), { isCopied: a, copy: o } = nr(), { isCopied: s, copy: l } = nr();
  if (!e)
    return null;
  const { cart: d, parcels: m, sender_name: u, tos_id: f } = e, h = e.external_id?.trim(), v = d?.currency || "", C = d?.prices?.total?.price ?? 0, S = ix(C / 100, v), j = 14, F = u && u.trim() !== "" ? u : "unknown sender";
  return /* @__PURE__ */ ve.jsxs(
    b,
    {
      className: rt(Zd.order, {
        [Zd.orderIsOpen]: r
      }),
      gap: "300",
      flexDirection: "column",
      children: [
        /* @__PURE__ */ ve.jsxs(
          b,
          {
            justifyContent: "space-between",
            alignItems: "center",
            className: Zd.orderHeader,
            onClick: () => i(!r),
            children: [
              /* @__PURE__ */ ve.jsxs(b, { gap: "100", flexDirection: "column", children: [
                /* @__PURE__ */ ve.jsxs(A.Paragraph, { variant: "4", children: [
                  "From ",
                  F
                ] }),
                h ? /* @__PURE__ */ ve.jsx(A.Paragraph, { variant: "3", children: /* @__PURE__ */ ve.jsxs("span", { children: [
                  "#",
                  h
                ] }) }) : /* @__PURE__ */ ve.jsx(A.Paragraph, { variant: "4", color: "tertiary", children: Gg })
              ] }),
              /* @__PURE__ */ ve.jsx(
                Qt,
                {
                  variant: "tertiary",
                  icon: r ? "angle-down" : "angle-right"
                }
              )
            ]
          }
        ),
        r && /* @__PURE__ */ ve.jsxs(b, { gap: "250", flexDirection: "column", margin: "200 0 0", children: [
          /* @__PURE__ */ ve.jsxs(b, { justifyContent: "space-between", children: [
            /* @__PURE__ */ ve.jsxs(b, { gap: "250", flexDirection: "row", children: [
              /* @__PURE__ */ ve.jsx(me, { size: j, name: "tag", color: "blue.900" }),
              /* @__PURE__ */ ve.jsxs(b, { gap: "100", flexDirection: "column", children: [
                /* @__PURE__ */ ve.jsx(A.Paragraph, { variant: "3", children: "Order number" }),
                /* @__PURE__ */ ve.jsx(b, { gap: "100", flexDirection: "row", flexWrap: "wrap", children: h ? /* @__PURE__ */ ve.jsx(A.Paragraph, { variant: "4", color: "secondary", children: h }) : /* @__PURE__ */ ve.jsx(A.Paragraph, { variant: "4", color: "tertiary", children: Gg }) })
              ] })
            ] }),
            h && /* @__PURE__ */ ve.jsx(b, { flexDirection: "row", children: /* @__PURE__ */ ve.jsx(Ge, { content: "Copy order number", children: /* @__PURE__ */ ve.jsx(
              me,
              {
                size: j,
                name: s ? "done" : "copy",
                className: no.clickableIcon,
                onClick: () => l(h)
              }
            ) }) })
          ] }),
          /* @__PURE__ */ ve.jsxs(b, { justifyContent: "space-between", children: [
            /* @__PURE__ */ ve.jsxs(b, { gap: "250", flexDirection: "row", children: [
              /* @__PURE__ */ ve.jsx(
                me,
                {
                  size: j,
                  name: "magnifying-glass-chart",
                  color: "blue.900"
                }
              ),
              /* @__PURE__ */ ve.jsxs(b, { gap: "100", flexDirection: "column", children: [
                /* @__PURE__ */ ve.jsx(A.Paragraph, { variant: "3", children: "Ingrid tracking ID" }),
                /* @__PURE__ */ ve.jsxs(b, { gap: "100", flexDirection: "row", flexWrap: "wrap", children: [
                  !f && /* @__PURE__ */ ve.jsx(A.Paragraph, { variant: "4", color: "tertiary", children: "No tracking ID here yet" }),
                  f && /* @__PURE__ */ ve.jsx(A.Paragraph, { variant: "4", color: "secondary", children: f })
                ] })
              ] })
            ] }),
            f && /* @__PURE__ */ ve.jsx(b, { flexDirection: "row", children: /* @__PURE__ */ ve.jsx(Ge, { content: "Copy tracking ID", children: /* @__PURE__ */ ve.jsx(
              me,
              {
                size: j,
                name: a ? "done" : "copy",
                className: no.clickableIcon,
                onClick: () => o(f)
              }
            ) }) })
          ] }),
          u && /* @__PURE__ */ ve.jsxs(b, { gap: "250", flexDirection: "row", children: [
            /* @__PURE__ */ ve.jsx(me, { size: 14, name: "user", color: "blue.900" }),
            /* @__PURE__ */ ve.jsxs(b, { gap: "100", flexDirection: "column", children: [
              /* @__PURE__ */ ve.jsx(A.Paragraph, { variant: "3", children: "Sender" }),
              /* @__PURE__ */ ve.jsx(A.Paragraph, { variant: "4", children: u })
            ] })
          ] }),
          /* @__PURE__ */ ve.jsxs(b, { gap: "250", flexDirection: "row", children: [
            /* @__PURE__ */ ve.jsx(me, { size: 14, name: "chart-bar", color: "blue.900" }),
            /* @__PURE__ */ ve.jsxs(b, { gap: "100", flexDirection: "column", children: [
              /* @__PURE__ */ ve.jsx(A.Paragraph, { variant: "3", children: "Order value" }),
              /* @__PURE__ */ ve.jsx(A.Paragraph, { variant: "4", children: S })
            ] })
          ] }),
          /* @__PURE__ */ ve.jsx(
            ax,
            {
              openByDefault: !0,
              title: "Order items",
              items: d?.items?.map((y) => y),
              currency: d?.currency
            }
          ),
          m && /* @__PURE__ */ ve.jsxs(b, { gap: "200", flexDirection: "column", margin: "0 0 100 0", children: [
            /* @__PURE__ */ ve.jsxs(b, { gap: "200", flexDirection: "row", alignItems: "center", children: [
              /* @__PURE__ */ ve.jsx(A.Heading, { variant: "heading-4", children: "Parcels" }),
              m.length > 0 && /* @__PURE__ */ ve.jsx(Pn, { variant: "success", size: "small", children: m.length })
            ] }),
            m.length === 0 && /* @__PURE__ */ ve.jsx(A.Paragraph, { variant: "4", color: "secondary", children: "No parcels here" }),
            m.map((y, q) => /* @__PURE__ */ ve.jsx(
              OI,
              {
                parcel: y
              },
              `parcel-${q}-${y?.tracking_number}`
            ))
          ] })
        ] })
      ]
    }
  );
}, zI = (e) => {
  const n = [], r = /* @__PURE__ */ new Map();
  for (const i of e) {
    if (!i?.external_id) {
      n.push(i);
      continue;
    }
    const a = r.get(i.external_id);
    if (a)
      a.parcels = [
        ...a.parcels ?? [],
        ...i.parcels ?? []
      ];
    else {
      const o = { ...i };
      r.set(i.external_id, o), n.push(o);
    }
  }
  return n;
}, UI = ({
  customerEmail: e
}) => {
  const { useQuery: n } = mn(), [r, i] = se([]), a = !e, { data: o, loading: s, error: l } = n(SI, {
    skip: a,
    variables: {
      email: e,
      locale: "en-GB"
    }
  }), d = !s && r.length > 0, m = l ? QS({
    error: l.graphQLErrors?.[0]
  }) : !1, u = l ? Tb({
    error: l.graphQLErrors?.[0]
  }) : !1;
  return He(() => {
    const f = o?.Ingrid?.DeliveryTracking_GetTrackingOrders;
    f?.orders && i(zI(f.orders));
  }, [o?.Ingrid?.DeliveryTracking_GetTrackingOrders]), s ? /* @__PURE__ */ ve.jsx(b, { justifyContent: "center", children: /* @__PURE__ */ ve.jsx(cn, {}) }) : m || !d && !l ? /* @__PURE__ */ ve.jsx(A.Paragraph, { color: "tertiary", align: "center", children: "No orders to track" }) : u ? /* @__PURE__ */ ve.jsx(A.Paragraph, { color: "tertiary", align: "center", children: "The API token used for the integration does not have the necessary access rights. Please contact your administrator." }) : l ? /* @__PURE__ */ ve.jsx(Fn, { error: l }) : /* @__PURE__ */ ve.jsxs(b, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ ve.jsxs(b, { gap: "200", flexDirection: "row", alignItems: "center", children: [
      /* @__PURE__ */ ve.jsx(A.Heading, { variant: "heading-3", children: "Orders" }),
      /* @__PURE__ */ ve.jsx(Pn, { variant: "success", size: "small", children: r.length })
    ] }),
    /* @__PURE__ */ ve.jsx(b, { gap: "200", flexDirection: "column", children: /* @__PURE__ */ ve.jsx(b, { gap: "200", flexDirection: "column", children: r.map((f, h) => /* @__PURE__ */ ve.jsx(
      VI,
      {
        order: f,
        openByDefault: h === 0
      },
      `${h}-${f?.tos_id}`
    )) }) })
  ] });
}, MI = ({ conversationContext: e }) => {
  const n = e?.customer?.email;
  return /* @__PURE__ */ ve.jsx(
    b,
    {
      gap: "300",
      flexDirection: "column",
      margin: "200 0 300",
      "data-testid": "widget-wrapper",
      children: /* @__PURE__ */ ve.jsx(UI, { customerEmail: n })
    }
  );
}, BI = [
  {
    key: "ingridUseStagingEnvironment",
    label: "Use Ingrid staging environment",
    required: !0,
    secret: !1,
    type: "switch",
    defaultValue: !1
  },
  {
    key: "ingridSiteId",
    label: "Site ID",
    placeholder: "Site ID from Ingrid",
    required: !0,
    secret: !1,
    type: "input"
  },
  {
    key: "ingridApiToken",
    label: "API token",
    placeholder: "API token from Ingrid",
    required: !0,
    secret: !0,
    type: "input"
  }
], Yg = [
  {
    key: "ingridUseStagingEnvironment",
    type: "boolean",
    secret: !1,
    defaultValue: !1
  },
  {
    key: "ingridSiteId",
    type: "string",
    secret: !1,
    defaultValue: ""
  },
  {
    key: "ingridApiToken",
    type: "string",
    secret: !0,
    defaultValue: ""
  }
], qI = {
  enabled: !1,
  name: "",
  ingridSiteId: "",
  ingridApiToken: "",
  ingridUseStagingEnvironment: !1
}, HI = ({
  integrationId: e,
  handleRedirect: n,
  showNotification: r,
  automationCouplingState: i
}) => {
  const a = !e, o = Bt({
    mode: "onChange",
    defaultValues: qI
  }), {
    create: s,
    update: l,
    remove: d,
    isLoading: m,
    error: u,
    misconfigurationCause: f,
    setMisconfigurationCause: h
  } = Tm({
    integrationId: e,
    integrationType: "INGRID",
    handleRedirect: n,
    showNotification: r
  }), {
    isLoading: v,
    error: C,
    isWidgetUnknown: S,
    refetch: j
  } = $m({
    integrationId: e,
    fieldDefinitions: Yg,
    form: o,
    onMisconfigured: h
  }), F = (q) => Rm(q, {
    fieldDefinitions: Yg,
    isCreationMode: a,
    create: s,
    update: l
  }), y = o.watch("name");
  return /* @__PURE__ */ ve.jsxs(
    Dm,
    {
      form: o,
      integrationId: e,
      onValidSubmit: F,
      error: C ?? u,
      onRetry: C ? j : void 0,
      isLoading: m || v,
      isWidgetUnknown: S,
      children: [
        f && /* @__PURE__ */ ve.jsx(Om, { cause: f }),
        /* @__PURE__ */ ve.jsxs(vt, { children: [
          /* @__PURE__ */ ve.jsx(ze, { children: /* @__PURE__ */ ve.jsx(En, { label: "Show the widget in the conversation sidebar", children: /* @__PURE__ */ ve.jsx(
            sr,
            {
              name: "enabled",
              control: o.control
            }
          ) }) }),
          /* @__PURE__ */ ve.jsx(ze, { span: 3, children: /* @__PURE__ */ ve.jsx(
            gt,
            {
              name: "name",
              label: "Widget name",
              control: o.control,
              rules: { required: "Name is required" },
              componentProps: {
                placeholder: "Insert the name of the widget",
                autoComplete: "off"
              }
            }
          ) }),
          /* @__PURE__ */ ve.jsx(ze, { span: 3 }),
          /* @__PURE__ */ ve.jsx(ze, { span: 3, children: /* @__PURE__ */ ve.jsx(En, { label: "Use Ingrid staging environment", children: /* @__PURE__ */ ve.jsx(
            sr,
            {
              name: "ingridUseStagingEnvironment",
              control: o.control
            }
          ) }) }),
          /* @__PURE__ */ ve.jsx(ze, { span: 3 }),
          /* @__PURE__ */ ve.jsx(ze, { span: 3, children: /* @__PURE__ */ ve.jsx(
            gt,
            {
              name: "ingridSiteId",
              label: "Site ID",
              control: o.control,
              rules: { required: "Site ID is required" },
              componentProps: {
                placeholder: "Site ID from Ingrid",
                autoComplete: "off"
              }
            }
          ) }),
          /* @__PURE__ */ ve.jsx(ze, { span: 3 }),
          /* @__PURE__ */ ve.jsx(ze, { span: 3, children: /* @__PURE__ */ ve.jsx(
            Eb,
            {
              name: "ingridApiToken",
              label: "API token",
              control: o.control,
              isCreationMode: a,
              rules: { required: "API token is required" },
              componentProps: {
                placeholder: "API token from Ingrid",
                autoComplete: "off"
              }
            }
          ) }),
          /* @__PURE__ */ ve.jsx(ze, { span: 3 })
        ] }),
        /* @__PURE__ */ ve.jsx(
          Pm,
          {
            integrationType: "INGRID",
            integrationId: e,
            widgetName: y,
            isCreationMode: a,
            isSubmitting: o.formState.isSubmitting,
            automationCouplingState: i,
            onConfirmDelete: () => d()
          }
        )
      ]
    }
  );
};
(function() {
  try {
    if (typeof document < "u") {
      var e = document.createElement("style");
      e.appendChild(document.createTextNode("._jiraCode_h30p6_1{padding:2px 4px;font-size:100%;font-family:var(--dixa-typography-family-code);color:var(--dixa-typography-color-primary);border-radius:4px}._jiraCodeInline_h30p6_8{background-color:var(--dixa-color-neutral-200)}._collapse_m2gjh_1{border:1px solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);font-size:var(--dixa-typography-size-200);line-height:var(--dixa-typography-line-height-200);padding:0}._collapseHeader_m2gjh_10>div{padding:var(--dixa-size-spacer-300) 0!important}._collapseHeader_m2gjh_10>div>div>p{white-space:unset!important}._collapseHeader_m2gjh_10>div:first-child{width:100%}._collapseHeader_m2gjh_10>div:first-child div:first-child{width:100%}._collapseHeader_m2gjh_10>div:first-child div:first-child p{width:calc(100% - 20px)}._collapseHeader_m2gjh_10{background-color:transparent!important;padding:0 var(--dixa-size-spacer-300) 0 0;letter-spacing:-.08px;color:var(--dixa-color-neutral-500)}._collapseHeaderLink_m2gjh_31{font-size:var(--dixa-typography-size-200);line-height:var(--dixa-typography-line-height-200);color:var(--dixa-typography-color-link);text-decoration:none}._collapseHeaderLink_m2gjh_31:hover{text-decoration:underline}._collapseHeaderStatus_m2gjh_40{font-size:var(--dixa-typography-size-200);line-height:var(--dixa-typography-line-height-200);color:var(--dixa-color-neutral-500);float:right}._collapseHeaderIcon_m2gjh_46{padding-top:.35em;transform:scale(1.4);margin-left:var(--dixa-size-spacer-100)}._collapseHeaderTitle_m2gjh_51{font-weight:var(--dixa-typography-weight-semibold);font-size:var(--dixa-typography-size-300);line-height:var(--dixa-typography-line-height-300);letter-spacing:-.16px;color:var(--dixa-typography-color-primary);width:100%}._collapseContent_m2gjh_59{padding:var(--dixa-size-spacer-200) var(--dixa-size-spacer-300)!important}._collapseContentHeadline_m2gjh_62{font-weight:var(--dixa-typography-weight-semibold);font-size:var(--dixa-typography-size-100);line-height:var(--dixa-typography-line-height-200);color:var(--dixa-typography-color-tertiary)}._collapseContentButtonSpacer_m2gjh_68{margin-top:var(--dixa-size-spacer-250)}._collapseContentButtonLink_m2gjh_71{color:var(--dixa-typography-color-link)}._collapseContentStatusTag_m2gjh_74{max-width:10em}._collapseContentDescription_m2gjh_77{max-height:75vh;overflow-y:auto}._result_axxxc_48{padding:0 var(--dixa-size-spacer-200);margin:0;outline:0;border:0;color:var(--dixa-typography-color-primary);background-color:var(--dixa-color-neutral-000);box-sizing:border-box;display:flex;align-items:center;position:relative;font-size:12px;line-height:32px;height:48px;width:100%;cursor:pointer}._result_axxxc_48:hover,._result_axxxc_48:focus{background-color:var(--dixa-color-neutral-100)}._resultName_axxxc_68{width:100%;text-align:left;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;font-weight:var(--dixa-typography-weight-semibold)}._resultNameIcon_axxxc_76{height:var(--dixa-typography-line-height-200);padding-right:var(--dixa-size-spacer-100);margin-top:-2px}._resultDescription_axxxc_81{width:100%;text-align:left;font-size:var(--dixa-typography-size-200);line-height:var(--dixa-typography-line-height-200);color:var(--dixa-typography-color-secondary);white-space:nowrap;overflow:hidden;text-overflow:ellipsis;margin-top:-.5em;margin-bottom:.5em}._resultLinkIcon_axxxc_93{position:absolute;right:5px;background-color:var(--dixa-color-neutral-000);border:1px solid var(--dixa-color-neutral-300);border-radius:5px;color:var(--dixa-color-neutral-500)}._tooltip_axxxc_102{width:500px;max-height:60vh;overflow:hidden;text-overflow:ellipsis}._tooltipContent_axxxc_108{display:flex;flex-direction:column;width:100%;max-height:60vh;max-height:60dvh}._tooltipName_axxxc_115{text-align:left;white-space:nowrap;font-weight:var(--dixa-typography-weight-semibold)}._tooltipNameIcon_axxxc_120{height:var(--dixa-typography-line-height-300);padding-right:var(--dixa-size-spacer-100);margin-top:-2px}._tooltipDescription_axxxc_125{padding-top:.5em;width:100%;text-align:left;color:var(--dixa-typography-color-secondary);flex-grow:1;overflow-y:auto}._tooltipSummary_axxxc_133{padding-top:.5em;font-weight:var(--dixa-typography-weight-semibold)}._tooltipTag_axxxc_137{width:fit-content;max-width:15em}._itemButton_1hl53_1{border:none;padding:0}._result_1hl53_6{padding:0 var(--dixa-size-spacer-200);margin:0;outline:0;border:0;color:var(--dixa-typography-color-primary);background-color:var(--dixa-color-neutral-000);box-sizing:border-box;display:flex;align-items:center;position:relative;font-size:var(--dixa-typography-size-200);line-height:32px;height:48px;width:100%;cursor:pointer}._result_1hl53_6:hover,._result_1hl53_6:focus{background-color:var(--dixa-color-neutral-100)}._resultIcon_1hl53_26{height:var(--dixa-size-spacer-400);padding-right:var(--dixa-size-spacer-250)}._resultName_1hl53_30{width:100%;text-align:left;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;font-weight:var(--dixa-typography-weight-semibold)}._resultCheckIcon_1hl53_38{height:var(--dixa-size-spacer-400)}._modalBody_1hk1o_1{width:600px}._modalBodyFormFields_1hk1o_4{display:grid;gap:var(--dixa-size-spacer-300) var(--dixa-size-spacer-400)}._wrapper_1bylq_1{gap:var(--dixa-size-spacer-250);margin-bottom:var(--dixa-size-spacer-300)}._inputWrapper_1bylq_6{background-color:var(--dixa-color-neutral-100);border-radius:var(--dixa-size-border-radius-100);margin:var(--dixa-size-spacer-300) 0;gap:var(--dixa-size-spacer-250);padding:var(--dixa-size-spacer-300)}._inputField_1bylq_14{text-align:center}._inputSeparator_1bylq_18{color:var(--dixa-color-neutral-600);text-align:center}._buttonLink_1bylq_23{color:var(--dixa-typography-color-link)}._noIssuesFound_1bylq_27{color:var(--dixa-color-neutral-400);font-size:var(--dixa-typography-size-200)}")), document.head.appendChild(e);
    }
  } catch (n) {
    console.error("vite-plugin-css-injected-by-js", n);
  }
})();
var eu = { exports: {} }, ma = {}, Qg;
function WI() {
  if (Qg) return ma;
  Qg = 1;
  var e = je, n = Symbol.for("react.element"), r = Symbol.for("react.fragment"), i = Object.prototype.hasOwnProperty, a = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, o = { key: !0, ref: !0, __self: !0, __source: !0 };
  function s(l, d, m) {
    var u, f = {}, h = null, v = null;
    m !== void 0 && (h = "" + m), d.key !== void 0 && (h = "" + d.key), d.ref !== void 0 && (v = d.ref);
    for (u in d) i.call(d, u) && !o.hasOwnProperty(u) && (f[u] = d[u]);
    if (l && l.defaultProps) for (u in d = l.defaultProps, d) f[u] === void 0 && (f[u] = d[u]);
    return { $$typeof: n, type: l, key: h, ref: v, props: f, _owner: a.current };
  }
  return ma.Fragment = r, ma.jsx = s, ma.jsxs = s, ma;
}
var Co = {}, Jg;
function KI() {
  return Jg || (Jg = 1, process.env.NODE_ENV !== "production" && (function() {
    var e = je, n = Symbol.for("react.element"), r = Symbol.for("react.portal"), i = Symbol.for("react.fragment"), a = Symbol.for("react.strict_mode"), o = Symbol.for("react.profiler"), s = Symbol.for("react.provider"), l = Symbol.for("react.context"), d = Symbol.for("react.forward_ref"), m = Symbol.for("react.suspense"), u = Symbol.for("react.suspense_list"), f = Symbol.for("react.memo"), h = Symbol.for("react.lazy"), v = Symbol.for("react.offscreen"), C = Symbol.iterator, S = "@@iterator";
    function j(t) {
      if (t === null || typeof t != "object")
        return null;
      var c = C && t[C] || t[S];
      return typeof c == "function" ? c : null;
    }
    var F = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function y(t) {
      {
        for (var c = arguments.length, p = new Array(c > 1 ? c - 1 : 0), g = 1; g < c; g++)
          p[g - 1] = arguments[g];
        q("error", t, p);
      }
    }
    function q(t, c, p) {
      {
        var g = F.ReactDebugCurrentFrame, P = g.getStackAddendum();
        P !== "" && (c += "%s", p = p.concat([P]));
        var L = p.map(function(I) {
          return String(I);
        });
        L.unshift("Warning: " + c), Function.prototype.apply.call(console[t], console, L);
      }
    }
    var T = !1, E = !1, D = !1, B = !1, ee = !1, J;
    J = Symbol.for("react.module.reference");
    function ae(t) {
      return !!(typeof t == "string" || typeof t == "function" || t === i || t === o || ee || t === a || t === m || t === u || B || t === v || T || E || D || typeof t == "object" && t !== null && (t.$$typeof === h || t.$$typeof === f || t.$$typeof === s || t.$$typeof === l || t.$$typeof === d || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      t.$$typeof === J || t.getModuleId !== void 0));
    }
    function Q(t, c, p) {
      var g = t.displayName;
      if (g)
        return g;
      var P = c.displayName || c.name || "";
      return P !== "" ? p + "(" + P + ")" : p;
    }
    function U(t) {
      return t.displayName || "Context";
    }
    function O(t) {
      if (t == null)
        return null;
      if (typeof t.tag == "number" && y("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof t == "function")
        return t.displayName || t.name || null;
      if (typeof t == "string")
        return t;
      switch (t) {
        case i:
          return "Fragment";
        case r:
          return "Portal";
        case o:
          return "Profiler";
        case a:
          return "StrictMode";
        case m:
          return "Suspense";
        case u:
          return "SuspenseList";
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case l:
            var c = t;
            return U(c) + ".Consumer";
          case s:
            var p = t;
            return U(p._context) + ".Provider";
          case d:
            return Q(t, t.render, "ForwardRef");
          case f:
            var g = t.displayName || null;
            return g !== null ? g : O(t.type) || "Memo";
          case h: {
            var P = t, L = P._payload, I = P._init;
            try {
              return O(I(L));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var H = Object.assign, Z = 0, ye, ce, le, ue, W, ke, Ee;
    function K() {
    }
    K.__reactDisabledLog = !0;
    function qe() {
      {
        if (Z === 0) {
          ye = console.log, ce = console.info, le = console.warn, ue = console.error, W = console.group, ke = console.groupCollapsed, Ee = console.groupEnd;
          var t = {
            configurable: !0,
            enumerable: !0,
            value: K,
            writable: !0
          };
          Object.defineProperties(console, {
            info: t,
            log: t,
            warn: t,
            error: t,
            group: t,
            groupCollapsed: t,
            groupEnd: t
          });
        }
        Z++;
      }
    }
    function Be() {
      {
        if (Z--, Z === 0) {
          var t = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: H({}, t, {
              value: ye
            }),
            info: H({}, t, {
              value: ce
            }),
            warn: H({}, t, {
              value: le
            }),
            error: H({}, t, {
              value: ue
            }),
            group: H({}, t, {
              value: W
            }),
            groupCollapsed: H({}, t, {
              value: ke
            }),
            groupEnd: H({}, t, {
              value: Ee
            })
          });
        }
        Z < 0 && y("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var Pe = F.ReactCurrentDispatcher, Me;
    function Fe(t, c, p) {
      {
        if (Me === void 0)
          try {
            throw Error();
          } catch (P) {
            var g = P.stack.trim().match(/\n( *(at )?)/);
            Me = g && g[1] || "";
          }
        return `
` + Me + t;
      }
    }
    var Ae = !1, $e;
    {
      var tn = typeof WeakMap == "function" ? WeakMap : Map;
      $e = new tn();
    }
    function Ie(t, c) {
      if (!t || Ae)
        return "";
      {
        var p = $e.get(t);
        if (p !== void 0)
          return p;
      }
      var g;
      Ae = !0;
      var P = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var L;
      L = Pe.current, Pe.current = null, qe();
      try {
        if (c) {
          var I = function() {
            throw Error();
          };
          if (Object.defineProperty(I.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(I, []);
            } catch (ne) {
              g = ne;
            }
            Reflect.construct(t, [], I);
          } else {
            try {
              I.call();
            } catch (ne) {
              g = ne;
            }
            t.call(I.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (ne) {
            g = ne;
          }
          t();
        }
      } catch (ne) {
        if (ne && g && typeof ne.stack == "string") {
          for (var N = ne.stack.split(`
`), te = g.stack.split(`
`), x = N.length - 1, V = te.length - 1; x >= 1 && V >= 0 && N[x] !== te[V]; )
            V--;
          for (; x >= 1 && V >= 0; x--, V--)
            if (N[x] !== te[V]) {
              if (x !== 1 || V !== 1)
                do
                  if (x--, V--, V < 0 || N[x] !== te[V]) {
                    var X = `
` + N[x].replace(" at new ", " at ");
                    return t.displayName && X.includes("<anonymous>") && (X = X.replace("<anonymous>", t.displayName)), typeof t == "function" && $e.set(t, X), X;
                  }
                while (x >= 1 && V >= 0);
              break;
            }
        }
      } finally {
        Ae = !1, Pe.current = L, Be(), Error.prepareStackTrace = P;
      }
      var we = t ? t.displayName || t.name : "", Se = we ? Fe(we) : "";
      return typeof t == "function" && $e.set(t, Se), Se;
    }
    function We(t, c, p) {
      return Ie(t, !1);
    }
    function Ze(t) {
      var c = t.prototype;
      return !!(c && c.isReactComponent);
    }
    function de(t, c, p) {
      if (t == null)
        return "";
      if (typeof t == "function")
        return Ie(t, Ze(t));
      if (typeof t == "string")
        return Fe(t);
      switch (t) {
        case m:
          return Fe("Suspense");
        case u:
          return Fe("SuspenseList");
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case d:
            return We(t.render);
          case f:
            return de(t.type, c, p);
          case h: {
            var g = t, P = g._payload, L = g._init;
            try {
              return de(L(P), c, p);
            } catch {
            }
          }
        }
      return "";
    }
    var fe = Object.prototype.hasOwnProperty, Te = {}, Le = F.ReactDebugCurrentFrame;
    function Re(t) {
      if (t) {
        var c = t._owner, p = de(t.type, t._source, c ? c.type : null);
        Le.setExtraStackFrame(p);
      } else
        Le.setExtraStackFrame(null);
    }
    function sn(t, c, p, g, P) {
      {
        var L = Function.call.bind(fe);
        for (var I in t)
          if (L(t, I)) {
            var N = void 0;
            try {
              if (typeof t[I] != "function") {
                var te = Error((g || "React class") + ": " + p + " type `" + I + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof t[I] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw te.name = "Invariant Violation", te;
              }
              N = t[I](c, I, g, p, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (x) {
              N = x;
            }
            N && !(N instanceof Error) && (Re(P), y("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", g || "React class", p, I, typeof N), Re(null)), N instanceof Error && !(N.message in Te) && (Te[N.message] = !0, Re(P), y("Failed %s type: %s", p, N.message), Re(null));
          }
      }
    }
    var w = Array.isArray;
    function _(t) {
      return w(t);
    }
    function $(t) {
      {
        var c = typeof Symbol == "function" && Symbol.toStringTag, p = c && t[Symbol.toStringTag] || t.constructor.name || "Object";
        return p;
      }
    }
    function G(t) {
      try {
        return Y(t), !1;
      } catch {
        return !0;
      }
    }
    function Y(t) {
      return "" + t;
    }
    function R(t) {
      if (G(t))
        return y("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", $(t)), Y(t);
    }
    var z = F.ReactCurrentOwner, ie = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, pe, _e;
    function en(t) {
      if (fe.call(t, "ref")) {
        var c = Object.getOwnPropertyDescriptor(t, "ref").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.ref !== void 0;
    }
    function un(t) {
      if (fe.call(t, "key")) {
        var c = Object.getOwnPropertyDescriptor(t, "key").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.key !== void 0;
    }
    function rn(t, c) {
      typeof t.ref == "string" && z.current;
    }
    function dn(t, c) {
      {
        var p = function() {
          pe || (pe = !0, y("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "key", {
          get: p,
          configurable: !0
        });
      }
    }
    function pn(t, c) {
      {
        var p = function() {
          _e || (_e = !0, y("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "ref", {
          get: p,
          configurable: !0
        });
      }
    }
    var ln = function(t, c, p, g, P, L, I) {
      var N = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: n,
        // Built-in properties that belong on the element
        type: t,
        key: c,
        ref: p,
        props: I,
        // Record the component responsible for creating this element.
        _owner: L
      };
      return N._store = {}, Object.defineProperty(N._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(N, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: g
      }), Object.defineProperty(N, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: P
      }), Object.freeze && (Object.freeze(N.props), Object.freeze(N)), N;
    };
    function kn(t, c, p, g, P) {
      {
        var L, I = {}, N = null, te = null;
        p !== void 0 && (R(p), N = "" + p), un(c) && (R(c.key), N = "" + c.key), en(c) && (te = c.ref, rn(c));
        for (L in c)
          fe.call(c, L) && !ie.hasOwnProperty(L) && (I[L] = c[L]);
        if (t && t.defaultProps) {
          var x = t.defaultProps;
          for (L in x)
            I[L] === void 0 && (I[L] = x[L]);
        }
        if (N || te) {
          var V = typeof t == "function" ? t.displayName || t.name || "Unknown" : t;
          N && dn(I, V), te && pn(I, V);
        }
        return ln(t, N, te, P, g, z.current, I);
      }
    }
    var Xe = F.ReactCurrentOwner, Sn = F.ReactDebugCurrentFrame;
    function Oe(t) {
      if (t) {
        var c = t._owner, p = de(t.type, t._source, c ? c.type : null);
        Sn.setExtraStackFrame(p);
      } else
        Sn.setExtraStackFrame(null);
    }
    var an;
    an = !1;
    function on(t) {
      return typeof t == "object" && t !== null && t.$$typeof === n;
    }
    function yn() {
      {
        if (Xe.current) {
          var t = O(Xe.current.type);
          if (t)
            return `

Check the render method of \`` + t + "`.";
        }
        return "";
      }
    }
    function qn(t) {
      return "";
    }
    var Nn = {};
    function gn(t) {
      {
        var c = yn();
        if (!c) {
          var p = typeof t == "string" ? t : t.displayName || t.name;
          p && (c = `

Check the top-level render call using <` + p + ">.");
        }
        return c;
      }
    }
    function hn(t, c) {
      {
        if (!t._store || t._store.validated || t.key != null)
          return;
        t._store.validated = !0;
        var p = gn(c);
        if (Nn[p])
          return;
        Nn[p] = !0;
        var g = "";
        t && t._owner && t._owner !== Xe.current && (g = " It was passed a child from " + O(t._owner.type) + "."), Oe(t), y('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', p, g), Oe(null);
      }
    }
    function jn(t, c) {
      {
        if (typeof t != "object")
          return;
        if (_(t))
          for (var p = 0; p < t.length; p++) {
            var g = t[p];
            on(g) && hn(g, c);
          }
        else if (on(t))
          t._store && (t._store.validated = !0);
        else if (t) {
          var P = j(t);
          if (typeof P == "function" && P !== t.entries)
            for (var L = P.call(t), I; !(I = L.next()).done; )
              on(I.value) && hn(I.value, c);
        }
      }
    }
    function Un(t) {
      {
        var c = t.type;
        if (c == null || typeof c == "string")
          return;
        var p;
        if (typeof c == "function")
          p = c.propTypes;
        else if (typeof c == "object" && (c.$$typeof === d || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        c.$$typeof === f))
          p = c.propTypes;
        else
          return;
        if (p) {
          var g = O(c);
          sn(p, t.props, "prop", g, t);
        } else if (c.PropTypes !== void 0 && !an) {
          an = !0;
          var P = O(c);
          y("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", P || "Unknown");
        }
        typeof c.getDefaultProps == "function" && !c.getDefaultProps.isReactClassApproved && y("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function Vn(t) {
      {
        for (var c = Object.keys(t.props), p = 0; p < c.length; p++) {
          var g = c[p];
          if (g !== "children" && g !== "key") {
            Oe(t), y("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", g), Oe(null);
            break;
          }
        }
        t.ref !== null && (Oe(t), y("Invalid attribute `ref` supplied to `React.Fragment`."), Oe(null));
      }
    }
    var _n = {};
    function xn(t, c, p, g, P, L) {
      {
        var I = ae(t);
        if (!I) {
          var N = "";
          (t === void 0 || typeof t == "object" && t !== null && Object.keys(t).length === 0) && (N += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var te = qn();
          te ? N += te : N += yn();
          var x;
          t === null ? x = "null" : _(t) ? x = "array" : t !== void 0 && t.$$typeof === n ? (x = "<" + (O(t.type) || "Unknown") + " />", N = " Did you accidentally export a JSX literal instead of a component?") : x = typeof t, y("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", x, N);
        }
        var V = kn(t, c, p, P, L);
        if (V == null)
          return V;
        if (I) {
          var X = c.children;
          if (X !== void 0)
            if (g)
              if (_(X)) {
                for (var we = 0; we < X.length; we++)
                  jn(X[we], t);
                Object.freeze && Object.freeze(X);
              } else
                y("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              jn(X, t);
        }
        if (fe.call(c, "key")) {
          var Se = O(t), ne = Object.keys(c).filter(function(wn) {
            return wn !== "key";
          }), nn = ne.length > 0 ? "{key: someKey, " + ne.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!_n[Se + nn]) {
            var Tn = ne.length > 0 ? "{" + ne.join(": ..., ") + ": ...}" : "{}";
            y(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, nn, Se, Tn, Se), _n[Se + nn] = !0;
          }
        }
        return t === i ? Vn(V) : Un(V), V;
      }
    }
    function Hn(t, c, p) {
      return xn(t, c, p, !0);
    }
    function Dn(t, c, p) {
      return xn(t, c, p, !1);
    }
    var Rn = Dn, Mn = Hn;
    Co.Fragment = i, Co.jsx = Rn, Co.jsxs = Mn;
  })()), Co;
}
var Xg;
function GI() {
  return Xg || (Xg = 1, process.env.NODE_ENV === "production" ? eu.exports = WI() : eu.exports = KI()), eu.exports;
}
var he = GI();
const bp = (e, n) => {
  const r = (o) => (e.marks || []).map((s) => ({
    formatterFunction: n.marks[e.type]?.[s.type],
    mark: s
  })).reduce(
    (s, l) => () => l.formatterFunction?.(l.mark, s) || o,
    () => o
  )(), i = (o, s) => () => o.content ? o.content.map((l) => bp(l, s)) : [], a = n.nodes[e.type] || n.default;
  return r(
    a(e, i(e, n))
  );
}, YI = "_jiraCode_h30p6_1", QI = "_jiraCodeInline_h30p6_8", nu = {
  jiraCode: YI,
  jiraCodeInline: QI
}, ox = {
  default: (e, n) => n().every((r) => typeof r == "string") ? n().join(" ") : /* @__PURE__ */ he.jsx(he.Fragment, { children: n() }),
  nodes: {
    doc: (e, n) => /* @__PURE__ */ he.jsx("div", { children: n() }),
    paragraph: (e, n) => /* @__PURE__ */ he.jsx("p", { children: n() }),
    text: (e) => e.text || "",
    hardBreak: () => /* @__PURE__ */ he.jsx("br", {}),
    bulletList: (e, n) => /* @__PURE__ */ he.jsx("ul", { children: n() }),
    orderedList: (e, n) => /* @__PURE__ */ he.jsx("ol", { children: n() }),
    listItem: (e, n) => /* @__PURE__ */ he.jsx("li", { children: n() }),
    codeBlock: (e, n) => /* @__PURE__ */ he.jsx("pre", { children: /* @__PURE__ */ he.jsx("code", { className: nu.jiraCode, children: n() }) }),
    heading: (e, n) => {
      switch (e.attrs?.level) {
        // Not using headlines above level 3
        case 1:
          return /* @__PURE__ */ he.jsx("h3", { children: n() });
        case 2:
          return /* @__PURE__ */ he.jsx("h4", { children: n() });
        case 3:
          return /* @__PURE__ */ he.jsx("h5", { children: n() });
        case 4:
          return /* @__PURE__ */ he.jsx("h6", { children: n() });
        case 5:
          return /* @__PURE__ */ he.jsx("b", { children: n() });
        case 6:
          return /* @__PURE__ */ he.jsx("b", { children: n() });
        default:
          return /* @__PURE__ */ he.jsx("h4", { children: n() });
      }
    }
  },
  marks: {
    text: {
      em: (e, n) => /* @__PURE__ */ he.jsx("em", { children: n() }),
      strong: (e, n) => /* @__PURE__ */ he.jsx("b", { children: n() }),
      underline: (e, n) => /* @__PURE__ */ he.jsx("u", { children: n() }),
      link: (e, n) => /* @__PURE__ */ he.jsx("a", { href: e.attrs?.href || "", target: "_blank", rel: "noreferrer", children: n() }),
      code: (e, n) => /* @__PURE__ */ he.jsx("code", { className: rt(nu.jiraCode, nu.jiraCodeInline), children: n() })
      // Removing color support for now.
      // textColor: (mark, next) => (
      // 	<span style={{ color: mark.attrs?.['color'] }}>{next()}</span>
      // ),
    }
  }
}, ks = ({
  iconUrl: e,
  className: n,
  width: r
}) => {
  const [i, a] = se(!1);
  return !e || i ? /* @__PURE__ */ he.jsx(me, { size: r, name: "question", className: n }) : /* @__PURE__ */ he.jsx(
    "img",
    {
      src: e,
      width: r,
      className: n,
      onError: ({ currentTarget: o }) => {
        o.onerror = null, a(!0);
      }
    }
  );
}, JI = "_collapse_m2gjh_1", XI = "_collapseHeader_m2gjh_10", ZI = "_collapseHeaderLink_m2gjh_31", eE = "_collapseHeaderStatus_m2gjh_40", nE = "_collapseHeaderTitle_m2gjh_51", tE = "_collapseContent_m2gjh_59", rE = "_collapseContentHeadline_m2gjh_62", iE = "_collapseContentButtonSpacer_m2gjh_68", aE = "_collapseContentButtonLink_m2gjh_71", oE = "_collapseContentStatusTag_m2gjh_74", sE = "_collapseContentDescription_m2gjh_77", pr = {
  collapse: JI,
  collapseHeader: XI,
  collapseHeaderLink: ZI,
  collapseHeaderStatus: eE,
  collapseHeaderTitle: nE,
  collapseContent: tE,
  collapseContentHeadline: rE,
  collapseContentButtonSpacer: iE,
  collapseContentButtonLink: aE,
  collapseContentStatusTag: oE,
  collapseContentDescription: sE
}, sx = ({
  jiraInstanceUrl: e,
  avatarId: n,
  iconUrl: r
}) => n ? `${e}/rest/api/3/universal_avatar/view/type/issuetype/avatar/${n}?size=medium` : r, lE = ({
  issues: e,
  jiraInstanceUrl: n,
  unlinkIssue: r
}) => {
  const i = e.reduce(
    (d, m) => m?.id ? { ...d, [m.id]: !1 } : d,
    {}
  ), [a, o] = se(i), { track: s } = bn(), l = (d, m) => {
    o({ ...a, [d]: m });
  };
  return /* @__PURE__ */ he.jsx(b, { flexDirection: "column", gap: "250", children: e?.length ? e.map((d) => {
    const { summary: m, description: u, status: f, issuetype: h } = d?.fields || {}, v = sx({
      avatarId: h?.avatarId,
      iconUrl: h?.iconUrl,
      jiraInstanceUrl: n
    }), C = !!(d?.id && a[d.id]);
    return /* @__PURE__ */ he.jsxs(
      lr,
      {
        onToggle: () => d?.id && l(d.id, !a[d.id]),
        isOpen: C,
        className: pr.collapse,
        children: [
          /* @__PURE__ */ he.jsx(lr.Header, { className: pr.collapseHeader, children: /* @__PURE__ */ he.jsxs(
            b,
            {
              flexDirection: "column",
              gap: "200",
              justifyContent: "space-between",
              children: [
                /* @__PURE__ */ he.jsxs(b, { flexDirection: "row", justifyContent: "space-between", children: [
                  /* @__PURE__ */ he.jsxs(b, { alignItems: "center", gap: "200", children: [
                    /* @__PURE__ */ he.jsx(ks, { width: 16, iconUrl: v }),
                    /* @__PURE__ */ he.jsx(
                      "a",
                      {
                        className: pr.collapseHeaderLink,
                        href: `${n}/browse/${d?.key}`,
                        target: "_blank",
                        rel: "noreferrer",
                        onClick: (S) => {
                          S.stopPropagation(), d?.key && s("jira:view:issue:clicked", {
                            jiraIssueKey: d.key,
                            jiraInstanceUrl: n
                          });
                        },
                        children: /* @__PURE__ */ he.jsxs(b, { alignItems: "center", gap: "200", children: [
                          d?.key,
                          /* @__PURE__ */ he.jsx(me, { name: "external-link", size: 16 })
                        ] })
                      },
                      d?.key
                    )
                  ] }),
                  /* @__PURE__ */ he.jsx("span", { className: pr.collapseHeaderStatus, children: f?.name && /* @__PURE__ */ he.jsx(An, { className: pr.collapseContentStatusTag, children: f.name }) })
                ] }),
                /* @__PURE__ */ he.jsx("div", { className: pr.collapseHeaderTitle, children: m })
              ]
            }
          ) }),
          /* @__PURE__ */ he.jsx(lr.Content, { className: pr.collapseContent, children: /* @__PURE__ */ he.jsxs(b, { flexDirection: "column", gap: "250", margin: "0 0 200 0", children: [
            /* @__PURE__ */ he.jsx("div", { className: pr.collapseContentHeadline, children: "Description" }),
            /* @__PURE__ */ he.jsx(Zn, { className: pr.collapseContentDescription, children: u ? bp(u, ox) : "" }),
            /* @__PURE__ */ he.jsx(
              Wn,
              {
                icon: "link-slash",
                variant: "secondary",
                className: pr.collapseContentButtonSpacer,
                onClick: () => d?.key && r(d.key),
                children: "Unlink issue from Jira"
              }
            ),
            /* @__PURE__ */ he.jsx(
              jt,
              {
                slotEnd: /* @__PURE__ */ he.jsx(me, { name: "external-link" }),
                variant: "tertiary",
                className: pr.collapseContentButtonLink,
                navigate: () => {
                  d?.key && (s("jira:view:issue:clicked", {
                    jiraIssueKey: d.key,
                    jiraInstanceUrl: n
                  }), window.open(
                    `${n}/browse/${d.key}`,
                    "_blank"
                  )?.focus());
                },
                children: "View issue in Jira"
              }
            )
          ] }) })
        ]
      },
      d?.id
    );
  }) : /* @__PURE__ */ he.jsx(he.Fragment, {}) });
}, cE = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "createBacklink" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "issueKey" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "title" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "url" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "globalId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Jira" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "createOrUpdateRemoteIssueLink" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "issueIdOrKey" }, value: { kind: "Variable", name: { kind: "Name", value: "issueKey" } } }, { kind: "Argument", name: { kind: "Name", value: "input" }, value: { kind: "ObjectValue", fields: [{ kind: "ObjectField", name: { kind: "Name", value: "globalId" }, value: { kind: "Variable", name: { kind: "Name", value: "globalId" } } }, { kind: "ObjectField", name: { kind: "Name", value: "application" }, value: { kind: "ObjectValue", fields: [{ kind: "ObjectField", name: { kind: "Name", value: "name" }, value: { kind: "StringValue", value: "Dixa Conversations", block: !1 } }, { kind: "ObjectField", name: { kind: "Name", value: "type" }, value: { kind: "StringValue", value: "com.dixa.conversations", block: !1 } }] } }, { kind: "ObjectField", name: { kind: "Name", value: "relationship" }, value: { kind: "StringValue", value: "dixa-backlink", block: !1 } }, { kind: "ObjectField", name: { kind: "Name", value: "object" }, value: { kind: "ObjectValue", fields: [{ kind: "ObjectField", name: { kind: "Name", value: "title" }, value: { kind: "Variable", name: { kind: "Name", value: "title" } } }, { kind: "ObjectField", name: { kind: "Name", value: "url" }, value: { kind: "Variable", name: { kind: "Name", value: "url" } } }, { kind: "ObjectField", name: { kind: "Name", value: "icon" }, value: { kind: "ObjectValue", fields: [{ kind: "ObjectField", name: { kind: "Name", value: "url16x16" }, value: { kind: "StringValue", value: "https://www.dixa.com/app/themes/dixa/app/frontend/src/images/favicons/favicon-32x32.png?v=2", block: !1 } }, { kind: "ObjectField", name: { kind: "Name", value: "title" }, value: { kind: "StringValue", value: "Dixa", block: !1 } }] } }] } }] } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "__typename" } }] } }] } }] } }] }, dE = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "removeBacklink" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "issueKey" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "globalId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Jira" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "deleteRemoteIssueLinkByGlobalId" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "issueIdOrKey" }, value: { kind: "Variable", name: { kind: "Name", value: "issueKey" } } }, { kind: "Argument", name: { kind: "Name", value: "globalId" }, value: { kind: "Variable", name: { kind: "Name", value: "globalId" } } }] }] } }] } }] }, uE = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "createIssue" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "input" } }, type: { kind: "NamedType", name: { kind: "Name", value: "Jira_IssueUpdateDetails_Input" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Jira" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "createIssue" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "input" }, value: { kind: "Variable", name: { kind: "Name", value: "input" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Jira_CreatedIssue" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "key" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Jira_ErrorCollection" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errorMessages" } }, { kind: "Field", name: { kind: "Name", value: "status" } }, { kind: "Field", name: { kind: "Name", value: "errors" } }] } }] } }] } }] } }] }, mE = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "jira" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Jira" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "getAllProjects" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "key" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "avatarUrls" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "_24x24" } }] } }] } }] } }] } }] }, pE = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getCreateIssueMeta" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "projectKey" } }, type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Jira" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "getCreateIssueMeta" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "projectKeys" }, value: { kind: "ListValue", values: [{ kind: "Variable", name: { kind: "Name", value: "projectKey" } }] } }, { kind: "Argument", name: { kind: "Name", value: "expand" }, value: { kind: "StringValue", value: "projects.issuetypes.fields", block: !1 } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "projects" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "key" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "issuetypes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "iconUrl" } }, { kind: "Field", name: { kind: "Name", value: "entityId" } }, { kind: "Field", name: { kind: "Name", value: "hierarchyLevel" } }, { kind: "Field", name: { kind: "Name", value: "subtask" } }, { kind: "Field", name: { kind: "Name", value: "scope" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "type" } }, { kind: "Field", name: { kind: "Name", value: "project" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "key" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }, { kind: "Field", name: { kind: "Name", value: "additionalProperties" } }] } }, { kind: "Field", name: { kind: "Name", value: "expand" } }, { kind: "Field", name: { kind: "Name", value: "subtask" } }, { kind: "Field", name: { kind: "Name", value: "description" } }, { kind: "Field", name: { kind: "Name", value: "fields" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "additionalProperties" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "key" } }, { kind: "Field", name: { kind: "Name", value: "value" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "key" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "required" } }, { kind: "Field", name: { kind: "Name", value: "hasDefaultValue" } }, { kind: "Field", name: { kind: "Name", value: "schema" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "type" } }, { kind: "Field", name: { kind: "Name", value: "system" } }, { kind: "Field", name: { kind: "Name", value: "items" } }, { kind: "Field", name: { kind: "Name", value: "custom" } }, { kind: "Field", name: { kind: "Name", value: "customId" } }] } }, { kind: "Field", name: { kind: "Name", value: "allowedValues" } }, { kind: "Field", name: { kind: "Name", value: "defaultValue" } }, { kind: "Field", name: { kind: "Name", value: "operations" } }, { kind: "Field", name: { kind: "Name", value: "autoCompleteUrl" } }] } }] } }] } }] } }] } }] } }] } }] } }] }, fE = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "searchAndReconsileIssuesUsingJql" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "jql" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "maxResults" } }, type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Jira" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "searchAndReconsileIssuesUsingJql" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "jql" }, value: { kind: "Variable", name: { kind: "Name", value: "jql" } } }, { kind: "Argument", name: { kind: "Name", value: "maxResults" }, value: { kind: "Variable", name: { kind: "Name", value: "maxResults" } } }, { kind: "Argument", name: { kind: "Name", value: "fields" }, value: { kind: "ListValue", values: [{ kind: "StringValue", value: "summary", block: !1 }, { kind: "StringValue", value: "description", block: !1 }, { kind: "StringValue", value: "status", block: !1 }, { kind: "StringValue", value: "updated", block: !1 }, { kind: "StringValue", value: "issuetype", block: !1 }, { kind: "StringValue", value: "project", block: !1 }] } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "issues" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "key" } }, { kind: "Field", name: { kind: "Name", value: "fields" } }] } }] } }] } }] } }] }, hE = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "findUsers" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "query" } }, type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Jira" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "findUsers" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "query" }, value: { kind: "Variable", name: { kind: "Name", value: "query" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "accountId" } }, { kind: "Field", name: { kind: "Name", value: "displayName" } }, { kind: "Field", name: { kind: "Name", value: "self" } }, { kind: "Field", name: { kind: "Name", value: "active" } }, { kind: "Field", name: { kind: "Name", value: "avatarUrls" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "_24x24" } }] } }] } }] } }] } }] }, yE = {
  '\n  mutation createBacklink(\n    $issueKey: String!\n    $title: String!\n    $url: String!\n    $globalId: String!\n  ) {\n    Jira {\n      createOrUpdateRemoteIssueLink(\n        issueIdOrKey: $issueKey\n        input: {\n          globalId: $globalId\n          application: {\n            name: "Dixa Conversations"\n            type: "com.dixa.conversations"\n          }\n          relationship: "dixa-backlink"\n          object: {\n            title: $title\n            url: $url\n            icon: {\n              url16x16: "https://www.dixa.com/app/themes/dixa/app/frontend/src/images/favicons/favicon-32x32.png?v=2"\n              title: "Dixa"\n            }\n          }\n        }\n      ) {\n        __typename\n      }\n    }\n  }\n': cE,
  "\n  mutation removeBacklink($issueKey: String!, $globalId: String!) {\n    Jira {\n      deleteRemoteIssueLinkByGlobalId(\n        issueIdOrKey: $issueKey\n        globalId: $globalId\n      )\n    }\n  }\n": dE,
  "\n  mutation createIssue($input: Jira_IssueUpdateDetails_Input) {\n    Jira {\n      createIssue(input: $input) {\n        ... on Jira_CreatedIssue {\n          id\n          key\n        }\n        ... on Jira_ErrorCollection {\n          errorMessages\n          status\n          errors\n        }\n      }\n    }\n  }\n": uE,
  "\n  query jira {\n    Jira {\n      getAllProjects {\n        id\n        key\n        name\n        avatarUrls {\n          _24x24\n        }\n      }\n    }\n  }\n": mE,
  '\n  query getCreateIssueMeta($projectKey: String) {\n    Jira {\n      getCreateIssueMeta(\n        projectKeys: [$projectKey]\n        expand: "projects.issuetypes.fields"\n      ) {\n        projects {\n          id\n          key\n          name\n          issuetypes {\n            id\n            name\n            iconUrl\n            entityId\n            hierarchyLevel\n            subtask\n            scope {\n              type\n              project {\n                id\n                key\n                name\n              }\n              additionalProperties\n            }\n            expand\n            subtask\n            description\n            fields {\n              additionalProperties {\n                key\n                value {\n                  key\n                  name\n                  required\n                  hasDefaultValue\n                  schema {\n                    type\n                    system\n                    items\n                    custom\n                    customId\n                  }\n                  allowedValues\n                  defaultValue\n                  operations\n                  autoCompleteUrl\n                }\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n': pE,
  '\n  query searchAndReconsileIssuesUsingJql($jql: String!, $maxResults: Int) {\n    Jira {\n      searchAndReconsileIssuesUsingJql(\n        jql: $jql\n        maxResults: $maxResults\n        fields: [\n          "summary"\n          "description"\n          "status"\n          "updated"\n          "issuetype"\n          "project"\n        ]\n      ) {\n        issues {\n          id\n          key\n          fields\n        }\n      }\n    }\n  }\n': fE,
  "\n  query findUsers($query: String) {\n    Jira {\n      findUsers(query: $query) {\n        accountId\n        displayName\n        self\n        active\n        avatarUrls {\n          _24x24\n        }\n      }\n    }\n  }\n": hE
};
function xi(e) {
  return yE[e] ?? {};
}
const lx = xi(
  /* GraphQL */
  `
  query searchAndReconsileIssuesUsingJql($jql: String!, $maxResults: Int) {
    Jira {
      searchAndReconsileIssuesUsingJql(
        jql: $jql
        maxResults: $maxResults
        fields: [
          "summary"
          "description"
          "status"
          "updated"
          "issuetype"
          "project"
        ]
      ) {
        issues {
          id
          key
          fields
        }
      }
    }
  }
`
), gE = xi(
  /* GraphQL */
  `
  mutation createBacklink(
    $issueKey: String!
    $title: String!
    $url: String!
    $globalId: String!
  ) {
    Jira {
      createOrUpdateRemoteIssueLink(
        issueIdOrKey: $issueKey
        input: {
          globalId: $globalId
          application: {
            name: "Dixa Conversations"
            type: "com.dixa.conversations"
          }
          relationship: "dixa-backlink"
          object: {
            title: $title
            url: $url
            icon: {
              url16x16: "https://www.dixa.com/app/themes/dixa/app/frontend/src/images/favicons/favicon-32x32.png?v=2"
              title: "Dixa"
            }
          }
        }
      ) {
        __typename
      }
    }
  }
`
), vE = xi(
  /* GraphQL */
  `
  mutation removeBacklink($issueKey: String!, $globalId: String!) {
    Jira {
      deleteRemoteIssueLinkByGlobalId(
        issueIdOrKey: $issueKey
        globalId: $globalId
      )
    }
  }
`
), kE = xi(
  /* GraphQL */
  `
  query jira {
    Jira {
      getAllProjects {
        id
        key
        name
        avatarUrls {
          _24x24
        }
      }
    }
  }
`
), bE = xi(
  /* GraphQL */
  `
  query getCreateIssueMeta($projectKey: String) {
    Jira {
      getCreateIssueMeta(
        projectKeys: [$projectKey]
        expand: "projects.issuetypes.fields"
      ) {
        projects {
          id
          key
          name
          issuetypes {
            id
            name
            iconUrl
            entityId
            hierarchyLevel
            subtask
            scope {
              type
              project {
                id
                key
                name
              }
              additionalProperties
            }
            expand
            subtask
            description
            fields {
              additionalProperties {
                key
                value {
                  key
                  name
                  required
                  hasDefaultValue
                  schema {
                    type
                    system
                    items
                    custom
                    customId
                  }
                  allowedValues
                  defaultValue
                  operations
                  autoCompleteUrl
                }
              }
            }
          }
        }
      }
    }
  }
`
), _E = xi(
  /* GraphQL */
  `
  mutation createIssue($input: Jira_IssueUpdateDetails_Input) {
    Jira {
      createIssue(input: $input) {
        ... on Jira_CreatedIssue {
          id
          key
        }
        ... on Jira_ErrorCollection {
          errorMessages
          status
          errors
        }
      }
    }
  }
`
), xE = xi(
  /* GraphQL */
  `
  query findUsers($query: String) {
    Jira {
      findUsers(query: $query) {
        accountId
        displayName
        self
        active
        avatarUrls {
          _24x24
        }
      }
    }
  }
`
), _p = new RegExp("[a-zA-Z0-9_]{2,}-[0-9]+"), SE = new RegExp(`^${_p.source}$`), NE = new RegExp(`/${_p.source}$`), Zg = new RegExp(
  `.+?[&?]selectedIssue=(${_p.source})[&?]?.*`
);
function cx(e, n) {
  const r = { jira: { issues: [] } }, [i, a] = se([]), [o, s] = se([]), [l, d] = se(), { track: m } = bn(), { showNotification: u, showModal: f, useLazyQuery: h, useMutation: v } = mn(), {
    loading: C,
    data: S,
    error: j,
    store: F
  } = Em(e ?? null), [
    y,
    { loading: q, error: T, data: E }
  ] = h(lx, {
    notifyOnNetworkStatusChange: !0
  });
  He(() => {
    const le = E?.Jira?.searchAndReconsileIssuesUsingJql?.issues || [];
    le?.length && (s(le), a(le.map((ue) => ue?.key).filter(Boolean)));
  }, [E]), He(
    () => d(j || T || void 0),
    [j, T]
  ), He(
    () => {
      C || U();
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [S?.jira?.issues, C]
  );
  const D = async (le, ue) => {
    await F(le).then(() => {
      u({
        icon: "check-circle-filled",
        severity: "success",
        title: ue.success.title,
        text: ue.success.text
      });
    }).catch((W) => {
      u({
        title: ue.error.title,
        text: `${ue.error.text} ${W.message && " (" + W.message + ")"}`,
        icon: "exclamation-triangle-filled",
        severity: "warning"
      });
    });
  }, [B] = v(gE, {
    onError: (le) => {
      u({
        title: "Something went wrong",
        text: `It looks like something went wrong when trying to create a link back from the issue to the conversation. Please create it manually in Jira.
				${le.message && " (" + le.message + ")"}`,
        icon: "exclamation-triangle-filled",
        severity: "warning"
      });
    }
  }), ee = (le, ue) => {
    const W = window.location.href, ke = ue ? W.replace(
      e?.toString() ?? "",
      ue?.toString()
    ) : W, Ee = ue ? `# ${ue}` : `# ${e}`;
    B({
      variables: {
        issueKey: le,
        title: Ee,
        url: ke,
        globalId: `system=${ke}`
      }
    });
  }, [J] = v(vE, {
    onError: (le) => {
      u({
        title: "Something went wrong",
        text: `It looks like something went wrong when trying to remove a link back from the issue to the conversation. Please remove it manually from Jira.
					${le.message && " (" + le.message + ")"}`,
        icon: "exclamation-triangle-filled",
        severity: "warning"
      });
    }
  }), ae = (le) => {
    const ue = window.location.href;
    J({
      variables: {
        issueKey: le,
        globalId: `system=${ue}`
      }
    });
  }, Q = (le) => ({
    jiraInstanceUrl: n,
    jiraIssueKey: le
  }), U = () => {
    S && S.jira?.issues?.length > 0 ? y({
      variables: {
        jql: `key in (${S?.jira?.issues.join(",")})`,
        maxResults: 15
      }
    }) : s([]);
  }, O = async (le, ue) => {
    m("jira:issue:link:clicked", Q(le));
    const W = S?.jira?.issues ? S : r;
    W.jira.issues = Array.from(
      new Set(W.jira.issues).add(le)
    ), await F(W, ue?.toString()).then(() => ee(le, ue)).catch((ke) => {
      u({
        title: "Linking failed",
        text: `Linking ${le} failed. Please try again. ${ke.message && " (" + ke.message + ")"}`,
        icon: "exclamation-triangle-filled",
        severity: "warning"
      });
    });
  }, H = (le) => {
    m("jira:issue:link:clicked", Q(le));
    const ue = S?.jira?.issues ? S : r;
    ue.jira.issues = Array.from(
      new Set(ue.jira.issues).add(le)
    ), D(ue, {
      success: {
        title: "Jira issue linked",
        text: `You linked the Jira issue ${le} to this conversation.`
      },
      error: {
        title: "Linking failed",
        text: `Linking ${le} failed. Please try again.`
      }
    }).then(() => ee(le));
  }, Z = (le) => {
    m("jira:issue:unlink:clicked", Q(le)), f({
      headline: `Unlink issue ${le}?`,
      text: `You are about to unlink the issue ${le}. Do you want to proceed?`,
      confirmLabel: "Unlink Jira issue",
      confirmVariant: "danger",
      cancelLabel: "Cancel",
      onConfirm: () => {
        m("jira:issue:unlink:confirmed", Q(le));
        const ue = {
          ...S,
          jira: {
            ...S?.jira,
            issues: S?.jira?.issues.filter((W) => W !== le) || []
          }
        };
        D(ue, {
          success: {
            title: "Jira issue unlinked",
            text: `You unlinked the Jira issue ${le}`
          },
          error: {
            title: "Unlinking failed",
            text: `Unlinking ${le} failed.`
          }
        }).then(() => ae(le));
      },
      onCancel: () => m("jira:issue:unlink:cancelled", Q(le))
    });
  }, ye = () => {
    m("jira:issue:unlink-all:clicked", { jiraInstanceUrl: n }), f({
      headline: "Unlink all Jira issues?",
      text: "You are about to unlink the all Jira issues from the conversation. Do you want to proceed?",
      confirmLabel: "Unlink ALL issues",
      confirmVariant: "danger",
      cancelLabel: "Cancel",
      onConfirm: () => {
        m("jira:issue:unlink-all:confirmed", { jiraInstanceUrl: n }), o?.forEach((le) => le?.key && ae(le.key)), D(r, {
          success: {
            title: "Unlinking successful",
            text: "All Jira issues were unlinked"
          },
          error: {
            title: "Unlinking failed",
            text: "Unlinking all issues failed."
          }
        });
      },
      onCancel: () => m("jira:issue:unlink-all:cancelled", { jiraInstanceUrl: n })
    });
  }, ce = S?.jira?.issues?.filter(
    (le) => !i?.includes(le)
  ) || [];
  return {
    linkIssue: H,
    linkIssueQuietly: O,
    unlinkIssue: Z,
    loadIssues: U,
    removeDanglingIssueLinks: () => {
      m("jira:issue:unlink-all-dangling:clicked", {
        jiraInstanceUrl: n
      });
      const le = {
        ...S,
        jira: {
          ...S?.jira,
          issues: S?.jira?.issues.filter(
            (ue) => !ce.includes(ue)
          ) || []
        }
      };
      F(le);
    },
    unlinkAllIssues: ye,
    maybeExtractIssueKey: (le) => {
      const ue = le.replace(/\s/g, "");
      if (SE.test(ue))
        return ue;
      if (Zg.test(le))
        return le.match(Zg)?.[1];
      if (le.startsWith(n) && NE.test(le))
        return le.substring(le.lastIndexOf("/") + 1);
    },
    isLoadingIssueLinks: C,
    danglingIssueLinks: ce,
    isLoadingIssues: q,
    issues: o,
    error: l
  };
}
function jE(e = !1, n) {
  const [r, i] = se(e);
  return He(() => {
    const a = r ? window.setTimeout(() => i(!1), 2e3) : void 0;
    return () => window.clearTimeout(a);
  }, [n, r]), { isCopied: r, copyToClipboard: (a) => {
    navigator.clipboard.writeText(a), i(!0);
  } };
}
const wE = "_result_axxxc_48", CE = "_resultName_axxxc_68", FE = "_resultNameIcon_axxxc_76", IE = "_resultDescription_axxxc_81", EE = "_resultLinkIcon_axxxc_93", TE = "_tooltip_axxxc_102", $E = "_tooltipContent_axxxc_108", DE = "_tooltipName_axxxc_115", RE = "_tooltipNameIcon_axxxc_120", OE = "_tooltipDescription_axxxc_125", PE = "_tooltipSummary_axxxc_133", AE = "_tooltipTag_axxxc_137", ir = {
  result: wE,
  resultName: CE,
  resultNameIcon: FE,
  resultDescription: IE,
  resultLinkIcon: EE,
  tooltip: TE,
  tooltipContent: $E,
  tooltipName: DE,
  tooltipNameIcon: RE,
  tooltipDescription: OE,
  tooltipSummary: PE,
  tooltipTag: AE
}, LE = ({
  item: e,
  jiraInstanceUrl: n,
  onSelect: r,
  disableTooltip: i = !1,
  ...a
}) => {
  const { issuetype: o, name: s, status: l, text: d, description: m } = e, [u, f] = se(!1), h = sx({
    avatarId: o?.avatarId,
    iconUrl: o?.iconUrl,
    jiraInstanceUrl: n
  });
  return /* @__PURE__ */ he.jsx(
    Ge,
    {
      disabled: i,
      className: ir.tooltip,
      content: /* @__PURE__ */ he.jsxs("div", { className: ir.tooltipContent, children: [
        /* @__PURE__ */ he.jsxs(
          b,
          {
            flexDirection: "row",
            justifyContent: "space-between",
            width: "100%",
            children: [
              /* @__PURE__ */ he.jsxs("span", { className: ir.tooltipName, children: [
                /* @__PURE__ */ he.jsx(
                  ks,
                  {
                    width: 16,
                    iconUrl: h,
                    className: ir.tooltipNameIcon
                  }
                ),
                " ",
                s
              ] }),
              /* @__PURE__ */ he.jsx(An, { className: ir.tooltipTag, children: l.name })
            ]
          }
        ),
        m && /* @__PURE__ */ he.jsx("div", { className: ir.tooltipSummary, children: m }),
        d && /* @__PURE__ */ he.jsx("div", { className: ir.tooltipDescription, children: d })
      ] }),
      side: "left",
      light: !0,
      children: /* @__PURE__ */ he.jsxs(
        "button",
        {
          ...a,
          className: ir.result,
          type: "button",
          onClick: () => {
            r(e);
          },
          onMouseEnter: () => f(!0),
          onMouseLeave: () => f(!1),
          children: [
            /* @__PURE__ */ he.jsxs(
              b,
              {
                flexDirection: "column",
                justifyContent: "center",
                style: {
                  width: u ? "calc(100% - 32px)" : "100%"
                },
                children: [
                  /* @__PURE__ */ he.jsx(b, { flexDirection: "row", children: /* @__PURE__ */ he.jsxs("span", { className: ir.resultName, children: [
                    /* @__PURE__ */ he.jsx(
                      ks,
                      {
                        width: 16,
                        iconUrl: h,
                        className: ir.resultNameIcon
                      }
                    ),
                    " ",
                    s
                  ] }) }),
                  m && /* @__PURE__ */ he.jsx("div", { className: ir.resultDescription, children: m })
                ]
              }
            ),
            u && /* @__PURE__ */ he.jsx(
              me,
              {
                className: ir.resultLinkIcon,
                name: "plus",
                size: 32
              }
            )
          ]
        }
      )
    }
  );
}, VE = ({
  className: e,
  searched: n,
  jiraInstanceUrl: r
}) => /* @__PURE__ */ he.jsx(
  jt,
  {
    slotEnd: /* @__PURE__ */ he.jsx(me, { name: "external-link" }),
    variant: "tertiary",
    style: { width: "100%" },
    className: e,
    navigate: () => {
      window.open(
        `${r}/secure/QuickSearch.jspa?searchString=${n}`,
        "_blank"
      )?.focus();
    },
    children: "View matching issues in Jira"
  }
), zE = ({
  onSelectIssue: e,
  jiraInstanceUrl: n,
  filterByProjectKey: r,
  disableTooltip: i
}) => {
  const { useLazyQuery: a } = mn(), [o, s] = se([]), [l, d] = se(""), [m, { loading: u, error: f, data: h, networkStatus: v }] = a(lx, {
    notifyOnNetworkStatusChange: !0
  }), { maybeExtractIssueKey: C } = cx(null, n);
  ki(
    () => {
      !u && l && v === Yt.ready ? m({
        variables: {
          jql: l,
          maxResults: 25
        }
      }) : s([]);
    },
    500,
    [l]
  ), He(() => {
    const T = h?.Jira?.searchAndReconsileIssuesUsingJql?.issues || [];
    s(
      T.map((E) => ({
        id: E?.key ?? "",
        name: E?.key ?? "",
        description: E?.fields.summary,
        status: E?.fields.status,
        issuetype: E?.fields.issuetype,
        text: E?.fields.description ? bp(E?.fields.description, ox) : /* @__PURE__ */ he.jsx(he.Fragment, {})
      }))
    );
  }, [h]);
  const S = (T) => {
    e(T.id), d("");
  }, j = (T) => {
    const E = T.trim(), D = C(E);
    if (D) {
      const B = D.replaceAll("[-_|]", "\\\\$0");
      d(`key = '${B}'`);
    } else E !== "" && d(
      `text ~ '${E}'${r ? " and project = " + r : ""}`
    );
  }, F = () => {
    d("");
  }, y = (T) => /* @__PURE__ */ he.jsx(VE, { ...T, jiraInstanceUrl: n }), q = (T) => /* @__PURE__ */ he.jsx(
    LE,
    {
      ...T,
      jiraInstanceUrl: n,
      disableTooltip: i
    }
  );
  return !u && f ? /* @__PURE__ */ he.jsx(Fn, { error: f }) : /* @__PURE__ */ he.jsx(
    Sr,
    {
      items: o,
      loading: u,
      onSearch: j,
      onSelect: S,
      onClear: F,
      emptyMessage: l ? u ? "" : "No Jira Issues found" : "Enter Jira issue key, link or search terms",
      suggestionComponent: y,
      itemComponent: q,
      placeholder: "Search and link existing issue",
      searchable: !0,
      clearable: !0
    }
  );
}, UE = ({
  field: e,
  value: n,
  onChange: r
}) => {
  const [i, a] = se(n ? [n] : []), o = (s, l) => {
    a(
      l ? [...i, s] : i.filter(({ id: d }) => d !== s.id)
    );
  };
  return He(() => {
    r(i);
  }, [i]), /* @__PURE__ */ he.jsx(
    Sr,
    {
      multiple: !0,
      onChange: o,
      selectedItems: i,
      items: e?.allowedValues?.map(
        ({ id: s, name: l, value: d }) => ({
          id: s,
          name: l || d
        })
      )
    }
  );
}, ME = "_itemButton_1hl53_1", BE = "_result_1hl53_6", qE = "_resultIcon_1hl53_26", HE = "_resultName_1hl53_30", WE = "_resultCheckIcon_1hl53_38", pa = {
  itemButton: ME,
  result: BE,
  resultIcon: qE,
  resultName: HE,
  resultCheckIcon: WE
}, rm = ({
  item: e,
  checked: n = !1,
  onSelectItem: r,
  jiraInstanceUrl: i
}) => {
  const a = (s) => {
    const l = s.indexOf("/rest/api/");
    return l >= 0 ? `${i}${s?.substring(l)}` : s;
  };
  let o = e?.iconUrl || e?.avatarUrls?._24x24 || null;
  return o && (o = o?.startsWith("https://api.atlassian.com/ex/") ? a(o) : o), /* @__PURE__ */ he.jsx(
    b,
    {
      flexDirection: "column",
      justifyContent: "center",
      width: "100%",
      "data-testid": "jira-select-item-component",
      children: /* @__PURE__ */ he.jsx(
        "button",
        {
          onClick: () => {
            r(e);
          },
          className: pa.itemButton,
          children: /* @__PURE__ */ he.jsxs(b, { className: pa.result, flexDirection: "row", width: "100%", children: [
            /* @__PURE__ */ he.jsx(
              ks,
              {
                width: 36,
                iconUrl: o || "",
                className: pa.resultIcon
              }
            ),
            /* @__PURE__ */ he.jsx(Zn, { className: pa.resultName, children: e.name }),
            n && /* @__PURE__ */ he.jsx(Zn, { className: pa.resultCheckIcon, children: /* @__PURE__ */ he.jsx(me, { name: "done" }) })
          ] })
        }
      )
    }
  );
}, KE = ({
  selectedItems: e,
  agentEmail: n,
  onSelect: r,
  jiraInstanceUrl: i
}) => {
  const { useLazyQuery: a } = mn(), [o, s] = se([]), [l, d] = se(), m = 2, [u, { loading: f, error: h, data: v, networkStatus: C }] = a(xE, {
    notifyOnNetworkStatusChange: !0
  });
  return ki(
    () => {
      !f && l && l.length >= m && C === Yt.ready ? u({
        variables: {
          query: l,
          maxResults: 10
        }
      }) : s([]);
    },
    500,
    [l]
  ), He(() => {
    n && u({
      variables: {
        query: n,
        maxResults: 1
      }
    }).then((S) => {
      if (S?.data?.Jira.findUsers?.length === 1) {
        const j = S?.data?.Jira?.findUsers[0];
        r(j.accountId), s([
          {
            id: j.accountId,
            name: j.displayName
          }
        ]);
      }
    });
  }, []), He(() => {
    const S = v?.Jira?.findUsers || [];
    s(
      S.filter(({ active: j }) => j).map(({ accountId: j, displayName: F, avatarUrls: y, active: q }) => ({
        id: j,
        name: F,
        avatarUrls: y,
        active: q
      }))
    );
  }, [v]), !f && h ? /* @__PURE__ */ he.jsx(Fn, { error: h }) : /* @__PURE__ */ he.jsx(
    Sr,
    {
      clearable: !0,
      searchable: !0,
      items: o,
      loading: f,
      onSearch: (S) => d(S),
      onSelect: r,
      onClear: () => d(void 0),
      selectedItems: e,
      emptyMessage: l ? f ? "" : "No user found" : "Enter keyword to search for user",
      itemComponent: ({ item: S, onSelect: j, checked: F }) => /* @__PURE__ */ he.jsx(
        rm,
        {
          item: S,
          checked: F,
          onSelectItem: j,
          jiraInstanceUrl: i
        }
      ),
      placeholder: "Search Jira users"
    }
  );
}, ev = ({
  field: e
}) => {
  const [n, r] = se(!1), [i, a] = v_();
  return He(() => {
    const o = n ? window.setTimeout(() => r(!1), 2e3) : void 0;
    return () => window.clearTimeout(o);
  }, [n]), /* @__PURE__ */ he.jsxs(b, { alignItems: "center", gap: "400", justifyContent: "space-between", children: [
    /* @__PURE__ */ he.jsx(b, { children: /* @__PURE__ */ he.jsx(me, { size: 24, name: "exclamation-triangle-filled", color: "red.500" }) }),
    /* @__PURE__ */ he.jsx(A.Paragraph, { children: "Your organizations Jira configuration is currently not fully supported by Dixa. Please reach out so we can have a look at this field. Please, attach a copy of the field details when contacting us. You can use the copy button to do so." }),
    /* @__PURE__ */ he.jsx(Ge, { content: n ? "Copied" : "Copy field details", children: /* @__PURE__ */ he.jsx(
      Qt,
      {
        variant: "secondary",
        icon: n ? "done" : "copy",
        onClick: () => {
          a(JSON.stringify(e, null, 2)), r(!0);
        }
      }
    ) })
  ] });
}, GE = ({
  field: e,
  onChange: n,
  value: r,
  conversationContext: i,
  jiraInstanceUrl: a
}) => {
  const { type: o, system: s } = e.schema;
  if (["array", "option", "priority"].includes(o) && (!e?.allowedValues || e.allowedValues.length === 0))
    return /* @__PURE__ */ he.jsx(ev, { field: e });
  switch (o) {
    case "issuelink":
    case "environment":
    case "any":
      return /* @__PURE__ */ he.jsx(_r, { onChange: n, value: r });
    case "string":
      return s === "description" ? /* @__PURE__ */ he.jsx(Ku, { onChange: n, value: r }) : /* @__PURE__ */ he.jsx(_r, { onChange: n, value: r });
    case "textarea":
      return /* @__PURE__ */ he.jsx(Ku, { onChange: n, value: r });
    case "number":
      return /* @__PURE__ */ he.jsx(_r, { type: "number", onChange: n, value: r });
    case "user":
      return /* @__PURE__ */ he.jsx(
        KE,
        {
          onSelect: n,
          selectedItems: r ? [r] : [],
          agentEmail: e.key === "reporter" && i?.agent?.email || void 0,
          jiraInstanceUrl: a
        }
      );
    case "option":
    case "priority":
      return /* @__PURE__ */ he.jsx(
        Sr,
        {
          onSelect: n,
          selectedItems: r ? [r] : [],
          items: e?.allowedValues?.map(
            ({ id: l, name: d, value: m }) => ({
              id: l,
              name: d || m
            })
          ) || []
        }
      );
    case "array":
      return /* @__PURE__ */ he.jsx(UE, { field: e, value: r, onChange: n });
    default:
      return /* @__PURE__ */ he.jsx(ev, { field: e });
  }
}, YE = ["description", "reporter", "summary"], QE = ({
  issueTypeFields: e,
  control: n,
  jiraInstanceUrl: r,
  conversationContext: i,
  errors: a
}) => /* @__PURE__ */ he.jsx(he.Fragment, { children: e.filter(({ key: o }) => o !== "project" && o !== "issuetype").filter(
  ({ key: o, required: s }) => s || YE.includes(o)
).map((o) => /* @__PURE__ */ he.jsx(
  zt,
  {
    control: n,
    render: ({ field: { onChange: s, value: l } }) => /* @__PURE__ */ he.jsx(
      En,
      {
        meta: {
          error: a && o.key in a ? a[o.key].message : null
        },
        label: o.name,
        required: o.required,
        children: GE({
          field: o,
          onChange: s,
          value: l,
          conversationContext: i,
          jiraInstanceUrl: r
        })
      },
      o.key
    ),
    name: o.key,
    rules: {
      required: o.required ? "This field is required" : !1
    }
  },
  o.key
)) }), JE = ({
  createdIssue: e,
  issueBaseLink: n,
  issueLinkCopied: r,
  setIssueLinkCopied: i,
  copyToClipboard: a
}) => /* @__PURE__ */ he.jsxs(
  b,
  {
    flexDirection: "column",
    gap: "400",
    "data-testid": "jira-create-issue-success-message",
    children: [
      /* @__PURE__ */ he.jsxs(A.Paragraph, { children: [
        "You can visit your new issue by following",
        " ",
        /* @__PURE__ */ he.jsxs(
          A.ExternalLink,
          {
            href: `${n}/${e.key}`,
            target: "_blank",
            children: [
              "this link ",
              /* @__PURE__ */ he.jsx(me, { name: "external-link" })
            ]
          }
        ),
        " ",
        "or copy it from the field below."
      ] }),
      /* @__PURE__ */ he.jsx(En, { label: "Jira issue link", children: /* @__PURE__ */ he.jsx(
        _r,
        {
          readOnly: !0,
          value: `${n}/${e.key}`,
          suffix: {
            type: "button",
            button: {
              icon: r ? "done" : "copy",
              onClick: () => {
                i(!0), a(`${n}/${e.key}`);
              }
            }
          }
        }
      ) })
    ]
  }
), XE = "_modalBody_1hk1o_1", ZE = "_modalBodyFormFields_1hk1o_4", nv = {
  modalBody: XE,
  modalBodyFormFields: ZE
}, eT = (e) => ({
  version: 1,
  type: "doc",
  content: e?.trim()?.split(`
`).filter((n) => n !== "").map((n) => ({
    type: "paragraph",
    content: [
      {
        type: "text",
        text: n
      }
    ]
  }))
}), nT = (e) => e?.custom?.split(":")?.[1] || null, tT = (e, n) => {
  if (e.startsWith("customfield_")) {
    const r = n.find((i) => i.key === e)?.schema;
    if (r)
      return r;
  }
  return null;
}, rT = (e, n) => {
  const r = ["environment", "textarea", "description"];
  return {
    fields: {
      ...Object.entries(e).reduce((i, [a, o]) => {
        if (!o || o === "")
          return delete e[a], i;
        const s = tT(a, n), l = nT(s) ?? a;
        return r.includes(l) ? i[a] = eT(o) : s?.type === "number" ? i[a] = parseInt(o) : i[a] = o, i;
      }, {}),
      summary: e.summary,
      project: { id: e.project.id },
      issuetype: { id: e.issuetype.id },
      ...e?.parent && { parent: { key: e.parent } },
      ...e?.reporter && {
        reporter: { id: e.reporter?.id ?? e.reporter }
      },
      ...e?.assignee && {
        assignee: { id: e.assignee?.id ?? e.assignee }
      }
    }
  };
}, iT = ({
  isOpen: e,
  onClose: n,
  linkIssueQuietly: r,
  conversationContext: i,
  jiraInstanceUrl: a,
  hasSortIssueTypeByLabelEnabled: o
}) => {
  const s = { project: void 0, issuetype: void 0 }, [l, d] = se([]), [m, u] = se(), [f, h] = se(0), [v, C] = se([]), [S, j] = se([]), [F, y] = se(!1), [q, T] = se(!1), [E, D] = se({}), { track: B } = bn(), { isCopied: ee, copyToClipboard: J } = jE(), ae = Bn(() => i?.conversationId, [e]), { useMutation: Q, useLazyQuery: U, showNotification: O } = mn(), {
    control: H,
    handleSubmit: Z,
    formState: { errors: ye },
    reset: ce,
    setValue: le,
    getValues: ue
  } = Bt({
    defaultValues: s
  }), W = S.length > 0, ke = `${a}/browse`, Ee = Object.keys(E).length > 0, [K, { loading: qe, error: Be }] = U(kE, {
    fetchPolicy: "no-cache",
    notifyOnNetworkStatusChange: !0,
    onCompleted: (fe) => {
      d(fe.Jira.getAllProjects);
    },
    onError: (fe) => {
      O({
        title: "Could not get project list",
        text: "We could not fetch the list of your projects. Please try again later.",
        icon: "exclamation-triangle-filled",
        severity: "warning"
      }), console.warn("Error response when fetching projects", fe), d([]);
    }
  }), [
    Pe,
    { loading: Me, error: Fe }
  ] = U(bE, {
    fetchPolicy: "no-cache",
    notifyOnNetworkStatusChange: !0,
    onCompleted: (fe) => {
      h(0);
      const Te = fe?.Jira?.getCreateIssueMeta?.projects[0];
      if (Te) {
        const Le = Te?.issuetypes.filter(
          ({ subtask: Re }) => !Re
        );
        C(Le || []), le(
          "issuetype",
          Le.length > 0 ? Le[0] : void 0
        );
      } else
        O({
          title: "Could not get issue-type list",
          text: "It seems that there are no issue-types for this project or you might not have the necessary access rights to view them.",
          icon: "exclamation-triangle-filled",
          severity: "warning"
        }), C([]), j([]);
    },
    onError: (fe) => {
      O({
        title: "Could not get issue list",
        text: "We could not fetch the list of issue-types for this project. Please try again later.",
        icon: "exclamation-triangle-filled",
        severity: "warning"
      }), console.warn("Error in getCreateIssueMeta", fe), C([]), j([]), h(0);
    }
  }), [Ae, { error: $e }] = Q(
    _E,
    {
      onError: () => {
        y(!1), O({
          title: "Creation was not successful",
          text: "Please try again later or contact your admin.",
          icon: "exclamation-triangle-filled",
          severity: "warning"
        }), B("jira:issue:create:failed", { jiraInstanceUrl: a });
      },
      onCompleted: (fe) => {
        if (y(!1), fe?.Jira && "key" in fe.Jira.createIssue)
          u(fe?.Jira?.createIssue), O({
            title: "Success",
            text: `Jira issue '${fe.Jira.createIssue.key}' created`,
            icon: "check-circle-filled",
            severity: "success"
          }), B("jira:issue:create:succeeded", {
            jiraInstanceUrl: a,
            jiraIssueKey: fe.Jira.createIssue.key
          }), ae && r(
            fe.Jira.createIssue.key,
            ae
          );
        else if ("errorMessages" in fe.Jira.createIssue || "errors" in fe.Jira.createIssue) {
          const Te = fe?.Jira?.createIssue?.errors;
          console.warn("There was a problem creating a Jira issue.", Te), O({
            title: "Creation was not successful",
            text: "Something went wrong. Please get in contact with Dixa.",
            icon: "exclamation-triangle-filled",
            severity: "warning"
          });
        }
      }
    }
  ), tn = (fe) => {
    y(!0), D({}), Ae({
      variables: {
        input: rT(fe, S)
      }
    });
  };
  He(() => {
    if (e)
      try {
        K();
      } catch (fe) {
        console.warn("Error when fetching initial projects", fe);
      }
  }, [e]), He(() => {
    const fe = q ? window.setTimeout(() => T(!1), 2e3) : void 0;
    return () => window.clearTimeout(fe);
  }, [q]), He(() => {
    if (v?.length > 0) {
      le("issuetype", v[f]);
      const fe = v[f]?.fields?.additionalProperties;
      if (fe?.length > 0) {
        const Te = fe.map(
          ({ value: w }) => w
        ), Le = (o ? Te.sort(({ name: w }, { name: _ }) => w.localeCompare(_)) : Te).sort(
          ({ required: w }, { required: _ }) => Number(_) - Number(w)
        ), { project: Re, issuetype: sn } = ue();
        ce({ project: Re, issuetype: sn }), j(Le);
      }
    } else
      j([]), le("issuetype", void 0);
  }, [v, le, f]), He(() => {
    if ($e && Vb($e)) {
      if ($e?.graphQLErrors?.length > 0) {
        const { graphQLErrors: fe } = $e, Te = fe[0].extensions?.integration?.responseBody;
        try {
          const Le = JSON.parse(Te);
          if (Le?.errors) {
            const Re = Object.keys(Le.errors).reduce(
              (sn, w) => ({
                ...sn,
                [w]: {
                  type: "required",
                  message: Le.errors[w],
                  ref: {
                    name: w
                  }
                }
              }),
              {}
            );
            D(Re);
          }
        } catch {
        }
      }
    } else
      D({});
  }, [$e]);
  const Ie = () => {
    d([]), j([]), C([]), u(void 0), h(0), y(!1), D({});
  }, We = () => {
    Ie(), ce(s), n();
  }, Ze = (fe) => {
    fe && Pe({
      variables: {
        projectKey: fe
      }
    });
  }, de = (fe) => {
    const Te = v.map((Le) => Le.id).indexOf(fe);
    h(Te ?? 0);
  };
  return /* @__PURE__ */ he.jsxs(
    wt,
    {
      isOpen: e,
      "data-testid": "jira-create-issue-modal",
      onClose: We,
      children: [
        /* @__PURE__ */ he.jsx(
          Ct,
          {
            title: m ? "Issue creation successful" : "Create new Jira issue",
            onClose: We
          }
        ),
        /* @__PURE__ */ he.jsxs(Ft, { className: nv.modalBody, children: [
          !qe && Be && /* @__PURE__ */ he.jsx(Fn, { error: Be, retry: K }),
          !Me && Fe && /* @__PURE__ */ he.jsx(
            Fn,
            {
              error: Fe,
              retry: Pe
            }
          ),
          !F && Ee && /* @__PURE__ */ he.jsx(b, { margin: "0 0 400", children: /* @__PURE__ */ he.jsx(
            Rs,
            {
              variant: "warning",
              description: /* @__PURE__ */ he.jsxs(
                b,
                {
                  gap: "300",
                  flexDirection: "column",
                  alignItems: "flex-start",
                  children: [
                    /* @__PURE__ */ he.jsx(A.Paragraph, { variant: "4", children: "The form contains input validation errors. Please correct them and try again to save. If your inputs seem fine, please contact our support team and provide the form schema to debug further." }),
                    /* @__PURE__ */ he.jsx(
                      Wn,
                      {
                        icon: ee ? "done" : "copy",
                        variant: "secondary",
                        onClick: () => J(JSON.stringify(S, null, 2)),
                        children: "Copy form schema"
                      }
                    )
                  ]
                }
              )
            }
          ) }),
          m ? /* @__PURE__ */ he.jsx(
            JE,
            {
              createdIssue: m,
              issueBaseLink: ke,
              issueLinkCopied: q,
              setIssueLinkCopied: T,
              copyToClipboard: J
            }
          ) : /* @__PURE__ */ he.jsx(
            "form",
            {
              "data-testid": "jira-create-issue-form",
              onSubmit: Z(tn),
              children: /* @__PURE__ */ he.jsxs(vt, { children: [
                /* @__PURE__ */ he.jsx(ze, { span: 3, children: /* @__PURE__ */ he.jsx(En, { label: "Project", required: !0, children: /* @__PURE__ */ he.jsx(
                  zt,
                  {
                    control: H,
                    name: "project",
                    rules: { required: "Please select a project" },
                    render: ({ field: { onChange: fe, value: Te } }) => /* @__PURE__ */ he.jsx(
                      Sr,
                      {
                        searchable: !0,
                        loading: qe,
                        onSelect: (Le) => {
                          Ze(Le.key), fe(Le);
                        },
                        selectedItems: [Te],
                        placeholder: "Select Jira project",
                        emptyMessage: Be ? "No projects found" : "No projects available",
                        items: l || [],
                        itemComponent: ({ item: Le, onSelect: Re, checked: sn }) => /* @__PURE__ */ he.jsx(
                          rm,
                          {
                            item: Le,
                            checked: sn,
                            onSelectItem: Re,
                            jiraInstanceUrl: a
                          }
                        )
                      }
                    )
                  }
                ) }) }),
                /* @__PURE__ */ he.jsx(ze, { span: 3, children: /* @__PURE__ */ he.jsx(En, { label: "Issue type", required: !0, children: /* @__PURE__ */ he.jsx(
                  zt,
                  {
                    control: H,
                    name: "issuetype",
                    rules: { required: "Please select an issue type" },
                    render: ({ field: { onChange: fe, value: Te } }) => /* @__PURE__ */ he.jsx(
                      Sr,
                      {
                        disabled: v.length === 0,
                        loading: Me,
                        onSelect: (Le) => {
                          de(Le.id), fe(Le);
                        },
                        selectedItems: [Te],
                        placeholder: v.length > 0 ? "Select Jira issue type" : "",
                        emptyMessage: Fe ? "No issues found" : "No issues available",
                        items: v,
                        itemComponent: ({ item: Le, onSelect: Re, checked: sn }) => /* @__PURE__ */ he.jsx(
                          rm,
                          {
                            item: Le,
                            checked: sn,
                            onSelectItem: Re,
                            jiraInstanceUrl: a
                          }
                        )
                      }
                    )
                  }
                ) }) }),
                W && // Wrapping all dynamic input fields inside one `FormField`
                // which can handle the overflow scrolling in case we get many
                // input fields in the form
                /* @__PURE__ */ he.jsx(ze, { className: nv.modalBodyFormFields, children: /* @__PURE__ */ he.jsx(
                  QE,
                  {
                    control: H,
                    errors: { ...ye, ...E },
                    getValues: ue,
                    conversationContext: i,
                    jiraInstanceUrl: a,
                    issueTypeFields: S
                  }
                ) })
              ] })
            }
          )
        ] }),
        /* @__PURE__ */ he.jsx(
          Tt,
          {
            confirmOnClick: m ? We : Z(tn),
            confirmProps: {
              disabled: !W,
              isLoading: F,
              loadingIndicator: /* @__PURE__ */ he.jsx(cn, { size: 16 })
            },
            confirmName: m ? "Close" : "Save",
            cancelOnClick: m ? void 0 : We
          }
        )
      ]
    }
  );
}, aT = (e) => {
  if (!e) return "";
  const n = "https://", r = (e.startsWith(n) ? e.slice(n.length) : e).split("/")[0];
  return `${n}${r}`;
}, oT = (e) => {
  if (!e?.trim())
    return "Please add a value";
  const n = "https://";
  if (e.startsWith(" ") || e.endsWith(" "))
    return "Please remove any empty spaces before or after the URL";
  const r = e.startsWith(n);
  if (r) {
    const i = e.slice(n.length).split("/");
    if (i.length > 1) {
      const a = r ? n.length + i[0].length : i[0].length;
      return i.length === 2 && i[1] === "" ? "Please remove the trailing slash `/`" : `Please remove the trailing path \`${e.slice(a)}\``;
    }
  } else
    return e.includes("://") ? `The protocol \`${e.substring(
      0,
      e.indexOf("://") + 3
    )}\` is not supported` : `Please add \`${n}\` as protocol`;
}, sT = "_wrapper_1bylq_1", lT = "_inputWrapper_1bylq_6", cT = "_inputSeparator_1bylq_18", dT = "_buttonLink_1bylq_23", uT = "_noIssuesFound_1bylq_27", fa = {
  wrapper: sT,
  inputWrapper: lT,
  inputSeparator: cT,
  buttonLink: dT,
  noIssuesFound: uT
}, mT = ({
  conversationContext: e,
  settings: n
}) => {
  const { track: r } = bn(), i = aT(n?.jiraSiteUrl), [a, o] = se(!1), s = !!e?.conversationId, {
    linkIssue: l,
    linkIssueQuietly: d,
    unlinkIssue: m,
    unlinkAllIssues: u,
    loadIssues: f,
    removeDanglingIssueLinks: h,
    danglingIssueLinks: v,
    isLoadingIssueLinks: C,
    isLoadingIssues: S,
    issues: j,
    error: F
  } = cx(
    s ? e.conversationId : null,
    i
  ), y = !!n?.enableCreateIssue, q = !!n?.enableSortIssueTypeByLabel, T = !!(j?.length || v?.length), E = !!n?.enableRemoveAllLinks && T, D = !C && !S && v?.length > 0 && !!n?.showDanglingLinks;
  return !S && F ? /* @__PURE__ */ he.jsx(Fn, { error: F, retry: () => f() }) : /* @__PURE__ */ he.jsxs(he.Fragment, { children: [
    /* @__PURE__ */ he.jsxs(b, { className: fa.wrapper, flexDirection: "column", children: [
      /* @__PURE__ */ he.jsxs(b, { className: fa.inputWrapper, flexDirection: "column", children: [
        y && /* @__PURE__ */ he.jsxs(he.Fragment, { children: [
          /* @__PURE__ */ he.jsx(
            Wn,
            {
              variant: "primary",
              onClick: () => o(!0),
              style: {
                minHeight: "38px"
              },
              children: "Create new issue"
            }
          ),
          /* @__PURE__ */ he.jsx("div", { className: fa.inputSeparator, children: "or" })
        ] }),
        /* @__PURE__ */ he.jsx(
          zE,
          {
            onSelectIssue: l,
            jiraInstanceUrl: i
          }
        )
      ] }),
      S ? /* @__PURE__ */ he.jsx(b, { justifyContent: "center", margin: "0 0 300 0", children: /* @__PURE__ */ he.jsx(cn, { "data-testid": "jira-widget-issue-spinner" }) }) : j?.length ? /* @__PURE__ */ he.jsx(
        lE,
        {
          issues: j,
          jiraInstanceUrl: i,
          unlinkIssue: m
        }
      ) : /* @__PURE__ */ he.jsx(A.Paragraph, { align: "center", className: fa.noIssuesFound, children: "No linked issues found" }),
      E && j?.length > 0 && /* @__PURE__ */ he.jsx(
        Wn,
        {
          variant: "secondary",
          disabled: !j?.length && !v?.length,
          onClick: u,
          children: "Unlink all issues"
        }
      ),
      D && /* @__PURE__ */ he.jsxs(
        b,
        {
          background: "neutral.100",
          padding: "300",
          borderRadius: "100",
          flexDirection: "column",
          gap: "200",
          children: [
            /* @__PURE__ */ he.jsx(A.Heading, { variant: "heading-3", children: "Unresolved linked issues" }),
            /* @__PURE__ */ he.jsx(b, { flexDirection: "row", flexWrap: "wrap", gap: "100", children: v.map((B) => /* @__PURE__ */ he.jsx(An, { onDelete: () => m(B), children: B }, B)) }),
            /* @__PURE__ */ he.jsx(
              Wn,
              {
                variant: "secondary",
                onClick: () => h(),
                icon: "link-slash",
                children: "Remove all unresolved issues"
              }
            )
          ]
        }
      ),
      /* @__PURE__ */ he.jsx(
        jt,
        {
          slotEnd: /* @__PURE__ */ he.jsx(me, { name: "external-link" }),
          variant: "tertiary",
          className: fa.buttonLink,
          navigate: () => {
            r("jira:view:jira:clicked", { jiraInstanceUrl: i }), window.open(i, "_blank")?.focus();
          },
          children: "Open Jira"
        }
      )
    ] }),
    a && /* @__PURE__ */ he.jsx(
      iT,
      {
        isOpen: a,
        onClose: () => o(!1),
        linkIssueQuietly: d,
        conversationContext: e,
        jiraInstanceUrl: i,
        hasSortIssueTypeByLabelEnabled: q
      }
    )
  ] });
}, tv = [
  {
    key: "jiraSiteUrl",
    label: "Jira site URL",
    placeholder: 'Insert your Jira site URL, e.g. "https://your-site.atlassian.net/"',
    secret: !1,
    type: "input",
    required: !0,
    customValidation: (e) => oT(e),
    defaultValue: ""
  },
  {
    key: "authorizeWithOauth",
    label: "Authorize with OAuth",
    secret: !1,
    type: "custom",
    hideOnCreate: !0,
    component: vi
  },
  {
    key: "enableRemoveAllLinks",
    label: 'Enable the "Remove all links" button',
    secret: !1,
    type: "switch",
    defaultValue: !1
  },
  {
    key: "showDanglingLinks",
    label: "Show unresolved links to Jira issues",
    secret: !1,
    type: "switch",
    defaultValue: !1
  },
  {
    key: "enableCreateIssue",
    label: 'Enable the "Create issue" button',
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "enableSortIssueTypeByLabel",
    label: "Enable to sort the issue types by label",
    secret: !1,
    type: "switch",
    defaultValue: !1
  }
];
(function() {
  try {
    if (typeof document < "u") {
      var e = document.createElement("style");
      e.appendChild(document.createTextNode("._notificationText_1polx_1{color:var(--dixa-color-neutral-500)}._message_1vrar_48{padding:var(--dixa-size-spacer-250);border-radius:var(--dixa-size-border-radius-100);border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300)}._message_1vrar_48:hover,._messageIsOpen_1vrar_56{border-color:var(--dixa-color-neutral-400)}._messageHeader_1vrar_59{cursor:pointer}._messageUnattended_1vrar_62{text-decoration:line-through}._messageLabel_1vrar_65{color:var(--dixa-typography-color-secondary)}._messageText_1vrar_68{max-height:150px;overflow:scroll;padding:var(--dixa-size-spacer-100) var(--dixa-size-spacer-200);border:1px solid var(--dixa-color-neutral-200);border-radius:var(--dixa-size-border-radius-100);overflow:hidden;overflow-y:auto;overflow-x:auto}._messageText_1vrar_68::-webkit-scrollbar{width:7px;height:7px}._messageText_1vrar_68::-webkit-scrollbar-track{background-color:var(--dixa-color-neutral-200)}._messageText_1vrar_68::-webkit-scrollbar-thumb{background-color:var(--dixa-color-neutral-400);border-radius:5px}._list_ld0hf_1{padding:0}._listItem_ld0hf_4{padding:var(--dixa-size-spacer-100);border-bottom:var(--dixa-size-border-100) solid var(--dixa-color-neutral-200)}._listItem_ld0hf_4:last-child{border-bottom:none}._tagHover_kzbzk_1:hover{cursor:pointer;border-color:var(--dixa-color-neutral-400)}._channelUnsubscribed_kzbzk_6{color:var(--dixa-color-neutral-500)}._subscriptionError_1qhhx_1{color:var(--dixa-typography-color-error);font-size:var(--dixa-typography-size-200)}")), document.head.appendChild(e);
    }
  } catch (n) {
    console.error("vite-plugin-css-injected-by-js", n);
  }
})();
var tu = { exports: {} }, ha = {}, rv;
function pT() {
  if (rv) return ha;
  rv = 1;
  var e = je, n = Symbol.for("react.element"), r = Symbol.for("react.fragment"), i = Object.prototype.hasOwnProperty, a = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, o = { key: !0, ref: !0, __self: !0, __source: !0 };
  function s(l, d, m) {
    var u, f = {}, h = null, v = null;
    m !== void 0 && (h = "" + m), d.key !== void 0 && (h = "" + d.key), d.ref !== void 0 && (v = d.ref);
    for (u in d) i.call(d, u) && !o.hasOwnProperty(u) && (f[u] = d[u]);
    if (l && l.defaultProps) for (u in d = l.defaultProps, d) f[u] === void 0 && (f[u] = d[u]);
    return { $$typeof: n, type: l, key: h, ref: v, props: f, _owner: a.current };
  }
  return ha.Fragment = r, ha.jsx = s, ha.jsxs = s, ha;
}
var Fo = {}, iv;
function fT() {
  return iv || (iv = 1, process.env.NODE_ENV !== "production" && (function() {
    var e = je, n = Symbol.for("react.element"), r = Symbol.for("react.portal"), i = Symbol.for("react.fragment"), a = Symbol.for("react.strict_mode"), o = Symbol.for("react.profiler"), s = Symbol.for("react.provider"), l = Symbol.for("react.context"), d = Symbol.for("react.forward_ref"), m = Symbol.for("react.suspense"), u = Symbol.for("react.suspense_list"), f = Symbol.for("react.memo"), h = Symbol.for("react.lazy"), v = Symbol.for("react.offscreen"), C = Symbol.iterator, S = "@@iterator";
    function j(t) {
      if (t === null || typeof t != "object")
        return null;
      var c = C && t[C] || t[S];
      return typeof c == "function" ? c : null;
    }
    var F = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function y(t) {
      {
        for (var c = arguments.length, p = new Array(c > 1 ? c - 1 : 0), g = 1; g < c; g++)
          p[g - 1] = arguments[g];
        q("error", t, p);
      }
    }
    function q(t, c, p) {
      {
        var g = F.ReactDebugCurrentFrame, P = g.getStackAddendum();
        P !== "" && (c += "%s", p = p.concat([P]));
        var L = p.map(function(I) {
          return String(I);
        });
        L.unshift("Warning: " + c), Function.prototype.apply.call(console[t], console, L);
      }
    }
    var T = !1, E = !1, D = !1, B = !1, ee = !1, J;
    J = Symbol.for("react.module.reference");
    function ae(t) {
      return !!(typeof t == "string" || typeof t == "function" || t === i || t === o || ee || t === a || t === m || t === u || B || t === v || T || E || D || typeof t == "object" && t !== null && (t.$$typeof === h || t.$$typeof === f || t.$$typeof === s || t.$$typeof === l || t.$$typeof === d || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      t.$$typeof === J || t.getModuleId !== void 0));
    }
    function Q(t, c, p) {
      var g = t.displayName;
      if (g)
        return g;
      var P = c.displayName || c.name || "";
      return P !== "" ? p + "(" + P + ")" : p;
    }
    function U(t) {
      return t.displayName || "Context";
    }
    function O(t) {
      if (t == null)
        return null;
      if (typeof t.tag == "number" && y("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof t == "function")
        return t.displayName || t.name || null;
      if (typeof t == "string")
        return t;
      switch (t) {
        case i:
          return "Fragment";
        case r:
          return "Portal";
        case o:
          return "Profiler";
        case a:
          return "StrictMode";
        case m:
          return "Suspense";
        case u:
          return "SuspenseList";
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case l:
            var c = t;
            return U(c) + ".Consumer";
          case s:
            var p = t;
            return U(p._context) + ".Provider";
          case d:
            return Q(t, t.render, "ForwardRef");
          case f:
            var g = t.displayName || null;
            return g !== null ? g : O(t.type) || "Memo";
          case h: {
            var P = t, L = P._payload, I = P._init;
            try {
              return O(I(L));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var H = Object.assign, Z = 0, ye, ce, le, ue, W, ke, Ee;
    function K() {
    }
    K.__reactDisabledLog = !0;
    function qe() {
      {
        if (Z === 0) {
          ye = console.log, ce = console.info, le = console.warn, ue = console.error, W = console.group, ke = console.groupCollapsed, Ee = console.groupEnd;
          var t = {
            configurable: !0,
            enumerable: !0,
            value: K,
            writable: !0
          };
          Object.defineProperties(console, {
            info: t,
            log: t,
            warn: t,
            error: t,
            group: t,
            groupCollapsed: t,
            groupEnd: t
          });
        }
        Z++;
      }
    }
    function Be() {
      {
        if (Z--, Z === 0) {
          var t = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: H({}, t, {
              value: ye
            }),
            info: H({}, t, {
              value: ce
            }),
            warn: H({}, t, {
              value: le
            }),
            error: H({}, t, {
              value: ue
            }),
            group: H({}, t, {
              value: W
            }),
            groupCollapsed: H({}, t, {
              value: ke
            }),
            groupEnd: H({}, t, {
              value: Ee
            })
          });
        }
        Z < 0 && y("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var Pe = F.ReactCurrentDispatcher, Me;
    function Fe(t, c, p) {
      {
        if (Me === void 0)
          try {
            throw Error();
          } catch (P) {
            var g = P.stack.trim().match(/\n( *(at )?)/);
            Me = g && g[1] || "";
          }
        return `
` + Me + t;
      }
    }
    var Ae = !1, $e;
    {
      var tn = typeof WeakMap == "function" ? WeakMap : Map;
      $e = new tn();
    }
    function Ie(t, c) {
      if (!t || Ae)
        return "";
      {
        var p = $e.get(t);
        if (p !== void 0)
          return p;
      }
      var g;
      Ae = !0;
      var P = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var L;
      L = Pe.current, Pe.current = null, qe();
      try {
        if (c) {
          var I = function() {
            throw Error();
          };
          if (Object.defineProperty(I.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(I, []);
            } catch (ne) {
              g = ne;
            }
            Reflect.construct(t, [], I);
          } else {
            try {
              I.call();
            } catch (ne) {
              g = ne;
            }
            t.call(I.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (ne) {
            g = ne;
          }
          t();
        }
      } catch (ne) {
        if (ne && g && typeof ne.stack == "string") {
          for (var N = ne.stack.split(`
`), te = g.stack.split(`
`), x = N.length - 1, V = te.length - 1; x >= 1 && V >= 0 && N[x] !== te[V]; )
            V--;
          for (; x >= 1 && V >= 0; x--, V--)
            if (N[x] !== te[V]) {
              if (x !== 1 || V !== 1)
                do
                  if (x--, V--, V < 0 || N[x] !== te[V]) {
                    var X = `
` + N[x].replace(" at new ", " at ");
                    return t.displayName && X.includes("<anonymous>") && (X = X.replace("<anonymous>", t.displayName)), typeof t == "function" && $e.set(t, X), X;
                  }
                while (x >= 1 && V >= 0);
              break;
            }
        }
      } finally {
        Ae = !1, Pe.current = L, Be(), Error.prepareStackTrace = P;
      }
      var we = t ? t.displayName || t.name : "", Se = we ? Fe(we) : "";
      return typeof t == "function" && $e.set(t, Se), Se;
    }
    function We(t, c, p) {
      return Ie(t, !1);
    }
    function Ze(t) {
      var c = t.prototype;
      return !!(c && c.isReactComponent);
    }
    function de(t, c, p) {
      if (t == null)
        return "";
      if (typeof t == "function")
        return Ie(t, Ze(t));
      if (typeof t == "string")
        return Fe(t);
      switch (t) {
        case m:
          return Fe("Suspense");
        case u:
          return Fe("SuspenseList");
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case d:
            return We(t.render);
          case f:
            return de(t.type, c, p);
          case h: {
            var g = t, P = g._payload, L = g._init;
            try {
              return de(L(P), c, p);
            } catch {
            }
          }
        }
      return "";
    }
    var fe = Object.prototype.hasOwnProperty, Te = {}, Le = F.ReactDebugCurrentFrame;
    function Re(t) {
      if (t) {
        var c = t._owner, p = de(t.type, t._source, c ? c.type : null);
        Le.setExtraStackFrame(p);
      } else
        Le.setExtraStackFrame(null);
    }
    function sn(t, c, p, g, P) {
      {
        var L = Function.call.bind(fe);
        for (var I in t)
          if (L(t, I)) {
            var N = void 0;
            try {
              if (typeof t[I] != "function") {
                var te = Error((g || "React class") + ": " + p + " type `" + I + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof t[I] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw te.name = "Invariant Violation", te;
              }
              N = t[I](c, I, g, p, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (x) {
              N = x;
            }
            N && !(N instanceof Error) && (Re(P), y("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", g || "React class", p, I, typeof N), Re(null)), N instanceof Error && !(N.message in Te) && (Te[N.message] = !0, Re(P), y("Failed %s type: %s", p, N.message), Re(null));
          }
      }
    }
    var w = Array.isArray;
    function _(t) {
      return w(t);
    }
    function $(t) {
      {
        var c = typeof Symbol == "function" && Symbol.toStringTag, p = c && t[Symbol.toStringTag] || t.constructor.name || "Object";
        return p;
      }
    }
    function G(t) {
      try {
        return Y(t), !1;
      } catch {
        return !0;
      }
    }
    function Y(t) {
      return "" + t;
    }
    function R(t) {
      if (G(t))
        return y("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", $(t)), Y(t);
    }
    var z = F.ReactCurrentOwner, ie = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, pe, _e;
    function en(t) {
      if (fe.call(t, "ref")) {
        var c = Object.getOwnPropertyDescriptor(t, "ref").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.ref !== void 0;
    }
    function un(t) {
      if (fe.call(t, "key")) {
        var c = Object.getOwnPropertyDescriptor(t, "key").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.key !== void 0;
    }
    function rn(t, c) {
      typeof t.ref == "string" && z.current;
    }
    function dn(t, c) {
      {
        var p = function() {
          pe || (pe = !0, y("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "key", {
          get: p,
          configurable: !0
        });
      }
    }
    function pn(t, c) {
      {
        var p = function() {
          _e || (_e = !0, y("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "ref", {
          get: p,
          configurable: !0
        });
      }
    }
    var ln = function(t, c, p, g, P, L, I) {
      var N = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: n,
        // Built-in properties that belong on the element
        type: t,
        key: c,
        ref: p,
        props: I,
        // Record the component responsible for creating this element.
        _owner: L
      };
      return N._store = {}, Object.defineProperty(N._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(N, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: g
      }), Object.defineProperty(N, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: P
      }), Object.freeze && (Object.freeze(N.props), Object.freeze(N)), N;
    };
    function kn(t, c, p, g, P) {
      {
        var L, I = {}, N = null, te = null;
        p !== void 0 && (R(p), N = "" + p), un(c) && (R(c.key), N = "" + c.key), en(c) && (te = c.ref, rn(c));
        for (L in c)
          fe.call(c, L) && !ie.hasOwnProperty(L) && (I[L] = c[L]);
        if (t && t.defaultProps) {
          var x = t.defaultProps;
          for (L in x)
            I[L] === void 0 && (I[L] = x[L]);
        }
        if (N || te) {
          var V = typeof t == "function" ? t.displayName || t.name || "Unknown" : t;
          N && dn(I, V), te && pn(I, V);
        }
        return ln(t, N, te, P, g, z.current, I);
      }
    }
    var Xe = F.ReactCurrentOwner, Sn = F.ReactDebugCurrentFrame;
    function Oe(t) {
      if (t) {
        var c = t._owner, p = de(t.type, t._source, c ? c.type : null);
        Sn.setExtraStackFrame(p);
      } else
        Sn.setExtraStackFrame(null);
    }
    var an;
    an = !1;
    function on(t) {
      return typeof t == "object" && t !== null && t.$$typeof === n;
    }
    function yn() {
      {
        if (Xe.current) {
          var t = O(Xe.current.type);
          if (t)
            return `

Check the render method of \`` + t + "`.";
        }
        return "";
      }
    }
    function qn(t) {
      return "";
    }
    var Nn = {};
    function gn(t) {
      {
        var c = yn();
        if (!c) {
          var p = typeof t == "string" ? t : t.displayName || t.name;
          p && (c = `

Check the top-level render call using <` + p + ">.");
        }
        return c;
      }
    }
    function hn(t, c) {
      {
        if (!t._store || t._store.validated || t.key != null)
          return;
        t._store.validated = !0;
        var p = gn(c);
        if (Nn[p])
          return;
        Nn[p] = !0;
        var g = "";
        t && t._owner && t._owner !== Xe.current && (g = " It was passed a child from " + O(t._owner.type) + "."), Oe(t), y('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', p, g), Oe(null);
      }
    }
    function jn(t, c) {
      {
        if (typeof t != "object")
          return;
        if (_(t))
          for (var p = 0; p < t.length; p++) {
            var g = t[p];
            on(g) && hn(g, c);
          }
        else if (on(t))
          t._store && (t._store.validated = !0);
        else if (t) {
          var P = j(t);
          if (typeof P == "function" && P !== t.entries)
            for (var L = P.call(t), I; !(I = L.next()).done; )
              on(I.value) && hn(I.value, c);
        }
      }
    }
    function Un(t) {
      {
        var c = t.type;
        if (c == null || typeof c == "string")
          return;
        var p;
        if (typeof c == "function")
          p = c.propTypes;
        else if (typeof c == "object" && (c.$$typeof === d || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        c.$$typeof === f))
          p = c.propTypes;
        else
          return;
        if (p) {
          var g = O(c);
          sn(p, t.props, "prop", g, t);
        } else if (c.PropTypes !== void 0 && !an) {
          an = !0;
          var P = O(c);
          y("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", P || "Unknown");
        }
        typeof c.getDefaultProps == "function" && !c.getDefaultProps.isReactClassApproved && y("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function Vn(t) {
      {
        for (var c = Object.keys(t.props), p = 0; p < c.length; p++) {
          var g = c[p];
          if (g !== "children" && g !== "key") {
            Oe(t), y("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", g), Oe(null);
            break;
          }
        }
        t.ref !== null && (Oe(t), y("Invalid attribute `ref` supplied to `React.Fragment`."), Oe(null));
      }
    }
    var _n = {};
    function xn(t, c, p, g, P, L) {
      {
        var I = ae(t);
        if (!I) {
          var N = "";
          (t === void 0 || typeof t == "object" && t !== null && Object.keys(t).length === 0) && (N += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var te = qn();
          te ? N += te : N += yn();
          var x;
          t === null ? x = "null" : _(t) ? x = "array" : t !== void 0 && t.$$typeof === n ? (x = "<" + (O(t.type) || "Unknown") + " />", N = " Did you accidentally export a JSX literal instead of a component?") : x = typeof t, y("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", x, N);
        }
        var V = kn(t, c, p, P, L);
        if (V == null)
          return V;
        if (I) {
          var X = c.children;
          if (X !== void 0)
            if (g)
              if (_(X)) {
                for (var we = 0; we < X.length; we++)
                  jn(X[we], t);
                Object.freeze && Object.freeze(X);
              } else
                y("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              jn(X, t);
        }
        if (fe.call(c, "key")) {
          var Se = O(t), ne = Object.keys(c).filter(function(wn) {
            return wn !== "key";
          }), nn = ne.length > 0 ? "{key: someKey, " + ne.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!_n[Se + nn]) {
            var Tn = ne.length > 0 ? "{" + ne.join(": ..., ") + ": ...}" : "{}";
            y(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, nn, Se, Tn, Se), _n[Se + nn] = !0;
          }
        }
        return t === i ? Vn(V) : Un(V), V;
      }
    }
    function Hn(t, c, p) {
      return xn(t, c, p, !0);
    }
    function Dn(t, c, p) {
      return xn(t, c, p, !1);
    }
    var Rn = Dn, Mn = Hn;
    Fo.Fragment = i, Fo.jsx = Rn, Fo.jsxs = Mn;
  })()), Fo;
}
var av;
function hT() {
  return av || (av = 1, process.env.NODE_ENV === "production" ? tu.exports = pT() : tu.exports = fT()), tu.exports;
}
var Ne = hT();
function yT({
  query: e,
  options: n,
  delayMs: r
}) {
  const { useLazyQuery: i } = mn(), [a, o] = se([]), [s] = i(e, n), [l, d] = se(
    []
  );
  return He(() => () => {
    l.forEach((m) => window.clearTimeout(m));
  }, []), [async (m) => {
    const u = [];
    for (const [f, h] of m.entries()) {
      f !== 0 && await new Promise((C) => {
        const S = setTimeout(C, r);
        d([...l, S]);
      });
      const v = await s({
        variables: h
      });
      u.push(v);
    }
    o(u);
  }, a];
}
var dx = /* @__PURE__ */ ((e) => (e.List = "list", e))(dx || {}), im = /* @__PURE__ */ ((e) => (e.Profile = "profile", e))(im || {}), am = /* @__PURE__ */ ((e) => (e.Subscribed = "SUBSCRIBED", e))(am || {}), om = /* @__PURE__ */ ((e) => (e.Unsubscribed = "UNSUBSCRIBED", e))(om || {});
const gT = { kind: "Document", definitions: [{ kind: "FragmentDefinition", name: { kind: "Name", value: "ClientErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }] }, vT = { kind: "Document", definitions: [{ kind: "FragmentDefinition", name: { kind: "Name", value: "ServerErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }] }, kT = { kind: "Document", definitions: [{ kind: "FragmentDefinition", name: { kind: "Name", value: "GetEventResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_GetEventResponseCollectionCompoundDocument" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "data" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "type" } }, { kind: "Field", name: { kind: "Name", value: "attributes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "timestamp" } }, { kind: "Field", name: { kind: "Name", value: "event_properties" } }] } }] } }] } }] }, bT = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "subscribeProfileToChannel" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "attributes" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_mutationInput_bulk_subscribe_profiles_input_data_attributes_Input" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "relationships" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_mutationInput_bulk_subscribe_profiles_input_data_relationships_Input" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Klaviyo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "bulk_subscribe_profiles" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "input" }, value: { kind: "ObjectValue", fields: [{ kind: "ObjectField", name: { kind: "Name", value: "data" }, value: { kind: "ObjectValue", fields: [{ kind: "ObjectField", name: { kind: "Name", value: "type" }, value: { kind: "EnumValue", value: "profile_subscription_bulk_create_job" } }, { kind: "ObjectField", name: { kind: "Name", value: "attributes" }, value: { kind: "Variable", name: { kind: "Name", value: "attributes" } } }, { kind: "ObjectField", name: { kind: "Name", value: "relationships" }, value: { kind: "Variable", name: { kind: "Name", value: "relationships" } } }] } }] } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ClientErrorResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ServerErrorResponseFragment" } }] } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ClientErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ServerErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }] }, _T = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "unsubscribeProfileByContact" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "attributes" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_mutationInput_bulk_unsubscribe_profiles_input_data_attributes_Input" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Klaviyo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "bulk_unsubscribe_profiles" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "input" }, value: { kind: "ObjectValue", fields: [{ kind: "ObjectField", name: { kind: "Name", value: "data" }, value: { kind: "ObjectValue", fields: [{ kind: "ObjectField", name: { kind: "Name", value: "type" }, value: { kind: "EnumValue", value: "profile_subscription_bulk_delete_job" } }, { kind: "ObjectField", name: { kind: "Name", value: "attributes" }, value: { kind: "Variable", name: { kind: "Name", value: "attributes" } } }] } }] } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ClientErrorResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ServerErrorResponseFragment" } }] } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ClientErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ServerErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }] }, xT = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getEvents" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "receivedEmailEventsFilter" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "openedEmailEventsFilter" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "clickedEmailEventsFilter" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "bouncedEmailEventsFilter" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "receivedSmsEventsFilter" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "pageSize" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_PositiveInt" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Klaviyo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", alias: { kind: "Name", value: "receivedEmail" }, name: { kind: "Name", value: "get_events" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "filter" }, value: { kind: "Variable", name: { kind: "Name", value: "receivedEmailEventsFilter" } } }, { kind: "Argument", name: { kind: "Name", value: "sort" }, value: { kind: "EnumValue", value: "_datetime" } }, { kind: "Argument", name: { kind: "Name", value: "page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_" }, value: { kind: "Variable", name: { kind: "Name", value: "pageSize" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_GetEventResponseCollectionCompoundDocument" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "GetEventResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ClientErrorResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ServerErrorResponseFragment" } }] } }] } }, { kind: "Field", alias: { kind: "Name", value: "openedEmail" }, name: { kind: "Name", value: "get_events" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "filter" }, value: { kind: "Variable", name: { kind: "Name", value: "openedEmailEventsFilter" } } }, { kind: "Argument", name: { kind: "Name", value: "sort" }, value: { kind: "EnumValue", value: "_datetime" } }, { kind: "Argument", name: { kind: "Name", value: "page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_" }, value: { kind: "Variable", name: { kind: "Name", value: "pageSize" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_GetEventResponseCollectionCompoundDocument" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "GetEventResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ClientErrorResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ServerErrorResponseFragment" } }] } }] } }, { kind: "Field", alias: { kind: "Name", value: "clickedEmail" }, name: { kind: "Name", value: "get_events" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "filter" }, value: { kind: "Variable", name: { kind: "Name", value: "clickedEmailEventsFilter" } } }, { kind: "Argument", name: { kind: "Name", value: "sort" }, value: { kind: "EnumValue", value: "_datetime" } }, { kind: "Argument", name: { kind: "Name", value: "page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_" }, value: { kind: "Variable", name: { kind: "Name", value: "pageSize" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_GetEventResponseCollectionCompoundDocument" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "GetEventResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ClientErrorResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ServerErrorResponseFragment" } }] } }] } }, { kind: "Field", alias: { kind: "Name", value: "bouncedEmail" }, name: { kind: "Name", value: "get_events" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "filter" }, value: { kind: "Variable", name: { kind: "Name", value: "bouncedEmailEventsFilter" } } }, { kind: "Argument", name: { kind: "Name", value: "sort" }, value: { kind: "EnumValue", value: "_datetime" } }, { kind: "Argument", name: { kind: "Name", value: "page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_" }, value: { kind: "Variable", name: { kind: "Name", value: "pageSize" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_GetEventResponseCollectionCompoundDocument" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "GetEventResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ClientErrorResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ServerErrorResponseFragment" } }] } }] } }, { kind: "Field", alias: { kind: "Name", value: "receivedSms" }, name: { kind: "Name", value: "get_events" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "filter" }, value: { kind: "Variable", name: { kind: "Name", value: "receivedSmsEventsFilter" } } }, { kind: "Argument", name: { kind: "Name", value: "sort" }, value: { kind: "EnumValue", value: "_datetime" } }, { kind: "Argument", name: { kind: "Name", value: "page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_" }, value: { kind: "Variable", name: { kind: "Name", value: "pageSize" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_GetEventResponseCollectionCompoundDocument" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "GetEventResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ClientErrorResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ServerErrorResponseFragment" } }] } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "GetEventResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_GetEventResponseCollectionCompoundDocument" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "data" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "type" } }, { kind: "Field", name: { kind: "Name", value: "attributes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "timestamp" } }, { kind: "Field", name: { kind: "Name", value: "event_properties" } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ClientErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ServerErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }] }, ST = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getFlowMessage" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "messageId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Klaviyo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "get_flow_message" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "id" }, value: { kind: "Variable", name: { kind: "Name", value: "messageId" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_GetFlowMessageEncodedResponseCompoundDocument" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "data" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "type" } }, { kind: "Field", name: { kind: "Name", value: "attributes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "definition" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_FlowEmail" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "preview_text" } }] } }] } }] } }] } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ClientErrorResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ServerErrorResponseFragment" } }] } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ClientErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ServerErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }] }, NT = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getMetrics" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Klaviyo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "get_metrics" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_GetMetricResponseCollectionCompoundDocument" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "data" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "attributes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ClientErrorResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ServerErrorResponseFragment" } }] } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ClientErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ServerErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }] }, jT = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getProfileByFilter" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "emailFilter" } }, type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "phoneNumberFilter" } }, type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "hasEmail" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Boolean" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "hasPhoneNumber" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Boolean" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Klaviyo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", alias: { kind: "Name", value: "profileByEmail" }, name: { kind: "Name", value: "get_profiles" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "filter" }, value: { kind: "Variable", name: { kind: "Name", value: "emailFilter" } } }, { kind: "Argument", name: { kind: "Name", value: "page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_" }, value: { kind: "IntValue", value: "1" } }], directives: [{ kind: "Directive", name: { kind: "Name", value: "include" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "if" }, value: { kind: "Variable", name: { kind: "Name", value: "hasEmail" } } }] }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_GetProfileResponseCollectionCompoundDocument" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "data" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }] } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ClientErrorResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ServerErrorResponseFragment" } }] } }] } }, { kind: "Field", alias: { kind: "Name", value: "profileByPhoneNumber" }, name: { kind: "Name", value: "get_profiles" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "filter" }, value: { kind: "Variable", name: { kind: "Name", value: "phoneNumberFilter" } } }, { kind: "Argument", name: { kind: "Name", value: "page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_" }, value: { kind: "IntValue", value: "1" } }], directives: [{ kind: "Directive", name: { kind: "Name", value: "include" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "if" }, value: { kind: "Variable", name: { kind: "Name", value: "hasPhoneNumber" } } }] }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_GetProfileResponseCollectionCompoundDocument" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "data" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }] } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ClientErrorResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ServerErrorResponseFragment" } }] } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ClientErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ServerErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }] }, wT = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getProfileById" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "profileId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Klaviyo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "get_profile" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "id" }, value: { kind: "Variable", name: { kind: "Name", value: "profileId" } } }, { kind: "Argument", name: { kind: "Name", value: "fields_LEFT_SQUARE_BRACE_profile_RIGHT_SQUARE_BRACE_" }, value: { kind: "ListValue", values: [{ kind: "EnumValue", value: "subscriptions" }, { kind: "EnumValue", value: "properties" }, { kind: "EnumValue", value: "predictive_analytics" }] } }, { kind: "Argument", name: { kind: "Name", value: "additional_fields_LEFT_SQUARE_BRACE_profile_RIGHT_SQUARE_BRACE_" }, value: { kind: "ListValue", values: [{ kind: "EnumValue", value: "subscriptions" }, { kind: "EnumValue", value: "predictive_analytics" }] } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_GetProfileResponseCompoundDocument" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "data" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "attributes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "subscriptions" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "email" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "marketing" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "consent" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "sms" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "marketing" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "consent" } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "properties" } }, { kind: "Field", name: { kind: "Name", value: "predictive_analytics" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "average_order_value" } }, { kind: "Field", name: { kind: "Name", value: "churn_probability" } }, { kind: "Field", name: { kind: "Name", value: "predicted_clv" } }, { kind: "Field", name: { kind: "Name", value: "historic_clv" } }, { kind: "Field", name: { kind: "Name", value: "total_clv" } }, { kind: "Field", name: { kind: "Name", value: "historic_number_of_orders" } }, { kind: "Field", name: { kind: "Name", value: "predicted_number_of_orders" } }, { kind: "Field", name: { kind: "Name", value: "average_days_between_orders" } }, { kind: "Field", name: { kind: "Name", value: "expected_date_of_next_order" } }, { kind: "Field", name: { kind: "Name", value: "ranked_channel_affinity" } }] } }] } }] } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ClientErrorResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ServerErrorResponseFragment" } }] } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ClientErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ServerErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }] }, CT = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getListsByProfileId" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "profileId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Klaviyo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "get_lists_for_profile" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "id" }, value: { kind: "Variable", name: { kind: "Name", value: "profileId" } } }, { kind: "Argument", name: { kind: "Name", value: "fields_LEFT_SQUARE_BRACE_list_RIGHT_SQUARE_BRACE_" }, value: { kind: "ListValue", values: [{ kind: "EnumValue", value: "name" }] } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_GetListResponseCollection" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "data" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "attributes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ClientErrorResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ServerErrorResponseFragment" } }] } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ClientErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ServerErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }] }, FT = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getSegmentsByProfileId" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "profileId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Klaviyo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "get_segments_for_profile" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "id" }, value: { kind: "Variable", name: { kind: "Name", value: "profileId" } } }, { kind: "Argument", name: { kind: "Name", value: "fields_LEFT_SQUARE_BRACE_segment_RIGHT_SQUARE_BRACE_" }, value: { kind: "ListValue", values: [{ kind: "EnumValue", value: "name" }] } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_GetSegmentResponseCollection" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "data" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "attributes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ClientErrorResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ServerErrorResponseFragment" } }] } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ClientErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ServerErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }] }, IT = {
  "\n  fragment ClientErrorResponseFragment on Klaviyo_ClientError_response {\n    errors {\n      id\n      code\n      title\n      detail\n      source {\n        pointer\n        parameter\n      }\n    }\n  }\n": gT,
  "\n  fragment ServerErrorResponseFragment on Klaviyo_ServerError_response {\n    errors {\n      id\n      code\n      title\n      detail\n      source {\n        pointer\n        parameter\n      }\n    }\n  }\n": vT,
  "\n  mutation subscribeProfileToChannel(\n    $attributes: Klaviyo_mutationInput_bulk_subscribe_profiles_input_data_attributes_Input!\n    $relationships: Klaviyo_mutationInput_bulk_subscribe_profiles_input_data_relationships_Input!\n  ) {\n    Klaviyo {\n      bulk_subscribe_profiles(\n        input: {\n          data: {\n            type: profile_subscription_bulk_create_job\n            attributes: $attributes\n            relationships: $relationships\n          }\n        }\n      ) {\n        ... on Klaviyo_ClientError_response {\n          ...ClientErrorResponseFragment\n        }\n        ... on Klaviyo_ServerError_response {\n          ...ServerErrorResponseFragment\n        }\n      }\n    }\n  }\n": bT,
  "\n  mutation unsubscribeProfileByContact(\n    $attributes: Klaviyo_mutationInput_bulk_unsubscribe_profiles_input_data_attributes_Input!\n  ) {\n    Klaviyo {\n      bulk_unsubscribe_profiles(\n        input: {\n          data: {\n            type: profile_subscription_bulk_delete_job\n            attributes: $attributes\n          }\n        }\n      ) {\n        ... on Klaviyo_ClientError_response {\n          ...ClientErrorResponseFragment\n        }\n        ... on Klaviyo_ServerError_response {\n          ...ServerErrorResponseFragment\n        }\n      }\n    }\n  }\n": _T,
  "\n  fragment GetEventResponseFragment on Klaviyo_GetEventResponseCollectionCompoundDocument {\n    data {\n      id\n      type\n      attributes {\n        timestamp\n        event_properties\n      }\n    }\n  }\n": kT,
  "\n  query getEvents(\n    $receivedEmailEventsFilter: String!\n    $openedEmailEventsFilter: String!\n    $clickedEmailEventsFilter: String!\n    $bouncedEmailEventsFilter: String!\n    $receivedSmsEventsFilter: String!\n    $pageSize: Klaviyo_PositiveInt!\n  ) {\n    Klaviyo {\n      receivedEmail: get_events(\n        filter: $receivedEmailEventsFilter\n        sort: _datetime\n        page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_: $pageSize\n      ) {\n        ... on Klaviyo_GetEventResponseCollectionCompoundDocument {\n          ...GetEventResponseFragment\n        }\n        ... on Klaviyo_ClientError_response {\n          ...ClientErrorResponseFragment\n        }\n        ... on Klaviyo_ServerError_response {\n          ...ServerErrorResponseFragment\n        }\n      }\n      openedEmail: get_events(\n        filter: $openedEmailEventsFilter\n        sort: _datetime\n        page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_: $pageSize\n      ) {\n        ... on Klaviyo_GetEventResponseCollectionCompoundDocument {\n          ...GetEventResponseFragment\n        }\n        ... on Klaviyo_ClientError_response {\n          ...ClientErrorResponseFragment\n        }\n        ... on Klaviyo_ServerError_response {\n          ...ServerErrorResponseFragment\n        }\n      }\n      clickedEmail: get_events(\n        filter: $clickedEmailEventsFilter\n        sort: _datetime\n        page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_: $pageSize\n      ) {\n        ... on Klaviyo_GetEventResponseCollectionCompoundDocument {\n          ...GetEventResponseFragment\n        }\n        ... on Klaviyo_ClientError_response {\n          ...ClientErrorResponseFragment\n        }\n        ... on Klaviyo_ServerError_response {\n          ...ServerErrorResponseFragment\n        }\n      }\n      bouncedEmail: get_events(\n        filter: $bouncedEmailEventsFilter\n        sort: _datetime\n        page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_: $pageSize\n      ) {\n        ... on Klaviyo_GetEventResponseCollectionCompoundDocument {\n          ...GetEventResponseFragment\n        }\n        ... on Klaviyo_ClientError_response {\n          ...ClientErrorResponseFragment\n        }\n        ... on Klaviyo_ServerError_response {\n          ...ServerErrorResponseFragment\n        }\n      }\n      receivedSms: get_events(\n        filter: $receivedSmsEventsFilter\n        sort: _datetime\n        page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_: $pageSize\n      ) {\n        ... on Klaviyo_GetEventResponseCollectionCompoundDocument {\n          ...GetEventResponseFragment\n        }\n        ... on Klaviyo_ClientError_response {\n          ...ClientErrorResponseFragment\n        }\n        ... on Klaviyo_ServerError_response {\n          ...ServerErrorResponseFragment\n        }\n      }\n    }\n  }\n": xT,
  "\n  query getFlowMessage($messageId: String!) {\n    Klaviyo {\n      get_flow_message(id: $messageId) {\n        ... on Klaviyo_GetFlowMessageEncodedResponseCompoundDocument {\n          data {\n            id\n            type\n            attributes {\n              definition {\n                ... on Klaviyo_FlowEmail {\n                  preview_text\n                }\n              }\n            }\n          }\n        }\n        ... on Klaviyo_ClientError_response {\n          ...ClientErrorResponseFragment\n        }\n        ... on Klaviyo_ServerError_response {\n          ...ServerErrorResponseFragment\n        }\n      }\n    }\n  }\n": ST,
  "\n  query getMetrics {\n    Klaviyo {\n      get_metrics {\n        ... on Klaviyo_GetMetricResponseCollectionCompoundDocument {\n          data {\n            id\n            attributes {\n              name\n            }\n          }\n        }\n        ... on Klaviyo_ClientError_response {\n          ...ClientErrorResponseFragment\n        }\n        ... on Klaviyo_ServerError_response {\n          ...ServerErrorResponseFragment\n        }\n      }\n    }\n  }\n": NT,
  "\n  query getProfileByFilter(\n    $emailFilter: String\n    $phoneNumberFilter: String\n    $hasEmail: Boolean!\n    $hasPhoneNumber: Boolean!\n  ) {\n    Klaviyo {\n      profileByEmail: get_profiles(\n        filter: $emailFilter\n        page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_: 1\n      ) @include(if: $hasEmail) {\n        ... on Klaviyo_GetProfileResponseCollectionCompoundDocument {\n          data {\n            id\n          }\n        }\n        ... on Klaviyo_ClientError_response {\n          ...ClientErrorResponseFragment\n        }\n        ... on Klaviyo_ServerError_response {\n          ...ServerErrorResponseFragment\n        }\n      }\n      profileByPhoneNumber: get_profiles(\n        filter: $phoneNumberFilter\n        page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_: 1\n      ) @include(if: $hasPhoneNumber) {\n        ... on Klaviyo_GetProfileResponseCollectionCompoundDocument {\n          data {\n            id\n          }\n        }\n        ... on Klaviyo_ClientError_response {\n          ...ClientErrorResponseFragment\n        }\n        ... on Klaviyo_ServerError_response {\n          ...ServerErrorResponseFragment\n        }\n      }\n    }\n  }\n": jT,
  "\n  query getProfileById($profileId: String!) {\n    Klaviyo {\n      get_profile(\n        id: $profileId\n        fields_LEFT_SQUARE_BRACE_profile_RIGHT_SQUARE_BRACE_: [\n          subscriptions\n          properties\n          predictive_analytics\n        ]\n        additional_fields_LEFT_SQUARE_BRACE_profile_RIGHT_SQUARE_BRACE_: [\n          subscriptions\n          predictive_analytics\n        ]\n      ) {\n        ... on Klaviyo_GetProfileResponseCompoundDocument {\n          data {\n            attributes {\n              subscriptions {\n                email {\n                  marketing {\n                    consent\n                  }\n                }\n                sms {\n                  marketing {\n                    consent\n                  }\n                }\n              }\n              properties\n              predictive_analytics {\n                average_order_value\n                churn_probability\n                predicted_clv\n                historic_clv\n                total_clv\n                historic_number_of_orders\n                predicted_number_of_orders\n                average_days_between_orders\n                expected_date_of_next_order\n                ranked_channel_affinity\n              }\n            }\n          }\n        }\n        ... on Klaviyo_ClientError_response {\n          ...ClientErrorResponseFragment\n        }\n        ... on Klaviyo_ServerError_response {\n          ...ServerErrorResponseFragment\n        }\n      }\n    }\n  }\n": wT,
  "\n  query getListsByProfileId($profileId: String!) {\n    Klaviyo {\n      get_lists_for_profile(\n        id: $profileId\n        fields_LEFT_SQUARE_BRACE_list_RIGHT_SQUARE_BRACE_: [name]\n      ) {\n        ... on Klaviyo_GetListResponseCollection {\n          data {\n            id\n            attributes {\n              name\n            }\n          }\n        }\n        ... on Klaviyo_ClientError_response {\n          ...ClientErrorResponseFragment\n        }\n        ... on Klaviyo_ServerError_response {\n          ...ServerErrorResponseFragment\n        }\n      }\n    }\n  }\n": CT,
  "\n  query getSegmentsByProfileId($profileId: String!) {\n    Klaviyo {\n      get_segments_for_profile(\n        id: $profileId\n        fields_LEFT_SQUARE_BRACE_segment_RIGHT_SQUARE_BRACE_: [name]\n      ) {\n        ... on Klaviyo_GetSegmentResponseCollection {\n          data {\n            id\n            attributes {\n              name\n            }\n          }\n        }\n        ... on Klaviyo_ClientError_response {\n          ...ClientErrorResponseFragment\n        }\n        ... on Klaviyo_ServerError_response {\n          ...ServerErrorResponseFragment\n        }\n      }\n    }\n  }\n": FT
};
function Wr(e) {
  return IT[e] ?? {};
}
const ET = Wr(
  /* GraphQL */
  `
  query getEvents(
    $receivedEmailEventsFilter: String!
    $openedEmailEventsFilter: String!
    $clickedEmailEventsFilter: String!
    $bouncedEmailEventsFilter: String!
    $receivedSmsEventsFilter: String!
    $pageSize: Klaviyo_PositiveInt!
  ) {
    Klaviyo {
      receivedEmail: get_events(
        filter: $receivedEmailEventsFilter
        sort: _datetime
        page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_: $pageSize
      ) {
        ... on Klaviyo_GetEventResponseCollectionCompoundDocument {
          ...GetEventResponseFragment
        }
        ... on Klaviyo_ClientError_response {
          ...ClientErrorResponseFragment
        }
        ... on Klaviyo_ServerError_response {
          ...ServerErrorResponseFragment
        }
      }
      openedEmail: get_events(
        filter: $openedEmailEventsFilter
        sort: _datetime
        page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_: $pageSize
      ) {
        ... on Klaviyo_GetEventResponseCollectionCompoundDocument {
          ...GetEventResponseFragment
        }
        ... on Klaviyo_ClientError_response {
          ...ClientErrorResponseFragment
        }
        ... on Klaviyo_ServerError_response {
          ...ServerErrorResponseFragment
        }
      }
      clickedEmail: get_events(
        filter: $clickedEmailEventsFilter
        sort: _datetime
        page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_: $pageSize
      ) {
        ... on Klaviyo_GetEventResponseCollectionCompoundDocument {
          ...GetEventResponseFragment
        }
        ... on Klaviyo_ClientError_response {
          ...ClientErrorResponseFragment
        }
        ... on Klaviyo_ServerError_response {
          ...ServerErrorResponseFragment
        }
      }
      bouncedEmail: get_events(
        filter: $bouncedEmailEventsFilter
        sort: _datetime
        page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_: $pageSize
      ) {
        ... on Klaviyo_GetEventResponseCollectionCompoundDocument {
          ...GetEventResponseFragment
        }
        ... on Klaviyo_ClientError_response {
          ...ClientErrorResponseFragment
        }
        ... on Klaviyo_ServerError_response {
          ...ServerErrorResponseFragment
        }
      }
      receivedSms: get_events(
        filter: $receivedSmsEventsFilter
        sort: _datetime
        page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_: $pageSize
      ) {
        ... on Klaviyo_GetEventResponseCollectionCompoundDocument {
          ...GetEventResponseFragment
        }
        ... on Klaviyo_ClientError_response {
          ...ClientErrorResponseFragment
        }
        ... on Klaviyo_ServerError_response {
          ...ServerErrorResponseFragment
        }
      }
    }
  }
`
), TT = Wr(
  /* GraphQL */
  `
  query getFlowMessage($messageId: String!) {
    Klaviyo {
      get_flow_message(id: $messageId) {
        ... on Klaviyo_GetFlowMessageEncodedResponseCompoundDocument {
          data {
            id
            type
            attributes {
              definition {
                ... on Klaviyo_FlowEmail {
                  preview_text
                }
              }
            }
          }
        }
        ... on Klaviyo_ClientError_response {
          ...ClientErrorResponseFragment
        }
        ... on Klaviyo_ServerError_response {
          ...ServerErrorResponseFragment
        }
      }
    }
  }
`
), $T = Wr(
  /* GraphQL */
  `
  query getMetrics {
    Klaviyo {
      get_metrics {
        ... on Klaviyo_GetMetricResponseCollectionCompoundDocument {
          data {
            id
            attributes {
              name
            }
          }
        }
        ... on Klaviyo_ClientError_response {
          ...ClientErrorResponseFragment
        }
        ... on Klaviyo_ServerError_response {
          ...ServerErrorResponseFragment
        }
      }
    }
  }
`
), DT = Wr(
  /* GraphQL */
  `
  query getProfileByFilter(
    $emailFilter: String
    $phoneNumberFilter: String
    $hasEmail: Boolean!
    $hasPhoneNumber: Boolean!
  ) {
    Klaviyo {
      profileByEmail: get_profiles(
        filter: $emailFilter
        page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_: 1
      ) @include(if: $hasEmail) {
        ... on Klaviyo_GetProfileResponseCollectionCompoundDocument {
          data {
            id
          }
        }
        ... on Klaviyo_ClientError_response {
          ...ClientErrorResponseFragment
        }
        ... on Klaviyo_ServerError_response {
          ...ServerErrorResponseFragment
        }
      }
      profileByPhoneNumber: get_profiles(
        filter: $phoneNumberFilter
        page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_: 1
      ) @include(if: $hasPhoneNumber) {
        ... on Klaviyo_GetProfileResponseCollectionCompoundDocument {
          data {
            id
          }
        }
        ... on Klaviyo_ClientError_response {
          ...ClientErrorResponseFragment
        }
        ... on Klaviyo_ServerError_response {
          ...ServerErrorResponseFragment
        }
      }
    }
  }
`
), RT = Wr(
  /* GraphQL */
  `
  query getProfileById($profileId: String!) {
    Klaviyo {
      get_profile(
        id: $profileId
        fields_LEFT_SQUARE_BRACE_profile_RIGHT_SQUARE_BRACE_: [
          subscriptions
          properties
          predictive_analytics
        ]
        additional_fields_LEFT_SQUARE_BRACE_profile_RIGHT_SQUARE_BRACE_: [
          subscriptions
          predictive_analytics
        ]
      ) {
        ... on Klaviyo_GetProfileResponseCompoundDocument {
          data {
            attributes {
              subscriptions {
                email {
                  marketing {
                    consent
                  }
                }
                sms {
                  marketing {
                    consent
                  }
                }
              }
              properties
              predictive_analytics {
                average_order_value
                churn_probability
                predicted_clv
                historic_clv
                total_clv
                historic_number_of_orders
                predicted_number_of_orders
                average_days_between_orders
                expected_date_of_next_order
                ranked_channel_affinity
              }
            }
          }
        }
        ... on Klaviyo_ClientError_response {
          ...ClientErrorResponseFragment
        }
        ... on Klaviyo_ServerError_response {
          ...ServerErrorResponseFragment
        }
      }
    }
  }
`
), OT = Wr(
  /* GraphQL */
  `
  query getListsByProfileId($profileId: String!) {
    Klaviyo {
      get_lists_for_profile(
        id: $profileId
        fields_LEFT_SQUARE_BRACE_list_RIGHT_SQUARE_BRACE_: [name]
      ) {
        ... on Klaviyo_GetListResponseCollection {
          data {
            id
            attributes {
              name
            }
          }
        }
        ... on Klaviyo_ClientError_response {
          ...ClientErrorResponseFragment
        }
        ... on Klaviyo_ServerError_response {
          ...ServerErrorResponseFragment
        }
      }
    }
  }
`
), PT = Wr(
  /* GraphQL */
  `
  query getSegmentsByProfileId($profileId: String!) {
    Klaviyo {
      get_segments_for_profile(
        id: $profileId
        fields_LEFT_SQUARE_BRACE_segment_RIGHT_SQUARE_BRACE_: [name]
      ) {
        ... on Klaviyo_GetSegmentResponseCollection {
          data {
            id
            attributes {
              name
            }
          }
        }
        ... on Klaviyo_ClientError_response {
          ...ClientErrorResponseFragment
        }
        ... on Klaviyo_ServerError_response {
          ...ServerErrorResponseFragment
        }
      }
    }
  }
`
), AT = Wr(
  /* GraphQL */
  `
  mutation subscribeProfileToChannel(
    $attributes: Klaviyo_mutationInput_bulk_subscribe_profiles_input_data_attributes_Input!
    $relationships: Klaviyo_mutationInput_bulk_subscribe_profiles_input_data_relationships_Input!
  ) {
    Klaviyo {
      bulk_subscribe_profiles(
        input: {
          data: {
            type: profile_subscription_bulk_create_job
            attributes: $attributes
            relationships: $relationships
          }
        }
      ) {
        ... on Klaviyo_ClientError_response {
          ...ClientErrorResponseFragment
        }
        ... on Klaviyo_ServerError_response {
          ...ServerErrorResponseFragment
        }
      }
    }
  }
`
), LT = Wr(
  /* GraphQL */
  `
  mutation unsubscribeProfileByContact(
    $attributes: Klaviyo_mutationInput_bulk_unsubscribe_profiles_input_data_attributes_Input!
  ) {
    Klaviyo {
      bulk_unsubscribe_profiles(
        input: {
          data: {
            type: profile_subscription_bulk_delete_job
            attributes: $attributes
          }
        }
      ) {
        ... on Klaviyo_ClientError_response {
          ...ClientErrorResponseFragment
        }
        ... on Klaviyo_ServerError_response {
          ...ServerErrorResponseFragment
        }
      }
    }
  }
`
);
function sm(e) {
  return e?.attributes?.event_properties?.$flow !== void 0;
}
function ov(e) {
  return sm(e) && e?.attributes?.event_properties?.$message;
}
function VT(e) {
  return e?.attributes?.event_properties?.["Bounce Type"] !== void 0;
}
function sv(e) {
  const n = e?.attributes?.timestamp;
  if (n)
    return n;
}
function zT(e) {
  return e.Klaviyo?.get_metrics?.__typename === "Klaviyo_GetMetricResponseCollectionCompoundDocument" && e.Klaviyo.get_metrics.data || [];
}
function UT(e) {
  return (e?.Klaviyo?.receivedEmail?.__typename === "Klaviyo_GetEventResponseCollectionCompoundDocument" && e.Klaviyo.receivedEmail.data || [])?.map((n) => ({
    ...n,
    eventType: "EMAIL"
  }));
}
function MT(e) {
  return (e?.Klaviyo?.receivedSms?.__typename === "Klaviyo_GetEventResponseCollectionCompoundDocument" && e.Klaviyo.receivedSms.data || [])?.map((n) => ({
    ...n,
    eventType: "SMS"
  }));
}
function BT(e) {
  return (e?.Klaviyo?.openedEmail?.__typename === "Klaviyo_GetEventResponseCollectionCompoundDocument" && e.Klaviyo.openedEmail.data || [])?.map((n) => ({
    ...n,
    eventType: "EMAIL"
  }));
}
function qT(e) {
  return (e?.Klaviyo?.clickedEmail?.__typename === "Klaviyo_GetEventResponseCollectionCompoundDocument" && e.Klaviyo.clickedEmail.data || [])?.map((n) => ({
    ...n,
    eventType: "EMAIL"
  }));
}
function HT(e) {
  return (e?.Klaviyo?.bouncedEmail?.__typename === "Klaviyo_GetEventResponseCollectionCompoundDocument" && e.Klaviyo.bouncedEmail.data || [])?.map((n) => ({
    ...n,
    eventType: "EMAIL"
  }));
}
function lv(e) {
  return e?.Klaviyo?.get_flow_message?.__typename === "Klaviyo_GetFlowMessageEncodedResponseCompoundDocument" && e.Klaviyo.get_flow_message.data || void 0;
}
function WT(e) {
  return e?.attributes?.definition?.__typename === "Klaviyo_FlowEmail" && e.attributes.definition.preview_text || void 0;
}
function KT(e) {
  try {
    return JSON.parse(JSON.stringify(e));
  } catch {
    return console.error(`Could not make a copy of ${JSON.stringify(e)}`), {};
  }
}
const GT = (e) => e.charAt(0).toUpperCase() + e.slice(1).toLowerCase();
function YT(e) {
  return e?.data?.attributes?.subscriptions?.email?.marketing?.consent === "SUBSCRIBED";
}
function QT(e) {
  return e?.data?.attributes?.subscriptions?.sms?.marketing?.consent === "SUBSCRIBED";
}
function JT({
  profileId: e,
  noOfMessagesToShow: n
}) {
  const { useLazyQuery: r, useQuery: i } = mn(), { track: a } = bn(), [o, s] = se(null), [l, d] = se(
    null
  ), [m, u] = se(null), [f, h] = se(null), [v, C] = se(
    null
  ), [S, j] = se([]), {
    data: F,
    error: y,
    loading: q,
    networkStatus: T
  } = i($T, {
    /*
    	Since metrics should rarely be changed, query once when the client initializes
    	and then read from the cache for the subsequent queries.
    */
    fetchPolicy: "network-only",
    // Used for first execution
    nextFetchPolicy: "cache-first",
    // Used for subsequent executions
    notifyOnNetworkStatusChange: !0
  }), [
    E,
    {
      data: D,
      error: B,
      loading: ee,
      networkStatus: J
    }
  ] = r(ET, {
    fetchPolicy: "no-cache",
    notifyOnNetworkStatusChange: !0
  });
  return He(() => {
    if (F && !q && T === Yt.ready) {
      const ae = zT(F);
      s(
        ae.find((Q) => Q?.attributes?.name === "Received Email")?.id || null
      ), d(
        ae.find((Q) => Q?.attributes?.name === "Opened Email")?.id || null
      ), u(
        ae.find((Q) => Q?.attributes?.name === "Clicked Email")?.id || null
      ), h(
        ae.find((Q) => Q?.attributes?.name === "Bounced Email")?.id || null
      ), C(
        ae.find((Q) => Q?.attributes?.name === "Received SMS")?.id || null
      );
    } else
      s(null), d(null), u(null), h(null), C(null);
  }, [F]), He(() => {
    o && l && m && f && v && !ee && J === Yt.ready ? E({
      variables: {
        receivedEmailEventsFilter: `equals(profile_id,"${e}"),equals(metric_id,"${o}")`,
        openedEmailEventsFilter: `equals(profile_id,"${e}"),equals(metric_id,"${l}")`,
        clickedEmailEventsFilter: `equals(profile_id,"${e}"),equals(metric_id,"${m}")`,
        bouncedEmailEventsFilter: `equals(profile_id,"${e}"),equals(metric_id,"${f}")`,
        receivedSmsEventsFilter: `equals(profile_id,"${e}"),equals(metric_id,"${v}")`,
        pageSize: n
      }
    }) : j([]);
  }, [
    o,
    l,
    m,
    f,
    v
  ]), He(() => {
    if (!ee && D) {
      const ae = UT(D), Q = BT(
        D
      ).map(
        (ce) => ce?.attributes?.event_properties.$message
      ), U = qT(
        D
      ).map(
        (ce) => ce?.attributes?.event_properties.$message
      );
      ae.forEach((ce) => {
        const le = ce.attributes?.event_properties.$message;
        ce.opened = Q.includes(le), ce.clicked = U.includes(le);
      });
      const O = MT(D), H = HT(D), Z = [
        ...ae,
        ...H,
        ...O
      ].sort((ce, le) => {
        const ue = sv(ce), W = sv(le);
        return ue == null && W == null ? 0 : ue == null ? 1 : W == null ? -1 : W - ue;
      }).slice(0, n);
      j(Z);
      const ye = Z.map((ce) => ce.id);
      a("klaviyo:messages:received", {
        emailsReceived: ae.filter(
          (ce) => ye.includes(ce.id)
        ).length,
        emailsBounced: H.filter(
          (ce) => ye.includes(ce.id)
        ).length,
        smsReceived: O.filter(
          (ce) => ye.includes(ce.id)
        ).length,
        total: ye.length
      });
    } else
      j([]);
  }, [ee, D]), Bn(
    () => ({
      receivedMessages: S,
      isLoading: q || ee,
      error: y || B
    }),
    [
      S,
      q,
      ee,
      y,
      B
    ]
  );
}
function XT({ profileId: e }) {
  const { useQuery: n } = mn(), [r, i] = se(), [a, o] = se(), {
    data: s,
    error: l,
    loading: d,
    refetch: m
  } = n(RT, {
    fetchPolicy: "no-cache",
    notifyOnNetworkStatusChange: !0,
    variables: {
      profileId: e
    }
  });
  He(() => {
    l && o(l);
  }, [l]), He(() => {
    !d && s && i(s.Klaviyo.get_profile);
  }, [d, s]);
  const u = async () => {
    const f = await m();
    f.error ? o(f.error) : f.data && i(
      f.data.Klaviyo.get_profile
    );
  };
  return Bn(
    () => ({
      profile: r,
      refetchProfile: u,
      isLoading: d,
      error: a
    }),
    // No need to add `refetchProfile` as a dependency here
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [r, d, a]
  );
}
function ZT({
  email: e,
  phoneNumber: n
}) {
  const { track: r } = bn(), { useLazyQuery: i } = mn(), [a, o] = se(), [s, l] = se(), [
    d,
    { data: m, error: u, loading: f }
  ] = i(DT, {
    fetchPolicy: "no-cache",
    notifyOnNetworkStatusChange: !0
  });
  He(() => {
    if (!f && m) {
      const v = m.Klaviyo?.profileByEmail?.__typename === "Klaviyo_GetProfileResponseCollectionCompoundDocument" && m.Klaviyo.profileByEmail || void 0, C = m.Klaviyo?.profileByPhoneNumber?.__typename === "Klaviyo_GetProfileResponseCollectionCompoundDocument" && m.Klaviyo.profileByPhoneNumber || void 0;
      h(v, C);
    }
  }, [f, m]);
  const h = (v, C) => {
    const S = v?.data?.length === 1 && v.data[0]?.id || void 0, j = C?.data?.length === 1 && C.data[0]?.id || void 0, F = S || j, y = !S || !j || S === j;
    if (F && y) {
      o(S || j), r("klaviyo:profile:received", { hasProfile: !0 });
      return;
    }
    o(void 0), r("klaviyo:profile:received", { hasProfile: !1 }), y || l(
      new Error(
        `Two different profiles were retrieved from Klaviyo for the email ${e} (profile ID ${S}) and phone number ${n} (profile ID ${j}).`
      )
    );
  };
  return Bn(
    () => ({
      profileId: a,
      getProfileId: d,
      isLoading: f,
      error: u || s
    }),
    [a, d, f, u, s]
  );
}
const cv = 800, e$ = {
  min: 800,
  // 0.8 seconds
  max: 1200
  // 1.2 seconds
}, n$ = 3, t$ = 1.5, r$ = ({
  query: e,
  delay: n,
  delayRange: r,
  maxCount: i = n$,
  useDelayRange: a = !1
}) => {
  const o = (B) => Math.floor(Math.random() * (B.max - B.min) + B.min), [s, l] = se(0), [d, m] = se(n || cv), [u, f] = se(r || e$), [h, v] = se(!1), [C, S] = se(!1), j = a || !!r, F = j ? o(u) : n || cv, [y, q] = se(F);
  Mw(
    async () => {
      const B = s + 1, ee = t$ ** B;
      l(B), q(
        (j ? o(u) : d) * ee
      ), await e().then(() => {
        S(!0), D();
      });
    },
    h ? y : null
  ), qw(() => D());
  const T = tt(() => {
    l(0), q(F);
  }, [F]), E = tt(
    (B = {}) => {
      const { delay: ee, delayRange: J } = B;
      S(!1), T(), J && (f(J), q(o(J))), ee && (m(ee), q(ee)), v(!0);
    },
    [T]
  ), D = tt(() => {
    v(!1), T();
  }, [T]);
  return He(() => {
    s >= i && D();
  }, [s, i, D]), Bn(
    () => ({ isRunning: h, isSuccessful: C, start: E, stop: D }),
    [h, C, E, D]
  );
}, i$ = (e) => {
  const n = e.graphQLErrors[0]?.extensions.integration?.responseHeaders?.["retry-after"];
  return n ? parseInt(n, 10) : void 0;
}, a$ = (e) => ({
  min: e * 1e3,
  max: e * 1e3 + 500
});
function o$({
  profileId: e,
  query: n
}) {
  const { useQuery: r } = mn(), [i, a] = se(), [o, s] = se(), {
    data: l,
    error: d,
    loading: m,
    refetch: u,
    networkStatus: f
  } = r(
    n === "lists" ? OT : PT,
    {
      fetchPolicy: "no-cache",
      notifyOnNetworkStatusChange: !0,
      variables: {
        profileId: e
      }
    }
  ), {
    isRunning: h,
    start: v,
    stop: C
  } = r$({
    query: u,
    useDelayRange: !0
  }), S = m || h;
  return He(() => {
    if (d)
      if (e0({
        errors: d.graphQLErrors
      })) {
        if (!h) {
          const j = i$(d);
          v({
            ...j && {
              delayRange: a$(j)
            }
          });
        }
      } else
        s(d);
  }, [d]), He(() => {
    if (!m && l?.Klaviyo) {
      let j = {}, F = {};
      n === "lists" && (j = l?.Klaviyo?.get_lists_for_profile), n === "segments" && (F = l?.Klaviyo?.get_segments_for_profile), (j?.data || F?.data) && (C(), a(
        (n === "lists" ? j?.data : F?.data)?.map((y) => ({
          ...y,
          type: n === "lists" ? "list" : "segment"
        }))
      ));
    }
  }, [m, l]), Bn(
    () => ({
      listsOrSegments: i,
      refetchListOrSegments: v,
      isLoading: S,
      error: o,
      networkStatus: f
    }),
    [i, S, o, f, v]
  );
}
const s$ = "_notificationText_1polx_1", xp = {
  notificationText: s$
}, Ys = ({ error: e }) => {
  const { track: n } = bn();
  let r = e;
  if (Vb(e)) {
    const i = e.graphQLErrors, a = i.length === 1 && Tb({ error: i[0] }), o = i.length === 1 && XS({ error: i[0] });
    if (a)
      n("klaviyo:profile:failed", { reason: "Invalid access token" }), r = new Error(
        "It was not possible to retrieve data from Klaviyo due to an access issue. Please contact your administrator."
      );
    else if (o)
      n("klaviyo:profile:failed", { reason: "Insufficient permissions" }), r = new Error(
        "You don't have enough permissions to see Klaviyo profile data for this conversation. This is typically due to a misconfiguration of the Klaviyo integration."
      );
    else
      return n("klaviyo:profile:failed", { reason: "Unexpected error" }), /* @__PURE__ */ Ne.jsx(Fn, { error: e });
  }
  return /* @__PURE__ */ Ne.jsx(b, { margin: "0 0 300", children: /* @__PURE__ */ Ne.jsx(
    Ke.Item,
    {
      contentLeft: /* @__PURE__ */ Ne.jsx(me, { color: "red.500", size: 20, name: "exclamation-triangle-filled" }),
      titleSecondary: r.message,
      title: "Unable to show Klaviyo profile data",
      variant: "dense"
    }
  ) });
}, l$ = "_message_1vrar_48", c$ = "_messageIsOpen_1vrar_56", d$ = "_messageHeader_1vrar_59", u$ = "_messageLabel_1vrar_65", m$ = "_messageText_1vrar_68", Li = {
  message: l$,
  messageIsOpen: c$,
  messageHeader: d$,
  messageLabel: u$,
  messageText: m$
}, p$ = ({ event: e, isLoadingPreview: n }) => {
  const r = e?.attributes?.event_properties, i = e.flowMessage && WT(e.flowMessage);
  return /* @__PURE__ */ Ne.jsxs(Ne.Fragment, { children: [
    /* @__PURE__ */ Ne.jsxs(b, { flexDirection: "column", justifyContent: "space-between", gap: "100", children: [
      /* @__PURE__ */ Ne.jsx(A.Paragraph, { variant: "4", className: Li.messageLabel, children: "Campaign name" }),
      /* @__PURE__ */ Ne.jsx(A.Paragraph, { children: r["Campaign Name"] })
    ] }),
    n ? /* @__PURE__ */ Ne.jsx(b, { justifyContent: "center", margin: "100", children: /* @__PURE__ */ Ne.jsx(cn, { size: 22 }) }) : i && i.length > 0 && /* @__PURE__ */ Ne.jsxs(
      b,
      {
        flexDirection: "column",
        justifyContent: "space-between",
        gap: "100",
        children: [
          /* @__PURE__ */ Ne.jsx(b, { children: /* @__PURE__ */ Ne.jsx(
            A.Paragraph,
            {
              variant: "4",
              className: Li.messageLabel,
              children: "Preview text"
            }
          ) }),
          /* @__PURE__ */ Ne.jsx(A.Paragraph, { variant: "4", className: Li.messageText, children: i })
        ]
      }
    )
  ] });
}, f$ = ({ event: e }) => {
  const n = e?.attributes?.event_properties;
  return /* @__PURE__ */ Ne.jsx(Ne.Fragment, { children: /* @__PURE__ */ Ne.jsxs(b, { flexDirection: "column", justifyContent: "space-between", gap: "100", children: [
    /* @__PURE__ */ Ne.jsx(b, { children: /* @__PURE__ */ Ne.jsx(A.Heading, { variant: "heading-4", children: "Message" }) }),
    /* @__PURE__ */ Ne.jsx(b, { children: n?.extra?.["Message Body"] })
  ] }) });
}, h$ = ({
  event: e,
  isLoadingPreview: n,
  openByDefault: r
}) => {
  const [i, a] = se(r), { attributes: o, eventType: s } = e, l = o?.datetime, d = o?.timestamp, m = "DD MMM YYYY @ HH:mm", u = Bn(
    () => () => l ? Ln(l).format(m) : d ? Ln.unix(d).format(m) : null,
    [d, l]
  )(), f = s === "EMAIL", h = s === "SMS", v = f && e.opened, C = f && e.clicked, S = f && o?.event_properties.Subject, j = h && o?.event_properties["Message Name"], F = f ? "mail" : "sms";
  return /* @__PURE__ */ Ne.jsxs(
    b,
    {
      gap: "300",
      flexDirection: "column",
      className: rt(Li.message, {
        [Li.messageIsOpen]: i
      }),
      children: [
        /* @__PURE__ */ Ne.jsxs(
          b,
          {
            alignItems: "center",
            justifyContent: "space-between",
            className: Li.messageHeader,
            onClick: () => a(!i),
            children: [
              /* @__PURE__ */ Ne.jsxs(b, { gap: "100", flexDirection: "column", children: [
                /* @__PURE__ */ Ne.jsxs(b, { gap: "200", alignItems: "center", children: [
                  /* @__PURE__ */ Ne.jsx(me, { size: 16, name: F }),
                  " ",
                  GT(s),
                  u && /* @__PURE__ */ Ne.jsx(Pn, { size: "small", variant: "info", children: u })
                ] }),
                S && S,
                j && j
              ] }),
              /* @__PURE__ */ Ne.jsx(
                Qt,
                {
                  variant: "tertiary",
                  icon: i ? "angle-up" : "angle-down"
                }
              )
            ]
          }
        ),
        i && /* @__PURE__ */ Ne.jsxs(b, { flexDirection: "column", gap: "300", children: [
          /* @__PURE__ */ Ne.jsx(Lm, {}),
          VT(e) && /* @__PURE__ */ Ne.jsx(b, { children: /* @__PURE__ */ Ne.jsx(Pn, { size: "medium", variant: "error", children: "Bounced" }) }),
          f && /* @__PURE__ */ Ne.jsxs(Ne.Fragment, { children: [
            /* @__PURE__ */ Ne.jsxs(b, { gap: "200", flexDirection: "row", flexWrap: "wrap", children: [
              /* @__PURE__ */ Ne.jsx(An, { children: /* @__PURE__ */ Ne.jsxs(b, { alignItems: "center", gap: "200", children: [
                /* @__PURE__ */ Ne.jsx(
                  me,
                  {
                    size: 16,
                    color: v ? "green.400" : "red.400",
                    name: v ? "check-circle-filled" : "close-circle-filled"
                  }
                ),
                " ",
                "Opened"
              ] }) }),
              /* @__PURE__ */ Ne.jsx(An, { children: /* @__PURE__ */ Ne.jsxs(b, { alignItems: "center", gap: "200", children: [
                /* @__PURE__ */ Ne.jsx(
                  me,
                  {
                    size: 16,
                    color: C ? "green.400" : "red.400",
                    name: C ? "check-circle-filled" : "close-circle-filled"
                  }
                ),
                " ",
                "Clicked"
              ] }) })
            ] }),
            /* @__PURE__ */ Ne.jsx(p$, { event: e, isLoadingPreview: n })
          ] }),
          h && /* @__PURE__ */ Ne.jsx(f$, { event: e })
        ] })
      ]
    }
  );
}, y$ = {
  /*
  	Compiler needs this casting so as not to complain that the string literal 'no-cache'
  	is actually of type "FetchPolicy", which type is defined as one of many string values,
  	including 'no-cache'.
  */
  fetchPolicy: "no-cache",
  notifyOnNetworkStatusChange: !0
}, g$ = ({
  profileId: e,
  noOfMessagesToShow: n
}) => {
  const [r, i] = se(!1), {
    receivedMessages: a,
    isLoading: o,
    error: s
  } = JT({
    profileId: e,
    noOfMessagesToShow: n
  }), [l, d] = yT({
    query: TT,
    options: y$,
    delayMs: 1e3
  }), [m, u] = se([]);
  He(() => {
    if (a.length > 0) {
      u(a);
      const h = a.filter((v) => sm(v)).map((v) => ov(v));
      h.length > 0 && (i(!0), l(
        h.map((v) => ({
          messageId: v
        }))
      ).finally(() => i(!1)));
    }
  }, [a]), He(() => {
    d.length > 0 && u(
      a?.map((h) => {
        if (h.eventType === "EMAIL" && sm(h) && !h.flowMessage) {
          const v = ov(h), C = d.find((j) => (j.data && lv(j.data))?.id === v), S = C?.data && lv(C.data);
          if (S)
            return {
              ...KT(h),
              flowMessage: S
            };
        }
        return h;
      })
    );
  }, [d]);
  const f = [];
  return s && f.push(s), d.length > 0 && f.push(
    ...d.map((h) => h.error).filter((h) => h)
  ), f && f.length > 0 ? /* @__PURE__ */ Ne.jsx(Ne.Fragment, { children: f.map((h, v) => h.graphQLErrors ? /* @__PURE__ */ Ne.jsx(
    Fn,
    {
      error: h
    },
    `lastMessagesError${v}`
  ) : /* @__PURE__ */ Ne.jsx(
    Ys,
    {
      error: h
    },
    `lastMessagesError${v}`
  )) }) : /* @__PURE__ */ Ne.jsxs(Ne.Fragment, { children: [
    /* @__PURE__ */ Ne.jsx(A.Heading, { variant: "heading-3", children: "Messages" }),
    o ? /* @__PURE__ */ Ne.jsx(b, { justifyContent: "center", margin: "0 0 300 0", children: /* @__PURE__ */ Ne.jsx(cn, {}) }) : /* @__PURE__ */ Ne.jsx(Ne.Fragment, { children: m?.length > 0 ? /* @__PURE__ */ Ne.jsx(b, { gap: "200", flexDirection: "column", children: m.map((h, v) => /* @__PURE__ */ Ne.jsx(
      h$,
      {
        event: h,
        isLoadingPreview: r,
        openByDefault: v === 0
      },
      h.id
    )) }) : /* @__PURE__ */ Ne.jsx(
      b,
      {
        justifyContent: "center",
        margin: "200",
        className: xp.notificationText,
        children: "No messages found for the profile"
      }
    ) })
  ] });
}, v$ = "_list_ld0hf_1", k$ = "_listItem_ld0hf_4", qr = {
  list: v$,
  listItem: k$
}, b$ = ({
  profile: e
}) => {
  const n = e?.data?.attributes?.properties, r = Object.entries(
    n ?? {}
  ).filter(([a, o]) => a !== "__typename" && o != null), i = r.length > 0;
  return /* @__PURE__ */ Ne.jsxs(b, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ Ne.jsx(A.Heading, { variant: "heading-3", children: "Custom properties" }),
    !i && /* @__PURE__ */ Ne.jsx(A.Paragraph, { variant: "4", color: "secondary", align: "center", children: "No custom properties available" }),
    i && /* @__PURE__ */ Ne.jsx(Ke, { className: qr.list, children: r.map(([a, o]) => typeof o == "boolean" || typeof o == "string" || typeof o == "number" || Array.isArray(o) && o.every((s) => typeof s == "string") ? /* @__PURE__ */ Ne.jsx(Ke.Text, { variant: "dense", className: qr.listItem, children: /* @__PURE__ */ Ne.jsxs(
      b,
      {
        justifyContent: "space-between",
        alignItems: "flex-start",
        gap: "200",
        children: [
          /* @__PURE__ */ Ne.jsx(A.Paragraph, { variant: "4", children: ZS(a) }),
          /* @__PURE__ */ Ne.jsx(
            b,
            {
              style: { flex: 1, minWidth: 0 },
              justifyContent: "flex-end",
              children: Xa(o)
            }
          )
        ]
      }
    ) }, a) : null) })
  ] });
}, dv = ({
  profileId: e,
  type: n
}) => {
  const [r, i] = se(!1), {
    listsOrSegments: a,
    error: o,
    isLoading: s,
    networkStatus: l,
    refetchListOrSegments: d
  } = o$({ profileId: e, query: n });
  He(() => {
    l === 4 && i(!0);
  }, [l]);
  const m = () => {
    a || d();
  }, u = a || [];
  return o ? /* @__PURE__ */ Ne.jsx(Ys, { error: o }) : s ? /* @__PURE__ */ Ne.jsx(Ke.Text, { variant: "dense", className: qr.listItem, children: /* @__PURE__ */ Ne.jsx(cn, { size: 14 }) }, "loading") : u.length > 0 ? /* @__PURE__ */ Ne.jsx(Ne.Fragment, { children: u.map(
    ({ attributes: f, type: h }, v) => /* @__PURE__ */ Ne.jsx(Ke.Text, { variant: "dense", className: qr.listItem, children: /* @__PURE__ */ Ne.jsxs(b, { justifyContent: "space-between", alignItems: "center", children: [
      /* @__PURE__ */ Ne.jsx(A.Paragraph, { variant: "4", children: f?.name }),
      !!h && /* @__PURE__ */ Ne.jsx(An, { children: $b(h) })
    ] }) }, v)
  ) }) : r && !a ? /* @__PURE__ */ Ne.jsx(Ke.Text, { variant: "dense", className: qr.listItem, children: /* @__PURE__ */ Ne.jsxs(b, { justifyContent: "space-between", alignItems: "center", children: [
    /* @__PURE__ */ Ne.jsxs(b, { gap: "200", children: [
      /* @__PURE__ */ Ne.jsx(me, { name: "exclamation-triangle-filled", color: "red" }),
      /* @__PURE__ */ Ne.jsxs(A.Paragraph, { variant: "4", color: "red.500", children: [
        n === "lists" ? "Lists" : "Segments",
        " could not be loaded"
      ] })
    ] }),
    /* @__PURE__ */ Ne.jsx(Ge, { content: "Refresh lists and segments", children: /* @__PURE__ */ Ne.jsx(Wn, { icon: "sync", variant: "secondary", onClick: () => m(), children: "Retry" }) })
  ] }) }, "refetch") : /* @__PURE__ */ Ne.jsx(Ke.Text, { variant: "dense", className: qr.listItem, children: /* @__PURE__ */ Ne.jsx(b, { justifyContent: "space-between", alignItems: "center", children: /* @__PURE__ */ Ne.jsx(A.Paragraph, { variant: "4", subdued: !0, children: /* @__PURE__ */ Ne.jsx("i", { children: `No ${n === "lists" ? "lists" : "segments"} available` }) }) }) }, "refetch");
}, _$ = 0.7, x$ = 0.3, S$ = (e) => e >= _$ ? { variant: "error", label: "High risk" } : e >= x$ ? { variant: "warning", label: "Medium risk" } : { variant: "success", label: "Low risk" }, N$ = (e) => /* @__PURE__ */ Ne.jsx(A.Paragraph, { as: "span", variant: "4", children: e.toFixed(2) }), j$ = (e) => {
  const n = S$(e);
  return /* @__PURE__ */ Ne.jsxs(b, { alignItems: "center", gap: "100", children: [
    /* @__PURE__ */ Ne.jsx(Pn, { size: "small", variant: n.variant, children: n.label }),
    /* @__PURE__ */ Ne.jsx(A.Paragraph, { as: "span", variant: "4", children: `${(e * 100).toFixed(1)}%` })
  ] });
}, w$ = (e) => {
  const n = e?.data?.attributes?.predictive_analytics ?? null;
  if (!n)
    return [];
  const r = [
    ["Average order value", n.average_order_value],
    ["Historic lifetime value", n.historic_clv],
    ["Predicted lifetime value", n.predicted_clv],
    ["Total lifetime value", n.total_clv]
  ], i = [
    ["Historic orders", n.historic_number_of_orders],
    ["Predicted orders", n.predicted_number_of_orders],
    [
      "Average days between orders",
      n.average_days_between_orders
    ],
    ["Expected next order", n.expected_date_of_next_order]
  ], a = n.churn_probability, o = n.ranked_channel_affinity?.filter(Boolean) ?? null;
  return [
    ...r.flatMap(
      ([s, l]) => l ? [{ label: s, content: N$(l) }] : []
    ),
    ...i.flatMap(
      ([s, l]) => l ? [{ label: s, content: Xa(l) }] : []
    ),
    ...a ? [
      {
        label: "Churn probability",
        content: j$(a)
      }
    ] : [],
    ...o?.length ? [
      {
        label: "Channel affinity",
        content: Xa(o)
      }
    ] : []
  ];
}, C$ = ({
  profile: e
}) => {
  const n = w$(e);
  return /* @__PURE__ */ Ne.jsxs(b, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ Ne.jsx(A.Heading, { variant: "heading-3", children: "Predictive analytics" }),
    n.length === 0 && /* @__PURE__ */ Ne.jsx(A.Paragraph, { variant: "4", color: "secondary", align: "center", children: "No predictive analytics available" }),
    n.length > 0 && /* @__PURE__ */ Ne.jsx(Ke, { className: qr.list, children: n.map(({ label: r, content: i }) => /* @__PURE__ */ Ne.jsx(Ke.Text, { variant: "dense", className: qr.listItem, children: /* @__PURE__ */ Ne.jsxs(
      b,
      {
        justifyContent: "space-between",
        alignItems: "center",
        gap: "200",
        children: [
          /* @__PURE__ */ Ne.jsx(A.Paragraph, { as: "span", variant: "4", children: r }),
          i
        ]
      }
    ) }, r)) })
  ] });
}, F$ = "_tagHover_kzbzk_1", I$ = "_channelUnsubscribed_kzbzk_6", uv = {
  tagHover: F$,
  channelUnsubscribed: I$
}, mv = ({
  isSubscribed: e,
  isLoading: n,
  channelName: r,
  channelIcon: i,
  hasReSubscriptionFeature: a,
  handleAction: o
}) => {
  const s = e ? "Unsubscribe" : "Subscribe", l = !e && !a;
  return /* @__PURE__ */ Ne.jsx(
    Ge,
    {
      content: l ? "You have to select a resubscription list in the settings." : s,
      children: /* @__PURE__ */ Ne.jsx(
        An,
        {
          className: uv.tagHover,
          color: e ? "green.500" : "neutral.200",
          children: /* @__PURE__ */ Ne.jsxs(
            b,
            {
              "data-testid": `widget-preference-${e ? "subscribed" : "unsubscribed"}`,
              gap: "200",
              alignItems: "center",
              className: rt({
                [uv.channelUnsubscribed]: !e || l
              }),
              onClick: () => {
                l || o();
              },
              children: [
                n ? /* @__PURE__ */ Ne.jsx(cn, { size: 16 }) : /* @__PURE__ */ Ne.jsx(me, { size: 16, name: i }),
                r
              ]
            }
          )
        }
      )
    }
  );
}, E$ = "_subscriptionError_1qhhx_1", T$ = {
  subscriptionError: E$
}, $$ = ({
  subscriptionListId: e,
  profile: n,
  email: r,
  phoneNumber: i,
  profileId: a,
  refetchProfile: o
}) => {
  const [s, l] = se(!1), [d, m] = se(!1), [u, f] = se(), { track: h } = bn(), [v, C] = Bw({
    channel: null,
    request: null
  }), S = YT(n), j = QT(n), F = !!e, { useMutation: y } = mn(), [q] = y(
    AT
  ), [T] = y(
    LT
  ), E = (ee) => {
    h("klaviyo:profile:subscribe:clicked", { channel: ee }), C.setAll({
      channel: ee,
      request: "subscribed"
    }), ((J) => q({
      variables: {
        attributes: {
          // eslint-disable-next-line camelcase
          custom_source: "Dixa integration",
          profiles: {
            data: [
              {
                type: im.Profile,
                id: a,
                attributes: {
                  email: r,
                  // eslint-disable-next-line camelcase
                  ...i ? { phone_number: i } : {},
                  subscriptions: {
                    ...J === "EMAIL" && {
                      email: {
                        marketing: {
                          consent: am.Subscribed
                        }
                      }
                    },
                    ...J === "SMS" && {
                      sms: {
                        marketing: {
                          consent: am.Subscribed
                        }
                      }
                    }
                  }
                }
              }
            ]
          }
        },
        relationships: {
          list: {
            data: {
              type: dx.List,
              id: e
            }
          }
        }
      }
    }))(ee).then(
      (J) => B({
        channel: ee,
        mutationResponse: J,
        isSubscriptionRequest: !0
      })
    ).catch(
      (J) => B({
        channel: ee,
        mutationErrorResponse: J,
        isSubscriptionRequest: !0
      })
    );
  }, D = (ee) => {
    h("klaviyo:profile:unsubscribe:clicked", { channel: ee }), C.setAll({
      channel: ee,
      request: "unsubscribed"
    }), T({
      variables: {
        attributes: {
          profiles: {
            data: [
              {
                type: im.Profile,
                attributes: {
                  ...ee === "EMAIL" ? { email: r } : {},
                  // eslint-disable-next-line camelcase
                  ...ee === "SMS" ? { phone_number: i } : {},
                  subscriptions: {
                    ...ee === "EMAIL" && {
                      email: {
                        marketing: {
                          consent: om.Unsubscribed
                        }
                      }
                    },
                    ...ee === "SMS" && {
                      sms: {
                        marketing: {
                          consent: om.Unsubscribed
                        }
                      }
                    }
                  }
                }
              }
            ]
          }
        }
      }
    }).then(
      (J) => B({
        channel: ee,
        mutationResponse: J,
        isSubscriptionRequest: !1
      })
    ).catch(
      (J) => B({
        channel: ee,
        mutationErrorResponse: J,
        isSubscriptionRequest: !1
      })
    );
  }, B = async ({
    channel: ee,
    mutationResponse: J,
    mutationErrorResponse: ae,
    isSubscriptionRequest: Q
  }) => {
    const U = ae?.networkError, O = U ? U?.statusCode : NaN, H = J?.errors, Z = !!H && Db({
      errors: H
    });
    O === 202 ? (h(
      Q ? "klaviyo:profile:subscribe:succeeded" : "klaviyo:profile:unsubscribe:succeeded",
      { channel: ee }
    ), await o()) : Z ? (h(
      Q ? "klaviyo:profile:subscribe:failed" : "klaviyo:profile:unsubscribe:failed",
      {
        channel: ee,
        reason: "Insufficient permissions"
      }
    ), f(
      `Request failed with a permission error. Could not ${Q ? "opt-in" : "opt-out"}.`
    )) : (h(
      Q ? "klaviyo:profile:subscribe:failed" : "klaviyo:profile:unsubscribe:failed",
      {
        channel: ee,
        reason: U?.message || "Unexpected error"
      }
    ), f(
      `Request failed. Could not ${Q ? "opt-in" : "opt-out"}.`
    )), m(!1), l(!1);
  };
  return He(() => {
    if (v.request === "subscribed") {
      const ee = `This subscription might be a double opt-in. The customer needs to check if they received a confirmation ${v.channel === "EMAIL" ? "email" : "sms"} to give consent.`;
      v.channel === "EMAIL" && !s && n?.data?.attributes?.subscriptions?.email?.marketing?.consent !== "SUBSCRIBED" && (f(ee), C.reset()), v.channel === "SMS" && !d && n?.data?.attributes?.subscriptions?.sms?.marketing?.consent !== "SUBSCRIBED" && (f(ee), C.reset());
    }
  }, [
    n?.data?.attributes?.subscriptions?.email?.marketing?.consent,
    n?.data?.attributes?.subscriptions?.sms?.marketing?.consent,
    s,
    d
  ]), /* @__PURE__ */ Ne.jsx(
    b,
    {
      "data-testid": "subscription-channels",
      gap: "200",
      flexDirection: "column",
      children: /* @__PURE__ */ Ne.jsxs(b, { gap: "200", flexDirection: "column", children: [
        /* @__PURE__ */ Ne.jsx(A.Heading, { variant: "heading-3", children: "Subscription channels" }),
        /* @__PURE__ */ Ne.jsxs(b, { gap: "100", flexDirection: "row", children: [
          /* @__PURE__ */ Ne.jsx(
            mv,
            {
              "data-testid": "subscription-channels-email-button",
              isLoading: s,
              isSubscribed: S,
              channelName: "Email",
              channelIcon: "mail",
              hasReSubscriptionFeature: F,
              handleAction: () => {
                l(!0), f(void 0), S ? D("EMAIL") : E("EMAIL");
              }
            }
          ),
          /* @__PURE__ */ Ne.jsx(
            mv,
            {
              "data-testid": "subscription-channels-sms-button",
              isLoading: d,
              isSubscribed: j,
              channelName: "Sms",
              channelIcon: "sms",
              hasReSubscriptionFeature: F,
              handleAction: () => {
                m(!0), f(void 0), j ? D("SMS") : E("SMS");
              }
            }
          )
        ] }),
        u && /* @__PURE__ */ Ne.jsx(b, { className: T$.subscriptionError, children: u })
      ] })
    }
  );
}, D$ = ({
  profileId: e,
  email: n,
  phoneNumber: r,
  showProfileLists: i,
  showProfileSegments: a,
  showSubscriptions: o,
  showCustomProperties: s,
  showPredictiveAnalytics: l,
  noOfMessagesToShow: d,
  subscriptionListId: m
}) => {
  const {
    profile: u,
    error: f,
    isLoading: h,
    refetchProfile: v
  } = XT({ profileId: e });
  return f ? /* @__PURE__ */ Ne.jsx(Ys, { error: f }) : h ? /* @__PURE__ */ Ne.jsx(b, { justifyContent: "center", margin: "0 0 300 0", children: /* @__PURE__ */ Ne.jsx(cn, {}) }) : !u && !h ? /* @__PURE__ */ Ne.jsx(
    b,
    {
      justifyContent: "center",
      margin: "200",
      className: xp.notificationText,
      children: "No Klaviyo profile data found"
    }
  ) : /* @__PURE__ */ Ne.jsxs(b, { flexDirection: "column", gap: "300", margin: "200 0 300", children: [
    (i || a) && /* @__PURE__ */ Ne.jsxs(b, { gap: "200", flexDirection: "column", children: [
      /* @__PURE__ */ Ne.jsx(A.Heading, { variant: "heading-3", children: "Lists & Segments" }),
      /* @__PURE__ */ Ne.jsxs(Ke, { className: qr.list, children: [
        i && /* @__PURE__ */ Ne.jsx(dv, { profileId: e, type: "lists" }),
        a && /* @__PURE__ */ Ne.jsx(
          dv,
          {
            profileId: e,
            type: "segments"
          }
        )
      ] })
    ] }),
    u && e && o && /* @__PURE__ */ Ne.jsx(
      $$,
      {
        profile: u,
        profileId: e,
        subscriptionListId: m,
        refetchProfile: v,
        email: n,
        phoneNumber: r
      }
    ),
    u && l && /* @__PURE__ */ Ne.jsx(C$, { profile: u }),
    u && s && /* @__PURE__ */ Ne.jsx(b$, { profile: u }),
    /* @__PURE__ */ Ne.jsx(
      g$,
      {
        profileId: e,
        noOfMessagesToShow: d
      }
    )
  ] });
}, R$ = ({
  conversationContext: e,
  settings: n
}) => {
  const r = e.customer?.email || void 0, i = e.customer?.phone_number || void 0, a = n?.showProfileLists, o = n?.showProfileSegments, s = n?.showSubscriptions, l = n?.showCustomProperties, d = n?.showPredictiveAnalytics, m = Number(n?.noOfMessagesToShow), u = n?.subscriptionListId, {
    profileId: f,
    getProfileId: h,
    isLoading: v,
    error: C
  } = ZT({ email: r, phoneNumber: i });
  return l0(() => {
    (r || i) && h({
      variables: {
        emailFilter: r ? `equals(email,"${r}")` : void 0,
        phoneNumberFilter: i ? `equals(phone_number,"${i}")` : void 0,
        hasEmail: !!r,
        hasPhoneNumber: !!i
      }
    });
  }, [r, i]), !r && !i ? /* @__PURE__ */ Ne.jsx(b, { justifyContent: "center", margin: "0 0 300 0", children: "The customer does not have an email nor a phone number" }) : v ? /* @__PURE__ */ Ne.jsx(b, { justifyContent: "center", margin: "0 0 300 0", children: /* @__PURE__ */ Ne.jsx(cn, {}) }) : C ? /* @__PURE__ */ Ne.jsx(Ys, { error: C }) : f ? /* @__PURE__ */ Ne.jsx(
    D$,
    {
      profileId: f,
      email: r,
      phoneNumber: i,
      showProfileLists: a,
      showProfileSegments: o,
      showSubscriptions: s,
      showCustomProperties: l,
      showPredictiveAnalytics: d,
      noOfMessagesToShow: m,
      subscriptionListId: u
    }
  ) : /* @__PURE__ */ Ne.jsx(
    b,
    {
      justifyContent: "center",
      margin: "0 0 300 0",
      className: xp.notificationText,
      children: "No profile ID found"
    }
  );
}, O$ = [
  {
    key: "showProfileLists",
    label: "Show Klaviyo lists for a profile",
    required: !1,
    secret: !1,
    type: "switch",
    defaultValue: !1
  },
  {
    key: "showProfileSegments",
    label: "Show Klaviyo segments for a profile",
    required: !1,
    secret: !1,
    type: "switch",
    defaultValue: !1
  },
  {
    key: "showSubscriptions",
    label: "Show subscription channels for Klaviyo messages",
    required: !1,
    secret: !1,
    type: "switch",
    defaultValue: !1
  },
  {
    key: "showCustomProperties",
    label: "Show custom properties for a profile",
    required: !1,
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "showPredictiveAnalytics",
    label: "Show predictive analytics for a profile",
    required: !1,
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "subscriptionListId",
    label: "Activate re-/subscription list selection",
    secret: !1,
    type: "hidden",
    hideOnCreate: !0
  },
  {
    key: "subscriptionListComponent",
    label: "Select a list to subscribe to",
    secret: !1,
    type: "custom",
    hideOnCreate: !0,
    component: JS
  },
  {
    key: "noOfMessagesToShow",
    label: "Choose how many messages to show",
    required: !0,
    secret: !1,
    type: "select",
    defaultValue: "5",
    selectItems: [
      { value: "3", label: "The three latest messages" },
      { value: "4", label: "The four latest messages" },
      { value: "5", label: "The five latest messages" }
    ]
  }
], P$ = [
  /**
   * The store ID will be fetched through the OAuth flow, so there's no real
   * reason to show it
   */
  {
    key: "authorizeWithOauth",
    label: "Authorize with OAuth",
    secret: !1,
    type: "custom",
    hideOnCreate: !0,
    component: vi
  }
], A$ = [
  {
    key: "klaviyoApiKey",
    label: "API key",
    placeholder: "API key from Klaviyo",
    required: !0,
    secret: !0,
    type: "input"
  }
];
function L$(e, n) {
  const r = {};
  return (e[e.length - 1] === "" ? [...e, ""] : e).join(
    (r.padRight ? " " : "") + "," + (r.padLeft === !1 ? "" : " ")
  ).trim();
}
const V$ = /^[$_\p{ID_Start}][$_\u{200C}\u{200D}\p{ID_Continue}]*$/u, z$ = /^[$_\p{ID_Start}][-$_\u{200C}\u{200D}\p{ID_Continue}]*$/u, U$ = {};
function pv(e, n) {
  return (U$.jsx ? z$ : V$).test(e);
}
const M$ = /[ \t\n\f\r]/g;
function B$(e) {
  return typeof e == "object" ? e.type === "text" ? fv(e.value) : !1 : fv(e);
}
function fv(e) {
  return e.replace(M$, "") === "";
}
class fo {
  /**
   * @constructor
   * @param {Properties} property
   * @param {Normal} normal
   * @param {string} [space]
   */
  constructor(n, r, i) {
    this.property = n, this.normal = r, i && (this.space = i);
  }
}
fo.prototype.property = {};
fo.prototype.normal = {};
fo.prototype.space = null;
function ux(e, n) {
  const r = {}, i = {};
  let a = -1;
  for (; ++a < e.length; )
    Object.assign(r, e[a].property), Object.assign(i, e[a].normal);
  return new fo(r, i, n);
}
function lm(e) {
  return e.toLowerCase();
}
class ur {
  /**
   * @constructor
   * @param {string} property
   * @param {string} attribute
   */
  constructor(n, r) {
    this.property = n, this.attribute = r;
  }
}
ur.prototype.space = null;
ur.prototype.boolean = !1;
ur.prototype.booleanish = !1;
ur.prototype.overloadedBoolean = !1;
ur.prototype.number = !1;
ur.prototype.commaSeparated = !1;
ur.prototype.spaceSeparated = !1;
ur.prototype.commaOrSpaceSeparated = !1;
ur.prototype.mustUseProperty = !1;
ur.prototype.defined = !1;
let q$ = 0;
const In = Si(), mt = Si(), mx = Si(), Ve = Si(), Xn = Si(), Vi = Si(), Jt = Si();
function Si() {
  return 2 ** ++q$;
}
const cm = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  boolean: In,
  booleanish: mt,
  commaOrSpaceSeparated: Jt,
  commaSeparated: Vi,
  number: Ve,
  overloadedBoolean: mx,
  spaceSeparated: Xn
}, Symbol.toStringTag, { value: "Module" })), ru = Object.keys(cm);
class Sp extends ur {
  /**
   * @constructor
   * @param {string} property
   * @param {string} attribute
   * @param {number|null} [mask]
   * @param {string} [space]
   */
  constructor(n, r, i, a) {
    let o = -1;
    if (super(n, r), hv(this, "space", a), typeof i == "number")
      for (; ++o < ru.length; ) {
        const s = ru[o];
        hv(this, ru[o], (i & cm[s]) === cm[s]);
      }
  }
}
Sp.prototype.defined = !0;
function hv(e, n, r) {
  r && (e[n] = r);
}
const H$ = {}.hasOwnProperty;
function Xi(e) {
  const n = {}, r = {};
  let i;
  for (i in e.properties)
    if (H$.call(e.properties, i)) {
      const a = e.properties[i], o = new Sp(
        i,
        e.transform(e.attributes || {}, i),
        a,
        e.space
      );
      e.mustUseProperty && e.mustUseProperty.includes(i) && (o.mustUseProperty = !0), n[i] = o, r[lm(i)] = i, r[lm(o.attribute)] = i;
    }
  return new fo(n, r, e.space);
}
const px = Xi({
  space: "xlink",
  transform(e, n) {
    return "xlink:" + n.slice(5).toLowerCase();
  },
  properties: {
    xLinkActuate: null,
    xLinkArcRole: null,
    xLinkHref: null,
    xLinkRole: null,
    xLinkShow: null,
    xLinkTitle: null,
    xLinkType: null
  }
}), fx = Xi({
  space: "xml",
  transform(e, n) {
    return "xml:" + n.slice(3).toLowerCase();
  },
  properties: { xmlLang: null, xmlBase: null, xmlSpace: null }
});
function hx(e, n) {
  return n in e ? e[n] : n;
}
function yx(e, n) {
  return hx(e, n.toLowerCase());
}
const gx = Xi({
  space: "xmlns",
  attributes: { xmlnsxlink: "xmlns:xlink" },
  transform: yx,
  properties: { xmlns: null, xmlnsXLink: null }
}), vx = Xi({
  transform(e, n) {
    return n === "role" ? n : "aria-" + n.slice(4).toLowerCase();
  },
  properties: {
    ariaActiveDescendant: null,
    ariaAtomic: mt,
    ariaAutoComplete: null,
    ariaBusy: mt,
    ariaChecked: mt,
    ariaColCount: Ve,
    ariaColIndex: Ve,
    ariaColSpan: Ve,
    ariaControls: Xn,
    ariaCurrent: null,
    ariaDescribedBy: Xn,
    ariaDetails: null,
    ariaDisabled: mt,
    ariaDropEffect: Xn,
    ariaErrorMessage: null,
    ariaExpanded: mt,
    ariaFlowTo: Xn,
    ariaGrabbed: mt,
    ariaHasPopup: null,
    ariaHidden: mt,
    ariaInvalid: null,
    ariaKeyShortcuts: null,
    ariaLabel: null,
    ariaLabelledBy: Xn,
    ariaLevel: Ve,
    ariaLive: null,
    ariaModal: mt,
    ariaMultiLine: mt,
    ariaMultiSelectable: mt,
    ariaOrientation: null,
    ariaOwns: Xn,
    ariaPlaceholder: null,
    ariaPosInSet: Ve,
    ariaPressed: mt,
    ariaReadOnly: mt,
    ariaRelevant: null,
    ariaRequired: mt,
    ariaRoleDescription: Xn,
    ariaRowCount: Ve,
    ariaRowIndex: Ve,
    ariaRowSpan: Ve,
    ariaSelected: mt,
    ariaSetSize: Ve,
    ariaSort: null,
    ariaValueMax: Ve,
    ariaValueMin: Ve,
    ariaValueNow: Ve,
    ariaValueText: null,
    role: null
  }
}), W$ = Xi({
  space: "html",
  attributes: {
    acceptcharset: "accept-charset",
    classname: "class",
    htmlfor: "for",
    httpequiv: "http-equiv"
  },
  transform: yx,
  mustUseProperty: ["checked", "multiple", "muted", "selected"],
  properties: {
    // Standard Properties.
    abbr: null,
    accept: Vi,
    acceptCharset: Xn,
    accessKey: Xn,
    action: null,
    allow: null,
    allowFullScreen: In,
    allowPaymentRequest: In,
    allowUserMedia: In,
    alt: null,
    as: null,
    async: In,
    autoCapitalize: null,
    autoComplete: Xn,
    autoFocus: In,
    autoPlay: In,
    blocking: Xn,
    capture: null,
    charSet: null,
    checked: In,
    cite: null,
    className: Xn,
    cols: Ve,
    colSpan: null,
    content: null,
    contentEditable: mt,
    controls: In,
    controlsList: Xn,
    coords: Ve | Vi,
    crossOrigin: null,
    data: null,
    dateTime: null,
    decoding: null,
    default: In,
    defer: In,
    dir: null,
    dirName: null,
    disabled: In,
    download: mx,
    draggable: mt,
    encType: null,
    enterKeyHint: null,
    fetchPriority: null,
    form: null,
    formAction: null,
    formEncType: null,
    formMethod: null,
    formNoValidate: In,
    formTarget: null,
    headers: Xn,
    height: Ve,
    hidden: In,
    high: Ve,
    href: null,
    hrefLang: null,
    htmlFor: Xn,
    httpEquiv: Xn,
    id: null,
    imageSizes: null,
    imageSrcSet: null,
    inert: In,
    inputMode: null,
    integrity: null,
    is: null,
    isMap: In,
    itemId: null,
    itemProp: Xn,
    itemRef: Xn,
    itemScope: In,
    itemType: Xn,
    kind: null,
    label: null,
    lang: null,
    language: null,
    list: null,
    loading: null,
    loop: In,
    low: Ve,
    manifest: null,
    max: null,
    maxLength: Ve,
    media: null,
    method: null,
    min: null,
    minLength: Ve,
    multiple: In,
    muted: In,
    name: null,
    nonce: null,
    noModule: In,
    noValidate: In,
    onAbort: null,
    onAfterPrint: null,
    onAuxClick: null,
    onBeforeMatch: null,
    onBeforePrint: null,
    onBeforeToggle: null,
    onBeforeUnload: null,
    onBlur: null,
    onCancel: null,
    onCanPlay: null,
    onCanPlayThrough: null,
    onChange: null,
    onClick: null,
    onClose: null,
    onContextLost: null,
    onContextMenu: null,
    onContextRestored: null,
    onCopy: null,
    onCueChange: null,
    onCut: null,
    onDblClick: null,
    onDrag: null,
    onDragEnd: null,
    onDragEnter: null,
    onDragExit: null,
    onDragLeave: null,
    onDragOver: null,
    onDragStart: null,
    onDrop: null,
    onDurationChange: null,
    onEmptied: null,
    onEnded: null,
    onError: null,
    onFocus: null,
    onFormData: null,
    onHashChange: null,
    onInput: null,
    onInvalid: null,
    onKeyDown: null,
    onKeyPress: null,
    onKeyUp: null,
    onLanguageChange: null,
    onLoad: null,
    onLoadedData: null,
    onLoadedMetadata: null,
    onLoadEnd: null,
    onLoadStart: null,
    onMessage: null,
    onMessageError: null,
    onMouseDown: null,
    onMouseEnter: null,
    onMouseLeave: null,
    onMouseMove: null,
    onMouseOut: null,
    onMouseOver: null,
    onMouseUp: null,
    onOffline: null,
    onOnline: null,
    onPageHide: null,
    onPageShow: null,
    onPaste: null,
    onPause: null,
    onPlay: null,
    onPlaying: null,
    onPopState: null,
    onProgress: null,
    onRateChange: null,
    onRejectionHandled: null,
    onReset: null,
    onResize: null,
    onScroll: null,
    onScrollEnd: null,
    onSecurityPolicyViolation: null,
    onSeeked: null,
    onSeeking: null,
    onSelect: null,
    onSlotChange: null,
    onStalled: null,
    onStorage: null,
    onSubmit: null,
    onSuspend: null,
    onTimeUpdate: null,
    onToggle: null,
    onUnhandledRejection: null,
    onUnload: null,
    onVolumeChange: null,
    onWaiting: null,
    onWheel: null,
    open: In,
    optimum: Ve,
    pattern: null,
    ping: Xn,
    placeholder: null,
    playsInline: In,
    popover: null,
    popoverTarget: null,
    popoverTargetAction: null,
    poster: null,
    preload: null,
    readOnly: In,
    referrerPolicy: null,
    rel: Xn,
    required: In,
    reversed: In,
    rows: Ve,
    rowSpan: Ve,
    sandbox: Xn,
    scope: null,
    scoped: In,
    seamless: In,
    selected: In,
    shadowRootClonable: In,
    shadowRootDelegatesFocus: In,
    shadowRootMode: null,
    shape: null,
    size: Ve,
    sizes: null,
    slot: null,
    span: Ve,
    spellCheck: mt,
    src: null,
    srcDoc: null,
    srcLang: null,
    srcSet: null,
    start: Ve,
    step: null,
    style: null,
    tabIndex: Ve,
    target: null,
    title: null,
    translate: null,
    type: null,
    typeMustMatch: In,
    useMap: null,
    value: mt,
    width: Ve,
    wrap: null,
    writingSuggestions: null,
    // Legacy.
    // See: https://html.spec.whatwg.org/#other-elements,-attributes-and-apis
    align: null,
    // Several. Use CSS `text-align` instead,
    aLink: null,
    // `<body>`. Use CSS `a:active {color}` instead
    archive: Xn,
    // `<object>`. List of URIs to archives
    axis: null,
    // `<td>` and `<th>`. Use `scope` on `<th>`
    background: null,
    // `<body>`. Use CSS `background-image` instead
    bgColor: null,
    // `<body>` and table elements. Use CSS `background-color` instead
    border: Ve,
    // `<table>`. Use CSS `border-width` instead,
    borderColor: null,
    // `<table>`. Use CSS `border-color` instead,
    bottomMargin: Ve,
    // `<body>`
    cellPadding: null,
    // `<table>`
    cellSpacing: null,
    // `<table>`
    char: null,
    // Several table elements. When `align=char`, sets the character to align on
    charOff: null,
    // Several table elements. When `char`, offsets the alignment
    classId: null,
    // `<object>`
    clear: null,
    // `<br>`. Use CSS `clear` instead
    code: null,
    // `<object>`
    codeBase: null,
    // `<object>`
    codeType: null,
    // `<object>`
    color: null,
    // `<font>` and `<hr>`. Use CSS instead
    compact: In,
    // Lists. Use CSS to reduce space between items instead
    declare: In,
    // `<object>`
    event: null,
    // `<script>`
    face: null,
    // `<font>`. Use CSS instead
    frame: null,
    // `<table>`
    frameBorder: null,
    // `<iframe>`. Use CSS `border` instead
    hSpace: Ve,
    // `<img>` and `<object>`
    leftMargin: Ve,
    // `<body>`
    link: null,
    // `<body>`. Use CSS `a:link {color: *}` instead
    longDesc: null,
    // `<frame>`, `<iframe>`, and `<img>`. Use an `<a>`
    lowSrc: null,
    // `<img>`. Use a `<picture>`
    marginHeight: Ve,
    // `<body>`
    marginWidth: Ve,
    // `<body>`
    noResize: In,
    // `<frame>`
    noHref: In,
    // `<area>`. Use no href instead of an explicit `nohref`
    noShade: In,
    // `<hr>`. Use background-color and height instead of borders
    noWrap: In,
    // `<td>` and `<th>`
    object: null,
    // `<applet>`
    profile: null,
    // `<head>`
    prompt: null,
    // `<isindex>`
    rev: null,
    // `<link>`
    rightMargin: Ve,
    // `<body>`
    rules: null,
    // `<table>`
    scheme: null,
    // `<meta>`
    scrolling: mt,
    // `<frame>`. Use overflow in the child context
    standby: null,
    // `<object>`
    summary: null,
    // `<table>`
    text: null,
    // `<body>`. Use CSS `color` instead
    topMargin: Ve,
    // `<body>`
    valueType: null,
    // `<param>`
    version: null,
    // `<html>`. Use a doctype.
    vAlign: null,
    // Several. Use CSS `vertical-align` instead
    vLink: null,
    // `<body>`. Use CSS `a:visited {color}` instead
    vSpace: Ve,
    // `<img>` and `<object>`
    // Non-standard Properties.
    allowTransparency: null,
    autoCorrect: null,
    autoSave: null,
    disablePictureInPicture: In,
    disableRemotePlayback: In,
    prefix: null,
    property: null,
    results: Ve,
    security: null,
    unselectable: null
  }
}), K$ = Xi({
  space: "svg",
  attributes: {
    accentHeight: "accent-height",
    alignmentBaseline: "alignment-baseline",
    arabicForm: "arabic-form",
    baselineShift: "baseline-shift",
    capHeight: "cap-height",
    className: "class",
    clipPath: "clip-path",
    clipRule: "clip-rule",
    colorInterpolation: "color-interpolation",
    colorInterpolationFilters: "color-interpolation-filters",
    colorProfile: "color-profile",
    colorRendering: "color-rendering",
    crossOrigin: "crossorigin",
    dataType: "datatype",
    dominantBaseline: "dominant-baseline",
    enableBackground: "enable-background",
    fillOpacity: "fill-opacity",
    fillRule: "fill-rule",
    floodColor: "flood-color",
    floodOpacity: "flood-opacity",
    fontFamily: "font-family",
    fontSize: "font-size",
    fontSizeAdjust: "font-size-adjust",
    fontStretch: "font-stretch",
    fontStyle: "font-style",
    fontVariant: "font-variant",
    fontWeight: "font-weight",
    glyphName: "glyph-name",
    glyphOrientationHorizontal: "glyph-orientation-horizontal",
    glyphOrientationVertical: "glyph-orientation-vertical",
    hrefLang: "hreflang",
    horizAdvX: "horiz-adv-x",
    horizOriginX: "horiz-origin-x",
    horizOriginY: "horiz-origin-y",
    imageRendering: "image-rendering",
    letterSpacing: "letter-spacing",
    lightingColor: "lighting-color",
    markerEnd: "marker-end",
    markerMid: "marker-mid",
    markerStart: "marker-start",
    navDown: "nav-down",
    navDownLeft: "nav-down-left",
    navDownRight: "nav-down-right",
    navLeft: "nav-left",
    navNext: "nav-next",
    navPrev: "nav-prev",
    navRight: "nav-right",
    navUp: "nav-up",
    navUpLeft: "nav-up-left",
    navUpRight: "nav-up-right",
    onAbort: "onabort",
    onActivate: "onactivate",
    onAfterPrint: "onafterprint",
    onBeforePrint: "onbeforeprint",
    onBegin: "onbegin",
    onCancel: "oncancel",
    onCanPlay: "oncanplay",
    onCanPlayThrough: "oncanplaythrough",
    onChange: "onchange",
    onClick: "onclick",
    onClose: "onclose",
    onCopy: "oncopy",
    onCueChange: "oncuechange",
    onCut: "oncut",
    onDblClick: "ondblclick",
    onDrag: "ondrag",
    onDragEnd: "ondragend",
    onDragEnter: "ondragenter",
    onDragExit: "ondragexit",
    onDragLeave: "ondragleave",
    onDragOver: "ondragover",
    onDragStart: "ondragstart",
    onDrop: "ondrop",
    onDurationChange: "ondurationchange",
    onEmptied: "onemptied",
    onEnd: "onend",
    onEnded: "onended",
    onError: "onerror",
    onFocus: "onfocus",
    onFocusIn: "onfocusin",
    onFocusOut: "onfocusout",
    onHashChange: "onhashchange",
    onInput: "oninput",
    onInvalid: "oninvalid",
    onKeyDown: "onkeydown",
    onKeyPress: "onkeypress",
    onKeyUp: "onkeyup",
    onLoad: "onload",
    onLoadedData: "onloadeddata",
    onLoadedMetadata: "onloadedmetadata",
    onLoadStart: "onloadstart",
    onMessage: "onmessage",
    onMouseDown: "onmousedown",
    onMouseEnter: "onmouseenter",
    onMouseLeave: "onmouseleave",
    onMouseMove: "onmousemove",
    onMouseOut: "onmouseout",
    onMouseOver: "onmouseover",
    onMouseUp: "onmouseup",
    onMouseWheel: "onmousewheel",
    onOffline: "onoffline",
    onOnline: "ononline",
    onPageHide: "onpagehide",
    onPageShow: "onpageshow",
    onPaste: "onpaste",
    onPause: "onpause",
    onPlay: "onplay",
    onPlaying: "onplaying",
    onPopState: "onpopstate",
    onProgress: "onprogress",
    onRateChange: "onratechange",
    onRepeat: "onrepeat",
    onReset: "onreset",
    onResize: "onresize",
    onScroll: "onscroll",
    onSeeked: "onseeked",
    onSeeking: "onseeking",
    onSelect: "onselect",
    onShow: "onshow",
    onStalled: "onstalled",
    onStorage: "onstorage",
    onSubmit: "onsubmit",
    onSuspend: "onsuspend",
    onTimeUpdate: "ontimeupdate",
    onToggle: "ontoggle",
    onUnload: "onunload",
    onVolumeChange: "onvolumechange",
    onWaiting: "onwaiting",
    onZoom: "onzoom",
    overlinePosition: "overline-position",
    overlineThickness: "overline-thickness",
    paintOrder: "paint-order",
    panose1: "panose-1",
    pointerEvents: "pointer-events",
    referrerPolicy: "referrerpolicy",
    renderingIntent: "rendering-intent",
    shapeRendering: "shape-rendering",
    stopColor: "stop-color",
    stopOpacity: "stop-opacity",
    strikethroughPosition: "strikethrough-position",
    strikethroughThickness: "strikethrough-thickness",
    strokeDashArray: "stroke-dasharray",
    strokeDashOffset: "stroke-dashoffset",
    strokeLineCap: "stroke-linecap",
    strokeLineJoin: "stroke-linejoin",
    strokeMiterLimit: "stroke-miterlimit",
    strokeOpacity: "stroke-opacity",
    strokeWidth: "stroke-width",
    tabIndex: "tabindex",
    textAnchor: "text-anchor",
    textDecoration: "text-decoration",
    textRendering: "text-rendering",
    transformOrigin: "transform-origin",
    typeOf: "typeof",
    underlinePosition: "underline-position",
    underlineThickness: "underline-thickness",
    unicodeBidi: "unicode-bidi",
    unicodeRange: "unicode-range",
    unitsPerEm: "units-per-em",
    vAlphabetic: "v-alphabetic",
    vHanging: "v-hanging",
    vIdeographic: "v-ideographic",
    vMathematical: "v-mathematical",
    vectorEffect: "vector-effect",
    vertAdvY: "vert-adv-y",
    vertOriginX: "vert-origin-x",
    vertOriginY: "vert-origin-y",
    wordSpacing: "word-spacing",
    writingMode: "writing-mode",
    xHeight: "x-height",
    // These were camelcased in Tiny. Now lowercased in SVG 2
    playbackOrder: "playbackorder",
    timelineBegin: "timelinebegin"
  },
  transform: hx,
  properties: {
    about: Jt,
    accentHeight: Ve,
    accumulate: null,
    additive: null,
    alignmentBaseline: null,
    alphabetic: Ve,
    amplitude: Ve,
    arabicForm: null,
    ascent: Ve,
    attributeName: null,
    attributeType: null,
    azimuth: Ve,
    bandwidth: null,
    baselineShift: null,
    baseFrequency: null,
    baseProfile: null,
    bbox: null,
    begin: null,
    bias: Ve,
    by: null,
    calcMode: null,
    capHeight: Ve,
    className: Xn,
    clip: null,
    clipPath: null,
    clipPathUnits: null,
    clipRule: null,
    color: null,
    colorInterpolation: null,
    colorInterpolationFilters: null,
    colorProfile: null,
    colorRendering: null,
    content: null,
    contentScriptType: null,
    contentStyleType: null,
    crossOrigin: null,
    cursor: null,
    cx: null,
    cy: null,
    d: null,
    dataType: null,
    defaultAction: null,
    descent: Ve,
    diffuseConstant: Ve,
    direction: null,
    display: null,
    dur: null,
    divisor: Ve,
    dominantBaseline: null,
    download: In,
    dx: null,
    dy: null,
    edgeMode: null,
    editable: null,
    elevation: Ve,
    enableBackground: null,
    end: null,
    event: null,
    exponent: Ve,
    externalResourcesRequired: null,
    fill: null,
    fillOpacity: Ve,
    fillRule: null,
    filter: null,
    filterRes: null,
    filterUnits: null,
    floodColor: null,
    floodOpacity: null,
    focusable: null,
    focusHighlight: null,
    fontFamily: null,
    fontSize: null,
    fontSizeAdjust: null,
    fontStretch: null,
    fontStyle: null,
    fontVariant: null,
    fontWeight: null,
    format: null,
    fr: null,
    from: null,
    fx: null,
    fy: null,
    g1: Vi,
    g2: Vi,
    glyphName: Vi,
    glyphOrientationHorizontal: null,
    glyphOrientationVertical: null,
    glyphRef: null,
    gradientTransform: null,
    gradientUnits: null,
    handler: null,
    hanging: Ve,
    hatchContentUnits: null,
    hatchUnits: null,
    height: null,
    href: null,
    hrefLang: null,
    horizAdvX: Ve,
    horizOriginX: Ve,
    horizOriginY: Ve,
    id: null,
    ideographic: Ve,
    imageRendering: null,
    initialVisibility: null,
    in: null,
    in2: null,
    intercept: Ve,
    k: Ve,
    k1: Ve,
    k2: Ve,
    k3: Ve,
    k4: Ve,
    kernelMatrix: Jt,
    kernelUnitLength: null,
    keyPoints: null,
    // SEMI_COLON_SEPARATED
    keySplines: null,
    // SEMI_COLON_SEPARATED
    keyTimes: null,
    // SEMI_COLON_SEPARATED
    kerning: null,
    lang: null,
    lengthAdjust: null,
    letterSpacing: null,
    lightingColor: null,
    limitingConeAngle: Ve,
    local: null,
    markerEnd: null,
    markerMid: null,
    markerStart: null,
    markerHeight: null,
    markerUnits: null,
    markerWidth: null,
    mask: null,
    maskContentUnits: null,
    maskUnits: null,
    mathematical: null,
    max: null,
    media: null,
    mediaCharacterEncoding: null,
    mediaContentEncodings: null,
    mediaSize: Ve,
    mediaTime: null,
    method: null,
    min: null,
    mode: null,
    name: null,
    navDown: null,
    navDownLeft: null,
    navDownRight: null,
    navLeft: null,
    navNext: null,
    navPrev: null,
    navRight: null,
    navUp: null,
    navUpLeft: null,
    navUpRight: null,
    numOctaves: null,
    observer: null,
    offset: null,
    onAbort: null,
    onActivate: null,
    onAfterPrint: null,
    onBeforePrint: null,
    onBegin: null,
    onCancel: null,
    onCanPlay: null,
    onCanPlayThrough: null,
    onChange: null,
    onClick: null,
    onClose: null,
    onCopy: null,
    onCueChange: null,
    onCut: null,
    onDblClick: null,
    onDrag: null,
    onDragEnd: null,
    onDragEnter: null,
    onDragExit: null,
    onDragLeave: null,
    onDragOver: null,
    onDragStart: null,
    onDrop: null,
    onDurationChange: null,
    onEmptied: null,
    onEnd: null,
    onEnded: null,
    onError: null,
    onFocus: null,
    onFocusIn: null,
    onFocusOut: null,
    onHashChange: null,
    onInput: null,
    onInvalid: null,
    onKeyDown: null,
    onKeyPress: null,
    onKeyUp: null,
    onLoad: null,
    onLoadedData: null,
    onLoadedMetadata: null,
    onLoadStart: null,
    onMessage: null,
    onMouseDown: null,
    onMouseEnter: null,
    onMouseLeave: null,
    onMouseMove: null,
    onMouseOut: null,
    onMouseOver: null,
    onMouseUp: null,
    onMouseWheel: null,
    onOffline: null,
    onOnline: null,
    onPageHide: null,
    onPageShow: null,
    onPaste: null,
    onPause: null,
    onPlay: null,
    onPlaying: null,
    onPopState: null,
    onProgress: null,
    onRateChange: null,
    onRepeat: null,
    onReset: null,
    onResize: null,
    onScroll: null,
    onSeeked: null,
    onSeeking: null,
    onSelect: null,
    onShow: null,
    onStalled: null,
    onStorage: null,
    onSubmit: null,
    onSuspend: null,
    onTimeUpdate: null,
    onToggle: null,
    onUnload: null,
    onVolumeChange: null,
    onWaiting: null,
    onZoom: null,
    opacity: null,
    operator: null,
    order: null,
    orient: null,
    orientation: null,
    origin: null,
    overflow: null,
    overlay: null,
    overlinePosition: Ve,
    overlineThickness: Ve,
    paintOrder: null,
    panose1: null,
    path: null,
    pathLength: Ve,
    patternContentUnits: null,
    patternTransform: null,
    patternUnits: null,
    phase: null,
    ping: Xn,
    pitch: null,
    playbackOrder: null,
    pointerEvents: null,
    points: null,
    pointsAtX: Ve,
    pointsAtY: Ve,
    pointsAtZ: Ve,
    preserveAlpha: null,
    preserveAspectRatio: null,
    primitiveUnits: null,
    propagate: null,
    property: Jt,
    r: null,
    radius: null,
    referrerPolicy: null,
    refX: null,
    refY: null,
    rel: Jt,
    rev: Jt,
    renderingIntent: null,
    repeatCount: null,
    repeatDur: null,
    requiredExtensions: Jt,
    requiredFeatures: Jt,
    requiredFonts: Jt,
    requiredFormats: Jt,
    resource: null,
    restart: null,
    result: null,
    rotate: null,
    rx: null,
    ry: null,
    scale: null,
    seed: null,
    shapeRendering: null,
    side: null,
    slope: null,
    snapshotTime: null,
    specularConstant: Ve,
    specularExponent: Ve,
    spreadMethod: null,
    spacing: null,
    startOffset: null,
    stdDeviation: null,
    stemh: null,
    stemv: null,
    stitchTiles: null,
    stopColor: null,
    stopOpacity: null,
    strikethroughPosition: Ve,
    strikethroughThickness: Ve,
    string: null,
    stroke: null,
    strokeDashArray: Jt,
    strokeDashOffset: null,
    strokeLineCap: null,
    strokeLineJoin: null,
    strokeMiterLimit: Ve,
    strokeOpacity: Ve,
    strokeWidth: null,
    style: null,
    surfaceScale: Ve,
    syncBehavior: null,
    syncBehaviorDefault: null,
    syncMaster: null,
    syncTolerance: null,
    syncToleranceDefault: null,
    systemLanguage: Jt,
    tabIndex: Ve,
    tableValues: null,
    target: null,
    targetX: Ve,
    targetY: Ve,
    textAnchor: null,
    textDecoration: null,
    textRendering: null,
    textLength: null,
    timelineBegin: null,
    title: null,
    transformBehavior: null,
    type: null,
    typeOf: Jt,
    to: null,
    transform: null,
    transformOrigin: null,
    u1: null,
    u2: null,
    underlinePosition: Ve,
    underlineThickness: Ve,
    unicode: null,
    unicodeBidi: null,
    unicodeRange: null,
    unitsPerEm: Ve,
    values: null,
    vAlphabetic: Ve,
    vMathematical: Ve,
    vectorEffect: null,
    vHanging: Ve,
    vIdeographic: Ve,
    version: null,
    vertAdvY: Ve,
    vertOriginX: Ve,
    vertOriginY: Ve,
    viewBox: null,
    viewTarget: null,
    visibility: null,
    width: null,
    widths: null,
    wordSpacing: null,
    writingMode: null,
    x: null,
    x1: null,
    x2: null,
    xChannelSelector: null,
    xHeight: Ve,
    y: null,
    y1: null,
    y2: null,
    yChannelSelector: null,
    z: null,
    zoomAndPan: null
  }
}), G$ = /^data[-\w.:]+$/i, yv = /-[a-z]/g, Y$ = /[A-Z]/g;
function Q$(e, n) {
  const r = lm(n);
  let i = n, a = ur;
  if (r in e.normal)
    return e.property[e.normal[r]];
  if (r.length > 4 && r.slice(0, 4) === "data" && G$.test(n)) {
    if (n.charAt(4) === "-") {
      const o = n.slice(5).replace(yv, X$);
      i = "data" + o.charAt(0).toUpperCase() + o.slice(1);
    } else {
      const o = n.slice(4);
      if (!yv.test(o)) {
        let s = o.replace(Y$, J$);
        s.charAt(0) !== "-" && (s = "-" + s), n = "data" + s;
      }
    }
    a = Sp;
  }
  return new a(i, n);
}
function J$(e) {
  return "-" + e.toLowerCase();
}
function X$(e) {
  return e.charAt(1).toUpperCase();
}
const Z$ = {
  classId: "classID",
  dataType: "datatype",
  itemId: "itemID",
  strokeDashArray: "strokeDasharray",
  strokeDashOffset: "strokeDashoffset",
  strokeLineCap: "strokeLinecap",
  strokeLineJoin: "strokeLinejoin",
  strokeMiterLimit: "strokeMiterlimit",
  typeOf: "typeof",
  xLinkActuate: "xlinkActuate",
  xLinkArcRole: "xlinkArcrole",
  xLinkHref: "xlinkHref",
  xLinkRole: "xlinkRole",
  xLinkShow: "xlinkShow",
  xLinkTitle: "xlinkTitle",
  xLinkType: "xlinkType",
  xmlnsXLink: "xmlnsXlink"
}, eD = ux([fx, px, gx, vx, W$], "html"), Np = ux([fx, px, gx, vx, K$], "svg");
function nD(e) {
  return e.join(" ").trim();
}
var Ci = {}, iu, gv;
function tD() {
  if (gv) return iu;
  gv = 1;
  var e = /\/\*[^*]*\*+([^/*][^*]*\*+)*\//g, n = /\n/g, r = /^\s*/, i = /^(\*?[-#/*\\\w]+(\[[0-9a-z_-]+\])?)\s*/, a = /^:\s*/, o = /^((?:'(?:\\'|.)*?'|"(?:\\"|.)*?"|\([^)]*?\)|[^};])+)/, s = /^[;\s]*/, l = /^\s+|\s+$/g, d = `
`, m = "/", u = "*", f = "", h = "comment", v = "declaration";
  iu = function(S, j) {
    if (typeof S != "string")
      throw new TypeError("First argument must be a string");
    if (!S) return [];
    j = j || {};
    var F = 1, y = 1;
    function q(O) {
      var H = O.match(n);
      H && (F += H.length);
      var Z = O.lastIndexOf(d);
      y = ~Z ? O.length - Z : y + O.length;
    }
    function T() {
      var O = { line: F, column: y };
      return function(H) {
        return H.position = new E(O), ee(), H;
      };
    }
    function E(O) {
      this.start = O, this.end = { line: F, column: y }, this.source = j.source;
    }
    E.prototype.content = S;
    function D(O) {
      var H = new Error(
        j.source + ":" + F + ":" + y + ": " + O
      );
      if (H.reason = O, H.filename = j.source, H.line = F, H.column = y, H.source = S, !j.silent) throw H;
    }
    function B(O) {
      var H = O.exec(S);
      if (H) {
        var Z = H[0];
        return q(Z), S = S.slice(Z.length), H;
      }
    }
    function ee() {
      B(r);
    }
    function J(O) {
      var H;
      for (O = O || []; H = ae(); )
        H !== !1 && O.push(H);
      return O;
    }
    function ae() {
      var O = T();
      if (!(m != S.charAt(0) || u != S.charAt(1))) {
        for (var H = 2; f != S.charAt(H) && (u != S.charAt(H) || m != S.charAt(H + 1)); )
          ++H;
        if (H += 2, f === S.charAt(H - 1))
          return D("End of comment missing");
        var Z = S.slice(2, H - 2);
        return y += 2, q(Z), S = S.slice(H), y += 2, O({
          type: h,
          comment: Z
        });
      }
    }
    function Q() {
      var O = T(), H = B(i);
      if (H) {
        if (ae(), !B(a)) return D("property missing ':'");
        var Z = B(o), ye = O({
          type: v,
          property: C(H[0].replace(e, f)),
          value: Z ? C(Z[0].replace(e, f)) : f
        });
        return B(s), ye;
      }
    }
    function U() {
      var O = [];
      J(O);
      for (var H; H = Q(); )
        H !== !1 && (O.push(H), J(O));
      return O;
    }
    return ee(), U();
  };
  function C(S) {
    return S ? S.replace(l, f) : f;
  }
  return iu;
}
var vv;
function rD() {
  if (vv) return Ci;
  vv = 1;
  var e = Ci && Ci.__importDefault || function(i) {
    return i && i.__esModule ? i : { default: i };
  };
  Object.defineProperty(Ci, "__esModule", { value: !0 }), Ci.default = r;
  var n = e(tD());
  function r(i, a) {
    var o = null;
    if (!i || typeof i != "string")
      return o;
    var s = (0, n.default)(i), l = typeof a == "function";
    return s.forEach(function(d) {
      if (d.type === "declaration") {
        var m = d.property, u = d.value;
        l ? a(m, u, d) : u && (o = o || {}, o[m] = u);
      }
    }), o;
  }
  return Ci;
}
var iD = rD();
const kv = /* @__PURE__ */ Um(iD), aD = kv.default || kv, kx = bx("end"), jp = bx("start");
function bx(e) {
  return n;
  function n(r) {
    const i = r && r.position && r.position[e] || {};
    if (typeof i.line == "number" && i.line > 0 && typeof i.column == "number" && i.column > 0)
      return {
        line: i.line,
        column: i.column,
        offset: typeof i.offset == "number" && i.offset > -1 ? i.offset : void 0
      };
  }
}
function oD(e) {
  const n = jp(e), r = kx(e);
  if (n && r)
    return { start: n, end: r };
}
function qa(e) {
  return !e || typeof e != "object" ? "" : "position" in e || "type" in e ? bv(e.position) : "start" in e || "end" in e ? bv(e) : "line" in e || "column" in e ? dm(e) : "";
}
function dm(e) {
  return _v(e && e.line) + ":" + _v(e && e.column);
}
function bv(e) {
  return dm(e && e.start) + "-" + dm(e && e.end);
}
function _v(e) {
  return e && typeof e == "number" ? e : 1;
}
class $t extends Error {
  /**
   * Create a message for `reason`.
   *
   * > 🪦 **Note**: also has obsolete signatures.
   *
   * @overload
   * @param {string} reason
   * @param {Options | null | undefined} [options]
   * @returns
   *
   * @overload
   * @param {string} reason
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @overload
   * @param {string} reason
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @overload
   * @param {string} reason
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @param {Error | VFileMessage | string} causeOrReason
   *   Reason for message, should use markdown.
   * @param {Node | NodeLike | Options | Point | Position | string | null | undefined} [optionsOrParentOrPlace]
   *   Configuration (optional).
   * @param {string | null | undefined} [origin]
   *   Place in code where the message originates (example:
   *   `'my-package:my-rule'` or `'my-rule'`).
   * @returns
   *   Instance of `VFileMessage`.
   */
  // eslint-disable-next-line complexity
  constructor(n, r, i) {
    super(), typeof r == "string" && (i = r, r = void 0);
    let a = "", o = {}, s = !1;
    if (r && ("line" in r && "column" in r ? o = { place: r } : "start" in r && "end" in r ? o = { place: r } : "type" in r ? o = {
      ancestors: [r],
      place: r.position
    } : o = { ...r }), typeof n == "string" ? a = n : !o.cause && n && (s = !0, a = n.message, o.cause = n), !o.ruleId && !o.source && typeof i == "string") {
      const d = i.indexOf(":");
      d === -1 ? o.ruleId = i : (o.source = i.slice(0, d), o.ruleId = i.slice(d + 1));
    }
    if (!o.place && o.ancestors && o.ancestors) {
      const d = o.ancestors[o.ancestors.length - 1];
      d && (o.place = d.position);
    }
    const l = o.place && "start" in o.place ? o.place.start : o.place;
    this.ancestors = o.ancestors || void 0, this.cause = o.cause || void 0, this.column = l ? l.column : void 0, this.fatal = void 0, this.file, this.message = a, this.line = l ? l.line : void 0, this.name = qa(o.place) || "1:1", this.place = o.place || void 0, this.reason = this.message, this.ruleId = o.ruleId || void 0, this.source = o.source || void 0, this.stack = s && o.cause && typeof o.cause.stack == "string" ? o.cause.stack : "", this.actual, this.expected, this.note, this.url;
  }
}
$t.prototype.file = "";
$t.prototype.name = "";
$t.prototype.reason = "";
$t.prototype.message = "";
$t.prototype.stack = "";
$t.prototype.column = void 0;
$t.prototype.line = void 0;
$t.prototype.ancestors = void 0;
$t.prototype.cause = void 0;
$t.prototype.fatal = void 0;
$t.prototype.place = void 0;
$t.prototype.ruleId = void 0;
$t.prototype.source = void 0;
const wp = {}.hasOwnProperty, sD = /* @__PURE__ */ new Map(), lD = /[A-Z]/g, cD = /-([a-z])/g, dD = /* @__PURE__ */ new Set(["table", "tbody", "thead", "tfoot", "tr"]), uD = /* @__PURE__ */ new Set(["td", "th"]), _x = "https://github.com/syntax-tree/hast-util-to-jsx-runtime";
function mD(e, n) {
  if (!n || n.Fragment === void 0)
    throw new TypeError("Expected `Fragment` in options");
  const r = n.filePath || void 0;
  let i;
  if (n.development) {
    if (typeof n.jsxDEV != "function")
      throw new TypeError(
        "Expected `jsxDEV` in options when `development: true`"
      );
    i = bD(r, n.jsxDEV);
  } else {
    if (typeof n.jsx != "function")
      throw new TypeError("Expected `jsx` in production options");
    if (typeof n.jsxs != "function")
      throw new TypeError("Expected `jsxs` in production options");
    i = kD(r, n.jsx, n.jsxs);
  }
  const a = {
    Fragment: n.Fragment,
    ancestors: [],
    components: n.components || {},
    create: i,
    elementAttributeNameCase: n.elementAttributeNameCase || "react",
    evaluater: n.createEvaluater ? n.createEvaluater() : void 0,
    filePath: r,
    ignoreInvalidStyle: n.ignoreInvalidStyle || !1,
    passKeys: n.passKeys !== !1,
    passNode: n.passNode || !1,
    schema: n.space === "svg" ? Np : eD,
    stylePropertyNameCase: n.stylePropertyNameCase || "dom",
    tableCellAlignToStyle: n.tableCellAlignToStyle !== !1
  }, o = xx(a, e, void 0);
  return o && typeof o != "string" ? o : a.create(
    e,
    a.Fragment,
    { children: o || void 0 },
    void 0
  );
}
function xx(e, n, r) {
  if (n.type === "element")
    return pD(e, n, r);
  if (n.type === "mdxFlowExpression" || n.type === "mdxTextExpression")
    return fD(e, n);
  if (n.type === "mdxJsxFlowElement" || n.type === "mdxJsxTextElement")
    return yD(e, n, r);
  if (n.type === "mdxjsEsm")
    return hD(e, n);
  if (n.type === "root")
    return gD(e, n, r);
  if (n.type === "text")
    return vD(e, n);
}
function pD(e, n, r) {
  const i = e.schema;
  let a = i;
  n.tagName.toLowerCase() === "svg" && i.space === "html" && (a = Np, e.schema = a), e.ancestors.push(n);
  const o = Nx(e, n.tagName, !1), s = _D(e, n);
  let l = Fp(e, n);
  return dD.has(n.tagName) && (l = l.filter(function(d) {
    return typeof d == "string" ? !B$(d) : !0;
  })), Sx(e, s, o, n), Cp(s, l), e.ancestors.pop(), e.schema = i, e.create(n, o, s, r);
}
function fD(e, n) {
  if (n.data && n.data.estree && e.evaluater) {
    const i = n.data.estree.body[0];
    return i.type, /** @type {Child | undefined} */
    e.evaluater.evaluateExpression(i.expression);
  }
  to(e, n.position);
}
function hD(e, n) {
  if (n.data && n.data.estree && e.evaluater)
    return (
      /** @type {Child | undefined} */
      e.evaluater.evaluateProgram(n.data.estree)
    );
  to(e, n.position);
}
function yD(e, n, r) {
  const i = e.schema;
  let a = i;
  n.name === "svg" && i.space === "html" && (a = Np, e.schema = a), e.ancestors.push(n);
  const o = n.name === null ? e.Fragment : Nx(e, n.name, !0), s = xD(e, n), l = Fp(e, n);
  return Sx(e, s, o, n), Cp(s, l), e.ancestors.pop(), e.schema = i, e.create(n, o, s, r);
}
function gD(e, n, r) {
  const i = {};
  return Cp(i, Fp(e, n)), e.create(n, e.Fragment, i, r);
}
function vD(e, n) {
  return n.value;
}
function Sx(e, n, r, i) {
  typeof r != "string" && r !== e.Fragment && e.passNode && (n.node = i);
}
function Cp(e, n) {
  if (n.length > 0) {
    const r = n.length > 1 ? n : n[0];
    r && (e.children = r);
  }
}
function kD(e, n, r) {
  return i;
  function i(a, o, s, l) {
    const m = Array.isArray(s.children) ? r : n;
    return l ? m(o, s, l) : m(o, s);
  }
}
function bD(e, n) {
  return r;
  function r(i, a, o, s) {
    const l = Array.isArray(o.children), d = jp(i);
    return n(
      a,
      o,
      s,
      l,
      {
        columnNumber: d ? d.column - 1 : void 0,
        fileName: e,
        lineNumber: d ? d.line : void 0
      },
      void 0
    );
  }
}
function _D(e, n) {
  const r = {};
  let i, a;
  for (a in n.properties)
    if (a !== "children" && wp.call(n.properties, a)) {
      const o = SD(e, a, n.properties[a]);
      if (o) {
        const [s, l] = o;
        e.tableCellAlignToStyle && s === "align" && typeof l == "string" && uD.has(n.tagName) ? i = l : r[s] = l;
      }
    }
  if (i) {
    const o = (
      /** @type {Style} */
      r.style || (r.style = {})
    );
    o[e.stylePropertyNameCase === "css" ? "text-align" : "textAlign"] = i;
  }
  return r;
}
function xD(e, n) {
  const r = {};
  for (const i of n.attributes)
    if (i.type === "mdxJsxExpressionAttribute")
      if (i.data && i.data.estree && e.evaluater) {
        const o = i.data.estree.body[0];
        o.type;
        const s = o.expression;
        s.type;
        const l = s.properties[0];
        l.type, Object.assign(
          r,
          e.evaluater.evaluateExpression(l.argument)
        );
      } else
        to(e, n.position);
    else {
      const a = i.name;
      let o;
      if (i.value && typeof i.value == "object")
        if (i.value.data && i.value.data.estree && e.evaluater) {
          const l = i.value.data.estree.body[0];
          l.type, o = e.evaluater.evaluateExpression(l.expression);
        } else
          to(e, n.position);
      else
        o = i.value === null ? !0 : i.value;
      r[a] = /** @type {Props[keyof Props]} */
      o;
    }
  return r;
}
function Fp(e, n) {
  const r = [];
  let i = -1;
  const a = e.passKeys ? /* @__PURE__ */ new Map() : sD;
  for (; ++i < n.children.length; ) {
    const o = n.children[i];
    let s;
    if (e.passKeys) {
      const d = o.type === "element" ? o.tagName : o.type === "mdxJsxFlowElement" || o.type === "mdxJsxTextElement" ? o.name : void 0;
      if (d) {
        const m = a.get(d) || 0;
        s = d + "-" + m, a.set(d, m + 1);
      }
    }
    const l = xx(e, o, s);
    l !== void 0 && r.push(l);
  }
  return r;
}
function SD(e, n, r) {
  const i = Q$(e.schema, n);
  if (!(r == null || typeof r == "number" && Number.isNaN(r))) {
    if (Array.isArray(r) && (r = i.commaSeparated ? L$(r) : nD(r)), i.property === "style") {
      let a = typeof r == "object" ? r : ND(e, String(r));
      return e.stylePropertyNameCase === "css" && (a = jD(a)), ["style", a];
    }
    return [
      e.elementAttributeNameCase === "react" && i.space ? Z$[i.property] || i.property : i.attribute,
      r
    ];
  }
}
function ND(e, n) {
  const r = {};
  try {
    aD(n, i);
  } catch (a) {
    if (!e.ignoreInvalidStyle) {
      const o = (
        /** @type {Error} */
        a
      ), s = new $t("Cannot parse `style` attribute", {
        ancestors: e.ancestors,
        cause: o,
        ruleId: "style",
        source: "hast-util-to-jsx-runtime"
      });
      throw s.file = e.filePath || void 0, s.url = _x + "#cannot-parse-style-attribute", s;
    }
  }
  return r;
  function i(a, o) {
    let s = a;
    s.slice(0, 2) !== "--" && (s.slice(0, 4) === "-ms-" && (s = "ms-" + s.slice(4)), s = s.replace(cD, CD)), r[s] = o;
  }
}
function Nx(e, n, r) {
  let i;
  if (!r)
    i = { type: "Literal", value: n };
  else if (n.includes(".")) {
    const a = n.split(".");
    let o = -1, s;
    for (; ++o < a.length; ) {
      const l = pv(a[o]) ? { type: "Identifier", name: a[o] } : { type: "Literal", value: a[o] };
      s = s ? {
        type: "MemberExpression",
        object: s,
        property: l,
        computed: !!(o && l.type === "Literal"),
        optional: !1
      } : l;
    }
    i = s;
  } else
    i = pv(n) && !/^[a-z]/.test(n) ? { type: "Identifier", name: n } : { type: "Literal", value: n };
  if (i.type === "Literal") {
    const a = (
      /** @type {keyof JSX.IntrinsicElements} */
      i.value
    );
    return wp.call(e.components, a) ? e.components[a] : a;
  }
  if (e.evaluater)
    return e.evaluater.evaluateExpression(i);
  to(e);
}
function to(e, n) {
  const r = new $t(
    "Cannot handle MDX estrees without `createEvaluater`",
    {
      ancestors: e.ancestors,
      place: n,
      ruleId: "mdx-estree",
      source: "hast-util-to-jsx-runtime"
    }
  );
  throw r.file = e.filePath || void 0, r.url = _x + "#cannot-handle-mdx-estrees-without-createevaluater", r;
}
function jD(e) {
  const n = {};
  let r;
  for (r in e)
    wp.call(e, r) && (n[wD(r)] = e[r]);
  return n;
}
function wD(e) {
  let n = e.replace(lD, FD);
  return n.slice(0, 3) === "ms-" && (n = "-" + n), n;
}
function CD(e, n) {
  return n.toUpperCase();
}
function FD(e) {
  return "-" + e.toLowerCase();
}
const au = {
  action: ["form"],
  cite: ["blockquote", "del", "ins", "q"],
  data: ["object"],
  formAction: ["button", "input"],
  href: ["a", "area", "base", "link"],
  icon: ["menuitem"],
  itemId: null,
  manifest: ["html"],
  ping: ["a", "area"],
  poster: ["video"],
  src: [
    "audio",
    "embed",
    "iframe",
    "img",
    "input",
    "script",
    "source",
    "track",
    "video"
  ]
}, ID = {};
function ED(e, n) {
  const r = ID, i = typeof r.includeImageAlt == "boolean" ? r.includeImageAlt : !0, a = typeof r.includeHtml == "boolean" ? r.includeHtml : !0;
  return jx(e, i, a);
}
function jx(e, n, r) {
  if (TD(e)) {
    if ("value" in e)
      return e.type === "html" && !r ? "" : e.value;
    if (n && "alt" in e && e.alt)
      return e.alt;
    if ("children" in e)
      return xv(e.children, n, r);
  }
  return Array.isArray(e) ? xv(e, n, r) : "";
}
function xv(e, n, r) {
  const i = [];
  let a = -1;
  for (; ++a < e.length; )
    i[a] = jx(e[a], n, r);
  return i.join("");
}
function TD(e) {
  return !!(e && typeof e == "object");
}
const Sv = document.createElement("i");
function Ip(e) {
  const n = "&" + e + ";";
  Sv.innerHTML = n;
  const r = Sv.textContent;
  return r.charCodeAt(r.length - 1) === 59 && e !== "semi" || r === n ? !1 : r;
}
function Rr(e, n, r, i) {
  const a = e.length;
  let o = 0, s;
  if (n < 0 ? n = -n > a ? 0 : a + n : n = n > a ? a : n, r = r > 0 ? r : 0, i.length < 1e4)
    s = Array.from(i), s.unshift(n, r), e.splice(...s);
  else
    for (r && e.splice(n, r); o < i.length; )
      s = i.slice(o, o + 1e4), s.unshift(n, 0), e.splice(...s), o += 1e4, n += 1e4;
}
function or(e, n) {
  return e.length > 0 ? (Rr(e, e.length, 0, n), e) : n;
}
const Nv = {}.hasOwnProperty;
function $D(e) {
  const n = {};
  let r = -1;
  for (; ++r < e.length; )
    DD(n, e[r]);
  return n;
}
function DD(e, n) {
  let r;
  for (r in n) {
    const a = (Nv.call(e, r) ? e[r] : void 0) || (e[r] = {}), o = n[r];
    let s;
    if (o)
      for (s in o) {
        Nv.call(a, s) || (a[s] = []);
        const l = o[s];
        RD(
          // @ts-expect-error Looks like a list.
          a[s],
          Array.isArray(l) ? l : l ? [l] : []
        );
      }
  }
}
function RD(e, n) {
  let r = -1;
  const i = [];
  for (; ++r < n.length; )
    (n[r].add === "after" ? e : i).push(n[r]);
  Rr(e, 0, 0, i);
}
function wx(e, n) {
  const r = Number.parseInt(e, n);
  return (
    // C0 except for HT, LF, FF, CR, space.
    r < 9 || r === 11 || r > 13 && r < 32 || // Control character (DEL) of C0, and C1 controls.
    r > 126 && r < 160 || // Lone high surrogates and low surrogates.
    r > 55295 && r < 57344 || // Noncharacters.
    r > 64975 && r < 65008 || /* eslint-disable no-bitwise */
    (r & 65535) === 65535 || (r & 65535) === 65534 || /* eslint-enable no-bitwise */
    // Out of range
    r > 1114111 ? "�" : String.fromCodePoint(r)
  );
}
function zi(e) {
  return e.replace(/[\t\n\r ]+/g, " ").replace(/^ | $/g, "").toLowerCase().toUpperCase();
}
const Ir = ni(/[A-Za-z]/), tr = ni(/[\dA-Za-z]/), OD = ni(/[#-'*+\--9=?A-Z^-~]/);
function um(e) {
  return (
    // Special whitespace codes (which have negative values), C0 and Control
    // character DEL
    e !== null && (e < 32 || e === 127)
  );
}
const mm = ni(/\d/), PD = ni(/[\dA-Fa-f]/), AD = ni(/[!-/:-@[-`{-~]/);
function vn(e) {
  return e !== null && e < -2;
}
function Gt(e) {
  return e !== null && (e < 0 || e === 32);
}
function zn(e) {
  return e === -2 || e === -1 || e === 32;
}
const LD = ni(new RegExp("\\p{P}|\\p{S}", "u")), VD = ni(/\s/);
function ni(e) {
  return n;
  function n(r) {
    return r !== null && r > -1 && e.test(String.fromCharCode(r));
  }
}
function Zi(e) {
  const n = [];
  let r = -1, i = 0, a = 0;
  for (; ++r < e.length; ) {
    const o = e.charCodeAt(r);
    let s = "";
    if (o === 37 && tr(e.charCodeAt(r + 1)) && tr(e.charCodeAt(r + 2)))
      a = 2;
    else if (o < 128)
      /[!#$&-;=?-Z_a-z~]/.test(String.fromCharCode(o)) || (s = String.fromCharCode(o));
    else if (o > 55295 && o < 57344) {
      const l = e.charCodeAt(r + 1);
      o < 56320 && l > 56319 && l < 57344 ? (s = String.fromCharCode(o, l), a = 1) : s = "�";
    } else
      s = String.fromCharCode(o);
    s && (n.push(e.slice(i, r), encodeURIComponent(s)), i = r + a + 1, s = ""), a && (r += a, a = 0);
  }
  return n.join("") + e.slice(i);
}
function et(e, n, r, i) {
  const a = i ? i - 1 : Number.POSITIVE_INFINITY;
  let o = 0;
  return s;
  function s(d) {
    return zn(d) ? (e.enter(r), l(d)) : n(d);
  }
  function l(d) {
    return zn(d) && o++ < a ? (e.consume(d), l) : (e.exit(r), n(d));
  }
}
const zD = {
  tokenize: UD
};
function UD(e) {
  const n = e.attempt(this.parser.constructs.contentInitial, i, a);
  let r;
  return n;
  function i(l) {
    if (l === null) {
      e.consume(l);
      return;
    }
    return e.enter("lineEnding"), e.consume(l), e.exit("lineEnding"), et(e, n, "linePrefix");
  }
  function a(l) {
    return e.enter("paragraph"), o(l);
  }
  function o(l) {
    const d = e.enter("chunkText", {
      contentType: "text",
      previous: r
    });
    return r && (r.next = d), r = d, s(l);
  }
  function s(l) {
    if (l === null) {
      e.exit("chunkText"), e.exit("paragraph"), e.consume(l);
      return;
    }
    return vn(l) ? (e.consume(l), e.exit("chunkText"), o) : (e.consume(l), s);
  }
}
const MD = {
  tokenize: BD
}, jv = {
  tokenize: qD
};
function BD(e) {
  const n = this, r = [];
  let i = 0, a, o, s;
  return l;
  function l(q) {
    if (i < r.length) {
      const T = r[i];
      return n.containerState = T[1], e.attempt(T[0].continuation, d, m)(q);
    }
    return m(q);
  }
  function d(q) {
    if (i++, n.containerState._closeFlow) {
      n.containerState._closeFlow = void 0, a && y();
      const T = n.events.length;
      let E = T, D;
      for (; E--; )
        if (n.events[E][0] === "exit" && n.events[E][1].type === "chunkFlow") {
          D = n.events[E][1].end;
          break;
        }
      F(i);
      let B = T;
      for (; B < n.events.length; )
        n.events[B][1].end = {
          ...D
        }, B++;
      return Rr(n.events, E + 1, 0, n.events.slice(T)), n.events.length = B, m(q);
    }
    return l(q);
  }
  function m(q) {
    if (i === r.length) {
      if (!a)
        return h(q);
      if (a.currentConstruct && a.currentConstruct.concrete)
        return C(q);
      n.interrupt = !!(a.currentConstruct && !a._gfmTableDynamicInterruptHack);
    }
    return n.containerState = {}, e.check(jv, u, f)(q);
  }
  function u(q) {
    return a && y(), F(i), h(q);
  }
  function f(q) {
    return n.parser.lazy[n.now().line] = i !== r.length, s = n.now().offset, C(q);
  }
  function h(q) {
    return n.containerState = {}, e.attempt(jv, v, C)(q);
  }
  function v(q) {
    return i++, r.push([n.currentConstruct, n.containerState]), h(q);
  }
  function C(q) {
    if (q === null) {
      a && y(), F(0), e.consume(q);
      return;
    }
    return a = a || n.parser.flow(n.now()), e.enter("chunkFlow", {
      _tokenizer: a,
      contentType: "flow",
      previous: o
    }), S(q);
  }
  function S(q) {
    if (q === null) {
      j(e.exit("chunkFlow"), !0), F(0), e.consume(q);
      return;
    }
    return vn(q) ? (e.consume(q), j(e.exit("chunkFlow")), i = 0, n.interrupt = void 0, l) : (e.consume(q), S);
  }
  function j(q, T) {
    const E = n.sliceStream(q);
    if (T && E.push(null), q.previous = o, o && (o.next = q), o = q, a.defineSkip(q.start), a.write(E), n.parser.lazy[q.start.line]) {
      let D = a.events.length;
      for (; D--; )
        if (
          // The token starts before the line ending…
          a.events[D][1].start.offset < s && // …and either is not ended yet…
          (!a.events[D][1].end || // …or ends after it.
          a.events[D][1].end.offset > s)
        )
          return;
      const B = n.events.length;
      let ee = B, J, ae;
      for (; ee--; )
        if (n.events[ee][0] === "exit" && n.events[ee][1].type === "chunkFlow") {
          if (J) {
            ae = n.events[ee][1].end;
            break;
          }
          J = !0;
        }
      for (F(i), D = B; D < n.events.length; )
        n.events[D][1].end = {
          ...ae
        }, D++;
      Rr(n.events, ee + 1, 0, n.events.slice(B)), n.events.length = D;
    }
  }
  function F(q) {
    let T = r.length;
    for (; T-- > q; ) {
      const E = r[T];
      n.containerState = E[1], E[0].exit.call(n, e);
    }
    r.length = q;
  }
  function y() {
    a.write([null]), o = void 0, a = void 0, n.containerState._closeFlow = void 0;
  }
}
function qD(e, n, r) {
  return et(e, e.attempt(this.parser.constructs.document, n, r), "linePrefix", this.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4);
}
function wv(e) {
  if (e === null || Gt(e) || VD(e))
    return 1;
  if (LD(e))
    return 2;
}
function Ep(e, n, r) {
  const i = [];
  let a = -1;
  for (; ++a < e.length; ) {
    const o = e[a].resolveAll;
    o && !i.includes(o) && (n = o(n, r), i.push(o));
  }
  return n;
}
const pm = {
  name: "attention",
  resolveAll: HD,
  tokenize: WD
};
function HD(e, n) {
  let r = -1, i, a, o, s, l, d, m, u;
  for (; ++r < e.length; )
    if (e[r][0] === "enter" && e[r][1].type === "attentionSequence" && e[r][1]._close) {
      for (i = r; i--; )
        if (e[i][0] === "exit" && e[i][1].type === "attentionSequence" && e[i][1]._open && // If the markers are the same:
        n.sliceSerialize(e[i][1]).charCodeAt(0) === n.sliceSerialize(e[r][1]).charCodeAt(0)) {
          if ((e[i][1]._close || e[r][1]._open) && (e[r][1].end.offset - e[r][1].start.offset) % 3 && !((e[i][1].end.offset - e[i][1].start.offset + e[r][1].end.offset - e[r][1].start.offset) % 3))
            continue;
          d = e[i][1].end.offset - e[i][1].start.offset > 1 && e[r][1].end.offset - e[r][1].start.offset > 1 ? 2 : 1;
          const f = {
            ...e[i][1].end
          }, h = {
            ...e[r][1].start
          };
          Cv(f, -d), Cv(h, d), s = {
            type: d > 1 ? "strongSequence" : "emphasisSequence",
            start: f,
            end: {
              ...e[i][1].end
            }
          }, l = {
            type: d > 1 ? "strongSequence" : "emphasisSequence",
            start: {
              ...e[r][1].start
            },
            end: h
          }, o = {
            type: d > 1 ? "strongText" : "emphasisText",
            start: {
              ...e[i][1].end
            },
            end: {
              ...e[r][1].start
            }
          }, a = {
            type: d > 1 ? "strong" : "emphasis",
            start: {
              ...s.start
            },
            end: {
              ...l.end
            }
          }, e[i][1].end = {
            ...s.start
          }, e[r][1].start = {
            ...l.end
          }, m = [], e[i][1].end.offset - e[i][1].start.offset && (m = or(m, [["enter", e[i][1], n], ["exit", e[i][1], n]])), m = or(m, [["enter", a, n], ["enter", s, n], ["exit", s, n], ["enter", o, n]]), m = or(m, Ep(n.parser.constructs.insideSpan.null, e.slice(i + 1, r), n)), m = or(m, [["exit", o, n], ["enter", l, n], ["exit", l, n], ["exit", a, n]]), e[r][1].end.offset - e[r][1].start.offset ? (u = 2, m = or(m, [["enter", e[r][1], n], ["exit", e[r][1], n]])) : u = 0, Rr(e, i - 1, r - i + 3, m), r = i + m.length - u - 2;
          break;
        }
    }
  for (r = -1; ++r < e.length; )
    e[r][1].type === "attentionSequence" && (e[r][1].type = "data");
  return e;
}
function WD(e, n) {
  const r = this.parser.constructs.attentionMarkers.null, i = this.previous, a = wv(i);
  let o;
  return s;
  function s(d) {
    return o = d, e.enter("attentionSequence"), l(d);
  }
  function l(d) {
    if (d === o)
      return e.consume(d), l;
    const m = e.exit("attentionSequence"), u = wv(d), f = !u || u === 2 && a || r.includes(d), h = !a || a === 2 && u || r.includes(i);
    return m._open = !!(o === 42 ? f : f && (a || !h)), m._close = !!(o === 42 ? h : h && (u || !f)), n(d);
  }
}
function Cv(e, n) {
  e.column += n, e.offset += n, e._bufferIndex += n;
}
const KD = {
  name: "autolink",
  tokenize: GD
};
function GD(e, n, r) {
  let i = 0;
  return a;
  function a(v) {
    return e.enter("autolink"), e.enter("autolinkMarker"), e.consume(v), e.exit("autolinkMarker"), e.enter("autolinkProtocol"), o;
  }
  function o(v) {
    return Ir(v) ? (e.consume(v), s) : v === 64 ? r(v) : m(v);
  }
  function s(v) {
    return v === 43 || v === 45 || v === 46 || tr(v) ? (i = 1, l(v)) : m(v);
  }
  function l(v) {
    return v === 58 ? (e.consume(v), i = 0, d) : (v === 43 || v === 45 || v === 46 || tr(v)) && i++ < 32 ? (e.consume(v), l) : (i = 0, m(v));
  }
  function d(v) {
    return v === 62 ? (e.exit("autolinkProtocol"), e.enter("autolinkMarker"), e.consume(v), e.exit("autolinkMarker"), e.exit("autolink"), n) : v === null || v === 32 || v === 60 || um(v) ? r(v) : (e.consume(v), d);
  }
  function m(v) {
    return v === 64 ? (e.consume(v), u) : OD(v) ? (e.consume(v), m) : r(v);
  }
  function u(v) {
    return tr(v) ? f(v) : r(v);
  }
  function f(v) {
    return v === 46 ? (e.consume(v), i = 0, u) : v === 62 ? (e.exit("autolinkProtocol").type = "autolinkEmail", e.enter("autolinkMarker"), e.consume(v), e.exit("autolinkMarker"), e.exit("autolink"), n) : h(v);
  }
  function h(v) {
    if ((v === 45 || tr(v)) && i++ < 63) {
      const C = v === 45 ? h : f;
      return e.consume(v), C;
    }
    return r(v);
  }
}
const Qs = {
  partial: !0,
  tokenize: YD
};
function YD(e, n, r) {
  return i;
  function i(o) {
    return zn(o) ? et(e, a, "linePrefix")(o) : a(o);
  }
  function a(o) {
    return o === null || vn(o) ? n(o) : r(o);
  }
}
const Cx = {
  continuation: {
    tokenize: JD
  },
  exit: XD,
  name: "blockQuote",
  tokenize: QD
};
function QD(e, n, r) {
  const i = this;
  return a;
  function a(s) {
    if (s === 62) {
      const l = i.containerState;
      return l.open || (e.enter("blockQuote", {
        _container: !0
      }), l.open = !0), e.enter("blockQuotePrefix"), e.enter("blockQuoteMarker"), e.consume(s), e.exit("blockQuoteMarker"), o;
    }
    return r(s);
  }
  function o(s) {
    return zn(s) ? (e.enter("blockQuotePrefixWhitespace"), e.consume(s), e.exit("blockQuotePrefixWhitespace"), e.exit("blockQuotePrefix"), n) : (e.exit("blockQuotePrefix"), n(s));
  }
}
function JD(e, n, r) {
  const i = this;
  return a;
  function a(s) {
    return zn(s) ? et(e, o, "linePrefix", i.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4)(s) : o(s);
  }
  function o(s) {
    return e.attempt(Cx, n, r)(s);
  }
}
function XD(e) {
  e.exit("blockQuote");
}
const Fx = {
  name: "characterEscape",
  tokenize: ZD
};
function ZD(e, n, r) {
  return i;
  function i(o) {
    return e.enter("characterEscape"), e.enter("escapeMarker"), e.consume(o), e.exit("escapeMarker"), a;
  }
  function a(o) {
    return AD(o) ? (e.enter("characterEscapeValue"), e.consume(o), e.exit("characterEscapeValue"), e.exit("characterEscape"), n) : r(o);
  }
}
const Ix = {
  name: "characterReference",
  tokenize: eR
};
function eR(e, n, r) {
  const i = this;
  let a = 0, o, s;
  return l;
  function l(f) {
    return e.enter("characterReference"), e.enter("characterReferenceMarker"), e.consume(f), e.exit("characterReferenceMarker"), d;
  }
  function d(f) {
    return f === 35 ? (e.enter("characterReferenceMarkerNumeric"), e.consume(f), e.exit("characterReferenceMarkerNumeric"), m) : (e.enter("characterReferenceValue"), o = 31, s = tr, u(f));
  }
  function m(f) {
    return f === 88 || f === 120 ? (e.enter("characterReferenceMarkerHexadecimal"), e.consume(f), e.exit("characterReferenceMarkerHexadecimal"), e.enter("characterReferenceValue"), o = 6, s = PD, u) : (e.enter("characterReferenceValue"), o = 7, s = mm, u(f));
  }
  function u(f) {
    if (f === 59 && a) {
      const h = e.exit("characterReferenceValue");
      return s === tr && !Ip(i.sliceSerialize(h)) ? r(f) : (e.enter("characterReferenceMarker"), e.consume(f), e.exit("characterReferenceMarker"), e.exit("characterReference"), n);
    }
    return s(f) && a++ < o ? (e.consume(f), u) : r(f);
  }
}
const Fv = {
  partial: !0,
  tokenize: tR
}, Iv = {
  concrete: !0,
  name: "codeFenced",
  tokenize: nR
};
function nR(e, n, r) {
  const i = this, a = {
    partial: !0,
    tokenize: E
  };
  let o = 0, s = 0, l;
  return d;
  function d(D) {
    return m(D);
  }
  function m(D) {
    const B = i.events[i.events.length - 1];
    return o = B && B[1].type === "linePrefix" ? B[2].sliceSerialize(B[1], !0).length : 0, l = D, e.enter("codeFenced"), e.enter("codeFencedFence"), e.enter("codeFencedFenceSequence"), u(D);
  }
  function u(D) {
    return D === l ? (s++, e.consume(D), u) : s < 3 ? r(D) : (e.exit("codeFencedFenceSequence"), zn(D) ? et(e, f, "whitespace")(D) : f(D));
  }
  function f(D) {
    return D === null || vn(D) ? (e.exit("codeFencedFence"), i.interrupt ? n(D) : e.check(Fv, S, T)(D)) : (e.enter("codeFencedFenceInfo"), e.enter("chunkString", {
      contentType: "string"
    }), h(D));
  }
  function h(D) {
    return D === null || vn(D) ? (e.exit("chunkString"), e.exit("codeFencedFenceInfo"), f(D)) : zn(D) ? (e.exit("chunkString"), e.exit("codeFencedFenceInfo"), et(e, v, "whitespace")(D)) : D === 96 && D === l ? r(D) : (e.consume(D), h);
  }
  function v(D) {
    return D === null || vn(D) ? f(D) : (e.enter("codeFencedFenceMeta"), e.enter("chunkString", {
      contentType: "string"
    }), C(D));
  }
  function C(D) {
    return D === null || vn(D) ? (e.exit("chunkString"), e.exit("codeFencedFenceMeta"), f(D)) : D === 96 && D === l ? r(D) : (e.consume(D), C);
  }
  function S(D) {
    return e.attempt(a, T, j)(D);
  }
  function j(D) {
    return e.enter("lineEnding"), e.consume(D), e.exit("lineEnding"), F;
  }
  function F(D) {
    return o > 0 && zn(D) ? et(e, y, "linePrefix", o + 1)(D) : y(D);
  }
  function y(D) {
    return D === null || vn(D) ? e.check(Fv, S, T)(D) : (e.enter("codeFlowValue"), q(D));
  }
  function q(D) {
    return D === null || vn(D) ? (e.exit("codeFlowValue"), y(D)) : (e.consume(D), q);
  }
  function T(D) {
    return e.exit("codeFenced"), n(D);
  }
  function E(D, B, ee) {
    let J = 0;
    return ae;
    function ae(Z) {
      return D.enter("lineEnding"), D.consume(Z), D.exit("lineEnding"), Q;
    }
    function Q(Z) {
      return D.enter("codeFencedFence"), zn(Z) ? et(D, U, "linePrefix", i.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4)(Z) : U(Z);
    }
    function U(Z) {
      return Z === l ? (D.enter("codeFencedFenceSequence"), O(Z)) : ee(Z);
    }
    function O(Z) {
      return Z === l ? (J++, D.consume(Z), O) : J >= s ? (D.exit("codeFencedFenceSequence"), zn(Z) ? et(D, H, "whitespace")(Z) : H(Z)) : ee(Z);
    }
    function H(Z) {
      return Z === null || vn(Z) ? (D.exit("codeFencedFence"), B(Z)) : ee(Z);
    }
  }
}
function tR(e, n, r) {
  const i = this;
  return a;
  function a(s) {
    return s === null ? r(s) : (e.enter("lineEnding"), e.consume(s), e.exit("lineEnding"), o);
  }
  function o(s) {
    return i.parser.lazy[i.now().line] ? r(s) : n(s);
  }
}
const ou = {
  name: "codeIndented",
  tokenize: iR
}, rR = {
  partial: !0,
  tokenize: aR
};
function iR(e, n, r) {
  const i = this;
  return a;
  function a(m) {
    return e.enter("codeIndented"), et(e, o, "linePrefix", 5)(m);
  }
  function o(m) {
    const u = i.events[i.events.length - 1];
    return u && u[1].type === "linePrefix" && u[2].sliceSerialize(u[1], !0).length >= 4 ? s(m) : r(m);
  }
  function s(m) {
    return m === null ? d(m) : vn(m) ? e.attempt(rR, s, d)(m) : (e.enter("codeFlowValue"), l(m));
  }
  function l(m) {
    return m === null || vn(m) ? (e.exit("codeFlowValue"), s(m)) : (e.consume(m), l);
  }
  function d(m) {
    return e.exit("codeIndented"), n(m);
  }
}
function aR(e, n, r) {
  const i = this;
  return a;
  function a(s) {
    return i.parser.lazy[i.now().line] ? r(s) : vn(s) ? (e.enter("lineEnding"), e.consume(s), e.exit("lineEnding"), a) : et(e, o, "linePrefix", 5)(s);
  }
  function o(s) {
    const l = i.events[i.events.length - 1];
    return l && l[1].type === "linePrefix" && l[2].sliceSerialize(l[1], !0).length >= 4 ? n(s) : vn(s) ? a(s) : r(s);
  }
}
const oR = {
  name: "codeText",
  previous: lR,
  resolve: sR,
  tokenize: cR
};
function sR(e) {
  let n = e.length - 4, r = 3, i, a;
  if ((e[r][1].type === "lineEnding" || e[r][1].type === "space") && (e[n][1].type === "lineEnding" || e[n][1].type === "space")) {
    for (i = r; ++i < n; )
      if (e[i][1].type === "codeTextData") {
        e[r][1].type = "codeTextPadding", e[n][1].type = "codeTextPadding", r += 2, n -= 2;
        break;
      }
  }
  for (i = r - 1, n++; ++i <= n; )
    a === void 0 ? i !== n && e[i][1].type !== "lineEnding" && (a = i) : (i === n || e[i][1].type === "lineEnding") && (e[a][1].type = "codeTextData", i !== a + 2 && (e[a][1].end = e[i - 1][1].end, e.splice(a + 2, i - a - 2), n -= i - a - 2, i = a + 2), a = void 0);
  return e;
}
function lR(e) {
  return e !== 96 || this.events[this.events.length - 1][1].type === "characterEscape";
}
function cR(e, n, r) {
  let i = 0, a, o;
  return s;
  function s(f) {
    return e.enter("codeText"), e.enter("codeTextSequence"), l(f);
  }
  function l(f) {
    return f === 96 ? (e.consume(f), i++, l) : (e.exit("codeTextSequence"), d(f));
  }
  function d(f) {
    return f === null ? r(f) : f === 32 ? (e.enter("space"), e.consume(f), e.exit("space"), d) : f === 96 ? (o = e.enter("codeTextSequence"), a = 0, u(f)) : vn(f) ? (e.enter("lineEnding"), e.consume(f), e.exit("lineEnding"), d) : (e.enter("codeTextData"), m(f));
  }
  function m(f) {
    return f === null || f === 32 || f === 96 || vn(f) ? (e.exit("codeTextData"), d(f)) : (e.consume(f), m);
  }
  function u(f) {
    return f === 96 ? (e.consume(f), a++, u) : a === i ? (e.exit("codeTextSequence"), e.exit("codeText"), n(f)) : (o.type = "codeTextData", m(f));
  }
}
class dR {
  /**
   * @param {ReadonlyArray<T> | null | undefined} [initial]
   *   Initial items (optional).
   * @returns
   *   Splice buffer.
   */
  constructor(n) {
    this.left = n ? [...n] : [], this.right = [];
  }
  /**
   * Array access;
   * does not move the cursor.
   *
   * @param {number} index
   *   Index.
   * @return {T}
   *   Item.
   */
  get(n) {
    if (n < 0 || n >= this.left.length + this.right.length)
      throw new RangeError("Cannot access index `" + n + "` in a splice buffer of size `" + (this.left.length + this.right.length) + "`");
    return n < this.left.length ? this.left[n] : this.right[this.right.length - n + this.left.length - 1];
  }
  /**
   * The length of the splice buffer, one greater than the largest index in the
   * array.
   */
  get length() {
    return this.left.length + this.right.length;
  }
  /**
   * Remove and return `list[0]`;
   * moves the cursor to `0`.
   *
   * @returns {T | undefined}
   *   Item, optional.
   */
  shift() {
    return this.setCursor(0), this.right.pop();
  }
  /**
   * Slice the buffer to get an array;
   * does not move the cursor.
   *
   * @param {number} start
   *   Start.
   * @param {number | null | undefined} [end]
   *   End (optional).
   * @returns {Array<T>}
   *   Array of items.
   */
  slice(n, r) {
    const i = r ?? Number.POSITIVE_INFINITY;
    return i < this.left.length ? this.left.slice(n, i) : n > this.left.length ? this.right.slice(this.right.length - i + this.left.length, this.right.length - n + this.left.length).reverse() : this.left.slice(n).concat(this.right.slice(this.right.length - i + this.left.length).reverse());
  }
  /**
   * Mimics the behavior of Array.prototype.splice() except for the change of
   * interface necessary to avoid segfaults when patching in very large arrays.
   *
   * This operation moves cursor is moved to `start` and results in the cursor
   * placed after any inserted items.
   *
   * @param {number} start
   *   Start;
   *   zero-based index at which to start changing the array;
   *   negative numbers count backwards from the end of the array and values
   *   that are out-of bounds are clamped to the appropriate end of the array.
   * @param {number | null | undefined} [deleteCount=0]
   *   Delete count (default: `0`);
   *   maximum number of elements to delete, starting from start.
   * @param {Array<T> | null | undefined} [items=[]]
   *   Items to include in place of the deleted items (default: `[]`).
   * @return {Array<T>}
   *   Any removed items.
   */
  splice(n, r, i) {
    const a = r || 0;
    this.setCursor(Math.trunc(n));
    const o = this.right.splice(this.right.length - a, Number.POSITIVE_INFINITY);
    return i && ya(this.left, i), o.reverse();
  }
  /**
   * Remove and return the highest-numbered item in the array, so
   * `list[list.length - 1]`;
   * Moves the cursor to `length`.
   *
   * @returns {T | undefined}
   *   Item, optional.
   */
  pop() {
    return this.setCursor(Number.POSITIVE_INFINITY), this.left.pop();
  }
  /**
   * Inserts a single item to the high-numbered side of the array;
   * moves the cursor to `length`.
   *
   * @param {T} item
   *   Item.
   * @returns {undefined}
   *   Nothing.
   */
  push(n) {
    this.setCursor(Number.POSITIVE_INFINITY), this.left.push(n);
  }
  /**
   * Inserts many items to the high-numbered side of the array.
   * Moves the cursor to `length`.
   *
   * @param {Array<T>} items
   *   Items.
   * @returns {undefined}
   *   Nothing.
   */
  pushMany(n) {
    this.setCursor(Number.POSITIVE_INFINITY), ya(this.left, n);
  }
  /**
   * Inserts a single item to the low-numbered side of the array;
   * Moves the cursor to `0`.
   *
   * @param {T} item
   *   Item.
   * @returns {undefined}
   *   Nothing.
   */
  unshift(n) {
    this.setCursor(0), this.right.push(n);
  }
  /**
   * Inserts many items to the low-numbered side of the array;
   * moves the cursor to `0`.
   *
   * @param {Array<T>} items
   *   Items.
   * @returns {undefined}
   *   Nothing.
   */
  unshiftMany(n) {
    this.setCursor(0), ya(this.right, n.reverse());
  }
  /**
   * Move the cursor to a specific position in the array. Requires
   * time proportional to the distance moved.
   *
   * If `n < 0`, the cursor will end up at the beginning.
   * If `n > length`, the cursor will end up at the end.
   *
   * @param {number} n
   *   Position.
   * @return {undefined}
   *   Nothing.
   */
  setCursor(n) {
    if (!(n === this.left.length || n > this.left.length && this.right.length === 0 || n < 0 && this.left.length === 0))
      if (n < this.left.length) {
        const r = this.left.splice(n, Number.POSITIVE_INFINITY);
        ya(this.right, r.reverse());
      } else {
        const r = this.right.splice(this.left.length + this.right.length - n, Number.POSITIVE_INFINITY);
        ya(this.left, r.reverse());
      }
  }
}
function ya(e, n) {
  let r = 0;
  if (n.length < 1e4)
    e.push(...n);
  else
    for (; r < n.length; )
      e.push(...n.slice(r, r + 1e4)), r += 1e4;
}
function Ex(e) {
  const n = {};
  let r = -1, i, a, o, s, l, d, m;
  const u = new dR(e);
  for (; ++r < u.length; ) {
    for (; r in n; )
      r = n[r];
    if (i = u.get(r), r && i[1].type === "chunkFlow" && u.get(r - 1)[1].type === "listItemPrefix" && (d = i[1]._tokenizer.events, o = 0, o < d.length && d[o][1].type === "lineEndingBlank" && (o += 2), o < d.length && d[o][1].type === "content"))
      for (; ++o < d.length && d[o][1].type !== "content"; )
        d[o][1].type === "chunkText" && (d[o][1]._isInFirstContentOfListItem = !0, o++);
    if (i[0] === "enter")
      i[1].contentType && (Object.assign(n, uR(u, r)), r = n[r], m = !0);
    else if (i[1]._container) {
      for (o = r, a = void 0; o-- && (s = u.get(o), s[1].type === "lineEnding" || s[1].type === "lineEndingBlank"); )
        s[0] === "enter" && (a && (u.get(a)[1].type = "lineEndingBlank"), s[1].type = "lineEnding", a = o);
      a && (i[1].end = {
        ...u.get(a)[1].start
      }, l = u.slice(a, r), l.unshift(i), u.splice(a, r - a + 1, l));
    }
  }
  return Rr(e, 0, Number.POSITIVE_INFINITY, u.slice(0)), !m;
}
function uR(e, n) {
  const r = e.get(n)[1], i = e.get(n)[2];
  let a = n - 1;
  const o = [], s = r._tokenizer || i.parser[r.contentType](r.start), l = s.events, d = [], m = {};
  let u, f, h = -1, v = r, C = 0, S = 0;
  const j = [S];
  for (; v; ) {
    for (; e.get(++a)[1] !== v; )
      ;
    o.push(a), v._tokenizer || (u = i.sliceStream(v), v.next || u.push(null), f && s.defineSkip(v.start), v._isInFirstContentOfListItem && (s._gfmTasklistFirstContentOfListItem = !0), s.write(u), v._isInFirstContentOfListItem && (s._gfmTasklistFirstContentOfListItem = void 0)), f = v, v = v.next;
  }
  for (v = r; ++h < l.length; )
    // Find a void token that includes a break.
    l[h][0] === "exit" && l[h - 1][0] === "enter" && l[h][1].type === l[h - 1][1].type && l[h][1].start.line !== l[h][1].end.line && (S = h + 1, j.push(S), v._tokenizer = void 0, v.previous = void 0, v = v.next);
  for (s.events = [], v ? (v._tokenizer = void 0, v.previous = void 0) : j.pop(), h = j.length; h--; ) {
    const F = l.slice(j[h], j[h + 1]), y = o.pop();
    d.push([y, y + F.length - 1]), e.splice(y, 2, F);
  }
  for (d.reverse(), h = -1; ++h < d.length; )
    m[C + d[h][0]] = C + d[h][1], C += d[h][1] - d[h][0] - 1;
  return m;
}
const mR = {
  resolve: fR,
  tokenize: hR
}, pR = {
  partial: !0,
  tokenize: yR
};
function fR(e) {
  return Ex(e), e;
}
function hR(e, n) {
  let r;
  return i;
  function i(l) {
    return e.enter("content"), r = e.enter("chunkContent", {
      contentType: "content"
    }), a(l);
  }
  function a(l) {
    return l === null ? o(l) : vn(l) ? e.check(pR, s, o)(l) : (e.consume(l), a);
  }
  function o(l) {
    return e.exit("chunkContent"), e.exit("content"), n(l);
  }
  function s(l) {
    return e.consume(l), e.exit("chunkContent"), r.next = e.enter("chunkContent", {
      contentType: "content",
      previous: r
    }), r = r.next, a;
  }
}
function yR(e, n, r) {
  const i = this;
  return a;
  function a(s) {
    return e.exit("chunkContent"), e.enter("lineEnding"), e.consume(s), e.exit("lineEnding"), et(e, o, "linePrefix");
  }
  function o(s) {
    if (s === null || vn(s))
      return r(s);
    const l = i.events[i.events.length - 1];
    return !i.parser.constructs.disable.null.includes("codeIndented") && l && l[1].type === "linePrefix" && l[2].sliceSerialize(l[1], !0).length >= 4 ? n(s) : e.interrupt(i.parser.constructs.flow, r, n)(s);
  }
}
function Tx(e, n, r, i, a, o, s, l, d) {
  const m = d || Number.POSITIVE_INFINITY;
  let u = 0;
  return f;
  function f(F) {
    return F === 60 ? (e.enter(i), e.enter(a), e.enter(o), e.consume(F), e.exit(o), h) : F === null || F === 32 || F === 41 || um(F) ? r(F) : (e.enter(i), e.enter(s), e.enter(l), e.enter("chunkString", {
      contentType: "string"
    }), S(F));
  }
  function h(F) {
    return F === 62 ? (e.enter(o), e.consume(F), e.exit(o), e.exit(a), e.exit(i), n) : (e.enter(l), e.enter("chunkString", {
      contentType: "string"
    }), v(F));
  }
  function v(F) {
    return F === 62 ? (e.exit("chunkString"), e.exit(l), h(F)) : F === null || F === 60 || vn(F) ? r(F) : (e.consume(F), F === 92 ? C : v);
  }
  function C(F) {
    return F === 60 || F === 62 || F === 92 ? (e.consume(F), v) : v(F);
  }
  function S(F) {
    return !u && (F === null || F === 41 || Gt(F)) ? (e.exit("chunkString"), e.exit(l), e.exit(s), e.exit(i), n(F)) : u < m && F === 40 ? (e.consume(F), u++, S) : F === 41 ? (e.consume(F), u--, S) : F === null || F === 32 || F === 40 || um(F) ? r(F) : (e.consume(F), F === 92 ? j : S);
  }
  function j(F) {
    return F === 40 || F === 41 || F === 92 ? (e.consume(F), S) : S(F);
  }
}
function $x(e, n, r, i, a, o) {
  const s = this;
  let l = 0, d;
  return m;
  function m(v) {
    return e.enter(i), e.enter(a), e.consume(v), e.exit(a), e.enter(o), u;
  }
  function u(v) {
    return l > 999 || v === null || v === 91 || v === 93 && !d || // To do: remove in the future once we’ve switched from
    // `micromark-extension-footnote` to `micromark-extension-gfm-footnote`,
    // which doesn’t need this.
    // Hidden footnotes hook.
    /* c8 ignore next 3 */
    v === 94 && !l && "_hiddenFootnoteSupport" in s.parser.constructs ? r(v) : v === 93 ? (e.exit(o), e.enter(a), e.consume(v), e.exit(a), e.exit(i), n) : vn(v) ? (e.enter("lineEnding"), e.consume(v), e.exit("lineEnding"), u) : (e.enter("chunkString", {
      contentType: "string"
    }), f(v));
  }
  function f(v) {
    return v === null || v === 91 || v === 93 || vn(v) || l++ > 999 ? (e.exit("chunkString"), u(v)) : (e.consume(v), d || (d = !zn(v)), v === 92 ? h : f);
  }
  function h(v) {
    return v === 91 || v === 92 || v === 93 ? (e.consume(v), l++, f) : f(v);
  }
}
function Dx(e, n, r, i, a, o) {
  let s;
  return l;
  function l(h) {
    return h === 34 || h === 39 || h === 40 ? (e.enter(i), e.enter(a), e.consume(h), e.exit(a), s = h === 40 ? 41 : h, d) : r(h);
  }
  function d(h) {
    return h === s ? (e.enter(a), e.consume(h), e.exit(a), e.exit(i), n) : (e.enter(o), m(h));
  }
  function m(h) {
    return h === s ? (e.exit(o), d(s)) : h === null ? r(h) : vn(h) ? (e.enter("lineEnding"), e.consume(h), e.exit("lineEnding"), et(e, m, "linePrefix")) : (e.enter("chunkString", {
      contentType: "string"
    }), u(h));
  }
  function u(h) {
    return h === s || h === null || vn(h) ? (e.exit("chunkString"), m(h)) : (e.consume(h), h === 92 ? f : u);
  }
  function f(h) {
    return h === s || h === 92 ? (e.consume(h), u) : u(h);
  }
}
function Ha(e, n) {
  let r;
  return i;
  function i(a) {
    return vn(a) ? (e.enter("lineEnding"), e.consume(a), e.exit("lineEnding"), r = !0, i) : zn(a) ? et(e, i, r ? "linePrefix" : "lineSuffix")(a) : n(a);
  }
}
const gR = {
  name: "definition",
  tokenize: kR
}, vR = {
  partial: !0,
  tokenize: bR
};
function kR(e, n, r) {
  const i = this;
  let a;
  return o;
  function o(v) {
    return e.enter("definition"), s(v);
  }
  function s(v) {
    return $x.call(
      i,
      e,
      l,
      // Note: we don’t need to reset the way `markdown-rs` does.
      r,
      "definitionLabel",
      "definitionLabelMarker",
      "definitionLabelString"
    )(v);
  }
  function l(v) {
    return a = zi(i.sliceSerialize(i.events[i.events.length - 1][1]).slice(1, -1)), v === 58 ? (e.enter("definitionMarker"), e.consume(v), e.exit("definitionMarker"), d) : r(v);
  }
  function d(v) {
    return Gt(v) ? Ha(e, m)(v) : m(v);
  }
  function m(v) {
    return Tx(
      e,
      u,
      // Note: we don’t need to reset the way `markdown-rs` does.
      r,
      "definitionDestination",
      "definitionDestinationLiteral",
      "definitionDestinationLiteralMarker",
      "definitionDestinationRaw",
      "definitionDestinationString"
    )(v);
  }
  function u(v) {
    return e.attempt(vR, f, f)(v);
  }
  function f(v) {
    return zn(v) ? et(e, h, "whitespace")(v) : h(v);
  }
  function h(v) {
    return v === null || vn(v) ? (e.exit("definition"), i.parser.defined.push(a), n(v)) : r(v);
  }
}
function bR(e, n, r) {
  return i;
  function i(l) {
    return Gt(l) ? Ha(e, a)(l) : r(l);
  }
  function a(l) {
    return Dx(e, o, r, "definitionTitle", "definitionTitleMarker", "definitionTitleString")(l);
  }
  function o(l) {
    return zn(l) ? et(e, s, "whitespace")(l) : s(l);
  }
  function s(l) {
    return l === null || vn(l) ? n(l) : r(l);
  }
}
const _R = {
  name: "hardBreakEscape",
  tokenize: xR
};
function xR(e, n, r) {
  return i;
  function i(o) {
    return e.enter("hardBreakEscape"), e.consume(o), a;
  }
  function a(o) {
    return vn(o) ? (e.exit("hardBreakEscape"), n(o)) : r(o);
  }
}
const SR = {
  name: "headingAtx",
  resolve: NR,
  tokenize: jR
};
function NR(e, n) {
  let r = e.length - 2, i = 3, a, o;
  return e[i][1].type === "whitespace" && (i += 2), r - 2 > i && e[r][1].type === "whitespace" && (r -= 2), e[r][1].type === "atxHeadingSequence" && (i === r - 1 || r - 4 > i && e[r - 2][1].type === "whitespace") && (r -= i + 1 === r ? 2 : 4), r > i && (a = {
    type: "atxHeadingText",
    start: e[i][1].start,
    end: e[r][1].end
  }, o = {
    type: "chunkText",
    start: e[i][1].start,
    end: e[r][1].end,
    contentType: "text"
  }, Rr(e, i, r - i + 1, [["enter", a, n], ["enter", o, n], ["exit", o, n], ["exit", a, n]])), e;
}
function jR(e, n, r) {
  let i = 0;
  return a;
  function a(u) {
    return e.enter("atxHeading"), o(u);
  }
  function o(u) {
    return e.enter("atxHeadingSequence"), s(u);
  }
  function s(u) {
    return u === 35 && i++ < 6 ? (e.consume(u), s) : u === null || Gt(u) ? (e.exit("atxHeadingSequence"), l(u)) : r(u);
  }
  function l(u) {
    return u === 35 ? (e.enter("atxHeadingSequence"), d(u)) : u === null || vn(u) ? (e.exit("atxHeading"), n(u)) : zn(u) ? et(e, l, "whitespace")(u) : (e.enter("atxHeadingText"), m(u));
  }
  function d(u) {
    return u === 35 ? (e.consume(u), d) : (e.exit("atxHeadingSequence"), l(u));
  }
  function m(u) {
    return u === null || u === 35 || Gt(u) ? (e.exit("atxHeadingText"), l(u)) : (e.consume(u), m);
  }
}
const wR = [
  "address",
  "article",
  "aside",
  "base",
  "basefont",
  "blockquote",
  "body",
  "caption",
  "center",
  "col",
  "colgroup",
  "dd",
  "details",
  "dialog",
  "dir",
  "div",
  "dl",
  "dt",
  "fieldset",
  "figcaption",
  "figure",
  "footer",
  "form",
  "frame",
  "frameset",
  "h1",
  "h2",
  "h3",
  "h4",
  "h5",
  "h6",
  "head",
  "header",
  "hr",
  "html",
  "iframe",
  "legend",
  "li",
  "link",
  "main",
  "menu",
  "menuitem",
  "nav",
  "noframes",
  "ol",
  "optgroup",
  "option",
  "p",
  "param",
  "search",
  "section",
  "summary",
  "table",
  "tbody",
  "td",
  "tfoot",
  "th",
  "thead",
  "title",
  "tr",
  "track",
  "ul"
], Ev = ["pre", "script", "style", "textarea"], CR = {
  concrete: !0,
  name: "htmlFlow",
  resolveTo: ER,
  tokenize: TR
}, FR = {
  partial: !0,
  tokenize: DR
}, IR = {
  partial: !0,
  tokenize: $R
};
function ER(e) {
  let n = e.length;
  for (; n-- && !(e[n][0] === "enter" && e[n][1].type === "htmlFlow"); )
    ;
  return n > 1 && e[n - 2][1].type === "linePrefix" && (e[n][1].start = e[n - 2][1].start, e[n + 1][1].start = e[n - 2][1].start, e.splice(n - 2, 2)), e;
}
function TR(e, n, r) {
  const i = this;
  let a, o, s, l, d;
  return m;
  function m(K) {
    return u(K);
  }
  function u(K) {
    return e.enter("htmlFlow"), e.enter("htmlFlowData"), e.consume(K), f;
  }
  function f(K) {
    return K === 33 ? (e.consume(K), h) : K === 47 ? (e.consume(K), o = !0, S) : K === 63 ? (e.consume(K), a = 3, i.interrupt ? n : W) : Ir(K) ? (e.consume(K), s = String.fromCharCode(K), j) : r(K);
  }
  function h(K) {
    return K === 45 ? (e.consume(K), a = 2, v) : K === 91 ? (e.consume(K), a = 5, l = 0, C) : Ir(K) ? (e.consume(K), a = 4, i.interrupt ? n : W) : r(K);
  }
  function v(K) {
    return K === 45 ? (e.consume(K), i.interrupt ? n : W) : r(K);
  }
  function C(K) {
    const qe = "CDATA[";
    return K === qe.charCodeAt(l++) ? (e.consume(K), l === qe.length ? i.interrupt ? n : U : C) : r(K);
  }
  function S(K) {
    return Ir(K) ? (e.consume(K), s = String.fromCharCode(K), j) : r(K);
  }
  function j(K) {
    if (K === null || K === 47 || K === 62 || Gt(K)) {
      const qe = K === 47, Be = s.toLowerCase();
      return !qe && !o && Ev.includes(Be) ? (a = 1, i.interrupt ? n(K) : U(K)) : wR.includes(s.toLowerCase()) ? (a = 6, qe ? (e.consume(K), F) : i.interrupt ? n(K) : U(K)) : (a = 7, i.interrupt && !i.parser.lazy[i.now().line] ? r(K) : o ? y(K) : q(K));
    }
    return K === 45 || tr(K) ? (e.consume(K), s += String.fromCharCode(K), j) : r(K);
  }
  function F(K) {
    return K === 62 ? (e.consume(K), i.interrupt ? n : U) : r(K);
  }
  function y(K) {
    return zn(K) ? (e.consume(K), y) : ae(K);
  }
  function q(K) {
    return K === 47 ? (e.consume(K), ae) : K === 58 || K === 95 || Ir(K) ? (e.consume(K), T) : zn(K) ? (e.consume(K), q) : ae(K);
  }
  function T(K) {
    return K === 45 || K === 46 || K === 58 || K === 95 || tr(K) ? (e.consume(K), T) : E(K);
  }
  function E(K) {
    return K === 61 ? (e.consume(K), D) : zn(K) ? (e.consume(K), E) : q(K);
  }
  function D(K) {
    return K === null || K === 60 || K === 61 || K === 62 || K === 96 ? r(K) : K === 34 || K === 39 ? (e.consume(K), d = K, B) : zn(K) ? (e.consume(K), D) : ee(K);
  }
  function B(K) {
    return K === d ? (e.consume(K), d = null, J) : K === null || vn(K) ? r(K) : (e.consume(K), B);
  }
  function ee(K) {
    return K === null || K === 34 || K === 39 || K === 47 || K === 60 || K === 61 || K === 62 || K === 96 || Gt(K) ? E(K) : (e.consume(K), ee);
  }
  function J(K) {
    return K === 47 || K === 62 || zn(K) ? q(K) : r(K);
  }
  function ae(K) {
    return K === 62 ? (e.consume(K), Q) : r(K);
  }
  function Q(K) {
    return K === null || vn(K) ? U(K) : zn(K) ? (e.consume(K), Q) : r(K);
  }
  function U(K) {
    return K === 45 && a === 2 ? (e.consume(K), ye) : K === 60 && a === 1 ? (e.consume(K), ce) : K === 62 && a === 4 ? (e.consume(K), ke) : K === 63 && a === 3 ? (e.consume(K), W) : K === 93 && a === 5 ? (e.consume(K), ue) : vn(K) && (a === 6 || a === 7) ? (e.exit("htmlFlowData"), e.check(FR, Ee, O)(K)) : K === null || vn(K) ? (e.exit("htmlFlowData"), O(K)) : (e.consume(K), U);
  }
  function O(K) {
    return e.check(IR, H, Ee)(K);
  }
  function H(K) {
    return e.enter("lineEnding"), e.consume(K), e.exit("lineEnding"), Z;
  }
  function Z(K) {
    return K === null || vn(K) ? O(K) : (e.enter("htmlFlowData"), U(K));
  }
  function ye(K) {
    return K === 45 ? (e.consume(K), W) : U(K);
  }
  function ce(K) {
    return K === 47 ? (e.consume(K), s = "", le) : U(K);
  }
  function le(K) {
    if (K === 62) {
      const qe = s.toLowerCase();
      return Ev.includes(qe) ? (e.consume(K), ke) : U(K);
    }
    return Ir(K) && s.length < 8 ? (e.consume(K), s += String.fromCharCode(K), le) : U(K);
  }
  function ue(K) {
    return K === 93 ? (e.consume(K), W) : U(K);
  }
  function W(K) {
    return K === 62 ? (e.consume(K), ke) : K === 45 && a === 2 ? (e.consume(K), W) : U(K);
  }
  function ke(K) {
    return K === null || vn(K) ? (e.exit("htmlFlowData"), Ee(K)) : (e.consume(K), ke);
  }
  function Ee(K) {
    return e.exit("htmlFlow"), n(K);
  }
}
function $R(e, n, r) {
  const i = this;
  return a;
  function a(s) {
    return vn(s) ? (e.enter("lineEnding"), e.consume(s), e.exit("lineEnding"), o) : r(s);
  }
  function o(s) {
    return i.parser.lazy[i.now().line] ? r(s) : n(s);
  }
}
function DR(e, n, r) {
  return i;
  function i(a) {
    return e.enter("lineEnding"), e.consume(a), e.exit("lineEnding"), e.attempt(Qs, n, r);
  }
}
const RR = {
  name: "htmlText",
  tokenize: OR
};
function OR(e, n, r) {
  const i = this;
  let a, o, s;
  return l;
  function l(W) {
    return e.enter("htmlText"), e.enter("htmlTextData"), e.consume(W), d;
  }
  function d(W) {
    return W === 33 ? (e.consume(W), m) : W === 47 ? (e.consume(W), E) : W === 63 ? (e.consume(W), q) : Ir(W) ? (e.consume(W), ee) : r(W);
  }
  function m(W) {
    return W === 45 ? (e.consume(W), u) : W === 91 ? (e.consume(W), o = 0, C) : Ir(W) ? (e.consume(W), y) : r(W);
  }
  function u(W) {
    return W === 45 ? (e.consume(W), v) : r(W);
  }
  function f(W) {
    return W === null ? r(W) : W === 45 ? (e.consume(W), h) : vn(W) ? (s = f, ce(W)) : (e.consume(W), f);
  }
  function h(W) {
    return W === 45 ? (e.consume(W), v) : f(W);
  }
  function v(W) {
    return W === 62 ? ye(W) : W === 45 ? h(W) : f(W);
  }
  function C(W) {
    const ke = "CDATA[";
    return W === ke.charCodeAt(o++) ? (e.consume(W), o === ke.length ? S : C) : r(W);
  }
  function S(W) {
    return W === null ? r(W) : W === 93 ? (e.consume(W), j) : vn(W) ? (s = S, ce(W)) : (e.consume(W), S);
  }
  function j(W) {
    return W === 93 ? (e.consume(W), F) : S(W);
  }
  function F(W) {
    return W === 62 ? ye(W) : W === 93 ? (e.consume(W), F) : S(W);
  }
  function y(W) {
    return W === null || W === 62 ? ye(W) : vn(W) ? (s = y, ce(W)) : (e.consume(W), y);
  }
  function q(W) {
    return W === null ? r(W) : W === 63 ? (e.consume(W), T) : vn(W) ? (s = q, ce(W)) : (e.consume(W), q);
  }
  function T(W) {
    return W === 62 ? ye(W) : q(W);
  }
  function E(W) {
    return Ir(W) ? (e.consume(W), D) : r(W);
  }
  function D(W) {
    return W === 45 || tr(W) ? (e.consume(W), D) : B(W);
  }
  function B(W) {
    return vn(W) ? (s = B, ce(W)) : zn(W) ? (e.consume(W), B) : ye(W);
  }
  function ee(W) {
    return W === 45 || tr(W) ? (e.consume(W), ee) : W === 47 || W === 62 || Gt(W) ? J(W) : r(W);
  }
  function J(W) {
    return W === 47 ? (e.consume(W), ye) : W === 58 || W === 95 || Ir(W) ? (e.consume(W), ae) : vn(W) ? (s = J, ce(W)) : zn(W) ? (e.consume(W), J) : ye(W);
  }
  function ae(W) {
    return W === 45 || W === 46 || W === 58 || W === 95 || tr(W) ? (e.consume(W), ae) : Q(W);
  }
  function Q(W) {
    return W === 61 ? (e.consume(W), U) : vn(W) ? (s = Q, ce(W)) : zn(W) ? (e.consume(W), Q) : J(W);
  }
  function U(W) {
    return W === null || W === 60 || W === 61 || W === 62 || W === 96 ? r(W) : W === 34 || W === 39 ? (e.consume(W), a = W, O) : vn(W) ? (s = U, ce(W)) : zn(W) ? (e.consume(W), U) : (e.consume(W), H);
  }
  function O(W) {
    return W === a ? (e.consume(W), a = void 0, Z) : W === null ? r(W) : vn(W) ? (s = O, ce(W)) : (e.consume(W), O);
  }
  function H(W) {
    return W === null || W === 34 || W === 39 || W === 60 || W === 61 || W === 96 ? r(W) : W === 47 || W === 62 || Gt(W) ? J(W) : (e.consume(W), H);
  }
  function Z(W) {
    return W === 47 || W === 62 || Gt(W) ? J(W) : r(W);
  }
  function ye(W) {
    return W === 62 ? (e.consume(W), e.exit("htmlTextData"), e.exit("htmlText"), n) : r(W);
  }
  function ce(W) {
    return e.exit("htmlTextData"), e.enter("lineEnding"), e.consume(W), e.exit("lineEnding"), le;
  }
  function le(W) {
    return zn(W) ? et(e, ue, "linePrefix", i.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4)(W) : ue(W);
  }
  function ue(W) {
    return e.enter("htmlTextData"), s(W);
  }
}
const Tp = {
  name: "labelEnd",
  resolveAll: VR,
  resolveTo: zR,
  tokenize: UR
}, PR = {
  tokenize: MR
}, AR = {
  tokenize: BR
}, LR = {
  tokenize: qR
};
function VR(e) {
  let n = -1;
  const r = [];
  for (; ++n < e.length; ) {
    const i = e[n][1];
    if (r.push(e[n]), i.type === "labelImage" || i.type === "labelLink" || i.type === "labelEnd") {
      const a = i.type === "labelImage" ? 4 : 2;
      i.type = "data", n += a;
    }
  }
  return e.length !== r.length && Rr(e, 0, e.length, r), e;
}
function zR(e, n) {
  let r = e.length, i = 0, a, o, s, l;
  for (; r--; )
    if (a = e[r][1], o) {
      if (a.type === "link" || a.type === "labelLink" && a._inactive)
        break;
      e[r][0] === "enter" && a.type === "labelLink" && (a._inactive = !0);
    } else if (s) {
      if (e[r][0] === "enter" && (a.type === "labelImage" || a.type === "labelLink") && !a._balanced && (o = r, a.type !== "labelLink")) {
        i = 2;
        break;
      }
    } else a.type === "labelEnd" && (s = r);
  const d = {
    type: e[o][1].type === "labelLink" ? "link" : "image",
    start: {
      ...e[o][1].start
    },
    end: {
      ...e[e.length - 1][1].end
    }
  }, m = {
    type: "label",
    start: {
      ...e[o][1].start
    },
    end: {
      ...e[s][1].end
    }
  }, u = {
    type: "labelText",
    start: {
      ...e[o + i + 2][1].end
    },
    end: {
      ...e[s - 2][1].start
    }
  };
  return l = [["enter", d, n], ["enter", m, n]], l = or(l, e.slice(o + 1, o + i + 3)), l = or(l, [["enter", u, n]]), l = or(l, Ep(n.parser.constructs.insideSpan.null, e.slice(o + i + 4, s - 3), n)), l = or(l, [["exit", u, n], e[s - 2], e[s - 1], ["exit", m, n]]), l = or(l, e.slice(s + 1)), l = or(l, [["exit", d, n]]), Rr(e, o, e.length, l), e;
}
function UR(e, n, r) {
  const i = this;
  let a = i.events.length, o, s;
  for (; a--; )
    if ((i.events[a][1].type === "labelImage" || i.events[a][1].type === "labelLink") && !i.events[a][1]._balanced) {
      o = i.events[a][1];
      break;
    }
  return l;
  function l(h) {
    return o ? o._inactive ? f(h) : (s = i.parser.defined.includes(zi(i.sliceSerialize({
      start: o.end,
      end: i.now()
    }))), e.enter("labelEnd"), e.enter("labelMarker"), e.consume(h), e.exit("labelMarker"), e.exit("labelEnd"), d) : r(h);
  }
  function d(h) {
    return h === 40 ? e.attempt(PR, u, s ? u : f)(h) : h === 91 ? e.attempt(AR, u, s ? m : f)(h) : s ? u(h) : f(h);
  }
  function m(h) {
    return e.attempt(LR, u, f)(h);
  }
  function u(h) {
    return n(h);
  }
  function f(h) {
    return o._balanced = !0, r(h);
  }
}
function MR(e, n, r) {
  return i;
  function i(f) {
    return e.enter("resource"), e.enter("resourceMarker"), e.consume(f), e.exit("resourceMarker"), a;
  }
  function a(f) {
    return Gt(f) ? Ha(e, o)(f) : o(f);
  }
  function o(f) {
    return f === 41 ? u(f) : Tx(e, s, l, "resourceDestination", "resourceDestinationLiteral", "resourceDestinationLiteralMarker", "resourceDestinationRaw", "resourceDestinationString", 32)(f);
  }
  function s(f) {
    return Gt(f) ? Ha(e, d)(f) : u(f);
  }
  function l(f) {
    return r(f);
  }
  function d(f) {
    return f === 34 || f === 39 || f === 40 ? Dx(e, m, r, "resourceTitle", "resourceTitleMarker", "resourceTitleString")(f) : u(f);
  }
  function m(f) {
    return Gt(f) ? Ha(e, u)(f) : u(f);
  }
  function u(f) {
    return f === 41 ? (e.enter("resourceMarker"), e.consume(f), e.exit("resourceMarker"), e.exit("resource"), n) : r(f);
  }
}
function BR(e, n, r) {
  const i = this;
  return a;
  function a(l) {
    return $x.call(i, e, o, s, "reference", "referenceMarker", "referenceString")(l);
  }
  function o(l) {
    return i.parser.defined.includes(zi(i.sliceSerialize(i.events[i.events.length - 1][1]).slice(1, -1))) ? n(l) : r(l);
  }
  function s(l) {
    return r(l);
  }
}
function qR(e, n, r) {
  return i;
  function i(o) {
    return e.enter("reference"), e.enter("referenceMarker"), e.consume(o), e.exit("referenceMarker"), a;
  }
  function a(o) {
    return o === 93 ? (e.enter("referenceMarker"), e.consume(o), e.exit("referenceMarker"), e.exit("reference"), n) : r(o);
  }
}
const HR = {
  name: "labelStartImage",
  resolveAll: Tp.resolveAll,
  tokenize: WR
};
function WR(e, n, r) {
  const i = this;
  return a;
  function a(l) {
    return e.enter("labelImage"), e.enter("labelImageMarker"), e.consume(l), e.exit("labelImageMarker"), o;
  }
  function o(l) {
    return l === 91 ? (e.enter("labelMarker"), e.consume(l), e.exit("labelMarker"), e.exit("labelImage"), s) : r(l);
  }
  function s(l) {
    return l === 94 && "_hiddenFootnoteSupport" in i.parser.constructs ? r(l) : n(l);
  }
}
const KR = {
  name: "labelStartLink",
  resolveAll: Tp.resolveAll,
  tokenize: GR
};
function GR(e, n, r) {
  const i = this;
  return a;
  function a(s) {
    return e.enter("labelLink"), e.enter("labelMarker"), e.consume(s), e.exit("labelMarker"), e.exit("labelLink"), o;
  }
  function o(s) {
    return s === 94 && "_hiddenFootnoteSupport" in i.parser.constructs ? r(s) : n(s);
  }
}
const su = {
  name: "lineEnding",
  tokenize: YR
};
function YR(e, n) {
  return r;
  function r(i) {
    return e.enter("lineEnding"), e.consume(i), e.exit("lineEnding"), et(e, n, "linePrefix");
  }
}
const as = {
  name: "thematicBreak",
  tokenize: QR
};
function QR(e, n, r) {
  let i = 0, a;
  return o;
  function o(m) {
    return e.enter("thematicBreak"), s(m);
  }
  function s(m) {
    return a = m, l(m);
  }
  function l(m) {
    return m === a ? (e.enter("thematicBreakSequence"), d(m)) : i >= 3 && (m === null || vn(m)) ? (e.exit("thematicBreak"), n(m)) : r(m);
  }
  function d(m) {
    return m === a ? (e.consume(m), i++, d) : (e.exit("thematicBreakSequence"), zn(m) ? et(e, l, "whitespace")(m) : l(m));
  }
}
const Ht = {
  continuation: {
    tokenize: eO
  },
  exit: tO,
  name: "list",
  tokenize: ZR
}, JR = {
  partial: !0,
  tokenize: rO
}, XR = {
  partial: !0,
  tokenize: nO
};
function ZR(e, n, r) {
  const i = this, a = i.events[i.events.length - 1];
  let o = a && a[1].type === "linePrefix" ? a[2].sliceSerialize(a[1], !0).length : 0, s = 0;
  return l;
  function l(v) {
    const C = i.containerState.type || (v === 42 || v === 43 || v === 45 ? "listUnordered" : "listOrdered");
    if (C === "listUnordered" ? !i.containerState.marker || v === i.containerState.marker : mm(v)) {
      if (i.containerState.type || (i.containerState.type = C, e.enter(C, {
        _container: !0
      })), C === "listUnordered")
        return e.enter("listItemPrefix"), v === 42 || v === 45 ? e.check(as, r, m)(v) : m(v);
      if (!i.interrupt || v === 49)
        return e.enter("listItemPrefix"), e.enter("listItemValue"), d(v);
    }
    return r(v);
  }
  function d(v) {
    return mm(v) && ++s < 10 ? (e.consume(v), d) : (!i.interrupt || s < 2) && (i.containerState.marker ? v === i.containerState.marker : v === 41 || v === 46) ? (e.exit("listItemValue"), m(v)) : r(v);
  }
  function m(v) {
    return e.enter("listItemMarker"), e.consume(v), e.exit("listItemMarker"), i.containerState.marker = i.containerState.marker || v, e.check(
      Qs,
      // Can’t be empty when interrupting.
      i.interrupt ? r : u,
      e.attempt(JR, h, f)
    );
  }
  function u(v) {
    return i.containerState.initialBlankLine = !0, o++, h(v);
  }
  function f(v) {
    return zn(v) ? (e.enter("listItemPrefixWhitespace"), e.consume(v), e.exit("listItemPrefixWhitespace"), h) : r(v);
  }
  function h(v) {
    return i.containerState.size = o + i.sliceSerialize(e.exit("listItemPrefix"), !0).length, n(v);
  }
}
function eO(e, n, r) {
  const i = this;
  return i.containerState._closeFlow = void 0, e.check(Qs, a, o);
  function a(l) {
    return i.containerState.furtherBlankLines = i.containerState.furtherBlankLines || i.containerState.initialBlankLine, et(e, n, "listItemIndent", i.containerState.size + 1)(l);
  }
  function o(l) {
    return i.containerState.furtherBlankLines || !zn(l) ? (i.containerState.furtherBlankLines = void 0, i.containerState.initialBlankLine = void 0, s(l)) : (i.containerState.furtherBlankLines = void 0, i.containerState.initialBlankLine = void 0, e.attempt(XR, n, s)(l));
  }
  function s(l) {
    return i.containerState._closeFlow = !0, i.interrupt = void 0, et(e, e.attempt(Ht, n, r), "linePrefix", i.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4)(l);
  }
}
function nO(e, n, r) {
  const i = this;
  return et(e, a, "listItemIndent", i.containerState.size + 1);
  function a(o) {
    const s = i.events[i.events.length - 1];
    return s && s[1].type === "listItemIndent" && s[2].sliceSerialize(s[1], !0).length === i.containerState.size ? n(o) : r(o);
  }
}
function tO(e) {
  e.exit(this.containerState.type);
}
function rO(e, n, r) {
  const i = this;
  return et(e, a, "listItemPrefixWhitespace", i.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 5);
  function a(o) {
    const s = i.events[i.events.length - 1];
    return !zn(o) && s && s[1].type === "listItemPrefixWhitespace" ? n(o) : r(o);
  }
}
const Tv = {
  name: "setextUnderline",
  resolveTo: iO,
  tokenize: aO
};
function iO(e, n) {
  let r = e.length, i, a, o;
  for (; r--; )
    if (e[r][0] === "enter") {
      if (e[r][1].type === "content") {
        i = r;
        break;
      }
      e[r][1].type === "paragraph" && (a = r);
    } else
      e[r][1].type === "content" && e.splice(r, 1), !o && e[r][1].type === "definition" && (o = r);
  const s = {
    type: "setextHeading",
    start: {
      ...e[a][1].start
    },
    end: {
      ...e[e.length - 1][1].end
    }
  };
  return e[a][1].type = "setextHeadingText", o ? (e.splice(a, 0, ["enter", s, n]), e.splice(o + 1, 0, ["exit", e[i][1], n]), e[i][1].end = {
    ...e[o][1].end
  }) : e[i][1] = s, e.push(["exit", s, n]), e;
}
function aO(e, n, r) {
  const i = this;
  let a;
  return o;
  function o(m) {
    let u = i.events.length, f;
    for (; u--; )
      if (i.events[u][1].type !== "lineEnding" && i.events[u][1].type !== "linePrefix" && i.events[u][1].type !== "content") {
        f = i.events[u][1].type === "paragraph";
        break;
      }
    return !i.parser.lazy[i.now().line] && (i.interrupt || f) ? (e.enter("setextHeadingLine"), a = m, s(m)) : r(m);
  }
  function s(m) {
    return e.enter("setextHeadingLineSequence"), l(m);
  }
  function l(m) {
    return m === a ? (e.consume(m), l) : (e.exit("setextHeadingLineSequence"), zn(m) ? et(e, d, "lineSuffix")(m) : d(m));
  }
  function d(m) {
    return m === null || vn(m) ? (e.exit("setextHeadingLine"), n(m)) : r(m);
  }
}
const oO = {
  tokenize: sO
};
function sO(e) {
  const n = this, r = e.attempt(
    // Try to parse a blank line.
    Qs,
    i,
    // Try to parse initial flow (essentially, only code).
    e.attempt(this.parser.constructs.flowInitial, a, et(e, e.attempt(this.parser.constructs.flow, a, e.attempt(mR, a)), "linePrefix"))
  );
  return r;
  function i(o) {
    if (o === null) {
      e.consume(o);
      return;
    }
    return e.enter("lineEndingBlank"), e.consume(o), e.exit("lineEndingBlank"), n.currentConstruct = void 0, r;
  }
  function a(o) {
    if (o === null) {
      e.consume(o);
      return;
    }
    return e.enter("lineEnding"), e.consume(o), e.exit("lineEnding"), n.currentConstruct = void 0, r;
  }
}
const lO = {
  resolveAll: Ox()
}, cO = Rx("string"), dO = Rx("text");
function Rx(e) {
  return {
    resolveAll: Ox(e === "text" ? uO : void 0),
    tokenize: n
  };
  function n(r) {
    const i = this, a = this.parser.constructs[e], o = r.attempt(a, s, l);
    return s;
    function s(u) {
      return m(u) ? o(u) : l(u);
    }
    function l(u) {
      if (u === null) {
        r.consume(u);
        return;
      }
      return r.enter("data"), r.consume(u), d;
    }
    function d(u) {
      return m(u) ? (r.exit("data"), o(u)) : (r.consume(u), d);
    }
    function m(u) {
      if (u === null)
        return !0;
      const f = a[u];
      let h = -1;
      if (f)
        for (; ++h < f.length; ) {
          const v = f[h];
          if (!v.previous || v.previous.call(i, i.previous))
            return !0;
        }
      return !1;
    }
  }
}
function Ox(e) {
  return n;
  function n(r, i) {
    let a = -1, o;
    for (; ++a <= r.length; )
      o === void 0 ? r[a] && r[a][1].type === "data" && (o = a, a++) : (!r[a] || r[a][1].type !== "data") && (a !== o + 2 && (r[o][1].end = r[a - 1][1].end, r.splice(o + 2, a - o - 2), a = o + 2), o = void 0);
    return e ? e(r, i) : r;
  }
}
function uO(e, n) {
  let r = 0;
  for (; ++r <= e.length; )
    if ((r === e.length || e[r][1].type === "lineEnding") && e[r - 1][1].type === "data") {
      const i = e[r - 1][1], a = n.sliceStream(i);
      let o = a.length, s = -1, l = 0, d;
      for (; o--; ) {
        const m = a[o];
        if (typeof m == "string") {
          for (s = m.length; m.charCodeAt(s - 1) === 32; )
            l++, s--;
          if (s) break;
          s = -1;
        } else if (m === -2)
          d = !0, l++;
        else if (m !== -1) {
          o++;
          break;
        }
      }
      if (l) {
        const m = {
          type: r === e.length || d || l < 2 ? "lineSuffix" : "hardBreakTrailing",
          start: {
            _bufferIndex: o ? s : i.start._bufferIndex + s,
            _index: i.start._index + o,
            line: i.end.line,
            column: i.end.column - l,
            offset: i.end.offset - l
          },
          end: {
            ...i.end
          }
        };
        i.end = {
          ...m.start
        }, i.start.offset === i.end.offset ? Object.assign(i, m) : (e.splice(r, 0, ["enter", m, n], ["exit", m, n]), r += 2);
      }
      r++;
    }
  return e;
}
const mO = {
  42: Ht,
  43: Ht,
  45: Ht,
  48: Ht,
  49: Ht,
  50: Ht,
  51: Ht,
  52: Ht,
  53: Ht,
  54: Ht,
  55: Ht,
  56: Ht,
  57: Ht,
  62: Cx
}, pO = {
  91: gR
}, fO = {
  [-2]: ou,
  [-1]: ou,
  32: ou
}, hO = {
  35: SR,
  42: as,
  45: [Tv, as],
  60: CR,
  61: Tv,
  95: as,
  96: Iv,
  126: Iv
}, yO = {
  38: Ix,
  92: Fx
}, gO = {
  [-5]: su,
  [-4]: su,
  [-3]: su,
  33: HR,
  38: Ix,
  42: pm,
  60: [KD, RR],
  91: KR,
  92: [_R, Fx],
  93: Tp,
  95: pm,
  96: oR
}, vO = {
  null: [pm, lO]
}, kO = {
  null: [42, 95]
}, bO = {
  null: []
}, _O = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  attentionMarkers: kO,
  contentInitial: pO,
  disable: bO,
  document: mO,
  flow: hO,
  flowInitial: fO,
  insideSpan: vO,
  string: yO,
  text: gO
}, Symbol.toStringTag, { value: "Module" }));
function xO(e, n, r) {
  let i = {
    _bufferIndex: -1,
    _index: 0,
    line: r && r.line || 1,
    column: r && r.column || 1,
    offset: r && r.offset || 0
  };
  const a = {}, o = [];
  let s = [], l = [];
  const d = {
    attempt: B(E),
    check: B(D),
    consume: y,
    enter: q,
    exit: T,
    interrupt: B(D, {
      interrupt: !0
    })
  }, m = {
    code: null,
    containerState: {},
    defineSkip: S,
    events: [],
    now: C,
    parser: e,
    previous: null,
    sliceSerialize: h,
    sliceStream: v,
    write: f
  };
  let u = n.tokenize.call(m, d);
  return n.resolveAll && o.push(n), m;
  function f(Q) {
    return s = or(s, Q), j(), s[s.length - 1] !== null ? [] : (ee(n, 0), m.events = Ep(o, m.events, m), m.events);
  }
  function h(Q, U) {
    return NO(v(Q), U);
  }
  function v(Q) {
    return SO(s, Q);
  }
  function C() {
    const {
      _bufferIndex: Q,
      _index: U,
      line: O,
      column: H,
      offset: Z
    } = i;
    return {
      _bufferIndex: Q,
      _index: U,
      line: O,
      column: H,
      offset: Z
    };
  }
  function S(Q) {
    a[Q.line] = Q.column, ae();
  }
  function j() {
    let Q;
    for (; i._index < s.length; ) {
      const U = s[i._index];
      if (typeof U == "string")
        for (Q = i._index, i._bufferIndex < 0 && (i._bufferIndex = 0); i._index === Q && i._bufferIndex < U.length; )
          F(U.charCodeAt(i._bufferIndex));
      else
        F(U);
    }
  }
  function F(Q) {
    u = u(Q);
  }
  function y(Q) {
    vn(Q) ? (i.line++, i.column = 1, i.offset += Q === -3 ? 2 : 1, ae()) : Q !== -1 && (i.column++, i.offset++), i._bufferIndex < 0 ? i._index++ : (i._bufferIndex++, i._bufferIndex === // Points w/ non-negative `_bufferIndex` reference
    // strings.
    /** @type {string} */
    s[i._index].length && (i._bufferIndex = -1, i._index++)), m.previous = Q;
  }
  function q(Q, U) {
    const O = U || {};
    return O.type = Q, O.start = C(), m.events.push(["enter", O, m]), l.push(O), O;
  }
  function T(Q) {
    const U = l.pop();
    return U.end = C(), m.events.push(["exit", U, m]), U;
  }
  function E(Q, U) {
    ee(Q, U.from);
  }
  function D(Q, U) {
    U.restore();
  }
  function B(Q, U) {
    return O;
    function O(H, Z, ye) {
      let ce, le, ue, W;
      return Array.isArray(H) ? (
        /* c8 ignore next 1 */
        Ee(H)
      ) : "tokenize" in H ? (
        // Looks like a construct.
        Ee([
          /** @type {Construct} */
          H
        ])
      ) : ke(H);
      function ke(Pe) {
        return Me;
        function Me(Fe) {
          const Ae = Fe !== null && Pe[Fe], $e = Fe !== null && Pe.null, tn = [
            // To do: add more extension tests.
            /* c8 ignore next 2 */
            ...Array.isArray(Ae) ? Ae : Ae ? [Ae] : [],
            ...Array.isArray($e) ? $e : $e ? [$e] : []
          ];
          return Ee(tn)(Fe);
        }
      }
      function Ee(Pe) {
        return ce = Pe, le = 0, Pe.length === 0 ? ye : K(Pe[le]);
      }
      function K(Pe) {
        return Me;
        function Me(Fe) {
          return W = J(), ue = Pe, Pe.partial || (m.currentConstruct = Pe), Pe.name && m.parser.constructs.disable.null.includes(Pe.name) ? Be() : Pe.tokenize.call(
            // If we do have fields, create an object w/ `context` as its
            // prototype.
            // This allows a “live binding”, which is needed for `interrupt`.
            U ? Object.assign(Object.create(m), U) : m,
            d,
            qe,
            Be
          )(Fe);
        }
      }
      function qe(Pe) {
        return Q(ue, W), Z;
      }
      function Be(Pe) {
        return W.restore(), ++le < ce.length ? K(ce[le]) : ye;
      }
    }
  }
  function ee(Q, U) {
    Q.resolveAll && !o.includes(Q) && o.push(Q), Q.resolve && Rr(m.events, U, m.events.length - U, Q.resolve(m.events.slice(U), m)), Q.resolveTo && (m.events = Q.resolveTo(m.events, m));
  }
  function J() {
    const Q = C(), U = m.previous, O = m.currentConstruct, H = m.events.length, Z = Array.from(l);
    return {
      from: H,
      restore: ye
    };
    function ye() {
      i = Q, m.previous = U, m.currentConstruct = O, m.events.length = H, l = Z, ae();
    }
  }
  function ae() {
    i.line in a && i.column < 2 && (i.column = a[i.line], i.offset += a[i.line] - 1);
  }
}
function SO(e, n) {
  const r = n.start._index, i = n.start._bufferIndex, a = n.end._index, o = n.end._bufferIndex;
  let s;
  if (r === a)
    s = [e[r].slice(i, o)];
  else {
    if (s = e.slice(r, a), i > -1) {
      const l = s[0];
      typeof l == "string" ? s[0] = l.slice(i) : s.shift();
    }
    o > 0 && s.push(e[a].slice(0, o));
  }
  return s;
}
function NO(e, n) {
  let r = -1;
  const i = [];
  let a;
  for (; ++r < e.length; ) {
    const o = e[r];
    let s;
    if (typeof o == "string")
      s = o;
    else switch (o) {
      case -5: {
        s = "\r";
        break;
      }
      case -4: {
        s = `
`;
        break;
      }
      case -3: {
        s = `\r
`;
        break;
      }
      case -2: {
        s = n ? " " : "	";
        break;
      }
      case -1: {
        if (!n && a) continue;
        s = " ";
        break;
      }
      default:
        s = String.fromCharCode(o);
    }
    a = o === -2, i.push(s);
  }
  return i.join("");
}
function jO(e) {
  const i = {
    constructs: (
      /** @type {FullNormalizedExtension} */
      $D([_O, ...(e || {}).extensions || []])
    ),
    content: a(zD),
    defined: [],
    document: a(MD),
    flow: a(oO),
    lazy: {},
    string: a(cO),
    text: a(dO)
  };
  return i;
  function a(o) {
    return s;
    function s(l) {
      return xO(i, o, l);
    }
  }
}
function wO(e) {
  for (; !Ex(e); )
    ;
  return e;
}
const $v = /[\0\t\n\r]/g;
function CO() {
  let e = 1, n = "", r = !0, i;
  return a;
  function a(o, s, l) {
    const d = [];
    let m, u, f, h, v;
    for (o = n + (typeof o == "string" ? o.toString() : new TextDecoder(s || void 0).decode(o)), f = 0, n = "", r && (o.charCodeAt(0) === 65279 && f++, r = void 0); f < o.length; ) {
      if ($v.lastIndex = f, m = $v.exec(o), h = m && m.index !== void 0 ? m.index : o.length, v = o.charCodeAt(h), !m) {
        n = o.slice(f);
        break;
      }
      if (v === 10 && f === h && i)
        d.push(-3), i = void 0;
      else
        switch (i && (d.push(-5), i = void 0), f < h && (d.push(o.slice(f, h)), e += h - f), v) {
          case 0: {
            d.push(65533), e++;
            break;
          }
          case 9: {
            for (u = Math.ceil(e / 4) * 4, d.push(-2); e++ < u; ) d.push(-1);
            break;
          }
          case 10: {
            d.push(-4), e = 1;
            break;
          }
          default:
            i = !0, e = 1;
        }
      f = h + 1;
    }
    return l && (i && d.push(-5), n && d.push(n), d.push(null)), d;
  }
}
const FO = /\\([!-/:-@[-`{-~])|&(#(?:\d{1,7}|x[\da-f]{1,6})|[\da-z]{1,31});/gi;
function IO(e) {
  return e.replace(FO, EO);
}
function EO(e, n, r) {
  if (n)
    return n;
  if (r.charCodeAt(0) === 35) {
    const a = r.charCodeAt(1), o = a === 120 || a === 88;
    return wx(r.slice(o ? 2 : 1), o ? 16 : 10);
  }
  return Ip(r) || e;
}
const Px = {}.hasOwnProperty;
function TO(e, n, r) {
  return typeof n != "string" && (r = n, n = void 0), $O(r)(wO(jO(r).document().write(CO()(e, n, !0))));
}
function $O(e) {
  const n = {
    transforms: [],
    canContainEols: ["emphasis", "fragment", "heading", "paragraph", "strong"],
    enter: {
      autolink: o(Re),
      autolinkProtocol: J,
      autolinkEmail: J,
      atxHeading: o(de),
      blockQuote: o($e),
      characterEscape: J,
      characterReference: J,
      codeFenced: o(tn),
      codeFencedFenceInfo: s,
      codeFencedFenceMeta: s,
      codeIndented: o(tn, s),
      codeText: o(Ie, s),
      codeTextData: J,
      data: J,
      codeFlowValue: J,
      definition: o(We),
      definitionDestinationString: s,
      definitionLabelString: s,
      definitionTitleString: s,
      emphasis: o(Ze),
      hardBreakEscape: o(fe),
      hardBreakTrailing: o(fe),
      htmlFlow: o(Te, s),
      htmlFlowData: J,
      htmlText: o(Te, s),
      htmlTextData: J,
      image: o(Le),
      label: s,
      link: o(Re),
      listItem: o(w),
      listItemValue: h,
      listOrdered: o(sn, f),
      listUnordered: o(sn),
      paragraph: o(_),
      reference: K,
      referenceString: s,
      resourceDestinationString: s,
      resourceTitleString: s,
      setextHeading: o(de),
      strong: o($),
      thematicBreak: o(Y)
    },
    exit: {
      atxHeading: d(),
      atxHeadingSequence: E,
      autolink: d(),
      autolinkEmail: Ae,
      autolinkProtocol: Fe,
      blockQuote: d(),
      characterEscapeValue: ae,
      characterReferenceMarkerHexadecimal: Be,
      characterReferenceMarkerNumeric: Be,
      characterReferenceValue: Pe,
      characterReference: Me,
      codeFenced: d(j),
      codeFencedFence: S,
      codeFencedFenceInfo: v,
      codeFencedFenceMeta: C,
      codeFlowValue: ae,
      codeIndented: d(F),
      codeText: d(Z),
      codeTextData: ae,
      data: ae,
      definition: d(),
      definitionDestinationString: T,
      definitionLabelString: y,
      definitionTitleString: q,
      emphasis: d(),
      hardBreakEscape: d(U),
      hardBreakTrailing: d(U),
      htmlFlow: d(O),
      htmlFlowData: ae,
      htmlText: d(H),
      htmlTextData: ae,
      image: d(ce),
      label: ue,
      labelText: le,
      lineEnding: Q,
      link: d(ye),
      listItem: d(),
      listOrdered: d(),
      listUnordered: d(),
      paragraph: d(),
      referenceString: qe,
      resourceDestinationString: W,
      resourceTitleString: ke,
      resource: Ee,
      setextHeading: d(ee),
      setextHeadingLineSequence: B,
      setextHeadingText: D,
      strong: d(),
      thematicBreak: d()
    }
  };
  Ax(n, (e || {}).mdastExtensions || []);
  const r = {};
  return i;
  function i(R) {
    let z = {
      type: "root",
      children: []
    };
    const ie = {
      stack: [z],
      tokenStack: [],
      config: n,
      enter: l,
      exit: m,
      buffer: s,
      resume: u,
      data: r
    }, pe = [];
    let _e = -1;
    for (; ++_e < R.length; )
      if (R[_e][1].type === "listOrdered" || R[_e][1].type === "listUnordered")
        if (R[_e][0] === "enter")
          pe.push(_e);
        else {
          const en = pe.pop();
          _e = a(R, en, _e);
        }
    for (_e = -1; ++_e < R.length; ) {
      const en = n[R[_e][0]];
      Px.call(en, R[_e][1].type) && en[R[_e][1].type].call(Object.assign({
        sliceSerialize: R[_e][2].sliceSerialize
      }, ie), R[_e][1]);
    }
    if (ie.tokenStack.length > 0) {
      const en = ie.tokenStack[ie.tokenStack.length - 1];
      (en[1] || Dv).call(ie, void 0, en[0]);
    }
    for (z.position = {
      start: Gr(R.length > 0 ? R[0][1].start : {
        line: 1,
        column: 1,
        offset: 0
      }),
      end: Gr(R.length > 0 ? R[R.length - 2][1].end : {
        line: 1,
        column: 1,
        offset: 0
      })
    }, _e = -1; ++_e < n.transforms.length; )
      z = n.transforms[_e](z) || z;
    return z;
  }
  function a(R, z, ie) {
    let pe = z - 1, _e = -1, en = !1, un, rn, dn, pn;
    for (; ++pe <= ie; ) {
      const ln = R[pe];
      switch (ln[1].type) {
        case "listUnordered":
        case "listOrdered":
        case "blockQuote": {
          ln[0] === "enter" ? _e++ : _e--, pn = void 0;
          break;
        }
        case "lineEndingBlank": {
          ln[0] === "enter" && (un && !pn && !_e && !dn && (dn = pe), pn = void 0);
          break;
        }
        case "linePrefix":
        case "listItemValue":
        case "listItemMarker":
        case "listItemPrefix":
        case "listItemPrefixWhitespace":
          break;
        default:
          pn = void 0;
      }
      if (!_e && ln[0] === "enter" && ln[1].type === "listItemPrefix" || _e === -1 && ln[0] === "exit" && (ln[1].type === "listUnordered" || ln[1].type === "listOrdered")) {
        if (un) {
          let kn = pe;
          for (rn = void 0; kn--; ) {
            const Xe = R[kn];
            if (Xe[1].type === "lineEnding" || Xe[1].type === "lineEndingBlank") {
              if (Xe[0] === "exit") continue;
              rn && (R[rn][1].type = "lineEndingBlank", en = !0), Xe[1].type = "lineEnding", rn = kn;
            } else if (!(Xe[1].type === "linePrefix" || Xe[1].type === "blockQuotePrefix" || Xe[1].type === "blockQuotePrefixWhitespace" || Xe[1].type === "blockQuoteMarker" || Xe[1].type === "listItemIndent")) break;
          }
          dn && (!rn || dn < rn) && (un._spread = !0), un.end = Object.assign({}, rn ? R[rn][1].start : ln[1].end), R.splice(rn || pe, 0, ["exit", un, ln[2]]), pe++, ie++;
        }
        if (ln[1].type === "listItemPrefix") {
          const kn = {
            type: "listItem",
            _spread: !1,
            start: Object.assign({}, ln[1].start),
            // @ts-expect-error: we’ll add `end` in a second.
            end: void 0
          };
          un = kn, R.splice(pe, 0, ["enter", kn, ln[2]]), pe++, ie++, dn = void 0, pn = !0;
        }
      }
    }
    return R[z][1]._spread = en, ie;
  }
  function o(R, z) {
    return ie;
    function ie(pe) {
      l.call(this, R(pe), pe), z && z.call(this, pe);
    }
  }
  function s() {
    this.stack.push({
      type: "fragment",
      children: []
    });
  }
  function l(R, z, ie) {
    this.stack[this.stack.length - 1].children.push(R), this.stack.push(R), this.tokenStack.push([z, ie || void 0]), R.position = {
      start: Gr(z.start),
      // @ts-expect-error: `end` will be patched later.
      end: void 0
    };
  }
  function d(R) {
    return z;
    function z(ie) {
      R && R.call(this, ie), m.call(this, ie);
    }
  }
  function m(R, z) {
    const ie = this.stack.pop(), pe = this.tokenStack.pop();
    if (pe)
      pe[0].type !== R.type && (z ? z.call(this, R, pe[0]) : (pe[1] || Dv).call(this, R, pe[0]));
    else throw new Error("Cannot close `" + R.type + "` (" + qa({
      start: R.start,
      end: R.end
    }) + "): it’s not open");
    ie.position.end = Gr(R.end);
  }
  function u() {
    return ED(this.stack.pop());
  }
  function f() {
    this.data.expectingFirstListItemValue = !0;
  }
  function h(R) {
    if (this.data.expectingFirstListItemValue) {
      const z = this.stack[this.stack.length - 2];
      z.start = Number.parseInt(this.sliceSerialize(R), 10), this.data.expectingFirstListItemValue = void 0;
    }
  }
  function v() {
    const R = this.resume(), z = this.stack[this.stack.length - 1];
    z.lang = R;
  }
  function C() {
    const R = this.resume(), z = this.stack[this.stack.length - 1];
    z.meta = R;
  }
  function S() {
    this.data.flowCodeInside || (this.buffer(), this.data.flowCodeInside = !0);
  }
  function j() {
    const R = this.resume(), z = this.stack[this.stack.length - 1];
    z.value = R.replace(/^(\r?\n|\r)|(\r?\n|\r)$/g, ""), this.data.flowCodeInside = void 0;
  }
  function F() {
    const R = this.resume(), z = this.stack[this.stack.length - 1];
    z.value = R.replace(/(\r?\n|\r)$/g, "");
  }
  function y(R) {
    const z = this.resume(), ie = this.stack[this.stack.length - 1];
    ie.label = z, ie.identifier = zi(this.sliceSerialize(R)).toLowerCase();
  }
  function q() {
    const R = this.resume(), z = this.stack[this.stack.length - 1];
    z.title = R;
  }
  function T() {
    const R = this.resume(), z = this.stack[this.stack.length - 1];
    z.url = R;
  }
  function E(R) {
    const z = this.stack[this.stack.length - 1];
    if (!z.depth) {
      const ie = this.sliceSerialize(R).length;
      z.depth = ie;
    }
  }
  function D() {
    this.data.setextHeadingSlurpLineEnding = !0;
  }
  function B(R) {
    const z = this.stack[this.stack.length - 1];
    z.depth = this.sliceSerialize(R).codePointAt(0) === 61 ? 1 : 2;
  }
  function ee() {
    this.data.setextHeadingSlurpLineEnding = void 0;
  }
  function J(R) {
    const ie = this.stack[this.stack.length - 1].children;
    let pe = ie[ie.length - 1];
    (!pe || pe.type !== "text") && (pe = G(), pe.position = {
      start: Gr(R.start),
      // @ts-expect-error: we’ll add `end` later.
      end: void 0
    }, ie.push(pe)), this.stack.push(pe);
  }
  function ae(R) {
    const z = this.stack.pop();
    z.value += this.sliceSerialize(R), z.position.end = Gr(R.end);
  }
  function Q(R) {
    const z = this.stack[this.stack.length - 1];
    if (this.data.atHardBreak) {
      const ie = z.children[z.children.length - 1];
      ie.position.end = Gr(R.end), this.data.atHardBreak = void 0;
      return;
    }
    !this.data.setextHeadingSlurpLineEnding && n.canContainEols.includes(z.type) && (J.call(this, R), ae.call(this, R));
  }
  function U() {
    this.data.atHardBreak = !0;
  }
  function O() {
    const R = this.resume(), z = this.stack[this.stack.length - 1];
    z.value = R;
  }
  function H() {
    const R = this.resume(), z = this.stack[this.stack.length - 1];
    z.value = R;
  }
  function Z() {
    const R = this.resume(), z = this.stack[this.stack.length - 1];
    z.value = R;
  }
  function ye() {
    const R = this.stack[this.stack.length - 1];
    if (this.data.inReference) {
      const z = this.data.referenceType || "shortcut";
      R.type += "Reference", R.referenceType = z, delete R.url, delete R.title;
    } else
      delete R.identifier, delete R.label;
    this.data.referenceType = void 0;
  }
  function ce() {
    const R = this.stack[this.stack.length - 1];
    if (this.data.inReference) {
      const z = this.data.referenceType || "shortcut";
      R.type += "Reference", R.referenceType = z, delete R.url, delete R.title;
    } else
      delete R.identifier, delete R.label;
    this.data.referenceType = void 0;
  }
  function le(R) {
    const z = this.sliceSerialize(R), ie = this.stack[this.stack.length - 2];
    ie.label = IO(z), ie.identifier = zi(z).toLowerCase();
  }
  function ue() {
    const R = this.stack[this.stack.length - 1], z = this.resume(), ie = this.stack[this.stack.length - 1];
    if (this.data.inReference = !0, ie.type === "link") {
      const pe = R.children;
      ie.children = pe;
    } else
      ie.alt = z;
  }
  function W() {
    const R = this.resume(), z = this.stack[this.stack.length - 1];
    z.url = R;
  }
  function ke() {
    const R = this.resume(), z = this.stack[this.stack.length - 1];
    z.title = R;
  }
  function Ee() {
    this.data.inReference = void 0;
  }
  function K() {
    this.data.referenceType = "collapsed";
  }
  function qe(R) {
    const z = this.resume(), ie = this.stack[this.stack.length - 1];
    ie.label = z, ie.identifier = zi(this.sliceSerialize(R)).toLowerCase(), this.data.referenceType = "full";
  }
  function Be(R) {
    this.data.characterReferenceType = R.type;
  }
  function Pe(R) {
    const z = this.sliceSerialize(R), ie = this.data.characterReferenceType;
    let pe;
    ie ? (pe = wx(z, ie === "characterReferenceMarkerNumeric" ? 10 : 16), this.data.characterReferenceType = void 0) : pe = Ip(z);
    const _e = this.stack[this.stack.length - 1];
    _e.value += pe;
  }
  function Me(R) {
    const z = this.stack.pop();
    z.position.end = Gr(R.end);
  }
  function Fe(R) {
    ae.call(this, R);
    const z = this.stack[this.stack.length - 1];
    z.url = this.sliceSerialize(R);
  }
  function Ae(R) {
    ae.call(this, R);
    const z = this.stack[this.stack.length - 1];
    z.url = "mailto:" + this.sliceSerialize(R);
  }
  function $e() {
    return {
      type: "blockquote",
      children: []
    };
  }
  function tn() {
    return {
      type: "code",
      lang: null,
      meta: null,
      value: ""
    };
  }
  function Ie() {
    return {
      type: "inlineCode",
      value: ""
    };
  }
  function We() {
    return {
      type: "definition",
      identifier: "",
      label: null,
      title: null,
      url: ""
    };
  }
  function Ze() {
    return {
      type: "emphasis",
      children: []
    };
  }
  function de() {
    return {
      type: "heading",
      // @ts-expect-error `depth` will be set later.
      depth: 0,
      children: []
    };
  }
  function fe() {
    return {
      type: "break"
    };
  }
  function Te() {
    return {
      type: "html",
      value: ""
    };
  }
  function Le() {
    return {
      type: "image",
      title: null,
      url: "",
      alt: null
    };
  }
  function Re() {
    return {
      type: "link",
      title: null,
      url: "",
      children: []
    };
  }
  function sn(R) {
    return {
      type: "list",
      ordered: R.type === "listOrdered",
      start: null,
      spread: R._spread,
      children: []
    };
  }
  function w(R) {
    return {
      type: "listItem",
      spread: R._spread,
      checked: null,
      children: []
    };
  }
  function _() {
    return {
      type: "paragraph",
      children: []
    };
  }
  function $() {
    return {
      type: "strong",
      children: []
    };
  }
  function G() {
    return {
      type: "text",
      value: ""
    };
  }
  function Y() {
    return {
      type: "thematicBreak"
    };
  }
}
function Gr(e) {
  return {
    line: e.line,
    column: e.column,
    offset: e.offset
  };
}
function Ax(e, n) {
  let r = -1;
  for (; ++r < n.length; ) {
    const i = n[r];
    Array.isArray(i) ? Ax(e, i) : DO(e, i);
  }
}
function DO(e, n) {
  let r;
  for (r in n)
    if (Px.call(n, r))
      switch (r) {
        case "canContainEols": {
          const i = n[r];
          i && e[r].push(...i);
          break;
        }
        case "transforms": {
          const i = n[r];
          i && e[r].push(...i);
          break;
        }
        case "enter":
        case "exit": {
          const i = n[r];
          i && Object.assign(e[r], i);
          break;
        }
      }
}
function Dv(e, n) {
  throw e ? new Error("Cannot close `" + e.type + "` (" + qa({
    start: e.start,
    end: e.end
  }) + "): a different token (`" + n.type + "`, " + qa({
    start: n.start,
    end: n.end
  }) + ") is open") : new Error("Cannot close document, a token (`" + n.type + "`, " + qa({
    start: n.start,
    end: n.end
  }) + ") is still open");
}
function RO(e) {
  const n = this;
  n.parser = r;
  function r(i) {
    return TO(i, {
      ...n.data("settings"),
      ...e,
      // Note: these options are not in the readme.
      // The goal is for them to be set by plugins on `data` instead of being
      // passed by users.
      extensions: n.data("micromarkExtensions") || [],
      mdastExtensions: n.data("fromMarkdownExtensions") || []
    });
  }
}
function OO(e, n) {
  const r = {
    type: "element",
    tagName: "blockquote",
    properties: {},
    children: e.wrap(e.all(n), !0)
  };
  return e.patch(n, r), e.applyData(n, r);
}
function PO(e, n) {
  const r = { type: "element", tagName: "br", properties: {}, children: [] };
  return e.patch(n, r), [e.applyData(n, r), { type: "text", value: `
` }];
}
function AO(e, n) {
  const r = n.value ? n.value + `
` : "", i = {}, a = n.lang ? n.lang.split(/\s+/) : [];
  a.length > 0 && (i.className = ["language-" + a[0]]);
  let o = {
    type: "element",
    tagName: "code",
    properties: i,
    children: [{ type: "text", value: r }]
  };
  return n.meta && (o.data = { meta: n.meta }), e.patch(n, o), o = e.applyData(n, o), o = { type: "element", tagName: "pre", properties: {}, children: [o] }, e.patch(n, o), o;
}
function LO(e, n) {
  const r = {
    type: "element",
    tagName: "del",
    properties: {},
    children: e.all(n)
  };
  return e.patch(n, r), e.applyData(n, r);
}
function VO(e, n) {
  const r = {
    type: "element",
    tagName: "em",
    properties: {},
    children: e.all(n)
  };
  return e.patch(n, r), e.applyData(n, r);
}
function zO(e, n) {
  const r = typeof e.options.clobberPrefix == "string" ? e.options.clobberPrefix : "user-content-", i = String(n.identifier).toUpperCase(), a = Zi(i.toLowerCase()), o = e.footnoteOrder.indexOf(i);
  let s, l = e.footnoteCounts.get(i);
  l === void 0 ? (l = 0, e.footnoteOrder.push(i), s = e.footnoteOrder.length) : s = o + 1, l += 1, e.footnoteCounts.set(i, l);
  const d = {
    type: "element",
    tagName: "a",
    properties: {
      href: "#" + r + "fn-" + a,
      id: r + "fnref-" + a + (l > 1 ? "-" + l : ""),
      dataFootnoteRef: !0,
      ariaDescribedBy: ["footnote-label"]
    },
    children: [{ type: "text", value: String(s) }]
  };
  e.patch(n, d);
  const m = {
    type: "element",
    tagName: "sup",
    properties: {},
    children: [d]
  };
  return e.patch(n, m), e.applyData(n, m);
}
function UO(e, n) {
  const r = {
    type: "element",
    tagName: "h" + n.depth,
    properties: {},
    children: e.all(n)
  };
  return e.patch(n, r), e.applyData(n, r);
}
function MO(e, n) {
  if (e.options.allowDangerousHtml) {
    const r = { type: "raw", value: n.value };
    return e.patch(n, r), e.applyData(n, r);
  }
}
function Lx(e, n) {
  const r = n.referenceType;
  let i = "]";
  if (r === "collapsed" ? i += "[]" : r === "full" && (i += "[" + (n.label || n.identifier) + "]"), n.type === "imageReference")
    return [{ type: "text", value: "![" + n.alt + i }];
  const a = e.all(n), o = a[0];
  o && o.type === "text" ? o.value = "[" + o.value : a.unshift({ type: "text", value: "[" });
  const s = a[a.length - 1];
  return s && s.type === "text" ? s.value += i : a.push({ type: "text", value: i }), a;
}
function BO(e, n) {
  const r = String(n.identifier).toUpperCase(), i = e.definitionById.get(r);
  if (!i)
    return Lx(e, n);
  const a = { src: Zi(i.url || ""), alt: n.alt };
  i.title !== null && i.title !== void 0 && (a.title = i.title);
  const o = { type: "element", tagName: "img", properties: a, children: [] };
  return e.patch(n, o), e.applyData(n, o);
}
function qO(e, n) {
  const r = { src: Zi(n.url) };
  n.alt !== null && n.alt !== void 0 && (r.alt = n.alt), n.title !== null && n.title !== void 0 && (r.title = n.title);
  const i = { type: "element", tagName: "img", properties: r, children: [] };
  return e.patch(n, i), e.applyData(n, i);
}
function HO(e, n) {
  const r = { type: "text", value: n.value.replace(/\r?\n|\r/g, " ") };
  e.patch(n, r);
  const i = {
    type: "element",
    tagName: "code",
    properties: {},
    children: [r]
  };
  return e.patch(n, i), e.applyData(n, i);
}
function WO(e, n) {
  const r = String(n.identifier).toUpperCase(), i = e.definitionById.get(r);
  if (!i)
    return Lx(e, n);
  const a = { href: Zi(i.url || "") };
  i.title !== null && i.title !== void 0 && (a.title = i.title);
  const o = {
    type: "element",
    tagName: "a",
    properties: a,
    children: e.all(n)
  };
  return e.patch(n, o), e.applyData(n, o);
}
function KO(e, n) {
  const r = { href: Zi(n.url) };
  n.title !== null && n.title !== void 0 && (r.title = n.title);
  const i = {
    type: "element",
    tagName: "a",
    properties: r,
    children: e.all(n)
  };
  return e.patch(n, i), e.applyData(n, i);
}
function GO(e, n, r) {
  const i = e.all(n), a = r ? YO(r) : Vx(n), o = {}, s = [];
  if (typeof n.checked == "boolean") {
    const u = i[0];
    let f;
    u && u.type === "element" && u.tagName === "p" ? f = u : (f = { type: "element", tagName: "p", properties: {}, children: [] }, i.unshift(f)), f.children.length > 0 && f.children.unshift({ type: "text", value: " " }), f.children.unshift({
      type: "element",
      tagName: "input",
      properties: { type: "checkbox", checked: n.checked, disabled: !0 },
      children: []
    }), o.className = ["task-list-item"];
  }
  let l = -1;
  for (; ++l < i.length; ) {
    const u = i[l];
    (a || l !== 0 || u.type !== "element" || u.tagName !== "p") && s.push({ type: "text", value: `
` }), u.type === "element" && u.tagName === "p" && !a ? s.push(...u.children) : s.push(u);
  }
  const d = i[i.length - 1];
  d && (a || d.type !== "element" || d.tagName !== "p") && s.push({ type: "text", value: `
` });
  const m = { type: "element", tagName: "li", properties: o, children: s };
  return e.patch(n, m), e.applyData(n, m);
}
function YO(e) {
  let n = !1;
  if (e.type === "list") {
    n = e.spread || !1;
    const r = e.children;
    let i = -1;
    for (; !n && ++i < r.length; )
      n = Vx(r[i]);
  }
  return n;
}
function Vx(e) {
  const n = e.spread;
  return n ?? e.children.length > 1;
}
function QO(e, n) {
  const r = {}, i = e.all(n);
  let a = -1;
  for (typeof n.start == "number" && n.start !== 1 && (r.start = n.start); ++a < i.length; ) {
    const s = i[a];
    if (s.type === "element" && s.tagName === "li" && s.properties && Array.isArray(s.properties.className) && s.properties.className.includes("task-list-item")) {
      r.className = ["contains-task-list"];
      break;
    }
  }
  const o = {
    type: "element",
    tagName: n.ordered ? "ol" : "ul",
    properties: r,
    children: e.wrap(i, !0)
  };
  return e.patch(n, o), e.applyData(n, o);
}
function JO(e, n) {
  const r = {
    type: "element",
    tagName: "p",
    properties: {},
    children: e.all(n)
  };
  return e.patch(n, r), e.applyData(n, r);
}
function XO(e, n) {
  const r = { type: "root", children: e.wrap(e.all(n)) };
  return e.patch(n, r), e.applyData(n, r);
}
function ZO(e, n) {
  const r = {
    type: "element",
    tagName: "strong",
    properties: {},
    children: e.all(n)
  };
  return e.patch(n, r), e.applyData(n, r);
}
function eP(e, n) {
  const r = e.all(n), i = r.shift(), a = [];
  if (i) {
    const s = {
      type: "element",
      tagName: "thead",
      properties: {},
      children: e.wrap([i], !0)
    };
    e.patch(n.children[0], s), a.push(s);
  }
  if (r.length > 0) {
    const s = {
      type: "element",
      tagName: "tbody",
      properties: {},
      children: e.wrap(r, !0)
    }, l = jp(n.children[1]), d = kx(n.children[n.children.length - 1]);
    l && d && (s.position = { start: l, end: d }), a.push(s);
  }
  const o = {
    type: "element",
    tagName: "table",
    properties: {},
    children: e.wrap(a, !0)
  };
  return e.patch(n, o), e.applyData(n, o);
}
function nP(e, n, r) {
  const i = r ? r.children : void 0, o = (i ? i.indexOf(n) : 1) === 0 ? "th" : "td", s = r && r.type === "table" ? r.align : void 0, l = s ? s.length : n.children.length;
  let d = -1;
  const m = [];
  for (; ++d < l; ) {
    const f = n.children[d], h = {}, v = s ? s[d] : void 0;
    v && (h.align = v);
    let C = { type: "element", tagName: o, properties: h, children: [] };
    f && (C.children = e.all(f), e.patch(f, C), C = e.applyData(f, C)), m.push(C);
  }
  const u = {
    type: "element",
    tagName: "tr",
    properties: {},
    children: e.wrap(m, !0)
  };
  return e.patch(n, u), e.applyData(n, u);
}
function tP(e, n) {
  const r = {
    type: "element",
    tagName: "td",
    // Assume body cell.
    properties: {},
    children: e.all(n)
  };
  return e.patch(n, r), e.applyData(n, r);
}
const Rv = 9, Ov = 32;
function rP(e) {
  const n = String(e), r = /\r?\n|\r/g;
  let i = r.exec(n), a = 0;
  const o = [];
  for (; i; )
    o.push(
      Pv(n.slice(a, i.index), a > 0, !0),
      i[0]
    ), a = i.index + i[0].length, i = r.exec(n);
  return o.push(Pv(n.slice(a), a > 0, !1)), o.join("");
}
function Pv(e, n, r) {
  let i = 0, a = e.length;
  if (n) {
    let o = e.codePointAt(i);
    for (; o === Rv || o === Ov; )
      i++, o = e.codePointAt(i);
  }
  if (r) {
    let o = e.codePointAt(a - 1);
    for (; o === Rv || o === Ov; )
      a--, o = e.codePointAt(a - 1);
  }
  return a > i ? e.slice(i, a) : "";
}
function iP(e, n) {
  const r = { type: "text", value: rP(String(n.value)) };
  return e.patch(n, r), e.applyData(n, r);
}
function aP(e, n) {
  const r = {
    type: "element",
    tagName: "hr",
    properties: {},
    children: []
  };
  return e.patch(n, r), e.applyData(n, r);
}
const oP = {
  blockquote: OO,
  break: PO,
  code: AO,
  delete: LO,
  emphasis: VO,
  footnoteReference: zO,
  heading: UO,
  html: MO,
  imageReference: BO,
  image: qO,
  inlineCode: HO,
  linkReference: WO,
  link: KO,
  listItem: GO,
  list: QO,
  paragraph: JO,
  // @ts-expect-error: root is different, but hard to type.
  root: XO,
  strong: ZO,
  table: eP,
  tableCell: tP,
  tableRow: nP,
  text: iP,
  thematicBreak: aP,
  toml: Io,
  yaml: Io,
  definition: Io,
  footnoteDefinition: Io
};
function Io() {
}
const zx = -1, Js = 0, bs = 1, _s = 2, $p = 3, Dp = 4, Rp = 5, Op = 6, Ux = 7, Mx = 8, Av = typeof self == "object" ? self : globalThis, sP = (e, n) => {
  const r = (a, o) => (e.set(o, a), a), i = (a) => {
    if (e.has(a))
      return e.get(a);
    const [o, s] = n[a];
    switch (o) {
      case Js:
      case zx:
        return r(s, a);
      case bs: {
        const l = r([], a);
        for (const d of s)
          l.push(i(d));
        return l;
      }
      case _s: {
        const l = r({}, a);
        for (const [d, m] of s)
          l[i(d)] = i(m);
        return l;
      }
      case $p:
        return r(new Date(s), a);
      case Dp: {
        const { source: l, flags: d } = s;
        return r(new RegExp(l, d), a);
      }
      case Rp: {
        const l = r(/* @__PURE__ */ new Map(), a);
        for (const [d, m] of s)
          l.set(i(d), i(m));
        return l;
      }
      case Op: {
        const l = r(/* @__PURE__ */ new Set(), a);
        for (const d of s)
          l.add(i(d));
        return l;
      }
      case Ux: {
        const { name: l, message: d } = s;
        return r(new Av[l](d), a);
      }
      case Mx:
        return r(BigInt(s), a);
      case "BigInt":
        return r(Object(BigInt(s)), a);
    }
    return r(new Av[o](s), a);
  };
  return i;
}, Lv = (e) => sP(/* @__PURE__ */ new Map(), e)(0), Fi = "", { toString: lP } = {}, { keys: cP } = Object, ga = (e) => {
  const n = typeof e;
  if (n !== "object" || !e)
    return [Js, n];
  const r = lP.call(e).slice(8, -1);
  switch (r) {
    case "Array":
      return [bs, Fi];
    case "Object":
      return [_s, Fi];
    case "Date":
      return [$p, Fi];
    case "RegExp":
      return [Dp, Fi];
    case "Map":
      return [Rp, Fi];
    case "Set":
      return [Op, Fi];
  }
  return r.includes("Array") ? [bs, r] : r.includes("Error") ? [Ux, r] : [_s, r];
}, Eo = ([e, n]) => e === Js && (n === "function" || n === "symbol"), dP = (e, n, r, i) => {
  const a = (s, l) => {
    const d = i.push(s) - 1;
    return r.set(l, d), d;
  }, o = (s) => {
    if (r.has(s))
      return r.get(s);
    let [l, d] = ga(s);
    switch (l) {
      case Js: {
        let u = s;
        switch (d) {
          case "bigint":
            l = Mx, u = s.toString();
            break;
          case "function":
          case "symbol":
            if (e)
              throw new TypeError("unable to serialize " + d);
            u = null;
            break;
          case "undefined":
            return a([zx], s);
        }
        return a([l, u], s);
      }
      case bs: {
        if (d)
          return a([d, [...s]], s);
        const u = [], f = a([l, u], s);
        for (const h of s)
          u.push(o(h));
        return f;
      }
      case _s: {
        if (d)
          switch (d) {
            case "BigInt":
              return a([d, s.toString()], s);
            case "Boolean":
            case "Number":
            case "String":
              return a([d, s.valueOf()], s);
          }
        if (n && "toJSON" in s)
          return o(s.toJSON());
        const u = [], f = a([l, u], s);
        for (const h of cP(s))
          (e || !Eo(ga(s[h]))) && u.push([o(h), o(s[h])]);
        return f;
      }
      case $p:
        return a([l, s.toISOString()], s);
      case Dp: {
        const { source: u, flags: f } = s;
        return a([l, { source: u, flags: f }], s);
      }
      case Rp: {
        const u = [], f = a([l, u], s);
        for (const [h, v] of s)
          (e || !(Eo(ga(h)) || Eo(ga(v)))) && u.push([o(h), o(v)]);
        return f;
      }
      case Op: {
        const u = [], f = a([l, u], s);
        for (const h of s)
          (e || !Eo(ga(h))) && u.push(o(h));
        return f;
      }
    }
    const { message: m } = s;
    return a([l, { name: d, message: m }], s);
  };
  return o;
}, Vv = (e, { json: n, lossy: r } = {}) => {
  const i = [];
  return dP(!(n || r), !!n, /* @__PURE__ */ new Map(), i)(e), i;
}, xs = typeof structuredClone == "function" ? (
  /* c8 ignore start */
  (e, n) => n && ("json" in n || "lossy" in n) ? Lv(Vv(e, n)) : structuredClone(e)
) : (e, n) => Lv(Vv(e, n));
function uP(e, n) {
  const r = [{ type: "text", value: "↩" }];
  return n > 1 && r.push({
    type: "element",
    tagName: "sup",
    properties: {},
    children: [{ type: "text", value: String(n) }]
  }), r;
}
function mP(e, n) {
  return "Back to reference " + (e + 1) + (n > 1 ? "-" + n : "");
}
function pP(e) {
  const n = typeof e.options.clobberPrefix == "string" ? e.options.clobberPrefix : "user-content-", r = e.options.footnoteBackContent || uP, i = e.options.footnoteBackLabel || mP, a = e.options.footnoteLabel || "Footnotes", o = e.options.footnoteLabelTagName || "h2", s = e.options.footnoteLabelProperties || {
    className: ["sr-only"]
  }, l = [];
  let d = -1;
  for (; ++d < e.footnoteOrder.length; ) {
    const m = e.footnoteById.get(
      e.footnoteOrder[d]
    );
    if (!m)
      continue;
    const u = e.all(m), f = String(m.identifier).toUpperCase(), h = Zi(f.toLowerCase());
    let v = 0;
    const C = [], S = e.footnoteCounts.get(f);
    for (; S !== void 0 && ++v <= S; ) {
      C.length > 0 && C.push({ type: "text", value: " " });
      let y = typeof r == "string" ? r : r(d, v);
      typeof y == "string" && (y = { type: "text", value: y }), C.push({
        type: "element",
        tagName: "a",
        properties: {
          href: "#" + n + "fnref-" + h + (v > 1 ? "-" + v : ""),
          dataFootnoteBackref: "",
          ariaLabel: typeof i == "string" ? i : i(d, v),
          className: ["data-footnote-backref"]
        },
        children: Array.isArray(y) ? y : [y]
      });
    }
    const j = u[u.length - 1];
    if (j && j.type === "element" && j.tagName === "p") {
      const y = j.children[j.children.length - 1];
      y && y.type === "text" ? y.value += " " : j.children.push({ type: "text", value: " " }), j.children.push(...C);
    } else
      u.push(...C);
    const F = {
      type: "element",
      tagName: "li",
      properties: { id: n + "fn-" + h },
      children: e.wrap(u, !0)
    };
    e.patch(m, F), l.push(F);
  }
  if (l.length !== 0)
    return {
      type: "element",
      tagName: "section",
      properties: { dataFootnotes: !0, className: ["footnotes"] },
      children: [
        {
          type: "element",
          tagName: o,
          properties: {
            ...xs(s),
            id: "footnote-label"
          },
          children: [{ type: "text", value: a }]
        },
        { type: "text", value: `
` },
        {
          type: "element",
          tagName: "ol",
          properties: {},
          children: e.wrap(l, !0)
        },
        { type: "text", value: `
` }
      ]
    };
}
const Bx = (
  // Note: overloads in JSDoc can’t yet use different `@template`s.
  /**
   * @type {(
   *   (<Condition extends string>(test: Condition) => (node: unknown, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node & {type: Condition}) &
   *   (<Condition extends Props>(test: Condition) => (node: unknown, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node & Condition) &
   *   (<Condition extends TestFunction>(test: Condition) => (node: unknown, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node & Predicate<Condition, Node>) &
   *   ((test?: null | undefined) => (node?: unknown, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node) &
   *   ((test?: Test) => Check)
   * )}
   */
  /**
   * @param {Test} [test]
   * @returns {Check}
   */
  (function(e) {
    if (e == null)
      return gP;
    if (typeof e == "function")
      return Xs(e);
    if (typeof e == "object")
      return Array.isArray(e) ? fP(e) : hP(e);
    if (typeof e == "string")
      return yP(e);
    throw new Error("Expected function, string, or object as test");
  })
);
function fP(e) {
  const n = [];
  let r = -1;
  for (; ++r < e.length; )
    n[r] = Bx(e[r]);
  return Xs(i);
  function i(...a) {
    let o = -1;
    for (; ++o < n.length; )
      if (n[o].apply(this, a)) return !0;
    return !1;
  }
}
function hP(e) {
  const n = (
    /** @type {Record<string, unknown>} */
    e
  );
  return Xs(r);
  function r(i) {
    const a = (
      /** @type {Record<string, unknown>} */
      /** @type {unknown} */
      i
    );
    let o;
    for (o in e)
      if (a[o] !== n[o]) return !1;
    return !0;
  }
}
function yP(e) {
  return Xs(n);
  function n(r) {
    return r && r.type === e;
  }
}
function Xs(e) {
  return n;
  function n(r, i, a) {
    return !!(vP(r) && e.call(
      this,
      r,
      typeof i == "number" ? i : void 0,
      a || void 0
    ));
  }
}
function gP() {
  return !0;
}
function vP(e) {
  return e !== null && typeof e == "object" && "type" in e;
}
const qx = [], kP = !0, zv = !1, bP = "skip";
function _P(e, n, r, i) {
  let a;
  typeof n == "function" && typeof r != "function" ? (i = r, r = n) : a = n;
  const o = Bx(a), s = i ? -1 : 1;
  l(e, void 0, [])();
  function l(d, m, u) {
    const f = (
      /** @type {Record<string, unknown>} */
      d && typeof d == "object" ? d : {}
    );
    if (typeof f.type == "string") {
      const v = (
        // `hast`
        typeof f.tagName == "string" ? f.tagName : (
          // `xast`
          typeof f.name == "string" ? f.name : void 0
        )
      );
      Object.defineProperty(h, "name", {
        value: "node (" + (d.type + (v ? "<" + v + ">" : "")) + ")"
      });
    }
    return h;
    function h() {
      let v = qx, C, S, j;
      if ((!n || o(d, m, u[u.length - 1] || void 0)) && (v = xP(r(d, u)), v[0] === zv))
        return v;
      if ("children" in d && d.children) {
        const F = (
          /** @type {UnistParent} */
          d
        );
        if (F.children && v[0] !== bP)
          for (S = (i ? F.children.length : -1) + s, j = u.concat(F); S > -1 && S < F.children.length; ) {
            const y = F.children[S];
            if (C = l(y, S, j)(), C[0] === zv)
              return C;
            S = typeof C[1] == "number" ? C[1] : S + s;
          }
      }
      return v;
    }
  }
}
function xP(e) {
  return Array.isArray(e) ? e : typeof e == "number" ? [kP, e] : e == null ? qx : [e];
}
function Hx(e, n, r, i) {
  let a, o, s;
  typeof n == "function" && typeof r != "function" ? (o = void 0, s = n, a = r) : (o = n, s = r, a = i), _P(e, o, l, a);
  function l(d, m) {
    const u = m[m.length - 1], f = u ? u.children.indexOf(d) : void 0;
    return s(d, f, u);
  }
}
const fm = {}.hasOwnProperty, SP = {};
function NP(e, n) {
  const r = n || SP, i = /* @__PURE__ */ new Map(), a = /* @__PURE__ */ new Map(), o = /* @__PURE__ */ new Map(), s = { ...oP, ...r.handlers }, l = {
    all: m,
    applyData: wP,
    definitionById: i,
    footnoteById: a,
    footnoteCounts: o,
    footnoteOrder: [],
    handlers: s,
    one: d,
    options: r,
    patch: jP,
    wrap: FP
  };
  return Hx(e, function(u) {
    if (u.type === "definition" || u.type === "footnoteDefinition") {
      const f = u.type === "definition" ? i : a, h = String(u.identifier).toUpperCase();
      f.has(h) || f.set(h, u);
    }
  }), l;
  function d(u, f) {
    const h = u.type, v = l.handlers[h];
    if (fm.call(l.handlers, h) && v)
      return v(l, u, f);
    if (l.options.passThrough && l.options.passThrough.includes(h)) {
      if ("children" in u) {
        const { children: S, ...j } = u, F = xs(j);
        return F.children = l.all(u), F;
      }
      return xs(u);
    }
    return (l.options.unknownHandler || CP)(l, u, f);
  }
  function m(u) {
    const f = [];
    if ("children" in u) {
      const h = u.children;
      let v = -1;
      for (; ++v < h.length; ) {
        const C = l.one(h[v], u);
        if (C) {
          if (v && h[v - 1].type === "break" && (!Array.isArray(C) && C.type === "text" && (C.value = Uv(C.value)), !Array.isArray(C) && C.type === "element")) {
            const S = C.children[0];
            S && S.type === "text" && (S.value = Uv(S.value));
          }
          Array.isArray(C) ? f.push(...C) : f.push(C);
        }
      }
    }
    return f;
  }
}
function jP(e, n) {
  e.position && (n.position = oD(e));
}
function wP(e, n) {
  let r = n;
  if (e && e.data) {
    const i = e.data.hName, a = e.data.hChildren, o = e.data.hProperties;
    if (typeof i == "string")
      if (r.type === "element")
        r.tagName = i;
      else {
        const s = "children" in r ? r.children : [r];
        r = { type: "element", tagName: i, properties: {}, children: s };
      }
    r.type === "element" && o && Object.assign(r.properties, xs(o)), "children" in r && r.children && a !== null && a !== void 0 && (r.children = a);
  }
  return r;
}
function CP(e, n) {
  const r = n.data || {}, i = "value" in n && !(fm.call(r, "hProperties") || fm.call(r, "hChildren")) ? { type: "text", value: n.value } : {
    type: "element",
    tagName: "div",
    properties: {},
    children: e.all(n)
  };
  return e.patch(n, i), e.applyData(n, i);
}
function FP(e, n) {
  const r = [];
  let i = -1;
  for (n && r.push({ type: "text", value: `
` }); ++i < e.length; )
    i && r.push({ type: "text", value: `
` }), r.push(e[i]);
  return n && e.length > 0 && r.push({ type: "text", value: `
` }), r;
}
function Uv(e) {
  let n = 0, r = e.charCodeAt(n);
  for (; r === 9 || r === 32; )
    n++, r = e.charCodeAt(n);
  return e.slice(n);
}
function Mv(e, n) {
  const r = NP(e, n), i = r.one(e, void 0), a = pP(r), o = Array.isArray(i) ? { type: "root", children: i } : i || { type: "root", children: [] };
  return a && o.children.push({ type: "text", value: `
` }, a), o;
}
function IP(e, n) {
  return e && "run" in e ? async function(r, i) {
    const a = (
      /** @type {HastRoot} */
      Mv(r, { file: i, ...n })
    );
    await e.run(a, i);
  } : function(r, i) {
    return (
      /** @type {HastRoot} */
      Mv(r, { file: i, ...e || n })
    );
  };
}
function Bv(e) {
  if (e)
    throw e;
}
var lu, qv;
function EP() {
  if (qv) return lu;
  qv = 1;
  var e = Object.prototype.hasOwnProperty, n = Object.prototype.toString, r = Object.defineProperty, i = Object.getOwnPropertyDescriptor, a = function(m) {
    return typeof Array.isArray == "function" ? Array.isArray(m) : n.call(m) === "[object Array]";
  }, o = function(m) {
    if (!m || n.call(m) !== "[object Object]")
      return !1;
    var u = e.call(m, "constructor"), f = m.constructor && m.constructor.prototype && e.call(m.constructor.prototype, "isPrototypeOf");
    if (m.constructor && !u && !f)
      return !1;
    var h;
    for (h in m)
      ;
    return typeof h > "u" || e.call(m, h);
  }, s = function(m, u) {
    r && u.name === "__proto__" ? r(m, u.name, {
      enumerable: !0,
      configurable: !0,
      value: u.newValue,
      writable: !0
    }) : m[u.name] = u.newValue;
  }, l = function(m, u) {
    if (u === "__proto__")
      if (e.call(m, u)) {
        if (i)
          return i(m, u).value;
      } else return;
    return m[u];
  };
  return lu = function d() {
    var m, u, f, h, v, C, S = arguments[0], j = 1, F = arguments.length, y = !1;
    for (typeof S == "boolean" && (y = S, S = arguments[1] || {}, j = 2), (S == null || typeof S != "object" && typeof S != "function") && (S = {}); j < F; ++j)
      if (m = arguments[j], m != null)
        for (u in m)
          f = l(S, u), h = l(m, u), S !== h && (y && h && (o(h) || (v = a(h))) ? (v ? (v = !1, C = f && a(f) ? f : []) : C = f && o(f) ? f : {}, s(S, { name: u, newValue: d(y, C, h) })) : typeof h < "u" && s(S, { name: u, newValue: h }));
    return S;
  }, lu;
}
var TP = EP();
const cu = /* @__PURE__ */ Um(TP);
function hm(e) {
  if (typeof e != "object" || e === null)
    return !1;
  const n = Object.getPrototypeOf(e);
  return (n === null || n === Object.prototype || Object.getPrototypeOf(n) === null) && !(Symbol.toStringTag in e) && !(Symbol.iterator in e);
}
function $P() {
  const e = [], n = { run: r, use: i };
  return n;
  function r(...a) {
    let o = -1;
    const s = a.pop();
    if (typeof s != "function")
      throw new TypeError("Expected function as last argument, not " + s);
    l(null, ...a);
    function l(d, ...m) {
      const u = e[++o];
      let f = -1;
      if (d) {
        s(d);
        return;
      }
      for (; ++f < a.length; )
        (m[f] === null || m[f] === void 0) && (m[f] = a[f]);
      a = m, u ? DP(u, l)(...m) : s(null, ...m);
    }
  }
  function i(a) {
    if (typeof a != "function")
      throw new TypeError(
        "Expected `middelware` to be a function, not " + a
      );
    return e.push(a), n;
  }
}
function DP(e, n) {
  let r;
  return i;
  function i(...s) {
    const l = e.length > s.length;
    let d;
    l && s.push(a);
    try {
      d = e.apply(this, s);
    } catch (m) {
      const u = (
        /** @type {Error} */
        m
      );
      if (l && r)
        throw u;
      return a(u);
    }
    l || (d instanceof Promise ? d.then(o, a) : d instanceof Error ? a(d) : o(d));
  }
  function a(s, ...l) {
    r || (r = !0, n(s, ...l));
  }
  function o(s) {
    a(null, s);
  }
}
const Cr = { basename: RP, dirname: OP, extname: PP, join: AP, sep: "/" };
function RP(e, n) {
  if (n !== void 0 && typeof n != "string")
    throw new TypeError('"ext" argument must be a string');
  ho(e);
  let r = 0, i = -1, a = e.length, o;
  if (n === void 0 || n.length === 0 || n.length > e.length) {
    for (; a--; )
      if (e.codePointAt(a) === 47) {
        if (o) {
          r = a + 1;
          break;
        }
      } else i < 0 && (o = !0, i = a + 1);
    return i < 0 ? "" : e.slice(r, i);
  }
  if (n === e)
    return "";
  let s = -1, l = n.length - 1;
  for (; a--; )
    if (e.codePointAt(a) === 47) {
      if (o) {
        r = a + 1;
        break;
      }
    } else
      s < 0 && (o = !0, s = a + 1), l > -1 && (e.codePointAt(a) === n.codePointAt(l--) ? l < 0 && (i = a) : (l = -1, i = s));
  return r === i ? i = s : i < 0 && (i = e.length), e.slice(r, i);
}
function OP(e) {
  if (ho(e), e.length === 0)
    return ".";
  let n = -1, r = e.length, i;
  for (; --r; )
    if (e.codePointAt(r) === 47) {
      if (i) {
        n = r;
        break;
      }
    } else i || (i = !0);
  return n < 0 ? e.codePointAt(0) === 47 ? "/" : "." : n === 1 && e.codePointAt(0) === 47 ? "//" : e.slice(0, n);
}
function PP(e) {
  ho(e);
  let n = e.length, r = -1, i = 0, a = -1, o = 0, s;
  for (; n--; ) {
    const l = e.codePointAt(n);
    if (l === 47) {
      if (s) {
        i = n + 1;
        break;
      }
      continue;
    }
    r < 0 && (s = !0, r = n + 1), l === 46 ? a < 0 ? a = n : o !== 1 && (o = 1) : a > -1 && (o = -1);
  }
  return a < 0 || r < 0 || // We saw a non-dot character immediately before the dot.
  o === 0 || // The (right-most) trimmed path component is exactly `..`.
  o === 1 && a === r - 1 && a === i + 1 ? "" : e.slice(a, r);
}
function AP(...e) {
  let n = -1, r;
  for (; ++n < e.length; )
    ho(e[n]), e[n] && (r = r === void 0 ? e[n] : r + "/" + e[n]);
  return r === void 0 ? "." : LP(r);
}
function LP(e) {
  ho(e);
  const n = e.codePointAt(0) === 47;
  let r = VP(e, !n);
  return r.length === 0 && !n && (r = "."), r.length > 0 && e.codePointAt(e.length - 1) === 47 && (r += "/"), n ? "/" + r : r;
}
function VP(e, n) {
  let r = "", i = 0, a = -1, o = 0, s = -1, l, d;
  for (; ++s <= e.length; ) {
    if (s < e.length)
      l = e.codePointAt(s);
    else {
      if (l === 47)
        break;
      l = 47;
    }
    if (l === 47) {
      if (!(a === s - 1 || o === 1)) if (a !== s - 1 && o === 2) {
        if (r.length < 2 || i !== 2 || r.codePointAt(r.length - 1) !== 46 || r.codePointAt(r.length - 2) !== 46) {
          if (r.length > 2) {
            if (d = r.lastIndexOf("/"), d !== r.length - 1) {
              d < 0 ? (r = "", i = 0) : (r = r.slice(0, d), i = r.length - 1 - r.lastIndexOf("/")), a = s, o = 0;
              continue;
            }
          } else if (r.length > 0) {
            r = "", i = 0, a = s, o = 0;
            continue;
          }
        }
        n && (r = r.length > 0 ? r + "/.." : "..", i = 2);
      } else
        r.length > 0 ? r += "/" + e.slice(a + 1, s) : r = e.slice(a + 1, s), i = s - a - 1;
      a = s, o = 0;
    } else l === 46 && o > -1 ? o++ : o = -1;
  }
  return r;
}
function ho(e) {
  if (typeof e != "string")
    throw new TypeError(
      "Path must be a string. Received " + JSON.stringify(e)
    );
}
const zP = { cwd: UP };
function UP() {
  return "/";
}
function ym(e) {
  return !!(e !== null && typeof e == "object" && "href" in e && e.href && "protocol" in e && e.protocol && // @ts-expect-error: indexing is fine.
  e.auth === void 0);
}
function MP(e) {
  if (typeof e == "string")
    e = new URL(e);
  else if (!ym(e)) {
    const n = new TypeError(
      'The "path" argument must be of type string or an instance of URL. Received `' + e + "`"
    );
    throw n.code = "ERR_INVALID_ARG_TYPE", n;
  }
  if (e.protocol !== "file:") {
    const n = new TypeError("The URL must be of scheme file");
    throw n.code = "ERR_INVALID_URL_SCHEME", n;
  }
  return BP(e);
}
function BP(e) {
  if (e.hostname !== "") {
    const i = new TypeError(
      'File URL host must be "localhost" or empty on darwin'
    );
    throw i.code = "ERR_INVALID_FILE_URL_HOST", i;
  }
  const n = e.pathname;
  let r = -1;
  for (; ++r < n.length; )
    if (n.codePointAt(r) === 37 && n.codePointAt(r + 1) === 50) {
      const i = n.codePointAt(r + 2);
      if (i === 70 || i === 102) {
        const a = new TypeError(
          "File URL path must not include encoded / characters"
        );
        throw a.code = "ERR_INVALID_FILE_URL_PATH", a;
      }
    }
  return decodeURIComponent(n);
}
const du = (
  /** @type {const} */
  [
    "history",
    "path",
    "basename",
    "stem",
    "extname",
    "dirname"
  ]
);
class Wx {
  /**
   * Create a new virtual file.
   *
   * `options` is treated as:
   *
   * *   `string` or `Uint8Array` — `{value: options}`
   * *   `URL` — `{path: options}`
   * *   `VFile` — shallow copies its data over to the new file
   * *   `object` — all fields are shallow copied over to the new file
   *
   * Path related fields are set in the following order (least specific to
   * most specific): `history`, `path`, `basename`, `stem`, `extname`,
   * `dirname`.
   *
   * You cannot set `dirname` or `extname` without setting either `history`,
   * `path`, `basename`, or `stem` too.
   *
   * @param {Compatible | null | undefined} [value]
   *   File value.
   * @returns
   *   New instance.
   */
  constructor(n) {
    let r;
    n ? ym(n) ? r = { path: n } : typeof n == "string" || qP(n) ? r = { value: n } : r = n : r = {}, this.cwd = "cwd" in r ? "" : zP.cwd(), this.data = {}, this.history = [], this.messages = [], this.value, this.map, this.result, this.stored;
    let i = -1;
    for (; ++i < du.length; ) {
      const o = du[i];
      o in r && r[o] !== void 0 && r[o] !== null && (this[o] = o === "history" ? [...r[o]] : r[o]);
    }
    let a;
    for (a in r)
      du.includes(a) || (this[a] = r[a]);
  }
  /**
   * Get the basename (including extname) (example: `'index.min.js'`).
   *
   * @returns {string | undefined}
   *   Basename.
   */
  get basename() {
    return typeof this.path == "string" ? Cr.basename(this.path) : void 0;
  }
  /**
   * Set basename (including extname) (`'index.min.js'`).
   *
   * Cannot contain path separators (`'/'` on unix, macOS, and browsers, `'\'`
   * on windows).
   * Cannot be nullified (use `file.path = file.dirname` instead).
   *
   * @param {string} basename
   *   Basename.
   * @returns {undefined}
   *   Nothing.
   */
  set basename(n) {
    mu(n, "basename"), uu(n, "basename"), this.path = Cr.join(this.dirname || "", n);
  }
  /**
   * Get the parent path (example: `'~'`).
   *
   * @returns {string | undefined}
   *   Dirname.
   */
  get dirname() {
    return typeof this.path == "string" ? Cr.dirname(this.path) : void 0;
  }
  /**
   * Set the parent path (example: `'~'`).
   *
   * Cannot be set if there’s no `path` yet.
   *
   * @param {string | undefined} dirname
   *   Dirname.
   * @returns {undefined}
   *   Nothing.
   */
  set dirname(n) {
    Hv(this.basename, "dirname"), this.path = Cr.join(n || "", this.basename);
  }
  /**
   * Get the extname (including dot) (example: `'.js'`).
   *
   * @returns {string | undefined}
   *   Extname.
   */
  get extname() {
    return typeof this.path == "string" ? Cr.extname(this.path) : void 0;
  }
  /**
   * Set the extname (including dot) (example: `'.js'`).
   *
   * Cannot contain path separators (`'/'` on unix, macOS, and browsers, `'\'`
   * on windows).
   * Cannot be set if there’s no `path` yet.
   *
   * @param {string | undefined} extname
   *   Extname.
   * @returns {undefined}
   *   Nothing.
   */
  set extname(n) {
    if (uu(n, "extname"), Hv(this.dirname, "extname"), n) {
      if (n.codePointAt(0) !== 46)
        throw new Error("`extname` must start with `.`");
      if (n.includes(".", 1))
        throw new Error("`extname` cannot contain multiple dots");
    }
    this.path = Cr.join(this.dirname, this.stem + (n || ""));
  }
  /**
   * Get the full path (example: `'~/index.min.js'`).
   *
   * @returns {string}
   *   Path.
   */
  get path() {
    return this.history[this.history.length - 1];
  }
  /**
   * Set the full path (example: `'~/index.min.js'`).
   *
   * Cannot be nullified.
   * You can set a file URL (a `URL` object with a `file:` protocol) which will
   * be turned into a path with `url.fileURLToPath`.
   *
   * @param {URL | string} path
   *   Path.
   * @returns {undefined}
   *   Nothing.
   */
  set path(n) {
    ym(n) && (n = MP(n)), mu(n, "path"), this.path !== n && this.history.push(n);
  }
  /**
   * Get the stem (basename w/o extname) (example: `'index.min'`).
   *
   * @returns {string | undefined}
   *   Stem.
   */
  get stem() {
    return typeof this.path == "string" ? Cr.basename(this.path, this.extname) : void 0;
  }
  /**
   * Set the stem (basename w/o extname) (example: `'index.min'`).
   *
   * Cannot contain path separators (`'/'` on unix, macOS, and browsers, `'\'`
   * on windows).
   * Cannot be nullified (use `file.path = file.dirname` instead).
   *
   * @param {string} stem
   *   Stem.
   * @returns {undefined}
   *   Nothing.
   */
  set stem(n) {
    mu(n, "stem"), uu(n, "stem"), this.path = Cr.join(this.dirname || "", n + (this.extname || ""));
  }
  // Normal prototypal methods.
  /**
   * Create a fatal message for `reason` associated with the file.
   *
   * The `fatal` field of the message is set to `true` (error; file not usable)
   * and the `file` field is set to the current file path.
   * The message is added to the `messages` field on `file`.
   *
   * > 🪦 **Note**: also has obsolete signatures.
   *
   * @overload
   * @param {string} reason
   * @param {MessageOptions | null | undefined} [options]
   * @returns {never}
   *
   * @overload
   * @param {string} reason
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @overload
   * @param {string} reason
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @overload
   * @param {string} reason
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @param {Error | VFileMessage | string} causeOrReason
   *   Reason for message, should use markdown.
   * @param {Node | NodeLike | MessageOptions | Point | Position | string | null | undefined} [optionsOrParentOrPlace]
   *   Configuration (optional).
   * @param {string | null | undefined} [origin]
   *   Place in code where the message originates (example:
   *   `'my-package:my-rule'` or `'my-rule'`).
   * @returns {never}
   *   Never.
   * @throws {VFileMessage}
   *   Message.
   */
  fail(n, r, i) {
    const a = this.message(n, r, i);
    throw a.fatal = !0, a;
  }
  /**
   * Create an info message for `reason` associated with the file.
   *
   * The `fatal` field of the message is set to `undefined` (info; change
   * likely not needed) and the `file` field is set to the current file path.
   * The message is added to the `messages` field on `file`.
   *
   * > 🪦 **Note**: also has obsolete signatures.
   *
   * @overload
   * @param {string} reason
   * @param {MessageOptions | null | undefined} [options]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @param {Error | VFileMessage | string} causeOrReason
   *   Reason for message, should use markdown.
   * @param {Node | NodeLike | MessageOptions | Point | Position | string | null | undefined} [optionsOrParentOrPlace]
   *   Configuration (optional).
   * @param {string | null | undefined} [origin]
   *   Place in code where the message originates (example:
   *   `'my-package:my-rule'` or `'my-rule'`).
   * @returns {VFileMessage}
   *   Message.
   */
  info(n, r, i) {
    const a = this.message(n, r, i);
    return a.fatal = void 0, a;
  }
  /**
   * Create a message for `reason` associated with the file.
   *
   * The `fatal` field of the message is set to `false` (warning; change may be
   * needed) and the `file` field is set to the current file path.
   * The message is added to the `messages` field on `file`.
   *
   * > 🪦 **Note**: also has obsolete signatures.
   *
   * @overload
   * @param {string} reason
   * @param {MessageOptions | null | undefined} [options]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @param {Error | VFileMessage | string} causeOrReason
   *   Reason for message, should use markdown.
   * @param {Node | NodeLike | MessageOptions | Point | Position | string | null | undefined} [optionsOrParentOrPlace]
   *   Configuration (optional).
   * @param {string | null | undefined} [origin]
   *   Place in code where the message originates (example:
   *   `'my-package:my-rule'` or `'my-rule'`).
   * @returns {VFileMessage}
   *   Message.
   */
  message(n, r, i) {
    const a = new $t(
      // @ts-expect-error: the overloads are fine.
      n,
      r,
      i
    );
    return this.path && (a.name = this.path + ":" + a.name, a.file = this.path), a.fatal = !1, this.messages.push(a), a;
  }
  /**
   * Serialize the file.
   *
   * > **Note**: which encodings are supported depends on the engine.
   * > For info on Node.js, see:
   * > <https://nodejs.org/api/util.html#whatwg-supported-encodings>.
   *
   * @param {string | null | undefined} [encoding='utf8']
   *   Character encoding to understand `value` as when it’s a `Uint8Array`
   *   (default: `'utf-8'`).
   * @returns {string}
   *   Serialized file.
   */
  toString(n) {
    return this.value === void 0 ? "" : typeof this.value == "string" ? this.value : new TextDecoder(n || void 0).decode(this.value);
  }
}
function uu(e, n) {
  if (e && e.includes(Cr.sep))
    throw new Error(
      "`" + n + "` cannot be a path: did not expect `" + Cr.sep + "`"
    );
}
function mu(e, n) {
  if (!e)
    throw new Error("`" + n + "` cannot be empty");
}
function Hv(e, n) {
  if (!e)
    throw new Error("Setting `" + n + "` requires `path` to be set too");
}
function qP(e) {
  return !!(e && typeof e == "object" && "byteLength" in e && "byteOffset" in e);
}
const HP = (
  /**
   * @type {new <Parameters extends Array<unknown>, Result>(property: string | symbol) => (...parameters: Parameters) => Result}
   */
  /** @type {unknown} */
  /**
   * @this {Function}
   * @param {string | symbol} property
   * @returns {(...parameters: Array<unknown>) => unknown}
   */
  (function(e) {
    const i = (
      /** @type {Record<string | symbol, Function>} */
      // Prototypes do exist.
      // type-coverage:ignore-next-line
      this.constructor.prototype
    ), a = i[e], o = function() {
      return a.apply(o, arguments);
    };
    return Object.setPrototypeOf(o, i), o;
  })
), WP = {}.hasOwnProperty;
class Pp extends HP {
  /**
   * Create a processor.
   */
  constructor() {
    super("copy"), this.Compiler = void 0, this.Parser = void 0, this.attachers = [], this.compiler = void 0, this.freezeIndex = -1, this.frozen = void 0, this.namespace = {}, this.parser = void 0, this.transformers = $P();
  }
  /**
   * Copy a processor.
   *
   * @deprecated
   *   This is a private internal method and should not be used.
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *   New *unfrozen* processor ({@linkcode Processor}) that is
   *   configured to work the same as its ancestor.
   *   When the descendant processor is configured in the future it does not
   *   affect the ancestral processor.
   */
  copy() {
    const n = (
      /** @type {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>} */
      new Pp()
    );
    let r = -1;
    for (; ++r < this.attachers.length; ) {
      const i = this.attachers[r];
      n.use(...i);
    }
    return n.data(cu(!0, {}, this.namespace)), n;
  }
  /**
   * Configure the processor with info available to all plugins.
   * Information is stored in an object.
   *
   * Typically, options can be given to a specific plugin, but sometimes it
   * makes sense to have information shared with several plugins.
   * For example, a list of HTML elements that are self-closing, which is
   * needed during all phases.
   *
   * > **Note**: setting information cannot occur on *frozen* processors.
   * > Call the processor first to create a new unfrozen processor.
   *
   * > **Note**: to register custom data in TypeScript, augment the
   * > {@linkcode Data} interface.
   *
   * @example
   *   This example show how to get and set info:
   *
   *   ```js
   *   import {unified} from 'unified'
   *
   *   const processor = unified().data('alpha', 'bravo')
   *
   *   processor.data('alpha') // => 'bravo'
   *
   *   processor.data() // => {alpha: 'bravo'}
   *
   *   processor.data({charlie: 'delta'})
   *
   *   processor.data() // => {charlie: 'delta'}
   *   ```
   *
   * @template {keyof Data} Key
   *
   * @overload
   * @returns {Data}
   *
   * @overload
   * @param {Data} dataset
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *
   * @overload
   * @param {Key} key
   * @returns {Data[Key]}
   *
   * @overload
   * @param {Key} key
   * @param {Data[Key]} value
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *
   * @param {Data | Key} [key]
   *   Key to get or set, or entire dataset to set, or nothing to get the
   *   entire dataset (optional).
   * @param {Data[Key]} [value]
   *   Value to set (optional).
   * @returns {unknown}
   *   The current processor when setting, the value at `key` when getting, or
   *   the entire dataset when getting without key.
   */
  data(n, r) {
    return typeof n == "string" ? arguments.length === 2 ? (hu("data", this.frozen), this.namespace[n] = r, this) : WP.call(this.namespace, n) && this.namespace[n] || void 0 : n ? (hu("data", this.frozen), this.namespace = n, this) : this.namespace;
  }
  /**
   * Freeze a processor.
   *
   * Frozen processors are meant to be extended and not to be configured
   * directly.
   *
   * When a processor is frozen it cannot be unfrozen.
   * New processors working the same way can be created by calling the
   * processor.
   *
   * It’s possible to freeze processors explicitly by calling `.freeze()`.
   * Processors freeze automatically when `.parse()`, `.run()`, `.runSync()`,
   * `.stringify()`, `.process()`, or `.processSync()` are called.
   *
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *   The current processor.
   */
  freeze() {
    if (this.frozen)
      return this;
    const n = (
      /** @type {Processor} */
      /** @type {unknown} */
      this
    );
    for (; ++this.freezeIndex < this.attachers.length; ) {
      const [r, ...i] = this.attachers[this.freezeIndex];
      if (i[0] === !1)
        continue;
      i[0] === !0 && (i[0] = void 0);
      const a = r.call(n, ...i);
      typeof a == "function" && this.transformers.use(a);
    }
    return this.frozen = !0, this.freezeIndex = Number.POSITIVE_INFINITY, this;
  }
  /**
   * Parse text to a syntax tree.
   *
   * > **Note**: `parse` freezes the processor if not already *frozen*.
   *
   * > **Note**: `parse` performs the parse phase, not the run phase or other
   * > phases.
   *
   * @param {Compatible | undefined} [file]
   *   file to parse (optional); typically `string` or `VFile`; any value
   *   accepted as `x` in `new VFile(x)`.
   * @returns {ParseTree extends undefined ? Node : ParseTree}
   *   Syntax tree representing `file`.
   */
  parse(n) {
    this.freeze();
    const r = To(n), i = this.parser || this.Parser;
    return pu("parse", i), i(String(r), r);
  }
  /**
   * Process the given file as configured on the processor.
   *
   * > **Note**: `process` freezes the processor if not already *frozen*.
   *
   * > **Note**: `process` performs the parse, run, and stringify phases.
   *
   * @overload
   * @param {Compatible | undefined} file
   * @param {ProcessCallback<VFileWithOutput<CompileResult>>} done
   * @returns {undefined}
   *
   * @overload
   * @param {Compatible | undefined} [file]
   * @returns {Promise<VFileWithOutput<CompileResult>>}
   *
   * @param {Compatible | undefined} [file]
   *   File (optional); typically `string` or `VFile`]; any value accepted as
   *   `x` in `new VFile(x)`.
   * @param {ProcessCallback<VFileWithOutput<CompileResult>> | undefined} [done]
   *   Callback (optional).
   * @returns {Promise<VFile> | undefined}
   *   Nothing if `done` is given.
   *   Otherwise a promise, rejected with a fatal error or resolved with the
   *   processed file.
   *
   *   The parsed, transformed, and compiled value is available at
   *   `file.value` (see note).
   *
   *   > **Note**: unified typically compiles by serializing: most
   *   > compilers return `string` (or `Uint8Array`).
   *   > Some compilers, such as the one configured with
   *   > [`rehype-react`][rehype-react], return other values (in this case, a
   *   > React tree).
   *   > If you’re using a compiler that doesn’t serialize, expect different
   *   > result values.
   *   >
   *   > To register custom results in TypeScript, add them to
   *   > {@linkcode CompileResultMap}.
   *
   *   [rehype-react]: https://github.com/rehypejs/rehype-react
   */
  process(n, r) {
    const i = this;
    return this.freeze(), pu("process", this.parser || this.Parser), fu("process", this.compiler || this.Compiler), r ? a(void 0, r) : new Promise(a);
    function a(o, s) {
      const l = To(n), d = (
        /** @type {HeadTree extends undefined ? Node : HeadTree} */
        /** @type {unknown} */
        i.parse(l)
      );
      i.run(d, l, function(u, f, h) {
        if (u || !f || !h)
          return m(u);
        const v = (
          /** @type {CompileTree extends undefined ? Node : CompileTree} */
          /** @type {unknown} */
          f
        ), C = i.stringify(v, h);
        YP(C) ? h.value = C : h.result = C, m(
          u,
          /** @type {VFileWithOutput<CompileResult>} */
          h
        );
      });
      function m(u, f) {
        u || !f ? s(u) : o ? o(f) : r(void 0, f);
      }
    }
  }
  /**
   * Process the given file as configured on the processor.
   *
   * An error is thrown if asynchronous transforms are configured.
   *
   * > **Note**: `processSync` freezes the processor if not already *frozen*.
   *
   * > **Note**: `processSync` performs the parse, run, and stringify phases.
   *
   * @param {Compatible | undefined} [file]
   *   File (optional); typically `string` or `VFile`; any value accepted as
   *   `x` in `new VFile(x)`.
   * @returns {VFileWithOutput<CompileResult>}
   *   The processed file.
   *
   *   The parsed, transformed, and compiled value is available at
   *   `file.value` (see note).
   *
   *   > **Note**: unified typically compiles by serializing: most
   *   > compilers return `string` (or `Uint8Array`).
   *   > Some compilers, such as the one configured with
   *   > [`rehype-react`][rehype-react], return other values (in this case, a
   *   > React tree).
   *   > If you’re using a compiler that doesn’t serialize, expect different
   *   > result values.
   *   >
   *   > To register custom results in TypeScript, add them to
   *   > {@linkcode CompileResultMap}.
   *
   *   [rehype-react]: https://github.com/rehypejs/rehype-react
   */
  processSync(n) {
    let r = !1, i;
    return this.freeze(), pu("processSync", this.parser || this.Parser), fu("processSync", this.compiler || this.Compiler), this.process(n, a), Kv("processSync", "process", r), i;
    function a(o, s) {
      r = !0, Bv(o), i = s;
    }
  }
  /**
   * Run *transformers* on a syntax tree.
   *
   * > **Note**: `run` freezes the processor if not already *frozen*.
   *
   * > **Note**: `run` performs the run phase, not other phases.
   *
   * @overload
   * @param {HeadTree extends undefined ? Node : HeadTree} tree
   * @param {RunCallback<TailTree extends undefined ? Node : TailTree>} done
   * @returns {undefined}
   *
   * @overload
   * @param {HeadTree extends undefined ? Node : HeadTree} tree
   * @param {Compatible | undefined} file
   * @param {RunCallback<TailTree extends undefined ? Node : TailTree>} done
   * @returns {undefined}
   *
   * @overload
   * @param {HeadTree extends undefined ? Node : HeadTree} tree
   * @param {Compatible | undefined} [file]
   * @returns {Promise<TailTree extends undefined ? Node : TailTree>}
   *
   * @param {HeadTree extends undefined ? Node : HeadTree} tree
   *   Tree to transform and inspect.
   * @param {(
   *   RunCallback<TailTree extends undefined ? Node : TailTree> |
   *   Compatible
   * )} [file]
   *   File associated with `node` (optional); any value accepted as `x` in
   *   `new VFile(x)`.
   * @param {RunCallback<TailTree extends undefined ? Node : TailTree>} [done]
   *   Callback (optional).
   * @returns {Promise<TailTree extends undefined ? Node : TailTree> | undefined}
   *   Nothing if `done` is given.
   *   Otherwise, a promise rejected with a fatal error or resolved with the
   *   transformed tree.
   */
  run(n, r, i) {
    Wv(n), this.freeze();
    const a = this.transformers;
    return !i && typeof r == "function" && (i = r, r = void 0), i ? o(void 0, i) : new Promise(o);
    function o(s, l) {
      const d = To(r);
      a.run(n, d, m);
      function m(u, f, h) {
        const v = (
          /** @type {TailTree extends undefined ? Node : TailTree} */
          f || n
        );
        u ? l(u) : s ? s(v) : i(void 0, v, h);
      }
    }
  }
  /**
   * Run *transformers* on a syntax tree.
   *
   * An error is thrown if asynchronous transforms are configured.
   *
   * > **Note**: `runSync` freezes the processor if not already *frozen*.
   *
   * > **Note**: `runSync` performs the run phase, not other phases.
   *
   * @param {HeadTree extends undefined ? Node : HeadTree} tree
   *   Tree to transform and inspect.
   * @param {Compatible | undefined} [file]
   *   File associated with `node` (optional); any value accepted as `x` in
   *   `new VFile(x)`.
   * @returns {TailTree extends undefined ? Node : TailTree}
   *   Transformed tree.
   */
  runSync(n, r) {
    let i = !1, a;
    return this.run(n, r, o), Kv("runSync", "run", i), a;
    function o(s, l) {
      Bv(s), a = l, i = !0;
    }
  }
  /**
   * Compile a syntax tree.
   *
   * > **Note**: `stringify` freezes the processor if not already *frozen*.
   *
   * > **Note**: `stringify` performs the stringify phase, not the run phase
   * > or other phases.
   *
   * @param {CompileTree extends undefined ? Node : CompileTree} tree
   *   Tree to compile.
   * @param {Compatible | undefined} [file]
   *   File associated with `node` (optional); any value accepted as `x` in
   *   `new VFile(x)`.
   * @returns {CompileResult extends undefined ? Value : CompileResult}
   *   Textual representation of the tree (see note).
   *
   *   > **Note**: unified typically compiles by serializing: most compilers
   *   > return `string` (or `Uint8Array`).
   *   > Some compilers, such as the one configured with
   *   > [`rehype-react`][rehype-react], return other values (in this case, a
   *   > React tree).
   *   > If you’re using a compiler that doesn’t serialize, expect different
   *   > result values.
   *   >
   *   > To register custom results in TypeScript, add them to
   *   > {@linkcode CompileResultMap}.
   *
   *   [rehype-react]: https://github.com/rehypejs/rehype-react
   */
  stringify(n, r) {
    this.freeze();
    const i = To(r), a = this.compiler || this.Compiler;
    return fu("stringify", a), Wv(n), a(n, i);
  }
  /**
   * Configure the processor to use a plugin, a list of usable values, or a
   * preset.
   *
   * If the processor is already using a plugin, the previous plugin
   * configuration is changed based on the options that are passed in.
   * In other words, the plugin is not added a second time.
   *
   * > **Note**: `use` cannot be called on *frozen* processors.
   * > Call the processor first to create a new unfrozen processor.
   *
   * @example
   *   There are many ways to pass plugins to `.use()`.
   *   This example gives an overview:
   *
   *   ```js
   *   import {unified} from 'unified'
   *
   *   unified()
   *     // Plugin with options:
   *     .use(pluginA, {x: true, y: true})
   *     // Passing the same plugin again merges configuration (to `{x: true, y: false, z: true}`):
   *     .use(pluginA, {y: false, z: true})
   *     // Plugins:
   *     .use([pluginB, pluginC])
   *     // Two plugins, the second with options:
   *     .use([pluginD, [pluginE, {}]])
   *     // Preset with plugins and settings:
   *     .use({plugins: [pluginF, [pluginG, {}]], settings: {position: false}})
   *     // Settings only:
   *     .use({settings: {position: false}})
   *   ```
   *
   * @template {Array<unknown>} [Parameters=[]]
   * @template {Node | string | undefined} [Input=undefined]
   * @template [Output=Input]
   *
   * @overload
   * @param {Preset | null | undefined} [preset]
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *
   * @overload
   * @param {PluggableList} list
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *
   * @overload
   * @param {Plugin<Parameters, Input, Output>} plugin
   * @param {...(Parameters | [boolean])} parameters
   * @returns {UsePlugin<ParseTree, HeadTree, TailTree, CompileTree, CompileResult, Input, Output>}
   *
   * @param {PluggableList | Plugin | Preset | null | undefined} value
   *   Usable value.
   * @param {...unknown} parameters
   *   Parameters, when a plugin is given as a usable value.
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *   Current processor.
   */
  use(n, ...r) {
    const i = this.attachers, a = this.namespace;
    if (hu("use", this.frozen), n != null) if (typeof n == "function")
      d(n, r);
    else if (typeof n == "object")
      Array.isArray(n) ? l(n) : s(n);
    else
      throw new TypeError("Expected usable value, not `" + n + "`");
    return this;
    function o(m) {
      if (typeof m == "function")
        d(m, []);
      else if (typeof m == "object")
        if (Array.isArray(m)) {
          const [u, ...f] = (
            /** @type {PluginTuple<Array<unknown>>} */
            m
          );
          d(u, f);
        } else
          s(m);
      else
        throw new TypeError("Expected usable value, not `" + m + "`");
    }
    function s(m) {
      if (!("plugins" in m) && !("settings" in m))
        throw new Error(
          "Expected usable value but received an empty preset, which is probably a mistake: presets typically come with `plugins` and sometimes with `settings`, but this has neither"
        );
      l(m.plugins), m.settings && (a.settings = cu(!0, a.settings, m.settings));
    }
    function l(m) {
      let u = -1;
      if (m != null) if (Array.isArray(m))
        for (; ++u < m.length; ) {
          const f = m[u];
          o(f);
        }
      else
        throw new TypeError("Expected a list of plugins, not `" + m + "`");
    }
    function d(m, u) {
      let f = -1, h = -1;
      for (; ++f < i.length; )
        if (i[f][0] === m) {
          h = f;
          break;
        }
      if (h === -1)
        i.push([m, ...u]);
      else if (u.length > 0) {
        let [v, ...C] = u;
        const S = i[h][1];
        hm(S) && hm(v) && (v = cu(!0, S, v)), i[h] = [m, v, ...C];
      }
    }
  }
}
const KP = new Pp().freeze();
function pu(e, n) {
  if (typeof n != "function")
    throw new TypeError("Cannot `" + e + "` without `parser`");
}
function fu(e, n) {
  if (typeof n != "function")
    throw new TypeError("Cannot `" + e + "` without `compiler`");
}
function hu(e, n) {
  if (n)
    throw new Error(
      "Cannot call `" + e + "` on a frozen processor.\nCreate a new processor first, by calling it: use `processor()` instead of `processor`."
    );
}
function Wv(e) {
  if (!hm(e) || typeof e.type != "string")
    throw new TypeError("Expected node, got `" + e + "`");
}
function Kv(e, n, r) {
  if (!r)
    throw new Error(
      "`" + e + "` finished async. Use `" + n + "` instead"
    );
}
function To(e) {
  return GP(e) ? e : new Wx(e);
}
function GP(e) {
  return !!(e && typeof e == "object" && "message" in e && "messages" in e);
}
function YP(e) {
  return typeof e == "string" || QP(e);
}
function QP(e) {
  return !!(e && typeof e == "object" && "byteLength" in e && "byteOffset" in e);
}
const JP = "https://github.com/remarkjs/react-markdown/blob/main/changelog.md", Gv = [], Yv = { allowDangerousHtml: !0 }, XP = /^(https?|ircs?|mailto|xmpp)$/i, ZP = [
  { from: "astPlugins", id: "remove-buggy-html-in-markdown-parser" },
  { from: "allowDangerousHtml", id: "remove-buggy-html-in-markdown-parser" },
  {
    from: "allowNode",
    id: "replace-allownode-allowedtypes-and-disallowedtypes",
    to: "allowElement"
  },
  {
    from: "allowedTypes",
    id: "replace-allownode-allowedtypes-and-disallowedtypes",
    to: "allowedElements"
  },
  {
    from: "disallowedTypes",
    id: "replace-allownode-allowedtypes-and-disallowedtypes",
    to: "disallowedElements"
  },
  { from: "escapeHtml", id: "remove-buggy-html-in-markdown-parser" },
  { from: "includeElementIndex", id: "#remove-includeelementindex" },
  {
    from: "includeNodeIndex",
    id: "change-includenodeindex-to-includeelementindex"
  },
  { from: "linkTarget", id: "remove-linktarget" },
  { from: "plugins", id: "change-plugins-to-remarkplugins", to: "remarkPlugins" },
  { from: "rawSourcePos", id: "#remove-rawsourcepos" },
  { from: "renderers", id: "change-renderers-to-components", to: "components" },
  { from: "source", id: "change-source-to-children", to: "children" },
  { from: "sourcePos", id: "#remove-sourcepos" },
  { from: "transformImageUri", id: "#add-urltransform", to: "urlTransform" },
  { from: "transformLinkUri", id: "#add-urltransform", to: "urlTransform" }
];
function eA(e) {
  const n = e.allowedElements, r = e.allowElement, i = e.children || "", a = e.className, o = e.components, s = e.disallowedElements, l = e.rehypePlugins || Gv, d = e.remarkPlugins || Gv, m = e.remarkRehypeOptions ? { ...e.remarkRehypeOptions, ...Yv } : Yv, u = e.skipHtml, f = e.unwrapDisallowed, h = e.urlTransform || nA, v = KP().use(RO).use(d).use(IP, m).use(l), C = new Wx();
  typeof i == "string" && (C.value = i);
  for (const y of ZP)
    Object.hasOwn(e, y.from) && ("" + y.from + (y.to ? "use `" + y.to + "` instead" : "remove it") + JP + y.id, void 0);
  const S = v.parse(C);
  let j = v.runSync(S, C);
  return a && (j = {
    type: "element",
    tagName: "div",
    properties: { className: a },
    // Assume no doctypes.
    children: (
      /** @type {Array<ElementContent>} */
      j.type === "root" ? j.children : [j]
    )
  }), Hx(j, F), mD(j, {
    Fragment: Ue.Fragment,
    components: o,
    ignoreInvalidStyle: !0,
    jsx: Ue.jsx,
    jsxs: Ue.jsxs,
    passKeys: !0,
    passNode: !0
  });
  function F(y, q, T) {
    if (y.type === "raw" && T && typeof q == "number")
      return u ? T.children.splice(q, 1) : T.children[q] = { type: "text", value: y.value }, q;
    if (y.type === "element") {
      let E;
      for (E in au)
        if (Object.hasOwn(au, E) && Object.hasOwn(y.properties, E)) {
          const D = y.properties[E], B = au[E];
          (B === null || B.includes(y.tagName)) && (y.properties[E] = h(String(D || ""), E, y));
        }
    }
    if (y.type === "element") {
      let E = n ? !n.includes(y.tagName) : s ? s.includes(y.tagName) : !1;
      if (!E && r && typeof q == "number" && (E = !r(y, q, T)), E && T && typeof q == "number")
        return f && y.children ? T.children.splice(q, 1, ...y.children) : T.children.splice(q, 1), q;
    }
  }
}
function nA(e) {
  const n = e.indexOf(":"), r = e.indexOf("?"), i = e.indexOf("#"), a = e.indexOf("/");
  return (
    // If there is no protocol, it’s relative.
    n < 0 || // If the first colon is after a `?`, `#`, or `/`, it’s not a protocol.
    a > -1 && n > a || r > -1 && n > r || i > -1 && n > i || // It is a protocol, it should be allowed.
    XP.test(e.slice(0, n)) ? e : ""
  );
}
(function() {
  try {
    if (typeof document < "u") {
      var e = document.createElement("style");
      e.appendChild(document.createTextNode('._issueAvatar_kc0sw_1{margin:var(--dixa-size-spacer-100) 0}._issueAvatar_kc0sw_1 h2{font-weight:var(--dixa-typography-weight-normal);align-items:center;display:flex}._issueField_kc0sw_9{font-weight:var(--dixa-typography-weight-normal)}._issueDescription_kc0sw_12{font-weight:var(--dixa-typography-weight-normal);color:var(--dixa-color-neutral-800);padding:var(--dixa-size-spacer-200);border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100)}._issueDescription_kc0sw_12 p{margin:unset}._wrapper_e0qj3_1{width:400px;padding:0 0 var(--dixa-size-spacer-200) 0;max-height:400px;overflow:hidden;position:relative}._wrapper_e0qj3_1 ._description_e0qj3_8{color:var(--dixa-color-neutral-600)}._wrapper_e0qj3_1:after{width:100%;height:var(--dixa-size-spacer-400);content:"";position:absolute;bottom:0;left:0;background:linear-gradient(0deg,#fff,#ffffffbc 19%,#ffffff8a 34%,#ffffff61 47%,#ffffff47 56.5%,#ffffff31 65%,#ffffff20 73%,#ffffff13 80.2%,#ffffff0b 86.1%,#ffffff05 91%,#ffffff02 95.2%,#ffffff01 98.2%,#fff0)}._resultTitle_e0qj3_21{text-align:left;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;color:var(--dixa-color-neutral-600)}._resultTooltipTitle_e0qj3_28{margin-bottom:var(--dixa-size-spacer-200)}._resultLinkIcon_e0qj3_31{position:absolute;right:var(--dixa-size-spacer-300);background-color:var(--dixa-color-neutral-000);border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);color:var(--dixa-color-neutral-500)}._loader_13xpk_1{width:100%;display:flex;padding:var(--dixa-size-spacer-200);justify-content:center}._dropdown_13xpk_8{max-height:300px;overflow-y:scroll}._loadMore_13xpk_13{cursor:pointer}._loadMore_13xpk_13:hover{background-color:var(--dixa-color-neutral-100)}._loadMore_13xpk_13:hover p{color:var(--dixa-color-purple-600)}._loadMore_13xpk_13 p{color:var(--dixa-color-purple-500)}._collapse_su0f9_1{border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);font-size:var(--dixa-typography-size-200);line-height:var(--dixa-typography-line-height-200);padding:var(--dixa-size-spacer-100)}._collapseHeader_su0f9_8{padding:var(--dixa-size-spacer-250);width:100%;box-sizing:border-box;background-color:transparent;gap:var(--dixa-size-spacer-100)}._collapseHeader_su0f9_8>div:first-of-type{padding:0!important;padding-right:var(--dixa-size-spacer-300);width:100%}._collapseHeader_su0f9_8>div>div:first-of-type{padding:0!important;width:100%}._collapseHeader_su0f9_8 p>div:first-of-type{justify-content:space-between}._collapseHeader_su0f9_8>div>div>p{white-space:unset!important;margin:0}._collapseContent_su0f9_31{padding:0 var(--dixa-size-spacer-250) var(--dixa-size-spacer-250) var(--dixa-size-spacer-250)}._url_su0f9_35{align-items:center;display:flex;flex-direction:row;gap:var(--dixa-size-spacer-100);color:var(--dixa-color-purple-500);font-weight:var(--dixa-typography-weight-semibold);cursor:pointer;font-size:var(--dixa-typography-size-200);line-height:var(--dixa-typography-line-height-200)}._empty_su0f9_47 p{color:var(--dixa-color-neutral-400)}._externalLink_su0f9_51{color:var(--dixa-typography-color-link)}._emptyState_su0f9_55{font-weight:var(--dixa-typography-weight-normal)}._modalBody_iv3ua_1{width:600px}._error_iv3ua_5{border:var(--dixa-size-border-100) solid var(--dixa-typography-color-error)}._emptyState_iv3ua_9{padding:var(--dixa-size-spacer-100) var(--dixa-size-spacer-200) var(--dixa-size-spacer-200)}._emptyState_iv3ua_9 p{color:var(--dixa-color-neutral-400)}._dropdown_iv3ua_16{max-height:300px;overflow-y:scroll}._modalWrapper_4kh9u_1{min-width:600px;position:relative}._copyButton_4kh9u_6{height:var(--dixa-size-spacer-500);width:var(--dixa-size-spacer-500)}._copyButton_4kh9u_6 button{background-color:var(--dixa-color-neutral-100);border-radius:0 var(--dixa-size-border-radius-100) var(--dixa-size-border-radius-100) 0}._copyWrapper_4kh9u_15{box-sizing:border-box}._copyWrapper_4kh9u_15:focus-within{border-radius:var(--dixa-size-border-radius-100);outline:solid var(--dixa-size-border-100) var(--dixa-color-purple-500);box-shadow:0 0 0 3px var(--dixa-color-purple-300)}._copyField_4kh9u_24{cursor:pointer;min-width:62ch;height:var(--dixa-size-spacer-500);border-radius:var(--dixa-size-border-radius-100) 0 0 var(--dixa-size-border-radius-100);border:none}._copyField_4kh9u_24:hover{border:none}._copyField_4kh9u_24:focus-within{box-shadow:none;border:none;outline:none}._copyField_4kh9u_24 input{color:var(--dixa-color-neutral-800);background-color:var(--dixa-color-neutral-100);cursor:pointer;border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-200);border-right:none}._externalLink_4kh9u_47{display:flex;align-items:center}._externalLinkIcon_4kh9u_52{align-self:center}._textWrapper_4kh9u_56{display:flex;gap:var(--dixa-size-spacer-100)}')), document.head.appendChild(e);
    }
  } catch (n) {
    console.error("vite-plugin-css-injected-by-js", n);
  }
})();
var yu = { exports: {} }, va = {}, Qv;
function tA() {
  if (Qv) return va;
  Qv = 1;
  var e = je, n = Symbol.for("react.element"), r = Symbol.for("react.fragment"), i = Object.prototype.hasOwnProperty, a = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, o = { key: !0, ref: !0, __self: !0, __source: !0 };
  function s(l, d, m) {
    var u, f = {}, h = null, v = null;
    m !== void 0 && (h = "" + m), d.key !== void 0 && (h = "" + d.key), d.ref !== void 0 && (v = d.ref);
    for (u in d) i.call(d, u) && !o.hasOwnProperty(u) && (f[u] = d[u]);
    if (l && l.defaultProps) for (u in d = l.defaultProps, d) f[u] === void 0 && (f[u] = d[u]);
    return { $$typeof: n, type: l, key: h, ref: v, props: f, _owner: a.current };
  }
  return va.Fragment = r, va.jsx = s, va.jsxs = s, va;
}
var $o = {}, Jv;
function rA() {
  return Jv || (Jv = 1, process.env.NODE_ENV !== "production" && (function() {
    var e = je, n = Symbol.for("react.element"), r = Symbol.for("react.portal"), i = Symbol.for("react.fragment"), a = Symbol.for("react.strict_mode"), o = Symbol.for("react.profiler"), s = Symbol.for("react.provider"), l = Symbol.for("react.context"), d = Symbol.for("react.forward_ref"), m = Symbol.for("react.suspense"), u = Symbol.for("react.suspense_list"), f = Symbol.for("react.memo"), h = Symbol.for("react.lazy"), v = Symbol.for("react.offscreen"), C = Symbol.iterator, S = "@@iterator";
    function j(t) {
      if (t === null || typeof t != "object")
        return null;
      var c = C && t[C] || t[S];
      return typeof c == "function" ? c : null;
    }
    var F = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function y(t) {
      {
        for (var c = arguments.length, p = new Array(c > 1 ? c - 1 : 0), g = 1; g < c; g++)
          p[g - 1] = arguments[g];
        q("error", t, p);
      }
    }
    function q(t, c, p) {
      {
        var g = F.ReactDebugCurrentFrame, P = g.getStackAddendum();
        P !== "" && (c += "%s", p = p.concat([P]));
        var L = p.map(function(I) {
          return String(I);
        });
        L.unshift("Warning: " + c), Function.prototype.apply.call(console[t], console, L);
      }
    }
    var T = !1, E = !1, D = !1, B = !1, ee = !1, J;
    J = Symbol.for("react.module.reference");
    function ae(t) {
      return !!(typeof t == "string" || typeof t == "function" || t === i || t === o || ee || t === a || t === m || t === u || B || t === v || T || E || D || typeof t == "object" && t !== null && (t.$$typeof === h || t.$$typeof === f || t.$$typeof === s || t.$$typeof === l || t.$$typeof === d || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      t.$$typeof === J || t.getModuleId !== void 0));
    }
    function Q(t, c, p) {
      var g = t.displayName;
      if (g)
        return g;
      var P = c.displayName || c.name || "";
      return P !== "" ? p + "(" + P + ")" : p;
    }
    function U(t) {
      return t.displayName || "Context";
    }
    function O(t) {
      if (t == null)
        return null;
      if (typeof t.tag == "number" && y("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof t == "function")
        return t.displayName || t.name || null;
      if (typeof t == "string")
        return t;
      switch (t) {
        case i:
          return "Fragment";
        case r:
          return "Portal";
        case o:
          return "Profiler";
        case a:
          return "StrictMode";
        case m:
          return "Suspense";
        case u:
          return "SuspenseList";
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case l:
            var c = t;
            return U(c) + ".Consumer";
          case s:
            var p = t;
            return U(p._context) + ".Provider";
          case d:
            return Q(t, t.render, "ForwardRef");
          case f:
            var g = t.displayName || null;
            return g !== null ? g : O(t.type) || "Memo";
          case h: {
            var P = t, L = P._payload, I = P._init;
            try {
              return O(I(L));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var H = Object.assign, Z = 0, ye, ce, le, ue, W, ke, Ee;
    function K() {
    }
    K.__reactDisabledLog = !0;
    function qe() {
      {
        if (Z === 0) {
          ye = console.log, ce = console.info, le = console.warn, ue = console.error, W = console.group, ke = console.groupCollapsed, Ee = console.groupEnd;
          var t = {
            configurable: !0,
            enumerable: !0,
            value: K,
            writable: !0
          };
          Object.defineProperties(console, {
            info: t,
            log: t,
            warn: t,
            error: t,
            group: t,
            groupCollapsed: t,
            groupEnd: t
          });
        }
        Z++;
      }
    }
    function Be() {
      {
        if (Z--, Z === 0) {
          var t = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: H({}, t, {
              value: ye
            }),
            info: H({}, t, {
              value: ce
            }),
            warn: H({}, t, {
              value: le
            }),
            error: H({}, t, {
              value: ue
            }),
            group: H({}, t, {
              value: W
            }),
            groupCollapsed: H({}, t, {
              value: ke
            }),
            groupEnd: H({}, t, {
              value: Ee
            })
          });
        }
        Z < 0 && y("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var Pe = F.ReactCurrentDispatcher, Me;
    function Fe(t, c, p) {
      {
        if (Me === void 0)
          try {
            throw Error();
          } catch (P) {
            var g = P.stack.trim().match(/\n( *(at )?)/);
            Me = g && g[1] || "";
          }
        return `
` + Me + t;
      }
    }
    var Ae = !1, $e;
    {
      var tn = typeof WeakMap == "function" ? WeakMap : Map;
      $e = new tn();
    }
    function Ie(t, c) {
      if (!t || Ae)
        return "";
      {
        var p = $e.get(t);
        if (p !== void 0)
          return p;
      }
      var g;
      Ae = !0;
      var P = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var L;
      L = Pe.current, Pe.current = null, qe();
      try {
        if (c) {
          var I = function() {
            throw Error();
          };
          if (Object.defineProperty(I.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(I, []);
            } catch (ne) {
              g = ne;
            }
            Reflect.construct(t, [], I);
          } else {
            try {
              I.call();
            } catch (ne) {
              g = ne;
            }
            t.call(I.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (ne) {
            g = ne;
          }
          t();
        }
      } catch (ne) {
        if (ne && g && typeof ne.stack == "string") {
          for (var N = ne.stack.split(`
`), te = g.stack.split(`
`), x = N.length - 1, V = te.length - 1; x >= 1 && V >= 0 && N[x] !== te[V]; )
            V--;
          for (; x >= 1 && V >= 0; x--, V--)
            if (N[x] !== te[V]) {
              if (x !== 1 || V !== 1)
                do
                  if (x--, V--, V < 0 || N[x] !== te[V]) {
                    var X = `
` + N[x].replace(" at new ", " at ");
                    return t.displayName && X.includes("<anonymous>") && (X = X.replace("<anonymous>", t.displayName)), typeof t == "function" && $e.set(t, X), X;
                  }
                while (x >= 1 && V >= 0);
              break;
            }
        }
      } finally {
        Ae = !1, Pe.current = L, Be(), Error.prepareStackTrace = P;
      }
      var we = t ? t.displayName || t.name : "", Se = we ? Fe(we) : "";
      return typeof t == "function" && $e.set(t, Se), Se;
    }
    function We(t, c, p) {
      return Ie(t, !1);
    }
    function Ze(t) {
      var c = t.prototype;
      return !!(c && c.isReactComponent);
    }
    function de(t, c, p) {
      if (t == null)
        return "";
      if (typeof t == "function")
        return Ie(t, Ze(t));
      if (typeof t == "string")
        return Fe(t);
      switch (t) {
        case m:
          return Fe("Suspense");
        case u:
          return Fe("SuspenseList");
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case d:
            return We(t.render);
          case f:
            return de(t.type, c, p);
          case h: {
            var g = t, P = g._payload, L = g._init;
            try {
              return de(L(P), c, p);
            } catch {
            }
          }
        }
      return "";
    }
    var fe = Object.prototype.hasOwnProperty, Te = {}, Le = F.ReactDebugCurrentFrame;
    function Re(t) {
      if (t) {
        var c = t._owner, p = de(t.type, t._source, c ? c.type : null);
        Le.setExtraStackFrame(p);
      } else
        Le.setExtraStackFrame(null);
    }
    function sn(t, c, p, g, P) {
      {
        var L = Function.call.bind(fe);
        for (var I in t)
          if (L(t, I)) {
            var N = void 0;
            try {
              if (typeof t[I] != "function") {
                var te = Error((g || "React class") + ": " + p + " type `" + I + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof t[I] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw te.name = "Invariant Violation", te;
              }
              N = t[I](c, I, g, p, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (x) {
              N = x;
            }
            N && !(N instanceof Error) && (Re(P), y("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", g || "React class", p, I, typeof N), Re(null)), N instanceof Error && !(N.message in Te) && (Te[N.message] = !0, Re(P), y("Failed %s type: %s", p, N.message), Re(null));
          }
      }
    }
    var w = Array.isArray;
    function _(t) {
      return w(t);
    }
    function $(t) {
      {
        var c = typeof Symbol == "function" && Symbol.toStringTag, p = c && t[Symbol.toStringTag] || t.constructor.name || "Object";
        return p;
      }
    }
    function G(t) {
      try {
        return Y(t), !1;
      } catch {
        return !0;
      }
    }
    function Y(t) {
      return "" + t;
    }
    function R(t) {
      if (G(t))
        return y("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", $(t)), Y(t);
    }
    var z = F.ReactCurrentOwner, ie = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, pe, _e;
    function en(t) {
      if (fe.call(t, "ref")) {
        var c = Object.getOwnPropertyDescriptor(t, "ref").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.ref !== void 0;
    }
    function un(t) {
      if (fe.call(t, "key")) {
        var c = Object.getOwnPropertyDescriptor(t, "key").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.key !== void 0;
    }
    function rn(t, c) {
      typeof t.ref == "string" && z.current;
    }
    function dn(t, c) {
      {
        var p = function() {
          pe || (pe = !0, y("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "key", {
          get: p,
          configurable: !0
        });
      }
    }
    function pn(t, c) {
      {
        var p = function() {
          _e || (_e = !0, y("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "ref", {
          get: p,
          configurable: !0
        });
      }
    }
    var ln = function(t, c, p, g, P, L, I) {
      var N = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: n,
        // Built-in properties that belong on the element
        type: t,
        key: c,
        ref: p,
        props: I,
        // Record the component responsible for creating this element.
        _owner: L
      };
      return N._store = {}, Object.defineProperty(N._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(N, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: g
      }), Object.defineProperty(N, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: P
      }), Object.freeze && (Object.freeze(N.props), Object.freeze(N)), N;
    };
    function kn(t, c, p, g, P) {
      {
        var L, I = {}, N = null, te = null;
        p !== void 0 && (R(p), N = "" + p), un(c) && (R(c.key), N = "" + c.key), en(c) && (te = c.ref, rn(c));
        for (L in c)
          fe.call(c, L) && !ie.hasOwnProperty(L) && (I[L] = c[L]);
        if (t && t.defaultProps) {
          var x = t.defaultProps;
          for (L in x)
            I[L] === void 0 && (I[L] = x[L]);
        }
        if (N || te) {
          var V = typeof t == "function" ? t.displayName || t.name || "Unknown" : t;
          N && dn(I, V), te && pn(I, V);
        }
        return ln(t, N, te, P, g, z.current, I);
      }
    }
    var Xe = F.ReactCurrentOwner, Sn = F.ReactDebugCurrentFrame;
    function Oe(t) {
      if (t) {
        var c = t._owner, p = de(t.type, t._source, c ? c.type : null);
        Sn.setExtraStackFrame(p);
      } else
        Sn.setExtraStackFrame(null);
    }
    var an;
    an = !1;
    function on(t) {
      return typeof t == "object" && t !== null && t.$$typeof === n;
    }
    function yn() {
      {
        if (Xe.current) {
          var t = O(Xe.current.type);
          if (t)
            return `

Check the render method of \`` + t + "`.";
        }
        return "";
      }
    }
    function qn(t) {
      return "";
    }
    var Nn = {};
    function gn(t) {
      {
        var c = yn();
        if (!c) {
          var p = typeof t == "string" ? t : t.displayName || t.name;
          p && (c = `

Check the top-level render call using <` + p + ">.");
        }
        return c;
      }
    }
    function hn(t, c) {
      {
        if (!t._store || t._store.validated || t.key != null)
          return;
        t._store.validated = !0;
        var p = gn(c);
        if (Nn[p])
          return;
        Nn[p] = !0;
        var g = "";
        t && t._owner && t._owner !== Xe.current && (g = " It was passed a child from " + O(t._owner.type) + "."), Oe(t), y('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', p, g), Oe(null);
      }
    }
    function jn(t, c) {
      {
        if (typeof t != "object")
          return;
        if (_(t))
          for (var p = 0; p < t.length; p++) {
            var g = t[p];
            on(g) && hn(g, c);
          }
        else if (on(t))
          t._store && (t._store.validated = !0);
        else if (t) {
          var P = j(t);
          if (typeof P == "function" && P !== t.entries)
            for (var L = P.call(t), I; !(I = L.next()).done; )
              on(I.value) && hn(I.value, c);
        }
      }
    }
    function Un(t) {
      {
        var c = t.type;
        if (c == null || typeof c == "string")
          return;
        var p;
        if (typeof c == "function")
          p = c.propTypes;
        else if (typeof c == "object" && (c.$$typeof === d || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        c.$$typeof === f))
          p = c.propTypes;
        else
          return;
        if (p) {
          var g = O(c);
          sn(p, t.props, "prop", g, t);
        } else if (c.PropTypes !== void 0 && !an) {
          an = !0;
          var P = O(c);
          y("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", P || "Unknown");
        }
        typeof c.getDefaultProps == "function" && !c.getDefaultProps.isReactClassApproved && y("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function Vn(t) {
      {
        for (var c = Object.keys(t.props), p = 0; p < c.length; p++) {
          var g = c[p];
          if (g !== "children" && g !== "key") {
            Oe(t), y("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", g), Oe(null);
            break;
          }
        }
        t.ref !== null && (Oe(t), y("Invalid attribute `ref` supplied to `React.Fragment`."), Oe(null));
      }
    }
    var _n = {};
    function xn(t, c, p, g, P, L) {
      {
        var I = ae(t);
        if (!I) {
          var N = "";
          (t === void 0 || typeof t == "object" && t !== null && Object.keys(t).length === 0) && (N += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var te = qn();
          te ? N += te : N += yn();
          var x;
          t === null ? x = "null" : _(t) ? x = "array" : t !== void 0 && t.$$typeof === n ? (x = "<" + (O(t.type) || "Unknown") + " />", N = " Did you accidentally export a JSX literal instead of a component?") : x = typeof t, y("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", x, N);
        }
        var V = kn(t, c, p, P, L);
        if (V == null)
          return V;
        if (I) {
          var X = c.children;
          if (X !== void 0)
            if (g)
              if (_(X)) {
                for (var we = 0; we < X.length; we++)
                  jn(X[we], t);
                Object.freeze && Object.freeze(X);
              } else
                y("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              jn(X, t);
        }
        if (fe.call(c, "key")) {
          var Se = O(t), ne = Object.keys(c).filter(function(wn) {
            return wn !== "key";
          }), nn = ne.length > 0 ? "{key: someKey, " + ne.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!_n[Se + nn]) {
            var Tn = ne.length > 0 ? "{" + ne.join(": ..., ") + ": ...}" : "{}";
            y(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, nn, Se, Tn, Se), _n[Se + nn] = !0;
          }
        }
        return t === i ? Vn(V) : Un(V), V;
      }
    }
    function Hn(t, c, p) {
      return xn(t, c, p, !0);
    }
    function Dn(t, c, p) {
      return xn(t, c, p, !1);
    }
    var Rn = Dn, Mn = Hn;
    $o.Fragment = i, $o.jsx = Rn, $o.jsxs = Mn;
  })()), $o;
}
var Xv;
function iA() {
  return Xv || (Xv = 1, process.env.NODE_ENV === "production" ? yu.exports = tA() : yu.exports = rA()), yu.exports;
}
var re = iA();
const aA = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "createIssue" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "issueTitle" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "issueDescription" } }, type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "teamId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "projectId" } }, type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "statusId" } }, type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "priority" } }, type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Linear" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "issueCreate" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "input" }, value: { kind: "ObjectValue", fields: [{ kind: "ObjectField", name: { kind: "Name", value: "title" }, value: { kind: "Variable", name: { kind: "Name", value: "issueTitle" } } }, { kind: "ObjectField", name: { kind: "Name", value: "description" }, value: { kind: "Variable", name: { kind: "Name", value: "issueDescription" } } }, { kind: "ObjectField", name: { kind: "Name", value: "teamId" }, value: { kind: "Variable", name: { kind: "Name", value: "teamId" } } }, { kind: "ObjectField", name: { kind: "Name", value: "projectId" }, value: { kind: "Variable", name: { kind: "Name", value: "projectId" } } }, { kind: "ObjectField", name: { kind: "Name", value: "stateId" }, value: { kind: "Variable", name: { kind: "Name", value: "statusId" } } }, { kind: "ObjectField", name: { kind: "Name", value: "priority" }, value: { kind: "Variable", name: { kind: "Name", value: "priority" } } }] } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "success" } }, { kind: "Field", name: { kind: "Name", value: "issue" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "identifier" } }, { kind: "Field", name: { kind: "Name", value: "url" } }] } }] } }] } }] } }] }, oA = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "staticData" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Linear" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "teams" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "edges" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "node" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "organization" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "urlKey" } }] } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "issuePriorityValues" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "priority" } }, { kind: "Field", name: { kind: "Name", value: "label" } }] } }, { kind: "Field", name: { kind: "Name", value: "organization" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "urlKey" } }] } }] } }] } }] }, sA = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "teamData" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "teamId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Linear" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "team" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "id" }, value: { kind: "Variable", name: { kind: "Name", value: "teamId" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "projects" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "edges" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "node" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "states" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "edges" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "node" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "type" } }, { kind: "Field", name: { kind: "Name", value: "color" } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "templates" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "edges" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "node" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "type" } }, { kind: "Field", name: { kind: "Name", value: "templateData" } }] } }] } }] } }] } }] } }] } }] }, lA = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "searchIssues" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "issueQuery" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "after" } }, type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "first" } }, type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Linear" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "searchIssues" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "Variable", name: { kind: "Name", value: "first" } } }, { kind: "Argument", name: { kind: "Name", value: "after" }, value: { kind: "Variable", name: { kind: "Name", value: "after" } } }, { kind: "Argument", name: { kind: "Name", value: "term" }, value: { kind: "Variable", name: { kind: "Name", value: "issueQuery" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "edges" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "node" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "description" } }, { kind: "Field", name: { kind: "Name", value: "identifier" } }, { kind: "Field", name: { kind: "Name", value: "priority" } }, { kind: "Field", name: { kind: "Name", value: "priorityLabel" } }, { kind: "Field", name: { kind: "Name", value: "url" } }, { kind: "Field", name: { kind: "Name", value: "state" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "type" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "color" } }] } }, { kind: "Field", name: { kind: "Name", value: "assignee" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "displayName" } }, { kind: "Field", name: { kind: "Name", value: "avatarUrl" } }, { kind: "Field", name: { kind: "Name", value: "email" } }] } }, { kind: "Field", name: { kind: "Name", value: "labels" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "edges" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "node" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "color" } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "team" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "organization" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "urlKey" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "project" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "pageInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "hasNextPage" } }, { kind: "Field", name: { kind: "Name", value: "endCursor" } }] } }] } }] } }] } }] }, cA = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "searchLinkedIssues" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "linkedIssues" } }, type: { kind: "ListType", type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Linear" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "issues" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "filter" }, value: { kind: "ObjectValue", fields: [{ kind: "ObjectField", name: { kind: "Name", value: "id" }, value: { kind: "ObjectValue", fields: [{ kind: "ObjectField", name: { kind: "Name", value: "in" }, value: { kind: "Variable", name: { kind: "Name", value: "linkedIssues" } } }] } }] } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "edges" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "node" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "description" } }, { kind: "Field", name: { kind: "Name", value: "identifier" } }, { kind: "Field", name: { kind: "Name", value: "priority" } }, { kind: "Field", name: { kind: "Name", value: "priorityLabel" } }, { kind: "Field", name: { kind: "Name", value: "url" } }, { kind: "Field", name: { kind: "Name", value: "state" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "type" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "color" } }] } }, { kind: "Field", name: { kind: "Name", value: "assignee" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "displayName" } }, { kind: "Field", name: { kind: "Name", value: "avatarUrl" } }, { kind: "Field", name: { kind: "Name", value: "email" } }] } }, { kind: "Field", name: { kind: "Name", value: "labels" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "edges" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "node" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "color" } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "team" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "organization" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "urlKey" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "project" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }] } }] } }] } }] } }] }, dA = {
  "\n  mutation createIssue(\n    $issueTitle: String!\n    $issueDescription: String\n    $teamId: String!\n    $projectId: String\n    $statusId: String\n    $priority: Int\n  ) {\n    Linear {\n      issueCreate(\n        input: {\n          title: $issueTitle\n          description: $issueDescription\n          teamId: $teamId\n          projectId: $projectId\n          stateId: $statusId\n          priority: $priority\n        }\n      ) {\n        success\n        issue {\n          id\n          title\n          identifier\n          url\n        }\n      }\n    }\n  }\n": aA,
  "\n  query staticData {\n    Linear {\n      teams {\n        edges {\n          node {\n            id\n            name\n            organization {\n              urlKey\n            }\n          }\n        }\n      }\n      issuePriorityValues {\n        priority\n        label\n      }\n      organization {\n        urlKey\n      }\n    }\n  }\n": oA,
  "\n  query teamData($teamId: String!) {\n    Linear {\n      team(id: $teamId) {\n        projects {\n          edges {\n            node {\n              id\n              name\n            }\n          }\n        }\n        states {\n          edges {\n            node {\n              id\n              name\n              type\n              color\n            }\n          }\n        }\n        templates {\n          edges {\n            node {\n              id\n              name\n              type\n              templateData\n            }\n          }\n        }\n      }\n    }\n  }\n": sA,
  "\n  query searchIssues($issueQuery: String! $after: String, $first: Int ) {\n    Linear {\n      searchIssues(\n        first:$first\n        after:$after\n        term: $issueQuery\n      ) {\n        edges {\n          node {\n            id\n            title\n            description\n            identifier\n            priority\n            priorityLabel\n            url\n            state {\n              id\n              type\n              name\n              color\n            }\n            assignee {\n              name\n              displayName\n              avatarUrl\n              email\n            }\n            labels {\n              edges {\n                node {\n                  id\n                  name\n                  color\n                }\n              }\n            }\n            team {\n              name\n              organization {\n                urlKey\n              }\n            }\n            project {\n              id\n              name\n            }\n          }\n        }\n        pageInfo {\n          hasNextPage\n          endCursor\n        }\n      }\n    }\n  }\n": lA,
  "\n  query searchLinkedIssues($linkedIssues: [ID!]) {\n    Linear {\n      issues(filter: { id: { in: $linkedIssues } }) {\n        edges {\n          node {\n            id\n            title\n            description\n            identifier\n            priority\n            priorityLabel\n            url\n            state {\n              id\n              type\n              name\n              color\n            }\n            assignee {\n              name\n              displayName\n              avatarUrl\n              email\n            }\n            labels {\n              edges {\n                node {\n                  id\n                  name\n                  color\n                }\n              }\n            }\n            team {\n              name\n              organization {\n                urlKey\n              }\n            }\n            project {\n              id\n              name\n            }\n          }\n        }\n      }\n    }\n  }\n": cA
};
function yo(e) {
  return dA[e] ?? {};
}
const uA = yo(
  /* GraphQL */
  `
  query searchIssues($issueQuery: String! $after: String, $first: Int ) {
    Linear {
      searchIssues(
        first:$first
        after:$after
        term: $issueQuery
      ) {
        edges {
          node {
            id
            title
            description
            identifier
            priority
            priorityLabel
            url
            state {
              id
              type
              name
              color
            }
            assignee {
              name
              displayName
              avatarUrl
              email
            }
            labels {
              edges {
                node {
                  id
                  name
                  color
                }
              }
            }
            team {
              name
              organization {
                urlKey
              }
            }
            project {
              id
              name
            }
          }
        }
        pageInfo {
          hasNextPage
          endCursor
        }
      }
    }
  }
`
), mA = yo(
  /* GraphQL */
  `
  query searchLinkedIssues($linkedIssues: [ID!]) {
    Linear {
      issues(filter: { id: { in: $linkedIssues } }) {
        edges {
          node {
            id
            title
            description
            identifier
            priority
            priorityLabel
            url
            state {
              id
              type
              name
              color
            }
            assignee {
              name
              displayName
              avatarUrl
              email
            }
            labels {
              edges {
                node {
                  id
                  name
                  color
                }
              }
            }
            team {
              name
              organization {
                urlKey
              }
            }
            project {
              id
              name
            }
          }
        }
      }
    }
  }
`
), Do = ({
  title: e,
  children: n
}) => /* @__PURE__ */ re.jsxs(b, { flexDirection: "column", gap: "100", children: [
  /* @__PURE__ */ re.jsx(A.Paragraph, { variant: "5", color: "neutral.500", children: e }),
  n
] }), pA = "_issueAvatar_kc0sw_1", fA = "_issueField_kc0sw_9", hA = "_issueDescription_kc0sw_12", Ro = {
  issueAvatar: pA,
  issueField: fA,
  issueDescription: hA
}, Kx = ({ issue: e }) => /* @__PURE__ */ re.jsxs(re.Fragment, { children: [
  /* @__PURE__ */ re.jsx(Do, { title: "Assignee", children: /* @__PURE__ */ re.jsxs(
    b,
    {
      gap: "200",
      flexDirection: "row",
      alignContent: "center",
      className: Ro.issueAvatar,
      children: [
        /* @__PURE__ */ re.jsx(
          Vm,
          {
            size: "24",
            user: e.assignee ? {
              name: e.assignee.name || null,
              // eslint-disable-next-line camelcase
              avatar_url: e.assignee.avatarUrl || null,
              email: e.assignee.email
            } : void 0
          }
        ),
        /* @__PURE__ */ re.jsx(A.Heading, { variant: "heading-4", children: e.assignee ? e.assignee.name : "Unassigned" })
      ]
    }
  ) }),
  e.team?.name && /* @__PURE__ */ re.jsx(Do, { title: "Team", children: /* @__PURE__ */ re.jsx(
    A.Paragraph,
    {
      variant: "3",
      color: "neutral.800",
      className: Ro.issueField,
      children: e.team.name
    }
  ) }),
  e.project?.name && /* @__PURE__ */ re.jsx(Do, { title: "Project", children: /* @__PURE__ */ re.jsx(
    A.Paragraph,
    {
      variant: "3",
      color: "neutral.800",
      className: Ro.issueField,
      children: e.project.name
    }
  ) }),
  /* @__PURE__ */ re.jsx(Do, { title: "Description", children: /* @__PURE__ */ re.jsx(eA, { className: Ro.issueDescription, children: e.description }) })
] }), yA = /* @__PURE__ */ re.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "var(--dixa-color-neutral-500)",
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    "aria-label": "No Priority",
    "data-testid": "noPriorityIcon",
    children: [
      /* @__PURE__ */ re.jsx("rect", { width: "2", height: "2", rx: "1", transform: "matrix(-1 0 0 1 5 7)" }),
      /* @__PURE__ */ re.jsx("rect", { width: "2", height: "2", rx: "1", transform: "matrix(-1 0 0 1 8 7)" }),
      /* @__PURE__ */ re.jsx("rect", { width: "2", height: "2", rx: "1", transform: "matrix(-1 0 0 1 11 7)" })
    ]
  }
), gA = /* @__PURE__ */ re.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "var(--dixa-color-neutral-500)",
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    "aria-label": "Low Priority",
    children: [
      /* @__PURE__ */ re.jsx("rect", { x: "1", y: "8", width: "3", height: "6", rx: "1" }),
      /* @__PURE__ */ re.jsx("rect", { x: "6", y: "5", width: "3", height: "9", rx: "1", fillOpacity: "0.4" }),
      /* @__PURE__ */ re.jsx("rect", { x: "11", y: "2", width: "3", height: "12", rx: "1", fillOpacity: "0.4" })
    ]
  }
), vA = /* @__PURE__ */ re.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "var(--dixa-color-neutral-500)",
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    "aria-label": "Medium Priority",
    children: [
      /* @__PURE__ */ re.jsx("rect", { x: "1", y: "8", width: "3", height: "6", rx: "1" }),
      /* @__PURE__ */ re.jsx("rect", { x: "6", y: "5", width: "3", height: "9", rx: "1" }),
      /* @__PURE__ */ re.jsx("rect", { x: "11", y: "2", width: "3", height: "12", rx: "1", fillOpacity: "0.4" })
    ]
  }
), kA = /* @__PURE__ */ re.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "var(--dixa-color-neutral-500)",
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    "aria-label": "High Priority",
    children: [
      /* @__PURE__ */ re.jsx("rect", { x: "1", y: "8", width: "3", height: "6", rx: "1" }),
      /* @__PURE__ */ re.jsx("rect", { x: "6", y: "5", width: "3", height: "9", rx: "1" }),
      /* @__PURE__ */ re.jsx("rect", { x: "11", y: "2", width: "3", height: "12", rx: "1" })
    ]
  }
), bA = /* @__PURE__ */ re.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "16",
    height: "16",
    viewBox: "-1 -1 15 15",
    "aria-label": "Urgent Priority",
    fill: "var(--dixa-color-orange-400)",
    children: /* @__PURE__ */ re.jsx(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M2 0a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2V2a2 2 0 00-2-2H2zm3.914 3h1.738L7.5 8.602H6.07L5.914 3zm1.809 7.164a.95.95 0 01-.938.938.934.934 0 110-1.867c.5 0 .934.417.938.93z"
      }
    )
  }
), Gx = {
  0: yA,
  1: bA,
  2: kA,
  3: vA,
  4: gA
}, _A = (e) => e in Gx, Ss = ({ priority: e }) => _A(e) ? Gx[e] : /* @__PURE__ */ re.jsx(An, { "data-testid": "defaultPriorityTag", children: e }), xA = (e, n) => /* @__PURE__ */ re.jsx(
  "svg",
  {
    width: "14",
    height: "14",
    viewBox: "0 0 14 14",
    "aria-label": n,
    fill: e,
    "data-testid": "defaultStatusIcon",
    children: /* @__PURE__ */ re.jsx(
      "path",
      {
        d: "M13.9408 7.91426L11.9576 7.65557C11.9855 7.4419 12 7.22314 12 7C12 6.77686 11.9855 6.5581 11.9576 6.34443L13.9408 6.08573C13.9799 6.38496 14 6.69013 14 7C14 7.30987 13.9799 7.61504 13.9408 7.91426ZM13.4688 4.32049C13.2328 3.7514 12.9239 3.22019 12.5538 2.73851L10.968 3.95716C11.2328 4.30185 11.4533 4.68119 11.6214 5.08659L13.4688 4.32049ZM11.2615 1.4462L10.0428 3.03204C9.69815 2.76716 9.31881 2.54673 8.91341 2.37862L9.67951 0.531163C10.2486 0.767153 10.7798 1.07605 11.2615 1.4462ZM7.91426 0.0591659L7.65557 2.04237C7.4419 2.01449 7.22314 2 7 2C6.77686 2 6.5581 2.01449 6.34443 2.04237L6.08574 0.059166C6.38496 0.0201343 6.69013 0 7 0C7.30987 0 7.61504 0.0201343 7.91426 0.0591659ZM4.32049 0.531164L5.08659 2.37862C4.68119 2.54673 4.30185 2.76716 3.95716 3.03204L2.73851 1.4462C3.22019 1.07605 3.7514 0.767153 4.32049 0.531164ZM1.4462 2.73851L3.03204 3.95716C2.76716 4.30185 2.54673 4.68119 2.37862 5.08659L0.531164 4.32049C0.767153 3.7514 1.07605 3.22019 1.4462 2.73851ZM0.0591659 6.08574C0.0201343 6.38496 0 6.69013 0 7C0 7.30987 0.0201343 7.61504 0.059166 7.91426L2.04237 7.65557C2.01449 7.4419 2 7.22314 2 7C2 6.77686 2.01449 6.5581 2.04237 6.34443L0.0591659 6.08574ZM0.531164 9.67951L2.37862 8.91341C2.54673 9.31881 2.76716 9.69815 3.03204 10.0428L1.4462 11.2615C1.07605 10.7798 0.767153 10.2486 0.531164 9.67951ZM2.73851 12.5538L3.95716 10.968C4.30185 11.2328 4.68119 11.4533 5.08659 11.6214L4.32049 13.4688C3.7514 13.2328 3.22019 12.9239 2.73851 12.5538ZM6.08574 13.9408L6.34443 11.9576C6.5581 11.9855 6.77686 12 7 12C7.22314 12 7.4419 11.9855 7.65557 11.9576L7.91427 13.9408C7.61504 13.9799 7.30987 14 7 14C6.69013 14 6.38496 13.9799 6.08574 13.9408ZM9.67951 13.4688L8.91341 11.6214C9.31881 11.4533 9.69815 11.2328 10.0428 10.968L11.2615 12.5538C10.7798 12.9239 10.2486 13.2328 9.67951 13.4688ZM12.5538 11.2615L10.968 10.0428C11.2328 9.69815 11.4533 9.31881 11.6214 8.91341L13.4688 9.67951C13.2328 10.2486 12.924 10.7798 12.5538 11.2615Z",
        stroke: "none"
      }
    )
  }
), SA = (e, n) => /* @__PURE__ */ re.jsxs(
  "svg",
  {
    width: "14",
    height: "14",
    viewBox: "0 0 14 14",
    fill: "none",
    "aria-label": n,
    "data-testid": "unstartedStatusIcon",
    children: [
      /* @__PURE__ */ re.jsx(
        "rect",
        {
          x: "1",
          y: "1",
          width: "12",
          height: "12",
          rx: "6",
          stroke: e,
          strokeWidth: "2",
          fill: "none"
        }
      ),
      /* @__PURE__ */ re.jsx(
        "path",
        {
          fill: e,
          stroke: "none",
          d: "M 3.5,3.5 L3.5,0 A3.5,3.5 0 0,1 3.5, 0 z",
          transform: "translate(3.5,3.5)"
        }
      )
    ]
  }
), NA = (e, n) => /* @__PURE__ */ re.jsxs("svg", { width: "14", height: "14", viewBox: "0 0 14 14", fill: "none", "aria-label": n, children: [
  /* @__PURE__ */ re.jsx(
    "rect",
    {
      x: "1",
      y: "1",
      width: "12",
      height: "12",
      rx: "6",
      stroke: e,
      strokeWidth: "2",
      fill: "none"
    }
  ),
  /* @__PURE__ */ re.jsx(
    "path",
    {
      fill: e,
      stroke: "none",
      d: "M 3.5,3.5 L3.5,0 A3.5,3.5 0 0,1 3.5, 7 z",
      transform: "translate(3.5,3.5)"
    }
  )
] }), jA = (e, n) => /* @__PURE__ */ re.jsx(
  "svg",
  {
    width: "14",
    height: "14",
    viewBox: "0 0 14 14",
    "aria-label": n,
    fill: e,
    children: /* @__PURE__ */ re.jsx(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M7 0C3.13401 0 0 3.13401 0 7C0 10.866 3.13401 14 7 14C10.866 14 14 10.866 14 7C14 3.13401 10.866 0 7 0ZM11.101 5.10104C11.433 4.76909 11.433 4.23091 11.101 3.89896C10.7691 3.56701 10.2309 3.56701 9.89896 3.89896L5.5 8.29792L4.10104 6.89896C3.7691 6.56701 3.2309 6.56701 2.89896 6.89896C2.56701 7.2309 2.56701 7.7691 2.89896 8.10104L4.89896 10.101C5.2309 10.433 5.7691 10.433 6.10104 10.101L11.101 5.10104Z"
      }
    )
  }
), wA = (e, n) => /* @__PURE__ */ re.jsx(
  "svg",
  {
    width: "14",
    height: "14",
    viewBox: "0 0 14 14",
    "aria-label": n,
    fill: e,
    children: /* @__PURE__ */ re.jsx(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M7 14C10.866 14 14 10.866 14 7C14 3.13401 10.866 0 7 0C3.13401 0 0 3.13401 0 7C0 10.866 3.13401 14 7 14ZM5.03033 3.96967C4.73744 3.67678 4.26256 3.67678 3.96967 3.96967C3.67678 4.26256 3.67678 4.73744 3.96967 5.03033L5.93934 7L3.96967 8.96967C3.67678 9.26256 3.67678 9.73744 3.96967 10.0303C4.26256 10.3232 4.73744 10.3232 5.03033 10.0303L7 8.06066L8.96967 10.0303C9.26256 10.3232 9.73744 10.3232 10.0303 10.0303C10.3232 9.73744 10.3232 9.26256 10.0303 8.96967L8.06066 7L10.0303 5.03033C10.3232 4.73744 10.3232 4.26256 10.0303 3.96967C9.73744 3.67678 9.26256 3.67678 8.96967 3.96967L7 5.93934L5.03033 3.96967Z",
        stroke: "none"
      }
    )
  }
), CA = (e, n) => /* @__PURE__ */ re.jsx(
  "svg",
  {
    width: "14",
    height: "14",
    viewBox: "0 0 14 14",
    "aria-label": n,
    fill: e,
    children: /* @__PURE__ */ re.jsx(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M7 0C3.13401 0 0 3.13401 0 7C0 10.866 3.13401 14 7 14C10.866 14 14 10.866 14 7C14 3.13401 10.866 0 7 0ZM11.101 5.10104C11.433 4.76909 11.433 4.23091 11.101 3.89896C10.7691 3.56701 10.2309 3.56701 9.89896 3.89896L5.5 8.29792L4.10104 6.89896C3.7691 6.56701 3.2309 6.56701 2.89896 6.89896C2.56701 7.2309 2.56701 7.7691 2.89896 8.10104L4.89896 10.101C5.2309 10.433 5.7691 10.433 6.10104 10.101L11.101 5.10104Z"
      }
    )
  }
), gm = {
  backlog: (e, n) => xA(e, n),
  unstarted: (e, n) => SA(e, n),
  started: (e, n) => NA(e, n),
  done: (e, n) => jA(e, n),
  canceled: (e, n) => wA(e, n),
  completed: (e, n) => CA(e, n)
}, FA = (e) => e in gm, Ns = ({
  type: e = "backlog",
  color: n = "var(--dixa-color-neutral-400)",
  name: r = "linear-backlog-icon"
}) => FA(e) ? gm[e](n, r) : gm.backlog(
  "var(--dixa-color-neutral-400)",
  "linear-backlog-icon"
), IA = "_wrapper_e0qj3_1", EA = "_resultTitle_e0qj3_21", TA = "_resultTooltipTitle_e0qj3_28", $A = "_resultLinkIcon_e0qj3_31", ka = {
  wrapper: IA,
  resultTitle: EA,
  resultTooltipTitle: TA,
  resultLinkIcon: $A
}, DA = ({
  issue: e
}) => {
  const [n, r] = se(!1), {
    list: { isDisabled: i },
    item: { onSelect: a }
  } = Am(h0()), o = tt(
    (s) => {
      i || a({
        value: e,
        meta: {
          target: s?.target,
          event: s || void 0
        }
      });
    },
    [i, a, e]
  );
  return /* @__PURE__ */ re.jsx(
    Ge,
    {
      wrap: "none",
      side: "left",
      content: /* @__PURE__ */ re.jsxs(b, { flexDirection: "column", gap: "300", className: ka.wrapper, children: [
        /* @__PURE__ */ re.jsxs(b, { flexDirection: "row", justifyContent: "space-between", gap: "300", children: [
          /* @__PURE__ */ re.jsxs(b, { flexDirection: "row", gap: "200", alignItems: "center", children: [
            /* @__PURE__ */ re.jsx(
              Ns,
              {
                type: e.state.type,
                name: e.state.name,
                color: e.state.color
              }
            ),
            /* @__PURE__ */ re.jsx(A.Heading, { variant: "heading-3", children: e.identifier }),
            /* @__PURE__ */ re.jsx(Ss, { priority: e.priority })
          ] }),
          /* @__PURE__ */ re.jsx(An, { children: e.state.name })
        ] }),
        /* @__PURE__ */ re.jsxs(b, { gap: "200", flexDirection: "column", children: [
          /* @__PURE__ */ re.jsx(
            A.Heading,
            {
              variant: "heading-3",
              className: ka.resultTooltipTitle,
              children: e.title
            }
          ),
          /* @__PURE__ */ re.jsx(Kx, { issue: e })
        ] })
      ] }),
      light: !0,
      children: /* @__PURE__ */ re.jsx(
        st.Item,
        {
          value: e,
          noFixedSelectionStateSpace: !0,
          className: ka.result,
          onMouseEnter: () => r(!0),
          onMouseLeave: () => r(!1),
          "data-testid": "selectionListItemWrapper",
          onClick: o,
          children: /* @__PURE__ */ re.jsxs(
            b,
            {
              flexDirection: "column",
              style: {
                width: n ? "calc(100% - 32px)" : "100%"
              },
              children: [
                /* @__PURE__ */ re.jsxs(b, { flexDirection: "row", gap: "200", alignItems: "center", children: [
                  /* @__PURE__ */ re.jsx(
                    Ns,
                    {
                      type: e.state.type,
                      color: e.state.color,
                      name: e.state.name
                    }
                  ),
                  /* @__PURE__ */ re.jsx(A.Heading, { variant: "heading-3", children: e.identifier }),
                  /* @__PURE__ */ re.jsx(Ss, { priority: e.priority })
                ] }),
                /* @__PURE__ */ re.jsx(A.Paragraph, { variant: "4", className: ka.resultTitle, children: e.title }),
                n && /* @__PURE__ */ re.jsx(
                  me,
                  {
                    className: ka.resultLinkIcon,
                    name: "plus",
                    size: 32
                  }
                )
              ]
            }
          )
        },
        e.id
      )
    }
  );
}, RA = "_loader_13xpk_1", OA = "_dropdown_13xpk_8", PA = "_loadMore_13xpk_13", gu = {
  loader: RA,
  dropdown: OA,
  loadMore: PA
}, AA = ({
  handleSelect: e,
  linkedIssues: n
}) => {
  const [r, i] = se(), [a, o] = se([]), [s, l] = se(""), [d, m] = se(!1), { useLazyQuery: u } = mn(), [f, { data: h, loading: v, networkStatus: C }] = u(
    uA,
    {
      fetchPolicy: "no-cache",
      notifyOnNetworkStatusChange: !0
    }
  );
  ki(
    () => {
      !v && s !== "" && C === Yt.ready ? f({
        variables: {
          issueQuery: s,
          first: 8
        }
      }) : o([]);
    },
    500,
    [s]
  ), He(() => {
    v || o([]);
  }, [s]), He(() => {
    if (h && Object.keys(h).length > 0) {
      const j = h.Linear.searchIssues.edges.map(
        ({ node: T }) => T
      ), F = a.filter(
        (T) => !n.find((E) => E.id === T.id)
      ), y = F.filter(
        (T) => !j.find(
          (E) => E.id === T.id
        )
      ), q = j.filter(
        (T) => !n.find((E) => E.id === T.id)
      );
      n.length > 0 ? o(
        d ? [...y, ...q] : q
      ) : h?.Linear?.searchIssues?.edges && o(
        d ? [...F, ...j] : j
      ), h.Linear.searchIssues.pageInfo.hasNextPage && m(!1), i(h.Linear.searchIssues?.pageInfo);
    }
  }, [h, n]);
  const S = () => {
    !v && s !== "" && C === Yt.ready ? (m(!0), f({
      variables: {
        issueQuery: s,
        first: 8,
        after: r?.endCursor
      }
    })) : o([]);
  };
  return /* @__PURE__ */ re.jsx(b, { flexDirection: "column", gap: "200", "data-testid": "searchBarWrapper", children: /* @__PURE__ */ re.jsxs(
    Qr,
    {
      "data-testid": "searchBarComponent",
      clearable: !0,
      getItemTitleByValue: (j) => j?.title,
      onChange: (j) => e(j.selectedValues[0]),
      dropdownProps: { className: gu.dropdown },
      filter: {
        value: s,
        onChange: (j) => {
          const F = j.target.value;
          l(F);
        }
      },
      placeholder: "Search Linear issues",
      children: [
        a?.map((j) => /* @__PURE__ */ re.jsx(DA, { issue: j }, j.id)),
        r?.hasNextPage && !v && s !== "" && a.length && /* @__PURE__ */ re.jsx(
          b,
          {
            gap: "100",
            justifyContent: "center",
            padding: "200",
            alignItems: "center",
            onClick: () => S(),
            className: gu.loadMore,
            children: /* @__PURE__ */ re.jsx(A.Paragraph, { variant: "3", children: "Load more ..." })
          }
        ),
        v && s !== "" && /* @__PURE__ */ re.jsx(b, { justifyContent: "center", className: gu.loader, children: /* @__PURE__ */ re.jsx(cn, { size: 24 }) }),
        s === "" && a.length === 0 && /* @__PURE__ */ re.jsx(
          b,
          {
            justifyContent: "center",
            style: { margin: "var(--dixa-size-spacer-250)" },
            children: /* @__PURE__ */ re.jsx(A.Paragraph, { variant: "3", color: "neutral.400", children: "Enter issue title or description" })
          }
        ),
        a.length === 0 && s !== "" && !v && /* @__PURE__ */ re.jsx(
          b,
          {
            justifyContent: "center",
            style: { margin: "var(--dixa-size-spacer-250)" },
            children: /* @__PURE__ */ re.jsx(A.Paragraph, { variant: "3", color: "neutral.400", children: "No Linear issues found" })
          }
        )
      ]
    }
  ) });
}, LA = "_collapse_su0f9_1", VA = "_collapseHeader_su0f9_8", zA = "_collapseContent_su0f9_31", UA = "_url_su0f9_35", MA = "_externalLink_su0f9_51", BA = "_emptyState_su0f9_55", Yr = {
  collapse: LA,
  collapseHeader: VA,
  collapseContent: zA,
  url: UA,
  externalLink: MA,
  emptyState: BA
}, qA = ({
  linkedIssues: e,
  isLoading: n,
  handleUnlinkIssue: r,
  showUnlinkAllModal: i,
  showUnlinkAllButton: a,
  organizationUrl: o
}) => {
  const s = e.reduce(
    (u, f) => ({ ...u, [f.id]: !1 }),
    {}
  ), [l, d] = se(s), { track: m } = bn();
  return n ? /* @__PURE__ */ re.jsx(
    b,
    {
      flexDirection: "column",
      margin: "0 0 400 0",
      justifyContent: "center",
      alignItems: "center",
      children: /* @__PURE__ */ re.jsx(cn, { size: 24 })
    }
  ) : e.length === 0 ? /* @__PURE__ */ re.jsxs(
    b,
    {
      flexDirection: "column",
      justifyContent: "center",
      margin: "0 0 300 0",
      gap: "300",
      children: [
        /* @__PURE__ */ re.jsx(
          A.Paragraph,
          {
            align: "center",
            variant: "3",
            color: "neutral.400",
            className: Yr.emptyState,
            children: "No linked issues found"
          }
        ),
        /* @__PURE__ */ re.jsx(
          jt,
          {
            slotEnd: /* @__PURE__ */ re.jsx(me, { name: "external-link" }),
            variant: "tertiary",
            className: Yr.externalLink,
            navigate: () => window.open(
              `https://linear.app/${e[0]?.team?.organization.urlKey ?? ""}`,
              "_blank"
            )?.focus(),
            children: "Open Linear"
          }
        )
      ]
    }
  ) : /* @__PURE__ */ re.jsxs(
    b,
    {
      flexDirection: "column",
      gap: "250",
      margin: "0 0 400 0",
      "data-testid": "linkedIssueWrapper",
      children: [
        e.map((u) => {
          const f = l[u.id];
          return /* @__PURE__ */ re.jsxs(
            lr,
            {
              "data-testid": "collapseCard",
              onToggle: () => d({ ...l, [u.id]: !l[u.id] }),
              isOpen: f,
              className: Yr.collapse,
              children: [
                /* @__PURE__ */ re.jsx(lr.Header, { className: Yr.collapseHeader, children: /* @__PURE__ */ re.jsxs(b, { flexDirection: "column", gap: "100", children: [
                  /* @__PURE__ */ re.jsxs(b, { flexDirection: "row", justifyContent: "space-between", children: [
                    /* @__PURE__ */ re.jsxs(b, { gap: "100", alignItems: "center", children: [
                      /* @__PURE__ */ re.jsx(Ge, { content: /* @__PURE__ */ re.jsx(b, { children: u.state.name }), children: /* @__PURE__ */ re.jsx(b, { alignSelf: "center", children: /* @__PURE__ */ re.jsx(
                        Ns,
                        {
                          type: u.state.type,
                          color: u.state.color,
                          name: u.state.name
                        }
                      ) }) }),
                      /* @__PURE__ */ re.jsxs(
                        A.ExternalLink,
                        {
                          className: Yr.url,
                          href: u.url,
                          target: "_blank",
                          rel: "noreferrer",
                          children: [
                            u.identifier,
                            /* @__PURE__ */ re.jsx(me, { name: "external-link" })
                          ]
                        }
                      ),
                      /* @__PURE__ */ re.jsx(Ge, { content: /* @__PURE__ */ re.jsx(b, { children: u.priorityLabel }), children: /* @__PURE__ */ re.jsx(b, { alignSelf: "center", children: /* @__PURE__ */ re.jsx(Ss, { priority: u.priority }) }) })
                    ] }),
                    /* @__PURE__ */ re.jsx(An, { children: u.state.name })
                  ] }),
                  u.title
                ] }) }),
                /* @__PURE__ */ re.jsx(lr.Content, { className: Yr.collapseContent, children: /* @__PURE__ */ re.jsxs(b, { flexDirection: "column", gap: "300", children: [
                  u?.labels && u?.labels?.edges?.length > 0 && /* @__PURE__ */ re.jsx(
                    b,
                    {
                      flexDirection: "row",
                      gap: "200",
                      alignItems: "center",
                      flexWrap: "wrap",
                      children: u.labels?.edges.map((h) => /* @__PURE__ */ re.jsx(An, { color: h.node.color, children: h.node.name }, h.node.id))
                    }
                  ),
                  /* @__PURE__ */ re.jsx(Kx, { issue: u }),
                  /* @__PURE__ */ re.jsx(
                    Wn,
                    {
                      slotStart: /* @__PURE__ */ re.jsx(me, { name: "link-slash" }),
                      variant: "secondary",
                      onClick: () => r(u.id),
                      style: { marginTop: "var(--dixa-size-spacer-200)" },
                      children: "Unlink issue from Linear"
                    }
                  ),
                  /* @__PURE__ */ re.jsxs(
                    jt,
                    {
                      slotEnd: /* @__PURE__ */ re.jsx(me, { name: "external-link" }),
                      variant: "tertiary",
                      className: Yr.externalLink,
                      onClick: () => {
                        m("linear:open:issue:clicked", {
                          linearInstanceUrl: o,
                          linearIssueKey: u.id
                        });
                      },
                      navigate: () => window.open(u.url, "_blank")?.focus(),
                      children: [
                        "View ",
                        u.identifier,
                        " in Linear"
                      ]
                    }
                  )
                ] }) })
              ]
            },
            u.id
          );
        }),
        e.length > 1 && a && /* @__PURE__ */ re.jsx(
          Wn,
          {
            slotStart: /* @__PURE__ */ re.jsx(me, { name: "link-slash" }),
            variant: "secondary",
            onClick: () => i(!0),
            children: "Unlink all issues"
          }
        ),
        /* @__PURE__ */ re.jsx(
          jt,
          {
            slotEnd: /* @__PURE__ */ re.jsx(me, { name: "external-link" }),
            variant: "tertiary",
            className: Yr.externalLink,
            onClick: () => {
              m("linear:open:linear:clicked", {
                // we check against empty linkedIssues earlier in the code.
                // function is using item at index 0 since all teams belong in the same organization/workspace,
                linearInstanceUrl: o,
                linearIssueKey: e[0].id
              });
            },
            disabled: !o,
            navigate: () => window.open(o, "_blank")?.focus(),
            children: "Open Linear"
          }
        )
      ]
    }
  );
}, HA = {
  default: (e, n) => (n() ?? []).join(""),
  nodes: {
    doc: (e, n) => (n() ?? []).join(""),
    heading: (e, n) => `
${"#".repeat(
      parseInt(e.attrs?.level) || 1
    )} ${n()}

`,
    bullet_list: (e, n) => `
` + n().map((r) => `- ${r}`).join(""),
    ordered_list: (e, n) => `
` + n().map((r) => `1. ${r}`).join(""),
    // We're not emitting list items from the listItem formatter but from the
    // ordered/bullet list nodes above, as markdown does not encapsulate list items
    //listItem: (_node, children) => '- ' + children(),
    paragraph: (e, n) => n().join("") + `
`,
    text: (e) => e.text ?? "",
    hard_break: () => `
`,
    blockquote: (e, n) => `> ${n().join("")}
`,
    code_block: (e, n) => "\n```" + (e.attrs?.language || "") + `
` + n() + "\n```\n"
  },
  marks: {
    text: {
      strong: (e, n) => `**${n()}**`,
      strike: (e, n) => `~~${n()}~~`,
      subsup: (e, n) => {
        switch (e.attrs?.type) {
          case "sub":
            return `<sub>${n()}</sub>`;
          case "sup":
            return `<sup>${n()}</sup>`;
          default:
            return n();
        }
      },
      underline: (e, n) => `<u>${n()}</u>`,
      em: (e, n) => `*${n()}*`,
      link: (e, n) => `[${n()}](${e.attrs?.href})`,
      code: (e, n) => `\`${n()}\``
    }
  }
}, Yx = (e, n) => {
  const r = (o) => (e.marks || []).map((s) => ({
    formatterFunction: n.marks[e.type]?.[s.type],
    mark: s
  })).reduce(
    (s, l) => () => l.formatterFunction?.(l.mark, s) || o,
    () => o
  )(), i = (o, s) => () => o.content ? o.content.map((l) => Yx(l, s)) : [], a = n.nodes[e.type] || n.default;
  return r(
    a(e, i(e, n))
  );
}, WA = "_modalBody_iv3ua_1", KA = "_error_iv3ua_5", GA = "_dropdown_iv3ua_16", Ii = {
  modalBody: WA,
  error: KA,
  dropdown: GA
}, YA = yo(
  /* GraphQL */
  `
  mutation createIssue(
    $issueTitle: String!
    $issueDescription: String
    $teamId: String!
    $projectId: String
    $statusId: String
    $priority: Int
  ) {
    Linear {
      issueCreate(
        input: {
          title: $issueTitle
          description: $issueDescription
          teamId: $teamId
          projectId: $projectId
          stateId: $statusId
          priority: $priority
        }
      ) {
        success
        issue {
          id
          title
          identifier
          url
        }
      }
    }
  }
`
), QA = yo(
  /* GraphQL */
  `
  query staticData {
    Linear {
      teams {
        edges {
          node {
            id
            name
            organization {
              urlKey
            }
          }
        }
      }
      issuePriorityValues {
        priority
        label
      }
      organization {
        urlKey
      }
    }
  }
`
), JA = yo(
  /* GraphQL */
  `
  query teamData($teamId: String!) {
    Linear {
      team(id: $teamId) {
        projects {
          edges {
            node {
              id
              name
            }
          }
        }
        states {
          edges {
            node {
              id
              name
              type
              color
            }
          }
        }
        templates {
          edges {
            node {
              id
              name
              type
              templateData
            }
          }
        }
      }
    }
  }
`
), XA = ({
  setCreatedIssue: e,
  isCreateIssueModalOpen: n,
  setIsCreateIssueModalOpen: r,
  setIsCreationSuccessfulModalOpen: i,
  addToLinkedIssueIds: a,
  organizationUrl: o,
  setOrganizationUrl: s
}) => {
  const { useLazyQuery: l, showNotification: d } = mn(), { control: m, handleSubmit: u, reset: f } = Bt(), [h, v] = se([]), [C, S] = se(), [j, F] = se([]), [y, q] = se(), [T, E] = se([]), [D, B] = se(), [ee, J] = se([]), [ae, Q] = se(), [U, O] = se([]), [H, Z] = se(), [ye, ce] = se(!1), { useMutation: le } = mn(), { track: ue } = bn(), [W, { loading: ke }] = le(
    YA,
    {
      onError: () => {
        ce(!1), d({
          title: "Creation was not successful",
          text: "Please try again later or contact your admin.",
          icon: "exclamation-triangle-filled",
          severity: "warning"
        });
      },
      onCompleted: (Ie) => {
        const We = {
          identifier: Ie.Linear?.issueCreate?.issue?.identifier,
          url: Ie.Linear?.issueCreate?.issue?.url
        };
        Ie.Linear && Ie.Linear?.issueCreate?.issue?.id && (a(Ie.Linear?.issueCreate?.issue?.id), Ae(We), ce(!1), d({
          title: "Issue was created and linked to the conversation",
          text: `Issue ${Ie.Linear.issueCreate.issue.identifier} was created and added to the active conversation`,
          icon: "exclamation-triangle-filled",
          severity: "success"
        }), ue("linear:create:new:issue:confirmed", {
          linearInstanceUrl: o
        }));
      }
    }
  ), [
    Ee,
    { data: K, loading: qe, error: Be }
  ] = l(QA, {
    fetchPolicy: "no-cache",
    notifyOnNetworkStatusChange: !0,
    onError: () => d({
      title: "Error while fetching team ID",
      text: "Please try again later or contact your admin.",
      icon: "exclamation-triangle-filled",
      severity: "warning"
    }),
    onCompleted: (Ie) => {
      const We = Ie.Linear.teams.edges.map(
        ({ node: Ze }) => Ze
      );
      v(We), J(Ie.Linear.issuePriorityValues), s(`${s2}${Ie.Linear.organization.urlKey}`);
    }
  }), [Pe, { data: Me, loading: Fe }] = l(JA, {
    fetchPolicy: "no-cache",
    notifyOnNetworkStatusChange: !0,
    onError: () => d({
      title: "Error while fetching team projects",
      text: "Please try again later or contact your admin.",
      icon: "exclamation-triangle-filled",
      severity: "warning"
    }),
    onCompleted: (Ie) => {
      const We = Ie?.Linear?.team?.projects?.edges?.map(
        ({ node: fe }) => fe
      );
      F(We);
      const Ze = Ie?.Linear?.team?.states?.edges?.map(
        ({ node: fe }) => fe
      );
      E(Ze);
      const de = Ie?.Linear?.team?.templates?.edges?.map(
        ({ node: fe }) => fe
      );
      O(
        de.filter(
          (fe) => fe.type === "issue"
        )
      );
    }
  }), Ae = (Ie) => {
    r(!1), q(void 0), S(void 0), B(void 0), Q(void 0), Z(void 0), Ie && (e(Ie), i(!0)), f({
      title: "",
      description: "",
      projectId: "",
      teamId: "",
      statusId: "",
      priority: void 0
    });
  }, $e = (Ie) => {
    K && !qe && (W({
      variables: {
        issueTitle: Ie.title,
        issueDescription: Ie?.description,
        teamId: Ie.team.id,
        projectId: Ie?.project?.id,
        statusId: Ie?.status?.id,
        priority: Ie?.priority?.priority
      }
    }), ce(!0));
  };
  He(() => {
    n && Ee();
  }, [n]);
  const tn = () => {
    ue("linear:create:new:issue:cancelled", {
      linearInstanceUrl: o
    });
  };
  return /* @__PURE__ */ re.jsxs(
    wt,
    {
      isOpen: n,
      onClose: () => {
        tn(), Ae();
      },
      children: [
        /* @__PURE__ */ re.jsx(
          Ct,
          {
            title: "Create new Linear issue",
            onClose: () => {
              tn(), Ae();
            }
          }
        ),
        /* @__PURE__ */ re.jsx(
          Ft,
          {
            className: Ii.modalBody,
            "data-testid": "createIssueModalBody",
            children: Be ? /* @__PURE__ */ re.jsx(Fn, { error: Be }) : /* @__PURE__ */ re.jsx("form", { onSubmit: u($e), id: "issueCreationForm", children: /* @__PURE__ */ re.jsxs(vt, { children: [
              /* @__PURE__ */ re.jsx(ze, { span: 3, children: /* @__PURE__ */ re.jsx(
                zt,
                {
                  control: m,
                  name: "team",
                  rules: {
                    required: "Team is required"
                  },
                  render: ({
                    field: { value: Ie, onChange: We },
                    fieldState: { error: Ze }
                  }) => /* @__PURE__ */ re.jsx(
                    En,
                    {
                      required: !0,
                      label: "Team",
                      meta: {
                        error: Ze?.message ?? null
                      },
                      children: /* @__PURE__ */ re.jsx(
                        Qr,
                        {
                          dropdownProps: { className: Ii.dropdown },
                          placeholder: "Select Linear team",
                          className: rt({ [Ii.error]: Ze }),
                          getItemTitleByValue: (de) => de?.name,
                          onChange: (de) => {
                            q(void 0), B(void 0), Q(void 0), Z(void 0), S(de.selectedValues[0]), Pe({
                              variables: { teamId: de.selectedValues[0].id }
                            }), We(de.selectedValues[0]);
                          },
                          value: C ? [Ie] : void 0,
                          children: h?.map((de) => /* @__PURE__ */ re.jsx(
                            st.Item,
                            {
                              value: de,
                              noFixedSelectionStateSpace: !0,
                              children: /* @__PURE__ */ re.jsx(A.Paragraph, { children: de.name })
                            },
                            de.id
                          ))
                        }
                      )
                    }
                  )
                }
              ) }),
              /* @__PURE__ */ re.jsx(ze, { span: 3, children: /* @__PURE__ */ re.jsx(
                zt,
                {
                  control: m,
                  name: "project",
                  render: ({ field: { value: Ie, onChange: We } }) => {
                    const Ze = Fe ? [{ name: "Loading projects...", id: "" }] : void 0;
                    return /* @__PURE__ */ re.jsx(En, { label: "Project", children: /* @__PURE__ */ re.jsx(
                      Qr,
                      {
                        dropdownProps: { className: Ii.dropdown },
                        clearable: !0,
                        getItemTitleByValue: (de) => de?.name,
                        disabled: C === void 0,
                        placeholder: C ? "Select Linear project" : "Select a Team first",
                        onChange: (de) => {
                          q(de.selectedValues[0]), We(de.selectedValues[0]);
                        },
                        value: y ? [Ie] : Ze,
                        children: /* @__PURE__ */ re.jsxs(re.Fragment, { children: [
                          Fe && /* @__PURE__ */ re.jsx(
                            b,
                            {
                              justifyContent: "center",
                              style: {
                                padding: "var(--dixa-size-spacer-200)"
                              },
                              children: /* @__PURE__ */ re.jsx(cn, { size: 24 })
                            }
                          ),
                          Me && !Fe && j.map((de) => /* @__PURE__ */ re.jsx(
                            st.Item,
                            {
                              value: de,
                              noFixedSelectionStateSpace: !0,
                              children: /* @__PURE__ */ re.jsx(A.Paragraph, { children: de.name })
                            },
                            de.id
                          ))
                        ] })
                      }
                    ) });
                  }
                }
              ) }),
              /* @__PURE__ */ re.jsx(ze, { span: 6, children: /* @__PURE__ */ re.jsx(En, { label: "Template", children: /* @__PURE__ */ re.jsx(
                Qr,
                {
                  clearable: !0,
                  dropdownProps: { className: Ii.dropdown },
                  disabled: !C || Fe,
                  placeholder: C ? "Select template" : "Select a Team first",
                  getItemTitleByValue: (Ie) => Ie?.name,
                  onChange: (Ie) => {
                    if (Ie.selectedValues.length > 0) {
                      Z(Ie.selectedValues[0]);
                      const We = JSON.parse(
                        Ie.selectedValues[0].templateData
                      ), Ze = ee.filter(
                        (Le) => Le.priority === We.priority
                      );
                      Q(
                        Ze ? Ze[0] : void 0
                      );
                      const de = T.filter(
                        (Le) => Le.id === We.stateId
                      );
                      B(
                        de ? de[0] : void 0
                      );
                      const fe = j.filter(
                        (Le) => Le.id === We.projectId
                      );
                      q(
                        fe ? fe[0] : void 0
                      );
                      const Te = We.description;
                      f({
                        title: We?.title,
                        priority: Ze[0],
                        status: de[0],
                        project: fe[0],
                        description: Te ? Yx(Te, HA) : "",
                        team: C
                      });
                    } else
                      f({
                        title: "",
                        description: "",
                        team: C
                      }), q(void 0), Q(void 0), B(void 0), Z(void 0);
                  },
                  value: H ? [H] : void 0,
                  children: U?.map((Ie) => /* @__PURE__ */ re.jsx(
                    st.Item,
                    {
                      value: Ie,
                      noFixedSelectionStateSpace: !0,
                      children: /* @__PURE__ */ re.jsx(A.Paragraph, { children: Ie.name })
                    },
                    Ie.id
                  ))
                }
              ) }) }),
              /* @__PURE__ */ re.jsx(ze, { span: 6, children: /* @__PURE__ */ re.jsx(
                zt,
                {
                  control: m,
                  name: "title",
                  rules: {
                    required: "Title field is required",
                    minLength: 2
                  },
                  render: ({
                    field: { onChange: Ie, value: We },
                    fieldState: { error: Ze }
                  }) => /* @__PURE__ */ re.jsx(
                    cr,
                    {
                      required: !0,
                      label: "Title",
                      placeholder: "Insert issue title here",
                      input: {
                        name: "issueTitle",
                        value: We || "",
                        onChange: Ie
                      },
                      meta: {
                        error: Ze?.message ?? null
                      }
                    }
                  )
                }
              ) }),
              /* @__PURE__ */ re.jsx(ze, { span: 3, children: /* @__PURE__ */ re.jsx(
                zt,
                {
                  control: m,
                  name: "status",
                  render: ({ field: { value: Ie, onChange: We } }) => {
                    const Ze = Fe ? [
                      {
                        name: "Loading statuses...",
                        id: "",
                        type: "",
                        color: ""
                      }
                    ] : void 0;
                    return /* @__PURE__ */ re.jsx(En, { label: "Status", children: /* @__PURE__ */ re.jsx(
                      Qr,
                      {
                        dropdownProps: { className: Ii.dropdown },
                        clearable: !0,
                        getItemTitleByValue: (de) => de?.name,
                        disabled: C === void 0,
                        placeholder: C ? "Select Issue status" : "Select a Team first",
                        onChange: (de) => {
                          B(de.selectedValues[0]), We(de.selectedValues[0]);
                        },
                        value: D ? [Ie] : Ze,
                        children: /* @__PURE__ */ re.jsxs(re.Fragment, { children: [
                          Fe && /* @__PURE__ */ re.jsx(
                            b,
                            {
                              justifyContent: "center",
                              style: {
                                padding: "var(--dixa-size-spacer-200)"
                              },
                              children: /* @__PURE__ */ re.jsx(cn, { size: 24 })
                            }
                          ),
                          Me && !Fe && T.map((de) => /* @__PURE__ */ re.jsx(
                            st.Item,
                            {
                              value: de,
                              noFixedSelectionStateSpace: !0,
                              children: /* @__PURE__ */ re.jsxs(
                                b,
                                {
                                  flexDirection: "row",
                                  gap: "300",
                                  alignItems: "center",
                                  children: [
                                    /* @__PURE__ */ re.jsx(
                                      Ns,
                                      {
                                        type: de.type,
                                        color: de.color,
                                        name: de.name
                                      }
                                    ),
                                    /* @__PURE__ */ re.jsx(A.Paragraph, { children: de.name })
                                  ]
                                }
                              )
                            },
                            de.id
                          ))
                        ] })
                      }
                    ) });
                  }
                }
              ) }),
              /* @__PURE__ */ re.jsx(ze, { span: 3, children: /* @__PURE__ */ re.jsx(
                zt,
                {
                  control: m,
                  name: "priority",
                  render: ({ field: { value: Ie, onChange: We } }) => {
                    const Ze = qe ? [
                      {
                        label: "Loading Priorities...",
                        priority: 0
                      }
                    ] : void 0;
                    return /* @__PURE__ */ re.jsx(En, { label: "Priority", children: /* @__PURE__ */ re.jsx(
                      Qr,
                      {
                        clearable: !0,
                        getItemTitleByValue: (de) => de?.label,
                        disabled: C === void 0,
                        placeholder: C ? "Select Issue priority" : "Select a Team first",
                        onChange: (de) => {
                          Q(de.selectedValues[0]), We(de.selectedValues[0]);
                        },
                        value: ae ? [Ie] : Ze,
                        children: /* @__PURE__ */ re.jsxs(re.Fragment, { children: [
                          Fe && /* @__PURE__ */ re.jsx(
                            b,
                            {
                              justifyContent: "center",
                              style: {
                                padding: "var(--dixa-size-spacer-200)"
                              },
                              children: /* @__PURE__ */ re.jsx(cn, { size: 24 })
                            }
                          ),
                          K && !qe && ee.map((de) => /* @__PURE__ */ re.jsx(
                            st.Item,
                            {
                              value: de,
                              noFixedSelectionStateSpace: !0,
                              children: /* @__PURE__ */ re.jsxs(
                                b,
                                {
                                  flexDirection: "row",
                                  gap: "300",
                                  alignItems: "center",
                                  children: [
                                    /* @__PURE__ */ re.jsx(
                                      Ss,
                                      {
                                        priority: de.priority
                                      }
                                    ),
                                    /* @__PURE__ */ re.jsx(A.Paragraph, { children: de.label })
                                  ]
                                }
                              )
                            },
                            de.priority
                          ))
                        ] })
                      }
                    ) });
                  }
                }
              ) }),
              /* @__PURE__ */ re.jsx(ze, { children: /* @__PURE__ */ re.jsx(
                zt,
                {
                  control: m,
                  name: "description",
                  render: ({
                    field: { onChange: Ie, value: We },
                    fieldState: { error: Ze }
                  }) => /* @__PURE__ */ re.jsx(
                    p0,
                    {
                      label: "Description",
                      placeholder: "Insert Issue description here",
                      input: {
                        name: "description",
                        value: We || "",
                        onChange: Ie
                      },
                      meta: {
                        error: Ze?.message ?? null
                      }
                    }
                  )
                }
              ) })
            ] }) })
          }
        ),
        /* @__PURE__ */ re.jsx(
          Tt,
          {
            confirmOnClick: u($e),
            confirmProps: {
              disabled: ke || !K,
              isLoading: ye || qe || Fe,
              loadingIndicator: /* @__PURE__ */ re.jsx(cn, { size: 16 })
            },
            confirmName: "Save",
            cancelOnClick: () => {
              tn(), Ae();
            }
          }
        )
      ]
    }
  );
}, ZA = "_modalWrapper_4kh9u_1", e2 = "_copyButton_4kh9u_6", n2 = "_copyWrapper_4kh9u_15", t2 = "_copyField_4kh9u_24", r2 = "_externalLink_4kh9u_47", i2 = "_externalLinkIcon_4kh9u_52", a2 = "_textWrapper_4kh9u_56", ti = {
  modalWrapper: ZA,
  copyButton: e2,
  copyWrapper: n2,
  copyField: t2,
  externalLink: r2,
  externalLinkIcon: i2,
  textWrapper: a2
}, o2 = ({
  isCreationSuccessfulModalOpen: e,
  createdIssueData: n,
  setIsCreationSuccessfulModalOpen: r
}) => /* @__PURE__ */ re.jsxs(
  wt,
  {
    isOpen: !!n && e,
    className: ti.modalWrapper,
    onClose: () => r(!1),
    children: [
      /* @__PURE__ */ re.jsx(
        Ct,
        {
          title: "Issue creation successful",
          onClose: () => r(!1)
        }
      ),
      /* @__PURE__ */ re.jsx(Ft, { children: /* @__PURE__ */ re.jsxs(
        b,
        {
          gap: "300",
          flexDirection: "column",
          "data-testid": "creationSuccessfulModal",
          children: [
            /* @__PURE__ */ re.jsxs(A.Paragraph, { className: ti.textWrapper, children: [
              `You can visit issue ${n?.identifier} by following `,
              " ",
              /* @__PURE__ */ re.jsxs(
                A.ExternalLink,
                {
                  href: n?.url,
                  target: "_blank",
                  className: ti.externalLink,
                  children: [
                    "this link",
                    " ",
                    /* @__PURE__ */ re.jsx(me, { name: "external-link", className: ti.externalLinkIcon })
                  ]
                }
              ),
              "or copy it from the field below."
            ] }),
            /* @__PURE__ */ re.jsx(En, { label: "Linear issue link", children: /* @__PURE__ */ re.jsxs(
              b,
              {
                flexDirection: "row",
                alignItems: "center",
                "data-testid": "copyInputField",
                className: ti.copyWrapper,
                children: [
                  /* @__PURE__ */ re.jsx(
                    _r,
                    {
                      readOnly: !0,
                      value: n?.url,
                      className: ti.copyField
                    }
                  ),
                  /* @__PURE__ */ re.jsx(
                    f0,
                    {
                      className: ti.copyButton,
                      textToCopy: n?.url || "",
                      clickedProps: {
                        icon: "check-circle-filled"
                      }
                    }
                  )
                ]
              }
            ) })
          ]
        }
      ) }),
      /* @__PURE__ */ re.jsx(
        Tt,
        {
          cancelOnClick: () => r(!1),
          cancelProps: { variant: "primary" },
          cancelName: "Close"
        }
      )
    ]
  }
), s2 = "https://linear.app/", l2 = ({
  conversationContext: e,
  settings: n
}) => {
  const [r, i] = se([]), [a, o] = se([]), [s, l] = se(!1), [d, m] = se(!1), [u, f] = se(!1), [h, v] = se(), { useLazyQuery: C } = mn(), [S, j] = se(""), F = n?.enableCreateIssue, y = !!n?.enableUnlinkAll, { track: q } = bn(), {
    loading: T,
    data: E,
    error: D,
    store: B
  } = Em(e?.conversationId ?? null), [
    ee,
    {
      data: J,
      loading: ae,
      networkStatus: Q,
      error: U
    }
  ] = C(mA, {
    fetchPolicy: "no-cache",
    notifyOnNetworkStatusChange: !0
  });
  He(() => {
    !T && !D && E && E?.linear?.issues?.length > 0 ? (o(E.linear.issues), ee({
      variables: {
        linkedIssues: E.linear.issues
      }
    })) : !T && !D && (i([]), o([]));
  }, [E, T, D]), He(() => {
    J && J?.Linear && !ae && Q === Yt.ready && Object.keys(J).length > 0 && i(J.Linear.issues?.edges?.map(({ node: ce }) => ce));
  }, [J, ae, Q]);
  const O = (ce) => {
    ce && ce?.team?.organization?.urlKey && q("linear:link:issue:clicked", {
      linearInstanceUrl: S,
      linearIssueKey: ce.id
    });
    const le = (ue) => ue.id === ce?.id;
    r.some((ue) => ue && le(ue)) || (E && a.length === 0 && o([]), B({
      linear: {
        issues: [...a, ce.id]
      }
    }));
  }, H = (ce) => {
    const le = E?.linear.issues.filter((ue) => ue !== ce) || [];
    q("linear:unlink:issue:clicked", {
      linearInstanceUrl: S,
      linearIssueKey: ce
    }), i(r.filter(({ id: ue }) => ue !== ce)), o(le), B({
      linear: {
        issues: le
      }
    });
  }, Z = () => {
    l(!1), i([]), o([]), B({
      linear: {
        issues: []
      }
    });
  }, ye = T || ae || !E && !D || (E?.linear?.issues?.length ?? 0) > 0 && r.length === 0;
  return !T && !ae && (U || D) ? /* @__PURE__ */ re.jsx(Fn, { error: U || D }) : /* @__PURE__ */ re.jsxs(b, { flexDirection: "column", gap: "300", children: [
    /* @__PURE__ */ re.jsxs(
      wt,
      {
        isOpen: s,
        onClose: () => l(!1),
        children: [
          /* @__PURE__ */ re.jsx(
            Ct,
            {
              title: "Unlink all Linear issues?",
              onClose: () => l(!1)
            }
          ),
          /* @__PURE__ */ re.jsx(Ft, { "data-testid": "unlinkAllIssuesModalBody", children: "You are about to unlink all Linear issues from the conversation. Do you want to proceed?" }),
          /* @__PURE__ */ re.jsx(
            Tt,
            {
              confirmOnClick: () => Z(),
              confirmName: "Unlink all",
              cancelOnClick: () => l(!1)
            }
          )
        ]
      }
    ),
    /* @__PURE__ */ re.jsx(
      XA,
      {
        isCreateIssueModalOpen: d,
        setIsCreateIssueModalOpen: (ce) => m(ce),
        setIsCreationSuccessfulModalOpen: (ce) => f(ce),
        addToLinkedIssueIds: (ce) => {
          B({
            linear: {
              issues: [...a, ce]
            }
          });
        },
        setCreatedIssue: (ce) => v(ce),
        organizationUrl: S,
        setOrganizationUrl: (ce) => j(ce)
      }
    ),
    /* @__PURE__ */ re.jsx(
      o2,
      {
        isCreationSuccessfulModalOpen: u,
        setIsCreationSuccessfulModalOpen: (ce) => f(ce),
        createdIssueData: h
      }
    ),
    /* @__PURE__ */ re.jsxs(
      b,
      {
        flexDirection: "column",
        background: "neutral.100",
        padding: "300",
        borderRadius: "100",
        gap: "250",
        children: [
          F && /* @__PURE__ */ re.jsxs(re.Fragment, { children: [
            /* @__PURE__ */ re.jsx(
              Wn,
              {
                variant: "primary",
                onClick: () => {
                  q("linear:create:new:issue:clicked", {
                    linearInstanceUrl: S
                  }), m(!0);
                },
                style: { minHeight: "38px" },
                children: "Create new issue"
              }
            ),
            /* @__PURE__ */ re.jsx(A.Paragraph, { color: "neutral.600", align: "center", children: "or" })
          ] }),
          /* @__PURE__ */ re.jsx(AA, { handleSelect: O, linkedIssues: r })
        ]
      }
    ),
    /* @__PURE__ */ re.jsx(
      qA,
      {
        linkedIssues: r,
        isLoading: ye,
        handleUnlinkIssue: H,
        showUnlinkAllModal: (ce) => l(ce),
        showUnlinkAllButton: y,
        organizationUrl: S
      }
    )
  ] });
}, c2 = [
  {
    key: "enableCreateIssue",
    label: 'Enable the "Create issue" button',
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "enableUnlinkAll",
    label: 'Enable the "Unlink all" button',
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "authorizeWithOauth",
    label: "Authorize with OAuth",
    secret: !1,
    type: "custom",
    hideOnCreate: !0,
    component: vi
  }
], Zv = [
  {
    key: "enableCreateIssue",
    type: "boolean",
    secret: !1,
    defaultValue: !0
  },
  {
    key: "enableUnlinkAll",
    type: "boolean",
    secret: !1,
    defaultValue: !0
  }
], ri = "LINEAR", d2 = {
  enabled: !1,
  name: "",
  enableCreateIssue: !0,
  enableUnlinkAll: !0
}, u2 = ({
  integrationId: e,
  configuration: n,
  handleRedirect: r,
  showNotification: i,
  automationCouplingState: a
}) => {
  const o = !e, s = Bt({
    mode: "onChange",
    defaultValues: d2
  }), {
    create: l,
    update: d,
    remove: m,
    isLoading: u,
    error: f,
    misconfigurationCause: h,
    setMisconfigurationCause: v
  } = Tm({
    integrationId: e,
    integrationType: ri,
    handleRedirect: r,
    showNotification: i
  }), {
    isLoading: C,
    error: S,
    isWidgetUnknown: j,
    refetch: F
  } = $m({
    integrationId: e,
    fieldDefinitions: Zv,
    form: s,
    onMisconfigured: v
  }), y = (T) => Rm(T, {
    fieldDefinitions: Zv,
    isCreationMode: o,
    create: l,
    update: d
  }), q = s.watch("name");
  return /* @__PURE__ */ re.jsxs(
    Dm,
    {
      form: s,
      integrationId: e,
      onValidSubmit: y,
      error: S ?? f,
      onRetry: S ? F : void 0,
      isLoading: u || C,
      isWidgetUnknown: j,
      children: [
        h && /* @__PURE__ */ re.jsx(Om, { cause: h }),
        /* @__PURE__ */ re.jsxs(vt, { children: [
          /* @__PURE__ */ re.jsx(ze, { children: /* @__PURE__ */ re.jsx(En, { label: "Show the widget in the conversation sidebar", children: /* @__PURE__ */ re.jsx(
            sr,
            {
              name: "enabled",
              control: s.control
            }
          ) }) }),
          /* @__PURE__ */ re.jsx(ze, { span: 3, children: /* @__PURE__ */ re.jsx(
            gt,
            {
              name: "name",
              label: "Widget name",
              control: s.control,
              rules: { required: "Name is required" },
              componentProps: {
                placeholder: "Insert the name of the widget",
                autoComplete: "off"
              }
            }
          ) }),
          /* @__PURE__ */ re.jsx(ze, { span: 3 }),
          /* @__PURE__ */ re.jsx(ze, { span: 3, children: /* @__PURE__ */ re.jsx(En, { label: 'Enable the "Create issue" button', children: /* @__PURE__ */ re.jsx(
            sr,
            {
              name: "enableCreateIssue",
              control: s.control
            }
          ) }) }),
          /* @__PURE__ */ re.jsx(ze, { span: 3 }),
          /* @__PURE__ */ re.jsx(ze, { span: 3, children: /* @__PURE__ */ re.jsx(En, { label: 'Enable the "Unlink all" button', children: /* @__PURE__ */ re.jsx(
            sr,
            {
              name: "enableUnlinkAll",
              control: s.control
            }
          ) }) }),
          /* @__PURE__ */ re.jsx(ze, { span: 3 }),
          !o && e && /* @__PURE__ */ re.jsx(
            vi,
            {
              configuration: n,
              integrationId: e,
              integrationType: ri,
              label: "Authorize with OAuth"
            }
          )
        ] }),
        /* @__PURE__ */ re.jsx(
          Pm,
          {
            integrationType: ri,
            integrationId: e,
            widgetName: q,
            isCreationMode: o,
            isSubmitting: s.formState.isSubmitting,
            automationCouplingState: a,
            onConfirmDelete: () => m(),
            confirmDeleteVariant: "danger",
            deleteConfirmationBody: /* @__PURE__ */ re.jsxs(b, { gap: "400", children: [
              /* @__PURE__ */ re.jsx(
                me,
                {
                  size: 24,
                  name: "exclamation-triangle-filled",
                  color: "red.500"
                }
              ),
              /* @__PURE__ */ re.jsxs(b, { gap: "200", flexDirection: "column", children: [
                /* @__PURE__ */ re.jsxs(A.Heading, { withMarginBottom: !0, children: [
                  "By deleting the ",
                  ri,
                  " integration, all links between Dixa and ",
                  ri,
                  " are also deleted."
                ] }),
                /* @__PURE__ */ re.jsxs(A.Paragraph, { children: [
                  "All data in ",
                  ri,
                  " stays untouched."
                ] }),
                /* @__PURE__ */ re.jsxs(A.Paragraph, { children: [
                  "Are you sure you want to delete the ",
                  ri,
                  " ",
                  'integration "',
                  q,
                  '"?'
                ] })
              ] })
            ] })
          }
        )
      ]
    }
  );
};
(function() {
  try {
    if (typeof document < "u") {
      var e = document.createElement("style");
      e.appendChild(document.createTextNode("._wrapper_27vny_1{border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-300);background-color:var(--dixa-color-neutral-100)}._textVariant_27vny_7{color:var(--dixa-typography-color-secondary);font-size:var(--dixa-typography-size-300)}._copyIcon_27vny_12{cursor:pointer;color:var(--dixa-typography-color-secondary)}._labelText_1q5b5_1{color:var(--dixa-typography-color-secondary)}._list_1q5b5_5{padding:0}._listItem_1q5b5_8{padding:var(--dixa-size-spacer-100);border-bottom:var(--dixa-size-border-100) solid var(--dixa-color-neutral-200)}._listItem_1q5b5_8:last-child{border-bottom:none}._listItemEdit_1q5b5_15{cursor:pointer}._notificationText_1q5b5_19{color:var(--dixa-color-neutral-500)}._modalBody_1clhs_1{width:400px}._reward_1wxia_1{border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-250)}._reward_1wxia_1:hover{border-color:var(--dixa-color-neutral-400)}")), document.head.appendChild(e);
    }
  } catch (n) {
    console.error("vite-plugin-css-injected-by-js", n);
  }
})();
var vu = { exports: {} }, ba = {}, ek;
function m2() {
  if (ek) return ba;
  ek = 1;
  var e = je, n = Symbol.for("react.element"), r = Symbol.for("react.fragment"), i = Object.prototype.hasOwnProperty, a = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, o = { key: !0, ref: !0, __self: !0, __source: !0 };
  function s(l, d, m) {
    var u, f = {}, h = null, v = null;
    m !== void 0 && (h = "" + m), d.key !== void 0 && (h = "" + d.key), d.ref !== void 0 && (v = d.ref);
    for (u in d) i.call(d, u) && !o.hasOwnProperty(u) && (f[u] = d[u]);
    if (l && l.defaultProps) for (u in d = l.defaultProps, d) f[u] === void 0 && (f[u] = d[u]);
    return { $$typeof: n, type: l, key: h, ref: v, props: f, _owner: a.current };
  }
  return ba.Fragment = r, ba.jsx = s, ba.jsxs = s, ba;
}
var Oo = {}, nk;
function p2() {
  return nk || (nk = 1, process.env.NODE_ENV !== "production" && (function() {
    var e = je, n = Symbol.for("react.element"), r = Symbol.for("react.portal"), i = Symbol.for("react.fragment"), a = Symbol.for("react.strict_mode"), o = Symbol.for("react.profiler"), s = Symbol.for("react.provider"), l = Symbol.for("react.context"), d = Symbol.for("react.forward_ref"), m = Symbol.for("react.suspense"), u = Symbol.for("react.suspense_list"), f = Symbol.for("react.memo"), h = Symbol.for("react.lazy"), v = Symbol.for("react.offscreen"), C = Symbol.iterator, S = "@@iterator";
    function j(t) {
      if (t === null || typeof t != "object")
        return null;
      var c = C && t[C] || t[S];
      return typeof c == "function" ? c : null;
    }
    var F = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function y(t) {
      {
        for (var c = arguments.length, p = new Array(c > 1 ? c - 1 : 0), g = 1; g < c; g++)
          p[g - 1] = arguments[g];
        q("error", t, p);
      }
    }
    function q(t, c, p) {
      {
        var g = F.ReactDebugCurrentFrame, P = g.getStackAddendum();
        P !== "" && (c += "%s", p = p.concat([P]));
        var L = p.map(function(I) {
          return String(I);
        });
        L.unshift("Warning: " + c), Function.prototype.apply.call(console[t], console, L);
      }
    }
    var T = !1, E = !1, D = !1, B = !1, ee = !1, J;
    J = Symbol.for("react.module.reference");
    function ae(t) {
      return !!(typeof t == "string" || typeof t == "function" || t === i || t === o || ee || t === a || t === m || t === u || B || t === v || T || E || D || typeof t == "object" && t !== null && (t.$$typeof === h || t.$$typeof === f || t.$$typeof === s || t.$$typeof === l || t.$$typeof === d || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      t.$$typeof === J || t.getModuleId !== void 0));
    }
    function Q(t, c, p) {
      var g = t.displayName;
      if (g)
        return g;
      var P = c.displayName || c.name || "";
      return P !== "" ? p + "(" + P + ")" : p;
    }
    function U(t) {
      return t.displayName || "Context";
    }
    function O(t) {
      if (t == null)
        return null;
      if (typeof t.tag == "number" && y("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof t == "function")
        return t.displayName || t.name || null;
      if (typeof t == "string")
        return t;
      switch (t) {
        case i:
          return "Fragment";
        case r:
          return "Portal";
        case o:
          return "Profiler";
        case a:
          return "StrictMode";
        case m:
          return "Suspense";
        case u:
          return "SuspenseList";
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case l:
            var c = t;
            return U(c) + ".Consumer";
          case s:
            var p = t;
            return U(p._context) + ".Provider";
          case d:
            return Q(t, t.render, "ForwardRef");
          case f:
            var g = t.displayName || null;
            return g !== null ? g : O(t.type) || "Memo";
          case h: {
            var P = t, L = P._payload, I = P._init;
            try {
              return O(I(L));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var H = Object.assign, Z = 0, ye, ce, le, ue, W, ke, Ee;
    function K() {
    }
    K.__reactDisabledLog = !0;
    function qe() {
      {
        if (Z === 0) {
          ye = console.log, ce = console.info, le = console.warn, ue = console.error, W = console.group, ke = console.groupCollapsed, Ee = console.groupEnd;
          var t = {
            configurable: !0,
            enumerable: !0,
            value: K,
            writable: !0
          };
          Object.defineProperties(console, {
            info: t,
            log: t,
            warn: t,
            error: t,
            group: t,
            groupCollapsed: t,
            groupEnd: t
          });
        }
        Z++;
      }
    }
    function Be() {
      {
        if (Z--, Z === 0) {
          var t = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: H({}, t, {
              value: ye
            }),
            info: H({}, t, {
              value: ce
            }),
            warn: H({}, t, {
              value: le
            }),
            error: H({}, t, {
              value: ue
            }),
            group: H({}, t, {
              value: W
            }),
            groupCollapsed: H({}, t, {
              value: ke
            }),
            groupEnd: H({}, t, {
              value: Ee
            })
          });
        }
        Z < 0 && y("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var Pe = F.ReactCurrentDispatcher, Me;
    function Fe(t, c, p) {
      {
        if (Me === void 0)
          try {
            throw Error();
          } catch (P) {
            var g = P.stack.trim().match(/\n( *(at )?)/);
            Me = g && g[1] || "";
          }
        return `
` + Me + t;
      }
    }
    var Ae = !1, $e;
    {
      var tn = typeof WeakMap == "function" ? WeakMap : Map;
      $e = new tn();
    }
    function Ie(t, c) {
      if (!t || Ae)
        return "";
      {
        var p = $e.get(t);
        if (p !== void 0)
          return p;
      }
      var g;
      Ae = !0;
      var P = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var L;
      L = Pe.current, Pe.current = null, qe();
      try {
        if (c) {
          var I = function() {
            throw Error();
          };
          if (Object.defineProperty(I.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(I, []);
            } catch (ne) {
              g = ne;
            }
            Reflect.construct(t, [], I);
          } else {
            try {
              I.call();
            } catch (ne) {
              g = ne;
            }
            t.call(I.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (ne) {
            g = ne;
          }
          t();
        }
      } catch (ne) {
        if (ne && g && typeof ne.stack == "string") {
          for (var N = ne.stack.split(`
`), te = g.stack.split(`
`), x = N.length - 1, V = te.length - 1; x >= 1 && V >= 0 && N[x] !== te[V]; )
            V--;
          for (; x >= 1 && V >= 0; x--, V--)
            if (N[x] !== te[V]) {
              if (x !== 1 || V !== 1)
                do
                  if (x--, V--, V < 0 || N[x] !== te[V]) {
                    var X = `
` + N[x].replace(" at new ", " at ");
                    return t.displayName && X.includes("<anonymous>") && (X = X.replace("<anonymous>", t.displayName)), typeof t == "function" && $e.set(t, X), X;
                  }
                while (x >= 1 && V >= 0);
              break;
            }
        }
      } finally {
        Ae = !1, Pe.current = L, Be(), Error.prepareStackTrace = P;
      }
      var we = t ? t.displayName || t.name : "", Se = we ? Fe(we) : "";
      return typeof t == "function" && $e.set(t, Se), Se;
    }
    function We(t, c, p) {
      return Ie(t, !1);
    }
    function Ze(t) {
      var c = t.prototype;
      return !!(c && c.isReactComponent);
    }
    function de(t, c, p) {
      if (t == null)
        return "";
      if (typeof t == "function")
        return Ie(t, Ze(t));
      if (typeof t == "string")
        return Fe(t);
      switch (t) {
        case m:
          return Fe("Suspense");
        case u:
          return Fe("SuspenseList");
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case d:
            return We(t.render);
          case f:
            return de(t.type, c, p);
          case h: {
            var g = t, P = g._payload, L = g._init;
            try {
              return de(L(P), c, p);
            } catch {
            }
          }
        }
      return "";
    }
    var fe = Object.prototype.hasOwnProperty, Te = {}, Le = F.ReactDebugCurrentFrame;
    function Re(t) {
      if (t) {
        var c = t._owner, p = de(t.type, t._source, c ? c.type : null);
        Le.setExtraStackFrame(p);
      } else
        Le.setExtraStackFrame(null);
    }
    function sn(t, c, p, g, P) {
      {
        var L = Function.call.bind(fe);
        for (var I in t)
          if (L(t, I)) {
            var N = void 0;
            try {
              if (typeof t[I] != "function") {
                var te = Error((g || "React class") + ": " + p + " type `" + I + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof t[I] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw te.name = "Invariant Violation", te;
              }
              N = t[I](c, I, g, p, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (x) {
              N = x;
            }
            N && !(N instanceof Error) && (Re(P), y("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", g || "React class", p, I, typeof N), Re(null)), N instanceof Error && !(N.message in Te) && (Te[N.message] = !0, Re(P), y("Failed %s type: %s", p, N.message), Re(null));
          }
      }
    }
    var w = Array.isArray;
    function _(t) {
      return w(t);
    }
    function $(t) {
      {
        var c = typeof Symbol == "function" && Symbol.toStringTag, p = c && t[Symbol.toStringTag] || t.constructor.name || "Object";
        return p;
      }
    }
    function G(t) {
      try {
        return Y(t), !1;
      } catch {
        return !0;
      }
    }
    function Y(t) {
      return "" + t;
    }
    function R(t) {
      if (G(t))
        return y("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", $(t)), Y(t);
    }
    var z = F.ReactCurrentOwner, ie = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, pe, _e;
    function en(t) {
      if (fe.call(t, "ref")) {
        var c = Object.getOwnPropertyDescriptor(t, "ref").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.ref !== void 0;
    }
    function un(t) {
      if (fe.call(t, "key")) {
        var c = Object.getOwnPropertyDescriptor(t, "key").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.key !== void 0;
    }
    function rn(t, c) {
      typeof t.ref == "string" && z.current;
    }
    function dn(t, c) {
      {
        var p = function() {
          pe || (pe = !0, y("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "key", {
          get: p,
          configurable: !0
        });
      }
    }
    function pn(t, c) {
      {
        var p = function() {
          _e || (_e = !0, y("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "ref", {
          get: p,
          configurable: !0
        });
      }
    }
    var ln = function(t, c, p, g, P, L, I) {
      var N = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: n,
        // Built-in properties that belong on the element
        type: t,
        key: c,
        ref: p,
        props: I,
        // Record the component responsible for creating this element.
        _owner: L
      };
      return N._store = {}, Object.defineProperty(N._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(N, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: g
      }), Object.defineProperty(N, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: P
      }), Object.freeze && (Object.freeze(N.props), Object.freeze(N)), N;
    };
    function kn(t, c, p, g, P) {
      {
        var L, I = {}, N = null, te = null;
        p !== void 0 && (R(p), N = "" + p), un(c) && (R(c.key), N = "" + c.key), en(c) && (te = c.ref, rn(c));
        for (L in c)
          fe.call(c, L) && !ie.hasOwnProperty(L) && (I[L] = c[L]);
        if (t && t.defaultProps) {
          var x = t.defaultProps;
          for (L in x)
            I[L] === void 0 && (I[L] = x[L]);
        }
        if (N || te) {
          var V = typeof t == "function" ? t.displayName || t.name || "Unknown" : t;
          N && dn(I, V), te && pn(I, V);
        }
        return ln(t, N, te, P, g, z.current, I);
      }
    }
    var Xe = F.ReactCurrentOwner, Sn = F.ReactDebugCurrentFrame;
    function Oe(t) {
      if (t) {
        var c = t._owner, p = de(t.type, t._source, c ? c.type : null);
        Sn.setExtraStackFrame(p);
      } else
        Sn.setExtraStackFrame(null);
    }
    var an;
    an = !1;
    function on(t) {
      return typeof t == "object" && t !== null && t.$$typeof === n;
    }
    function yn() {
      {
        if (Xe.current) {
          var t = O(Xe.current.type);
          if (t)
            return `

Check the render method of \`` + t + "`.";
        }
        return "";
      }
    }
    function qn(t) {
      return "";
    }
    var Nn = {};
    function gn(t) {
      {
        var c = yn();
        if (!c) {
          var p = typeof t == "string" ? t : t.displayName || t.name;
          p && (c = `

Check the top-level render call using <` + p + ">.");
        }
        return c;
      }
    }
    function hn(t, c) {
      {
        if (!t._store || t._store.validated || t.key != null)
          return;
        t._store.validated = !0;
        var p = gn(c);
        if (Nn[p])
          return;
        Nn[p] = !0;
        var g = "";
        t && t._owner && t._owner !== Xe.current && (g = " It was passed a child from " + O(t._owner.type) + "."), Oe(t), y('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', p, g), Oe(null);
      }
    }
    function jn(t, c) {
      {
        if (typeof t != "object")
          return;
        if (_(t))
          for (var p = 0; p < t.length; p++) {
            var g = t[p];
            on(g) && hn(g, c);
          }
        else if (on(t))
          t._store && (t._store.validated = !0);
        else if (t) {
          var P = j(t);
          if (typeof P == "function" && P !== t.entries)
            for (var L = P.call(t), I; !(I = L.next()).done; )
              on(I.value) && hn(I.value, c);
        }
      }
    }
    function Un(t) {
      {
        var c = t.type;
        if (c == null || typeof c == "string")
          return;
        var p;
        if (typeof c == "function")
          p = c.propTypes;
        else if (typeof c == "object" && (c.$$typeof === d || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        c.$$typeof === f))
          p = c.propTypes;
        else
          return;
        if (p) {
          var g = O(c);
          sn(p, t.props, "prop", g, t);
        } else if (c.PropTypes !== void 0 && !an) {
          an = !0;
          var P = O(c);
          y("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", P || "Unknown");
        }
        typeof c.getDefaultProps == "function" && !c.getDefaultProps.isReactClassApproved && y("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function Vn(t) {
      {
        for (var c = Object.keys(t.props), p = 0; p < c.length; p++) {
          var g = c[p];
          if (g !== "children" && g !== "key") {
            Oe(t), y("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", g), Oe(null);
            break;
          }
        }
        t.ref !== null && (Oe(t), y("Invalid attribute `ref` supplied to `React.Fragment`."), Oe(null));
      }
    }
    var _n = {};
    function xn(t, c, p, g, P, L) {
      {
        var I = ae(t);
        if (!I) {
          var N = "";
          (t === void 0 || typeof t == "object" && t !== null && Object.keys(t).length === 0) && (N += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var te = qn();
          te ? N += te : N += yn();
          var x;
          t === null ? x = "null" : _(t) ? x = "array" : t !== void 0 && t.$$typeof === n ? (x = "<" + (O(t.type) || "Unknown") + " />", N = " Did you accidentally export a JSX literal instead of a component?") : x = typeof t, y("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", x, N);
        }
        var V = kn(t, c, p, P, L);
        if (V == null)
          return V;
        if (I) {
          var X = c.children;
          if (X !== void 0)
            if (g)
              if (_(X)) {
                for (var we = 0; we < X.length; we++)
                  jn(X[we], t);
                Object.freeze && Object.freeze(X);
              } else
                y("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              jn(X, t);
        }
        if (fe.call(c, "key")) {
          var Se = O(t), ne = Object.keys(c).filter(function(wn) {
            return wn !== "key";
          }), nn = ne.length > 0 ? "{key: someKey, " + ne.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!_n[Se + nn]) {
            var Tn = ne.length > 0 ? "{" + ne.join(": ..., ") + ": ...}" : "{}";
            y(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, nn, Se, Tn, Se), _n[Se + nn] = !0;
          }
        }
        return t === i ? Vn(V) : Un(V), V;
      }
    }
    function Hn(t, c, p) {
      return xn(t, c, p, !0);
    }
    function Dn(t, c, p) {
      return xn(t, c, p, !1);
    }
    var Rn = Dn, Mn = Hn;
    Oo.Fragment = i, Oo.jsx = Rn, Oo.jsxs = Mn;
  })()), Oo;
}
var tk;
function f2() {
  return tk || (tk = 1, process.env.NODE_ENV === "production" ? vu.exports = m2() : vu.exports = p2()), vu.exports;
}
var De = f2();
const h2 = { kind: "Document", definitions: [{ kind: "FragmentDefinition", name: { kind: "Name", value: "BadRequest" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_BadRequest" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }] }, y2 = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "addPoints" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "merchantId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "input" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_updateCustomersPoints_request_Input" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "LoyaltyLion" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "updateCustomersPoints" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "merchant_id" }, value: { kind: "Variable", name: { kind: "Name", value: "merchantId" } } }, { kind: "Argument", name: { kind: "Name", value: "input" }, value: { kind: "Variable", name: { kind: "Name", value: "input" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_updateCustomersPoints_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "UpdateCustomersPointsResponse" } }] } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "BadRequest" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_BadRequest" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "Unauthorized" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_Unauthorized" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "Forbidden" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_Forbidden" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "NotFound" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_NotFound" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "UnprocessableEntity" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_UnprocessableEntity" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ServerError" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_ServerError" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "UpdateCustomersPointsResponse" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_updateCustomersPoints_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "BadRequest" } }, { kind: "FragmentSpread", name: { kind: "Name", value: "Unauthorized" } }, { kind: "FragmentSpread", name: { kind: "Name", value: "Forbidden" } }, { kind: "FragmentSpread", name: { kind: "Name", value: "NotFound" } }, { kind: "FragmentSpread", name: { kind: "Name", value: "UnprocessableEntity" } }, { kind: "FragmentSpread", name: { kind: "Name", value: "ServerError" } }] } }] }, g2 = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "removePoints" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "merchantId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "input" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_removeCustomersPoints_request_Input" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "LoyaltyLion" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "removeCustomersPoints" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "merchant_id" }, value: { kind: "Variable", name: { kind: "Name", value: "merchantId" } } }, { kind: "Argument", name: { kind: "Name", value: "input" }, value: { kind: "Variable", name: { kind: "Name", value: "input" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_removeCustomersPoints_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "RemoveCustomersPointsResponse" } }] } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "BadRequest" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_BadRequest" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "Unauthorized" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_Unauthorized" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "Forbidden" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_Forbidden" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "NotFound" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_NotFound" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "UnprocessableEntity" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_UnprocessableEntity" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ServerError" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_ServerError" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "RemoveCustomersPointsResponse" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_removeCustomersPoints_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "BadRequest" } }, { kind: "FragmentSpread", name: { kind: "Name", value: "Unauthorized" } }, { kind: "FragmentSpread", name: { kind: "Name", value: "Forbidden" } }, { kind: "FragmentSpread", name: { kind: "Name", value: "NotFound" } }, { kind: "FragmentSpread", name: { kind: "Name", value: "UnprocessableEntity" } }, { kind: "FragmentSpread", name: { kind: "Name", value: "ServerError" } }] } }] }, v2 = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getCustomers" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "email" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "LoyaltyLion" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "getCustomers" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "email" }, value: { kind: "Variable", name: { kind: "Name", value: "email" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_getCustomers_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_Customers" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "customers" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "merchant_id" } }, { kind: "Field", name: { kind: "Name", value: "email" } }, { kind: "Field", name: { kind: "Name", value: "points_approved" } }, { kind: "Field", name: { kind: "Name", value: "points_pending" } }, { kind: "Field", name: { kind: "Name", value: "points_spent" } }, { kind: "Field", name: { kind: "Name", value: "rewards_claimed" } }, { kind: "Field", name: { kind: "Name", value: "birthday" } }, { kind: "Field", name: { kind: "Name", value: "guest" } }, { kind: "Field", name: { kind: "Name", value: "blocked" } }, { kind: "Field", name: { kind: "Name", value: "enrolled" } }, { kind: "Field", name: { kind: "Name", value: "enrolled_at" } }, { kind: "Field", name: { kind: "Name", value: "referral_id" } }, { kind: "Field", name: { kind: "Name", value: "referred_by" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "merchant_id" } }] } }, { kind: "Field", name: { kind: "Name", value: "loyalty_tier_membership" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "started_at" } }, { kind: "Field", name: { kind: "Name", value: "expires_at" } }, { kind: "Field", name: { kind: "Name", value: "manual" } }, { kind: "Field", name: { kind: "Name", value: "loyalty_tier" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "position" } }, { kind: "Field", name: { kind: "Name", value: "default" } }, { kind: "Field", name: { kind: "Name", value: "hidden" } }, { kind: "Field", name: { kind: "Name", value: "lower_bound" } }, { kind: "Field", name: { kind: "Name", value: "upper_bound" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "insights_segment" } }, { kind: "Field", name: { kind: "Name", value: "referral_url" } }, { kind: "Field", name: { kind: "Name", value: "metadata" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "shopify_source_url" } }] } }, { kind: "Field", name: { kind: "Name", value: "properties" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "first_name" } }, { kind: "Field", name: { kind: "Name", value: "last_name" } }] } }] } }] } }] } }] } }] } }] } }] }, k2 = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getRewards" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "merchantId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "LoyaltyLion" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "getAvailableRewards" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "merchant_id" }, value: { kind: "Variable", name: { kind: "Name", value: "merchantId" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_getAvailableRewards_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_Rewards" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "rewards" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "description" } }, { kind: "Field", name: { kind: "Name", value: "site_id" } }, { kind: "Field", name: { kind: "Name", value: "target_site" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "url" } }] } }, { kind: "Field", name: { kind: "Name", value: "content" } }, { kind: "Field", name: { kind: "Name", value: "kind" } }, { kind: "Field", name: { kind: "Name", value: "point_cost" } }] } }] } }, { kind: "FragmentSpread", name: { kind: "Name", value: "BadRequest" } }, { kind: "FragmentSpread", name: { kind: "Name", value: "Unauthorized" } }, { kind: "FragmentSpread", name: { kind: "Name", value: "Forbidden" } }, { kind: "FragmentSpread", name: { kind: "Name", value: "NotFound" } }, { kind: "FragmentSpread", name: { kind: "Name", value: "ServerError" } }] } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "BadRequest" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_BadRequest" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "Unauthorized" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_Unauthorized" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "Forbidden" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_Forbidden" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "NotFound" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_NotFound" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ServerError" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_ServerError" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }] }, b2 = {
  "\n  fragment BadRequest on LoyaltyLion_BadRequest {\n    message\n  }\n  fragment Unauthorized on LoyaltyLion_Unauthorized {\n    message\n  }\n  fragment Forbidden on LoyaltyLion_Forbidden {\n    message\n  }\n  fragment NotFound on LoyaltyLion_NotFound {\n    message\n  }\n  fragment UnprocessableEntity on LoyaltyLion_UnprocessableEntity {\n    message\n  }\n  fragment ServerError on LoyaltyLion_ServerError {\n    message\n  }\n\n  fragment UpdateCustomersPointsResponse on LoyaltyLion_updateCustomersPoints_response {\n    ...BadRequest\n    ...Unauthorized\n    ...Forbidden\n    ...NotFound\n    ...UnprocessableEntity\n    ...ServerError\n  }\n\n  fragment RemoveCustomersPointsResponse on LoyaltyLion_removeCustomersPoints_response {\n    ...BadRequest\n    ...Unauthorized\n    ...Forbidden\n    ...NotFound\n    ...UnprocessableEntity\n    ...ServerError\n  }\n": h2,
  "\n  mutation addPoints(\n    $merchantId: String!\n    $input: LoyaltyLion_updateCustomersPoints_request_Input!\n  ) {\n    LoyaltyLion {\n      updateCustomersPoints(merchant_id: $merchantId, input: $input) {\n        ... on LoyaltyLion_updateCustomersPoints_response {\n          ...UpdateCustomersPointsResponse\n        }\n      }\n    }\n  }\n": y2,
  "\n  mutation removePoints(\n    $merchantId: String!\n    $input: LoyaltyLion_removeCustomersPoints_request_Input!\n  ) {\n    LoyaltyLion {\n      removeCustomersPoints(merchant_id: $merchantId, input: $input) {\n        ... on LoyaltyLion_removeCustomersPoints_response {\n          ...RemoveCustomersPointsResponse\n        }\n      }\n    }\n  }\n": g2,
  "\n  query getCustomers($email: String!) {\n    LoyaltyLion {\n      getCustomers(email: $email) {\n        ... on LoyaltyLion_getCustomers_response {\n          ... on LoyaltyLion_Customers {\n            customers {\n              id\n              merchant_id\n              email\n              points_approved\n              points_pending\n              points_spent\n              rewards_claimed\n              birthday\n              guest\n              blocked\n              enrolled\n              enrolled_at\n              referral_id\n              referred_by {\n                id\n                merchant_id\n              }\n              loyalty_tier_membership {\n                started_at\n                expires_at\n                manual\n                loyalty_tier {\n                  id\n                  name\n                  position\n                  default\n                  hidden\n                  lower_bound\n                  upper_bound\n                }\n              }\n              insights_segment\n              referral_url\n              metadata {\n                shopify_source_url\n              }\n              properties {\n                name\n                first_name\n                last_name\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n": v2,
  "\n  query getRewards($merchantId: String!) {\n    LoyaltyLion {\n      getAvailableRewards(merchant_id: $merchantId) {\n        ... on LoyaltyLion_getAvailableRewards_response {\n          ... on LoyaltyLion_Rewards {\n            rewards {\n              id\n              title\n              description\n              site_id\n              target_site {\n                id\n                name\n                url\n              }\n              content\n              kind\n              point_cost\n            }\n          }\n          ...BadRequest\n          ...Unauthorized\n          ...Forbidden\n          ...NotFound\n          ...ServerError\n        }\n      }\n    }\n  }\n": k2
};
function Zs(e) {
  return b2[e] ?? {};
}
const _2 = Zs(
  /* GraphQL */
  `
  query getCustomers($email: String!) {
    LoyaltyLion {
      getCustomers(email: $email) {
        ... on LoyaltyLion_getCustomers_response {
          ... on LoyaltyLion_Customers {
            customers {
              id
              merchant_id
              email
              points_approved
              points_pending
              points_spent
              rewards_claimed
              birthday
              guest
              blocked
              enrolled
              enrolled_at
              referral_id
              referred_by {
                id
                merchant_id
              }
              loyalty_tier_membership {
                started_at
                expires_at
                manual
                loyalty_tier {
                  id
                  name
                  position
                  default
                  hidden
                  lower_bound
                  upper_bound
                }
              }
              insights_segment
              referral_url
              metadata {
                shopify_source_url
              }
              properties {
                name
                first_name
                last_name
              }
            }
          }
        }
      }
    }
  }
`
), x2 = Zs(
  /* GraphQL */
  `
  query getRewards($merchantId: String!) {
    LoyaltyLion {
      getAvailableRewards(merchant_id: $merchantId) {
        ... on LoyaltyLion_getAvailableRewards_response {
          ... on LoyaltyLion_Rewards {
            rewards {
              id
              title
              description
              site_id
              target_site {
                id
                name
                url
              }
              content
              kind
              point_cost
            }
          }
          ...BadRequest
          ...Unauthorized
          ...Forbidden
          ...NotFound
          ...ServerError
        }
      }
    }
  }
`
), S2 = Zs(
  /* GraphQL */
  `
  mutation addPoints(
    $merchantId: String!
    $input: LoyaltyLion_updateCustomersPoints_request_Input!
  ) {
    LoyaltyLion {
      updateCustomersPoints(merchant_id: $merchantId, input: $input) {
        ... on LoyaltyLion_updateCustomersPoints_response {
          ...UpdateCustomersPointsResponse
        }
      }
    }
  }
`
), N2 = Zs(
  /* GraphQL */
  `
  mutation removePoints(
    $merchantId: String!
    $input: LoyaltyLion_removeCustomersPoints_request_Input!
  ) {
    LoyaltyLion {
      removeCustomersPoints(merchant_id: $merchantId, input: $input) {
        ... on LoyaltyLion_removeCustomersPoints_response {
          ...RemoveCustomersPointsResponse
        }
      }
    }
  }
`
);
function ku(e = !1, n) {
  const [r, i] = se(e);
  return He(() => {
    const a = r ? window.setTimeout(() => i(!1), 2e3) : void 0;
    return () => window.clearTimeout(a);
  }, [n, r]), { isCopied: r, copy: (a) => {
    navigator.clipboard.writeText(a), i(!0);
  } };
}
const j2 = "_wrapper_27vny_1", w2 = "_copyIcon_27vny_12", _a = {
  wrapper: j2,
  copyIcon: w2
}, C2 = ({
  customer: e
}) => {
  const { isCopied: n, copy: r } = ku(), { isCopied: i, copy: a } = ku(), { isCopied: o, copy: s } = ku();
  if (!e)
    return null;
  const l = 14, {
    email: d,
    properties: m,
    metadata: u,
    birthday: f,
    created_at: h,
    enrolled: v,
    enrolled_at: C,
    referral_url: S
  } = e, j = f ? Ln(f).isSame(Date.now(), "day") : !1, { name: F, first_name: y, last_name: q } = m ?? {}, T = F ?? (`${y} ${q}`.trim() || "A customer has no name"), E = u?.shopify_source_url ? u.shopify_source_url.startsWith("https://") ? u.shopify_source_url : `https://${u.shopify_source_url}` : "";
  return /* @__PURE__ */ De.jsx(b, { gap: "300", flexDirection: "column", children: /* @__PURE__ */ De.jsxs(b, { className: _a.wrapper, gap: "250", flexDirection: "column", children: [
    /* @__PURE__ */ De.jsxs(
      b,
      {
        justifyContent: "space-between",
        className: _a.block,
        alignItems: "center",
        children: [
          /* @__PURE__ */ De.jsx(A.Heading, { variant: "heading-2", children: T }),
          j && /* @__PURE__ */ De.jsx(A.Paragraph, { variant: "4", color: "primary", children: "... has birthday today 🥳" })
        ]
      }
    ),
    h && /* @__PURE__ */ De.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
      /* @__PURE__ */ De.jsx(A.Paragraph, { variant: "4", color: "secondary", children: "Member since" }),
      /* @__PURE__ */ De.jsx(A.Paragraph, { variant: "4", color: "secondary", children: Ln(h).format("DD MMM YYYY @ HH:mm") })
    ] }),
    v && /* @__PURE__ */ De.jsx(b, { gap: "200", children: /* @__PURE__ */ De.jsxs(A.Paragraph, { variant: "4", color: "secondary", children: [
      "Enrolled since ",
      Ln(C).format("DD MMM YYYY @ HH:mm")
    ] }) }),
    /* @__PURE__ */ De.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
      /* @__PURE__ */ De.jsxs(b, { alignItems: "center", gap: "200", children: [
        /* @__PURE__ */ De.jsx(me, { size: l, name: "mail" }),
        /* @__PURE__ */ De.jsx(A.ExternalLink, { href: `mailto:${d}`, children: d })
      ] }),
      /* @__PURE__ */ De.jsx(Ge, { content: n ? "Copied" : "Copy", children: /* @__PURE__ */ De.jsx(
        me,
        {
          size: l,
          name: n ? "done" : "copy",
          onClick: () => r(d),
          className: _a.copyIcon
        }
      ) })
    ] }),
    E && /* @__PURE__ */ De.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
      /* @__PURE__ */ De.jsxs(b, { alignItems: "center", gap: "200", children: [
        /* @__PURE__ */ De.jsx(me, { size: l, name: "link" }),
        /* @__PURE__ */ De.jsx(Ge, { content: "Shopify shop", children: /* @__PURE__ */ De.jsx(
          A.ExternalLink,
          {
            href: E,
            target: "_blank",
            rel: "noreferrer",
            children: E.replace("https://", "")
          }
        ) })
      ] }),
      /* @__PURE__ */ De.jsx(Ge, { content: i ? "Copied" : "Copy", children: /* @__PURE__ */ De.jsx(
        me,
        {
          size: l,
          name: i ? "done" : "copy",
          onClick: () => a(E),
          className: _a.copyIcon
        }
      ) })
    ] }),
    S && /* @__PURE__ */ De.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
      /* @__PURE__ */ De.jsxs(b, { alignItems: "center", gap: "200", children: [
        /* @__PURE__ */ De.jsx(me, { size: l, name: "external-link" }),
        /* @__PURE__ */ De.jsx(Ge, { content: "Referral link", children: /* @__PURE__ */ De.jsx(
          A.ExternalLink,
          {
            href: S,
            target: "_blank",
            rel: "noreferrer",
            children: S.replace("https://", "")
          }
        ) })
      ] }),
      /* @__PURE__ */ De.jsx(Ge, { content: o ? "Copied" : "Copy", children: /* @__PURE__ */ De.jsx(
        me,
        {
          size: l,
          name: o ? "done" : "copy",
          onClick: () => s(S),
          className: _a.copyIcon
        }
      ) })
    ] })
  ] }) });
}, F2 = "_list_1q5b5_5", I2 = "_listItem_1q5b5_8", E2 = "_listItemEdit_1q5b5_15", T2 = "_notificationText_1q5b5_19", qi = {
  list: F2,
  listItem: I2,
  listItemEdit: E2,
  notificationText: T2
}, $2 = "_modalBody_1clhs_1", D2 = {
  modalBody: $2
}, R2 = ({
  isOpen: e,
  points: n,
  merchantId: r,
  onClose: i,
  refetchCustomerData: a
}) => {
  const { useMutation: o, showNotification: s } = mn(), { track: l } = bn(), [d, m] = se(n), [u, f] = se(""), [h, v] = se(), [C, { loading: S }] = o(
    S2,
    {
      onCompleted: () => {
        s({
          title: "Success",
          text: "Added points successfully",
          icon: "check-circle-filled",
          severity: "success"
        }), l("loyaltylion:add:points:succeeded"), Q();
      }
    }
  ), [j, { loading: F }] = o(N2), y = S || F, q = !!h, T = n === d ? "Change the value to update the points" : "", E = isNaN(d), D = E ? "Points can not be empty" : "", B = d > n && d - n > 1e6, ee = B ? "Points can not exceed 1,000,000" : "", J = () => {
    if (!r) {
      v(["Merchant information is missing."]), d > n ? l("loyaltylion:add:points:failed") : d < n && l("loyaltylion:remove:points:failed");
      return;
    }
    d > n && C({
      variables: {
        input: {
          points: d - n,
          reason: u
        },
        merchantId: r
      }
    }).catch((U) => {
      const O = U?.networkError;
      (O ? O?.statusCode : NaN) === 201 ? (l("loyaltylion:add:points:succeeded"), s({
        title: "Success",
        text: "Added points successfully",
        icon: "check-circle-filled",
        severity: "success"
      }), Q()) : (l("loyaltylion:add:points:failed"), v(["Failed to add points, try again later."]));
    }), d < n && j({
      variables: {
        input: {
          points: n - d,
          reason: u
        },
        merchantId: r
      }
    }).then((U) => {
      U.data?.LoyaltyLion?.removeCustomersPoints?.__typename === "LoyaltyLion_Void_container" ? (l("loyaltylion:remove:points:succeeded"), s({
        title: "Success",
        text: "Removed points successfully",
        icon: "check-circle-filled",
        severity: "success"
      }), Q()) : "errors" in U && (l("loyaltylion:remove:points:failed"), v(
        U.errors?.map((O) => O.message) ?? [
          "Failed to remove points, try again later."
        ]
      ));
    }).catch(() => {
      l("loyaltylion:remove:points:failed"), v(["Failed to remove points, try again later."]);
    });
  }, ae = () => {
    E && m(n), f(""), i();
  }, Q = () => {
    a(), ae();
  };
  return /* @__PURE__ */ De.jsxs(
    wt,
    {
      isOpen: e,
      onClose: ae,
      "data-testid": "change-points-modal",
      children: [
        /* @__PURE__ */ De.jsx(Ct, { title: "Change points", onClose: ae }),
        /* @__PURE__ */ De.jsxs(Ft, { className: D2.modalBody, children: [
          /* @__PURE__ */ De.jsxs(vt, { children: [
            /* @__PURE__ */ De.jsx(ze, { span: 6, children: /* @__PURE__ */ De.jsx(
              cr,
              {
                required: !0,
                label: "New points",
                type: "number",
                placeholder: "Insert new points",
                min: 0,
                max: 1e5,
                meta: {
                  error: ee || D,
                  warning: T
                },
                input: {
                  name: "points",
                  value: d.toString(),
                  onChange: (U) => m(U?.target.valueAsNumber ?? 0)
                },
                "data-testid": "points-input"
              }
            ) }),
            /* @__PURE__ */ De.jsx(ze, { span: 6, children: /* @__PURE__ */ De.jsx(
              cr,
              {
                label: "Reason",
                placeholder: "Insert an optional reason",
                input: {
                  name: "reason",
                  value: u,
                  onChange: (U) => f(U?.target.value ?? "")
                }
              }
            ) })
          ] }),
          !y && q && /* @__PURE__ */ De.jsx(b, { margin: "200 0", flexDirection: "column", children: /* @__PURE__ */ De.jsx(Ke, { children: h?.map((U, O) => /* @__PURE__ */ De.jsx(
            Ke.Item,
            {
              variant: "dense",
              title: U,
              contentLeft: /* @__PURE__ */ De.jsx(
                me,
                {
                  color: "red.500",
                  size: 16,
                  name: "exclamation-triangle-filled"
                }
              )
            },
            O
          )) }) })
        ] }),
        /* @__PURE__ */ De.jsx(
          Tt,
          {
            confirmName: "Save",
            confirmOnClick: () => J(),
            confirmProps: {
              isLoading: y,
              disabled: E || B || n === d,
              loadingIndicator: /* @__PURE__ */ De.jsx(cn, { size: 16 })
            },
            cancelOnClick: ae
          }
        )
      ]
    }
  );
}, O2 = ({
  label: e,
  points: n,
  setIsModalOpen: r
}) => {
  const i = n > 0 ? "green.500" : "neutral.400", a = n > 0 ? "warning" : "secondary", o = 10;
  return /* @__PURE__ */ De.jsx(Ke.Text, { variant: "dense", className: qi.listItem, children: /* @__PURE__ */ De.jsxs(b, { justifyContent: "space-between", children: [
    /* @__PURE__ */ De.jsxs(b, { gap: "200", alignItems: "center", children: [
      /* @__PURE__ */ De.jsx(me, { color: i, size: o, name: "star-full" }),
      /* @__PURE__ */ De.jsx(A.Paragraph, { variant: "4", children: e })
    ] }),
    /* @__PURE__ */ De.jsxs(b, { gap: "200", alignItems: "center", children: [
      r && /* @__PURE__ */ De.jsx(Ge, { content: "Edit points", children: /* @__PURE__ */ De.jsx(
        me,
        {
          name: "pen",
          size: o,
          "aria-label": "Edit points",
          className: qi.listItemEdit,
          onClick: () => r(!0)
        }
      ) }),
      /* @__PURE__ */ De.jsx(Pn, { size: "small", variant: a, children: n })
    ] })
  ] }) });
}, P2 = ({
  customer: e,
  refetchCustomerData: n
}) => {
  const [r, i] = se(!1);
  if (!e)
    return null;
  const {
    merchant_id: a,
    points_approved: o,
    points_pending: s,
    points_spent: l,
    rewards_claimed: d
  } = e, m = [
    {
      id: "pointsApproved",
      label: "Points approved",
      points: o ?? 0,
      setIsModalOpen: i
    },
    {
      id: "pointsPending",
      label: "Points pending",
      points: s ?? 0
    },
    {
      id: "pointsSpent",
      label: "Points spent",
      points: l ?? 0
    },
    {
      id: "rewardClaimed",
      label: "Rewards claimed",
      points: d ?? 0
    }
  ];
  return /* @__PURE__ */ De.jsxs(b, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ De.jsx(A.Heading, { variant: "heading-3", children: "Points balance" }),
    /* @__PURE__ */ De.jsx(Ke, { className: qi.list, children: m.map(({ id: u, points: f, label: h, setIsModalOpen: v }) => /* @__PURE__ */ De.jsx(
      O2,
      {
        points: f,
        label: h,
        setIsModalOpen: v
      },
      u
    )) }),
    /* @__PURE__ */ De.jsx(
      R2,
      {
        isOpen: r,
        points: o,
        merchantId: a,
        onClose: () => i(!1),
        refetchCustomerData: n
      }
    )
  ] });
}, A2 = "_reward_1wxia_1", L2 = {
  reward: A2
}, V2 = ({ reward: e }) => {
  const {
    title: n,
    point_cost: r,
    target_site: i,
    description: a
  } = e, o = i?.name, s = i?.url;
  return /* @__PURE__ */ De.jsx(b, { gap: "100", flexDirection: "column", className: L2.reward, children: /* @__PURE__ */ De.jsx(Ge, { content: a ?? "No description", children: /* @__PURE__ */ De.jsxs(b, { gap: "100", flexDirection: "column", children: [
    /* @__PURE__ */ De.jsxs(b, { justifyContent: "space-between", children: [
      /* @__PURE__ */ De.jsxs(b, { gap: "100", alignItems: "center", children: [
        /* @__PURE__ */ De.jsx(me, { name: "star", size: 12, color: "neutral.500" }),
        n
      ] }),
      /* @__PURE__ */ De.jsxs(Pn, { size: "small", variant: "info", children: [
        r ?? 0,
        " points"
      ] })
    ] }),
    o && s && /* @__PURE__ */ De.jsxs(b, { gap: "100", flexDirection: "row", alignItems: "center", children: [
      /* @__PURE__ */ De.jsx(me, { size: 14, name: "external-link" }),
      /* @__PURE__ */ De.jsx(
        A.ExternalLink,
        {
          href: s,
          target: "_blank",
          rel: "noreferrer",
          children: o
        }
      )
    ] })
  ] }) }) });
}, z2 = ({ customer: e }) => {
  const { useQuery: n } = mn(), [r, i] = se(), { merchant_id: a } = e, {
    loading: o,
    error: s,
    data: l
  } = n(x2, {
    skip: !a,
    variables: {
      merchantId: a
    }
  });
  if (He(() => {
    if (l?.LoyaltyLion) {
      const d = l.LoyaltyLion?.getAvailableRewards?.rewards;
      d && i(d);
    }
  }, [l]), s) {
    const d = s.graphQLErrors;
    return io({ errors: d }) ? /* @__PURE__ */ De.jsx(
      b,
      {
        justifyContent: "center",
        margin: "200 0 300 0",
        className: qi.notificationText,
        children: "No rewards found"
      }
    ) : Db({ errors: d }) ? /* @__PURE__ */ De.jsx(
      b,
      {
        justifyContent: "center",
        margin: "200 0 300 0",
        className: qi.notificationText,
        children: "You don't have permissions to view rewards"
      }
    ) : /* @__PURE__ */ De.jsx(Fn, { error: s });
  }
  return /* @__PURE__ */ De.jsxs(b, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ De.jsx(A.Heading, { variant: "heading-3", children: "Available rewards" }),
    o ? /* @__PURE__ */ De.jsx(b, { justifyContent: "center", margin: "200 0 300 0", children: /* @__PURE__ */ De.jsx(cn, {}) }) : /* @__PURE__ */ De.jsx(b, { gap: "200", flexDirection: "column", children: r?.map((d) => /* @__PURE__ */ De.jsx(V2, { reward: d }, d.id)) })
  ] });
}, U2 = ({ customer: e }) => {
  const { blocked: n, guest: r, insights_segment: i } = e ?? {}, a = n || r || i, o = 14;
  return a ? /* @__PURE__ */ De.jsxs(b, { gap: "200", flexDirection: "row", flexWrap: "wrap", children: [
    n && /* @__PURE__ */ De.jsx(b, { alignItems: "start", children: /* @__PURE__ */ De.jsx(An, { children: /* @__PURE__ */ De.jsxs(b, { gap: "200", alignItems: "center", children: [
      /* @__PURE__ */ De.jsx(
        me,
        {
          size: o,
          color: "red.500",
          name: "exclamation-triangle-filled"
        }
      ),
      "Blocked"
    ] }) }) }),
    r && /* @__PURE__ */ De.jsx(b, { alignItems: "start", children: /* @__PURE__ */ De.jsx(An, { children: /* @__PURE__ */ De.jsxs(b, { gap: "200", alignItems: "center", children: [
      /* @__PURE__ */ De.jsx(me, { size: o, color: "green.500", name: "user" }),
      "Guest"
    ] }) }) }),
    i && /* @__PURE__ */ De.jsx(b, { alignItems: "start", children: /* @__PURE__ */ De.jsx(Ge, { content: "Insights segment", children: /* @__PURE__ */ De.jsx(An, { children: /* @__PURE__ */ De.jsxs(b, { gap: "200", alignItems: "center", children: [
      /* @__PURE__ */ De.jsx(me, { size: o, color: "green.500", name: "team" }),
      i
    ] }) }) }) })
  ] }) : null;
}, M2 = ({
  conversationContext: e,
  settings: n
}) => {
  const { useQuery: r } = mn(), { track: i } = bn(), [a, o] = se(null), { customer: s } = e, {
    showCustomerSummary: l,
    showTags: d,
    showPointsBalance: m,
    showAvailableRewards: u
  } = n, f = !l && !d && !m && !u, {
    loading: h,
    error: v,
    data: C,
    refetch: S
  } = r(_2, {
    skip: !s?.email,
    variables: {
      email: s?.email ?? ""
    }
  });
  return He(() => {
    if (C && !h) {
      const j = (C?.LoyaltyLion?.getCustomers).customers;
      j && j.length > 0 && (o(j[0]), i("loyaltylion:customer:received"));
    }
  }, [C, h]), s?.email ? v ? io({
    errors: v.graphQLErrors
  }) ? /* @__PURE__ */ De.jsxs(
    b,
    {
      justifyContent: "center",
      margin: "200 0 300 0",
      className: qi.notificationText,
      children: [
        "No user found for email: ",
        s?.email
      ]
    }
  ) : /* @__PURE__ */ De.jsx(Fn, { error: v }) : h ? /* @__PURE__ */ De.jsx(b, { justifyContent: "center", margin: "200 0 300 0", children: /* @__PURE__ */ De.jsx(cn, {}) }) : f ? /* @__PURE__ */ De.jsx(
    b,
    {
      justifyContent: "center",
      margin: "200 0 300 0",
      "data-testid": "no-feature-enabled-message",
      children: "All features toggles in the integration settings are disabled"
    }
  ) : /* @__PURE__ */ De.jsx(
    b,
    {
      gap: "300",
      flexDirection: "column",
      margin: "0 0 300 0",
      "data-testid": "widget-wrapper",
      children: a ? /* @__PURE__ */ De.jsxs(De.Fragment, { children: [
        l && /* @__PURE__ */ De.jsx(C2, { customer: a }),
        d && /* @__PURE__ */ De.jsx(U2, { customer: a }),
        m && /* @__PURE__ */ De.jsx(
          P2,
          {
            customer: a,
            refetchCustomerData: S
          }
        ),
        u && /* @__PURE__ */ De.jsx(z2, { customer: a })
      ] }) : /* @__PURE__ */ De.jsx(b, { justifyContent: "center", padding: "200", children: "Nothing found" })
    }
  ) : /* @__PURE__ */ De.jsx(
    b,
    {
      justifyContent: "center",
      margin: "200 0 300 0",
      "data-testid": "no-email-message",
      children: "We can only search LoyaltyLion with an email and there seems to be no email in this conversation"
    }
  );
}, B2 = [
  {
    key: "basicAuthorization",
    label: "LoyaltyLion authorization",
    required: !0,
    secret: !0,
    type: "basicAuthInput",
    defaultValue: "",
    additionalProperties: {
      username: {
        label: "Token"
      },
      password: {
        label: "Secret"
      }
    }
  },
  {
    key: "showCustomerSummary",
    label: "Show customer summary",
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "showTags",
    label: "Show tags",
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "showPointsBalance",
    label: "Show points balance",
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "showAvailableRewards",
    label: "Show available rewards",
    secret: !1,
    type: "switch",
    defaultValue: !0
  }
];
(function() {
  try {
    if (typeof document < "u") {
      var e = document.createElement("style");
      e.appendChild(document.createTextNode("._messageContainer_1rxr4_1{padding:var(--dixa-size-spacer-250);border-radius:var(--dixa-size-border-radius-100);border:var(--dixa-size-border-100) solid}._chip_1rxr4_7{color:var(--dixa-typography-color-secondary)}._chipLabel_1rxr4_10{font-weight:var(--dixa-typography-weight-semibold)}._chipValue_1rxr4_13{font-weight:var(--dixa-typography-weight-normal)}._conversation_1draa_1{border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-250)}._conversation_1draa_1:hover{border-color:var(--dixa-color-neutral-400)}._conversationSubLine_1draa_9{font-size:var(--dixa-typography-size-200);color:var(--dixa-typography-color-tertiary)}._modal_1draa_14{width:800px}")), document.head.appendChild(e);
    }
  } catch (n) {
    console.error("vite-plugin-css-injected-by-js", n);
  }
})();
var bu = { exports: {} }, xa = {}, rk;
function q2() {
  if (rk) return xa;
  rk = 1;
  var e = je, n = Symbol.for("react.element"), r = Symbol.for("react.fragment"), i = Object.prototype.hasOwnProperty, a = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, o = { key: !0, ref: !0, __self: !0, __source: !0 };
  function s(l, d, m) {
    var u, f = {}, h = null, v = null;
    m !== void 0 && (h = "" + m), d.key !== void 0 && (h = "" + d.key), d.ref !== void 0 && (v = d.ref);
    for (u in d) i.call(d, u) && !o.hasOwnProperty(u) && (f[u] = d[u]);
    if (l && l.defaultProps) for (u in d = l.defaultProps, d) f[u] === void 0 && (f[u] = d[u]);
    return { $$typeof: n, type: l, key: h, ref: v, props: f, _owner: a.current };
  }
  return xa.Fragment = r, xa.jsx = s, xa.jsxs = s, xa;
}
var Po = {}, ik;
function H2() {
  return ik || (ik = 1, process.env.NODE_ENV !== "production" && (function() {
    var e = je, n = Symbol.for("react.element"), r = Symbol.for("react.portal"), i = Symbol.for("react.fragment"), a = Symbol.for("react.strict_mode"), o = Symbol.for("react.profiler"), s = Symbol.for("react.provider"), l = Symbol.for("react.context"), d = Symbol.for("react.forward_ref"), m = Symbol.for("react.suspense"), u = Symbol.for("react.suspense_list"), f = Symbol.for("react.memo"), h = Symbol.for("react.lazy"), v = Symbol.for("react.offscreen"), C = Symbol.iterator, S = "@@iterator";
    function j(t) {
      if (t === null || typeof t != "object")
        return null;
      var c = C && t[C] || t[S];
      return typeof c == "function" ? c : null;
    }
    var F = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function y(t) {
      {
        for (var c = arguments.length, p = new Array(c > 1 ? c - 1 : 0), g = 1; g < c; g++)
          p[g - 1] = arguments[g];
        q("error", t, p);
      }
    }
    function q(t, c, p) {
      {
        var g = F.ReactDebugCurrentFrame, P = g.getStackAddendum();
        P !== "" && (c += "%s", p = p.concat([P]));
        var L = p.map(function(I) {
          return String(I);
        });
        L.unshift("Warning: " + c), Function.prototype.apply.call(console[t], console, L);
      }
    }
    var T = !1, E = !1, D = !1, B = !1, ee = !1, J;
    J = Symbol.for("react.module.reference");
    function ae(t) {
      return !!(typeof t == "string" || typeof t == "function" || t === i || t === o || ee || t === a || t === m || t === u || B || t === v || T || E || D || typeof t == "object" && t !== null && (t.$$typeof === h || t.$$typeof === f || t.$$typeof === s || t.$$typeof === l || t.$$typeof === d || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      t.$$typeof === J || t.getModuleId !== void 0));
    }
    function Q(t, c, p) {
      var g = t.displayName;
      if (g)
        return g;
      var P = c.displayName || c.name || "";
      return P !== "" ? p + "(" + P + ")" : p;
    }
    function U(t) {
      return t.displayName || "Context";
    }
    function O(t) {
      if (t == null)
        return null;
      if (typeof t.tag == "number" && y("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof t == "function")
        return t.displayName || t.name || null;
      if (typeof t == "string")
        return t;
      switch (t) {
        case i:
          return "Fragment";
        case r:
          return "Portal";
        case o:
          return "Profiler";
        case a:
          return "StrictMode";
        case m:
          return "Suspense";
        case u:
          return "SuspenseList";
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case l:
            var c = t;
            return U(c) + ".Consumer";
          case s:
            var p = t;
            return U(p._context) + ".Provider";
          case d:
            return Q(t, t.render, "ForwardRef");
          case f:
            var g = t.displayName || null;
            return g !== null ? g : O(t.type) || "Memo";
          case h: {
            var P = t, L = P._payload, I = P._init;
            try {
              return O(I(L));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var H = Object.assign, Z = 0, ye, ce, le, ue, W, ke, Ee;
    function K() {
    }
    K.__reactDisabledLog = !0;
    function qe() {
      {
        if (Z === 0) {
          ye = console.log, ce = console.info, le = console.warn, ue = console.error, W = console.group, ke = console.groupCollapsed, Ee = console.groupEnd;
          var t = {
            configurable: !0,
            enumerable: !0,
            value: K,
            writable: !0
          };
          Object.defineProperties(console, {
            info: t,
            log: t,
            warn: t,
            error: t,
            group: t,
            groupCollapsed: t,
            groupEnd: t
          });
        }
        Z++;
      }
    }
    function Be() {
      {
        if (Z--, Z === 0) {
          var t = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: H({}, t, {
              value: ye
            }),
            info: H({}, t, {
              value: ce
            }),
            warn: H({}, t, {
              value: le
            }),
            error: H({}, t, {
              value: ue
            }),
            group: H({}, t, {
              value: W
            }),
            groupCollapsed: H({}, t, {
              value: ke
            }),
            groupEnd: H({}, t, {
              value: Ee
            })
          });
        }
        Z < 0 && y("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var Pe = F.ReactCurrentDispatcher, Me;
    function Fe(t, c, p) {
      {
        if (Me === void 0)
          try {
            throw Error();
          } catch (P) {
            var g = P.stack.trim().match(/\n( *(at )?)/);
            Me = g && g[1] || "";
          }
        return `
` + Me + t;
      }
    }
    var Ae = !1, $e;
    {
      var tn = typeof WeakMap == "function" ? WeakMap : Map;
      $e = new tn();
    }
    function Ie(t, c) {
      if (!t || Ae)
        return "";
      {
        var p = $e.get(t);
        if (p !== void 0)
          return p;
      }
      var g;
      Ae = !0;
      var P = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var L;
      L = Pe.current, Pe.current = null, qe();
      try {
        if (c) {
          var I = function() {
            throw Error();
          };
          if (Object.defineProperty(I.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(I, []);
            } catch (ne) {
              g = ne;
            }
            Reflect.construct(t, [], I);
          } else {
            try {
              I.call();
            } catch (ne) {
              g = ne;
            }
            t.call(I.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (ne) {
            g = ne;
          }
          t();
        }
      } catch (ne) {
        if (ne && g && typeof ne.stack == "string") {
          for (var N = ne.stack.split(`
`), te = g.stack.split(`
`), x = N.length - 1, V = te.length - 1; x >= 1 && V >= 0 && N[x] !== te[V]; )
            V--;
          for (; x >= 1 && V >= 0; x--, V--)
            if (N[x] !== te[V]) {
              if (x !== 1 || V !== 1)
                do
                  if (x--, V--, V < 0 || N[x] !== te[V]) {
                    var X = `
` + N[x].replace(" at new ", " at ");
                    return t.displayName && X.includes("<anonymous>") && (X = X.replace("<anonymous>", t.displayName)), typeof t == "function" && $e.set(t, X), X;
                  }
                while (x >= 1 && V >= 0);
              break;
            }
        }
      } finally {
        Ae = !1, Pe.current = L, Be(), Error.prepareStackTrace = P;
      }
      var we = t ? t.displayName || t.name : "", Se = we ? Fe(we) : "";
      return typeof t == "function" && $e.set(t, Se), Se;
    }
    function We(t, c, p) {
      return Ie(t, !1);
    }
    function Ze(t) {
      var c = t.prototype;
      return !!(c && c.isReactComponent);
    }
    function de(t, c, p) {
      if (t == null)
        return "";
      if (typeof t == "function")
        return Ie(t, Ze(t));
      if (typeof t == "string")
        return Fe(t);
      switch (t) {
        case m:
          return Fe("Suspense");
        case u:
          return Fe("SuspenseList");
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case d:
            return We(t.render);
          case f:
            return de(t.type, c, p);
          case h: {
            var g = t, P = g._payload, L = g._init;
            try {
              return de(L(P), c, p);
            } catch {
            }
          }
        }
      return "";
    }
    var fe = Object.prototype.hasOwnProperty, Te = {}, Le = F.ReactDebugCurrentFrame;
    function Re(t) {
      if (t) {
        var c = t._owner, p = de(t.type, t._source, c ? c.type : null);
        Le.setExtraStackFrame(p);
      } else
        Le.setExtraStackFrame(null);
    }
    function sn(t, c, p, g, P) {
      {
        var L = Function.call.bind(fe);
        for (var I in t)
          if (L(t, I)) {
            var N = void 0;
            try {
              if (typeof t[I] != "function") {
                var te = Error((g || "React class") + ": " + p + " type `" + I + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof t[I] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw te.name = "Invariant Violation", te;
              }
              N = t[I](c, I, g, p, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (x) {
              N = x;
            }
            N && !(N instanceof Error) && (Re(P), y("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", g || "React class", p, I, typeof N), Re(null)), N instanceof Error && !(N.message in Te) && (Te[N.message] = !0, Re(P), y("Failed %s type: %s", p, N.message), Re(null));
          }
      }
    }
    var w = Array.isArray;
    function _(t) {
      return w(t);
    }
    function $(t) {
      {
        var c = typeof Symbol == "function" && Symbol.toStringTag, p = c && t[Symbol.toStringTag] || t.constructor.name || "Object";
        return p;
      }
    }
    function G(t) {
      try {
        return Y(t), !1;
      } catch {
        return !0;
      }
    }
    function Y(t) {
      return "" + t;
    }
    function R(t) {
      if (G(t))
        return y("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", $(t)), Y(t);
    }
    var z = F.ReactCurrentOwner, ie = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, pe, _e;
    function en(t) {
      if (fe.call(t, "ref")) {
        var c = Object.getOwnPropertyDescriptor(t, "ref").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.ref !== void 0;
    }
    function un(t) {
      if (fe.call(t, "key")) {
        var c = Object.getOwnPropertyDescriptor(t, "key").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.key !== void 0;
    }
    function rn(t, c) {
      typeof t.ref == "string" && z.current;
    }
    function dn(t, c) {
      {
        var p = function() {
          pe || (pe = !0, y("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "key", {
          get: p,
          configurable: !0
        });
      }
    }
    function pn(t, c) {
      {
        var p = function() {
          _e || (_e = !0, y("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "ref", {
          get: p,
          configurable: !0
        });
      }
    }
    var ln = function(t, c, p, g, P, L, I) {
      var N = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: n,
        // Built-in properties that belong on the element
        type: t,
        key: c,
        ref: p,
        props: I,
        // Record the component responsible for creating this element.
        _owner: L
      };
      return N._store = {}, Object.defineProperty(N._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(N, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: g
      }), Object.defineProperty(N, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: P
      }), Object.freeze && (Object.freeze(N.props), Object.freeze(N)), N;
    };
    function kn(t, c, p, g, P) {
      {
        var L, I = {}, N = null, te = null;
        p !== void 0 && (R(p), N = "" + p), un(c) && (R(c.key), N = "" + c.key), en(c) && (te = c.ref, rn(c));
        for (L in c)
          fe.call(c, L) && !ie.hasOwnProperty(L) && (I[L] = c[L]);
        if (t && t.defaultProps) {
          var x = t.defaultProps;
          for (L in x)
            I[L] === void 0 && (I[L] = x[L]);
        }
        if (N || te) {
          var V = typeof t == "function" ? t.displayName || t.name || "Unknown" : t;
          N && dn(I, V), te && pn(I, V);
        }
        return ln(t, N, te, P, g, z.current, I);
      }
    }
    var Xe = F.ReactCurrentOwner, Sn = F.ReactDebugCurrentFrame;
    function Oe(t) {
      if (t) {
        var c = t._owner, p = de(t.type, t._source, c ? c.type : null);
        Sn.setExtraStackFrame(p);
      } else
        Sn.setExtraStackFrame(null);
    }
    var an;
    an = !1;
    function on(t) {
      return typeof t == "object" && t !== null && t.$$typeof === n;
    }
    function yn() {
      {
        if (Xe.current) {
          var t = O(Xe.current.type);
          if (t)
            return `

Check the render method of \`` + t + "`.";
        }
        return "";
      }
    }
    function qn(t) {
      return "";
    }
    var Nn = {};
    function gn(t) {
      {
        var c = yn();
        if (!c) {
          var p = typeof t == "string" ? t : t.displayName || t.name;
          p && (c = `

Check the top-level render call using <` + p + ">.");
        }
        return c;
      }
    }
    function hn(t, c) {
      {
        if (!t._store || t._store.validated || t.key != null)
          return;
        t._store.validated = !0;
        var p = gn(c);
        if (Nn[p])
          return;
        Nn[p] = !0;
        var g = "";
        t && t._owner && t._owner !== Xe.current && (g = " It was passed a child from " + O(t._owner.type) + "."), Oe(t), y('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', p, g), Oe(null);
      }
    }
    function jn(t, c) {
      {
        if (typeof t != "object")
          return;
        if (_(t))
          for (var p = 0; p < t.length; p++) {
            var g = t[p];
            on(g) && hn(g, c);
          }
        else if (on(t))
          t._store && (t._store.validated = !0);
        else if (t) {
          var P = j(t);
          if (typeof P == "function" && P !== t.entries)
            for (var L = P.call(t), I; !(I = L.next()).done; )
              on(I.value) && hn(I.value, c);
        }
      }
    }
    function Un(t) {
      {
        var c = t.type;
        if (c == null || typeof c == "string")
          return;
        var p;
        if (typeof c == "function")
          p = c.propTypes;
        else if (typeof c == "object" && (c.$$typeof === d || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        c.$$typeof === f))
          p = c.propTypes;
        else
          return;
        if (p) {
          var g = O(c);
          sn(p, t.props, "prop", g, t);
        } else if (c.PropTypes !== void 0 && !an) {
          an = !0;
          var P = O(c);
          y("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", P || "Unknown");
        }
        typeof c.getDefaultProps == "function" && !c.getDefaultProps.isReactClassApproved && y("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function Vn(t) {
      {
        for (var c = Object.keys(t.props), p = 0; p < c.length; p++) {
          var g = c[p];
          if (g !== "children" && g !== "key") {
            Oe(t), y("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", g), Oe(null);
            break;
          }
        }
        t.ref !== null && (Oe(t), y("Invalid attribute `ref` supplied to `React.Fragment`."), Oe(null));
      }
    }
    var _n = {};
    function xn(t, c, p, g, P, L) {
      {
        var I = ae(t);
        if (!I) {
          var N = "";
          (t === void 0 || typeof t == "object" && t !== null && Object.keys(t).length === 0) && (N += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var te = qn();
          te ? N += te : N += yn();
          var x;
          t === null ? x = "null" : _(t) ? x = "array" : t !== void 0 && t.$$typeof === n ? (x = "<" + (O(t.type) || "Unknown") + " />", N = " Did you accidentally export a JSX literal instead of a component?") : x = typeof t, y("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", x, N);
        }
        var V = kn(t, c, p, P, L);
        if (V == null)
          return V;
        if (I) {
          var X = c.children;
          if (X !== void 0)
            if (g)
              if (_(X)) {
                for (var we = 0; we < X.length; we++)
                  jn(X[we], t);
                Object.freeze && Object.freeze(X);
              } else
                y("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              jn(X, t);
        }
        if (fe.call(c, "key")) {
          var Se = O(t), ne = Object.keys(c).filter(function(wn) {
            return wn !== "key";
          }), nn = ne.length > 0 ? "{key: someKey, " + ne.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!_n[Se + nn]) {
            var Tn = ne.length > 0 ? "{" + ne.join(": ..., ") + ": ...}" : "{}";
            y(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, nn, Se, Tn, Se), _n[Se + nn] = !0;
          }
        }
        return t === i ? Vn(V) : Un(V), V;
      }
    }
    function Hn(t, c, p) {
      return xn(t, c, p, !0);
    }
    function Dn(t, c, p) {
      return xn(t, c, p, !1);
    }
    var Rn = Dn, Mn = Hn;
    Po.Fragment = i, Po.jsx = Rn, Po.jsxs = Mn;
  })()), Po;
}
var ak;
function W2() {
  return ak || (ak = 1, process.env.NODE_ENV === "production" ? bu.exports = q2() : bu.exports = H2()), bu.exports;
}
var Cn = W2();
const K2 = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "conversationsQuery" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "query" } }, type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Miuros" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "findTickets" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "query" }, value: { kind: "Variable", name: { kind: "Name", value: "query" } } }, { kind: "Argument", name: { kind: "Name", value: "page_size" }, value: { kind: "IntValue", value: "10" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "data" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "labels" } }, { kind: "Field", name: { kind: "Name", value: "subject" } }, { kind: "Field", name: { kind: "Name", value: "messages" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "direction" } }, { kind: "Field", name: { kind: "Name", value: "body" } }, { kind: "Field", name: { kind: "Name", value: "agent" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "email" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }, { kind: "Field", name: { kind: "Name", value: "created_at" } }] } }, { kind: "Field", name: { kind: "Name", value: "custom_fields" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "additionalProperties" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "key" } }, { kind: "Field", name: { kind: "Name", value: "value" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "value" } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "created_at" } }] } }] } }] } }] } }] }, G2 = {
  "\n  query conversationsQuery($query: String) {\n    Miuros {\n      findTickets(query: $query, page_size: 10) {\n        data {\n          id\n          labels\n          subject\n          messages {\n            direction\n            body\n            agent {\n              email\n              name\n            }\n            created_at\n          }\n          custom_fields {\n            additionalProperties {\n              key\n              value {\n                value\n              }\n            }\n          }\n          created_at\n        }\n      }\n    }\n  }\n": K2
};
function Y2(e) {
  return G2[e] ?? {};
}
const {
  entries: Qx,
  setPrototypeOf: ok,
  isFrozen: Q2,
  getPrototypeOf: J2,
  getOwnPropertyDescriptor: X2
} = Object;
let {
  freeze: Ut,
  seal: dr,
  create: za
} = Object, {
  apply: vm,
  construct: km
} = typeof Reflect < "u" && Reflect;
Ut || (Ut = function(e) {
  return e;
});
dr || (dr = function(e) {
  return e;
});
vm || (vm = function(e, n) {
  for (var r = arguments.length, i = new Array(r > 2 ? r - 2 : 0), a = 2; a < r; a++)
    i[a - 2] = arguments[a];
  return e.apply(n, i);
});
km || (km = function(e) {
  for (var n = arguments.length, r = new Array(n > 1 ? n - 1 : 0), i = 1; i < n; i++)
    r[i - 1] = arguments[i];
  return new e(...r);
});
const Sa = Mt(Array.prototype.forEach), Z2 = Mt(Array.prototype.lastIndexOf), sk = Mt(Array.prototype.pop), Na = Mt(Array.prototype.push), eL = Mt(Array.prototype.splice), os = Mt(String.prototype.toLowerCase), _u = Mt(String.prototype.toString), xu = Mt(String.prototype.match), Ei = Mt(String.prototype.replace), nL = Mt(String.prototype.indexOf), tL = Mt(String.prototype.trim), fr = Mt(Object.prototype.hasOwnProperty), Dt = Mt(RegExp.prototype.test), ja = rL(TypeError);
function Mt(e) {
  return function(n) {
    n instanceof RegExp && (n.lastIndex = 0);
    for (var r = arguments.length, i = new Array(r > 1 ? r - 1 : 0), a = 1; a < r; a++)
      i[a - 1] = arguments[a];
    return vm(e, n, i);
  };
}
function rL(e) {
  return function() {
    for (var n = arguments.length, r = new Array(n), i = 0; i < n; i++)
      r[i] = arguments[i];
    return km(e, r);
  };
}
function $n(e, n) {
  let r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : os;
  ok && ok(e, null);
  let i = n.length;
  for (; i--; ) {
    let a = n[i];
    if (typeof a == "string") {
      const o = r(a);
      o !== a && (Q2(n) || (n[i] = o), a = o);
    }
    e[a] = !0;
  }
  return e;
}
function iL(e) {
  for (let n = 0; n < e.length; n++)
    fr(e, n) || (e[n] = null);
  return e;
}
function wr(e) {
  const n = za(null);
  for (const [r, i] of Qx(e))
    fr(e, r) && (Array.isArray(i) ? n[r] = iL(i) : i && typeof i == "object" && i.constructor === Object ? n[r] = wr(i) : n[r] = i);
  return n;
}
function wa(e, n) {
  for (; e !== null; ) {
    const i = X2(e, n);
    if (i) {
      if (i.get)
        return Mt(i.get);
      if (typeof i.value == "function")
        return Mt(i.value);
    }
    e = J2(e);
  }
  function r() {
    return null;
  }
  return r;
}
const lk = Ut(["a", "abbr", "acronym", "address", "area", "article", "aside", "audio", "b", "bdi", "bdo", "big", "blink", "blockquote", "body", "br", "button", "canvas", "caption", "center", "cite", "code", "col", "colgroup", "content", "data", "datalist", "dd", "decorator", "del", "details", "dfn", "dialog", "dir", "div", "dl", "dt", "element", "em", "fieldset", "figcaption", "figure", "font", "footer", "form", "h1", "h2", "h3", "h4", "h5", "h6", "head", "header", "hgroup", "hr", "html", "i", "img", "input", "ins", "kbd", "label", "legend", "li", "main", "map", "mark", "marquee", "menu", "menuitem", "meter", "nav", "nobr", "ol", "optgroup", "option", "output", "p", "picture", "pre", "progress", "q", "rp", "rt", "ruby", "s", "samp", "search", "section", "select", "shadow", "slot", "small", "source", "spacer", "span", "strike", "strong", "style", "sub", "summary", "sup", "table", "tbody", "td", "template", "textarea", "tfoot", "th", "thead", "time", "tr", "track", "tt", "u", "ul", "var", "video", "wbr"]), Su = Ut(["svg", "a", "altglyph", "altglyphdef", "altglyphitem", "animatecolor", "animatemotion", "animatetransform", "circle", "clippath", "defs", "desc", "ellipse", "enterkeyhint", "exportparts", "filter", "font", "g", "glyph", "glyphref", "hkern", "image", "inputmode", "line", "lineargradient", "marker", "mask", "metadata", "mpath", "part", "path", "pattern", "polygon", "polyline", "radialgradient", "rect", "stop", "style", "switch", "symbol", "text", "textpath", "title", "tref", "tspan", "view", "vkern"]), Nu = Ut(["feBlend", "feColorMatrix", "feComponentTransfer", "feComposite", "feConvolveMatrix", "feDiffuseLighting", "feDisplacementMap", "feDistantLight", "feDropShadow", "feFlood", "feFuncA", "feFuncB", "feFuncG", "feFuncR", "feGaussianBlur", "feImage", "feMerge", "feMergeNode", "feMorphology", "feOffset", "fePointLight", "feSpecularLighting", "feSpotLight", "feTile", "feTurbulence"]), aL = Ut(["animate", "color-profile", "cursor", "discard", "font-face", "font-face-format", "font-face-name", "font-face-src", "font-face-uri", "foreignobject", "hatch", "hatchpath", "mesh", "meshgradient", "meshpatch", "meshrow", "missing-glyph", "script", "set", "solidcolor", "unknown", "use"]), ju = Ut(["math", "menclose", "merror", "mfenced", "mfrac", "mglyph", "mi", "mlabeledtr", "mmultiscripts", "mn", "mo", "mover", "mpadded", "mphantom", "mroot", "mrow", "ms", "mspace", "msqrt", "mstyle", "msub", "msup", "msubsup", "mtable", "mtd", "mtext", "mtr", "munder", "munderover", "mprescripts"]), oL = Ut(["maction", "maligngroup", "malignmark", "mlongdiv", "mscarries", "mscarry", "msgroup", "mstack", "msline", "msrow", "semantics", "annotation", "annotation-xml", "mprescripts", "none"]), ck = Ut(["#text"]), dk = Ut(["accept", "action", "align", "alt", "autocapitalize", "autocomplete", "autopictureinpicture", "autoplay", "background", "bgcolor", "border", "capture", "cellpadding", "cellspacing", "checked", "cite", "class", "clear", "color", "cols", "colspan", "controls", "controlslist", "coords", "crossorigin", "datetime", "decoding", "default", "dir", "disabled", "disablepictureinpicture", "disableremoteplayback", "download", "draggable", "enctype", "enterkeyhint", "exportparts", "face", "for", "headers", "height", "hidden", "high", "href", "hreflang", "id", "inert", "inputmode", "integrity", "ismap", "kind", "label", "lang", "list", "loading", "loop", "low", "max", "maxlength", "media", "method", "min", "minlength", "multiple", "muted", "name", "nonce", "noshade", "novalidate", "nowrap", "open", "optimum", "part", "pattern", "placeholder", "playsinline", "popover", "popovertarget", "popovertargetaction", "poster", "preload", "pubdate", "radiogroup", "readonly", "rel", "required", "rev", "reversed", "role", "rows", "rowspan", "spellcheck", "scope", "selected", "shape", "size", "sizes", "slot", "span", "srclang", "start", "src", "srcset", "step", "style", "summary", "tabindex", "title", "translate", "type", "usemap", "valign", "value", "width", "wrap", "xmlns", "slot"]), wu = Ut(["accent-height", "accumulate", "additive", "alignment-baseline", "amplitude", "ascent", "attributename", "attributetype", "azimuth", "basefrequency", "baseline-shift", "begin", "bias", "by", "class", "clip", "clippathunits", "clip-path", "clip-rule", "color", "color-interpolation", "color-interpolation-filters", "color-profile", "color-rendering", "cx", "cy", "d", "dx", "dy", "diffuseconstant", "direction", "display", "divisor", "dur", "edgemode", "elevation", "end", "exponent", "fill", "fill-opacity", "fill-rule", "filter", "filterunits", "flood-color", "flood-opacity", "font-family", "font-size", "font-size-adjust", "font-stretch", "font-style", "font-variant", "font-weight", "fx", "fy", "g1", "g2", "glyph-name", "glyphref", "gradientunits", "gradienttransform", "height", "href", "id", "image-rendering", "in", "in2", "intercept", "k", "k1", "k2", "k3", "k4", "kerning", "keypoints", "keysplines", "keytimes", "lang", "lengthadjust", "letter-spacing", "kernelmatrix", "kernelunitlength", "lighting-color", "local", "marker-end", "marker-mid", "marker-start", "markerheight", "markerunits", "markerwidth", "maskcontentunits", "maskunits", "max", "mask", "mask-type", "media", "method", "mode", "min", "name", "numoctaves", "offset", "operator", "opacity", "order", "orient", "orientation", "origin", "overflow", "paint-order", "path", "pathlength", "patterncontentunits", "patterntransform", "patternunits", "points", "preservealpha", "preserveaspectratio", "primitiveunits", "r", "rx", "ry", "radius", "refx", "refy", "repeatcount", "repeatdur", "restart", "result", "rotate", "scale", "seed", "shape-rendering", "slope", "specularconstant", "specularexponent", "spreadmethod", "startoffset", "stddeviation", "stitchtiles", "stop-color", "stop-opacity", "stroke-dasharray", "stroke-dashoffset", "stroke-linecap", "stroke-linejoin", "stroke-miterlimit", "stroke-opacity", "stroke", "stroke-width", "style", "surfacescale", "systemlanguage", "tabindex", "tablevalues", "targetx", "targety", "transform", "transform-origin", "text-anchor", "text-decoration", "text-rendering", "textlength", "type", "u1", "u2", "unicode", "values", "viewbox", "visibility", "version", "vert-adv-y", "vert-origin-x", "vert-origin-y", "width", "word-spacing", "wrap", "writing-mode", "xchannelselector", "ychannelselector", "x", "x1", "x2", "xmlns", "y", "y1", "y2", "z", "zoomandpan"]), uk = Ut(["accent", "accentunder", "align", "bevelled", "close", "columnalign", "columnlines", "columnspacing", "columnspan", "denomalign", "depth", "dir", "display", "displaystyle", "encoding", "fence", "frame", "height", "href", "id", "largeop", "length", "linethickness", "lquote", "lspace", "mathbackground", "mathcolor", "mathsize", "mathvariant", "maxsize", "minsize", "movablelimits", "notation", "numalign", "open", "rowalign", "rowlines", "rowspacing", "rowspan", "rspace", "rquote", "scriptlevel", "scriptminsize", "scriptsizemultiplier", "selection", "separator", "separators", "stretchy", "subscriptshift", "supscriptshift", "symmetric", "voffset", "width", "xmlns"]), Ao = Ut(["xlink:href", "xml:id", "xlink:title", "xml:space", "xmlns:xlink"]), sL = dr(/\{\{[\w\W]*|[\w\W]*\}\}/gm), lL = dr(/<%[\w\W]*|[\w\W]*%>/gm), cL = dr(/\$\{[\w\W]*/gm), dL = dr(/^data-[\-\w.\u00B7-\uFFFF]+$/), uL = dr(/^aria-[\-\w]+$/), Jx = dr(
  /^(?:(?:(?:f|ht)tps?|mailto|tel|callto|sms|cid|xmpp|matrix):|[^a-z]|[a-z+.\-]+(?:[^a-z+.\-:]|$))/i
  // eslint-disable-line no-useless-escape
), mL = dr(/^(?:\w+script|data):/i), pL = dr(
  /[\u0000-\u0020\u00A0\u1680\u180E\u2000-\u2029\u205F\u3000]/g
  // eslint-disable-line no-control-regex
), Xx = dr(/^html$/i), fL = dr(/^[a-z][.\w]*(-[.\w]+)+$/i);
var mk = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  ARIA_ATTR: uL,
  ATTR_WHITESPACE: pL,
  CUSTOM_ELEMENT: fL,
  DATA_ATTR: dL,
  DOCTYPE_NAME: Xx,
  ERB_EXPR: lL,
  IS_ALLOWED_URI: Jx,
  IS_SCRIPT_OR_DATA: mL,
  MUSTACHE_EXPR: sL,
  TMPLIT_EXPR: cL
});
const Ca = {
  element: 1,
  text: 3,
  // Deprecated
  progressingInstruction: 7,
  comment: 8,
  document: 9
}, hL = function() {
  return typeof window > "u" ? null : window;
}, yL = function(e, n) {
  if (typeof e != "object" || typeof e.createPolicy != "function")
    return null;
  let r = null;
  const i = "data-tt-policy-suffix";
  n && n.hasAttribute(i) && (r = n.getAttribute(i));
  const a = "dompurify" + (r ? "#" + r : "");
  try {
    return e.createPolicy(a, {
      createHTML(o) {
        return o;
      },
      createScriptURL(o) {
        return o;
      }
    });
  } catch {
    return console.warn("TrustedTypes policy " + a + " could not be created."), null;
  }
}, pk = function() {
  return {
    afterSanitizeAttributes: [],
    afterSanitizeElements: [],
    afterSanitizeShadowDOM: [],
    beforeSanitizeAttributes: [],
    beforeSanitizeElements: [],
    beforeSanitizeShadowDOM: [],
    uponSanitizeAttribute: [],
    uponSanitizeElement: [],
    uponSanitizeShadowNode: []
  };
};
function Zx() {
  let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : hL();
  const n = (x) => Zx(x);
  if (n.version = "3.4.0", n.removed = [], !e || !e.document || e.document.nodeType !== Ca.document || !e.Element)
    return n.isSupported = !1, n;
  let {
    document: r
  } = e;
  const i = r, a = i.currentScript, {
    DocumentFragment: o,
    HTMLTemplateElement: s,
    Node: l,
    Element: d,
    NodeFilter: m,
    NamedNodeMap: u = e.NamedNodeMap || e.MozNamedAttrMap,
    HTMLFormElement: f,
    DOMParser: h,
    trustedTypes: v
  } = e, C = d.prototype, S = wa(C, "cloneNode"), j = wa(C, "remove"), F = wa(C, "nextSibling"), y = wa(C, "childNodes"), q = wa(C, "parentNode");
  if (typeof s == "function") {
    const x = r.createElement("template");
    x.content && x.content.ownerDocument && (r = x.content.ownerDocument);
  }
  let T, E = "";
  const {
    implementation: D,
    createNodeIterator: B,
    createDocumentFragment: ee,
    getElementsByTagName: J
  } = r, {
    importNode: ae
  } = i;
  let Q = pk();
  n.isSupported = typeof Qx == "function" && typeof q == "function" && D && D.createHTMLDocument !== void 0;
  const {
    MUSTACHE_EXPR: U,
    ERB_EXPR: O,
    TMPLIT_EXPR: H,
    DATA_ATTR: Z,
    ARIA_ATTR: ye,
    IS_SCRIPT_OR_DATA: ce,
    ATTR_WHITESPACE: le,
    CUSTOM_ELEMENT: ue
  } = mk;
  let {
    IS_ALLOWED_URI: W
  } = mk, ke = null;
  const Ee = $n({}, [...lk, ...Su, ...Nu, ...ju, ...ck]);
  let K = null;
  const qe = $n({}, [...dk, ...wu, ...uk, ...Ao]);
  let Be = Object.seal(za(null, {
    tagNameCheck: {
      writable: !0,
      configurable: !1,
      enumerable: !0,
      value: null
    },
    attributeNameCheck: {
      writable: !0,
      configurable: !1,
      enumerable: !0,
      value: null
    },
    allowCustomizedBuiltInElements: {
      writable: !0,
      configurable: !1,
      enumerable: !0,
      value: !1
    }
  })), Pe = null, Me = null;
  const Fe = Object.seal(za(null, {
    tagCheck: {
      writable: !0,
      configurable: !1,
      enumerable: !0,
      value: null
    },
    attributeCheck: {
      writable: !0,
      configurable: !1,
      enumerable: !0,
      value: null
    }
  }));
  let Ae = !0, $e = !0, tn = !1, Ie = !0, We = !1, Ze = !0, de = !1, fe = !1, Te = !1, Le = !1, Re = !1, sn = !1, w = !0, _ = !1;
  const $ = "user-content-";
  let G = !0, Y = !1, R = {}, z = null;
  const ie = $n({}, ["annotation-xml", "audio", "colgroup", "desc", "foreignobject", "head", "iframe", "math", "mi", "mn", "mo", "ms", "mtext", "noembed", "noframes", "noscript", "plaintext", "script", "style", "svg", "template", "thead", "title", "video", "xmp"]);
  let pe = null;
  const _e = $n({}, ["audio", "video", "img", "source", "image", "track"]);
  let en = null;
  const un = $n({}, ["alt", "class", "for", "id", "label", "name", "pattern", "placeholder", "role", "summary", "title", "value", "style", "xmlns"]), rn = "http://www.w3.org/1998/Math/MathML", dn = "http://www.w3.org/2000/svg", pn = "http://www.w3.org/1999/xhtml";
  let ln = pn, kn = !1, Xe = null;
  const Sn = $n({}, [rn, dn, pn], _u);
  let Oe = $n({}, ["mi", "mo", "mn", "ms", "mtext"]), an = $n({}, ["annotation-xml"]);
  const on = $n({}, ["title", "style", "font", "a", "script"]);
  let yn = null;
  const qn = ["application/xhtml+xml", "text/html"], Nn = "text/html";
  let gn = null, hn = null;
  const jn = r.createElement("form"), Un = function(x) {
    return x instanceof RegExp || x instanceof Function;
  }, Vn = function() {
    let x = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    if (!(hn && hn === x)) {
      if ((!x || typeof x != "object") && (x = {}), x = wr(x), yn = // eslint-disable-next-line unicorn/prefer-includes
      qn.indexOf(x.PARSER_MEDIA_TYPE) === -1 ? Nn : x.PARSER_MEDIA_TYPE, gn = yn === "application/xhtml+xml" ? _u : os, ke = fr(x, "ALLOWED_TAGS") ? $n({}, x.ALLOWED_TAGS, gn) : Ee, K = fr(x, "ALLOWED_ATTR") ? $n({}, x.ALLOWED_ATTR, gn) : qe, Xe = fr(x, "ALLOWED_NAMESPACES") ? $n({}, x.ALLOWED_NAMESPACES, _u) : Sn, en = fr(x, "ADD_URI_SAFE_ATTR") ? $n(wr(un), x.ADD_URI_SAFE_ATTR, gn) : un, pe = fr(x, "ADD_DATA_URI_TAGS") ? $n(wr(_e), x.ADD_DATA_URI_TAGS, gn) : _e, z = fr(x, "FORBID_CONTENTS") ? $n({}, x.FORBID_CONTENTS, gn) : ie, Pe = fr(x, "FORBID_TAGS") ? $n({}, x.FORBID_TAGS, gn) : wr({}), Me = fr(x, "FORBID_ATTR") ? $n({}, x.FORBID_ATTR, gn) : wr({}), R = fr(x, "USE_PROFILES") ? x.USE_PROFILES : !1, Ae = x.ALLOW_ARIA_ATTR !== !1, $e = x.ALLOW_DATA_ATTR !== !1, tn = x.ALLOW_UNKNOWN_PROTOCOLS || !1, Ie = x.ALLOW_SELF_CLOSE_IN_ATTR !== !1, We = x.SAFE_FOR_TEMPLATES || !1, Ze = x.SAFE_FOR_XML !== !1, de = x.WHOLE_DOCUMENT || !1, Le = x.RETURN_DOM || !1, Re = x.RETURN_DOM_FRAGMENT || !1, sn = x.RETURN_TRUSTED_TYPE || !1, Te = x.FORCE_BODY || !1, w = x.SANITIZE_DOM !== !1, _ = x.SANITIZE_NAMED_PROPS || !1, G = x.KEEP_CONTENT !== !1, Y = x.IN_PLACE || !1, W = x.ALLOWED_URI_REGEXP || Jx, ln = x.NAMESPACE || pn, Oe = x.MATHML_TEXT_INTEGRATION_POINTS || Oe, an = x.HTML_INTEGRATION_POINTS || an, Be = x.CUSTOM_ELEMENT_HANDLING || za(null), x.CUSTOM_ELEMENT_HANDLING && Un(x.CUSTOM_ELEMENT_HANDLING.tagNameCheck) && (Be.tagNameCheck = x.CUSTOM_ELEMENT_HANDLING.tagNameCheck), x.CUSTOM_ELEMENT_HANDLING && Un(x.CUSTOM_ELEMENT_HANDLING.attributeNameCheck) && (Be.attributeNameCheck = x.CUSTOM_ELEMENT_HANDLING.attributeNameCheck), x.CUSTOM_ELEMENT_HANDLING && typeof x.CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements == "boolean" && (Be.allowCustomizedBuiltInElements = x.CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements), We && ($e = !1), Re && (Le = !0), R && (ke = $n({}, ck), K = za(null), R.html === !0 && ($n(ke, lk), $n(K, dk)), R.svg === !0 && ($n(ke, Su), $n(K, wu), $n(K, Ao)), R.svgFilters === !0 && ($n(ke, Nu), $n(K, wu), $n(K, Ao)), R.mathMl === !0 && ($n(ke, ju), $n(K, uk), $n(K, Ao))), Fe.tagCheck = null, Fe.attributeCheck = null, x.ADD_TAGS && (typeof x.ADD_TAGS == "function" ? Fe.tagCheck = x.ADD_TAGS : (ke === Ee && (ke = wr(ke)), $n(ke, x.ADD_TAGS, gn))), x.ADD_ATTR && (typeof x.ADD_ATTR == "function" ? Fe.attributeCheck = x.ADD_ATTR : (K === qe && (K = wr(K)), $n(K, x.ADD_ATTR, gn))), x.ADD_URI_SAFE_ATTR && $n(en, x.ADD_URI_SAFE_ATTR, gn), x.FORBID_CONTENTS && (z === ie && (z = wr(z)), $n(z, x.FORBID_CONTENTS, gn)), x.ADD_FORBID_CONTENTS && (z === ie && (z = wr(z)), $n(z, x.ADD_FORBID_CONTENTS, gn)), G && (ke["#text"] = !0), de && $n(ke, ["html", "head", "body"]), ke.table && ($n(ke, ["tbody"]), delete Pe.tbody), x.TRUSTED_TYPES_POLICY) {
        if (typeof x.TRUSTED_TYPES_POLICY.createHTML != "function")
          throw ja('TRUSTED_TYPES_POLICY configuration option must provide a "createHTML" hook.');
        if (typeof x.TRUSTED_TYPES_POLICY.createScriptURL != "function")
          throw ja('TRUSTED_TYPES_POLICY configuration option must provide a "createScriptURL" hook.');
        T = x.TRUSTED_TYPES_POLICY, E = T.createHTML("");
      } else
        T === void 0 && (T = yL(v, a)), T !== null && typeof E == "string" && (E = T.createHTML(""));
      Ut && Ut(x), hn = x;
    }
  }, _n = $n({}, [...Su, ...Nu, ...aL]), xn = $n({}, [...ju, ...oL]), Hn = function(x) {
    let V = q(x);
    (!V || !V.tagName) && (V = {
      namespaceURI: ln,
      tagName: "template"
    });
    const X = os(x.tagName), we = os(V.tagName);
    return Xe[x.namespaceURI] ? x.namespaceURI === dn ? V.namespaceURI === pn ? X === "svg" : V.namespaceURI === rn ? X === "svg" && (we === "annotation-xml" || Oe[we]) : !!_n[X] : x.namespaceURI === rn ? V.namespaceURI === pn ? X === "math" : V.namespaceURI === dn ? X === "math" && an[we] : !!xn[X] : x.namespaceURI === pn ? V.namespaceURI === dn && !an[we] || V.namespaceURI === rn && !Oe[we] ? !1 : !xn[X] && (on[X] || !_n[X]) : !!(yn === "application/xhtml+xml" && Xe[x.namespaceURI]) : !1;
  }, Dn = function(x) {
    Na(n.removed, {
      element: x
    });
    try {
      q(x).removeChild(x);
    } catch {
      j(x);
    }
  }, Rn = function(x, V) {
    try {
      Na(n.removed, {
        attribute: V.getAttributeNode(x),
        from: V
      });
    } catch {
      Na(n.removed, {
        attribute: null,
        from: V
      });
    }
    if (V.removeAttribute(x), x === "is")
      if (Le || Re)
        try {
          Dn(V);
        } catch {
        }
      else
        try {
          V.setAttribute(x, "");
        } catch {
        }
  }, Mn = function(x) {
    let V = null, X = null;
    if (Te)
      x = "<remove></remove>" + x;
    else {
      const ne = xu(x, /^[\r\n\t ]+/);
      X = ne && ne[0];
    }
    yn === "application/xhtml+xml" && ln === pn && (x = '<html xmlns="http://www.w3.org/1999/xhtml"><head></head><body>' + x + "</body></html>");
    const we = T ? T.createHTML(x) : x;
    if (ln === pn)
      try {
        V = new h().parseFromString(we, yn);
      } catch {
      }
    if (!V || !V.documentElement) {
      V = D.createDocument(ln, "template", null);
      try {
        V.documentElement.innerHTML = kn ? E : we;
      } catch {
      }
    }
    const Se = V.body || V.documentElement;
    return x && X && Se.insertBefore(r.createTextNode(X), Se.childNodes[0] || null), ln === pn ? J.call(V, de ? "html" : "body")[0] : de ? V.documentElement : Se;
  }, t = function(x) {
    return B.call(
      x.ownerDocument || x,
      x,
      // eslint-disable-next-line no-bitwise
      m.SHOW_ELEMENT | m.SHOW_COMMENT | m.SHOW_TEXT | m.SHOW_PROCESSING_INSTRUCTION | m.SHOW_CDATA_SECTION,
      null
    );
  }, c = function(x) {
    return x instanceof f && (typeof x.nodeName != "string" || typeof x.textContent != "string" || typeof x.removeChild != "function" || !(x.attributes instanceof u) || typeof x.removeAttribute != "function" || typeof x.setAttribute != "function" || typeof x.namespaceURI != "string" || typeof x.insertBefore != "function" || typeof x.hasChildNodes != "function");
  }, p = function(x) {
    return typeof l == "function" && x instanceof l;
  };
  function g(x, V, X) {
    Sa(x, (we) => {
      we.call(n, V, X, hn);
    });
  }
  const P = function(x) {
    let V = null;
    if (g(Q.beforeSanitizeElements, x, null), c(x))
      return Dn(x), !0;
    const X = gn(x.nodeName);
    if (g(Q.uponSanitizeElement, x, {
      tagName: X,
      allowedTags: ke
    }), Ze && x.hasChildNodes() && !p(x.firstElementChild) && Dt(/<[/\w!]/g, x.innerHTML) && Dt(/<[/\w!]/g, x.textContent) || Ze && x.namespaceURI === pn && X === "style" && p(x.firstElementChild) || x.nodeType === Ca.progressingInstruction || Ze && x.nodeType === Ca.comment && Dt(/<[/\w]/g, x.data))
      return Dn(x), !0;
    if (Pe[X] || !(Fe.tagCheck instanceof Function && Fe.tagCheck(X)) && !ke[X]) {
      if (!Pe[X] && I(X) && (Be.tagNameCheck instanceof RegExp && Dt(Be.tagNameCheck, X) || Be.tagNameCheck instanceof Function && Be.tagNameCheck(X)))
        return !1;
      if (G && !z[X]) {
        const we = q(x) || x.parentNode, Se = y(x) || x.childNodes;
        if (Se && we) {
          const ne = Se.length;
          for (let nn = ne - 1; nn >= 0; --nn) {
            const Tn = S(Se[nn], !0);
            Tn.__removalCount = (x.__removalCount || 0) + 1, we.insertBefore(Tn, F(x));
          }
        }
      }
      return Dn(x), !0;
    }
    return x instanceof d && !Hn(x) || (X === "noscript" || X === "noembed" || X === "noframes") && Dt(/<\/no(script|embed|frames)/i, x.innerHTML) ? (Dn(x), !0) : (We && x.nodeType === Ca.text && (V = x.textContent, Sa([U, O, H], (we) => {
      V = Ei(V, we, " ");
    }), x.textContent !== V && (Na(n.removed, {
      element: x.cloneNode()
    }), x.textContent = V)), g(Q.afterSanitizeElements, x, null), !1);
  }, L = function(x, V, X) {
    if (Me[V] || w && (V === "id" || V === "name") && (X in r || X in jn))
      return !1;
    if (!($e && !Me[V] && Dt(Z, V)) && !(Ae && Dt(ye, V)) && !(Fe.attributeCheck instanceof Function && Fe.attributeCheck(V, x))) {
      if (!K[V] || Me[V]) {
        if (
          // First condition does a very basic check if a) it's basically a valid custom element tagname AND
          // b) if the tagName passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.tagNameCheck
          // and c) if the attribute name passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.attributeNameCheck
          !(I(x) && (Be.tagNameCheck instanceof RegExp && Dt(Be.tagNameCheck, x) || Be.tagNameCheck instanceof Function && Be.tagNameCheck(x)) && (Be.attributeNameCheck instanceof RegExp && Dt(Be.attributeNameCheck, V) || Be.attributeNameCheck instanceof Function && Be.attributeNameCheck(V, x)) || // Alternative, second condition checks if it's an `is`-attribute, AND
          // the value passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.tagNameCheck
          V === "is" && Be.allowCustomizedBuiltInElements && (Be.tagNameCheck instanceof RegExp && Dt(Be.tagNameCheck, X) || Be.tagNameCheck instanceof Function && Be.tagNameCheck(X)))
        ) return !1;
      } else if (!en[V] && !Dt(W, Ei(X, le, "")) && !((V === "src" || V === "xlink:href" || V === "href") && x !== "script" && nL(X, "data:") === 0 && pe[x]) && !(tn && !Dt(ce, Ei(X, le, ""))) && X)
        return !1;
    }
    return !0;
  }, I = function(x) {
    return x !== "annotation-xml" && xu(x, ue);
  }, N = function(x) {
    g(Q.beforeSanitizeAttributes, x, null);
    const {
      attributes: V
    } = x;
    if (!V || c(x))
      return;
    const X = {
      attrName: "",
      attrValue: "",
      keepAttr: !0,
      allowedAttributes: K,
      forceKeepAttr: void 0
    };
    let we = V.length;
    for (; we--; ) {
      const Se = V[we], {
        name: ne,
        namespaceURI: nn,
        value: Tn
      } = Se, wn = gn(ne), ea = Tn;
      let kt = ne === "value" ? ea : tL(ea);
      if (X.attrName = wn, X.attrValue = kt, X.keepAttr = !0, X.forceKeepAttr = void 0, g(Q.uponSanitizeAttribute, x, X), kt = X.attrValue, _ && (wn === "id" || wn === "name") && (Rn(ne, x), kt = $ + kt), Ze && Dt(/((--!?|])>)|<\/(style|script|title|xmp|textarea|noscript|iframe|noembed|noframes)/i, kt)) {
        Rn(ne, x);
        continue;
      }
      if (wn === "attributename" && xu(kt, "href")) {
        Rn(ne, x);
        continue;
      }
      if (X.forceKeepAttr)
        continue;
      if (!X.keepAttr) {
        Rn(ne, x);
        continue;
      }
      if (!Ie && Dt(/\/>/i, kt)) {
        Rn(ne, x);
        continue;
      }
      We && Sa([U, O, H], (MS) => {
        kt = Ei(kt, MS, " ");
      });
      const nf = gn(x.nodeName);
      if (!L(nf, wn, kt)) {
        Rn(ne, x);
        continue;
      }
      if (T && typeof v == "object" && typeof v.getAttributeType == "function" && !nn)
        switch (v.getAttributeType(nf, wn)) {
          case "TrustedHTML": {
            kt = T.createHTML(kt);
            break;
          }
          case "TrustedScriptURL": {
            kt = T.createScriptURL(kt);
            break;
          }
        }
      if (kt !== ea)
        try {
          nn ? x.setAttributeNS(nn, ne, kt) : x.setAttribute(ne, kt), c(x) ? Dn(x) : sk(n.removed);
        } catch {
          Rn(ne, x);
        }
    }
    g(Q.afterSanitizeAttributes, x, null);
  }, te = function(x) {
    let V = null;
    const X = t(x);
    for (g(Q.beforeSanitizeShadowDOM, x, null); V = X.nextNode(); )
      g(Q.uponSanitizeShadowNode, V, null), P(V), N(V), V.content instanceof o && te(V.content);
    g(Q.afterSanitizeShadowDOM, x, null);
  };
  return n.sanitize = function(x) {
    let V = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, X = null, we = null, Se = null, ne = null;
    if (kn = !x, kn && (x = "<!-->"), typeof x != "string" && !p(x))
      if (typeof x.toString == "function") {
        if (x = x.toString(), typeof x != "string")
          throw ja("dirty is not a string, aborting");
      } else
        throw ja("toString is not a function");
    if (!n.isSupported)
      return x;
    if (fe || Vn(V), n.removed = [], typeof x == "string" && (Y = !1), Y) {
      if (x.nodeName) {
        const wn = gn(x.nodeName);
        if (!ke[wn] || Pe[wn])
          throw ja("root node is forbidden and cannot be sanitized in-place");
      }
    } else if (x instanceof l)
      X = Mn("<!---->"), we = X.ownerDocument.importNode(x, !0), we.nodeType === Ca.element && we.nodeName === "BODY" || we.nodeName === "HTML" ? X = we : X.appendChild(we);
    else {
      if (!Le && !We && !de && // eslint-disable-next-line unicorn/prefer-includes
      x.indexOf("<") === -1)
        return T && sn ? T.createHTML(x) : x;
      if (X = Mn(x), !X)
        return Le ? null : sn ? E : "";
    }
    X && Te && Dn(X.firstChild);
    const nn = t(Y ? x : X);
    for (; Se = nn.nextNode(); )
      P(Se), N(Se), Se.content instanceof o && te(Se.content);
    if (Y)
      return x;
    if (Le) {
      if (We) {
        X.normalize();
        let wn = X.innerHTML;
        Sa([U, O, H], (ea) => {
          wn = Ei(wn, ea, " ");
        }), X.innerHTML = wn;
      }
      if (Re)
        for (ne = ee.call(X.ownerDocument); X.firstChild; )
          ne.appendChild(X.firstChild);
      else
        ne = X;
      return (K.shadowroot || K.shadowrootmode) && (ne = ae.call(i, ne, !0)), ne;
    }
    let Tn = de ? X.outerHTML : X.innerHTML;
    return de && ke["!doctype"] && X.ownerDocument && X.ownerDocument.doctype && X.ownerDocument.doctype.name && Dt(Xx, X.ownerDocument.doctype.name) && (Tn = "<!DOCTYPE " + X.ownerDocument.doctype.name + `>
` + Tn), We && Sa([U, O, H], (wn) => {
      Tn = Ei(Tn, wn, " ");
    }), T && sn ? T.createHTML(Tn) : Tn;
  }, n.setConfig = function() {
    let x = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    Vn(x), fe = !0;
  }, n.clearConfig = function() {
    hn = null, fe = !1;
  }, n.isValidAttribute = function(x, V, X) {
    hn || Vn({});
    const we = gn(x), Se = gn(V);
    return L(we, Se, X);
  }, n.addHook = function(x, V) {
    typeof V == "function" && Na(Q[x], V);
  }, n.removeHook = function(x, V) {
    if (V !== void 0) {
      const X = Z2(Q[x], V);
      return X === -1 ? void 0 : eL(Q[x], X, 1)[0];
    }
    return sk(Q[x]);
  }, n.removeHooks = function(x) {
    Q[x] = [];
  }, n.removeAllHooks = function() {
    Q = pk();
  }, n;
}
var gL = Zx();
const vL = "_messageContainer_1rxr4_1", kL = "_chip_1rxr4_7", bL = "_chipLabel_1rxr4_10", _L = "_chipValue_1rxr4_13", Lo = {
  messageContainer: vL,
  chip: kL,
  chipLabel: bL,
  chipValue: _L
}, fk = {
  INBOUND: {
    background: "var(--dixa-color-neutral-000)",
    borderColor: "var(--dixa-color-neutral-100)"
  },
  OUTBOUND: {
    background: "var(--dixa-color-neutral-100)",
    borderColor: "var(--dixa-color-neutral-200)"
  },
  INTERNAL: {
    background: "var(--dixa-color-orange-100)",
    borderColor: "var(--dixa-color-orange-200)"
  }
}, xL = ({
  messages: e,
  customFields: n,
  attachments: r,
  conversationContext: i
}) => {
  He(() => {
    document.getElementById("endOfConversationAnchor") && document.getElementById("endOfConversationAnchor")?.scrollIntoView({ behavior: "smooth" });
  }, [e]);
  const a = () => {
    const o = "Contact";
    if (!i?.customer)
      return o;
    const {
      name: s,
      given_name: l,
      family_name: d,
      email: m,
      phone_number: u
    } = i.customer;
    return s ?? l ?? d ?? m ?? u ?? o;
  };
  return /* @__PURE__ */ Cn.jsxs(b, { flexDirection: "column", gap: "200", children: [
    /* @__PURE__ */ Cn.jsx(b, { flexDirection: "row", flexWrap: "wrap", margin: "0 0 300", children: !!n?.length && /* @__PURE__ */ Cn.jsxs(b, { gap: "100", children: [
      /* @__PURE__ */ Cn.jsx(Ge, { content: "Conversation Attributes", children: /* @__PURE__ */ Cn.jsx(
        Vm,
        {
          icon: "input",
          color: {
            contentColor: "var(--dixa-color-neutral-700)",
            backgroundColor: "var(--dixa-color-neutral-200)"
          }
        }
      ) }),
      n.map((o, s) => /* @__PURE__ */ Cn.jsx(b, { alignItems: "center", children: /* @__PURE__ */ Cn.jsx(An, { className: Lo.chip, children: /* @__PURE__ */ Cn.jsxs(b, { gap: "100", children: [
        /* @__PURE__ */ Cn.jsxs(Zn, { className: Lo.chipLabel, children: [
          o.name,
          ":"
        ] }),
        /* @__PURE__ */ Cn.jsx(Zn, { className: Lo.chipValue, children: o.value })
      ] }) }) }, `${s}-${o.name}`))
    ] }) }),
    e?.map((o) => /* @__PURE__ */ Cn.jsx(
      b,
      {
        className: Lo.messageContainer,
        gap: "200",
        style: {
          backgroundColor: o?.direction ? fk[o.direction].background : "var(--dixa-color-neutral-000)",
          borderColor: o?.direction ? fk[o.direction].borderColor : "var(--dixa-color-neutral-100)"
        },
        children: /* @__PURE__ */ Cn.jsxs(b, { flexDirection: "column", gap: "200", width: "100%", children: [
          /* @__PURE__ */ Cn.jsxs(b, { flexDirection: "row", justifyContent: "space-between", children: [
            /* @__PURE__ */ Cn.jsx(A.Heading, { variant: "heading-3", children: o?.direction == "INBOUND" ? a() : o?.agent?.name }),
            /* @__PURE__ */ Cn.jsx(A.Paragraph, { variant: "4", children: /* @__PURE__ */ Cn.jsx(y0, { relative: !0, time: o?.created_at }) })
          ] }),
          /* @__PURE__ */ Cn.jsx(
            "div",
            {
              dangerouslySetInnerHTML: {
                __html: gL.sanitize(
                  o?.body?.replaceAll(/\r\n?|\n/g, "<br />") || ""
                )
              }
            }
          )
        ] })
      },
      o?.created_at
    )),
    r && /* @__PURE__ */ Cn.jsx(b, { gap: "200", flexDirection: "row", flexWrap: "wrap", margin: "300 0 0", children: r.map((o, s) => /* @__PURE__ */ Cn.jsx(
      g0,
      {
        fileName: o.url,
        label: o.label,
        onDownload: () => {
          window.open(o.url, "_blank")?.focus();
        }
      },
      `${s}-${o.url}`
    )) }),
    /* @__PURE__ */ Cn.jsx("div", { id: "endOfConversationAnchor", children: " " })
  ] });
}, SL = "_conversation_1draa_1", NL = "_conversationSubLine_1draa_9", jL = "_modal_1draa_14", Cu = {
  conversation: SL,
  conversationSubLine: NL,
  modal: jL
}, wL = (e) => (e && JSON.parse(e) || []).map((n) => ({
  url: n.URL__c,
  label: n.Name,
  type: n.File_Type__c
})), CL = (e) => Object.entries(e || {}).filter(([n]) => n.endsWith("__c")).map(([n, r]) => ({
  name: n.replace("__c", "").replaceAll("_", " "),
  // transform key into readable name
  value: r?.value ? r.value.toString() : ""
})), FL = ({
  conversation: e,
  conversationContext: n
}) => {
  const [r, i] = se(!1), a = e?.created_at, o = e?.custom_fields, s = o && "attachments" in o;
  return /* @__PURE__ */ Cn.jsxs(b, { className: Cu.conversation, gap: "300", flexDirection: "column", children: [
    /* @__PURE__ */ Cn.jsxs(b, { justifyContent: "space-between", alignItems: "center", children: [
      /* @__PURE__ */ Cn.jsxs(b, { flexDirection: "column", gap: "100", children: [
        /* @__PURE__ */ Cn.jsxs(b, { flexDirection: "row", gap: "100", children: [
          /* @__PURE__ */ Cn.jsx(A.Heading, { variant: "heading-4", children: e?.id }),
          a && /* @__PURE__ */ Cn.jsx(Pn, { size: "small", variant: "info", children: Ln(e?.created_at).format("DD MMM YYYY @ HH:mm") })
        ] }),
        /* @__PURE__ */ Cn.jsx(
          A.Heading,
          {
            variant: "heading-4",
            className: Cu.conversationSubLine,
            children: e?.subject
          }
        ),
        !!e?.labels?.length && /* @__PURE__ */ Cn.jsx(b, { gap: "200", flexDirection: "row", flexWrap: "wrap", children: [...new Set(e.labels)].map((l) => /* @__PURE__ */ Cn.jsx(An, { children: l }, `${e.id}-${l}`)) })
      ] }),
      /* @__PURE__ */ Cn.jsx(Ge, { content: "Show conversation preview", children: /* @__PURE__ */ Cn.jsx(
        Qt,
        {
          variant: "secondary",
          icon: "eye",
          onClick: () => i(!0),
          "data-testid": "open-messages-preview"
        }
      ) })
    ] }),
    /* @__PURE__ */ Cn.jsxs(
      wt,
      {
        isOpen: r,
        allowEscClose: !0,
        onClose: () => i(!1),
        className: Cu.modal,
        children: [
          /* @__PURE__ */ Cn.jsx(
            Ct,
            {
              title: "Conversation preview",
              onClose: () => i(!1)
            }
          ),
          /* @__PURE__ */ Cn.jsx(Ft, { children: /* @__PURE__ */ Cn.jsx(
            xL,
            {
              messages: e?.messages || [],
              ...s && {
                attachments: wL(
                  o?.attachments?.value
                )
              },
              conversationContext: n,
              customFields: CL(
                e?.custom_fields
              )
            }
          ) })
        ]
      }
    )
  ] });
}, IL = ({
  conversations: e,
  conversationContext: n,
  conversationsToShow: r
}) => {
  const [i, a] = se(!1), o = r > 0 ? r : 1, s = e?.length > o, l = Bn(
    () => e?.sort((d, m) => m?.created_at.localeCompare(d?.created_at)).slice(
      0,
      i ? e.length : o
    ),
    [e, i, o]
  );
  return /* @__PURE__ */ Cn.jsxs(b, { flexDirection: "column", gap: "200", margin: "200 0 300 0", children: [
    l.map((d, m) => /* @__PURE__ */ Cn.jsx(
      FL,
      {
        conversation: d,
        conversationContext: n
      },
      `${m}-${d?.id}`
    )),
    s && /* @__PURE__ */ Cn.jsxs(
      Wn,
      {
        variant: "secondary",
        onClick: () => a(!i),
        children: [
          "Show ",
          i ? "less" : "all"
        ]
      }
    )
  ] });
}, EL = Y2(
  /* GraphQL*/
  `
  query conversationsQuery($query: String) {
    Miuros {
      findTickets(query: $query, page_size: 10) {
        data {
          id
          labels
          subject
          messages {
            direction
            body
            agent {
              email
              name
            }
            created_at
          }
          custom_fields {
            additionalProperties {
              key
              value {
                value
              }
            }
          }
          created_at
        }
      }
    }
  }
`
), TL = ({
  conversationContext: e,
  settings: n
}) => {
  const [r, i] = se([]), a = Number.parseInt(n?.amountOfConversationsToShow) || 1, o = [
    e.customer?.email,
    e.customer?.phone_number
  ].filter((u) => !!u).map((u) => `'${u}'`).join(","), { useQuery: s } = mn(), { data: l, loading: d, error: m } = s(EL, {
    skip: o.length === 0,
    variables: {
      query: `requester_id=in=(${o})`
    }
  });
  return He(() => {
    if (l?.Miuros) {
      const u = l?.Miuros?.findTickets?.data;
      u && i(u);
    }
  }, [l]), m ? /* @__PURE__ */ Cn.jsx(Fn, { error: m }) : d ? /* @__PURE__ */ Cn.jsx(b, { justifyContent: "center", margin: "200 0 300 0", children: /* @__PURE__ */ Cn.jsx(cn, {}) }) : r?.length === 0 ? /* @__PURE__ */ Cn.jsx(b, { justifyContent: "center", margin: "200 0 300 0", children: "No conversations found for this customer" }) : /* @__PURE__ */ Cn.jsx(
    IL,
    {
      "data-testid": "conversation-list",
      conversationsToShow: a,
      conversations: r,
      conversationContext: e
    }
  );
}, $L = [
  {
    key: "miurosClientId",
    label: "Authorization: Client ID",
    placeholder: "Insert client ID",
    required: !0,
    secret: !1,
    type: "input"
  },
  {
    key: "miurosClientSecret",
    label: "Authorization: Client Secret",
    placeholder: "Insert client secret",
    required: !0,
    secret: !0,
    type: "input"
  },
  {
    key: "authorizeWithOauth",
    label: "Authorize",
    secret: !1,
    type: "custom",
    hideOnCreate: !0,
    component: vi
  },
  {
    key: "amountOfConversationsToShow",
    label: "Number of conversation to show before the fold",
    placeholder: "Enter number",
    required: !0,
    defaultValue: "1",
    secret: !1,
    type: "input",
    customValidation: (e) => isNaN(Number.parseInt(e)) ? "Please enter a number" : void 0
  }
];
(function() {
  try {
    if (typeof document < "u") {
      var e = document.createElement("style");
      e.appendChild(document.createTextNode("._list_2c4dq_1{padding:0}._listItem_2c4dq_4{padding:var(--dixa-size-spacer-100);border-bottom:var(--dixa-size-border-100) solid var(--dixa-color-neutral-200)}._listItem_2c4dq_4:last-child{border-bottom:none}._copyIcon_2c4dq_12{cursor:pointer;color:var(--dixa-typography-color-secondary)}._wrapper_1nher_1{border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-300);background-color:var(--dixa-color-neutral-100)}._order_1dlaa_1{border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-250)}._order_1dlaa_1:hover,._orderIsOpen_1dlaa_9{border-color:var(--dixa-color-neutral-400)}._orderHeader_1dlaa_12{cursor:pointer}._note_1dlaa_16{border:var(--dixa-size-border-100) dashed var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-200);max-height:100px;overflow-y:auto}")), document.head.appendChild(e);
    }
  } catch (n) {
    console.error("vite-plugin-css-injected-by-js", n);
  }
})();
var Fu = { exports: {} }, Fa = {}, hk;
function DL() {
  if (hk) return Fa;
  hk = 1;
  var e = je, n = Symbol.for("react.element"), r = Symbol.for("react.fragment"), i = Object.prototype.hasOwnProperty, a = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, o = { key: !0, ref: !0, __self: !0, __source: !0 };
  function s(l, d, m) {
    var u, f = {}, h = null, v = null;
    m !== void 0 && (h = "" + m), d.key !== void 0 && (h = "" + d.key), d.ref !== void 0 && (v = d.ref);
    for (u in d) i.call(d, u) && !o.hasOwnProperty(u) && (f[u] = d[u]);
    if (l && l.defaultProps) for (u in d = l.defaultProps, d) f[u] === void 0 && (f[u] = d[u]);
    return { $$typeof: n, type: l, key: h, ref: v, props: f, _owner: a.current };
  }
  return Fa.Fragment = r, Fa.jsx = s, Fa.jsxs = s, Fa;
}
var Vo = {}, yk;
function RL() {
  return yk || (yk = 1, process.env.NODE_ENV !== "production" && (function() {
    var e = je, n = Symbol.for("react.element"), r = Symbol.for("react.portal"), i = Symbol.for("react.fragment"), a = Symbol.for("react.strict_mode"), o = Symbol.for("react.profiler"), s = Symbol.for("react.provider"), l = Symbol.for("react.context"), d = Symbol.for("react.forward_ref"), m = Symbol.for("react.suspense"), u = Symbol.for("react.suspense_list"), f = Symbol.for("react.memo"), h = Symbol.for("react.lazy"), v = Symbol.for("react.offscreen"), C = Symbol.iterator, S = "@@iterator";
    function j(t) {
      if (t === null || typeof t != "object")
        return null;
      var c = C && t[C] || t[S];
      return typeof c == "function" ? c : null;
    }
    var F = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function y(t) {
      {
        for (var c = arguments.length, p = new Array(c > 1 ? c - 1 : 0), g = 1; g < c; g++)
          p[g - 1] = arguments[g];
        q("error", t, p);
      }
    }
    function q(t, c, p) {
      {
        var g = F.ReactDebugCurrentFrame, P = g.getStackAddendum();
        P !== "" && (c += "%s", p = p.concat([P]));
        var L = p.map(function(I) {
          return String(I);
        });
        L.unshift("Warning: " + c), Function.prototype.apply.call(console[t], console, L);
      }
    }
    var T = !1, E = !1, D = !1, B = !1, ee = !1, J;
    J = Symbol.for("react.module.reference");
    function ae(t) {
      return !!(typeof t == "string" || typeof t == "function" || t === i || t === o || ee || t === a || t === m || t === u || B || t === v || T || E || D || typeof t == "object" && t !== null && (t.$$typeof === h || t.$$typeof === f || t.$$typeof === s || t.$$typeof === l || t.$$typeof === d || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      t.$$typeof === J || t.getModuleId !== void 0));
    }
    function Q(t, c, p) {
      var g = t.displayName;
      if (g)
        return g;
      var P = c.displayName || c.name || "";
      return P !== "" ? p + "(" + P + ")" : p;
    }
    function U(t) {
      return t.displayName || "Context";
    }
    function O(t) {
      if (t == null)
        return null;
      if (typeof t.tag == "number" && y("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof t == "function")
        return t.displayName || t.name || null;
      if (typeof t == "string")
        return t;
      switch (t) {
        case i:
          return "Fragment";
        case r:
          return "Portal";
        case o:
          return "Profiler";
        case a:
          return "StrictMode";
        case m:
          return "Suspense";
        case u:
          return "SuspenseList";
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case l:
            var c = t;
            return U(c) + ".Consumer";
          case s:
            var p = t;
            return U(p._context) + ".Provider";
          case d:
            return Q(t, t.render, "ForwardRef");
          case f:
            var g = t.displayName || null;
            return g !== null ? g : O(t.type) || "Memo";
          case h: {
            var P = t, L = P._payload, I = P._init;
            try {
              return O(I(L));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var H = Object.assign, Z = 0, ye, ce, le, ue, W, ke, Ee;
    function K() {
    }
    K.__reactDisabledLog = !0;
    function qe() {
      {
        if (Z === 0) {
          ye = console.log, ce = console.info, le = console.warn, ue = console.error, W = console.group, ke = console.groupCollapsed, Ee = console.groupEnd;
          var t = {
            configurable: !0,
            enumerable: !0,
            value: K,
            writable: !0
          };
          Object.defineProperties(console, {
            info: t,
            log: t,
            warn: t,
            error: t,
            group: t,
            groupCollapsed: t,
            groupEnd: t
          });
        }
        Z++;
      }
    }
    function Be() {
      {
        if (Z--, Z === 0) {
          var t = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: H({}, t, {
              value: ye
            }),
            info: H({}, t, {
              value: ce
            }),
            warn: H({}, t, {
              value: le
            }),
            error: H({}, t, {
              value: ue
            }),
            group: H({}, t, {
              value: W
            }),
            groupCollapsed: H({}, t, {
              value: ke
            }),
            groupEnd: H({}, t, {
              value: Ee
            })
          });
        }
        Z < 0 && y("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var Pe = F.ReactCurrentDispatcher, Me;
    function Fe(t, c, p) {
      {
        if (Me === void 0)
          try {
            throw Error();
          } catch (P) {
            var g = P.stack.trim().match(/\n( *(at )?)/);
            Me = g && g[1] || "";
          }
        return `
` + Me + t;
      }
    }
    var Ae = !1, $e;
    {
      var tn = typeof WeakMap == "function" ? WeakMap : Map;
      $e = new tn();
    }
    function Ie(t, c) {
      if (!t || Ae)
        return "";
      {
        var p = $e.get(t);
        if (p !== void 0)
          return p;
      }
      var g;
      Ae = !0;
      var P = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var L;
      L = Pe.current, Pe.current = null, qe();
      try {
        if (c) {
          var I = function() {
            throw Error();
          };
          if (Object.defineProperty(I.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(I, []);
            } catch (ne) {
              g = ne;
            }
            Reflect.construct(t, [], I);
          } else {
            try {
              I.call();
            } catch (ne) {
              g = ne;
            }
            t.call(I.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (ne) {
            g = ne;
          }
          t();
        }
      } catch (ne) {
        if (ne && g && typeof ne.stack == "string") {
          for (var N = ne.stack.split(`
`), te = g.stack.split(`
`), x = N.length - 1, V = te.length - 1; x >= 1 && V >= 0 && N[x] !== te[V]; )
            V--;
          for (; x >= 1 && V >= 0; x--, V--)
            if (N[x] !== te[V]) {
              if (x !== 1 || V !== 1)
                do
                  if (x--, V--, V < 0 || N[x] !== te[V]) {
                    var X = `
` + N[x].replace(" at new ", " at ");
                    return t.displayName && X.includes("<anonymous>") && (X = X.replace("<anonymous>", t.displayName)), typeof t == "function" && $e.set(t, X), X;
                  }
                while (x >= 1 && V >= 0);
              break;
            }
        }
      } finally {
        Ae = !1, Pe.current = L, Be(), Error.prepareStackTrace = P;
      }
      var we = t ? t.displayName || t.name : "", Se = we ? Fe(we) : "";
      return typeof t == "function" && $e.set(t, Se), Se;
    }
    function We(t, c, p) {
      return Ie(t, !1);
    }
    function Ze(t) {
      var c = t.prototype;
      return !!(c && c.isReactComponent);
    }
    function de(t, c, p) {
      if (t == null)
        return "";
      if (typeof t == "function")
        return Ie(t, Ze(t));
      if (typeof t == "string")
        return Fe(t);
      switch (t) {
        case m:
          return Fe("Suspense");
        case u:
          return Fe("SuspenseList");
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case d:
            return We(t.render);
          case f:
            return de(t.type, c, p);
          case h: {
            var g = t, P = g._payload, L = g._init;
            try {
              return de(L(P), c, p);
            } catch {
            }
          }
        }
      return "";
    }
    var fe = Object.prototype.hasOwnProperty, Te = {}, Le = F.ReactDebugCurrentFrame;
    function Re(t) {
      if (t) {
        var c = t._owner, p = de(t.type, t._source, c ? c.type : null);
        Le.setExtraStackFrame(p);
      } else
        Le.setExtraStackFrame(null);
    }
    function sn(t, c, p, g, P) {
      {
        var L = Function.call.bind(fe);
        for (var I in t)
          if (L(t, I)) {
            var N = void 0;
            try {
              if (typeof t[I] != "function") {
                var te = Error((g || "React class") + ": " + p + " type `" + I + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof t[I] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw te.name = "Invariant Violation", te;
              }
              N = t[I](c, I, g, p, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (x) {
              N = x;
            }
            N && !(N instanceof Error) && (Re(P), y("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", g || "React class", p, I, typeof N), Re(null)), N instanceof Error && !(N.message in Te) && (Te[N.message] = !0, Re(P), y("Failed %s type: %s", p, N.message), Re(null));
          }
      }
    }
    var w = Array.isArray;
    function _(t) {
      return w(t);
    }
    function $(t) {
      {
        var c = typeof Symbol == "function" && Symbol.toStringTag, p = c && t[Symbol.toStringTag] || t.constructor.name || "Object";
        return p;
      }
    }
    function G(t) {
      try {
        return Y(t), !1;
      } catch {
        return !0;
      }
    }
    function Y(t) {
      return "" + t;
    }
    function R(t) {
      if (G(t))
        return y("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", $(t)), Y(t);
    }
    var z = F.ReactCurrentOwner, ie = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, pe, _e;
    function en(t) {
      if (fe.call(t, "ref")) {
        var c = Object.getOwnPropertyDescriptor(t, "ref").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.ref !== void 0;
    }
    function un(t) {
      if (fe.call(t, "key")) {
        var c = Object.getOwnPropertyDescriptor(t, "key").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.key !== void 0;
    }
    function rn(t, c) {
      typeof t.ref == "string" && z.current;
    }
    function dn(t, c) {
      {
        var p = function() {
          pe || (pe = !0, y("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "key", {
          get: p,
          configurable: !0
        });
      }
    }
    function pn(t, c) {
      {
        var p = function() {
          _e || (_e = !0, y("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "ref", {
          get: p,
          configurable: !0
        });
      }
    }
    var ln = function(t, c, p, g, P, L, I) {
      var N = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: n,
        // Built-in properties that belong on the element
        type: t,
        key: c,
        ref: p,
        props: I,
        // Record the component responsible for creating this element.
        _owner: L
      };
      return N._store = {}, Object.defineProperty(N._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(N, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: g
      }), Object.defineProperty(N, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: P
      }), Object.freeze && (Object.freeze(N.props), Object.freeze(N)), N;
    };
    function kn(t, c, p, g, P) {
      {
        var L, I = {}, N = null, te = null;
        p !== void 0 && (R(p), N = "" + p), un(c) && (R(c.key), N = "" + c.key), en(c) && (te = c.ref, rn(c));
        for (L in c)
          fe.call(c, L) && !ie.hasOwnProperty(L) && (I[L] = c[L]);
        if (t && t.defaultProps) {
          var x = t.defaultProps;
          for (L in x)
            I[L] === void 0 && (I[L] = x[L]);
        }
        if (N || te) {
          var V = typeof t == "function" ? t.displayName || t.name || "Unknown" : t;
          N && dn(I, V), te && pn(I, V);
        }
        return ln(t, N, te, P, g, z.current, I);
      }
    }
    var Xe = F.ReactCurrentOwner, Sn = F.ReactDebugCurrentFrame;
    function Oe(t) {
      if (t) {
        var c = t._owner, p = de(t.type, t._source, c ? c.type : null);
        Sn.setExtraStackFrame(p);
      } else
        Sn.setExtraStackFrame(null);
    }
    var an;
    an = !1;
    function on(t) {
      return typeof t == "object" && t !== null && t.$$typeof === n;
    }
    function yn() {
      {
        if (Xe.current) {
          var t = O(Xe.current.type);
          if (t)
            return `

Check the render method of \`` + t + "`.";
        }
        return "";
      }
    }
    function qn(t) {
      return "";
    }
    var Nn = {};
    function gn(t) {
      {
        var c = yn();
        if (!c) {
          var p = typeof t == "string" ? t : t.displayName || t.name;
          p && (c = `

Check the top-level render call using <` + p + ">.");
        }
        return c;
      }
    }
    function hn(t, c) {
      {
        if (!t._store || t._store.validated || t.key != null)
          return;
        t._store.validated = !0;
        var p = gn(c);
        if (Nn[p])
          return;
        Nn[p] = !0;
        var g = "";
        t && t._owner && t._owner !== Xe.current && (g = " It was passed a child from " + O(t._owner.type) + "."), Oe(t), y('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', p, g), Oe(null);
      }
    }
    function jn(t, c) {
      {
        if (typeof t != "object")
          return;
        if (_(t))
          for (var p = 0; p < t.length; p++) {
            var g = t[p];
            on(g) && hn(g, c);
          }
        else if (on(t))
          t._store && (t._store.validated = !0);
        else if (t) {
          var P = j(t);
          if (typeof P == "function" && P !== t.entries)
            for (var L = P.call(t), I; !(I = L.next()).done; )
              on(I.value) && hn(I.value, c);
        }
      }
    }
    function Un(t) {
      {
        var c = t.type;
        if (c == null || typeof c == "string")
          return;
        var p;
        if (typeof c == "function")
          p = c.propTypes;
        else if (typeof c == "object" && (c.$$typeof === d || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        c.$$typeof === f))
          p = c.propTypes;
        else
          return;
        if (p) {
          var g = O(c);
          sn(p, t.props, "prop", g, t);
        } else if (c.PropTypes !== void 0 && !an) {
          an = !0;
          var P = O(c);
          y("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", P || "Unknown");
        }
        typeof c.getDefaultProps == "function" && !c.getDefaultProps.isReactClassApproved && y("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function Vn(t) {
      {
        for (var c = Object.keys(t.props), p = 0; p < c.length; p++) {
          var g = c[p];
          if (g !== "children" && g !== "key") {
            Oe(t), y("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", g), Oe(null);
            break;
          }
        }
        t.ref !== null && (Oe(t), y("Invalid attribute `ref` supplied to `React.Fragment`."), Oe(null));
      }
    }
    var _n = {};
    function xn(t, c, p, g, P, L) {
      {
        var I = ae(t);
        if (!I) {
          var N = "";
          (t === void 0 || typeof t == "object" && t !== null && Object.keys(t).length === 0) && (N += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var te = qn();
          te ? N += te : N += yn();
          var x;
          t === null ? x = "null" : _(t) ? x = "array" : t !== void 0 && t.$$typeof === n ? (x = "<" + (O(t.type) || "Unknown") + " />", N = " Did you accidentally export a JSX literal instead of a component?") : x = typeof t, y("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", x, N);
        }
        var V = kn(t, c, p, P, L);
        if (V == null)
          return V;
        if (I) {
          var X = c.children;
          if (X !== void 0)
            if (g)
              if (_(X)) {
                for (var we = 0; we < X.length; we++)
                  jn(X[we], t);
                Object.freeze && Object.freeze(X);
              } else
                y("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              jn(X, t);
        }
        if (fe.call(c, "key")) {
          var Se = O(t), ne = Object.keys(c).filter(function(wn) {
            return wn !== "key";
          }), nn = ne.length > 0 ? "{key: someKey, " + ne.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!_n[Se + nn]) {
            var Tn = ne.length > 0 ? "{" + ne.join(": ..., ") + ": ...}" : "{}";
            y(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, nn, Se, Tn, Se), _n[Se + nn] = !0;
          }
        }
        return t === i ? Vn(V) : Un(V), V;
      }
    }
    function Hn(t, c, p) {
      return xn(t, c, p, !0);
    }
    function Dn(t, c, p) {
      return xn(t, c, p, !1);
    }
    var Rn = Dn, Mn = Hn;
    Vo.Fragment = i, Vo.jsx = Rn, Vo.jsxs = Mn;
  })()), Vo;
}
var gk;
function OL() {
  return gk || (gk = 1, process.env.NODE_ENV === "production" ? Fu.exports = DL() : Fu.exports = RL()), Fu.exports;
}
var be = OL();
const PL = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getAddresses" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "customerId" } }, type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Recharge" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "getAddresses" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "customer_id" }, value: { kind: "Variable", name: { kind: "Name", value: "customerId" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Recharge_Addresses" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "addresses" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "payment_method_id" } }, { kind: "Field", name: { kind: "Name", value: "address1" } }, { kind: "Field", name: { kind: "Name", value: "address2" } }, { kind: "Field", name: { kind: "Name", value: "city" } }, { kind: "Field", name: { kind: "Name", value: "company" } }, { kind: "Field", name: { kind: "Name", value: "country_code" } }, { kind: "Field", name: { kind: "Name", value: "created_at" } }, { kind: "Field", name: { kind: "Name", value: "customer_id" } }, { kind: "Field", name: { kind: "Name", value: "discounts" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "value" } }, { kind: "Field", name: { kind: "Name", value: "value_type" } }] } }, { kind: "Field", name: { kind: "Name", value: "first_name" } }, { kind: "Field", name: { kind: "Name", value: "last_name" } }, { kind: "Field", name: { kind: "Name", value: "order_attributes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "value" } }] } }, { kind: "Field", name: { kind: "Name", value: "order_note" } }, { kind: "Field", name: { kind: "Name", value: "phone" } }, { kind: "Field", name: { kind: "Name", value: "presentment_currency" } }, { kind: "Field", name: { kind: "Name", value: "shipping_lines_conserved" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "price" } }] } }, { kind: "Field", name: { kind: "Name", value: "shipping_lines_override" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "price" } }] } }, { kind: "Field", name: { kind: "Name", value: "updated_at" } }, { kind: "Field", name: { kind: "Name", value: "zip" } }] } }] } }] } }] } }] } }] }, AL = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getCustomerDetails" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "email" } }, type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Recharge" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "getStore" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Recharge_Store" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "store" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "external_platform" } }, { kind: "Field", name: { kind: "Name", value: "customer_portal_base_url" } }, { kind: "Field", name: { kind: "Name", value: "merchant_portal_base_url" } }, { kind: "Field", name: { kind: "Name", value: "identifier" } }, { kind: "Field", name: { kind: "Name", value: "checkout_platform" } }, { kind: "Field", name: { kind: "Name", value: "external_platform" } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "getCustomers" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "email" }, value: { kind: "Variable", name: { kind: "Name", value: "email" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Recharge_Customers" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "customers" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "email" } }, { kind: "Field", name: { kind: "Name", value: "phone" } }, { kind: "Field", name: { kind: "Name", value: "first_name" } }, { kind: "Field", name: { kind: "Name", value: "last_name" } }, { kind: "Field", name: { kind: "Name", value: "created_at" } }, { kind: "Field", name: { kind: "Name", value: "updated_at" } }, { kind: "Field", name: { kind: "Name", value: "external_customer_id" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "ecommerce" } }] } }, { kind: "Field", name: { kind: "Name", value: "subscriptions_active_count" } }, { kind: "Field", name: { kind: "Name", value: "subscriptions_total_count" } }, { kind: "Field", name: { kind: "Name", value: "has_valid_payment_method" } }, { kind: "Field", name: { kind: "Name", value: "hash" } }] } }] } }] } }] } }] } }] }, LL = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getOrders" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "customerId" } }, type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "limit" } }, type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "addressId" } }, type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Recharge" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "getOrders" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "customer_id" }, value: { kind: "Variable", name: { kind: "Name", value: "customerId" } } }, { kind: "Argument", name: { kind: "Name", value: "limit" }, value: { kind: "Variable", name: { kind: "Name", value: "limit" } } }, { kind: "Argument", name: { kind: "Name", value: "address_id" }, value: { kind: "Variable", name: { kind: "Name", value: "addressId" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Recharge_Orders" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "orders" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "created_at" } }, { kind: "Field", name: { kind: "Name", value: "currency" } }, { kind: "Field", name: { kind: "Name", value: "is_prepaid" } }, { kind: "Field", name: { kind: "Name", value: "note" } }, { kind: "Field", name: { kind: "Name", value: "status" } }, { kind: "Field", name: { kind: "Name", value: "subtotal_price" } }, { kind: "Field", name: { kind: "Name", value: "total_discounts" } }, { kind: "Field", name: { kind: "Name", value: "total_duties" } }, { kind: "Field", name: { kind: "Name", value: "total_line_items_price" } }, { kind: "Field", name: { kind: "Name", value: "total_price" } }, { kind: "Field", name: { kind: "Name", value: "total_refunds" } }, { kind: "Field", name: { kind: "Name", value: "total_tax" } }, { kind: "Field", name: { kind: "Name", value: "total_weight_grams" } }, { kind: "Field", name: { kind: "Name", value: "type" } }, { kind: "Field", name: { kind: "Name", value: "charge" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "external_transaction_id" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "payment_processor" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "billing_address" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "address1" } }, { kind: "Field", name: { kind: "Name", value: "address2" } }, { kind: "Field", name: { kind: "Name", value: "city" } }, { kind: "Field", name: { kind: "Name", value: "company" } }, { kind: "Field", name: { kind: "Name", value: "country_code" } }, { kind: "Field", name: { kind: "Name", value: "first_name" } }, { kind: "Field", name: { kind: "Name", value: "last_name" } }, { kind: "Field", name: { kind: "Name", value: "phone" } }, { kind: "Field", name: { kind: "Name", value: "province" } }, { kind: "Field", name: { kind: "Name", value: "zip" } }] } }, { kind: "Field", name: { kind: "Name", value: "shipping_address" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "address1" } }, { kind: "Field", name: { kind: "Name", value: "address2" } }, { kind: "Field", name: { kind: "Name", value: "city" } }, { kind: "Field", name: { kind: "Name", value: "company" } }, { kind: "Field", name: { kind: "Name", value: "country_code" } }, { kind: "Field", name: { kind: "Name", value: "first_name" } }, { kind: "Field", name: { kind: "Name", value: "last_name" } }, { kind: "Field", name: { kind: "Name", value: "phone" } }, { kind: "Field", name: { kind: "Name", value: "province" } }, { kind: "Field", name: { kind: "Name", value: "zip" } }] } }] } }] } }] } }] } }] } }] }, VL = {
  "\n  query getAddresses($customerId: String) {\n    Recharge {\n      getAddresses(customer_id: $customerId) {\n        ... on Recharge_Addresses {\n          addresses {\n            id\n            payment_method_id\n            address1\n            address2\n            city\n            company\n            country_code\n            created_at\n            customer_id\n            discounts {\n              id\n              code\n              value\n              value_type\n            }\n            first_name\n            last_name\n            order_attributes {\n              name\n              value\n            }\n            order_note\n            phone\n            presentment_currency\n            shipping_lines_conserved {\n              code\n              title\n              price\n            }\n            shipping_lines_override {\n              code\n              title\n              price\n            }\n            updated_at\n            zip\n          }\n        }\n      }\n    }\n  }\n": PL,
  "\n  query getCustomerDetails($email: String) {\n    Recharge {\n      getStore {\n        ... on Recharge_Store {\n          store {\n            id\n            name\n            external_platform\n            customer_portal_base_url\n            merchant_portal_base_url\n            identifier\n            checkout_platform\n            external_platform\n          }\n        }\n      }\n      getCustomers(email: $email) {\n        ... on Recharge_Customers {\n          customers {\n            id\n            email\n            phone\n            first_name\n            last_name\n            created_at\n            updated_at\n            external_customer_id {\n              ecommerce\n            }\n            subscriptions_active_count\n            subscriptions_total_count\n            has_valid_payment_method\n            hash\n          }\n        }\n      }\n    }\n  }\n": AL,
  "\n  query getOrders($customerId: String, $limit: String, $addressId: String) {\n    Recharge {\n      getOrders(\n        customer_id: $customerId\n        limit: $limit\n        address_id: $addressId\n      ) {\n        ... on Recharge_Orders {\n          orders {\n            id\n            created_at\n            currency\n            is_prepaid\n            note\n            status\n            subtotal_price\n            total_discounts\n            total_duties\n            total_line_items_price\n            total_price\n            total_refunds\n            total_tax\n            total_weight_grams\n            type\n            charge {\n              external_transaction_id {\n                payment_processor\n              }\n            }\n            billing_address {\n              address1\n              address2\n              city\n              company\n              country_code\n              first_name\n              last_name\n              phone\n              province\n              zip\n            }\n            shipping_address {\n              address1\n              address2\n              city\n              company\n              country_code\n              first_name\n              last_name\n              phone\n              province\n              zip\n            }\n          }\n        }\n      }\n    }\n  }\n": LL
};
function Ap(e) {
  return VL[e] ?? {};
}
const zL = Ap(
  /* GraphQL */
  `
  query getCustomerDetails($email: String) {
    Recharge {
      getStore {
        ... on Recharge_Store {
          store {
            id
            name
            external_platform
            customer_portal_base_url
            merchant_portal_base_url
            identifier
            checkout_platform
            external_platform
          }
        }
      }
      getCustomers(email: $email) {
        ... on Recharge_Customers {
          customers {
            id
            email
            phone
            first_name
            last_name
            created_at
            updated_at
            external_customer_id {
              ecommerce
            }
            subscriptions_active_count
            subscriptions_total_count
            has_valid_payment_method
            hash
          }
        }
      }
    }
  }
`
), UL = Ap(
  /* GraphQL */
  `
  query getAddresses($customerId: String) {
    Recharge {
      getAddresses(customer_id: $customerId) {
        ... on Recharge_Addresses {
          addresses {
            id
            payment_method_id
            address1
            address2
            city
            company
            country_code
            created_at
            customer_id
            discounts {
              id
              code
              value
              value_type
            }
            first_name
            last_name
            order_attributes {
              name
              value
            }
            order_note
            phone
            presentment_currency
            shipping_lines_conserved {
              code
              title
              price
            }
            shipping_lines_override {
              code
              title
              price
            }
            updated_at
            zip
          }
        }
      }
    }
  }
`
), ML = Ap(
  /* GraphQL */
  `
  query getOrders($customerId: String, $limit: String, $addressId: String) {
    Recharge {
      getOrders(
        customer_id: $customerId
        limit: $limit
        address_id: $addressId
      ) {
        ... on Recharge_Orders {
          orders {
            id
            created_at
            currency
            is_prepaid
            note
            status
            subtotal_price
            total_discounts
            total_duties
            total_line_items_price
            total_price
            total_refunds
            total_tax
            total_weight_grams
            type
            charge {
              external_transaction_id {
                payment_processor
              }
            }
            billing_address {
              address1
              address2
              city
              company
              country_code
              first_name
              last_name
              phone
              province
              zip
            }
            shipping_address {
              address1
              address2
              city
              company
              country_code
              first_name
              last_name
              phone
              province
              zip
            }
          }
        }
      }
    }
  }
`
);
function bm(e = !1, n) {
  const [r, i] = se(e);
  return He(() => {
    const a = r ? window.setTimeout(() => i(!1), 2e3) : void 0;
    return () => window.clearTimeout(a);
  }, [n, r]), { isCopied: r, copy: (a) => {
    navigator.clipboard.writeText(a), i(!0);
  } };
}
const BL = (e) => `${e.charAt(0).toUpperCase()}${e.slice(1).toLowerCase()}`, eS = "DD MMM YYYY @ HH:mm", qL = "_list_2c4dq_1", HL = "_listItem_2c4dq_4", WL = "_copyIcon_2c4dq_12", hi = {
  list: qL,
  listItem: HL,
  copyIcon: WL
}, _m = ({
  address: e,
  icon: n,
  title: r,
  isLoading: i = !1,
  hasMultipleAddresses: a = !1
}) => {
  const { isCopied: o, copy: s } = bm(), l = 14, {
    first_name: d,
    last_name: m,
    address1: u,
    address2: f,
    city: h,
    zip: v,
    country_code: C
  } = e ?? {}, S = `${d} ${m}`.trim() || void 0, j = `${h} ${v}`.trim() || void 0, F = [S, u, f, j, C].filter(
    Boolean
  );
  return /* @__PURE__ */ be.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
    /* @__PURE__ */ be.jsxs(b, { gap: "200", children: [
      /* @__PURE__ */ be.jsx(me, { size: l, name: n }),
      i ? /* @__PURE__ */ be.jsx(cn, { size: l }) : /* @__PURE__ */ be.jsxs(b, { gap: "200", flexDirection: "column", children: [
        r && /* @__PURE__ */ be.jsx(A.Paragraph, { variant: "3", children: r }),
        /* @__PURE__ */ be.jsx(A.Paragraph, { variant: "4", children: F.map((y, q) => /* @__PURE__ */ be.jsx(Zn, { children: y }, q)) })
      ] })
    ] }),
    !i && /* @__PURE__ */ be.jsxs(b, { gap: "100", children: [
      a && /* @__PURE__ */ be.jsx(Ge, { content: "The customer has multiple addresses, showing only the first here.", children: /* @__PURE__ */ be.jsx(
        me,
        {
          size: l,
          name: "exclamation",
          className: hi.copyIcon
        }
      ) }),
      /* @__PURE__ */ be.jsx(Ge, { content: `Copy ${r ? r.toLowerCase() : "address"}`, children: /* @__PURE__ */ be.jsx(
        me,
        {
          size: l,
          name: o ? "done" : "copy",
          onClick: () => s(F.join(", ")),
          className: hi.copyIcon
        }
      ) })
    ] })
  ] });
}, KL = "_wrapper_1nher_1", GL = {
  wrapper: KL
}, YL = ({
  customer: e,
  store: n
}) => {
  const { track: r } = bn(), { isCopied: i, copy: a } = bm(), { isCopied: o, copy: s } = bm(), { useQuery: l } = mn(), d = e?.id, {
    loading: m,
    error: u,
    data: f
  } = l(UL, {
    skip: !d,
    variables: {
      customerId: d?.toString()
    }
  }), h = f?.Recharge?.getAddresses, v = !m && h?.addresses?.[0] ? h.addresses[0] : void 0, C = (h?.addresses?.length ?? 0) > 1;
  if (He(() => {
    v && r("recharge:profile:received");
  }, [v, r]), u)
    return /* @__PURE__ */ be.jsx(Fn, { error: u });
  if (!e)
    return null;
  const {
    id: S,
    phone: j,
    email: F,
    first_name: y,
    last_name: q,
    created_at: T,
    has_valid_payment_method: E
  } = e, D = 14, B = n ? `https://${n.identifier}.admin.rechargeapps.com/merchant/customers/${S}` : null, ee = `${y || ""} ${q || ""}`.trim() || "A customer has no name";
  return /* @__PURE__ */ be.jsx(b, { gap: "300", flexDirection: "column", children: /* @__PURE__ */ be.jsxs(b, { className: GL.wrapper, gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ be.jsx(A.Heading, { variant: "heading-2", children: ee }),
    T && /* @__PURE__ */ be.jsxs(b, { gap: "200", justifyContent: "space-between", margin: "0 0 200", children: [
      /* @__PURE__ */ be.jsx(A.Paragraph, { variant: "4", children: "Member since" }),
      /* @__PURE__ */ be.jsx(A.Paragraph, { variant: "4", children: Ln(T).format(eS) })
    ] }),
    F && /* @__PURE__ */ be.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
      /* @__PURE__ */ be.jsxs(b, { gap: "200", alignItems: "center", children: [
        /* @__PURE__ */ be.jsx(me, { size: D, name: "mail" }),
        /* @__PURE__ */ be.jsx(A.ExternalLink, { href: `mailto:${F}`, children: F })
      ] }),
      /* @__PURE__ */ be.jsx(Ge, { content: "Copy email", children: /* @__PURE__ */ be.jsx(
        me,
        {
          size: D,
          name: i ? "done" : "copy",
          onClick: () => a(F),
          className: hi.copyIcon
        }
      ) })
    ] }),
    j && /* @__PURE__ */ be.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
      /* @__PURE__ */ be.jsxs(b, { gap: "200", alignItems: "center", children: [
        /* @__PURE__ */ be.jsx(me, { size: D, name: "phone" }),
        /* @__PURE__ */ be.jsx(A.Paragraph, { variant: "4", children: j })
      ] }),
      /* @__PURE__ */ be.jsx(Ge, { content: "Copy phone number", children: /* @__PURE__ */ be.jsx(
        me,
        {
          size: D,
          name: o ? "done" : "copy",
          onClick: () => s(j),
          className: hi.copyIcon
        }
      ) })
    ] }),
    /* @__PURE__ */ be.jsx(
      _m,
      {
        address: v,
        icon: "home",
        isLoading: m,
        hasMultipleAddresses: C
      }
    ),
    /* @__PURE__ */ be.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
      /* @__PURE__ */ be.jsxs(b, { gap: "200", alignItems: "center", children: [
        /* @__PURE__ */ be.jsx(me, { size: D, name: "credit-card" }),
        /* @__PURE__ */ be.jsx(A.Paragraph, { variant: "4", children: "Has valid payment method" })
      ] }),
      /* @__PURE__ */ be.jsx(
        me,
        {
          size: D,
          name: E ? "check-circle" : "close-circle-filled",
          color: E ? "green.500" : "red.500"
        }
      )
    ] }),
    B && /* @__PURE__ */ be.jsxs(b, { alignItems: "center", gap: "200", children: [
      /* @__PURE__ */ be.jsx(me, { size: D, name: "external-link" }),
      /* @__PURE__ */ be.jsx(
        A.ExternalLink,
        {
          href: B,
          target: "_blank",
          rel: "noreferrer",
          onClick: () => r("recharge:external:customer:overview:opened"),
          children: "View customer in Recharge"
        }
      )
    ] })
  ] }) });
}, QL = "_order_1dlaa_1", JL = "_orderIsOpen_1dlaa_9", XL = "_orderHeader_1dlaa_12", ZL = "_note_1dlaa_16", zo = {
  order: QL,
  orderIsOpen: JL,
  orderHeader: XL,
  note: ZL
}, eV = ({
  order: e,
  isOpenByDefault: n,
  store: r
}) => {
  const { track: i } = bn(), [a, o] = se(n), {
    id: s,
    status: l,
    charge: d,
    currency: m,
    note: u,
    created_at: f,
    billing_address: h,
    shipping_address: v,
    total_price: C,
    is_prepaid: S
  } = e, j = 14, F = r ? `https://${r.identifier}.admin.rechargeapps.com/merchant/orders/${s}` : null, y = d?.external_transaction_id?.payment_processor || void 0;
  return /* @__PURE__ */ be.jsxs(
    b,
    {
      className: rt(zo.order, {
        [zo.orderIsOpen]: a
      }),
      gap: "200",
      flexDirection: "column",
      children: [
        /* @__PURE__ */ be.jsxs(
          b,
          {
            justifyContent: "space-between",
            alignItems: "center",
            className: zo.orderHeader,
            onClick: () => o(!a),
            children: [
              /* @__PURE__ */ be.jsxs(b, { gap: "100", flexDirection: "column", children: [
                f && /* @__PURE__ */ be.jsx(b, { alignItems: "center", children: /* @__PURE__ */ be.jsx(A.Paragraph, { variant: "4", children: Ln(f).format(eS) }) }),
                /* @__PURE__ */ be.jsxs(A.Paragraph, { variant: "1", children: [
                  "Order #",
                  s
                ] })
              ] }),
              /* @__PURE__ */ be.jsx(
                Qt,
                {
                  variant: "tertiary",
                  icon: a ? "angle-down" : "angle-right"
                }
              )
            ]
          }
        ),
        a && /* @__PURE__ */ be.jsxs(b, { gap: "250", flexDirection: "column", margin: "200 0 0", children: [
          u && /* @__PURE__ */ be.jsx(Ge, { content: "Note", children: /* @__PURE__ */ be.jsx(
            A.Paragraph,
            {
              variant: "4",
              color: "secondary",
              className: zo.note,
              children: u
            }
          ) }),
          l && /* @__PURE__ */ be.jsxs(b, { gap: "250", flexDirection: "row", children: [
            /* @__PURE__ */ be.jsx(me, { size: j, name: "activity" }),
            /* @__PURE__ */ be.jsxs(b, { gap: "200", flexDirection: "column", children: [
              /* @__PURE__ */ be.jsx(A.Paragraph, { variant: "3", children: "Status" }),
              /* @__PURE__ */ be.jsx(A.Paragraph, { variant: "4", children: BL(l) })
            ] })
          ] }),
          /* @__PURE__ */ be.jsxs(b, { gap: "250", flexDirection: "row", children: [
            /* @__PURE__ */ be.jsx(me, { size: j, name: "credit-card" }),
            /* @__PURE__ */ be.jsxs(b, { gap: "200", flexDirection: "column", children: [
              /* @__PURE__ */ be.jsx(A.Paragraph, { variant: "3", children: "Prepaid" }),
              /* @__PURE__ */ be.jsx(A.Paragraph, { variant: "4", children: S ? "Yes" : "No" })
            ] })
          ] }),
          y && /* @__PURE__ */ be.jsxs(b, { gap: "250", flexDirection: "row", children: [
            /* @__PURE__ */ be.jsx(me, { size: j, name: "cog" }),
            /* @__PURE__ */ be.jsxs(b, { gap: "200", flexDirection: "column", children: [
              /* @__PURE__ */ be.jsx(A.Paragraph, { variant: "3", children: "Payment processor" }),
              /* @__PURE__ */ be.jsx(A.Paragraph, { variant: "4", children: y })
            ] })
          ] }),
          /* @__PURE__ */ be.jsxs(b, { gap: "250", flexDirection: "row", children: [
            /* @__PURE__ */ be.jsx(me, { size: j, name: "chart-bar" }),
            /* @__PURE__ */ be.jsxs(b, { gap: "200", flexDirection: "column", children: [
              /* @__PURE__ */ be.jsx(A.Paragraph, { variant: "3", children: "Order value" }),
              /* @__PURE__ */ be.jsxs(A.Paragraph, { variant: "4", children: [
                C,
                " ",
                m
              ] })
            ] })
          ] }),
          /* @__PURE__ */ be.jsx(
            _m,
            {
              address: h,
              icon: "home",
              title: "Billing address"
            }
          ),
          /* @__PURE__ */ be.jsx(
            _m,
            {
              address: v,
              icon: "map-pin",
              title: "Shipping address"
            }
          ),
          F && /* @__PURE__ */ be.jsx(
            jt,
            {
              variant: "secondary",
              style: {
                color: "var(--dixa-typography-color-link)",
                padding: "var(--dixa-size-spacer-100)"
              },
              navigate: () => window.open(F, "_blank")?.focus(),
              slotStart: /* @__PURE__ */ be.jsx(me, { name: "external-link" }),
              onClick: () => i("recharge:external:order:opened"),
              children: "View order in Recharge"
            }
          )
        ] })
      ]
    }
  );
}, nV = ({
  customerId: e,
  store: n
}) => {
  const { track: r } = bn(), { useQuery: i } = mn(), {
    loading: a,
    error: o,
    data: s
  } = i(ML, {
    skip: !e,
    variables: {
      customerId: e?.toString(),
      limit: "5"
    }
  }), l = s?.Recharge?.getOrders, d = !a && l?.orders && l.orders.length > 0 ? l.orders : [];
  if (!e)
    return null;
  if (o)
    return /* @__PURE__ */ be.jsx(Fn, { error: o });
  const m = n ? `https://${n.identifier}.admin.rechargeapps.com/merchant/orders/processed?limit=25` : null;
  return /* @__PURE__ */ be.jsxs(b, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ be.jsxs(b, { gap: "200", flexDirection: "row", alignItems: "center", children: [
      /* @__PURE__ */ be.jsx(A.Heading, { variant: "heading-3", children: "Customer orders" }),
      !a && /* @__PURE__ */ be.jsx(Pn, { variant: "success", size: "small", children: d.length })
    ] }),
    /* @__PURE__ */ be.jsxs(b, { gap: "200", flexDirection: "column", children: [
      a && /* @__PURE__ */ be.jsx(b, { justifyContent: "center", margin: "300", children: /* @__PURE__ */ be.jsx(cn, {}) }),
      !a && d.length === 0 && /* @__PURE__ */ be.jsx(
        b,
        {
          justifyContent: "center",
          margin: "200 0 300 0",
          "data-testid": "widget-no-orders",
          children: /* @__PURE__ */ be.jsx(A.Paragraph, { color: "tertiary", children: "No orders found" })
        }
      ),
      !a && d.length > 0 && /* @__PURE__ */ be.jsx(b, { gap: "200", flexDirection: "column", children: d.map((u, f) => /* @__PURE__ */ be.jsx(
        eV,
        {
          order: u,
          isOpenByDefault: f === 0,
          store: n
        },
        `${f}-${u.id}`
      )) }),
      m && /* @__PURE__ */ be.jsx(
        jt,
        {
          variant: "secondary",
          style: {
            color: "var(--dixa-typography-color-link)",
            padding: "var(--dixa-size-spacer-100)"
          },
          navigate: () => window.open(m, "_blank")?.focus(),
          slotStart: /* @__PURE__ */ be.jsx(me, { name: "external-link" }),
          onClick: () => r("recharge:external:orders:list:opened"),
          children: "View all orders in Recharge"
        }
      )
    ] })
  ] });
}, tV = ({
  customer: e
}) => {
  if (!e)
    return null;
  const {
    subscriptions_active_count: n,
    subscriptions_total_count: r
  } = e, i = r ?? 0, a = n ?? 0;
  return /* @__PURE__ */ be.jsxs(b, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ be.jsx(A.Heading, { variant: "heading-3", children: "Subscriptions overview" }),
    /* @__PURE__ */ be.jsxs(Ke, { className: hi.list, children: [
      /* @__PURE__ */ be.jsx(Ke.Text, { variant: "dense", className: hi.listItem, children: /* @__PURE__ */ be.jsxs(b, { justifyContent: "space-between", children: [
        /* @__PURE__ */ be.jsx(A.Paragraph, { variant: "4", children: "Total subscriptions" }),
        /* @__PURE__ */ be.jsx(A.Paragraph, { variant: "4", children: i })
      ] }) }),
      /* @__PURE__ */ be.jsx(Ke.Text, { variant: "dense", className: hi.listItem, children: /* @__PURE__ */ be.jsxs(b, { justifyContent: "space-between", children: [
        /* @__PURE__ */ be.jsx(A.Paragraph, { variant: "4", children: "Active subscriptions" }),
        /* @__PURE__ */ be.jsx(A.Paragraph, { variant: "4", children: a })
      ] }) })
    ] })
  ] });
}, rV = ({
  conversationContext: e,
  settings: n
}) => {
  const { useQuery: r } = mn(), i = e?.customer?.email, a = n.displayCustomerDetails ?? !1, o = n.displaysubscriptionOverview ?? !1, s = n.displayOrders ?? !1, l = !a && !o && !s, {
    loading: d,
    error: m,
    data: u
  } = r(zL, {
    skip: !i,
    variables: {
      email: i
    }
  }), f = !d && u ? u?.Recharge?.getCustomers?.customers?.[0] : void 0, h = !d && u ? u?.Recharge?.getStore?.store ?? void 0 : void 0;
  if (m) {
    const v = m.graphQLErrors;
    return Fm({ errors: v }) ? /* @__PURE__ */ be.jsx(
      A.Paragraph,
      {
        margin: "200 0 300 0",
        color: "secondary",
        "data-testid": "widget-downstream-api-forbidden-error",
        children: "The token used for the integration does not have the necessary access rights. Please contact your administrator."
      }
    ) : Im({ errors: v }) ? /* @__PURE__ */ be.jsx(
      A.Paragraph,
      {
        margin: "200 0 300 0",
        color: "secondary",
        "data-testid": "widget-downstream-api-authorization-error",
        children: "The integration could not authorize against Recharge. Please contact your administrator."
      }
    ) : /* @__PURE__ */ be.jsx(Fn, { error: m });
  }
  return d ? /* @__PURE__ */ be.jsx(b, { justifyContent: "center", margin: "300", children: /* @__PURE__ */ be.jsx(cn, {}) }) : f ? l ? /* @__PURE__ */ be.jsx(
    A.Paragraph,
    {
      margin: "200 0 300 0",
      color: "secondary",
      align: "center",
      "data-testid": "widget-no-features",
      children: "All features toggles in the settings are disabled."
    }
  ) : /* @__PURE__ */ be.jsxs(
    b,
    {
      gap: "300",
      flexDirection: "column",
      margin: "200 0 300 0",
      "data-testid": "widget-wrapper",
      children: [
        a && /* @__PURE__ */ be.jsx(YL, { customer: f, store: h }),
        o && /* @__PURE__ */ be.jsx(tV, { customer: f }),
        s && /* @__PURE__ */ be.jsx(nV, { customerId: f.id, store: h })
      ]
    }
  ) : /* @__PURE__ */ be.jsx(
    A.Paragraph,
    {
      margin: "200 0 300 0",
      color: "secondary",
      align: "center",
      "data-testid": "widget-customer-not-found",
      children: "No data found for this customer in Recharge."
    }
  );
}, iV = [
  {
    key: "rechargeAccessToken",
    label: "API token",
    placeholder: "Insert the Admin API token for Recharge",
    required: !0,
    secret: !0,
    type: "input"
  },
  {
    key: "displayCustomerDetails",
    label: "Displays details of a customer",
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "displaysubscriptionOverview",
    label: "Displays the subscription overview",
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "displayOrders",
    label: "Displays the last 5 orders",
    secret: !1,
    type: "switch",
    defaultValue: !0
  }
], vk = [
  {
    key: "rechargeAccessToken",
    type: "string",
    secret: !0,
    defaultValue: ""
  },
  {
    key: "displayCustomerDetails",
    type: "boolean",
    secret: !1,
    defaultValue: !0
  },
  {
    key: "displaysubscriptionOverview",
    type: "boolean",
    secret: !1,
    defaultValue: !0
  },
  {
    key: "displayOrders",
    type: "boolean",
    secret: !1,
    defaultValue: !0
  }
], aV = {
  enabled: !1,
  name: "",
  rechargeAccessToken: "",
  displayCustomerDetails: !0,
  displaysubscriptionOverview: !0,
  displayOrders: !0
}, oV = ({
  integrationId: e,
  handleRedirect: n,
  showNotification: r,
  automationCouplingState: i
}) => {
  const a = !e, o = Bt({
    mode: "onChange",
    defaultValues: aV
  }), {
    create: s,
    update: l,
    remove: d,
    isLoading: m,
    error: u,
    misconfigurationCause: f,
    setMisconfigurationCause: h
  } = Tm({
    integrationId: e,
    integrationType: "RECHARGE",
    handleRedirect: n,
    showNotification: r
  }), {
    isLoading: v,
    error: C,
    isWidgetUnknown: S,
    refetch: j
  } = $m({
    integrationId: e,
    fieldDefinitions: vk,
    form: o,
    onMisconfigured: h
  }), F = (q) => Rm(q, {
    fieldDefinitions: vk,
    isCreationMode: a,
    create: s,
    update: l
  }), y = o.watch("name");
  return /* @__PURE__ */ be.jsxs(
    Dm,
    {
      form: o,
      integrationId: e,
      onValidSubmit: F,
      error: C ?? u,
      onRetry: C ? j : void 0,
      isLoading: m || v,
      isWidgetUnknown: S,
      children: [
        f && /* @__PURE__ */ be.jsx(Om, { cause: f }),
        /* @__PURE__ */ be.jsxs(vt, { children: [
          /* @__PURE__ */ be.jsx(ze, { children: /* @__PURE__ */ be.jsx(En, { label: "Show the widget in the conversation sidebar", children: /* @__PURE__ */ be.jsx(
            sr,
            {
              name: "enabled",
              control: o.control
            }
          ) }) }),
          /* @__PURE__ */ be.jsx(ze, { span: 3, children: /* @__PURE__ */ be.jsx(
            gt,
            {
              name: "name",
              label: "Widget name",
              control: o.control,
              rules: { required: "Name is required" },
              componentProps: {
                placeholder: "Insert the name of the widget",
                autoComplete: "off"
              }
            }
          ) }),
          /* @__PURE__ */ be.jsx(ze, { span: 3 }),
          /* @__PURE__ */ be.jsx(ze, { span: 3, children: /* @__PURE__ */ be.jsx(
            Eb,
            {
              name: "rechargeAccessToken",
              label: "API token",
              control: o.control,
              isCreationMode: a,
              rules: { required: "API token is required" },
              componentProps: {
                placeholder: "Insert the Admin API token for Recharge",
                autoComplete: "off"
              }
            }
          ) }),
          /* @__PURE__ */ be.jsx(ze, { span: 3 }),
          /* @__PURE__ */ be.jsx(ze, { span: 3, children: /* @__PURE__ */ be.jsx(En, { label: "Displays details of a customer", children: /* @__PURE__ */ be.jsx(
            sr,
            {
              name: "displayCustomerDetails",
              control: o.control
            }
          ) }) }),
          /* @__PURE__ */ be.jsx(ze, { span: 3 }),
          /* @__PURE__ */ be.jsx(ze, { span: 3, children: /* @__PURE__ */ be.jsx(En, { label: "Displays the subscription overview", children: /* @__PURE__ */ be.jsx(
            sr,
            {
              name: "displaysubscriptionOverview",
              control: o.control
            }
          ) }) }),
          /* @__PURE__ */ be.jsx(ze, { span: 3 }),
          /* @__PURE__ */ be.jsx(ze, { span: 3, children: /* @__PURE__ */ be.jsx(En, { label: "Displays the last 5 orders", children: /* @__PURE__ */ be.jsx(
            sr,
            {
              name: "displayOrders",
              control: o.control
            }
          ) }) }),
          /* @__PURE__ */ be.jsx(ze, { span: 3 })
        ] }),
        /* @__PURE__ */ be.jsx(
          Pm,
          {
            integrationType: "RECHARGE",
            integrationId: e,
            widgetName: y,
            isCreationMode: a,
            isSubmitting: o.formState.isSubmitting,
            automationCouplingState: i,
            onConfirmDelete: () => d()
          }
        )
      ]
    }
  );
};
(function() {
  try {
    if (typeof document < "u") {
      var e = document.createElement("style");
      e.appendChild(document.createTextNode("._banner_d9pot_1{border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-300);margin-bottom:var(--dixa-size-spacer-400)}._list_d9pot_8{margin:var(--dixa-size-spacer-200) 0;padding-left:var(--dixa-size-spacer-500)}._list_d9pot_8 li{margin-bottom:var(--dixa-size-spacer-200)}._list_d9pot_8 li:last-child{margin-bottom:0}._list_alvh6_1{padding:0}._listItem_alvh6_4{padding:var(--dixa-size-spacer-100);border-bottom:var(--dixa-size-border-100) solid var(--dixa-color-neutral-200)}._listItem_alvh6_4:last-child{border-bottom:none}._listItemEdit_alvh6_11{cursor:pointer}._fullWidth_alvh6_15{width:100%}._boxWrapper_alvh6_19{border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-200);border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-300)}._modal_1vkwz_1{width:800px}._disabled_1vkwz_5 input{color:var(--dixa-typography-color-tertiary);background-color:var(--dixa-color-neutral-100);pointer-events:none}._wrapper_10fld_1{border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-300) var(--dixa-size-spacer-300) var(--dixa-size-spacer-250);background-color:var(--dixa-color-neutral-100)}._copyIcon_10fld_7{cursor:pointer;color:var(--dixa-typography-color-secondary)}._creationModal_pbe64_1{width:800px}._detailsModal_pbe64_5{width:600px}._percentageSuffix_pbe64_9{background-color:var(--dixa-color-neutral-100);padding:var(--dixa-size-spacer-100) var(--dixa-size-spacer-250)}._modal_11d6e_1{width:600px}._modalBody_11d6e_4{max-height:500px;overflow-y:auto}._codeContainer_11d6e_9{margin:var(--dixa-size-spacer-200) var(--dixa-size-spacer-100) 0 0;padding:var(--dixa-size-spacer-200);border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100)}._modal_1wlra_1{width:800px}._clickableIcon_33mqm_1{cursor:pointer;color:var(--dixa-typography-color-secondary)}._productTableHeader_6h6pl_1>tr>th{height:var(--dixa-size-spacer-300)}._productImage_6h6pl_5{width:50px;height:50px}._modal_1mprq_1{width:900px}._modal_21e62_1{max-width:900px}._modal_al73g_1{width:600px}._editIcon_1dntr_1,._icon_cddi1_1{cursor:pointer;color:var(--dixa-typography-color-secondary)}._link_cddi1_6{font-size:var(--dixa-typography-size-200)}._order_135ze_1{border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-250)}._order_135ze_1:hover,._orderIsOpen_135ze_9{border-color:var(--dixa-color-neutral-400)}._orderHeader_135ze_12{cursor:pointer}._segmentName_1dkhk_1{overflow:hidden;white-space:nowrap}")), document.head.appendChild(e);
    }
  } catch (n) {
    console.error("vite-plugin-css-injected-by-js", n);
  }
})();
var Iu = { exports: {} }, Ia = {}, kk;
function sV() {
  if (kk) return Ia;
  kk = 1;
  var e = je, n = Symbol.for("react.element"), r = Symbol.for("react.fragment"), i = Object.prototype.hasOwnProperty, a = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, o = { key: !0, ref: !0, __self: !0, __source: !0 };
  function s(l, d, m) {
    var u, f = {}, h = null, v = null;
    m !== void 0 && (h = "" + m), d.key !== void 0 && (h = "" + d.key), d.ref !== void 0 && (v = d.ref);
    for (u in d) i.call(d, u) && !o.hasOwnProperty(u) && (f[u] = d[u]);
    if (l && l.defaultProps) for (u in d = l.defaultProps, d) f[u] === void 0 && (f[u] = d[u]);
    return { $$typeof: n, type: l, key: h, ref: v, props: f, _owner: a.current };
  }
  return Ia.Fragment = r, Ia.jsx = s, Ia.jsxs = s, Ia;
}
var Uo = {}, bk;
function lV() {
  return bk || (bk = 1, process.env.NODE_ENV !== "production" && (function() {
    var e = je, n = Symbol.for("react.element"), r = Symbol.for("react.portal"), i = Symbol.for("react.fragment"), a = Symbol.for("react.strict_mode"), o = Symbol.for("react.profiler"), s = Symbol.for("react.provider"), l = Symbol.for("react.context"), d = Symbol.for("react.forward_ref"), m = Symbol.for("react.suspense"), u = Symbol.for("react.suspense_list"), f = Symbol.for("react.memo"), h = Symbol.for("react.lazy"), v = Symbol.for("react.offscreen"), C = Symbol.iterator, S = "@@iterator";
    function j(t) {
      if (t === null || typeof t != "object")
        return null;
      var c = C && t[C] || t[S];
      return typeof c == "function" ? c : null;
    }
    var F = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function y(t) {
      {
        for (var c = arguments.length, p = new Array(c > 1 ? c - 1 : 0), g = 1; g < c; g++)
          p[g - 1] = arguments[g];
        q("error", t, p);
      }
    }
    function q(t, c, p) {
      {
        var g = F.ReactDebugCurrentFrame, P = g.getStackAddendum();
        P !== "" && (c += "%s", p = p.concat([P]));
        var L = p.map(function(I) {
          return String(I);
        });
        L.unshift("Warning: " + c), Function.prototype.apply.call(console[t], console, L);
      }
    }
    var T = !1, E = !1, D = !1, B = !1, ee = !1, J;
    J = Symbol.for("react.module.reference");
    function ae(t) {
      return !!(typeof t == "string" || typeof t == "function" || t === i || t === o || ee || t === a || t === m || t === u || B || t === v || T || E || D || typeof t == "object" && t !== null && (t.$$typeof === h || t.$$typeof === f || t.$$typeof === s || t.$$typeof === l || t.$$typeof === d || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      t.$$typeof === J || t.getModuleId !== void 0));
    }
    function Q(t, c, p) {
      var g = t.displayName;
      if (g)
        return g;
      var P = c.displayName || c.name || "";
      return P !== "" ? p + "(" + P + ")" : p;
    }
    function U(t) {
      return t.displayName || "Context";
    }
    function O(t) {
      if (t == null)
        return null;
      if (typeof t.tag == "number" && y("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof t == "function")
        return t.displayName || t.name || null;
      if (typeof t == "string")
        return t;
      switch (t) {
        case i:
          return "Fragment";
        case r:
          return "Portal";
        case o:
          return "Profiler";
        case a:
          return "StrictMode";
        case m:
          return "Suspense";
        case u:
          return "SuspenseList";
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case l:
            var c = t;
            return U(c) + ".Consumer";
          case s:
            var p = t;
            return U(p._context) + ".Provider";
          case d:
            return Q(t, t.render, "ForwardRef");
          case f:
            var g = t.displayName || null;
            return g !== null ? g : O(t.type) || "Memo";
          case h: {
            var P = t, L = P._payload, I = P._init;
            try {
              return O(I(L));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var H = Object.assign, Z = 0, ye, ce, le, ue, W, ke, Ee;
    function K() {
    }
    K.__reactDisabledLog = !0;
    function qe() {
      {
        if (Z === 0) {
          ye = console.log, ce = console.info, le = console.warn, ue = console.error, W = console.group, ke = console.groupCollapsed, Ee = console.groupEnd;
          var t = {
            configurable: !0,
            enumerable: !0,
            value: K,
            writable: !0
          };
          Object.defineProperties(console, {
            info: t,
            log: t,
            warn: t,
            error: t,
            group: t,
            groupCollapsed: t,
            groupEnd: t
          });
        }
        Z++;
      }
    }
    function Be() {
      {
        if (Z--, Z === 0) {
          var t = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: H({}, t, {
              value: ye
            }),
            info: H({}, t, {
              value: ce
            }),
            warn: H({}, t, {
              value: le
            }),
            error: H({}, t, {
              value: ue
            }),
            group: H({}, t, {
              value: W
            }),
            groupCollapsed: H({}, t, {
              value: ke
            }),
            groupEnd: H({}, t, {
              value: Ee
            })
          });
        }
        Z < 0 && y("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var Pe = F.ReactCurrentDispatcher, Me;
    function Fe(t, c, p) {
      {
        if (Me === void 0)
          try {
            throw Error();
          } catch (P) {
            var g = P.stack.trim().match(/\n( *(at )?)/);
            Me = g && g[1] || "";
          }
        return `
` + Me + t;
      }
    }
    var Ae = !1, $e;
    {
      var tn = typeof WeakMap == "function" ? WeakMap : Map;
      $e = new tn();
    }
    function Ie(t, c) {
      if (!t || Ae)
        return "";
      {
        var p = $e.get(t);
        if (p !== void 0)
          return p;
      }
      var g;
      Ae = !0;
      var P = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var L;
      L = Pe.current, Pe.current = null, qe();
      try {
        if (c) {
          var I = function() {
            throw Error();
          };
          if (Object.defineProperty(I.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(I, []);
            } catch (ne) {
              g = ne;
            }
            Reflect.construct(t, [], I);
          } else {
            try {
              I.call();
            } catch (ne) {
              g = ne;
            }
            t.call(I.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (ne) {
            g = ne;
          }
          t();
        }
      } catch (ne) {
        if (ne && g && typeof ne.stack == "string") {
          for (var N = ne.stack.split(`
`), te = g.stack.split(`
`), x = N.length - 1, V = te.length - 1; x >= 1 && V >= 0 && N[x] !== te[V]; )
            V--;
          for (; x >= 1 && V >= 0; x--, V--)
            if (N[x] !== te[V]) {
              if (x !== 1 || V !== 1)
                do
                  if (x--, V--, V < 0 || N[x] !== te[V]) {
                    var X = `
` + N[x].replace(" at new ", " at ");
                    return t.displayName && X.includes("<anonymous>") && (X = X.replace("<anonymous>", t.displayName)), typeof t == "function" && $e.set(t, X), X;
                  }
                while (x >= 1 && V >= 0);
              break;
            }
        }
      } finally {
        Ae = !1, Pe.current = L, Be(), Error.prepareStackTrace = P;
      }
      var we = t ? t.displayName || t.name : "", Se = we ? Fe(we) : "";
      return typeof t == "function" && $e.set(t, Se), Se;
    }
    function We(t, c, p) {
      return Ie(t, !1);
    }
    function Ze(t) {
      var c = t.prototype;
      return !!(c && c.isReactComponent);
    }
    function de(t, c, p) {
      if (t == null)
        return "";
      if (typeof t == "function")
        return Ie(t, Ze(t));
      if (typeof t == "string")
        return Fe(t);
      switch (t) {
        case m:
          return Fe("Suspense");
        case u:
          return Fe("SuspenseList");
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case d:
            return We(t.render);
          case f:
            return de(t.type, c, p);
          case h: {
            var g = t, P = g._payload, L = g._init;
            try {
              return de(L(P), c, p);
            } catch {
            }
          }
        }
      return "";
    }
    var fe = Object.prototype.hasOwnProperty, Te = {}, Le = F.ReactDebugCurrentFrame;
    function Re(t) {
      if (t) {
        var c = t._owner, p = de(t.type, t._source, c ? c.type : null);
        Le.setExtraStackFrame(p);
      } else
        Le.setExtraStackFrame(null);
    }
    function sn(t, c, p, g, P) {
      {
        var L = Function.call.bind(fe);
        for (var I in t)
          if (L(t, I)) {
            var N = void 0;
            try {
              if (typeof t[I] != "function") {
                var te = Error((g || "React class") + ": " + p + " type `" + I + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof t[I] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw te.name = "Invariant Violation", te;
              }
              N = t[I](c, I, g, p, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (x) {
              N = x;
            }
            N && !(N instanceof Error) && (Re(P), y("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", g || "React class", p, I, typeof N), Re(null)), N instanceof Error && !(N.message in Te) && (Te[N.message] = !0, Re(P), y("Failed %s type: %s", p, N.message), Re(null));
          }
      }
    }
    var w = Array.isArray;
    function _(t) {
      return w(t);
    }
    function $(t) {
      {
        var c = typeof Symbol == "function" && Symbol.toStringTag, p = c && t[Symbol.toStringTag] || t.constructor.name || "Object";
        return p;
      }
    }
    function G(t) {
      try {
        return Y(t), !1;
      } catch {
        return !0;
      }
    }
    function Y(t) {
      return "" + t;
    }
    function R(t) {
      if (G(t))
        return y("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", $(t)), Y(t);
    }
    var z = F.ReactCurrentOwner, ie = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, pe, _e;
    function en(t) {
      if (fe.call(t, "ref")) {
        var c = Object.getOwnPropertyDescriptor(t, "ref").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.ref !== void 0;
    }
    function un(t) {
      if (fe.call(t, "key")) {
        var c = Object.getOwnPropertyDescriptor(t, "key").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.key !== void 0;
    }
    function rn(t, c) {
      typeof t.ref == "string" && z.current;
    }
    function dn(t, c) {
      {
        var p = function() {
          pe || (pe = !0, y("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "key", {
          get: p,
          configurable: !0
        });
      }
    }
    function pn(t, c) {
      {
        var p = function() {
          _e || (_e = !0, y("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "ref", {
          get: p,
          configurable: !0
        });
      }
    }
    var ln = function(t, c, p, g, P, L, I) {
      var N = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: n,
        // Built-in properties that belong on the element
        type: t,
        key: c,
        ref: p,
        props: I,
        // Record the component responsible for creating this element.
        _owner: L
      };
      return N._store = {}, Object.defineProperty(N._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(N, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: g
      }), Object.defineProperty(N, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: P
      }), Object.freeze && (Object.freeze(N.props), Object.freeze(N)), N;
    };
    function kn(t, c, p, g, P) {
      {
        var L, I = {}, N = null, te = null;
        p !== void 0 && (R(p), N = "" + p), un(c) && (R(c.key), N = "" + c.key), en(c) && (te = c.ref, rn(c));
        for (L in c)
          fe.call(c, L) && !ie.hasOwnProperty(L) && (I[L] = c[L]);
        if (t && t.defaultProps) {
          var x = t.defaultProps;
          for (L in x)
            I[L] === void 0 && (I[L] = x[L]);
        }
        if (N || te) {
          var V = typeof t == "function" ? t.displayName || t.name || "Unknown" : t;
          N && dn(I, V), te && pn(I, V);
        }
        return ln(t, N, te, P, g, z.current, I);
      }
    }
    var Xe = F.ReactCurrentOwner, Sn = F.ReactDebugCurrentFrame;
    function Oe(t) {
      if (t) {
        var c = t._owner, p = de(t.type, t._source, c ? c.type : null);
        Sn.setExtraStackFrame(p);
      } else
        Sn.setExtraStackFrame(null);
    }
    var an;
    an = !1;
    function on(t) {
      return typeof t == "object" && t !== null && t.$$typeof === n;
    }
    function yn() {
      {
        if (Xe.current) {
          var t = O(Xe.current.type);
          if (t)
            return `

Check the render method of \`` + t + "`.";
        }
        return "";
      }
    }
    function qn(t) {
      return "";
    }
    var Nn = {};
    function gn(t) {
      {
        var c = yn();
        if (!c) {
          var p = typeof t == "string" ? t : t.displayName || t.name;
          p && (c = `

Check the top-level render call using <` + p + ">.");
        }
        return c;
      }
    }
    function hn(t, c) {
      {
        if (!t._store || t._store.validated || t.key != null)
          return;
        t._store.validated = !0;
        var p = gn(c);
        if (Nn[p])
          return;
        Nn[p] = !0;
        var g = "";
        t && t._owner && t._owner !== Xe.current && (g = " It was passed a child from " + O(t._owner.type) + "."), Oe(t), y('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', p, g), Oe(null);
      }
    }
    function jn(t, c) {
      {
        if (typeof t != "object")
          return;
        if (_(t))
          for (var p = 0; p < t.length; p++) {
            var g = t[p];
            on(g) && hn(g, c);
          }
        else if (on(t))
          t._store && (t._store.validated = !0);
        else if (t) {
          var P = j(t);
          if (typeof P == "function" && P !== t.entries)
            for (var L = P.call(t), I; !(I = L.next()).done; )
              on(I.value) && hn(I.value, c);
        }
      }
    }
    function Un(t) {
      {
        var c = t.type;
        if (c == null || typeof c == "string")
          return;
        var p;
        if (typeof c == "function")
          p = c.propTypes;
        else if (typeof c == "object" && (c.$$typeof === d || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        c.$$typeof === f))
          p = c.propTypes;
        else
          return;
        if (p) {
          var g = O(c);
          sn(p, t.props, "prop", g, t);
        } else if (c.PropTypes !== void 0 && !an) {
          an = !0;
          var P = O(c);
          y("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", P || "Unknown");
        }
        typeof c.getDefaultProps == "function" && !c.getDefaultProps.isReactClassApproved && y("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function Vn(t) {
      {
        for (var c = Object.keys(t.props), p = 0; p < c.length; p++) {
          var g = c[p];
          if (g !== "children" && g !== "key") {
            Oe(t), y("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", g), Oe(null);
            break;
          }
        }
        t.ref !== null && (Oe(t), y("Invalid attribute `ref` supplied to `React.Fragment`."), Oe(null));
      }
    }
    var _n = {};
    function xn(t, c, p, g, P, L) {
      {
        var I = ae(t);
        if (!I) {
          var N = "";
          (t === void 0 || typeof t == "object" && t !== null && Object.keys(t).length === 0) && (N += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var te = qn();
          te ? N += te : N += yn();
          var x;
          t === null ? x = "null" : _(t) ? x = "array" : t !== void 0 && t.$$typeof === n ? (x = "<" + (O(t.type) || "Unknown") + " />", N = " Did you accidentally export a JSX literal instead of a component?") : x = typeof t, y("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", x, N);
        }
        var V = kn(t, c, p, P, L);
        if (V == null)
          return V;
        if (I) {
          var X = c.children;
          if (X !== void 0)
            if (g)
              if (_(X)) {
                for (var we = 0; we < X.length; we++)
                  jn(X[we], t);
                Object.freeze && Object.freeze(X);
              } else
                y("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              jn(X, t);
        }
        if (fe.call(c, "key")) {
          var Se = O(t), ne = Object.keys(c).filter(function(wn) {
            return wn !== "key";
          }), nn = ne.length > 0 ? "{key: someKey, " + ne.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!_n[Se + nn]) {
            var Tn = ne.length > 0 ? "{" + ne.join(": ..., ") + ": ...}" : "{}";
            y(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, nn, Se, Tn, Se), _n[Se + nn] = !0;
          }
        }
        return t === i ? Vn(V) : Un(V), V;
      }
    }
    function Hn(t, c, p) {
      return xn(t, c, p, !0);
    }
    function Dn(t, c, p) {
      return xn(t, c, p, !1);
    }
    var Rn = Dn, Mn = Hn;
    Uo.Fragment = i, Uo.jsx = Rn, Uo.jsxs = Mn;
  })()), Uo;
}
var _k;
function cV() {
  return _k || (_k = 1, process.env.NODE_ENV === "production" ? Iu.exports = sV() : Iu.exports = lV()), Iu.exports;
}
var k = cV();
const xk = "__PairingContext__", dV = () => globalThis[xk] ?? (() => {
  const e = Ob({});
  return globalThis[xk] = e, e;
})(), uV = dV(), mV = () => Am(uV), pV = "_banner_d9pot_1", fV = "_list_d9pot_8", Sk = {
  banner: pV,
  list: fV
}, Nk = "https://apps.shopify.com/dixa-dashboard", hV = {
  install: {
    description: "Connect your Shopify store to Dixa with just a few clicks.",
    listHeading: "How it works:",
    listType: "ol",
    listItems: [
      'Click "Install Dixa app in Shopify" below to start the connection',
      "You'll be redirected to the Shopify App Store to install the Dixa app",
      "After installing, the connection is set up automatically",
      "Return to the Settings > Integrations overview to see your newly connected Shopify integration"
    ],
    buttonText: "Install Dixa app in Shopify",
    buttonVariant: "primary"
  },
  migration: {
    description: "This integration uses a legacy connection method. We recommend upgrading to the Dixa Shopify app for a simpler, more reliable connection that doesn't require manual credential management.",
    listHeading: "Benefits of upgrading:",
    listType: "ul",
    listItems: [
      "No need to manage Client ID and Client Secret",
      "Automatic token refresh handled by the app",
      "Easier setup for new stores"
    ],
    buttonText: "Upgrade via Shopify App Store",
    buttonVariant: "primary"
  }
}, nS = ({
  label: e,
  bannerVariant: n = "install"
}) => {
  const { initiateFromDixa: r } = mV(), [i, a] = se(!1), [o, s] = se(null), l = hV[n], d = async () => {
    if (n === "install" && r) {
      a(!0), s(null);
      try {
        const u = await r();
        window.open(
          u ?? Nk,
          "_blank",
          "noopener,noreferrer"
        );
      } catch {
        s("Failed to start the connection. Please try again.");
      } finally {
        a(!1);
      }
      return;
    }
    window.open(Nk, "_blank", "noopener,noreferrer");
  }, m = l.listType === "ol" ? "ol" : "ul";
  return /* @__PURE__ */ k.jsx(ze, { children: /* @__PURE__ */ k.jsxs(b, { gap: "300", flexDirection: "column", className: Sk.banner, children: [
    /* @__PURE__ */ k.jsx(A.Heading, { variant: "heading-2", children: e }),
    /* @__PURE__ */ k.jsxs(b, { alignItems: "center", gap: "200", children: [
      /* @__PURE__ */ k.jsx(b, { children: /* @__PURE__ */ k.jsx(me, { size: 30, name: "shopify", color: "green.500" }) }),
      /* @__PURE__ */ k.jsx(A.Paragraph, { children: l.description })
    ] }),
    /* @__PURE__ */ k.jsxs(b, { gap: "200", flexDirection: "column", children: [
      /* @__PURE__ */ k.jsx(A.Heading, { variant: "heading-3", children: l.listHeading }),
      /* @__PURE__ */ k.jsx(A.Paragraph, { as: "div", children: /* @__PURE__ */ k.jsx(m, { className: Sk.list, children: l.listItems.map((u, f) => /* @__PURE__ */ k.jsx("li", { children: u }, f)) }) })
    ] }),
    o && /* @__PURE__ */ k.jsx(A.Paragraph, { color: "danger", children: o }),
    /* @__PURE__ */ k.jsx(b, { margin: "200 0 0 0", children: /* @__PURE__ */ k.jsx(
      Wn,
      {
        onClick: d,
        icon: "external-link",
        variant: l.buttonVariant,
        disabled: i,
        children: i ? /* @__PURE__ */ k.jsxs(b, { alignItems: "center", gap: "200", children: [
          /* @__PURE__ */ k.jsx(cn, { size: 16 }),
          "Connecting…"
        ] }) : l.buttonText
      }
    ) })
  ] }) });
}, yV = (e) => /* @__PURE__ */ k.jsx(nS, { ...e, bannerVariant: "install" }), gV = (e) => /* @__PURE__ */ k.jsx(nS, { ...e, bannerVariant: "migration" }), vV = [
  {
    key: "shopifyClientId",
    label: "Client ID",
    placeholder: "Client ID from Shopify",
    required: !0,
    secret: !0,
    type: "input"
  },
  {
    key: "shopifyClientSecret",
    label: "Client Secret",
    placeholder: "Client Secret from Shopify",
    required: !0,
    secret: !0,
    type: "input"
  }
], kV = [
  {
    key: "apiAccessToken",
    label: "API Access Token",
    placeholder: "API access token from Shopify",
    required: !0,
    secret: !0,
    type: "input"
  }
], bV = [
  {
    key: "marketplaceInstallBanner",
    label: "Connect your Shopify store",
    secret: !1,
    type: "custom",
    component: yV
  }
], _V = [
  {
    key: "apiHostName",
    label: "Connected Shopify store",
    placeholder: "",
    required: !1,
    secret: !1,
    type: "input",
    prefix: "https://",
    readOnly: !0
  }
], jk = [
  {
    key: "migrationBanner",
    label: "Upgrade to simplified connection",
    secret: !1,
    type: "custom",
    component: gV,
    additionalProperties: { renderAboveForm: !0 }
  }
], tS = [
  {
    key: "displayRefundOrder",
    label: "Display the refund order button",
    secret: !1,
    type: "switch",
    defaultValue: !1
  },
  {
    key: "displayPartialRefundOrder",
    label: "Displays the partial refund order button",
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "displayCancelOrder",
    label: "Displays the cancel order button",
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "enableEditShippingAddress",
    label: 'Enable the "edit shipping address" button',
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "displayOrdersOverview",
    label: "Displays short orders overview",
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    // We keep the key name to the first version which only showed marketing
    // consent for email in order to not change the existing integration setting
    // for customers. The current version shows both email and phone marketing consent.
    key: "displayEmailMarketingConsent",
    label: "Displays the email and phone marketing consent status of the customer",
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "displaySegmentMembership",
    label: "Displays the segment memberships of the customer",
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "displayDiscountCodes",
    label: "Displays available discount codes",
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "displayDiscountCodeCreation",
    label: "Displays the discount code creation button",
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "displayCreateOrder",
    label: "Displays the create order button",
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "displayCreateDraftOrder",
    label: "Displays the create draft order button",
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "displayDuplicateOrder",
    label: "Displays the duplicate order button",
    secret: !1,
    type: "switch",
    defaultValue: !0
  }
], wk = [
  {
    key: "apiHostName",
    label: "API host name",
    placeholder: 'Host name of your shop, e.g. "my-webshop.myshopify.com"',
    required: !0,
    secret: !1,
    type: "input",
    prefix: "https://",
    customValidation: (e) => Ib(e)
  },
  ...tS
];
var Ri = /* @__PURE__ */ ((e) => (e.Invalid = "INVALID", e.NotSubscribed = "NOT_SUBSCRIBED", e.Pending = "PENDING", e.Subscribed = "SUBSCRIBED", e.Unsubscribed = "UNSUBSCRIBED", e))(Ri || {}), yi = /* @__PURE__ */ ((e) => (e.ConfirmedOptIn = "CONFIRMED_OPT_IN", e.SingleOptIn = "SINGLE_OPT_IN", e.Unknown = "UNKNOWN", e))(yi || {}), Er = /* @__PURE__ */ ((e) => (e.NotSubscribed = "NOT_SUBSCRIBED", e.Pending = "PENDING", e.Redacted = "REDACTED", e.Subscribed = "SUBSCRIBED", e.Unsubscribed = "UNSUBSCRIBED", e))(Er || {}), rS = /* @__PURE__ */ ((e) => (e.All = "ALL", e))(rS || {}), si = /* @__PURE__ */ ((e) => (e.Customer = "CUSTOMER", e.Declined = "DECLINED", e.Fraud = "FRAUD", e.Inventory = "INVENTORY", e.Other = "OTHER", e.Staff = "STAFF", e))(si || {}), Br = /* @__PURE__ */ ((e) => (e.Authorized = "AUTHORIZED", e.Expired = "EXPIRED", e.Paid = "PAID", e.PartiallyPaid = "PARTIALLY_PAID", e.PartiallyRefunded = "PARTIALLY_REFUNDED", e.Pending = "PENDING", e.Refunded = "REFUNDED", e.Voided = "VOIDED", e))(Br || {}), ss = /* @__PURE__ */ ((e) => (e.Fulfilled = "FULFILLED", e.Partial = "PARTIAL", e.Restocked = "RESTOCKED", e))(ss || {}), iS = /* @__PURE__ */ ((e) => (e.Authorization = "AUTHORIZATION", e.Capture = "CAPTURE", e.Change = "CHANGE", e.EmvAuthorization = "EMV_AUTHORIZATION", e.Refund = "REFUND", e.Sale = "SALE", e.SuggestedRefund = "SUGGESTED_REFUND", e.Void = "VOID", e))(iS || {});
const xV = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "refundCreate" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "input" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Shopify_RefundInput" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Shopify" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "refundCreate" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "input" }, value: { kind: "Variable", name: { kind: "Name", value: "input" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "userErrors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "field" } }, { kind: "Field", name: { kind: "Name", value: "message" } }] } }] } }] } }] } }] }, SV = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "orderUpdate" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "input" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Shopify_OrderInput" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Shopify" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "orderUpdate" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "input" }, value: { kind: "Variable", name: { kind: "Name", value: "input" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "order" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "shippingAddress" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "firstName" } }, { kind: "Field", name: { kind: "Name", value: "lastName" } }, { kind: "Field", name: { kind: "Name", value: "company" } }, { kind: "Field", name: { kind: "Name", value: "address1" } }, { kind: "Field", name: { kind: "Name", value: "address2" } }, { kind: "Field", name: { kind: "Name", value: "city" } }, { kind: "Field", name: { kind: "Name", value: "countryCodeV2" } }, { kind: "Field", name: { kind: "Name", value: "provinceCode" } }, { kind: "Field", name: { kind: "Name", value: "zip" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "userErrors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "field" } }, { kind: "Field", name: { kind: "Name", value: "message" } }] } }] } }] } }] } }] }, NV = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "orderCancel" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "notifyCustomer" } }, type: { kind: "NamedType", name: { kind: "Name", value: "Boolean" } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "orderId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "reason" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Shopify_OrderCancelReason" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "refundMethod" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Shopify_OrderCancelRefundMethodInput" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "restock" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Boolean" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "staffNote" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Shopify" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "orderCancel" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "notifyCustomer" }, value: { kind: "Variable", name: { kind: "Name", value: "notifyCustomer" } } }, { kind: "Argument", name: { kind: "Name", value: "orderId" }, value: { kind: "Variable", name: { kind: "Name", value: "orderId" } } }, { kind: "Argument", name: { kind: "Name", value: "reason" }, value: { kind: "Variable", name: { kind: "Name", value: "reason" } } }, { kind: "Argument", name: { kind: "Name", value: "refundMethod" }, value: { kind: "Variable", name: { kind: "Name", value: "refundMethod" } } }, { kind: "Argument", name: { kind: "Name", value: "restock" }, value: { kind: "Variable", name: { kind: "Name", value: "restock" } } }, { kind: "Argument", name: { kind: "Name", value: "staffNote" }, value: { kind: "Variable", name: { kind: "Name", value: "staffNote" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "job" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "done" } }] } }, { kind: "Field", name: { kind: "Name", value: "orderCancelUserErrors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "field" } }, { kind: "Field", name: { kind: "Name", value: "message" } }] } }] } }] } }] } }] }, jV = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "createCustomer" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "input" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Shopify_CustomerInput" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Shopify" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "customerCreate" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "input" }, value: { kind: "Variable", name: { kind: "Name", value: "input" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "userErrors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "field" } }, { kind: "Field", name: { kind: "Name", value: "message" } }] } }, { kind: "Field", name: { kind: "Name", value: "customer" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "defaultEmailAddress" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "emailAddress" } }] } }, { kind: "Field", name: { kind: "Name", value: "defaultPhoneNumber" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "phoneNumber" } }, { kind: "Field", name: { kind: "Name", value: "marketingState" } }, { kind: "Field", name: { kind: "Name", value: "marketingOptInLevel" } }] } }, { kind: "Field", name: { kind: "Name", value: "taxExempt" } }, { kind: "Field", name: { kind: "Name", value: "firstName" } }, { kind: "Field", name: { kind: "Name", value: "lastName" } }, { kind: "Field", name: { kind: "Name", value: "amountSpent" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }] } }] } }] } }] } }] }, wV = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "createOrder" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "order" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Shopify_OrderCreateOrderInput" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "options" } }, type: { kind: "NamedType", name: { kind: "Name", value: "Shopify_OrderCreateOptionsInput" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Shopify" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "orderCreate" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "order" }, value: { kind: "Variable", name: { kind: "Name", value: "order" } } }, { kind: "Argument", name: { kind: "Name", value: "options" }, value: { kind: "Variable", name: { kind: "Name", value: "options" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "order" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "createdAt" } }, { kind: "Field", name: { kind: "Name", value: "displayFulfillmentStatus" } }, { kind: "Field", name: { kind: "Name", value: "displayFinancialStatus" } }, { kind: "Field", name: { kind: "Name", value: "totalPriceSet" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "presentmentMoney" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }, { kind: "Field", name: { kind: "Name", value: "shopMoney" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "userErrors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "field" } }, { kind: "Field", name: { kind: "Name", value: "message" } }] } }] } }] } }] } }] }, CV = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "createDraftOrder" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "input" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Shopify_DraftOrderInput" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Shopify" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "draftOrderCreate" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "input" }, value: { kind: "Variable", name: { kind: "Name", value: "input" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "draftOrder" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "createdAt" } }, { kind: "Field", name: { kind: "Name", value: "tags" } }, { kind: "Field", name: { kind: "Name", value: "status" } }, { kind: "Field", name: { kind: "Name", value: "totalPriceSet" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "presentmentMoney" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }, { kind: "Field", name: { kind: "Name", value: "shopMoney" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "userErrors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "field" } }, { kind: "Field", name: { kind: "Name", value: "message" } }] } }] } }] } }] } }] }, FV = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "createDiscountCode" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "input" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Shopify_DiscountCodeBasicInput" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Shopify" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "discountCodeBasicCreate" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "basicCodeDiscount" }, value: { kind: "Variable", name: { kind: "Name", value: "input" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "codeDiscountNode" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "codeDiscount" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Shopify_DiscountCodeBasic" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "codes" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "1" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "code" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "status" } }, { kind: "Field", name: { kind: "Name", value: "startsAt" } }, { kind: "Field", name: { kind: "Name", value: "endsAt" } }, { kind: "Field", name: { kind: "Name", value: "usageLimit" } }, { kind: "Field", name: { kind: "Name", value: "appliesOncePerCustomer" } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "userErrors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "field" } }, { kind: "Field", name: { kind: "Name", value: "message" } }] } }] } }] } }] } }] }, IV = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "refuncLineItems" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "input" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Shopify_RefundInput" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Shopify" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "refundCreate" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "input" }, value: { kind: "Variable", name: { kind: "Name", value: "input" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "refund" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "totalRefundedSet" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "presentmentMoney" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "userErrors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "field" } }, { kind: "Field", name: { kind: "Name", value: "message" } }] } }] } }] } }] } }] }, EV = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "updateOrder" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "input" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Shopify_OrderInput" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Shopify" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "orderUpdate" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "input" }, value: { kind: "Variable", name: { kind: "Name", value: "input" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "order" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "tags" } }] } }] } }] } }] } }] }, TV = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "segments" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "first" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Shopify" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "segments" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "Variable", name: { kind: "Name", value: "first" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "edges" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "node" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }] } }] } }] } }] }, $V = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "customerSegmentMembership" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "customerId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "segmentIds" } }, type: { kind: "NonNullType", type: { kind: "ListType", type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Shopify" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "customerSegmentMembership" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "customerId" }, value: { kind: "Variable", name: { kind: "Name", value: "customerId" } } }, { kind: "Argument", name: { kind: "Name", value: "segmentIds" }, value: { kind: "Variable", name: { kind: "Name", value: "segmentIds" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "memberships" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "segmentId" } }, { kind: "Field", name: { kind: "Name", value: "isMember" } }] } }] } }] } }] } }] }, DV = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "shopifyCustomerData" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "query" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Shopify" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "shop" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "countriesInShippingZones" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "countryCodes" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "customers" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "1" } }, { kind: "Argument", name: { kind: "Name", value: "query" }, value: { kind: "Variable", name: { kind: "Name", value: "query" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "edges" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "node" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "displayName" } }, { kind: "Field", name: { kind: "Name", value: "firstName" } }, { kind: "Field", name: { kind: "Name", value: "lastName" } }, { kind: "Field", name: { kind: "Name", value: "defaultEmailAddress" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "emailAddress" } }, { kind: "Field", name: { kind: "Name", value: "marketingOptInLevel" } }, { kind: "Field", name: { kind: "Name", value: "marketingState" } }, { kind: "Field", name: { kind: "Name", value: "marketingUpdatedAt" } }] } }, { kind: "Field", name: { kind: "Name", value: "defaultPhoneNumber" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "phoneNumber" } }, { kind: "Field", name: { kind: "Name", value: "marketingOptInLevel" } }, { kind: "Field", name: { kind: "Name", value: "marketingState" } }, { kind: "Field", name: { kind: "Name", value: "marketingUpdatedAt" } }] } }, { kind: "Field", name: { kind: "Name", value: "numberOfOrders" } }, { kind: "Field", name: { kind: "Name", value: "tags" } }, { kind: "Field", name: { kind: "Name", value: "verifiedEmail" } }, { kind: "Field", name: { kind: "Name", value: "amountSpent" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }, { kind: "Field", name: { kind: "Name", value: "defaultAddress" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "firstName" } }, { kind: "Field", name: { kind: "Name", value: "lastName" } }, { kind: "Field", name: { kind: "Name", value: "address1" } }, { kind: "Field", name: { kind: "Name", value: "address2" } }, { kind: "Field", name: { kind: "Name", value: "city" } }, { kind: "Field", name: { kind: "Name", value: "country" } }, { kind: "Field", name: { kind: "Name", value: "zip" } }, { kind: "Field", name: { kind: "Name", value: "phone" } }, { kind: "Field", name: { kind: "Name", value: "provinceCode" } }, { kind: "Field", name: { kind: "Name", value: "countryCodeV2" } }] } }] } }] } }] } }] } }] } }] }, RV = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "shopifyCustomerOrders" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "query" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Shopify" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "orders" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "5" } }, { kind: "Argument", name: { kind: "Name", value: "query" }, value: { kind: "Variable", name: { kind: "Name", value: "query" } } }, { kind: "Argument", name: { kind: "Name", value: "sortKey" }, value: { kind: "EnumValue", value: "CREATED_AT" } }, { kind: "Argument", name: { kind: "Name", value: "reverse" }, value: { kind: "BooleanValue", value: !0 } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "edges" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "node" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "createdAt" } }, { kind: "Field", name: { kind: "Name", value: "displayFulfillmentStatus" } }, { kind: "Field", name: { kind: "Name", value: "displayFinancialStatus" } }, { kind: "Field", name: { kind: "Name", value: "cancelledAt" } }, { kind: "Field", name: { kind: "Name", value: "tags" } }, { kind: "Field", name: { kind: "Name", value: "netPaymentSet" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "presentmentMoney" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "totalRefundedSet" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "presentmentMoney" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "billingAddress" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "firstName" } }, { kind: "Field", name: { kind: "Name", value: "lastName" } }, { kind: "Field", name: { kind: "Name", value: "company" } }, { kind: "Field", name: { kind: "Name", value: "address1" } }, { kind: "Field", name: { kind: "Name", value: "address2" } }, { kind: "Field", name: { kind: "Name", value: "city" } }, { kind: "Field", name: { kind: "Name", value: "country" } }, { kind: "Field", name: { kind: "Name", value: "countryCodeV2" } }, { kind: "Field", name: { kind: "Name", value: "province" } }, { kind: "Field", name: { kind: "Name", value: "provinceCode" } }, { kind: "Field", name: { kind: "Name", value: "zip" } }, { kind: "Field", name: { kind: "Name", value: "phone" } }] } }, { kind: "Field", name: { kind: "Name", value: "shippingAddress" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "firstName" } }, { kind: "Field", name: { kind: "Name", value: "lastName" } }, { kind: "Field", name: { kind: "Name", value: "company" } }, { kind: "Field", name: { kind: "Name", value: "address1" } }, { kind: "Field", name: { kind: "Name", value: "address2" } }, { kind: "Field", name: { kind: "Name", value: "city" } }, { kind: "Field", name: { kind: "Name", value: "country" } }, { kind: "Field", name: { kind: "Name", value: "countryCodeV2" } }, { kind: "Field", name: { kind: "Name", value: "province" } }, { kind: "Field", name: { kind: "Name", value: "provinceCode" } }, { kind: "Field", name: { kind: "Name", value: "zip" } }, { kind: "Field", name: { kind: "Name", value: "phone" } }] } }, { kind: "Field", name: { kind: "Name", value: "suggestedRefund" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "suggestFullRefund" }, value: { kind: "BooleanValue", value: !0 } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amountSet" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "presentmentMoney" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "suggestedTransactions" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "accountNumber" } }, { kind: "Field", name: { kind: "Name", value: "gateway" } }, { kind: "Field", name: { kind: "Name", value: "kind" } }, { kind: "Field", name: { kind: "Name", value: "parentTransaction" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }] } }, { kind: "Field", name: { kind: "Name", value: "amountSet" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "presentmentMoney" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "refundLineItems" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "lineItem" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "quantity" } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "shippingLines" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "5" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "edges" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "node" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "source" } }, { kind: "Field", name: { kind: "Name", value: "discountedPriceSet" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "shopMoney" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }] } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "fulfillments" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "2" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "trackingInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "company" } }, { kind: "Field", name: { kind: "Name", value: "number" } }, { kind: "Field", name: { kind: "Name", value: "url" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "lineItems" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "15" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "edges" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "node" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "quantity" } }, { kind: "Field", name: { kind: "Name", value: "variantTitle" } }, { kind: "Field", name: { kind: "Name", value: "sku" } }, { kind: "Field", name: { kind: "Name", value: "image" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "url" } }] } }, { kind: "Field", name: { kind: "Name", value: "product" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }] } }, { kind: "Field", name: { kind: "Name", value: "discountedUnitPriceSet" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "shopMoney" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }] } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "refunds" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "totalRefunded" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }, { kind: "Field", name: { kind: "Name", value: "refundLineItems" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "250" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "edges" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "node" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "quantity" } }, { kind: "Field", name: { kind: "Name", value: "lineItem" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "title" } }] } }] } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "currentTotalPriceSet" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "presentmentMoney" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }, { kind: "Field", name: { kind: "Name", value: "shopMoney" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }] } }] } }] } }] } }] } }] } }] }, OV = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "readDiscountCodes" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "first" } }, type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Shopify" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "codeDiscountNodes" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "Variable", name: { kind: "Name", value: "first" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "codeDiscount" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Shopify_DiscountCodeApp" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "codesCount" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "count" } }] } }, { kind: "Field", name: { kind: "Name", value: "codes" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "Variable", name: { kind: "Name", value: "first" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "code" } }] } }] } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Shopify_DiscountCodeBasic" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "codesCount" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "count" } }] } }, { kind: "Field", name: { kind: "Name", value: "codes" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "Variable", name: { kind: "Name", value: "first" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "code" } }] } }] } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Shopify_DiscountCodeBxgy" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "codesCount" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "count" } }] } }, { kind: "Field", name: { kind: "Name", value: "codes" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "Variable", name: { kind: "Name", value: "first" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "code" } }] } }] } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Shopify_DiscountCodeFreeShipping" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "codesCount" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "count" } }] } }, { kind: "Field", name: { kind: "Name", value: "codes" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "Variable", name: { kind: "Name", value: "first" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "code" } }] } }] } }] } }] } }] } }] } }] } }] } }] }, PV = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "searchProducts" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "query" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "productCount" } }, type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "mediaCount" } }, type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Shopify" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "products" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "Variable", name: { kind: "Name", value: "productCount" } } }, { kind: "Argument", name: { kind: "Name", value: "query" }, value: { kind: "Variable", name: { kind: "Name", value: "query" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "description" } }, { kind: "Field", name: { kind: "Name", value: "onlineStoreUrl" } }, { kind: "Field", name: { kind: "Name", value: "status" } }, { kind: "Field", name: { kind: "Name", value: "tags" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "totalInventory" } }, { kind: "Field", name: { kind: "Name", value: "priceRangeV2" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "maxVariantPrice" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }, { kind: "Field", name: { kind: "Name", value: "minVariantPrice" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "media" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "Variable", name: { kind: "Name", value: "mediaCount" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "alt" } }, { kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "status" } }, { kind: "Field", name: { kind: "Name", value: "mediaContentType" } }, { kind: "Field", name: { kind: "Name", value: "preview" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "image" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "altText" } }, { kind: "Field", name: { kind: "Name", value: "url" } }] } }] } }] } }] } }] } }] } }] } }] } }] }, AV = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "test" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Shopify" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "shop" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "email" } }, { kind: "Field", name: { kind: "Name", value: "description" } }] } }] } }] } }] }, LV = {
  "\n  mutation refundCreate($input: Shopify_RefundInput!) {\n    Shopify {\n      refundCreate(input: $input) {\n        userErrors {\n          field\n          message\n        }\n      }\n    }\n  }\n": xV,
  "\n  mutation orderUpdate($input: Shopify_OrderInput!) {\n    Shopify {\n      orderUpdate(input: $input) {\n        order {\n          shippingAddress {\n            firstName\n            lastName\n            company\n            address1\n            address2\n            city\n            countryCodeV2\n            provinceCode\n            zip\n          }\n        }\n        userErrors {\n          field\n          message\n        }\n      }\n    }\n  }\n": SV,
  "\n  mutation orderCancel(\n    $notifyCustomer: Boolean\n    $orderId: ID!\n    $reason: Shopify_OrderCancelReason!\n    $refundMethod: Shopify_OrderCancelRefundMethodInput!\n    $restock: Boolean!\n    $staffNote: String!\n  ) {\n    Shopify {\n      orderCancel(\n        notifyCustomer: $notifyCustomer\n        orderId: $orderId\n        reason: $reason\n        refundMethod: $refundMethod\n        restock: $restock\n        staffNote: $staffNote\n      ) {\n        job {\n          id\n          done\n        }\n        orderCancelUserErrors {\n          code\n          field\n          message\n        }\n      }\n    }\n  }\n": NV,
  "\n  mutation createCustomer($input: Shopify_CustomerInput!) {\n    Shopify {\n      customerCreate(input: $input) {\n        userErrors {\n          field\n          message\n        }\n        customer {\n          id\n          defaultEmailAddress {\n            emailAddress\n          }\n          defaultPhoneNumber {\n            phoneNumber\n            marketingState\n            marketingOptInLevel\n          }\n          taxExempt\n          firstName\n          lastName\n          amountSpent {\n            amount\n            currencyCode\n          }\n        }\n      }\n    }\n  }\n": jV,
  "\n  mutation createOrder(\n    $order: Shopify_OrderCreateOrderInput!\n    $options: Shopify_OrderCreateOptionsInput\n  ) {\n    Shopify {\n      orderCreate(order: $order, options: $options) {\n        order {\n          id\n          name\n          createdAt\n          displayFulfillmentStatus\n          displayFinancialStatus\n          totalPriceSet {\n            presentmentMoney {\n              amount\n              currencyCode\n            }\n            shopMoney {\n              amount\n              currencyCode\n            }\n          }\n        }\n        userErrors {\n          field\n          message\n        }\n      }\n    }\n  }\n": wV,
  "\n  mutation createDraftOrder($input: Shopify_DraftOrderInput!) {\n    Shopify {\n      draftOrderCreate(input: $input) {\n        draftOrder {\n          id\n          name\n          createdAt\n          tags\n          status\n          totalPriceSet {\n            presentmentMoney {\n              amount\n              currencyCode\n            }\n            shopMoney {\n              amount\n              currencyCode\n            }\n          }\n        }\n        userErrors {\n          field\n          message\n        }\n      }\n    }\n  }\n": CV,
  "\n  mutation createDiscountCode($input: Shopify_DiscountCodeBasicInput!) {\n    Shopify {\n      discountCodeBasicCreate(basicCodeDiscount: $input) {\n        codeDiscountNode {\n          id\n          codeDiscount {\n            ... on Shopify_DiscountCodeBasic {\n              codes(first: 1) {\n                nodes {\n                  code\n                }\n              }\n              title\n              status\n              startsAt\n              endsAt\n              usageLimit\n              appliesOncePerCustomer\n            }\n          }\n        }\n        userErrors {\n          field\n          message\n        }\n      }\n    }\n  }\n": FV,
  "\n  mutation refuncLineItems($input: Shopify_RefundInput!) {\n    Shopify {\n      refundCreate(input: $input) {\n        refund {\n          id\n          totalRefundedSet {\n            presentmentMoney {\n              amount\n              currencyCode\n            }\n          }\n        }\n        userErrors {\n          field\n          message\n        }\n      }\n    }\n  }\n": IV,
  "\n  mutation updateOrder($input: Shopify_OrderInput!) {\n    Shopify {\n      orderUpdate(input: $input) {\n        order {\n          id\n          tags\n        }\n      }\n    }\n  }\n": EV,
  "\n  query segments($first: Int!) {\n    Shopify {\n      segments(first: $first) {\n        edges {\n          node {\n            id\n            name\n          }\n        }\n      }\n    }\n  }\n": TV,
  "\n  query customerSegmentMembership($customerId: ID!, $segmentIds: [ID!]!) {\n    Shopify {\n      customerSegmentMembership(\n        customerId: $customerId\n        segmentIds: $segmentIds\n      ) {\n        memberships {\n          segmentId\n          isMember\n        }\n      }\n    }\n  }\n": $V,
  "\n  query shopifyCustomerData($query: String!) {\n    Shopify {\n      shop {\n        countriesInShippingZones {\n          countryCodes\n        }\n      }\n\n      customers(first: 1, query: $query) {\n        edges {\n          node {\n            id\n            displayName\n            firstName\n            lastName\n            defaultEmailAddress {\n              emailAddress\n              marketingOptInLevel\n              marketingState\n              marketingUpdatedAt\n            }\n            defaultPhoneNumber {\n              phoneNumber\n              marketingOptInLevel\n              marketingState\n              marketingUpdatedAt\n            }\n            numberOfOrders\n            tags\n            verifiedEmail\n            amountSpent {\n              amount\n              currencyCode\n            }\n            defaultAddress {\n              firstName\n              lastName\n              address1\n              address2\n              city\n              country\n              zip\n              phone\n              provinceCode\n              countryCodeV2\n            }\n          }\n        }\n      }\n    }\n  }\n": DV,
  "\n  query shopifyCustomerOrders($query: String!) {\n    Shopify {\n      orders(first: 5, query: $query, sortKey: CREATED_AT, reverse: true) {\n        edges {\n          node {\n            id\n            name\n            createdAt\n            displayFulfillmentStatus\n            displayFinancialStatus\n            cancelledAt\n            tags\n            netPaymentSet {\n              presentmentMoney {\n                amount\n                currencyCode\n              }\n            }\n            totalRefundedSet {\n              presentmentMoney {\n                amount\n                currencyCode\n              }\n            }\n            billingAddress {\n              firstName\n              lastName\n              company\n              address1\n              address2\n              city\n              country\n              countryCodeV2\n              province\n              provinceCode\n              zip\n              phone\n            }\n            shippingAddress {\n              firstName\n              lastName\n              company\n              address1\n              address2\n              city\n              country\n              countryCodeV2\n              province\n              provinceCode\n              zip\n              phone\n            }\n            suggestedRefund(suggestFullRefund: true) {\n              amountSet {\n                presentmentMoney {\n                  amount\n                  currencyCode\n                }\n              }\n              suggestedTransactions {\n                accountNumber\n                gateway\n                kind\n                parentTransaction {\n                  id\n                }\n                amountSet {\n                  presentmentMoney {\n                    amount\n                    currencyCode\n                  }\n                }\n              }\n              refundLineItems {\n                lineItem {\n                  id\n                  quantity\n                }\n              }\n            }\n            shippingLines(first: 5) {\n              edges {\n                node {\n                  title\n                  code\n                  source\n                  discountedPriceSet {\n                    shopMoney {\n                      amount\n                      currencyCode\n                    }\n                  }\n                }\n              }\n            }\n            fulfillments(first: 2) {\n              trackingInfo {\n                company\n                number\n                url\n              }\n            }\n            lineItems(first: 15) {\n              edges {\n                node {\n                  id\n                  title\n                  quantity\n                  variantTitle\n                  sku\n                  image {\n                    url\n                  }\n                  product {\n                    id\n                  }\n                  discountedUnitPriceSet {\n                    shopMoney {\n                      amount\n                      currencyCode\n                    }\n                  }\n                }\n              }\n            }\n            refunds {\n              totalRefunded {\n                amount\n                currencyCode\n              }\n              refundLineItems(first: 250) {\n                edges {\n                  node {\n                    id\n                    quantity\n                    lineItem {\n                      id\n                      title\n                    }\n                  }\n                }\n              }\n            }\n            currentTotalPriceSet {\n              presentmentMoney {\n                amount\n                currencyCode\n              }\n              shopMoney {\n                amount\n                currencyCode\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n": RV,
  "\n  query readDiscountCodes($first: Int) {\n    Shopify {\n      codeDiscountNodes(first: $first) {\n        nodes {\n          id\n          codeDiscount {\n            ... on Shopify_DiscountCodeApp {\n              title\n              codesCount {\n                count\n              }\n              codes(first: $first) {\n                nodes {\n                  code\n                }\n              }\n            }\n\n            ... on Shopify_DiscountCodeBasic {\n              title\n              codesCount {\n                count\n              }\n              codes(first: $first) {\n                nodes {\n                  code\n                }\n              }\n            }\n\n            ... on Shopify_DiscountCodeBxgy {\n              title\n              codesCount {\n                count\n              }\n              codes(first: $first) {\n                nodes {\n                  code\n                }\n              }\n            }\n\n            ... on Shopify_DiscountCodeFreeShipping {\n              title\n              codesCount {\n                count\n              }\n              codes(first: $first) {\n                nodes {\n                  code\n                }\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n": OV,
  "\n  query searchProducts($query: String!, $productCount: Int, $mediaCount: Int) {\n    Shopify {\n      products(first: $productCount, query: $query) {\n        nodes {\n          id\n          title\n          description\n          onlineStoreUrl\n          status\n          tags\n          title\n          totalInventory\n          priceRangeV2 {\n            maxVariantPrice {\n              amount\n              currencyCode\n            }\n            minVariantPrice {\n              amount\n              currencyCode\n            }\n          }\n          media(first: $mediaCount) {\n            nodes {\n              alt\n              id\n              status\n              mediaContentType\n              preview {\n                image {\n                  id\n                  altText\n                  url\n                }\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n": PV,
  "\n  query test {\n    Shopify {\n      shop {\n        name\n        email\n        description\n      }\n    }\n  }\n": AV
};
function mr(e) {
  return LV[e] ?? {};
}
const VV = mr(
  /* GraphQL */
  `
  query shopifyCustomerData($query: String!) {
    Shopify {
      shop {
        countriesInShippingZones {
          countryCodes
        }
      }

      customers(first: 1, query: $query) {
        edges {
          node {
            id
            displayName
            firstName
            lastName
            defaultEmailAddress {
              emailAddress
              marketingOptInLevel
              marketingState
              marketingUpdatedAt
            }
            defaultPhoneNumber {
              phoneNumber
              marketingOptInLevel
              marketingState
              marketingUpdatedAt
            }
            numberOfOrders
            tags
            verifiedEmail
            amountSpent {
              amount
              currencyCode
            }
            defaultAddress {
              firstName
              lastName
              address1
              address2
              city
              country
              zip
              phone
              provinceCode
              countryCodeV2
            }
          }
        }
      }
    }
  }
`
), zV = mr(
  /* GraphQL */
  `
  query shopifyCustomerOrders($query: String!) {
    Shopify {
      orders(first: 5, query: $query, sortKey: CREATED_AT, reverse: true) {
        edges {
          node {
            id
            name
            createdAt
            displayFulfillmentStatus
            displayFinancialStatus
            cancelledAt
            tags
            netPaymentSet {
              presentmentMoney {
                amount
                currencyCode
              }
            }
            totalRefundedSet {
              presentmentMoney {
                amount
                currencyCode
              }
            }
            billingAddress {
              firstName
              lastName
              company
              address1
              address2
              city
              country
              countryCodeV2
              province
              provinceCode
              zip
              phone
            }
            shippingAddress {
              firstName
              lastName
              company
              address1
              address2
              city
              country
              countryCodeV2
              province
              provinceCode
              zip
              phone
            }
            suggestedRefund(suggestFullRefund: true) {
              amountSet {
                presentmentMoney {
                  amount
                  currencyCode
                }
              }
              suggestedTransactions {
                accountNumber
                gateway
                kind
                parentTransaction {
                  id
                }
                amountSet {
                  presentmentMoney {
                    amount
                    currencyCode
                  }
                }
              }
              refundLineItems {
                lineItem {
                  id
                  quantity
                }
              }
            }
            shippingLines(first: 5) {
              edges {
                node {
                  title
                  code
                  source
                  discountedPriceSet {
                    shopMoney {
                      amount
                      currencyCode
                    }
                  }
                }
              }
            }
            fulfillments(first: 2) {
              trackingInfo {
                company
                number
                url
              }
            }
            lineItems(first: 15) {
              edges {
                node {
                  id
                  title
                  quantity
                  variantTitle
                  sku
                  image {
                    url
                  }
                  product {
                    id
                  }
                  discountedUnitPriceSet {
                    shopMoney {
                      amount
                      currencyCode
                    }
                  }
                }
              }
            }
            refunds {
              totalRefunded {
                amount
                currencyCode
              }
              refundLineItems(first: 250) {
                edges {
                  node {
                    id
                    quantity
                    lineItem {
                      id
                      title
                    }
                  }
                }
              }
            }
            currentTotalPriceSet {
              presentmentMoney {
                amount
                currencyCode
              }
              shopMoney {
                amount
                currencyCode
              }
            }
          }
        }
      }
    }
  }
`
), UV = mr(
  /* GraphQL */
  `
  query segments($first: Int!) {
    Shopify {
      segments(first: $first) {
        edges {
          node {
            id
            name
          }
        }
      }
    }
  }
`
), MV = mr(
  /* GraphQL */
  `
  query customerSegmentMembership($customerId: ID!, $segmentIds: [ID!]!) {
    Shopify {
      customerSegmentMembership(
        customerId: $customerId
        segmentIds: $segmentIds
      ) {
        memberships {
          segmentId
          isMember
        }
      }
    }
  }
`
), Lp = mr(
  /* GraphQL */
  `
  query searchProducts($query: String!, $productCount: Int, $mediaCount: Int) {
    Shopify {
      products(first: $productCount, query: $query) {
        nodes {
          id
          title
          description
          onlineStoreUrl
          status
          tags
          title
          totalInventory
          priceRangeV2 {
            maxVariantPrice {
              amount
              currencyCode
            }
            minVariantPrice {
              amount
              currencyCode
            }
          }
          media(first: $mediaCount) {
            nodes {
              alt
              id
              status
              mediaContentType
              preview {
                image {
                  id
                  altText
                  url
                }
              }
            }
          }
        }
      }
    }
  }
`
), BV = mr(
  /* GraphQL */
  `
  query readDiscountCodes($first: Int) {
    Shopify {
      codeDiscountNodes(first: $first) {
        nodes {
          id
          codeDiscount {
            ... on Shopify_DiscountCodeApp {
              title
              codesCount {
                count
              }
              codes(first: $first) {
                nodes {
                  code
                }
              }
            }

            ... on Shopify_DiscountCodeBasic {
              title
              codesCount {
                count
              }
              codes(first: $first) {
                nodes {
                  code
                }
              }
            }

            ... on Shopify_DiscountCodeBxgy {
              title
              codesCount {
                count
              }
              codes(first: $first) {
                nodes {
                  code
                }
              }
            }

            ... on Shopify_DiscountCodeFreeShipping {
              title
              codesCount {
                count
              }
              codes(first: $first) {
                nodes {
                  code
                }
              }
            }
          }
        }
      }
    }
  }
`
), qV = mr(
  /* GraphQL */
  `
  mutation orderUpdate($input: Shopify_OrderInput!) {
    Shopify {
      orderUpdate(input: $input) {
        order {
          shippingAddress {
            firstName
            lastName
            company
            address1
            address2
            city
            countryCodeV2
            provinceCode
            zip
          }
        }
        userErrors {
          field
          message
        }
      }
    }
  }
`
), HV = mr(
  /* GraphQL */
  `
  mutation refundCreate($input: Shopify_RefundInput!) {
    Shopify {
      refundCreate(input: $input) {
        userErrors {
          field
          message
        }
      }
    }
  }
`
), WV = mr(
  /* GraphQL */
  `
  mutation orderCancel(
    $notifyCustomer: Boolean
    $orderId: ID!
    $reason: Shopify_OrderCancelReason!
    $refundMethod: Shopify_OrderCancelRefundMethodInput!
    $restock: Boolean!
    $staffNote: String!
  ) {
    Shopify {
      orderCancel(
        notifyCustomer: $notifyCustomer
        orderId: $orderId
        reason: $reason
        refundMethod: $refundMethod
        restock: $restock
        staffNote: $staffNote
      ) {
        job {
          id
          done
        }
        orderCancelUserErrors {
          code
          field
          message
        }
      }
    }
  }
`
), KV = mr(
  /* GraphQL */
  `
  mutation updateOrder($input: Shopify_OrderInput!) {
    Shopify {
      orderUpdate(input: $input) {
        order {
          id
          tags
        }
      }
    }
  }
`
), GV = mr(
  /* GraphQL */
  `
  mutation createCustomer($input: Shopify_CustomerInput!) {
    Shopify {
      customerCreate(input: $input) {
        userErrors {
          field
          message
        }
        customer {
          id
          defaultEmailAddress {
            emailAddress
          }
          defaultPhoneNumber {
            phoneNumber
            marketingState
            marketingOptInLevel
          }
          taxExempt
          firstName
          lastName
          amountSpent {
            amount
            currencyCode
          }
        }
      }
    }
  }
`
), YV = mr(
  /* GraphQL */
  `
  mutation createDiscountCode($input: Shopify_DiscountCodeBasicInput!) {
    Shopify {
      discountCodeBasicCreate(basicCodeDiscount: $input) {
        codeDiscountNode {
          id
          codeDiscount {
            ... on Shopify_DiscountCodeBasic {
              codes(first: 1) {
                nodes {
                  code
                }
              }
              title
              status
              startsAt
              endsAt
              usageLimit
              appliesOncePerCustomer
            }
          }
        }
        userErrors {
          field
          message
        }
      }
    }
  }
`
), aS = Os`
  mutation createOrder(
    $order: Shopify_OrderCreateOrderInput!
    $options: Shopify_OrderCreateOptionsInput
  ) {
    Shopify {
      orderCreate(order: $order, options: $options) {
        order {
          id
          name
          createdAt
          displayFulfillmentStatus
          displayFinancialStatus
          totalPriceSet {
            presentmentMoney {
              amount
              currencyCode
            }
            shopMoney {
              amount
              currencyCode
            }
          }
        }
        userErrors {
          field
          message
        }
      }
    }
  }
`, QV = Os`
  mutation createDraftOrder($input: Shopify_DraftOrderInput!) {
    Shopify {
      draftOrderCreate(input: $input) {
        draftOrder {
          id
          name
          createdAt
          tags
          status
          totalPriceSet {
            presentmentMoney {
              amount
              currencyCode
            }
            shopMoney {
              amount
              currencyCode
            }
          }
        }
        userErrors {
          field
          message
        }
      }
    }
  }
`, JV = ({
  conversationContext: e
}) => {
  const { useQuery: n } = mn(), r = e.customer?.email, i = e.customer?.phone_number, a = r ? `email:"${r}"` : null, o = i ? `phone:"${i}"` : null, s = a ?? o ?? null, {
    loading: l,
    error: d,
    data: m,
    refetch: u,
    networkStatus: f
  } = n(VV, {
    skip: !s,
    variables: {
      query: s
    },
    notifyOnNetworkStatusChange: !0
  });
  return {
    isCustomerLoading: l,
    customerError: d,
    customerData: m,
    refetchCustomer: u,
    customerNetworkStatus: f
  };
}, XV = () => {
  const { useLazyQuery: e } = mn(), [
    n,
    {
      loading: r,
      error: i,
      data: a,
      refetch: o
    }
  ] = e(zV);
  return {
    getCustomerOrders: n,
    isCustomerOrdersLoading: r,
    customerOrdersError: i,
    customerOrders: a,
    refetchCustomerOrders: o
  };
};
function ro(e = !1, n) {
  const [r, i] = se(e);
  return He(() => {
    const a = r ? window.setTimeout(() => i(!1), 2e3) : void 0;
    return () => window.clearTimeout(a);
  }, [n, r]), { isCopied: r, copy: (a) => {
    navigator.clipboard.writeText(a), i(!0);
  } };
}
const ZV = "_list_alvh6_1", ez = "_listItem_alvh6_4", nz = "_fullWidth_alvh6_15", tz = "_boxWrapper_alvh6_19", Et = {
  list: ZV,
  listItem: ez,
  fullWidth: nz,
  boxWrapper: tz
}, rz = "_modal_1vkwz_1", iz = "_disabled_1vkwz_5", Eu = {
  modal: rz,
  disabled: iz
}, Ck = [
  {
    label: "Single Opt-In",
    description: "After providing their information, the customer receives marketing information without any intermediate steps.",
    value: yi.SingleOptIn
  },
  {
    label: "Confirmed Opt-In",
    description: "After providing their information, the customer receives a confirmation and is required to perform a intermediate step before receiving marketing information.",
    value: yi.ConfirmedOptIn
  },
  {
    label: "Unknown",
    description: "The customer receives marketing information but how they were opted in is unknown.",
    value: yi.Unknown
  }
], Fk = [
  {
    label: "Not Subscribed",
    description: "The customer hasn’t subscribed to SMS marketing.",
    value: Er.NotSubscribed
  },
  {
    label: "Pending",
    description: "The customer is in the process of subscribing to SMS marketing.",
    value: Er.Pending
  },
  {
    label: "Redacted",
    description: "The customer’s personal data is erased. This value is internally-set and read-only.",
    value: Er.Redacted
  },
  {
    label: "Subscribed",
    description: "The customer is subscribed to SMS marketing.",
    value: Er.Subscribed
  },
  {
    label: "Unsubscribed",
    description: "The customer isn’t currently subscribed to SMS marketing but was previously subscribed.",
    value: Er.Unsubscribed
  }
], az = ({
  conversationContext: e,
  isOpen: n,
  setIsOpen: r,
  isMutationLoading: i,
  setIsMutationLoading: a,
  refetchCustomer: o
}) => {
  const { track: s } = bn(), { useMutation: l, showNotification: d } = mn(), [m, u] = se(), [f, h] = se(), [v, C] = Lf(!0), [S, j] = Lf(!0), F = !!m, y = e.customer?.email, q = e.customer?.phone_number, T = e.customer?.given_name, E = e.customer?.family_name, D = {
    email: y ?? "",
    phone: q ?? "",
    firstName: T ?? "",
    lastName: E ?? "",
    smsMarketingState: null,
    smsMarketingOptInLevel: null
  }, B = Bt({
    defaultValues: D
  });
  He(() => {
    f?.forEach((O) => {
      const H = O?.field?.[0];
      H && (B.setError(H, {
        type: "server",
        message: O.message
      }), B.setFocus(H));
    });
  }, [f, B]);
  const [ee, { error: J, reset: ae }] = l(GV, {
    onError: (O) => {
      u(O.message), a(!1), d({
        title: "Something went wrong",
        text: "The customer creation was not successful.",
        icon: "exclamation-triangle-filled",
        severity: "warning"
      });
    },
    onCompleted: async (O) => {
      const H = O?.Shopify?.customerCreate?.userErrors || [];
      H.length > 0 ? (h(H), a(!1), d({
        title: "Something went wrong",
        text: "The customer creation was not successful.",
        icon: "exclamation-triangle-filled",
        severity: "warning"
      })) : (setTimeout(async () => {
        await o(), a(!1);
      }, 3e3), d({
        title: "Success",
        text: "The customer creation was successful.",
        icon: "check-circle-filled",
        severity: "success"
      }), s("shopify:profile:created"), r(!1));
    }
  }), Q = tt(
    (O) => {
      a(!0), u(void 0), ee({
        variables: {
          input: {
            firstName: O.firstName,
            lastName: O.lastName,
            ...v && { email: O.email },
            ...S && { phone: O.phone },
            ...O.smsMarketingState && {
              smsMarketingConsent: {
                marketingState: O.smsMarketingState,
                marketingOptInLevel: O.smsMarketingOptInLevel
              }
            }
          }
        }
      });
    },
    [ee, a, S, v]
  ), U = () => {
    r(!1), ae(), u(void 0), B.reset(D);
  };
  return /* @__PURE__ */ k.jsxs(wt, { isOpen: n, onClose: U, className: Eu.modal, children: [
    /* @__PURE__ */ k.jsx(Ct, { title: "Create new customer", onClose: U }),
    /* @__PURE__ */ k.jsx(Ft, { children: /* @__PURE__ */ k.jsxs(vt, { children: [
      /* @__PURE__ */ k.jsx(ze, { span: 3, children: /* @__PURE__ */ k.jsx(
        gt,
        {
          label: "First name",
          name: "firstName",
          control: B.control,
          rules: {
            required: "First name is required"
          }
        }
      ) }),
      /* @__PURE__ */ k.jsx(ze, { span: 3, children: /* @__PURE__ */ k.jsx(
        gt,
        {
          label: "Last name",
          name: "lastName",
          control: B.control,
          rules: {
            required: "Last name is required"
          }
        }
      ) }),
      /* @__PURE__ */ k.jsx(ze, { children: /* @__PURE__ */ k.jsx(
        gt,
        {
          label: "Email",
          name: "email",
          control: B.control,
          rules: {
            required: v ? "Email is required" : void 0
          },
          componentProps: {
            className: rt({
              [Eu.disabled]: !v
            }),
            prefix: {
              type: "custom",
              value: /* @__PURE__ */ k.jsx(
                Gu,
                {
                  disabled: !S,
                  name: "hasEmail",
                  value: "email",
                  checked: v,
                  onChange: () => C()
                }
              )
            }
          }
        }
      ) }),
      /* @__PURE__ */ k.jsx(ze, { children: /* @__PURE__ */ k.jsx(
        gt,
        {
          label: "Phone",
          name: "phone",
          control: B.control,
          rules: {
            required: S ? "Phone is required" : void 0
          },
          componentProps: {
            className: rt({
              [Eu.disabled]: !S
            }),
            prefix: {
              type: "custom",
              value: /* @__PURE__ */ k.jsx(
                Gu,
                {
                  disabled: !v,
                  name: "hasPhone",
                  value: "phone",
                  checked: S,
                  onChange: () => j()
                }
              )
            }
          }
        }
      ) }),
      /* @__PURE__ */ k.jsx(ze, { children: /* @__PURE__ */ k.jsx(
        xr,
        {
          control: B.control,
          label: "SMS marketing state",
          name: "smsMarketingState",
          rules: {
            required: {
              value: !0,
              message: "Please select a marketing state"
            }
          },
          componentProps: {
            placeholder: "Select a marketing state",
            equalityFn: (O, H) => O === H,
            getItemTitleByValue: (O) => {
              const H = Fk.find(
                (Z) => Z.value === O
              );
              return /* @__PURE__ */ k.jsxs(
                b,
                {
                  flexDirection: "column",
                  gap: "100",
                  margin: "100 0 200",
                  children: [
                    /* @__PURE__ */ k.jsx(A.Heading, { variant: "heading-3", children: H.label }),
                    /* @__PURE__ */ k.jsx(A.Paragraph, { color: "secondary", children: H.description })
                  ]
                }
              );
            }
          },
          children: Fk.map((O) => /* @__PURE__ */ k.jsx(st.Item, { value: O.value, children: /* @__PURE__ */ k.jsxs(b, { flexDirection: "column", gap: "100", children: [
            /* @__PURE__ */ k.jsx(A.Heading, { variant: "heading-3", children: O.label }),
            /* @__PURE__ */ k.jsx(A.Paragraph, { color: "secondary", children: O.description })
          ] }) }, O.value))
        }
      ) }),
      /* @__PURE__ */ k.jsx(ze, { children: /* @__PURE__ */ k.jsx(
        xr,
        {
          control: B.control,
          label: "SMS marketing opt-in level",
          name: "smsMarketingOptInLevel",
          rules: {
            required: {
              value: !0,
              message: "Please select a marketing opt-in level"
            }
          },
          componentProps: {
            placeholder: "Select a marketing opt-in level",
            equalityFn: (O, H) => O === H,
            getItemTitleByValue: (O) => {
              const H = Ck.find(
                (Z) => Z.value === O
              );
              return /* @__PURE__ */ k.jsxs(
                b,
                {
                  flexDirection: "column",
                  gap: "100",
                  margin: "100 0 200",
                  children: [
                    /* @__PURE__ */ k.jsx(A.Heading, { variant: "heading-3", children: H.label }),
                    /* @__PURE__ */ k.jsx(A.Paragraph, { color: "secondary", children: H.description })
                  ]
                }
              );
            }
          },
          children: Ck.map((O) => /* @__PURE__ */ k.jsx(st.Item, { value: O.value, children: /* @__PURE__ */ k.jsxs(b, { flexDirection: "column", gap: "100", children: [
            /* @__PURE__ */ k.jsx(A.Heading, { variant: "heading-3", children: O.label }),
            /* @__PURE__ */ k.jsx(A.Paragraph, { color: "secondary", children: O.description })
          ] }) }, O.value))
        }
      ) }),
      F && /* @__PURE__ */ k.jsx(ze, { children: /* @__PURE__ */ k.jsxs(b, { flexDirection: "row", gap: "200", alignItems: "center", children: [
        /* @__PURE__ */ k.jsx(me, { name: "close-circle-filled", color: "red.500" }),
        /* @__PURE__ */ k.jsx(A.Paragraph, { children: m })
      ] }) })
    ] }) }),
    /* @__PURE__ */ k.jsx(
      Tt,
      {
        confirmProps: {
          disabled: !(B.formState.isValid && B.formState.isDirty),
          isLoading: i,
          loadingIndicator: /* @__PURE__ */ k.jsx(cn, { size: 16 })
        },
        confirmOnClick: B.handleSubmit(Q),
        cancelOnClick: U,
        confirmName: J ? "Close" : "Save",
        cancelName: J ? void 0 : "Cancel"
      }
    )
  ] });
}, oz = ({
  conversationContext: e,
  refetchCustomer: n
}) => {
  const [r, i] = se(!1), [a, o] = se(!1);
  return /* @__PURE__ */ k.jsxs(k.Fragment, { children: [
    /* @__PURE__ */ k.jsx(
      Wn,
      {
        variant: "secondary",
        onClick: () => i(!0),
        isLoading: a,
        loadingIndicator: /* @__PURE__ */ k.jsx(cn, { size: 16 }),
        slotStart: /* @__PURE__ */ k.jsx(me, { size: 14, name: "user-plus", color: "green.500" }),
        className: Et.fullWidth,
        children: "Create new Shopify profile"
      }
    ),
    /* @__PURE__ */ k.jsx(
      az,
      {
        isOpen: r,
        setIsOpen: i,
        isMutationLoading: a,
        setIsMutationLoading: o,
        conversationContext: e,
        refetchCustomer: n
      }
    )
  ] });
}, Vp = (e) => {
  const n = e?.match(/shopify\/\w+\/(\d+)/);
  return n ? n[1] : null;
}, xm = "DD MMM YYYY @ HH:mm", sz = "_wrapper_10fld_1", lz = "_copyIcon_10fld_7", Mo = {
  wrapper: sz,
  copyIcon: lz
}, cz = ({
  customer: e,
  shopifyDomain: n,
  refresh: r,
  loading: i,
  networkStatus: a
}) => {
  const { isCopied: o, copy: s } = ro(), { isCopied: l, copy: d } = ro(), { track: m } = bn();
  if (!e)
    return null;
  const {
    id: u,
    displayName: f,
    defaultEmailAddress: h,
    defaultPhoneNumber: v,
    tags: C = [],
    verifiedEmail: S
  } = e, j = h?.emailAddress, F = v?.phoneNumber, y = Vp(u), q = `https://${n}/admin/customers/${y ?? ""}`, T = i && a === Yt.refetch, E = 14;
  return /* @__PURE__ */ k.jsxs(b, { gap: "300", flexDirection: "column", children: [
    /* @__PURE__ */ k.jsxs(b, { className: Mo.wrapper, gap: "200", flexDirection: "column", children: [
      /* @__PURE__ */ k.jsxs(b, { justifyContent: "space-between", alignItems: "center", children: [
        /* @__PURE__ */ k.jsx(A.Heading, { variant: "heading-3", children: f }),
        T ? /* @__PURE__ */ k.jsx(cn, { size: E }) : /* @__PURE__ */ k.jsx(Ge, { content: "Reload customer", children: /* @__PURE__ */ k.jsx(
          me,
          {
            size: E,
            name: "sync",
            onClick: () => {
              m("shopify:refreshed", { shopifyId: u }), r();
            },
            className: Mo.copyIcon
          }
        ) })
      ] }),
      j && /* @__PURE__ */ k.jsxs(b, { justifyContent: "space-between", alignItems: "center", children: [
        /* @__PURE__ */ k.jsxs(b, { alignItems: "center", gap: "200", children: [
          /* @__PURE__ */ k.jsx(me, { size: E, name: "mail" }),
          /* @__PURE__ */ k.jsx(A.ExternalLink, { href: `mailto:${j}`, children: j }),
          /* @__PURE__ */ k.jsx(
            Ge,
            {
              content: S ? "Verified email" : "Email is not verified",
              children: /* @__PURE__ */ k.jsx(b, { alignItems: "center", children: /* @__PURE__ */ k.jsx(
                me,
                {
                  size: E,
                  color: S ? "green.500" : "red.500",
                  name: S ? "check-circle" : "exclamation"
                }
              ) })
            }
          )
        ] }),
        /* @__PURE__ */ k.jsx(Ge, { content: "Copy Email", children: /* @__PURE__ */ k.jsx(
          me,
          {
            size: E,
            name: o ? "done" : "copy",
            onClick: () => s(j),
            className: Mo.copyIcon
          }
        ) })
      ] }),
      F && /* @__PURE__ */ k.jsxs(b, { justifyContent: "space-between", alignItems: "center", children: [
        /* @__PURE__ */ k.jsxs(b, { alignItems: "center", gap: "200", children: [
          /* @__PURE__ */ k.jsx(me, { size: E, name: "phone" }),
          /* @__PURE__ */ k.jsx(A.ExternalLink, { href: `tel:${F}`, children: F })
        ] }),
        /* @__PURE__ */ k.jsx(Ge, { content: "Copy phone number", children: /* @__PURE__ */ k.jsx(
          me,
          {
            size: E,
            name: l ? "done" : "copy",
            onClick: () => d(F),
            className: Mo.copyIcon
          }
        ) })
      ] }),
      /* @__PURE__ */ k.jsxs(b, { alignItems: "center", gap: "200", children: [
        /* @__PURE__ */ k.jsx(me, { size: E, name: "external-link" }),
        /* @__PURE__ */ k.jsx(
          A.ExternalLink,
          {
            href: q,
            target: "_blank",
            rel: "noreferrer",
            children: "View customer in Shopify"
          }
        )
      ] })
    ] }),
    C.length > 0 && /* @__PURE__ */ k.jsxs(k.Fragment, { children: [
      /* @__PURE__ */ k.jsx(A.Heading, { variant: "heading-3", children: "Tags" }),
      /* @__PURE__ */ k.jsx(b, { gap: "200", flexDirection: "row", flexWrap: "wrap", children: C.map((D) => /* @__PURE__ */ k.jsx(An, { children: D }, `${u}-${D}`)) })
    ] })
  ] });
}, dz = "_creationModal_pbe64_1", uz = "_detailsModal_pbe64_5", mz = "_percentageSuffix_pbe64_9", Tu = {
  creationModal: dz,
  detailsModal: uz,
  percentageSuffix: mz
}, pz = () => {
  const e = "ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789";
  return Array.from(
    { length: 12 },
    () => e.charAt(Math.floor(Math.random() * e.length))
  ).join("");
}, fz = (e) => {
  const n = e.customerGetsOption === "percentage" ? e.customerGets / 100 : e.customerGets, r = (() => {
    switch (e.minimumRequirementOption) {
      case "quantity":
        return "greaterThanOrEqualToQuantity";
      case "subtotal":
        return "greaterThanOrEqualToSubtotal";
      case "none":
      default:
        return null;
    }
  })(), i = e.maximumUsage;
  return {
    code: e.code,
    title: e.title,
    usageLimit: i === "only-once" ? 1 : null,
    appliesOncePerCustomer: i === "once-per-customer",
    customerGets: {
      value: {
        [e.customerGetsOption]: e.customerGetsOption === "discountAmount" ? { amount: n } : n
      },
      items: {
        all: !0
      }
    },
    context: {
      all: rS.All
    },
    ...r && {
      minimumRequirement: {
        [e.minimumRequirementOption]: {
          [r]: e.minimumRequirementOption === "quantity" ? e.minimumRequirementValue?.toString() : e.minimumRequirementValue
        }
      }
    },
    startsAt: (/* @__PURE__ */ new Date()).toISOString()
  };
}, Ik = [
  {
    label: "Percentage",
    description: "The percentage value of the discount.",
    value: "percentage"
  },
  {
    label: "Amount",
    description: "The value of the discount.",
    value: "discountAmount"
  }
], Ek = [
  {
    label: "None",
    description: "No minimum requirements.",
    value: "none"
  },
  {
    label: "Quantity",
    description: "Minimum required quantity of items.",
    value: "quantity"
  },
  {
    label: "Subtotal",
    description: "Minimum required order subtotal.",
    value: "subtotal"
  }
], Tk = [
  {
    label: "No limit",
    value: "no-limit",
    description: "The discount code can be used unlimited times."
  },
  {
    label: "Only once",
    value: "only-once",
    description: "The discount code can only be used once."
  },
  {
    label: "Once per customer",
    value: "once-per-customer",
    description: "The discount code can be used once per customer."
  }
], hz = ({
  codeDiscount: e
}) => {
  const n = e?.codes?.nodes?.[0]?.code, { isCopied: r, copy: i } = nr(), a = e?.usageLimit ? `${e?.usageLimit} uses remaining` : "No limit";
  return /* @__PURE__ */ k.jsxs(b, { flexDirection: "column", gap: "400", children: [
    /* @__PURE__ */ k.jsxs(Ke, { children: [
      /* @__PURE__ */ k.jsx(Ke.Text, { children: /* @__PURE__ */ k.jsxs(b, { justifyContent: "space-between", children: [
        /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "1", children: "Title" }),
        /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "2", color: "secondary", children: e?.title })
      ] }) }),
      /* @__PURE__ */ k.jsx(Ke.Text, { children: /* @__PURE__ */ k.jsxs(b, { justifyContent: "space-between", children: [
        /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "1", children: "Status" }),
        /* @__PURE__ */ k.jsxs(b, { gap: "200", alignItems: "center", children: [
          /* @__PURE__ */ k.jsx(
            me,
            {
              name: e?.status === "ACTIVE" ? "check-circle-filled" : "circle-filled",
              color: e?.status === "ACTIVE" ? "green.500" : "neutral.500"
            }
          ),
          /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "2", color: "secondary", children: e?.status })
        ] })
      ] }) }),
      /* @__PURE__ */ k.jsx(Ke.Text, { children: /* @__PURE__ */ k.jsxs(b, { justifyContent: "space-between", children: [
        /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "1", children: "Usage limit" }),
        /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "2", color: "secondary", children: a })
      ] }) }),
      /* @__PURE__ */ k.jsx(Ke.Text, { children: /* @__PURE__ */ k.jsxs(b, { justifyContent: "space-between", children: [
        /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "1", children: "Applies once per customer" }),
        /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "2", color: "secondary", children: e?.appliesOncePerCustomer ? "Yes" : "No" })
      ] }) }),
      /* @__PURE__ */ k.jsx(Ke.Text, { children: /* @__PURE__ */ k.jsxs(b, { justifyContent: "space-between", children: [
        /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "1", children: "Starts at" }),
        /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "2", color: "secondary", children: Ln(e?.startsAt).format(yt) })
      ] }) })
    ] }),
    /* @__PURE__ */ k.jsx(En, { label: "Discount code", children: /* @__PURE__ */ k.jsx(
      _r,
      {
        readOnly: !0,
        value: n,
        suffix: {
          type: "button",
          button: {
            icon: r ? "done" : "copy",
            onClick: () => {
              i(n);
            }
          }
        }
      }
    ) })
  ] });
}, yz = "shopify-discount-code-form", $k = {
  title: "",
  code: "",
  customerGets: void 0,
  customerGetsOption: "percentage",
  minimumRequirementOption: "none",
  minimumRequirementValue: void 0,
  maximumUsage: "only-once"
}, gz = ({
  isOpen: e,
  setIsOpen: n
}) => {
  const { track: r } = bn(), { useMutation: i, showNotification: a } = mn(), [o, s] = se(
    []
  ), [l, d] = se(), m = Bt({
    mode: "all",
    defaultValues: $k
  });
  He(() => {
    o?.forEach((E) => {
      const D = E?.field?.[1];
      D && m.setError(D, {
        type: "server",
        message: E.message
      });
    });
  }, [o, m]);
  const u = !!l, f = m.watch("minimumRequirementOption"), h = m.watch("customerGetsOption"), v = Bn(() => {
    switch (f) {
      case "quantity":
        return "Minimum quantity";
      case "subtotal":
        return "Minimum subtotal";
      case "none":
      default:
        return "";
    }
  }, [f]), [
    C,
    {
      loading: S,
      error: j,
      reset: F
    }
  ] = i(YV, {
    onError: () => {
      a({
        title: "Something went wrong",
        text: "The discount code creation was not successful.",
        icon: "exclamation-triangle-filled",
        severity: "warning"
      });
    },
    onCompleted: (E) => {
      const D = E?.Shopify?.discountCodeBasicCreate?.userErrors;
      if (D && D.length > 0)
        s(D);
      else {
        const B = E?.Shopify?.discountCodeBasicCreate?.codeDiscountNode?.codeDiscount;
        B && "codes" in B && d(B), a({
          title: "Success",
          text: "The discount code was created successfully.",
          icon: "check-circle-filled",
          severity: "success"
        }), r("shopify:discount:code:created"), s([]);
      }
    }
  }), y = () => {
    m.setValue("code", pz(), {
      shouldDirty: !0,
      shouldValidate: !0,
      shouldTouch: !0
    });
  }, q = (E) => {
    C({
      variables: {
        input: fz(E)
      }
    });
  }, T = () => {
    m.reset($k), s([]), F(), d(void 0), n(!1);
  };
  return /* @__PURE__ */ k.jsxs(
    wt,
    {
      isOpen: e,
      onClose: T,
      className: rt({
        [Tu.creationModal]: !u,
        [Tu.detailsModal]: u
      }),
      children: [
        /* @__PURE__ */ k.jsx(
          Ct,
          {
            title: u ? "Discount code details" : "Create new discount code",
            onClose: T
          }
        ),
        /* @__PURE__ */ k.jsxs(Ft, { children: [
          u && /* @__PURE__ */ k.jsx(hz, { codeDiscount: l }),
          !u && /* @__PURE__ */ k.jsxs("form", { noValidate: !0, id: yz, onSubmit: m.handleSubmit(q), children: [
            /* @__PURE__ */ k.jsx(b, { margin: "0 0 400", children: /* @__PURE__ */ k.jsx(
              Rs,
              {
                variant: "info",
                description: /* @__PURE__ */ k.jsx(A.Paragraph, { children: "This code will be eligible for all customers." })
              }
            ) }),
            /* @__PURE__ */ k.jsxs(vt, { children: [
              /* @__PURE__ */ k.jsx(ze, { children: /* @__PURE__ */ k.jsx(
                gt,
                {
                  label: "Title",
                  name: "title",
                  control: m.control,
                  rules: {
                    required: "Please enter a title"
                  },
                  componentProps: {
                    placeholder: "Enter a title"
                  }
                }
              ) }),
              /* @__PURE__ */ k.jsx(ze, { span: 3, children: /* @__PURE__ */ k.jsx(
                xr,
                {
                  control: m.control,
                  label: "Discount type",
                  name: "customerGetsOption",
                  rules: {
                    required: "Please select a discount type"
                  },
                  componentProps: {
                    placeholder: "Select a discount type",
                    equalityFn: (E, D) => E === D,
                    onChange: () => {
                      m.setValue("customerGets", void 0), m.clearErrors("customerGets");
                    },
                    getItemTitleByValue: (E) => {
                      const D = Ik.find(
                        (B) => B.value === E
                      );
                      return /* @__PURE__ */ k.jsx(b, { margin: "0 0 100", children: /* @__PURE__ */ k.jsx(A.Heading, { variant: "heading-3", children: D?.label }) });
                    }
                  },
                  children: Ik.map((E) => /* @__PURE__ */ k.jsx(st.Item, { value: E.value, children: /* @__PURE__ */ k.jsxs(b, { flexDirection: "column", gap: "100", children: [
                    /* @__PURE__ */ k.jsx(A.Heading, { variant: "heading-3", children: E.label }),
                    /* @__PURE__ */ k.jsx(A.Paragraph, { color: "secondary", children: E.description })
                  ] }) }, E.value))
                }
              ) }),
              /* @__PURE__ */ k.jsx(ze, { span: 3, children: /* @__PURE__ */ k.jsx(
                gt,
                {
                  label: "Discount value",
                  name: "customerGets",
                  control: m.control,
                  rules: {
                    required: "Please enter a value",
                    validate: (E) => {
                      if (E) {
                        if (h === "percentage" && (E < 0 || E > 100))
                          return "Percentage must be between 0 and 100";
                        if (h === "discountAmount" && E < 0)
                          return "Discount amount must be greater than 0";
                      }
                    }
                  },
                  componentProps: {
                    placeholder: "Enter a value",
                    type: "number",
                    ...h === "percentage" && {
                      suffix: {
                        type: "custom",
                        noWrap: !0,
                        value: /* @__PURE__ */ k.jsx(
                          b,
                          {
                            alignItems: "center",
                            className: Tu.percentageSuffix,
                            children: "%"
                          }
                        )
                      }
                    }
                  }
                }
              ) }),
              /* @__PURE__ */ k.jsx(ze, { children: /* @__PURE__ */ k.jsx(
                gt,
                {
                  label: "Code",
                  name: "code",
                  control: m.control,
                  rules: {
                    required: "Please enter a code"
                  },
                  componentProps: {
                    placeholder: "Enter a code or click to the right to generate",
                    suffix: {
                      type: "button",
                      button: {
                        icon: "sync",
                        onClick: y
                      }
                    }
                  }
                }
              ) }),
              /* @__PURE__ */ k.jsx(ze, { span: 3, children: /* @__PURE__ */ k.jsx(
                xr,
                {
                  control: m.control,
                  label: "Minimum purchase requirements",
                  name: "minimumRequirementOption",
                  rules: {
                    required: "Please select a minimum requirement option"
                  },
                  componentProps: {
                    placeholder: "Select a minimum purchase requirement",
                    equalityFn: (E, D) => E === D,
                    onChange: () => {
                      m.setValue("minimumRequirementValue", void 0), m.clearErrors("minimumRequirementValue");
                    },
                    getItemTitleByValue: (E) => {
                      const D = Ek.find(
                        (B) => B.value === E
                      );
                      return /* @__PURE__ */ k.jsx(b, { margin: "0 0 100", children: /* @__PURE__ */ k.jsx(A.Heading, { variant: "heading-3", children: D?.label }) });
                    }
                  },
                  children: Ek.map((E) => /* @__PURE__ */ k.jsx(st.Item, { value: E.value, children: /* @__PURE__ */ k.jsxs(b, { flexDirection: "column", gap: "100", children: [
                    /* @__PURE__ */ k.jsx(A.Heading, { variant: "heading-3", children: E.label }),
                    /* @__PURE__ */ k.jsx(A.Paragraph, { color: "secondary", children: E.description })
                  ] }) }, E.value))
                }
              ) }),
              /* @__PURE__ */ k.jsx(ze, { span: 3, children: /* @__PURE__ */ k.jsx(
                gt,
                {
                  name: "minimumRequirementValue",
                  label: v,
                  control: m.control,
                  disabled: f === "none",
                  rules: {
                    required: {
                      value: f !== "none",
                      message: "Please enter a value"
                    },
                    validate: (E) => {
                      if (E && f !== "none" && E < 0)
                        return `Minimum ${f} must be greater than 0`;
                    }
                  },
                  componentProps: {
                    type: "number",
                    placeholder: "Enter a value"
                  }
                }
              ) }),
              /* @__PURE__ */ k.jsx(ze, { children: /* @__PURE__ */ k.jsx(
                xr,
                {
                  name: "maximumUsage",
                  label: "Maximum usage",
                  control: m.control,
                  componentProps: {
                    placeholder: "Select a maximum usage",
                    equalityFn: (E, D) => E === D,
                    getItemTitleByValue: (E) => {
                      const D = Tk.find(
                        (B) => B.value === E
                      );
                      return /* @__PURE__ */ k.jsx(b, { margin: "0 0 100", children: /* @__PURE__ */ k.jsx(A.Heading, { variant: "heading-3", children: D?.label }) });
                    }
                  },
                  children: Tk.map((E) => /* @__PURE__ */ k.jsx(st.Item, { value: E.value, children: /* @__PURE__ */ k.jsxs(b, { flexDirection: "column", gap: "100", children: [
                    /* @__PURE__ */ k.jsx(A.Heading, { variant: "heading-3", children: E.label }),
                    /* @__PURE__ */ k.jsx(A.Paragraph, { color: "secondary", children: E.description })
                  ] }) }, E.value))
                }
              ) })
            ] })
          ] }),
          j && /* @__PURE__ */ k.jsx(Fn, { error: j })
        ] }),
        /* @__PURE__ */ k.jsx(
          Tt,
          {
            confirmProps: {
              disabled: !u && !(m.formState.isValid && m.formState.isDirty),
              isLoading: S,
              loadingIndicator: /* @__PURE__ */ k.jsx(cn, { size: 16 })
            },
            confirmName: u ? "Close" : "Save",
            confirmOnClick: u ? T : m.handleSubmit(q),
            cancelOnClick: u ? void 0 : T
          }
        )
      ]
    }
  );
}, vz = ({ code: e }) => {
  const { isCopied: n, copy: r } = ro();
  return /* @__PURE__ */ k.jsxs(
    b,
    {
      justifyContent: "space-between",
      alignItems: "center",
      gap: "200",
      width: "100%",
      children: [
        /* @__PURE__ */ k.jsxs(b, { gap: "200", alignItems: "center", children: [
          /* @__PURE__ */ k.jsx(me, { size: 12, name: "shopify", color: "green.500" }),
          /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "3", children: e })
        ] }),
        /* @__PURE__ */ k.jsx(
          Qt,
          {
            icon: n ? "done" : "copy",
            onClick: () => r(e),
            variant: "secondary"
          }
        )
      ]
    }
  );
}, kz = ({
  discountCode: e
}) => {
  const { codeDiscount: n } = e;
  if (!("codes" in n))
    return null;
  const r = "summary" in n, i = n?.codes?.nodes ?? [];
  return /* @__PURE__ */ k.jsxs(b, { flexDirection: "column", gap: "100", children: [
    /* @__PURE__ */ k.jsx(A.Heading, { variant: "heading-3", children: n.title }),
    r && /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "4", color: "tertiary", children: n.summary }),
    /* @__PURE__ */ k.jsx(Ke, { children: i.map((a) => /* @__PURE__ */ k.jsx(Ke.Item, { className: Et.listItem, children: /* @__PURE__ */ k.jsx(vz, { code: a.code }, a.id) }, a.id)) })
  ] });
}, bz = "_modal_11d6e_1", _z = "_modalBody_11d6e_4", xz = "_codeContainer_11d6e_9", $u = {
  modal: bz,
  modalBody: _z,
  codeContainer: xz
}, Sz = [50, 100, 250], oS = 50, Nz = {
  maxNumberOfCodesToDisplay: oS
}, jz = ({
  isOpen: e,
  setIsOpen: n
}) => {
  const { useQuery: r } = mn(), [i, a] = se(
    oS
  ), [o, s] = se([]), l = o.length === 0, d = o.length > i, m = Bt({
    mode: "all",
    defaultValues: Nz
  }), { loading: u, error: f } = r(BV, {
    variables: {
      first: i
    },
    onCompleted: (v) => {
      const C = v?.Shopify?.codeDiscountNodes?.nodes ?? [];
      C && C.length > 0 && s(C);
    }
  }), h = () => {
    n(!1);
  };
  return /* @__PURE__ */ k.jsxs(wt, { isOpen: e, onClose: h, className: $u.modal, children: [
    /* @__PURE__ */ k.jsx(Ct, { title: "Discount codes", onClose: h }),
    /* @__PURE__ */ k.jsxs(Ft, { className: $u.modalBody, children: [
      d && /* @__PURE__ */ k.jsx(vt, { children: /* @__PURE__ */ k.jsx(ze, { span: 3, children: /* @__PURE__ */ k.jsx(
        xr,
        {
          control: m.control,
          label: "Number of codes to display",
          name: "maxNumberOfCodesToDisplay",
          componentProps: {
            placeholder: "Select a number of codes to display",
            onChange: (v) => {
              a(v.selectedValues[0]);
            },
            getItemTitleByValue: (v) => /* @__PURE__ */ k.jsx(b, { margin: "0 0 100", children: /* @__PURE__ */ k.jsx(A.Heading, { variant: "heading-3", children: v }) })
          },
          children: Sz.map((v) => /* @__PURE__ */ k.jsx(st.Item, { value: v, children: /* @__PURE__ */ k.jsx(A.Heading, { variant: "heading-3", children: v }) }, v))
        }
      ) }) }),
      u && /* @__PURE__ */ k.jsx(b, { justifyContent: "center", margin: "300", children: /* @__PURE__ */ k.jsx(cn, {}) }),
      f && /* @__PURE__ */ k.jsx(b, { justifyContent: "center", margin: "300", children: /* @__PURE__ */ k.jsx(A.Paragraph, { children: "Something went wrong while fetching discount codes." }) }),
      !u && l && /* @__PURE__ */ k.jsx(
        us,
        {
          title: "No discount codes found.",
          description: "There are no discount codes to display. You can create a new discount code with the 'Create new' button in our integration."
        }
      ),
      !u && !f && !l && o.map((v) => /* @__PURE__ */ k.jsx("div", { className: $u.codeContainer, children: /* @__PURE__ */ k.jsx(kz, { discountCode: v }) }, v.id))
    ] }),
    /* @__PURE__ */ k.jsx(Tt, { confirmName: "Close", confirmOnClick: h })
  ] });
}, wz = ({
  displayDiscountCodeCreation: e
}) => {
  const [n, r] = se(!1), [i, a] = se(!1);
  return /* @__PURE__ */ k.jsxs(k.Fragment, { children: [
    /* @__PURE__ */ k.jsxs(b, { gap: "200", flexDirection: "column", children: [
      /* @__PURE__ */ k.jsx(A.Heading, { variant: "heading-3", children: "Discount codes" }),
      /* @__PURE__ */ k.jsxs(b, { gap: "100", flexDirection: "row", alignItems: "center", width: "100%", children: [
        /* @__PURE__ */ k.jsx(b, { flex: "1", children: /* @__PURE__ */ k.jsx(
          Wn,
          {
            variant: "secondary",
            icon: "gift",
            onClick: () => a(!0),
            style: { width: "100%" },
            children: "View discount codes"
          }
        ) }),
        e && /* @__PURE__ */ k.jsx(b, { flex: "1", children: /* @__PURE__ */ k.jsx(
          Wn,
          {
            variant: "secondary",
            icon: "plus",
            onClick: () => r(!0),
            style: { width: "100%" },
            children: "Create new"
          }
        ) })
      ] })
    ] }),
    /* @__PURE__ */ k.jsx(
      jz,
      {
        isOpen: i,
        setIsOpen: a
      }
    ),
    /* @__PURE__ */ k.jsx(
      gz,
      {
        isOpen: n,
        setIsOpen: r
      }
    )
  ] });
}, Cz = ({
  customer: e
}) => {
  if (!e)
    return null;
  const { defaultEmailAddress: n, defaultPhoneNumber: r } = e, i = (h) => h ? $b(h.replaceAll("_", " ")) : "No state available", a = (h) => {
    switch (h) {
      case Ri.Invalid:
      case Ri.NotSubscribed:
      case Er.NotSubscribed:
        return "red.500";
      case Ri.Pending:
      case Er.Pending:
      case Ri.Unsubscribed:
      case Er.Unsubscribed:
        return "orange.500";
      case Ri.Subscribed:
      case Er.Subscribed:
        return "green.500";
      default:
        return "neutral.500";
    }
  }, o = (h) => {
    switch (h) {
      case yi.SingleOptIn:
      case yi.ConfirmedOptIn:
        return "green.500";
      case yi.Unknown:
      default:
        return "neutral.200";
    }
  }, {
    marketingState: s,
    marketingUpdatedAt: l,
    marketingOptInLevel: d
  } = n ?? {}, {
    marketingState: m,
    marketingUpdatedAt: u,
    marketingOptInLevel: f
  } = r ?? {};
  return /* @__PURE__ */ k.jsxs(b, { gap: "300", flexDirection: "column", children: [
    /* @__PURE__ */ k.jsx(A.Heading, { variant: "heading-3", children: "Marketing consent" }),
    /* @__PURE__ */ k.jsxs(b, { gap: "200", flexDirection: "column", children: [
      /* @__PURE__ */ k.jsxs(b, { gap: "200", flexDirection: "row", children: [
        /* @__PURE__ */ k.jsx(me, { name: "mail", color: "neutral.500" }),
        /* @__PURE__ */ k.jsx(A.Heading, { variant: "heading-4", children: "Email" })
      ] }),
      l && /* @__PURE__ */ k.jsx(Ge, { content: "Last updated at", children: /* @__PURE__ */ k.jsx(Pn, { size: "small", variant: "info", children: Ln(l).format(xm) }) }),
      /* @__PURE__ */ k.jsxs(b, { gap: "100", flexDirection: "row", children: [
        /* @__PURE__ */ k.jsx(Ge, { content: "Opt-In state", children: /* @__PURE__ */ k.jsx(An, { color: o(d), children: i(d) }) }),
        /* @__PURE__ */ k.jsx(Ge, { content: "Marketing state", children: /* @__PURE__ */ k.jsx(An, { color: a(s), children: i(s) }) })
      ] })
    ] }),
    /* @__PURE__ */ k.jsxs(b, { gap: "200", flexDirection: "column", children: [
      /* @__PURE__ */ k.jsxs(b, { gap: "200", flexDirection: "row", alignItems: "center", children: [
        /* @__PURE__ */ k.jsx(me, { name: "phone", color: "neutral.500" }),
        /* @__PURE__ */ k.jsx(A.Heading, { variant: "heading-4", children: "Phone" })
      ] }),
      u && /* @__PURE__ */ k.jsx(Ge, { content: "Last updated at", children: /* @__PURE__ */ k.jsx(Pn, { size: "small", variant: "info", children: Ln(u).format(xm) }) }),
      /* @__PURE__ */ k.jsxs(b, { gap: "100", flexDirection: "row", children: [
        /* @__PURE__ */ k.jsx(Ge, { content: "Opt-In state", children: /* @__PURE__ */ k.jsx(An, { color: o(f), children: i(f) }) }),
        /* @__PURE__ */ k.jsx(Ge, { content: "Marketing state", children: /* @__PURE__ */ k.jsx(An, { color: a(m), children: i(m) }) })
      ] })
    ] })
  ] });
}, Fz = ({
  ordersData: e
}) => {
  const n = (r) => r?.fulfillments?.length > 0 ? r.fulfillments[0].trackingInfo : [];
  return e.map(({ node: r }) => ({
    id: r.id,
    name: r.name,
    createdAt: new Date(r.createdAt),
    cancelledAt: r.cancelledAt ? new Date(r.cancelledAt) : void 0,
    status: `${r.displayFulfillmentStatus?.toLowerCase()}, ${r.displayFinancialStatus?.toLowerCase()}${r.cancelledAt ? ", cancelled" : ""}`,
    displayFinancialStatus: r.displayFinancialStatus,
    currentTotalPriceSet: r.currentTotalPriceSet,
    value: r.netPaymentSet?.presentmentMoney?.amount,
    currencyCode: r.netPaymentSet?.presentmentMoney?.currencyCode,
    shippingAddress: r.shippingAddress,
    billingAddress: r.billingAddress,
    lineItems: r.lineItems?.edges?.map(({ node: i }) => i),
    suggestedRefund: {
      orderId: r.id,
      amount: r.suggestedRefund?.amountSet?.presentmentMoney?.amount,
      currency: r.suggestedRefund?.amountSet?.presentmentMoney?.currencyCode,
      notify: !0,
      refundLineItems: r.suggestedRefund?.refundLineItems.map(
        ({ lineItem: i }) => ({
          lineItemId: i.id,
          quantity: i.quantity
        })
      ),
      transactions: r.suggestedRefund?.suggestedTransactions?.map(
        ({ amountSet: i, gateway: a, parentTransaction: o }) => ({
          amount: i?.presentmentMoney?.amount || "0.00",
          gateway: a ?? "",
          kind: iS.Refund,
          orderId: r.id,
          parentId: o?.id
        })
      ),
      shipping: {
        fullRefund: !0
      }
    },
    trackingInfos: n(r),
    shippingLines: r.shippingLines?.edges?.map(({ node: i }) => i),
    tags: r.tags,
    refunds: r.refunds
  }));
}, Dk = [
  {
    value: Br.Pending,
    label: "Pending",
    description: "The payment is pending"
  },
  {
    value: Br.Authorized,
    label: "Authorized",
    description: "The payment has been authorized but not captured"
  },
  {
    value: Br.Paid,
    label: "Paid",
    description: "The payment has been completed"
  },
  {
    value: Br.PartiallyPaid,
    label: "Partially Paid",
    description: "The payment has been partially completed"
  },
  {
    value: Br.Refunded,
    label: "Refunded",
    description: "The payment has been refunded"
  },
  {
    value: Br.Voided,
    label: "Voided",
    description: "The payment has been voided"
  },
  {
    value: Br.PartiallyRefunded,
    label: "Partially Refunded",
    description: "The payment has been partially refunded"
  }
], Rk = [
  {
    value: ss.Fulfilled,
    label: "Fulfilled",
    description: "Every line item in the order has been fulfilled"
  },
  {
    value: ss.Partial,
    label: "Partial",
    description: "At least one line item in the order has been fulfilled"
  },
  {
    value: ss.Restocked,
    label: "Restocked",
    description: "Every line item in the order has been restocked and the order canceled"
  }
], sS = (e) => e.length === 0 ? "" : e.map((n) => `id:${n.split("/").pop()}`).join(" OR "), Oi = (e) => Iz(Ez(e)), Iz = (e) => Object.fromEntries(
  Object.entries(e ?? {}).filter(([, n]) => n != null)
), Ez = (e) => {
  const n = e;
  if (typeof n == "object" && "countryCodeV2" in n) {
    const { countryCodeV2: r, ...i } = n;
    return {
      ...i,
      ...r && { countryCode: r }
    };
  }
  return e;
}, ii = ({
  control: e,
  name: n,
  label: r,
  placeholder: i,
  required: a = !1,
  apiUserError: o
}) => /* @__PURE__ */ k.jsx(
  zt,
  {
    name: n,
    control: e,
    rules: {
      required: a ? {
        value: !0,
        message: "This field is required"
      } : !1
    },
    render: ({ field: s, fieldState: l }) => /* @__PURE__ */ k.jsx(
      cr,
      {
        required: a,
        label: r,
        input: s,
        placeholder: i,
        meta: {
          warning: l?.error?.message,
          error: l?.error?.message || o?.[s.name]
        }
      }
    )
  }
), Tz = "_modal_1wlra_1", $z = {
  modal: Tz
};
function Ok(e) {
  try {
    return new Intl.DisplayNames(["en"], { type: "region" }).of(
      e.toUpperCase()
    ) ?? e;
  } catch {
    return e;
  }
}
const Pk = [
  "AF",
  "AX",
  "AL",
  "DZ",
  "AD",
  "AO",
  "AI",
  "AG",
  "AR",
  "AM",
  "AW",
  "AC",
  "AU",
  "AT",
  "AZ",
  "BS",
  "BH",
  "BD",
  "BB",
  "BY",
  "BE",
  "BZ",
  "BJ",
  "BM",
  "BT",
  "BO",
  "BA",
  "BW",
  "BV",
  "BR",
  "IO",
  "BN",
  "BG",
  "BF",
  "BI",
  "KH",
  "CA",
  "CV",
  "BQ",
  "KY",
  "CF",
  "TD",
  "CL",
  "CN",
  "CX",
  "CC",
  "CO",
  "KM",
  "CG",
  "CD",
  "CK",
  "CR",
  "HR",
  "CU",
  "CW",
  "CY",
  "CZ",
  "CI",
  "DK",
  "DJ",
  "DM",
  "DO",
  "EC",
  "EG",
  "SV",
  "GQ",
  "ER",
  "EE",
  "SZ",
  "ET",
  "FK",
  "FO",
  "FJ",
  "FI",
  "FR",
  "GF",
  "PF",
  "TF",
  "GA",
  "GM",
  "GE",
  "DE",
  "GH",
  "GI",
  "GR",
  "GL",
  "GD",
  "GP",
  "GT",
  "GG",
  "GN",
  "GW",
  "GY",
  "HT",
  "HM",
  "VA",
  "HN",
  "HK",
  "HU",
  "IS",
  "IN",
  "ID",
  "IR",
  "IQ",
  "IE",
  "IM",
  "IL",
  "IT",
  "JM",
  "JP",
  "JE",
  "JO",
  "KZ",
  "KE",
  "KI",
  "KP",
  "XK",
  "KW",
  "KG",
  "LA",
  "LV",
  "LB",
  "LS",
  "LR",
  "LY",
  "LI",
  "LT",
  "LU",
  "MO",
  "MG",
  "MW",
  "MY",
  "MV",
  "ML",
  "MT",
  "MQ",
  "MR",
  "MU",
  "YT",
  "MX",
  "MD",
  "MC",
  "MN",
  "ME",
  "MS",
  "MA",
  "MZ",
  "MM",
  "NA",
  "NR",
  "NP",
  "NL",
  "AN",
  "NC",
  "NZ",
  "NI",
  "NE",
  "NG",
  "NU",
  "NF",
  "MK",
  "NO",
  "OM",
  "PK",
  "PS",
  "PA",
  "PG",
  "PY",
  "PE",
  "PH",
  "PN",
  "PL",
  "PT",
  "QA",
  "CM",
  "RE",
  "RO",
  "RU",
  "RW",
  "BL",
  "SH",
  "KN",
  "LC",
  "MF",
  "PM",
  "WS",
  "SM",
  "ST",
  "SA",
  "SN",
  "RS",
  "SC",
  "SL",
  "SG",
  "SX",
  "SK",
  "SI",
  "SB",
  "SO",
  "ZA",
  "GS",
  "KR",
  "SS",
  "ES",
  "LK",
  "VC",
  "SD",
  "SR",
  "SJ",
  "SE",
  "CH",
  "SY",
  "TW",
  "TJ",
  "TZ",
  "TH",
  "TL",
  "TG",
  "TK",
  "TO",
  "TT",
  "TA",
  "TN",
  "TR",
  "TM",
  "TC",
  "TV",
  "UG",
  "UA",
  "AE",
  "GB",
  "US",
  "UM",
  "UY",
  "UZ",
  "VU",
  "VE",
  "VN",
  "VG",
  "WF",
  "EH",
  "YE",
  "ZM",
  "ZW",
  "ZZ"
], Ak = "shopify-shiping-address-form", Dz = ({
  title: e,
  address: n,
  isOpen: r,
  setIsOpen: i,
  orderId: a,
  shopifyId: o,
  shippingCountryCodes: s,
  onChange: l,
  refetchOrders: d
}) => {
  const { useMutation: m, showNotification: u } = mn(), { track: f } = bn(), [h, v] = se(!1), [C, S] = se({}), j = !l, [
    F,
    { error: y, reset: q }
  ] = m(qV, {
    onError: () => {
      v(!1), u({
        title: "Something went wrong",
        text: "The address change was not successful.",
        icon: "exclamation-triangle-filled",
        severity: "warning"
      });
    },
    onCompleted: (Q) => {
      v(!1);
      const U = Q?.Shopify?.orderUpdate?.userErrors;
      if (U != null && U.length > 0) {
        const O = U.reduce(
          (H, Z) => {
            const ye = Z.field;
            if (ye == null || ye.length === 0)
              return H;
            const ce = ye[ye.length - 1];
            return ce != null && (H[ce] = Z.message), H;
          },
          {}
        );
        S(O);
      } else
        u({
          title: "Success",
          text: "The address change was successful.",
          icon: "check-circle-filled",
          severity: "success"
        }), d(), ae();
    }
  }), T = tt(
    () => ({
      firstName: n?.firstName || "",
      lastName: n?.lastName || "",
      company: n?.company || "",
      address1: n?.address1 || "",
      address2: n?.address2 || "",
      city: n?.city || "",
      countryCodeV2: Pk.find(
        (Q) => Q === n?.countryCodeV2
      ),
      provinceCode: n?.province || "",
      zip: n?.zip || ""
    }),
    [n]
  ), { control: E, handleSubmit: D, formState: B, reset: ee } = Bt({
    mode: "all",
    defaultValues: T()
  }), J = D((Q) => {
    if (j) {
      if (v(!0), !o || !a) {
        v(!1);
        return;
      }
      f("shopify:order:edit:shipping:address:modal:submitted", {
        shopifyId: o,
        orderId: a
      });
      const { countryCodeV2: U, ...O } = Q, H = {
        ...O,
        countryCode: U
      };
      F({
        variables: {
          input: {
            id: a,
            shippingAddress: H
          }
        }
      });
    } else
      l(Q), ae();
  });
  He(() => {
    r && ee(T());
  }, [r, n, ee, T]);
  const ae = () => {
    ee(T()), S({}), q(), i(!1);
  };
  return /* @__PURE__ */ k.jsxs(
    wt,
    {
      isOpen: r,
      onClose: ae,
      className: $z.modal,
      "data-testid": "edit-shipping-address-modal",
      children: [
        /* @__PURE__ */ k.jsx(Ct, { title: e, onClose: () => ae() }),
        /* @__PURE__ */ k.jsx(Ft, { children: /* @__PURE__ */ k.jsxs("form", { noValidate: !0, id: Ak, onSubmit: J, children: [
          y && /* @__PURE__ */ k.jsx(Fn, { error: y }),
          /* @__PURE__ */ k.jsxs(vt, { children: [
            /* @__PURE__ */ k.jsx(ze, { span: 3, children: /* @__PURE__ */ k.jsx(
              ii,
              {
                required: !0,
                control: E,
                name: "firstName",
                label: "First name",
                placeholder: "Insert your first name",
                apiUserError: C
              }
            ) }),
            /* @__PURE__ */ k.jsx(ze, { span: 3, children: /* @__PURE__ */ k.jsx(
              ii,
              {
                required: !0,
                control: E,
                name: "lastName",
                label: "Last name",
                placeholder: "Insert your last name",
                apiUserError: C
              }
            ) }),
            /* @__PURE__ */ k.jsx(ze, { span: 6, children: /* @__PURE__ */ k.jsx(
              ii,
              {
                control: E,
                name: "company",
                label: "Company",
                placeholder: "Insert your company name"
              }
            ) }),
            /* @__PURE__ */ k.jsx(ze, { span: 6, children: /* @__PURE__ */ k.jsx(
              ii,
              {
                required: !0,
                control: E,
                name: "address1",
                label: "Address",
                placeholder: "Insert your address",
                apiUserError: C
              }
            ) }),
            /* @__PURE__ */ k.jsx(ze, { span: 6, children: /* @__PURE__ */ k.jsx(
              ii,
              {
                control: E,
                name: "address2",
                label: "Additional address details",
                placeholder: "Insert more address details"
              }
            ) }),
            /* @__PURE__ */ k.jsx(ze, { span: 3, children: /* @__PURE__ */ k.jsx(
              ii,
              {
                required: !0,
                control: E,
                name: "zip",
                label: "Zip / postal code",
                placeholder: "Insert your zip / postal code",
                apiUserError: C
              }
            ) }),
            /* @__PURE__ */ k.jsx(ze, { span: 3, children: /* @__PURE__ */ k.jsx(
              ii,
              {
                required: !0,
                control: E,
                name: "city",
                label: "City",
                placeholder: "Insert your city",
                apiUserError: C
              }
            ) }),
            /* @__PURE__ */ k.jsx(ze, { span: 6, children: /* @__PURE__ */ k.jsx(
              xr,
              {
                name: "countryCodeV2",
                control: E,
                label: "Country",
                rules: {
                  required: {
                    value: !0,
                    message: "Please select a country"
                  }
                },
                componentProps: {
                  placeholder: "Select your country",
                  getItemTitleByValue: (Q) => Q ? Ok(Q) : ""
                },
                children: Pk.filter((Q) => s.includes(Q)).map((Q) => /* @__PURE__ */ k.jsx(st.Item, { value: Q, children: /* @__PURE__ */ k.jsx(A.Paragraph, { children: Ok(Q) }) }, Q))
              }
            ) })
          ] })
        ] }) }),
        /* @__PURE__ */ k.jsx(
          Tt,
          {
            confirmProps: {
              disabled: !(B.isValid && B.isDirty),
              type: "submit",
              form: Ak,
              isLoading: h,
              loadingIndicator: /* @__PURE__ */ k.jsx(cn, { size: 16 })
            },
            confirmOnClick: () => {
              y && ae();
            },
            cancelOnClick: () => {
              o && a && !y && f("shopify:order:edit:shipping:address:modal:canceled", {
                shopifyId: o,
                orderId: a
              }), ae();
            },
            confirmName: y ? "Close" : "Save",
            cancelName: y ? void 0 : "Cancel"
          }
        )
      ]
    }
  );
}, Rz = "_clickableIcon_33mqm_1", Du = {
  clickableIcon: Rz
}, Lk = ({
  formFieldName: e,
  ...n
}) => {
  const r = Or(), { field: i } = np({
    control: r.control,
    name: e
  });
  return /* @__PURE__ */ k.jsx(
    Sm,
    {
      enableEditAddress: !0,
      openByDefault: !0,
      onChange: i.onChange,
      ...n
    }
  );
}, Sm = ({
  labelText: e,
  address: n,
  orderId: r,
  shopifyId: i,
  shippingCountryCodes: a,
  enableEditAddress: o,
  icon: s = "home",
  onChange: l,
  refetchOrders: d,
  openByDefault: m = !1
}) => {
  const [u, f] = se(!1), [h, v] = se(m), { isCopied: C, copy: S } = ro(), { track: j } = bn(), F = 14, y = o && (!!r || !!l), q = [n?.zip || "", n?.city || ""].filter(Boolean).join(" "), T = [n?.firstName || "", n?.lastName || ""].filter(Boolean).join(" "), E = n?.countryCodeV2 && n0(n.countryCodeV2), D = tt(() => [
    T,
    n?.company,
    n?.address1,
    n?.address2,
    q,
    n?.province,
    E
  ].filter(Boolean).join(`
`), [n, T, q, E]);
  if (!n)
    return null;
  const B = () => {
    i && r && j("shopify:order:edit:shipping:address:modal:opened", {
      shopifyId: i,
      orderId: r
    }), f(!0);
  };
  return /* @__PURE__ */ k.jsxs(k.Fragment, { children: [
    /* @__PURE__ */ k.jsxs(b, { justifyContent: "space-between", children: [
      /* @__PURE__ */ k.jsxs(b, { gap: "250", flexDirection: "row", children: [
        /* @__PURE__ */ k.jsx(me, { size: F, name: s, color: "green.500" }),
        /* @__PURE__ */ k.jsxs(b, { gap: "200", flexDirection: "column", children: [
          /* @__PURE__ */ k.jsxs(
            b,
            {
              gap: "100",
              flexDirection: "row",
              onClick: () => v(!h),
              className: Du.clickableIcon,
              alignItems: "center",
              children: [
                /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "3", children: e }),
                /* @__PURE__ */ k.jsx(
                  me,
                  {
                    size: F,
                    name: h ? "angle-down" : "angle-right"
                  }
                )
              ]
            }
          ),
          h && /* @__PURE__ */ k.jsxs(b, { gap: "100", flexDirection: "column", children: [
            T && /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "4", children: T }),
            n?.company && /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "4", children: n.company }),
            n?.address1 && /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "4", children: n.address1 }),
            n?.address2 && /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "4", children: n.address2 }),
            q && /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "4", children: q }),
            n?.province && /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "4", children: n.province }),
            E && /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "4", children: E })
          ] })
        ] })
      ] }),
      /* @__PURE__ */ k.jsxs(b, { gap: "250", flexDirection: "row", children: [
        y && /* @__PURE__ */ k.jsx(Ge, { content: `Edit ${e.toLowerCase()}`, children: /* @__PURE__ */ k.jsx(
          me,
          {
            size: F,
            name: "pen",
            onClick: () => B(),
            className: Du.clickableIcon
          }
        ) }),
        /* @__PURE__ */ k.jsx(Ge, { content: `Copy ${e.toLowerCase()}`, children: /* @__PURE__ */ k.jsx(
          me,
          {
            size: F,
            name: C ? "done" : "copy",
            onClick: () => S(D()),
            className: Du.clickableIcon
          }
        ) })
      ] })
    ] }),
    y && /* @__PURE__ */ k.jsx(
      Dz,
      {
        title: `Edit ${e}`,
        address: n,
        isOpen: u,
        setIsOpen: f,
        orderId: r,
        shopifyId: i,
        shippingCountryCodes: a,
        onChange: l,
        refetchOrders: d
      }
    )
  ] });
}, zp = ({
  withAddresses: e = !0,
  selectedProductIds: n
}) => {
  const r = Or(), i = es({ control: r.control, name: "lineItems" }), a = es({
    control: r.control,
    name: "billingAddress"
  }), o = es({
    control: r.control,
    name: "shippingAddress"
  }), s = Bn(() => n ? n.length === 0 ? [] : (i || []).filter(
    (m) => n.includes(m.id)
  ) : i, [i, n]), l = Bn(() => !s || s.length === 0 ? 0 : s.reduce((m, u) => {
    const f = u.priceRangeV2?.minVariantPrice?.amount || 0, h = u.quantity || 0;
    return m + f * h;
  }, 0), [s]), d = s?.[0]?.priceRangeV2?.minVariantPrice?.currencyCode || "";
  return /* @__PURE__ */ k.jsxs(b, { flexDirection: "column", gap: "300", children: [
    e && /* @__PURE__ */ k.jsxs(k.Fragment, { children: [
      /* @__PURE__ */ k.jsxs(A.Paragraph, { variant: "3", children: [
        a?.firstName,
        " ",
        a?.lastName
      ] }),
      /* @__PURE__ */ k.jsx(
        Lk,
        {
          formFieldName: "billingAddress",
          address: a,
          labelText: "Billing address",
          shippingCountryCodes: [],
          refetchOrders: () => Promise.resolve({})
        }
      ),
      /* @__PURE__ */ k.jsx(
        Lk,
        {
          formFieldName: "shippingAddress",
          address: o,
          labelText: "Shipping address",
          shippingCountryCodes: [],
          icon: "map-pin",
          refetchOrders: () => Promise.resolve({})
        }
      )
    ] }),
    /* @__PURE__ */ k.jsxs(b, { justifyContent: "space-between", children: [
      /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "4", children: "Subtotal" }),
      /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "4", children: `${l.toFixed(2)} ${d}` })
    ] }),
    /* @__PURE__ */ k.jsx(A.Paragraph, { color: "tertiary", variant: "5", children: "Tax and shipping will be calculated by Shopify based on customer address and store settings." })
  ] });
}, Oz = "_productTableHeader_6h6pl_1", Pz = "_productImage_6h6pl_5", Wa = {
  productTableHeader: Oz,
  productImage: Pz
}, Up = (e) => e.media?.nodes?.[0]?.preview?.image?.url || null, Az = ({
  product: e,
  index: n,
  onRemove: r
}) => {
  const i = Or(), a = e.priceRangeV2.minVariantPrice.amount, o = e.priceRangeV2.minVariantPrice.currencyCode, s = `lineItems.${n}.quantity`, l = i.watch(s), d = Up(e);
  return /* @__PURE__ */ k.jsxs(Jn.Tr, { children: [
    /* @__PURE__ */ k.jsx(Jn.Td, { children: /* @__PURE__ */ k.jsxs(b, { gap: "200", alignItems: "center", children: [
      d && /* @__PURE__ */ k.jsx(
        Wi,
        {
          src: d,
          alt: e.title,
          className: Wa.productImage
        }
      ),
      /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "4", children: e.title })
    ] }) }),
    /* @__PURE__ */ k.jsx(Jn.Td, { children: /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "4", children: e.totalInventory }) }),
    /* @__PURE__ */ k.jsx(Jn.Td, { children: /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "4", children: `${a} ${o}` }) }),
    /* @__PURE__ */ k.jsx(Jn.Td, { children: /* @__PURE__ */ k.jsx(
      gt,
      {
        noLabel: !0,
        noAlert: !0,
        name: s,
        control: i.control,
        componentProps: {
          type: "number",
          min: 1,
          max: e.totalInventory,
          tabIndex: 0
        }
      },
      `${s}-${l}`
    ) }),
    /* @__PURE__ */ k.jsx(Jn.Td, { children: /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "4", children: `${a * l} ${o}` }) }),
    /* @__PURE__ */ k.jsx(Jn.Td, { children: /* @__PURE__ */ k.jsx(b, { justifyContent: "flex-end", children: /* @__PURE__ */ k.jsx(Qt, { icon: "trash", variant: "secondary", onClick: r }) }) })
  ] });
}, Lz = 300, Ea = 2, Vz = 25, zz = ({
  onProductSelected: e
}) => {
  const { useLazyQuery: n, showNotification: r } = mn(), [i, a] = se(""), [o, s] = se([]), l = Or(), d = l.watch("selectedProductId"), [m, { loading: u, networkStatus: f }] = n(Lp, {
    fetchPolicy: "no-cache",
    notifyOnNetworkStatusChange: !0,
    onCompleted: (S) => {
      const j = S?.Shopify?.products?.nodes || [];
      s(
        j.filter((F) => !!F).sort((F, y) => F.title.localeCompare(y.title))
      );
    },
    onError: () => {
      s([]), r({
        title: "Something went wrong",
        text: "Could not search for products. Please try again.",
        icon: "exclamation-triangle-filled",
        severity: "warning"
      });
    }
  });
  ki(
    () => {
      i.trim().length >= Ea && !u && f === Yt.ready ? m({
        variables: {
          query: i.trim(),
          productCount: Vz,
          mediaCount: 1
        }
      }) : i.trim().length < Ea && s([]);
    },
    Lz,
    [i]
  ), He(() => {
    if (!d) return;
    const S = o.find(
      (j) => j.id === d
    );
    S && e(S), l.setValue("selectedProductId", void 0);
  }, [d, o, l, e]);
  const h = u && f !== Yt.ready, v = i.trim().length >= Ea, C = !o.length && !h && v;
  return /* @__PURE__ */ k.jsx(
    xr,
    {
      noAlert: !0,
      label: "Product selection",
      control: l.control,
      name: "selectedProductId",
      componentProps: {
        placeholder: `Search products (min. ${Ea} characters)`,
        tabIndex: 0,
        getItemTitleByValue: (S) => {
          const j = o.find(
            (F) => F.id === S
          );
          return j ? /* @__PURE__ */ k.jsx(A.Paragraph, { children: j.title }) : null;
        },
        filter: {
          value: i,
          onChange: (S) => {
            a(S.target.value);
          }
        },
        onToggleDropdown: (S) => {
          !S && i !== "" && a("");
        }
      },
      children: /* @__PURE__ */ k.jsxs(k.Fragment, { children: [
        h && /* @__PURE__ */ k.jsx(st.Item, { noFixedSelectionStateSpace: !0, children: /* @__PURE__ */ k.jsx(b, { justifyContent: "center", padding: "300", children: /* @__PURE__ */ k.jsx(cn, {}) }) }),
        !h && o.map((S) => {
          const j = S.totalInventory <= 0, F = Up(S);
          return /* @__PURE__ */ k.jsx(
            st.Item,
            {
              value: S.id,
              isDisabled: j,
              children: /* @__PURE__ */ k.jsxs(b, { justifyContent: "space-between", alignItems: "center", children: [
                /* @__PURE__ */ k.jsxs(b, { gap: "200", alignItems: "center", children: [
                  F && /* @__PURE__ */ k.jsx(
                    Wi,
                    {
                      src: F,
                      alt: S.title,
                      className: Wa.productImage
                    }
                  ),
                  i ? /* @__PURE__ */ k.jsx(
                    v0,
                    {
                      text: S.title,
                      highlight: i
                    }
                  ) : /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "4", children: S.title })
                ] }),
                /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "5", children: j ? "Out of stock" : `${S.totalInventory} in stock` })
              ] })
            },
            S.id
          );
        }),
        C && /* @__PURE__ */ k.jsx(st.Item, { noFixedSelectionStateSpace: !0, children: /* @__PURE__ */ k.jsx(
          us,
          {
            title: "No products found",
            description: "Try changing your search criteria."
          }
        ) }),
        !v && !h && /* @__PURE__ */ k.jsx(st.Item, { noFixedSelectionStateSpace: !0, children: /* @__PURE__ */ k.jsx(
          us,
          {
            title: "Search for products",
            description: `Type at least ${Ea} characters to search.`
          }
        ) })
      ] })
    }
  );
}, Mp = ({
  loading: e = !1,
  selectionMode: n = !1,
  hideDeleteButton: r = !1,
  hideProductSelect: i = !1,
  selectedProductIds: a = [],
  disabledProductIds: o = [],
  maxQuantities: s,
  onToggleSelect: l,
  onToggleSelectAll: d
}) => {
  const m = Or(), u = m.watch("lineItems"), f = !!u?.length, h = n && f ? u.filter(
    (j) => !o.includes(j?.id)
  ) : [], v = h.length > 0 && h.every(
    (j) => a.includes(j?.id)
  ), C = h.some(
    (j) => a.includes(j?.id)
  ) && !v, S = tt(
    (j) => {
      const F = m.getValues("lineItems"), y = F.findIndex(
        (q) => q?.id === j.id
      );
      if (y > -1) {
        const q = m.getValues(`lineItems.${y}.quantity`) || 0, T = [...F];
        T[y] = {
          ...T[y],
          quantity: q + 1
        }, m.setValue("lineItems", T);
      } else
        m.setValue("lineItems", [
          ...F,
          { ...j, quantity: 1 }
        ]);
    },
    [m]
  );
  return /* @__PURE__ */ k.jsxs(b, { gap: "200", flexDirection: "column", children: [
    !i && /* @__PURE__ */ k.jsx(zz, { onProductSelected: S }),
    !f && e && /* @__PURE__ */ k.jsx(
      b,
      {
        margin: "200 0",
        justifyContent: "center",
        padding: "300",
        className: Et.boxWrapper,
        children: /* @__PURE__ */ k.jsx(cn, {})
      }
    ),
    !f && !e && /* @__PURE__ */ k.jsx(
      b,
      {
        margin: "200 0",
        justifyContent: "center",
        className: Et.boxWrapper,
        children: /* @__PURE__ */ k.jsx(
          us,
          {
            title: "No products selected",
            description: "Select a product above for your new order"
          }
        )
      }
    ),
    f && /* @__PURE__ */ k.jsx(b, { margin: "300 0", children: /* @__PURE__ */ k.jsxs(
      Jn,
      {
        hoverable: !0,
        framed: !1,
        headerWithBackground: !1,
        className: Wa.productTable,
        children: [
          /* @__PURE__ */ k.jsx(Jn.Thead, { className: Wa.productTableHeader, children: /* @__PURE__ */ k.jsxs(Jn.Tr, { children: [
            n && /* @__PURE__ */ k.jsx(Jn.Th, { children: /* @__PURE__ */ k.jsx(
              tf,
              {
                checked: v,
                indeterminate: C,
                onChange: () => d?.(!v)
              }
            ) }),
            /* @__PURE__ */ k.jsx(Jn.Th, { children: "Product" }),
            /* @__PURE__ */ k.jsx(Jn.Th, { children: "In stock" }),
            /* @__PURE__ */ k.jsx(Jn.Th, { children: "Price" }),
            /* @__PURE__ */ k.jsx(Jn.Th, { children: "Quantity" }),
            /* @__PURE__ */ k.jsx(Jn.Th, { children: "Total" }),
            !r && /* @__PURE__ */ k.jsx(Jn.Th, {})
          ] }) }),
          /* @__PURE__ */ k.jsx(Jn.Tbody, { children: u?.map((j, F) => {
            if (!n)
              return /* @__PURE__ */ k.jsx(
                Az,
                {
                  product: j,
                  index: F,
                  onRemove: () => {
                    const U = u.filter(
                      (O, H) => H !== F
                    );
                    m.setValue("lineItems", U);
                  }
                },
                `${j?.id}-${F}`
              );
            const y = j, q = y.priceRangeV2.minVariantPrice.amount, T = y.priceRangeV2.minVariantPrice.currencyCode, E = `lineItems.${F}.quantity`, D = m.watch(E) || 0, B = q * D, ee = Up(y), J = a.includes(y.id), ae = o.includes(y.id), Q = s?.[y.id] ?? y.totalInventory;
            return /* @__PURE__ */ k.jsxs(
              Jn.Tr,
              {
                style: ae ? { opacity: 0.5 } : void 0,
                children: [
                  /* @__PURE__ */ k.jsx(Jn.Td, { children: /* @__PURE__ */ k.jsx(
                    tf,
                    {
                      checked: J,
                      disabled: ae,
                      onChange: () => l?.(y.id, !J)
                    }
                  ) }),
                  /* @__PURE__ */ k.jsx(Jn.Td, { children: /* @__PURE__ */ k.jsxs(b, { gap: "200", alignItems: "center", children: [
                    ee && /* @__PURE__ */ k.jsx(
                      Wi,
                      {
                        src: ee,
                        alt: y.title,
                        className: Wa.productImage
                      }
                    ),
                    /* @__PURE__ */ k.jsxs(b, { flexDirection: "column", children: [
                      /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "4", children: y.title }),
                      ae && /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "5", children: "Already refunded" })
                    ] })
                  ] }) }),
                  /* @__PURE__ */ k.jsx(Jn.Td, { children: /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "4", children: y.totalInventory }) }),
                  /* @__PURE__ */ k.jsx(Jn.Td, { children: /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "4", children: `${q} ${T}` }) }),
                  /* @__PURE__ */ k.jsx(Jn.Td, { children: /* @__PURE__ */ k.jsx(
                    gt,
                    {
                      noLabel: !0,
                      noAlert: !0,
                      disabled: ae || Q <= 1,
                      name: E,
                      control: m.control,
                      componentProps: {
                        type: "number",
                        min: 1,
                        max: Q,
                        tabIndex: 0
                      }
                    },
                    `${E}-${m.watch(E)}`
                  ) }),
                  /* @__PURE__ */ k.jsx(Jn.Td, { children: /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "4", children: `${B} ${T}` }) }),
                  !r && /* @__PURE__ */ k.jsx(Jn.Td, { children: /* @__PURE__ */ k.jsx(b, { justifyContent: "flex-end", children: /* @__PURE__ */ k.jsx(
                    Qt,
                    {
                      icon: "trash",
                      variant: "secondary",
                      onClick: () => {
                        const U = u.filter(
                          (O, H) => H !== F
                        );
                        m.setValue("lineItems", U), J && l?.(y.id, !1);
                      }
                    }
                  ) }) })
                ]
              },
              `${y.id}-${F}`
            );
          }) })
        ]
      }
    ) })
  ] });
}, lS = ({
  previousOrderStatus: e
} = {}) => {
  const n = Or();
  return /* @__PURE__ */ k.jsx(
    xr,
    {
      label: "Payment Status",
      name: "financialStatus",
      control: n.control,
      rules: {
        required: {
          value: !0,
          message: "Please select a payment status"
        }
      },
      componentProps: {
        placeholder: "Select payment status",
        tabIndex: 0,
        getItemTitleByValue: (r) => {
          const i = Dk.find(
            (a) => a.value === r
          );
          return i ? /* @__PURE__ */ k.jsxs(
            b,
            {
              flexDirection: "row",
              gap: "200",
              alignItems: "center",
              margin: "0 0 100 0",
              children: [
                /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "4", children: i.label }),
                /* @__PURE__ */ k.jsxs(A.Paragraph, { variant: "5", color: "secondary", children: [
                  "(",
                  i.description,
                  ")"
                ] })
              ]
            }
          ) : null;
        }
      },
      children: Dk.map((r) => {
        const i = e && r.value === e;
        return /* @__PURE__ */ k.jsx(st.Item, { value: r.value, children: /* @__PURE__ */ k.jsxs(b, { flexDirection: "column", gap: "100", children: [
          /* @__PURE__ */ k.jsxs(b, { flexDirection: "row", gap: "200", alignItems: "center", children: [
            /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "4", children: r.label }),
            i && /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "5", color: "secondary", children: "(previous order status)" })
          ] }),
          /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "5", color: "secondary", children: r.description })
        ] }) }, r.value);
      })
    }
  );
}, cS = () => {
  const e = Or();
  return /* @__PURE__ */ k.jsx(
    xr,
    {
      label: "Fulfillment Status",
      helpIcon: {
        text: "Defaults to 'unfulfilled' if nothing is selected"
      },
      name: "fulfillmentStatus",
      control: e.control,
      componentProps: {
        clearable: !0,
        placeholder: "Select fulfillment status",
        tabIndex: 0,
        getItemTitleByValue: (n) => {
          const r = Rk.find(
            (i) => i.value === n
          );
          return r ? /* @__PURE__ */ k.jsxs(b, { gap: "200", alignItems: "center", margin: "0 0 100 0", children: [
            /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "4", children: r.label }),
            /* @__PURE__ */ k.jsxs(A.Paragraph, { variant: "5", color: "secondary", children: [
              "(",
              r.description,
              ")"
            ] })
          ] }) : null;
        }
      },
      children: Rk.map((n) => /* @__PURE__ */ k.jsx(st.Item, { value: n.value, children: /* @__PURE__ */ k.jsxs(b, { flexDirection: "column", gap: "100", children: [
        /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "4", children: n.label }),
        /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "5", color: "secondary", children: n.description })
      ] }) }, n.value))
    }
  );
}, Uz = "_modal_1mprq_1", Mz = {
  modal: Uz
}, Ru = "create-shopify-order-form", Bz = ({
  isOpen: e,
  shopifyCustomer: n,
  displayCreateDraftOrder: r,
  setIsOpen: i,
  refetchCustomerOrders: a
}) => {
  const { useMutation: o, showNotification: s } = mn(), { track: l } = bn(), [d, m] = se(!1), [
    u,
    f
  ] = se(!1), h = {
    firstName: n.defaultAddress?.firstName,
    lastName: n.defaultAddress?.lastName,
    address1: n.defaultAddress?.address1,
    address2: n.defaultAddress?.address2,
    city: n.defaultAddress?.city,
    zip: n.defaultAddress?.zip,
    countryCodeV2: n.defaultAddress?.countryCodeV2,
    phone: n.defaultAddress?.phone
  }, v = {
    selectedProductId: void 0,
    lineItems: [],
    customNote: "",
    tags: [],
    billingAddress: h,
    shippingAddress: h,
    financialStatus: Br.Pending,
    fulfillmentStatus: void 0
  }, [C, S] = se([]), j = Bt({
    mode: "all",
    defaultValues: v
  }), F = j.watch("lineItems").length > 0, y = () => {
    j.reset(v), S([]), i(!1);
  };
  He(() => {
    C.length > 0 && j.setValue("tags", C, { shouldDirty: !0 });
  }, [C, j]);
  const [q, { error: T }] = o(
    aS,
    {
      onError: () => {
        m(!1), s({
          title: "Something went wrong",
          text: "The order creation was not successful.",
          icon: "exclamation-triangle-filled",
          severity: "warning"
        }), l("shopify:order:create:failed"), y();
      },
      onCompleted: () => {
        a(), m(!1), s({
          title: "Success",
          text: "The tags change was successful.",
          icon: "check-circle-filled",
          severity: "success"
        }), l("shopify:order:create:succeeded"), y();
      }
    }
  ), [E, { error: D }] = o(
    QV,
    {
      onError: () => {
        f(!1), s({
          title: "Something went wrong",
          text: "The draft order creation was not successful.",
          icon: "exclamation-triangle-filled",
          severity: "warning"
        }), l("shopify:order:create:draft:failed"), y();
      },
      onCompleted: () => {
        a(), f(!1), s({
          title: "Success",
          text: "The draft order creation was successful.",
          icon: "check-circle-filled",
          severity: "success"
        }), l("shopify:order:create:draft:succeeded"), y();
      }
    }
  ), B = (J) => {
    const ae = J.lineItems.map((O) => ({
      productId: O.id,
      requiresShipping: !0,
      priceSet: {
        shopMoney: {
          amount: O.priceRangeV2.maxVariantPrice.amount,
          currencyCode: O.priceRangeV2.maxVariantPrice.currencyCode
        }
      },
      quantity: O.quantity
    }));
    m(!0);
    const Q = Oi(J?.billingAddress), U = Oi(
      J?.shippingAddress
    );
    q({
      variables: {
        order: {
          lineItems: ae,
          customer: {
            toAssociate: {
              id: n?.id
            }
          },
          note: J.customNote,
          tags: J.tags,
          financialStatus: J.financialStatus,
          fulfillmentStatus: J.fulfillmentStatus,
          shippingAddress: U,
          billingAddress: Q
        }
      }
    });
  }, ee = (J) => {
    const ae = J.lineItems.map((O) => ({
      title: O.title,
      requiresShipping: !0,
      originalUnitPriceWithCurrency: {
        amount: O.priceRangeV2.maxVariantPrice.amount,
        currencyCode: O.priceRangeV2.maxVariantPrice.currencyCode
      },
      quantity: O.quantity
    }));
    f(!0);
    const Q = Oi(J?.billingAddress), U = Oi(
      J?.shippingAddress
    );
    E({
      variables: {
        input: {
          email: n.defaultEmailAddress?.emailAddress,
          note: J.customNote,
          tags: J.tags,
          lineItems: ae,
          shippingAddress: U,
          billingAddress: Q
        }
      }
    });
  };
  return /* @__PURE__ */ k.jsxs(
    wt,
    {
      isOpen: e,
      onClose: y,
      className: Mz.modal,
      allowEscClose: !1,
      children: [
        /* @__PURE__ */ k.jsx(Ct, { title: "Create new order", onClose: y }),
        /* @__PURE__ */ k.jsxs(Ft, { children: [
          /* @__PURE__ */ k.jsx(ep, { ...j, children: /* @__PURE__ */ k.jsx("form", { id: Ru, children: /* @__PURE__ */ k.jsxs(vt, { children: [
            /* @__PURE__ */ k.jsx(ze, { children: /* @__PURE__ */ k.jsx(Mp, {}) }),
            /* @__PURE__ */ k.jsx(ze, { children: /* @__PURE__ */ k.jsx(
              zt,
              {
                name: "tags",
                render: ({ fieldState: { error: J } }) => /* @__PURE__ */ k.jsx(
                  En,
                  {
                    label: "Tags",
                    meta: {
                      error: J?.message
                    },
                    children: /* @__PURE__ */ k.jsx(
                      "div",
                      {
                        tabIndex: 0,
                        onKeyDown: (ae) => {
                          ae.key === "Enter" && (ae.preventDefault(), ae.stopPropagation());
                        },
                        children: /* @__PURE__ */ k.jsx(
                          Ds,
                          {
                            placeholder: "Type and hit enter to add tags",
                            selectedTags: C,
                            onChange: (ae) => {
                              S(ae);
                            }
                          },
                          `tags-input-${e}`
                        )
                      }
                    )
                  }
                )
              }
            ) }),
            /* @__PURE__ */ k.jsx(ze, { span: 4, children: /* @__PURE__ */ k.jsxs(b, { flexDirection: "column", gap: "300", children: [
              /* @__PURE__ */ k.jsx(lS, {}),
              /* @__PURE__ */ k.jsx(cS, {}),
              /* @__PURE__ */ k.jsx(
                gt,
                {
                  label: "Custom note",
                  name: "customNote",
                  componentProps: {
                    placeholder: "Enter custom note",
                    tabIndex: 0
                  }
                }
              )
            ] }) }),
            /* @__PURE__ */ k.jsx(ze, { span: 2, children: /* @__PURE__ */ k.jsx(En, { label: "Details", noAlert: !0, children: /* @__PURE__ */ k.jsx(
              b,
              {
                flexDirection: "column",
                gap: "200",
                justifyContent: "end",
                className: Et.boxWrapper,
                children: /* @__PURE__ */ k.jsx(zp, {})
              }
            ) }) })
          ] }) }) }),
          (T || D) && /* @__PURE__ */ k.jsx(Fn, { error: T || D })
        ] }),
        /* @__PURE__ */ k.jsx(
          Tt,
          {
            confirmProps: {
              type: "submit",
              form: Ru,
              disabled: !F || d,
              isLoading: d,
              loadingIndicator: /* @__PURE__ */ k.jsx(cn, { size: 16 }),
              tabIndex: 0
            },
            confirmName: "Create order",
            confirmOnClick: j.handleSubmit(B),
            ...r && {
              confirmSecondaryName: "Create draft order",
              confirmSecondaryOnClick: () => {
                j.handleSubmit(ee)();
              },
              confirmSecondaryProps: {
                type: "submit",
                form: Ru,
                disabled: !F || u,
                isLoading: u,
                loadingIndicator: /* @__PURE__ */ k.jsx(cn, { size: 16 }),
                tabIndex: 0
              }
            }
          }
        )
      ]
    }
  );
}, qz = "_modal_al73g_1", Hz = {
  modal: qz
}, Vk = [
  {
    label: "Customer",
    value: si.Customer,
    description: "The customer wanted to cancel the order."
  },
  {
    label: "Declined",
    value: si.Declined,
    description: "Payment was declined."
  },
  {
    label: "Fraud",
    value: si.Fraud,
    description: "The order was fraudulent."
  },
  {
    label: "Inventory",
    value: si.Inventory,
    description: "There was insufficient inventory."
  },
  {
    label: "Other",
    value: si.Other,
    description: "The order was canceled for an unlisted reason."
  },
  {
    label: "Staff",
    value: si.Staff,
    description: "Staff made an error."
  }
], Wz = ({
  orderId: e,
  isOpen: n,
  orderName: r,
  setIsOpen: i,
  isMutationLoading: a,
  setIsMutationLoading: o,
  refetchOrders: s
}) => {
  const { track: l } = bn(), { useMutation: d, showNotification: m } = mn(), [u, f] = se([]), h = u.length > 0, v = {
    orderId: e,
    reason: null,
    refundMethod: {
      originalPaymentMethodsRefund: !0
    },
    restock: !0,
    notifyCustomer: !1,
    staffNote: ""
  }, C = Bt({
    defaultValues: v
  }), [S, { error: j, reset: F }] = d(WV, {
    onError: () => {
      o(!1), m({
        title: "Something went wrong",
        text: "Could not cancel the order.",
        icon: "exclamation-triangle-filled",
        severity: "warning"
      }), i(!1);
    },
    onCompleted: async (T) => {
      const E = T.Shopify?.orderCancel?.orderCancelUserErrors || [];
      if (E.length > 0)
        o(!1), f(E), m({
          title: "Something went wrong",
          text: "Could not cancel the order.",
          icon: "exclamation-triangle-filled",
          severity: "warning"
        });
      else {
        const D = T.Shopify?.orderCancel?.job?.done;
        setTimeout(async () => {
          await s().finally(() => o(!1));
        }, D ? 0 : 4e3), m({
          title: "Success",
          text: `${D ? "The order got cancelled" : "The order is being cancelled. It might take some time until it is reflected in the order details."}`,
          icon: "check-circle-filled",
          severity: "success"
        }), l("shopify:order:cancelled"), i(!1);
      }
    }
  }), y = tt(
    (T) => {
      T.reason != null && (o(!0), S({
        variables: {
          orderId: T.orderId,
          reason: T.reason,
          refundMethod: T.refundMethod,
          restock: T.restock,
          notifyCustomer: T.notifyCustomer,
          staffNote: T.staffNote ?? ""
        }
      }));
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [e]
  ), q = () => {
    i(!1), F(), f([]), C.reset(v);
  };
  return /* @__PURE__ */ k.jsxs(wt, { isOpen: n, onClose: q, className: Hz.modal, children: [
    /* @__PURE__ */ k.jsx(Ct, { title: `Cancel order ${r}`, onClose: q }),
    /* @__PURE__ */ k.jsx(Ft, { children: /* @__PURE__ */ k.jsxs(vt, { children: [
      /* @__PURE__ */ k.jsx(ze, { children: /* @__PURE__ */ k.jsx(
        xr,
        {
          control: C.control,
          label: "Reason",
          name: "reason",
          rules: {
            required: {
              value: !0,
              message: "Please select a reason"
            }
          },
          componentProps: {
            placeholder: "Select a reason",
            equalityFn: (T, E) => T === E,
            getItemTitleByValue: (T) => {
              if (!T)
                return "";
              const E = Vk.find(
                (D) => D.value === T
              );
              return /* @__PURE__ */ k.jsxs(b, { flexDirection: "row", gap: "200", children: [
                /* @__PURE__ */ k.jsx(A.Heading, { variant: "heading-3", children: E.label }),
                /* @__PURE__ */ k.jsx(A.Paragraph, { color: "secondary", children: E.description })
              ] });
            }
          },
          children: Vk.map((T) => /* @__PURE__ */ k.jsx(st.Item, { value: T.value, children: /* @__PURE__ */ k.jsxs(b, { flexDirection: "row", gap: "200", children: [
            /* @__PURE__ */ k.jsx(A.Heading, { variant: "heading-3", children: T.label }),
            /* @__PURE__ */ k.jsx(A.Paragraph, { color: "secondary", children: T.description })
          ] }) }, T.value))
        }
      ) }),
      /* @__PURE__ */ k.jsx(ze, { children: /* @__PURE__ */ k.jsx(En, { label: "Refund order", children: /* @__PURE__ */ k.jsx(
        sr,
        {
          control: C.control,
          name: "refundMethod.originalPaymentMethodsRefund"
        }
      ) }) }),
      /* @__PURE__ */ k.jsx(ze, { children: /* @__PURE__ */ k.jsx(En, { label: "Restock items", children: /* @__PURE__ */ k.jsx(sr, { control: C.control, name: "restock" }) }) }),
      /* @__PURE__ */ k.jsx(ze, { children: /* @__PURE__ */ k.jsx(En, { label: "Notify the customer", children: /* @__PURE__ */ k.jsx(sr, { control: C.control, name: "notifyCustomer" }) }) }),
      /* @__PURE__ */ k.jsx(ze, { children: /* @__PURE__ */ k.jsx(
        gt,
        {
          name: "staffNote",
          label: "Staff note",
          control: C.control
        }
      ) }),
      h && /* @__PURE__ */ k.jsx(ze, { children: /* @__PURE__ */ k.jsx(b, { gap: "200", flexDirection: "column", children: u.map((T) => /* @__PURE__ */ k.jsxs(
        b,
        {
          flexDirection: "row",
          gap: "200",
          alignItems: "center",
          children: [
            /* @__PURE__ */ k.jsx(me, { name: "close-circle-filled", color: "red.500" }),
            /* @__PURE__ */ k.jsx(A.Heading, { variant: "heading-3", children: T.code }),
            /* @__PURE__ */ k.jsxs(A.Paragraph, { children: [
              "(",
              T.field?.join(","),
              ") ",
              T.message
            ] })
          ]
        },
        T.code
      )) }) })
    ] }) }),
    /* @__PURE__ */ k.jsx(
      Tt,
      {
        confirmProps: {
          disabled: !(C.formState.isValid && C.formState.isDirty),
          isLoading: a,
          loadingIndicator: /* @__PURE__ */ k.jsx(cn, { size: 16 })
        },
        confirmOnClick: C.handleSubmit(y),
        cancelOnClick: q,
        confirmName: j ? "Close" : "Cancel order",
        cancelName: j ? void 0 : "Cancel"
      }
    )
  ] });
}, Kz = ({
  orderId: e,
  orderName: n,
  refetchOrders: r,
  disabled: i
}) => {
  const [a, o] = se(!1), [s, l] = se(!1);
  return /* @__PURE__ */ k.jsxs(b, { width: "100%", children: [
    /* @__PURE__ */ k.jsx(
      Wn,
      {
        variant: "secondary",
        onClick: () => o(!0),
        isLoading: s,
        loadingIndicator: /* @__PURE__ */ k.jsx(cn, { size: 16 }),
        disabled: i,
        slotStart: /* @__PURE__ */ k.jsx(
          me,
          {
            size: 14,
            name: "close-circle-filled",
            color: "red.500"
          }
        ),
        className: Et.fullWidth,
        children: "Cancel"
      }
    ),
    /* @__PURE__ */ k.jsx(
      Wz,
      {
        orderId: e,
        orderName: n,
        isOpen: a,
        setIsOpen: o,
        isMutationLoading: s,
        setIsMutationLoading: l,
        refetchOrders: r
      }
    )
  ] });
}, Gz = "_modal_1mprq_1", Yz = {
  modal: Gz
}, Qz = ({
  order: e,
  orderName: n,
  isOpen: r,
  shopifyId: i,
  setIsOpen: a,
  refetchOrders: o
}) => {
  const { useMutation: s, showNotification: l, useQuery: d } = mn(), { track: m } = bn(), [u, f] = se(!1), [h, v] = se(e?.tags || []), C = "duplicate-shopify-order-form", S = (U) => ({
    firstName: U?.firstName,
    lastName: U?.lastName,
    company: U?.company,
    address1: U?.address1,
    address2: U?.address2,
    city: U?.city,
    provinceCode: U?.provinceCode,
    zip: U?.zip,
    countryCode: U?.countryCodeV2,
    phone: U?.phone
  }), j = {
    selectedProductId: void 0,
    lineItems: [],
    customNote: "",
    tags: e?.tags || [],
    billingAddress: S(
      e?.billingAddress ?? e?.shippingAddress
    ),
    shippingAddress: S(e?.shippingAddress),
    financialStatus: void 0,
    fulfillmentStatus: void 0
  }, F = Bt({
    mode: "all",
    defaultValues: j
  }), y = F.watch("lineItems").length > 0, q = Bn(
    () => (e?.lineItems || []).map((U) => U.product?.id).filter((U) => !!U),
    [e]
  ), T = Bn(
    () => sS(q),
    [q]
  ), {
    data: E,
    loading: D,
    error: B
  } = d(Lp, {
    skip: !T,
    variables: {
      query: T,
      productCount: q.length,
      mediaCount: 1
    }
  });
  He(() => {
    B && l({
      title: "Something went wrong",
      text: "Could not load products for this order.",
      icon: "exclamation-triangle-filled",
      severity: "warning"
    });
  }, [B, l]), He(() => {
    if (!r || D || !E || F.getValues("lineItems")?.length)
      return;
    const U = E?.Shopify?.products?.nodes || [], O = [];
    e?.lineItems?.forEach((H) => {
      const Z = U.find(
        (ye) => ye.id === H.product?.id
      );
      Z && O.push({
        ...Z,
        quantity: H.quantity || 1,
        sku: H.sku,
        discountedUnitPrice: H.discountedUnitPriceSet?.shopMoney
      });
    }), O.length > 0 && F.setValue("lineItems", O, { shouldDirty: !0 });
  }, [r, E, D, e, F]), He(() => {
    (h.length > 0 || (F.getValues("tags") || []).length > 0) && F.setValue("tags", h, { shouldDirty: !0 });
  }, [h, F]);
  const [ee, { error: J }] = s(
    aS,
    {
      onError: () => {
        f(!1), l({
          title: "Something went wrong",
          text: "The order duplication was not successful.",
          icon: "exclamation-triangle-filled",
          severity: "warning"
        }), m("shopify:order:duplicate:failed"), Q();
      },
      onCompleted: () => {
        o(), f(!1), l({
          title: "Success",
          text: "The order was duplicated successfully.",
          icon: "check-circle-filled",
          severity: "success"
        }), m("shopify:order:duplicate:succeeded"), Q();
      }
    }
  ), ae = (U) => {
    const O = U.lineItems.map((Z) => ({
      productId: Z.id,
      requiresShipping: !0,
      priceSet: {
        shopMoney: {
          amount: Z.discountedUnitPrice?.amount ?? Z.priceRangeV2.maxVariantPrice.amount,
          currencyCode: Z.discountedUnitPrice?.currencyCode ?? Z.priceRangeV2.maxVariantPrice.currencyCode
        }
      },
      quantity: Z.quantity,
      sku: Z.sku
    })), H = (e?.shippingLines ?? []).map(
      (Z) => ({
        title: Z.title,
        code: Z.code,
        source: Z.source,
        priceSet: {
          shopMoney: {
            amount: Z.discountedPriceSet?.shopMoney?.amount ?? "0.00",
            currencyCode: Z.discountedPriceSet?.shopMoney?.currencyCode ?? "USD"
          }
        }
      })
    );
    f(!0), ee({
      variables: {
        order: {
          customer: {
            toAssociate: {
              id: i
            }
          },
          lineItems: O,
          shippingLines: H,
          note: U.customNote,
          tags: U.tags,
          financialStatus: U.financialStatus,
          fulfillmentStatus: U.fulfillmentStatus,
          shippingAddress: Oi(U?.shippingAddress),
          billingAddress: Oi(U?.billingAddress)
        }
      }
    });
  }, Q = () => {
    F.reset(j), v(e?.tags || []), a(!1);
  };
  return /* @__PURE__ */ k.jsxs(
    wt,
    {
      isOpen: r,
      onClose: Q,
      className: Yz.modal,
      allowEscClose: !1,
      children: [
        /* @__PURE__ */ k.jsx(Ct, { title: `Duplicate order ${n}`, onClose: Q }),
        /* @__PURE__ */ k.jsxs(Ft, { children: [
          /* @__PURE__ */ k.jsx(ep, { ...F, children: /* @__PURE__ */ k.jsx("form", { id: C, children: /* @__PURE__ */ k.jsxs(vt, { children: [
            /* @__PURE__ */ k.jsx(ze, { children: /* @__PURE__ */ k.jsx(Mp, { loading: D }) }),
            /* @__PURE__ */ k.jsx(ze, { children: /* @__PURE__ */ k.jsx(
              zt,
              {
                name: "tags",
                render: ({ fieldState: { error: U } }) => /* @__PURE__ */ k.jsx(
                  En,
                  {
                    label: "Tags",
                    meta: {
                      error: U?.message
                    },
                    children: /* @__PURE__ */ k.jsx(
                      "div",
                      {
                        tabIndex: 0,
                        onKeyDown: (O) => {
                          O.key === "Enter" && (O.preventDefault(), O.stopPropagation());
                        },
                        children: /* @__PURE__ */ k.jsx(
                          Ds,
                          {
                            placeholder: "Type and hit enter to add tags",
                            selectedTags: h,
                            onChange: (O) => {
                              v(O);
                            }
                          },
                          `tags-input-${r}`
                        )
                      }
                    )
                  }
                )
              }
            ) }),
            /* @__PURE__ */ k.jsx(ze, { span: 4, children: /* @__PURE__ */ k.jsxs(b, { flexDirection: "column", gap: "300", children: [
              /* @__PURE__ */ k.jsx(
                lS,
                {
                  previousOrderStatus: e?.displayFinancialStatus
                }
              ),
              /* @__PURE__ */ k.jsx(cS, {}),
              /* @__PURE__ */ k.jsx(
                gt,
                {
                  label: "Custom note",
                  name: "customNote",
                  componentProps: {
                    placeholder: "Enter custom note",
                    tabIndex: 0
                  }
                }
              )
            ] }) }),
            /* @__PURE__ */ k.jsx(ze, { span: 2, children: /* @__PURE__ */ k.jsx(En, { label: "Details", noAlert: !0, children: /* @__PURE__ */ k.jsx(
              b,
              {
                flexDirection: "column",
                gap: "200",
                justifyContent: "end",
                className: Et.boxWrapper,
                children: /* @__PURE__ */ k.jsx(zp, {})
              }
            ) }) })
          ] }) }) }),
          J && /* @__PURE__ */ k.jsx(Fn, { error: J })
        ] }),
        /* @__PURE__ */ k.jsx(
          Tt,
          {
            confirmProps: {
              type: "submit",
              form: C,
              disabled: !y || u || D,
              isLoading: u || D,
              loadingIndicator: /* @__PURE__ */ k.jsx(cn, { size: 16 }),
              tabIndex: 0
            },
            confirmName: "Create order",
            confirmOnClick: F.handleSubmit(ae)
          }
        )
      ]
    }
  );
}, Jz = ({
  orderId: e,
  lineItems: n,
  refundedQuantities: r = {}
}) => {
  if (!n || n?.length === 0)
    return null;
  const i = Object.values(r).some(
    (a) => a > 0
  );
  return /* @__PURE__ */ k.jsxs(b, { gap: "100", flexDirection: "column", children: [
    /* @__PURE__ */ k.jsxs(b, { gap: "250", flexDirection: "row", children: [
      /* @__PURE__ */ k.jsx(me, { size: 14, name: "shopify", color: "green.500" }),
      /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "3", children: "Line items" })
    ] }),
    i && /* @__PURE__ */ k.jsx(
      b,
      {
        gap: "100",
        flexDirection: "row",
        margin: "200 0 0",
        justifyContent: "center",
        children: /* @__PURE__ */ k.jsx(An, { color: "red.500", children: "Order has refunded items" })
      }
    ),
    /* @__PURE__ */ k.jsx(Ke, { children: n.map(({ id: a, title: o, quantity: s, variantTitle: l, image: d }) => {
      const m = r[a], u = m > 0, f = m > 1 ? `Refunded (${m} items)` : "Refunded";
      return /* @__PURE__ */ k.jsx(
        Ke.Item,
        {
          contentLeft: /* @__PURE__ */ k.jsxs(b, { gap: "200", children: [
            /* @__PURE__ */ k.jsx(A.Paragraph, { children: s }),
            /* @__PURE__ */ k.jsx(A.Paragraph, { children: "×" })
          ] }),
          title: /* @__PURE__ */ k.jsxs(A.Paragraph, { variant: "4", children: [
            o,
            " ",
            l && `(${l})`,
            u && /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "3", color: "red.500", children: f })
          ] }),
          contentRight: d?.url && /* @__PURE__ */ k.jsx(Wi, { src: `${d?.url}&height=48`, alt: o })
        },
        `list-${e}-${a}`
      );
    }) })
  ] });
}, Xz = Os`
  mutation refuncLineItems($input: Shopify_RefundInput!) {
    Shopify {
      refundCreate(input: $input) {
        refund {
          id
          totalRefundedSet {
            presentmentMoney {
              amount
              currencyCode
            }
          }
        }
        userErrors {
          field
          message
        }
      }
    }
  }
`, Zz = (e) => {
  const n = [];
  return e.refunds.forEach((r) => {
    const i = r.refundLineItems.edges.filter(
      (a) => a.node.id !== null
    );
    i.length > 0 && n.push({
      ...r,
      refundLineItems: {
        ...r.refundLineItems,
        edges: i
      }
    });
  }), n;
}, dS = (e) => {
  const n = {}, r = Zz(e);
  return e.lineItems?.forEach((i) => {
    n[i.id] = 0;
  }), r.forEach((i) => {
    i.refundLineItems.edges.forEach((a) => {
      const o = a.node;
      if (o.id !== null) {
        const s = o.lineItem.id;
        n[s] += o.quantity;
      }
    });
  }), n;
}, e3 = "_modal_21e62_1", n3 = {
  modal: e3
}, zk = "partial-refund-shopify-order-form", t3 = ({
  order: e,
  orderName: n,
  isOpen: r,
  setIsOpen: i,
  refetchOrders: a
}) => {
  const { useMutation: o, showNotification: s } = mn(), { track: l } = bn(), { useQuery: d } = mn(), [m, u] = se(!1), [f, h] = se([]), v = Bn(
    () => e?.refunds ? dS(e) : {},
    [e]
  ), C = Bn(
    () => (e?.lineItems || []).filter((U) => (v[U.id] || 0) >= (U.quantity || 0)).map((U) => U.product?.id).filter((U) => !!U),
    [e, v]
  ), S = Bn(() => {
    const U = {};
    return (e?.lineItems || []).forEach((O) => {
      if (O.product?.id) {
        const H = v[O.id] || 0, Z = Math.max(
          0,
          (O.quantity || 0) - H
        );
        U[O.product.id] = Z;
      }
    }), U;
  }, [e, v]), j = Bn(
    () => (e?.lineItems || []).map((U) => U.product?.id).filter((U) => !!U),
    [e]
  ), F = Bn(
    () => sS(j),
    [j]
  ), {
    data: y,
    loading: q,
    error: T
  } = d(Lp, {
    skip: !F,
    variables: {
      query: F,
      productCount: j.length,
      mediaCount: 1
    }
  });
  He(() => {
    T && s({
      title: "Something went wrong",
      text: "Could not load products for this order.",
      icon: "exclamation-triangle-filled",
      severity: "warning"
    });
  }, [T, s]);
  const E = {
    selectedProductId: void 0,
    lineItems: [],
    customNote: ""
  }, D = Bt({
    mode: "all",
    defaultValues: E
  }), B = f.length > 0, [ee, { error: J }] = o(
    Xz,
    {
      onError: () => {
        s({
          title: "Something went wrong",
          text: "The partial refund was not successful.",
          icon: "exclamation-triangle-filled",
          severity: "warning"
        }), l("shopify:order:partial:refund:failed"), Q();
      },
      onCompleted: () => {
        a(), s({
          title: "Success",
          text: "The partial refund was created successfully.",
          icon: "check-circle-filled",
          severity: "success"
        }), l("shopify:order:partial:refund:succeeded"), Q();
      }
    }
  );
  He(() => {
    if (!r || q || !y || D.getValues("lineItems")?.length)
      return;
    const U = y?.Shopify?.products?.nodes || [], O = [];
    e?.lineItems?.forEach((H) => {
      const Z = U.find(
        (ye) => ye.id === H.product?.id
      );
      if (Z) {
        const ye = v[H.id] || 0, ce = (H.quantity || 1) - ye;
        O.push({
          ...Z,
          quantity: ce > 0 ? ce : H.quantity || 1
        });
      }
    }), O.length > 0 && (D.setValue("lineItems", O, { shouldDirty: !0 }), h([]));
  }, [
    r,
    y,
    q,
    e,
    D,
    v
  ]);
  const ae = (U) => {
    u(!0);
    const O = (U.lineItems || []).filter(
      (H) => f.includes(H.id)
    ).map((H) => {
      const Z = e?.lineItems?.find(
        (ue) => ue.product?.id === H.id
      ), ye = v[Z?.id || ""] || 0, ce = (Z?.quantity || 0) - ye, le = Math.max(
        0,
        Math.min(ce, H.quantity || 0)
      );
      return Z && le > 0 ? { lineItemId: Z.id, quantity: le } : void 0;
    }).filter((H) => !!H);
    ee({
      variables: {
        input: {
          orderId: e.id,
          refundLineItems: O,
          note: U.customNote || void 0,
          notify: !0
        }
      }
    });
  }, Q = () => {
    D.reset(E), u(!1), i(!1);
  };
  return /* @__PURE__ */ k.jsxs(wt, { isOpen: r, onClose: Q, className: n3.modal, children: [
    /* @__PURE__ */ k.jsx(Ct, { title: `Refund order ${n}`, onClose: Q }),
    /* @__PURE__ */ k.jsxs(Ft, { children: [
      /* @__PURE__ */ k.jsx(ep, { ...D, children: /* @__PURE__ */ k.jsx("form", { id: zk, children: /* @__PURE__ */ k.jsxs(vt, { children: [
        /* @__PURE__ */ k.jsx(ze, { children: /* @__PURE__ */ k.jsx(
          Mp,
          {
            loading: q,
            selectionMode: !0,
            hideDeleteButton: !0,
            hideProductSelect: !0,
            selectedProductIds: f,
            disabledProductIds: C,
            maxQuantities: S,
            onToggleSelect: (U, O) => {
              h((H) => O ? Array.from(/* @__PURE__ */ new Set([...H, U])) : H.filter((Z) => Z !== U));
            },
            onToggleSelectAll: (U) => {
              const O = (D.getValues("lineItems") || []).map((H) => H.id).filter((H) => !C.includes(H));
              h(U ? O : []);
            }
          }
        ) }),
        /* @__PURE__ */ k.jsx(ze, { span: 4, children: /* @__PURE__ */ k.jsx(b, { flexDirection: "column", gap: "300", children: /* @__PURE__ */ k.jsx(
          gt,
          {
            label: "Custom note",
            name: "customNote",
            componentProps: {
              placeholder: "Enter custom note (optional)",
              tabIndex: 0
            }
          }
        ) }) }),
        /* @__PURE__ */ k.jsx(ze, { span: 2, children: /* @__PURE__ */ k.jsx(En, { label: "Details", noAlert: !0, children: /* @__PURE__ */ k.jsx(
          b,
          {
            flexDirection: "column",
            gap: "200",
            justifyContent: "end",
            className: Et.boxWrapper,
            children: /* @__PURE__ */ k.jsx(
              zp,
              {
                withAddresses: !1,
                selectedProductIds: f
              }
            )
          }
        ) }) })
      ] }) }) }),
      J && /* @__PURE__ */ k.jsx(Fn, { error: J })
    ] }),
    /* @__PURE__ */ k.jsx(
      Tt,
      {
        confirmProps: {
          type: "submit",
          form: zk,
          disabled: !B || m || q,
          isLoading: m || q,
          loadingIndicator: /* @__PURE__ */ k.jsx(cn, { size: 16 }),
          tabIndex: 0
        },
        confirmName: "Refund selected",
        confirmOnClick: D.handleSubmit(ae)
      }
    )
  ] });
}, r3 = ({
  order: e,
  shopifyId: n,
  orderLink: r,
  refetchOrders: i
}) => {
  const { useMutation: a, showNotification: o, showModal: s } = mn(), { track: l } = bn(), { suggestedRefund: d, currencyCode: m, id: u, name: f } = e, h = parseFloat(String(d?.amount)), v = !isNaN(h) && h > 0, [C] = a(HV, {
    onError: (F) => {
      setTimeout(() => j(F), 500);
    },
    onCompleted: (F) => {
      const y = F.Shopify?.refundCreate?.userErrors;
      y && y.length > 0 ? j(
        new zb({
          graphQLErrors: y.map((q) => ({
            message: q.message
          }))
        })
      ) : (o({
        title: "Order refunded",
        text: `You refunded order ${f}`,
        icon: "check-circle-filled",
        severity: "success"
      }), i());
    }
  }), S = tt(() => {
    l("shopify:order:refund:requested", { shopifyId: n, orderId: u });
    const { amount: F, ...y } = d;
    s(v ? {
      headline: `Refund Order ${f}?`,
      children: /* @__PURE__ */ k.jsxs(A.Paragraph, { children: [
        "You are about to refund ",
        F,
        " ",
        m,
        " to the customer. Are you sure you want to refund the order?"
      ] }),
      confirmLabel: "Confirm order refund",
      confirmVariant: "primary",
      cancelLabel: "Cancel",
      cancelVariant: "secondary",
      onConfirm: () => {
        l("shopify:order:refund:confirmed", { shopifyId: n, orderId: u }), C({
          variables: {
            input: y
          }
        });
      },
      onCancel: () => l("shopify:order:refund:canceled", { shopifyId: n, orderId: u })
    } : {
      headline: `Refund Order ${f}`,
      children: /* @__PURE__ */ k.jsx(A.Paragraph, { children: "No refund can be issued because no payment has been captured for this order. The order's financial status is currently pending." }),
      confirmLabel: "Close",
      confirmVariant: "secondary",
      onConfirm: () => {
      }
    });
  }, [
    n,
    u,
    f,
    m,
    d,
    v,
    s,
    C,
    l
  ]), j = tt(
    (F) => {
      s({
        headline: "Something went wrong",
        text: "It looks like something went wrong when trying to refund the order. Please create the refund in Shopify directly.",
        confirmLabel: "Close",
        children: /* @__PURE__ */ k.jsxs(b, { flexDirection: "column", children: [
          /* @__PURE__ */ k.jsx(Fn, { error: F }),
          /* @__PURE__ */ k.jsx(
            jt,
            {
              variant: "secondary",
              style: {
                color: "var(--dixa-typography-color-link)",
                padding: "var(--dixa-size-spacer-100)"
              },
              navigate: () => window.open(r, "_blank")?.focus(),
              slotStart: /* @__PURE__ */ k.jsx(me, { name: "external-link" }),
              children: "View order in Shopify"
            }
          )
        ] }),
        onConfirm: () => {
        }
      });
    },
    [r]
  );
  return /* @__PURE__ */ k.jsx(b, { width: "100%", children: /* @__PURE__ */ k.jsx(
    Wn,
    {
      variant: "secondary",
      onClick: S,
      disabled: d?.refundLineItems?.length === 0 || !v,
      slotStart: /* @__PURE__ */ k.jsx(me, { size: 14, name: "undo" }),
      className: Et.fullWidth,
      children: "Full refund"
    }
  ) });
}, i3 = "_modal_al73g_1", a3 = {
  modal: i3
}, o3 = ({
  orderId: e,
  tags: n,
  isOpen: r,
  setIsOpen: i,
  refetchOrders: a
}) => {
  const { track: o } = bn(), { useMutation: s, showNotification: l } = mn(), [d, m] = se(n), [u, f] = se(!1), h = Bt({
    defaultValues: {
      tags: n
    }
  });
  He(() => {
    d && h.setValue("tags", d, { shouldDirty: !0 });
  }, [d]);
  const [v, { error: C, reset: S }] = s(KV, {
    onError: () => {
      f(!1), l({
        title: "Something went wrong",
        text: "The tags change was not successful.",
        icon: "exclamation-triangle-filled",
        severity: "warning"
      }), i(!1);
    },
    onCompleted: async () => {
      await a(), f(!1), l({
        title: "Success",
        text: "The tags change was successful.",
        icon: "check-circle-filled",
        severity: "success"
      }), o("shopify:order:tags:updated"), i(!1);
    }
  }), j = tt(
    (y) => {
      f(!0), v({
        variables: {
          input: {
            id: e,
            tags: y.tags
          }
        }
      }).then((q) => {
        const T = q.data?.Shopify?.orderUpdate?.order?.tags ?? y.tags;
        h.reset({ tags: T });
      });
    },
    [e, h, v]
  ), F = () => {
    i(!1), S();
  };
  return /* @__PURE__ */ k.jsxs(wt, { isOpen: r, onClose: F, className: a3.modal, children: [
    /* @__PURE__ */ k.jsx(Ct, { title: "Manage tags for order", onClose: F }),
    /* @__PURE__ */ k.jsxs(Ft, { children: [
      /* @__PURE__ */ k.jsx(vt, { children: /* @__PURE__ */ k.jsx(ze, { children: /* @__PURE__ */ k.jsx(
        zt,
        {
          control: h.control,
          name: "tags",
          render: ({ fieldState: { error: y } }) => /* @__PURE__ */ k.jsx(
            En,
            {
              label: "Tags",
              meta: {
                error: y?.message
              },
              children: /* @__PURE__ */ k.jsx(
                Ds,
                {
                  placeholder: "Add tags here",
                  selectedTags: n,
                  onChange: (q) => m(q)
                }
              )
            }
          )
        }
      ) }) }),
      C && /* @__PURE__ */ k.jsx(Fn, { error: C })
    ] }),
    /* @__PURE__ */ k.jsx(
      Tt,
      {
        confirmProps: {
          disabled: !(h.formState.isValid && h.formState.isDirty),
          isLoading: u,
          loadingIndicator: /* @__PURE__ */ k.jsx(cn, { size: 16 })
        },
        confirmOnClick: h.handleSubmit(j),
        cancelOnClick: F,
        confirmName: C ? "Close" : "Save",
        cancelName: C ? void 0 : "Cancel"
      }
    )
  ] });
}, s3 = "_editIcon_1dntr_1", l3 = {
  editIcon: s3
}, c3 = ({
  orderId: e,
  tags: n,
  refetchOrders: r
}) => {
  const [i, a] = se(!1), o = 14, s = n.length > 0;
  return /* @__PURE__ */ k.jsxs(k.Fragment, { children: [
    /* @__PURE__ */ k.jsxs(b, { justifyContent: "space-between", children: [
      /* @__PURE__ */ k.jsxs(b, { gap: "250", flexDirection: "row", children: [
        /* @__PURE__ */ k.jsx(me, { size: o, name: "tag", color: "green.500" }),
        /* @__PURE__ */ k.jsxs(b, { gap: "200", flexDirection: "column", children: [
          /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "3", children: "Tags" }),
          /* @__PURE__ */ k.jsxs(b, { gap: "100", flexDirection: "row", flexWrap: "wrap", children: [
            !s && /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "4", color: "tertiary", children: "No tags here yet" }),
            s && n.map((l, d) => /* @__PURE__ */ k.jsx(Pn, { size: "small", variant: "primary", children: l }, d))
          ] })
        ] })
      ] }),
      /* @__PURE__ */ k.jsx(b, { gap: "250", flexDirection: "row", children: /* @__PURE__ */ k.jsx(Ge, { content: "Edit tags", children: /* @__PURE__ */ k.jsx(
        me,
        {
          size: o,
          name: "pen",
          className: l3.editIcon,
          onClick: () => a(!0)
        }
      ) }) })
    ] }),
    /* @__PURE__ */ k.jsx(
      o3,
      {
        orderId: e,
        tags: n,
        isOpen: i,
        setIsOpen: a,
        refetchOrders: r
      }
    )
  ] });
}, d3 = "_icon_cddi1_1", u3 = "_link_cddi1_6", Uk = {
  icon: d3,
  link: u3
}, m3 = ({ trackingInfo: e }) => {
  const { isCopied: n, copy: r } = ro(), { company: i, number: a, url: o } = e;
  return /* @__PURE__ */ k.jsx(
    Ke.Item,
    {
      contentLeft: /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "3", children: a }),
      title: /* @__PURE__ */ k.jsx(
        A.ExternalLink,
        {
          href: o,
          target: "_blank",
          rel: "noreferrer",
          className: Uk.link,
          children: i
        }
      ),
      contentRight: a && /* @__PURE__ */ k.jsx(Ge, { content: "Copy tracking code", children: /* @__PURE__ */ k.jsx(
        me,
        {
          size: 14,
          name: n ? "done" : "copy",
          onClick: () => r(a.toString()),
          className: Uk.icon
        }
      ) })
    }
  );
}, p3 = ({
  trackingInfos: e
}) => !e || e?.length === 0 ? null : /* @__PURE__ */ k.jsxs(b, { gap: "200", flexDirection: "column", children: [
  /* @__PURE__ */ k.jsxs(b, { gap: "250", flexDirection: "row", children: [
    /* @__PURE__ */ k.jsx(me, { size: 14, name: "eye", color: "green.500" }),
    /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "3", children: "Tracking" })
  ] }),
  /* @__PURE__ */ k.jsx(Ke, { children: e.map((n) => /* @__PURE__ */ k.jsx(m3, { trackingInfo: n }, n.number)) })
] }), f3 = "_order_135ze_1", h3 = "_orderIsOpen_135ze_9", y3 = "_orderHeader_135ze_12", Ou = {
  order: f3,
  orderIsOpen: h3,
  orderHeader: y3
}, g3 = ({
  order: e,
  shopifyId: n,
  openByDefault: r,
  customerCountryCodes: i,
  enableEditShippingAddress: a,
  displayRefund: o,
  displayCancel: s,
  shopifyDomain: l,
  displayDuplicateOrder: d,
  displayPartialRefundOrder: m,
  refetchOrders: u
}) => {
  const { track: f } = bn(), [h, v] = se(!1), [C, S] = se(!1), [j, F] = se(r), {
    id: y,
    name: q,
    createdAt: T,
    status: E,
    currentTotalPriceSet: D,
    currencyCode: B,
    lineItems: ee,
    billingAddress: J,
    shippingAddress: ae,
    trackingInfos: Q,
    tags: U
  } = e, O = !!ae, H = Vp(y), Z = `https://${l}/admin/orders/${H ?? ""}`, ye = D?.shopMoney?.amount ?? 0, ce = E.includes("cancelled"), le = new Intl.NumberFormat(void 0, {
    style: "currency",
    currency: B
  }).format(ye), ue = e?.refunds ? dS(e) : {}, W = !!ee?.length && ee.every((ke) => (ue[ke.id] || 0) >= (ke.quantity || 0));
  return /* @__PURE__ */ k.jsxs(
    b,
    {
      className: rt(Ou.order, {
        [Ou.orderIsOpen]: j
      }),
      gap: "200",
      flexDirection: "column",
      children: [
        /* @__PURE__ */ k.jsxs(
          b,
          {
            justifyContent: "space-between",
            alignItems: "center",
            className: Ou.orderHeader,
            onClick: () => F(!j),
            children: [
              /* @__PURE__ */ k.jsxs(b, { gap: "100", flexDirection: "column", children: [
                T && /* @__PURE__ */ k.jsx(b, { alignItems: "center", children: /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "4", children: Ln(T).format(xm) }) }),
                /* @__PURE__ */ k.jsxs(A.Paragraph, { variant: "1", children: [
                  "Order ",
                  q
                ] })
              ] }),
              /* @__PURE__ */ k.jsx(
                Qt,
                {
                  variant: "tertiary",
                  icon: j ? "angle-down" : "angle-right"
                }
              )
            ]
          }
        ),
        j && /* @__PURE__ */ k.jsxs(b, { gap: "250", flexDirection: "column", margin: "200 0 0", children: [
          /* @__PURE__ */ k.jsxs(b, { gap: "250", flexDirection: "row", children: [
            /* @__PURE__ */ k.jsx(me, { size: 14, name: "activity", color: "green.500" }),
            /* @__PURE__ */ k.jsxs(b, { gap: "200", flexDirection: "column", children: [
              /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "3", children: "Order status" }),
              /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "4", children: E })
            ] })
          ] }),
          /* @__PURE__ */ k.jsxs(b, { gap: "250", flexDirection: "row", children: [
            /* @__PURE__ */ k.jsx(me, { size: 14, name: "chart-bar", color: "green.500" }),
            /* @__PURE__ */ k.jsxs(b, { gap: "200", flexDirection: "column", children: [
              /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "3", children: "Order value" }),
              /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "4", children: le })
            ] })
          ] }),
          /* @__PURE__ */ k.jsx(
            c3,
            {
              orderId: y,
              tags: U,
              refetchOrders: u
            }
          ),
          /* @__PURE__ */ k.jsx(
            Sm,
            {
              openByDefault: !O,
              labelText: "Billing address",
              address: J,
              shippingCountryCodes: i,
              refetchOrders: u
            }
          ),
          /* @__PURE__ */ k.jsx(
            Sm,
            {
              openByDefault: O,
              shopifyId: n,
              orderId: y,
              icon: "map-pin",
              labelText: "Shipping address",
              address: ae,
              shippingCountryCodes: i,
              enableEditAddress: a,
              refetchOrders: u
            }
          ),
          /* @__PURE__ */ k.jsx(
            Jz,
            {
              orderId: y,
              lineItems: ee,
              refundedQuantities: ue
            }
          ),
          /* @__PURE__ */ k.jsx(p3, { trackingInfos: Q }),
          (o || m) && /* @__PURE__ */ k.jsxs(b, { flexDirection: "row", gap: "200", children: [
            o && /* @__PURE__ */ k.jsx(
              r3,
              {
                order: e,
                shopifyId: n,
                refetchOrders: u,
                orderLink: Z
              }
            ),
            m && /* @__PURE__ */ k.jsx(b, { width: "100%", children: /* @__PURE__ */ k.jsx(
              Wn,
              {
                variant: "secondary",
                icon: "undo",
                onClick: () => S(!0),
                className: Et.fullWidth,
                disabled: ce || W,
                children: "Partial refund"
              }
            ) })
          ] }),
          (d || s) && /* @__PURE__ */ k.jsxs(b, { flexDirection: "row", gap: "200", children: [
            d && /* @__PURE__ */ k.jsx(b, { width: "100%", children: /* @__PURE__ */ k.jsx(
              Wn,
              {
                variant: "secondary",
                icon: "plus",
                onClick: () => v(!0),
                className: Et.fullWidth,
                children: "Duplicate"
              }
            ) }),
            s && /* @__PURE__ */ k.jsx(
              Kz,
              {
                orderId: y,
                orderName: q,
                disabled: ce,
                refetchOrders: u
              }
            )
          ] }),
          /* @__PURE__ */ k.jsx(
            jt,
            {
              variant: "secondary",
              style: {
                color: "var(--dixa-typography-color-link)",
                padding: "var(--dixa-size-spacer-100)"
              },
              navigate: () => window.open(Z, "_blank")?.focus(),
              slotStart: /* @__PURE__ */ k.jsx(me, { name: "external-link" }),
              onClick: () => f("shopify:view:order:clicked", {
                shopifyId: n,
                orderId: y
              }),
              children: "View order in Shopify"
            }
          )
        ] }),
        h && /* @__PURE__ */ k.jsx(
          Qz,
          {
            order: e,
            shopifyId: n,
            orderName: q,
            isOpen: h,
            setIsOpen: v,
            refetchOrders: u
          }
        ),
        C && /* @__PURE__ */ k.jsx(
          t3,
          {
            order: e,
            orderName: q,
            isOpen: C,
            setIsOpen: S,
            refetchOrders: () => {
              u();
            }
          }
        )
      ]
    }
  );
}, v3 = ({
  customerCountryCodes: e,
  shopifyDomain: n,
  displayRefund: r,
  displayCancel: i,
  displayCreateOrder: a,
  displayCreateDraftOrder: o,
  displayDuplicateOrder: s,
  displayPartialRefundOrder: l,
  enableEditShippingAddress: d,
  shopifyCustomer: m
}) => {
  const { track: u } = bn(), [f, h] = se([]), [v, C] = se(!1), S = Vp(m?.id), j = `https://${n}/admin/orders?customer_id=${S ?? ""}`, {
    getCustomerOrders: F,
    isCustomerOrdersLoading: y,
    customerOrdersError: q,
    customerOrders: T,
    refetchCustomerOrders: E
  } = XV();
  return He(() => {
    !y && S && F({
      variables: {
        query: `customer_id:${S}`
      }
    });
  }, [S]), He(() => {
    const D = T?.Shopify?.orders?.edges;
    D && h(Fz({ ordersData: D }));
  }, [T]), m ? q ? /* @__PURE__ */ k.jsx(Fn, { error: q }) : /* @__PURE__ */ k.jsxs(b, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ k.jsxs(b, { gap: "200", flexDirection: "row", alignItems: "center", children: [
      /* @__PURE__ */ k.jsx(A.Heading, { variant: "heading-3", children: "Customer orders" }),
      !y && /* @__PURE__ */ k.jsx(Pn, { variant: "success", size: "small", children: f.length })
    ] }),
    a && /* @__PURE__ */ k.jsx(
      Wn,
      {
        variant: "secondary",
        icon: "plus",
        onClick: () => C(!0),
        children: "Create new order"
      }
    ),
    /* @__PURE__ */ k.jsxs(b, { gap: "200", flexDirection: "column", children: [
      y && /* @__PURE__ */ k.jsx(b, { justifyContent: "center", margin: "300", children: /* @__PURE__ */ k.jsx(cn, {}) }),
      !y && f.length === 0 && /* @__PURE__ */ k.jsx(b, { justifyContent: "center", margin: "200 0 300 0", children: /* @__PURE__ */ k.jsx(A.Paragraph, { color: "tertiary", children: "No orders found" }) }),
      !y && f.length > 0 && /* @__PURE__ */ k.jsx(b, { gap: "200", flexDirection: "column", children: f.map((D, B) => /* @__PURE__ */ k.jsx(
        g3,
        {
          order: D,
          openByDefault: B === 0,
          shopifyId: m?.id,
          displayRefund: r,
          displayCancel: i,
          enableEditShippingAddress: d,
          customerCountryCodes: e,
          refetchOrders: E,
          shopifyDomain: n,
          displayDuplicateOrder: s,
          displayPartialRefundOrder: l
        },
        `${B}-${D.id}`
      )) }),
      /* @__PURE__ */ k.jsx(
        jt,
        {
          variant: "secondary",
          style: {
            color: "var(--dixa-typography-color-link)",
            padding: "var(--dixa-size-spacer-100)"
          },
          navigate: () => window.open(j, "_blank")?.focus(),
          slotStart: /* @__PURE__ */ k.jsx(me, { name: "external-link" }),
          onClick: () => u("shopify:view:all:orders:clicked", {
            shopifyId: m?.id
          }),
          children: "View all orders in Shopify"
        }
      )
    ] }),
    a && /* @__PURE__ */ k.jsx(
      Bz,
      {
        isOpen: v,
        setIsOpen: C,
        shopifyCustomer: m,
        refetchCustomerOrders: E,
        displayCreateDraftOrder: o
      }
    )
  ] }) : null;
}, k3 = ({
  totalOrders: e,
  amountSpent: n
}) => {
  const r = n?.amount ?? 0, i = n?.currencyCode ?? "", a = `${Number.parseFloat(r).toFixed(
    2
  )} ${i}`;
  return /* @__PURE__ */ k.jsx(k.Fragment, { children: /* @__PURE__ */ k.jsxs(b, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ k.jsx(A.Heading, { variant: "heading-3", children: "Orders overview" }),
    /* @__PURE__ */ k.jsxs(Ke, { className: Et.list, children: [
      /* @__PURE__ */ k.jsx(Ke.Text, { variant: "dense", className: Et.listItem, children: /* @__PURE__ */ k.jsxs(b, { justifyContent: "space-between", children: [
        /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "4", children: "Total orders" }),
        /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "4", children: e })
      ] }) }),
      /* @__PURE__ */ k.jsx(Ke.Text, { variant: "dense", className: Et.listItem, children: /* @__PURE__ */ k.jsxs(b, { justifyContent: "space-between", children: [
        /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "4", children: "Total revenue" }),
        /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "4", children: a })
      ] }) })
    ] })
  ] }) });
}, b3 = "_segmentName_1dkhk_1", _3 = {
  segmentName: b3
}, x3 = 100, Bo = 10, S3 = ({
  shopifyId: e
}) => {
  const { useQuery: n, useLazyQuery: r } = mn(), [i, a] = se([]), [o, s] = se(Bo), [l, d] = se(!1), m = Bn(
    () => i.filter((S) => S.isMember).length,
    [i]
  ), { loading: u, error: f } = n(
    UV,
    {
      skip: !e,
      variables: {
        first: x3
      },
      onCompleted: (S) => {
        const j = S?.Shopify?.segments?.edges;
        if (j && j.length > 0) {
          const F = j.map(({ node: y }) => ({
            ...y,
            isMember: !1
          })).sort((y, q) => y.name.localeCompare(q.name));
          a(F), h({
            variables: {
              customerId: e,
              segmentIds: F.map((y) => y.id)
            }
          });
        }
      }
    }
  ), [
    h,
    { loading: v, error: C }
  ] = r(MV, {
    onCompleted: (S) => {
      const j = S?.Shopify?.customerSegmentMembership?.memberships;
      if (j && j.length > 0) {
        const F = i.map((y) => {
          const q = j.find(
            (T) => T.segmentId === y.id
          );
          return {
            ...y,
            ...q?.isMember && { isMember: q.isMember }
          };
        }).sort(
          (y, q) => y.isMember === q.isMember ? 0 : y.isMember ? -1 : 1
        );
        a(F);
      }
    }
  });
  return He(() => {
    s(l ? i.length : Bo);
  }, [l]), e ? /* @__PURE__ */ k.jsxs(b, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ k.jsxs(b, { gap: "200", flexDirection: "row", alignItems: "center", children: [
      /* @__PURE__ */ k.jsx(A.Heading, { variant: "heading-3", children: "Segment membership" }),
      !u && /* @__PURE__ */ k.jsx(Pn, { variant: "success", size: "small", children: m })
    ] }),
    u && /* @__PURE__ */ k.jsx(b, { justifyContent: "center", margin: "300", children: /* @__PURE__ */ k.jsx(cn, {}) }),
    !u && i.length === 0 && /* @__PURE__ */ k.jsx(A.Paragraph, { color: "tertiary", margin: "200 0 300 0", align: "center", children: "No segments found" }),
    f && /* @__PURE__ */ k.jsx(Fn, { error: f }),
    C && /* @__PURE__ */ k.jsx(Fn, { error: C }),
    !u && i.length > 0 && /* @__PURE__ */ k.jsxs(Ke, { className: Et.list, children: [
      i.slice(0, o).map(({ id: S, name: j, isMember: F }) => /* @__PURE__ */ k.jsx(Ke.Text, { className: Et.listItem, children: /* @__PURE__ */ k.jsx(
        Ge,
        {
          content: `${F ? "Member of" : "Not a member of"} ${j}`,
          children: /* @__PURE__ */ k.jsxs(b, { justifyContent: "space-between", children: [
            /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "4", className: _3.segmentName, children: j }),
            v && /* @__PURE__ */ k.jsx(cn, { size: 12 }),
            !v && /* @__PURE__ */ k.jsx(b, { children: /* @__PURE__ */ k.jsx(
              me,
              {
                color: F ? "green.500" : "neutral.300",
                name: "shopify"
              }
            ) })
          ] })
        }
      ) }, S)),
      i.length > Bo && /* @__PURE__ */ k.jsx(b, { justifyContent: "center", margin: "200 0 0", children: /* @__PURE__ */ k.jsx(
        Wn,
        {
          variant: "secondary",
          onClick: () => d(!l),
          icon: l ? "angle-up" : "angle-down",
          children: l ? "Show less" : `Show ${i.length - Bo} more`
        }
      ) })
    ] })
  ] }) : null;
}, N3 = ({
  conversationContext: e,
  settings: n
}) => {
  const {
    isCustomerLoading: r,
    customerError: i,
    customerData: a,
    refetchCustomer: o,
    customerNetworkStatus: s
  } = JV({ conversationContext: e }), [l, d] = se(), [m, u] = se(
    []
  ), f = n.apiHostName, h = n.displayRefundOrder ?? !1, v = n.displayCancelOrder ?? !1, C = n.enableEditShippingAddress ?? !1, S = n.displayEmailMarketingConsent ?? !1, j = n.displayOrdersOverview ?? !1, F = n.displaySegmentMembership ?? !1, y = n.displayDiscountCodeCreation ?? !1, q = n.displayDiscountCodes ?? !1, T = n.displayCreateOrder ?? !1, E = n.displayDuplicateOrder ?? !1, D = n.displayCreateDraftOrder ?? !1, B = n.displayPartialRefundOrder ?? !1;
  if (He(() => {
    const ee = a?.Shopify?.customers?.edges[0]?.node;
    ee && !r ? (u(
      a?.Shopify?.shop?.countriesInShippingZones?.countryCodes || []
    ), d(ee)) : d(void 0);
  }, [a]), !r && i)
    return /* @__PURE__ */ k.jsx(Fn, { error: i, retry: o });
  if (!r && !i && !l) {
    const ee = `https://${f}/admin/customers?search=${e.customer?.name || ""}`;
    return /* @__PURE__ */ k.jsxs(
      b,
      {
        margin: "200 0 300",
        gap: "300",
        flexDirection: "column",
        "data-testid": "widget-customer-not-found",
        children: [
          /* @__PURE__ */ k.jsx(A.Paragraph, { color: "secondary", children: "We cannot find the customer in Shopify." }),
          /* @__PURE__ */ k.jsxs(b, { gap: "200", flexDirection: "column", children: [
            /* @__PURE__ */ k.jsx(
              oz,
              {
                refetchCustomer: o,
                conversationContext: e
              }
            ),
            /* @__PURE__ */ k.jsx(
              jt,
              {
                variant: "secondary",
                style: {
                  color: "var(--dixa-typography-color-link)",
                  padding: "var(--dixa-size-spacer-100)"
                },
                navigate: () => window.open(ee, "_blank")?.focus(),
                slotStart: /* @__PURE__ */ k.jsx(me, { name: "external-link" }),
                children: "Search customers in Shopify"
              }
            )
          ] })
        ]
      }
    );
  }
  return r && s !== Yt.refetch ? /* @__PURE__ */ k.jsx(b, { margin: "200 0 300", justifyContent: "center", children: /* @__PURE__ */ k.jsx(cn, {}) }) : /* @__PURE__ */ k.jsxs(
    b,
    {
      gap: "300",
      flexDirection: "column",
      margin: "200 0 300",
      "data-testid": "widget-wrapper",
      children: [
        /* @__PURE__ */ k.jsx(
          cz,
          {
            customer: l,
            shopifyDomain: f,
            refresh: o,
            loading: r,
            networkStatus: s
          }
        ),
        j && /* @__PURE__ */ k.jsx(
          k3,
          {
            totalOrders: l?.numberOfOrders,
            amountSpent: l?.amountSpent
          }
        ),
        F && /* @__PURE__ */ k.jsx(S3, { shopifyId: l?.id }),
        S && /* @__PURE__ */ k.jsx(Cz, { customer: l }),
        q && /* @__PURE__ */ k.jsx(
          wz,
          {
            displayDiscountCodeCreation: y
          }
        ),
        /* @__PURE__ */ k.jsx(
          v3,
          {
            shopifyCustomer: l,
            shopifyDomain: f,
            displayRefund: h,
            displayCancel: v,
            displayCreateOrder: T,
            displayCreateDraftOrder: D,
            enableEditShippingAddress: C,
            customerCountryCodes: m,
            displayDuplicateOrder: E,
            displayPartialRefundOrder: B
          }
        )
      ]
    }
  );
}, _t = [];
for (let e = 0; e < 256; ++e)
  _t.push((e + 256).toString(16).slice(1));
function j3(e, n = 0) {
  return (_t[e[n + 0]] + _t[e[n + 1]] + _t[e[n + 2]] + _t[e[n + 3]] + "-" + _t[e[n + 4]] + _t[e[n + 5]] + "-" + _t[e[n + 6]] + _t[e[n + 7]] + "-" + _t[e[n + 8]] + _t[e[n + 9]] + "-" + _t[e[n + 10]] + _t[e[n + 11]] + _t[e[n + 12]] + _t[e[n + 13]] + _t[e[n + 14]] + _t[e[n + 15]]).toLowerCase();
}
let Pu;
const w3 = new Uint8Array(16);
function C3() {
  if (!Pu) {
    if (typeof crypto > "u" || !crypto.getRandomValues)
      throw new Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");
    Pu = crypto.getRandomValues.bind(crypto);
  }
  return Pu(w3);
}
const F3 = typeof crypto < "u" && crypto.randomUUID && crypto.randomUUID.bind(crypto), Mk = { randomUUID: F3 };
function I3(e, n, r) {
  if (Mk.randomUUID && !e)
    return Mk.randomUUID();
  e = e || {};
  const i = e.random ?? e.rng?.() ?? C3();
  if (i.length < 16)
    throw new Error("Random bytes length must be >= 16");
  return i[6] = i[6] & 15 | 64, i[8] = i[8] & 63 | 128, j3(i);
}
(function() {
  try {
    if (typeof document < "u") {
      var e = document.createElement("style");
      e.appendChild(document.createTextNode("._pointer_ls8kj_48{cursor:pointer;color:var(--dixa-typography-color-secondary)}._list_ls8kj_53{padding:0;overflow-y:auto;max-height:230px;background:linear-gradient(var(--dixa-color-neutral-000) 33%,rgba(255,255,255,0)),linear-gradient(rgba(255,255,255,0),var(--dixa-color-neutral-000) 66%) 0 100%,radial-gradient(farthest-side at 50% 0,var(--dixa-color-neutral-200),rgba(0,0,0,0)),radial-gradient(farthest-side at 50% 100%,var(--dixa-color-neutral-200),rgba(0,0,0,0)) 0 100%;background-color:var(--dixa-color-neutral-000);background-repeat:no-repeat;background-attachment:local,local,scroll,scroll;background-size:100% var(--dixa-size-spacer-400),100% var(--dixa-size-spacer-400),100% var(--dixa-size-spacer-200),100% var(--dixa-size-spacer-200)}._listItem_ls8kj_63{cursor:pointer;background-color:transparent;padding:var(--dixa-size-spacer-100);border-bottom:var(--dixa-size-border-100) solid var(--dixa-color-neutral-200)}._listItem_ls8kj_63:last-child{border-bottom:none}._modalBody_1clhs_1{width:400px}._wrapper_1ge6c_1{border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-300);background-color:var(--dixa-color-neutral-100)}._textVariant_1ge6c_7{color:var(--dixa-typography-color-secondary);font-size:var(--dixa-typography-size-300)}._block_1ge6c_12{margin-bottom:var(--dixa-size-spacer-250)}._wrapper_yud4a_1{border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-300)}._list_yud4a_7{padding:0}._listItem_yud4a_11{padding:var(--dixa-size-spacer-100);border-bottom:var(--dixa-size-border-100) solid var(--dixa-color-neutral-200)}._listItemTooltip_yud4a_15{cursor:pointer}._listItemTimestamp_yud4a_18{font-size:var(--dixa-typography-size-200);color:var(--dixa-typography-color-tertiary)}._listItem_yud4a_11:last-child{border-bottom:none}._tagHover_kzbzk_1:hover{cursor:pointer;border-color:var(--dixa-color-neutral-400)}._channelUnsubscribed_kzbzk_6{color:var(--dixa-color-neutral-500)}._list_zu4s7_1{padding:var(--dixa-size-spacer-100)}._listItem_zu4s7_4{padding:var(--dixa-size-spacer-200) var(--dixa-size-spacer-100)}._listSum_zu4s7_7{margin-top:var(--dixa-size-spacer-200);border-top:var(--dixa-size-border-100) solid var(--dixa-color-neutral-400)}._transaction_1kr8d_1{border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-250)}._transaction_1kr8d_1:hover,._transactionIsOpen_1kr8d_9{border-color:var(--dixa-color-neutral-400)}._transactionHeader_1kr8d_12{cursor:pointer}._transactionHeaderSubLine_1kr8d_15{font-size:var(--dixa-typography-size-200);color:var(--dixa-typography-color-tertiary)}._transactionHeaderAlignItemRight_1kr8d_19{margin-left:auto;margin-right:var(--dixa-size-spacer-200)}._message_unsvt_48{border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-250)}._message_unsvt_48:hover,._messageIsOpen_unsvt_56{border-color:var(--dixa-color-neutral-400)}._messageHeader_unsvt_60{cursor:pointer}._messageText_unsvt_64{max-height:150px;overflow:scroll;padding:var(--dixa-size-spacer-100) var(--dixa-size-spacer-200);border:1px solid var(--dixa-color-neutral-200);border-radius:var(--dixa-size-border-radius-100);overflow:hidden;overflow-y:auto;overflow-x:auto}._messageText_unsvt_64::-webkit-scrollbar{width:7px;height:7px}._messageText_unsvt_64::-webkit-scrollbar-track{background-color:var(--dixa-color-neutral-200)}._messageText_unsvt_64::-webkit-scrollbar-thumb{background-color:var(--dixa-color-neutral-400);border-radius:5px}._buttonLink_unsvt_86{color:var(--dixa-typography-color-link)}._order_19t4p_1{border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-250)}._order_19t4p_1:hover,._orderIsOpen_19t4p_9{border-color:var(--dixa-color-neutral-400)}._orderHeader_19t4p_12{cursor:pointer}._orderIconColor_19t4p_15{color:var(--dixa-color-green-500)}._delivery_1m9nb_1{word-break:break-all}._deliveryCode_1m9nb_4{font-family:var(--dixa-typography-family-code);color:var(--dixa-typography-color-tertiary)}")), document.head.appendChild(e);
    }
  } catch (n) {
    console.error("vite-plugin-css-injected-by-js", n);
  }
})();
var Au = { exports: {} }, Ta = {}, Bk;
function E3() {
  if (Bk) return Ta;
  Bk = 1;
  var e = je, n = Symbol.for("react.element"), r = Symbol.for("react.fragment"), i = Object.prototype.hasOwnProperty, a = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, o = { key: !0, ref: !0, __self: !0, __source: !0 };
  function s(l, d, m) {
    var u, f = {}, h = null, v = null;
    m !== void 0 && (h = "" + m), d.key !== void 0 && (h = "" + d.key), d.ref !== void 0 && (v = d.ref);
    for (u in d) i.call(d, u) && !o.hasOwnProperty(u) && (f[u] = d[u]);
    if (l && l.defaultProps) for (u in d = l.defaultProps, d) f[u] === void 0 && (f[u] = d[u]);
    return { $$typeof: n, type: l, key: h, ref: v, props: f, _owner: a.current };
  }
  return Ta.Fragment = r, Ta.jsx = s, Ta.jsxs = s, Ta;
}
var qo = {}, qk;
function T3() {
  return qk || (qk = 1, process.env.NODE_ENV !== "production" && (function() {
    var e = je, n = Symbol.for("react.element"), r = Symbol.for("react.portal"), i = Symbol.for("react.fragment"), a = Symbol.for("react.strict_mode"), o = Symbol.for("react.profiler"), s = Symbol.for("react.provider"), l = Symbol.for("react.context"), d = Symbol.for("react.forward_ref"), m = Symbol.for("react.suspense"), u = Symbol.for("react.suspense_list"), f = Symbol.for("react.memo"), h = Symbol.for("react.lazy"), v = Symbol.for("react.offscreen"), C = Symbol.iterator, S = "@@iterator";
    function j(t) {
      if (t === null || typeof t != "object")
        return null;
      var c = C && t[C] || t[S];
      return typeof c == "function" ? c : null;
    }
    var F = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function y(t) {
      {
        for (var c = arguments.length, p = new Array(c > 1 ? c - 1 : 0), g = 1; g < c; g++)
          p[g - 1] = arguments[g];
        q("error", t, p);
      }
    }
    function q(t, c, p) {
      {
        var g = F.ReactDebugCurrentFrame, P = g.getStackAddendum();
        P !== "" && (c += "%s", p = p.concat([P]));
        var L = p.map(function(I) {
          return String(I);
        });
        L.unshift("Warning: " + c), Function.prototype.apply.call(console[t], console, L);
      }
    }
    var T = !1, E = !1, D = !1, B = !1, ee = !1, J;
    J = Symbol.for("react.module.reference");
    function ae(t) {
      return !!(typeof t == "string" || typeof t == "function" || t === i || t === o || ee || t === a || t === m || t === u || B || t === v || T || E || D || typeof t == "object" && t !== null && (t.$$typeof === h || t.$$typeof === f || t.$$typeof === s || t.$$typeof === l || t.$$typeof === d || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      t.$$typeof === J || t.getModuleId !== void 0));
    }
    function Q(t, c, p) {
      var g = t.displayName;
      if (g)
        return g;
      var P = c.displayName || c.name || "";
      return P !== "" ? p + "(" + P + ")" : p;
    }
    function U(t) {
      return t.displayName || "Context";
    }
    function O(t) {
      if (t == null)
        return null;
      if (typeof t.tag == "number" && y("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof t == "function")
        return t.displayName || t.name || null;
      if (typeof t == "string")
        return t;
      switch (t) {
        case i:
          return "Fragment";
        case r:
          return "Portal";
        case o:
          return "Profiler";
        case a:
          return "StrictMode";
        case m:
          return "Suspense";
        case u:
          return "SuspenseList";
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case l:
            var c = t;
            return U(c) + ".Consumer";
          case s:
            var p = t;
            return U(p._context) + ".Provider";
          case d:
            return Q(t, t.render, "ForwardRef");
          case f:
            var g = t.displayName || null;
            return g !== null ? g : O(t.type) || "Memo";
          case h: {
            var P = t, L = P._payload, I = P._init;
            try {
              return O(I(L));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var H = Object.assign, Z = 0, ye, ce, le, ue, W, ke, Ee;
    function K() {
    }
    K.__reactDisabledLog = !0;
    function qe() {
      {
        if (Z === 0) {
          ye = console.log, ce = console.info, le = console.warn, ue = console.error, W = console.group, ke = console.groupCollapsed, Ee = console.groupEnd;
          var t = {
            configurable: !0,
            enumerable: !0,
            value: K,
            writable: !0
          };
          Object.defineProperties(console, {
            info: t,
            log: t,
            warn: t,
            error: t,
            group: t,
            groupCollapsed: t,
            groupEnd: t
          });
        }
        Z++;
      }
    }
    function Be() {
      {
        if (Z--, Z === 0) {
          var t = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: H({}, t, {
              value: ye
            }),
            info: H({}, t, {
              value: ce
            }),
            warn: H({}, t, {
              value: le
            }),
            error: H({}, t, {
              value: ue
            }),
            group: H({}, t, {
              value: W
            }),
            groupCollapsed: H({}, t, {
              value: ke
            }),
            groupEnd: H({}, t, {
              value: Ee
            })
          });
        }
        Z < 0 && y("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var Pe = F.ReactCurrentDispatcher, Me;
    function Fe(t, c, p) {
      {
        if (Me === void 0)
          try {
            throw Error();
          } catch (P) {
            var g = P.stack.trim().match(/\n( *(at )?)/);
            Me = g && g[1] || "";
          }
        return `
` + Me + t;
      }
    }
    var Ae = !1, $e;
    {
      var tn = typeof WeakMap == "function" ? WeakMap : Map;
      $e = new tn();
    }
    function Ie(t, c) {
      if (!t || Ae)
        return "";
      {
        var p = $e.get(t);
        if (p !== void 0)
          return p;
      }
      var g;
      Ae = !0;
      var P = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var L;
      L = Pe.current, Pe.current = null, qe();
      try {
        if (c) {
          var I = function() {
            throw Error();
          };
          if (Object.defineProperty(I.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(I, []);
            } catch (ne) {
              g = ne;
            }
            Reflect.construct(t, [], I);
          } else {
            try {
              I.call();
            } catch (ne) {
              g = ne;
            }
            t.call(I.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (ne) {
            g = ne;
          }
          t();
        }
      } catch (ne) {
        if (ne && g && typeof ne.stack == "string") {
          for (var N = ne.stack.split(`
`), te = g.stack.split(`
`), x = N.length - 1, V = te.length - 1; x >= 1 && V >= 0 && N[x] !== te[V]; )
            V--;
          for (; x >= 1 && V >= 0; x--, V--)
            if (N[x] !== te[V]) {
              if (x !== 1 || V !== 1)
                do
                  if (x--, V--, V < 0 || N[x] !== te[V]) {
                    var X = `
` + N[x].replace(" at new ", " at ");
                    return t.displayName && X.includes("<anonymous>") && (X = X.replace("<anonymous>", t.displayName)), typeof t == "function" && $e.set(t, X), X;
                  }
                while (x >= 1 && V >= 0);
              break;
            }
        }
      } finally {
        Ae = !1, Pe.current = L, Be(), Error.prepareStackTrace = P;
      }
      var we = t ? t.displayName || t.name : "", Se = we ? Fe(we) : "";
      return typeof t == "function" && $e.set(t, Se), Se;
    }
    function We(t, c, p) {
      return Ie(t, !1);
    }
    function Ze(t) {
      var c = t.prototype;
      return !!(c && c.isReactComponent);
    }
    function de(t, c, p) {
      if (t == null)
        return "";
      if (typeof t == "function")
        return Ie(t, Ze(t));
      if (typeof t == "string")
        return Fe(t);
      switch (t) {
        case m:
          return Fe("Suspense");
        case u:
          return Fe("SuspenseList");
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case d:
            return We(t.render);
          case f:
            return de(t.type, c, p);
          case h: {
            var g = t, P = g._payload, L = g._init;
            try {
              return de(L(P), c, p);
            } catch {
            }
          }
        }
      return "";
    }
    var fe = Object.prototype.hasOwnProperty, Te = {}, Le = F.ReactDebugCurrentFrame;
    function Re(t) {
      if (t) {
        var c = t._owner, p = de(t.type, t._source, c ? c.type : null);
        Le.setExtraStackFrame(p);
      } else
        Le.setExtraStackFrame(null);
    }
    function sn(t, c, p, g, P) {
      {
        var L = Function.call.bind(fe);
        for (var I in t)
          if (L(t, I)) {
            var N = void 0;
            try {
              if (typeof t[I] != "function") {
                var te = Error((g || "React class") + ": " + p + " type `" + I + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof t[I] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw te.name = "Invariant Violation", te;
              }
              N = t[I](c, I, g, p, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (x) {
              N = x;
            }
            N && !(N instanceof Error) && (Re(P), y("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", g || "React class", p, I, typeof N), Re(null)), N instanceof Error && !(N.message in Te) && (Te[N.message] = !0, Re(P), y("Failed %s type: %s", p, N.message), Re(null));
          }
      }
    }
    var w = Array.isArray;
    function _(t) {
      return w(t);
    }
    function $(t) {
      {
        var c = typeof Symbol == "function" && Symbol.toStringTag, p = c && t[Symbol.toStringTag] || t.constructor.name || "Object";
        return p;
      }
    }
    function G(t) {
      try {
        return Y(t), !1;
      } catch {
        return !0;
      }
    }
    function Y(t) {
      return "" + t;
    }
    function R(t) {
      if (G(t))
        return y("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", $(t)), Y(t);
    }
    var z = F.ReactCurrentOwner, ie = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, pe, _e;
    function en(t) {
      if (fe.call(t, "ref")) {
        var c = Object.getOwnPropertyDescriptor(t, "ref").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.ref !== void 0;
    }
    function un(t) {
      if (fe.call(t, "key")) {
        var c = Object.getOwnPropertyDescriptor(t, "key").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.key !== void 0;
    }
    function rn(t, c) {
      typeof t.ref == "string" && z.current;
    }
    function dn(t, c) {
      {
        var p = function() {
          pe || (pe = !0, y("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "key", {
          get: p,
          configurable: !0
        });
      }
    }
    function pn(t, c) {
      {
        var p = function() {
          _e || (_e = !0, y("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "ref", {
          get: p,
          configurable: !0
        });
      }
    }
    var ln = function(t, c, p, g, P, L, I) {
      var N = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: n,
        // Built-in properties that belong on the element
        type: t,
        key: c,
        ref: p,
        props: I,
        // Record the component responsible for creating this element.
        _owner: L
      };
      return N._store = {}, Object.defineProperty(N._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(N, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: g
      }), Object.defineProperty(N, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: P
      }), Object.freeze && (Object.freeze(N.props), Object.freeze(N)), N;
    };
    function kn(t, c, p, g, P) {
      {
        var L, I = {}, N = null, te = null;
        p !== void 0 && (R(p), N = "" + p), un(c) && (R(c.key), N = "" + c.key), en(c) && (te = c.ref, rn(c));
        for (L in c)
          fe.call(c, L) && !ie.hasOwnProperty(L) && (I[L] = c[L]);
        if (t && t.defaultProps) {
          var x = t.defaultProps;
          for (L in x)
            I[L] === void 0 && (I[L] = x[L]);
        }
        if (N || te) {
          var V = typeof t == "function" ? t.displayName || t.name || "Unknown" : t;
          N && dn(I, V), te && pn(I, V);
        }
        return ln(t, N, te, P, g, z.current, I);
      }
    }
    var Xe = F.ReactCurrentOwner, Sn = F.ReactDebugCurrentFrame;
    function Oe(t) {
      if (t) {
        var c = t._owner, p = de(t.type, t._source, c ? c.type : null);
        Sn.setExtraStackFrame(p);
      } else
        Sn.setExtraStackFrame(null);
    }
    var an;
    an = !1;
    function on(t) {
      return typeof t == "object" && t !== null && t.$$typeof === n;
    }
    function yn() {
      {
        if (Xe.current) {
          var t = O(Xe.current.type);
          if (t)
            return `

Check the render method of \`` + t + "`.";
        }
        return "";
      }
    }
    function qn(t) {
      return "";
    }
    var Nn = {};
    function gn(t) {
      {
        var c = yn();
        if (!c) {
          var p = typeof t == "string" ? t : t.displayName || t.name;
          p && (c = `

Check the top-level render call using <` + p + ">.");
        }
        return c;
      }
    }
    function hn(t, c) {
      {
        if (!t._store || t._store.validated || t.key != null)
          return;
        t._store.validated = !0;
        var p = gn(c);
        if (Nn[p])
          return;
        Nn[p] = !0;
        var g = "";
        t && t._owner && t._owner !== Xe.current && (g = " It was passed a child from " + O(t._owner.type) + "."), Oe(t), y('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', p, g), Oe(null);
      }
    }
    function jn(t, c) {
      {
        if (typeof t != "object")
          return;
        if (_(t))
          for (var p = 0; p < t.length; p++) {
            var g = t[p];
            on(g) && hn(g, c);
          }
        else if (on(t))
          t._store && (t._store.validated = !0);
        else if (t) {
          var P = j(t);
          if (typeof P == "function" && P !== t.entries)
            for (var L = P.call(t), I; !(I = L.next()).done; )
              on(I.value) && hn(I.value, c);
        }
      }
    }
    function Un(t) {
      {
        var c = t.type;
        if (c == null || typeof c == "string")
          return;
        var p;
        if (typeof c == "function")
          p = c.propTypes;
        else if (typeof c == "object" && (c.$$typeof === d || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        c.$$typeof === f))
          p = c.propTypes;
        else
          return;
        if (p) {
          var g = O(c);
          sn(p, t.props, "prop", g, t);
        } else if (c.PropTypes !== void 0 && !an) {
          an = !0;
          var P = O(c);
          y("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", P || "Unknown");
        }
        typeof c.getDefaultProps == "function" && !c.getDefaultProps.isReactClassApproved && y("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function Vn(t) {
      {
        for (var c = Object.keys(t.props), p = 0; p < c.length; p++) {
          var g = c[p];
          if (g !== "children" && g !== "key") {
            Oe(t), y("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", g), Oe(null);
            break;
          }
        }
        t.ref !== null && (Oe(t), y("Invalid attribute `ref` supplied to `React.Fragment`."), Oe(null));
      }
    }
    var _n = {};
    function xn(t, c, p, g, P, L) {
      {
        var I = ae(t);
        if (!I) {
          var N = "";
          (t === void 0 || typeof t == "object" && t !== null && Object.keys(t).length === 0) && (N += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var te = qn();
          te ? N += te : N += yn();
          var x;
          t === null ? x = "null" : _(t) ? x = "array" : t !== void 0 && t.$$typeof === n ? (x = "<" + (O(t.type) || "Unknown") + " />", N = " Did you accidentally export a JSX literal instead of a component?") : x = typeof t, y("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", x, N);
        }
        var V = kn(t, c, p, P, L);
        if (V == null)
          return V;
        if (I) {
          var X = c.children;
          if (X !== void 0)
            if (g)
              if (_(X)) {
                for (var we = 0; we < X.length; we++)
                  jn(X[we], t);
                Object.freeze && Object.freeze(X);
              } else
                y("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              jn(X, t);
        }
        if (fe.call(c, "key")) {
          var Se = O(t), ne = Object.keys(c).filter(function(wn) {
            return wn !== "key";
          }), nn = ne.length > 0 ? "{key: someKey, " + ne.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!_n[Se + nn]) {
            var Tn = ne.length > 0 ? "{" + ne.join(": ..., ") + ": ...}" : "{}";
            y(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, nn, Se, Tn, Se), _n[Se + nn] = !0;
          }
        }
        return t === i ? Vn(V) : Un(V), V;
      }
    }
    function Hn(t, c, p) {
      return xn(t, c, p, !0);
    }
    function Dn(t, c, p) {
      return xn(t, c, p, !1);
    }
    var Rn = Dn, Mn = Hn;
    qo.Fragment = i, qo.jsx = Rn, qo.jsxs = Mn;
  })()), qo;
}
var Hk;
function $3() {
  return Hk || (Hk = 1, process.env.NODE_ENV === "production" ? Au.exports = E3() : Au.exports = T3()), Au.exports;
}
var M = $3(), uS = /* @__PURE__ */ ((e) => (e.Adjustment = "Adjustment", e.Automation = "Automation", e.BonusBalanceAdjustment = "BonusBalanceAdjustment", e.BonusPromotion = "BonusPromotion", e.BonusPromotionReturn = "BonusPromotionReturn", e.Manual = "Manual", e.PointTransactionCancellation = "PointTransactionCancellation", e.Purchase = "Purchase", e.ReceiptAdjustment = "ReceiptAdjustment", e.Return = "Return", e.RewardVoucher = "RewardVoucher", e.UpdateBalance = "UpdateBalance", e))(uS || {}), Nm = /* @__PURE__ */ ((e) => (e.Addition = "Addition", e.Cancellation = "Cancellation", e.Deduction = "Deduction", e.Expiry = "Expiry", e))(Nm || {});
const D3 = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "updatePreferences" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "contactId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Voyado_UUID" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "input" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Voyado_contactAttributes_Input" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Voyado" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "ContactsV_ContactPatch" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "contactId" }, value: { kind: "Variable", name: { kind: "Name", value: "contactId" } } }, { kind: "Argument", name: { kind: "Name", value: "input" }, value: { kind: "Variable", name: { kind: "Name", value: "input" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }] } }] } }] } }] }, R3 = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "updatePoints" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "input" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Voyado_AddPointTransactionRequestModel_Input" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Voyado" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "PointTransaction_AddPointTransacion" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "input" }, value: { kind: "Variable", name: { kind: "Name", value: "input" } } }] }] } }] } }] }, O3 = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getContactById" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "contactId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Voyado_UUID" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Voyado" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "ContactsV_GetContactById" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "contactId" }, value: { kind: "Variable", name: { kind: "Name", value: "contactId" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "attributes" } }, { kind: "Field", name: { kind: "Name", value: "meta" } }, { kind: "Field", name: { kind: "Name", value: "preferences" } }, { kind: "Field", name: { kind: "Name", value: "consents" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "date" } }, { kind: "Field", name: { kind: "Name", value: "value" } }, { kind: "Field", name: { kind: "Name", value: "source" } }, { kind: "Field", name: { kind: "Name", value: "comment" } }] } }] } }] } }] } }] }, P3 = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getContactOverviewById" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "contactId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Voyado" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "ContactOverview_GetContactOverviewAsync" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "contactId" }, value: { kind: "Variable", name: { kind: "Name", value: "contactId" } } }] }] } }] } }] }, A3 = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getContactId" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "email" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "mobilePhone" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Voyado" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "ContactOverview_GetContactIdAsync" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "email" }, value: { kind: "Variable", name: { kind: "Name", value: "email" } } }, { kind: "Argument", name: { kind: "Name", value: "mobilePhone" }, value: { kind: "Variable", name: { kind: "Name", value: "mobilePhone" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Voyado_ContactOverview_GetContactIdAsync_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Voyado_String_container" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "String" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Voyado_ApiExceptionMultipleMatchesResponse" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errorCode" } }, { kind: "Field", name: { kind: "Name", value: "message" } }, { kind: "Field", name: { kind: "Name", value: "requestId" } }, { kind: "Field", name: { kind: "Name", value: "messageDetails" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "multipleMatchesFound" } }] } }] } }] } }] } }] } }] } }] }, L3 = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getLatestMessagesByContactId" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "contactId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Voyado_UUID" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "count" } }, type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Voyado" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "ContactMessage_GetSmsMessagesByContactId" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "contactId" }, value: { kind: "Variable", name: { kind: "Name", value: "contactId" } } }, { kind: "Argument", name: { kind: "Name", value: "count" }, value: { kind: "Variable", name: { kind: "Name", value: "count" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Voyado_ListResultOfApiMessage" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "count" } }, { kind: "Field", name: { kind: "Name", value: "items" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "messageId" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "sendDateTime" } }, { kind: "Field", name: { kind: "Name", value: "type" } }, { kind: "Field", name: { kind: "Name", value: "source" } }, { kind: "Field", name: { kind: "Name", value: "isTransactional" } }, { kind: "Field", name: { kind: "Name", value: "status" } }, { kind: "Field", name: { kind: "Name", value: "messageLink" } }, { kind: "Field", name: { kind: "Name", value: "messageText" } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "ContactMessage_GetPostalMessagesByContactId" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "contactId" }, value: { kind: "Variable", name: { kind: "Name", value: "contactId" } } }, { kind: "Argument", name: { kind: "Name", value: "count" }, value: { kind: "Variable", name: { kind: "Name", value: "count" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Voyado_ListResultOfApiMessage" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "count" } }, { kind: "Field", name: { kind: "Name", value: "items" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "messageId" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "sendDateTime" } }, { kind: "Field", name: { kind: "Name", value: "type" } }, { kind: "Field", name: { kind: "Name", value: "source" } }, { kind: "Field", name: { kind: "Name", value: "isTransactional" } }, { kind: "Field", name: { kind: "Name", value: "status" } }, { kind: "Field", name: { kind: "Name", value: "messageLink" } }, { kind: "Field", name: { kind: "Name", value: "messageText" } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "ContactMessage_GetEmailMessagesByContactId" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "contactId" }, value: { kind: "Variable", name: { kind: "Name", value: "contactId" } } }, { kind: "Argument", name: { kind: "Name", value: "count" }, value: { kind: "Variable", name: { kind: "Name", value: "count" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Voyado_ListResultOfApiMessage" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "count" } }, { kind: "Field", name: { kind: "Name", value: "items" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "messageId" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "sendDateTime" } }, { kind: "Field", name: { kind: "Name", value: "type" } }, { kind: "Field", name: { kind: "Name", value: "source" } }, { kind: "Field", name: { kind: "Name", value: "isTransactional" } }, { kind: "Field", name: { kind: "Name", value: "status" } }, { kind: "Field", name: { kind: "Name", value: "messageLink" } }, { kind: "Field", name: { kind: "Name", value: "messageText" } }] } }] } }] } }] } }] } }] }, V3 = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getCustomerTransactions" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "contactId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Voyado_UUID" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "offset" } }, type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "count" } }, type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Voyado" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Transactions_GetTransactionsWithArticlesByContactId" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "contactId" }, value: { kind: "Variable", name: { kind: "Name", value: "contactId" } } }, { kind: "Argument", name: { kind: "Name", value: "offset" }, value: { kind: "Variable", name: { kind: "Name", value: "offset" } } }, { kind: "Argument", name: { kind: "Name", value: "count" }, value: { kind: "Variable", name: { kind: "Name", value: "count" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "count" } }, { kind: "Field", name: { kind: "Name", value: "totalCount" } }, { kind: "Field", name: { kind: "Name", value: "items" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "createdDate" } }, { kind: "Field", name: { kind: "Name", value: "transactionNumber" } }, { kind: "Field", name: { kind: "Name", value: "storeName" } }, { kind: "Field", name: { kind: "Name", value: "numberOfItems" } }, { kind: "Field", name: { kind: "Name", value: "netPriceSum" } }, { kind: "Field", name: { kind: "Name", value: "localNetPriceSum" } }, { kind: "Field", name: { kind: "Name", value: "localCurrency" } }, { kind: "Field", name: { kind: "Name", value: "lineItems" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "quantity" } }, { kind: "Field", name: { kind: "Name", value: "article" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }] } }, { kind: "Field", name: { kind: "Name", value: "localPrice" } }, { kind: "Field", name: { kind: "Name", value: "type" } }] } }] } }] } }] } }] } }] }, z3 = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getOrdersByContactId" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "contactId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Voyado_UUID" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "offset" } }, type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "count" } }, type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Voyado" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Orders_GetAllByContact" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "contactId" }, value: { kind: "Variable", name: { kind: "Name", value: "contactId" } } }, { kind: "Argument", name: { kind: "Name", value: "offset" }, value: { kind: "Variable", name: { kind: "Name", value: "offset" } } }, { kind: "Argument", name: { kind: "Name", value: "count" }, value: { kind: "Variable", name: { kind: "Name", value: "count" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "totalCount" } }, { kind: "Field", name: { kind: "Name", value: "items" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "orderId" } }, { kind: "Field", name: { kind: "Name", value: "createdAt" } }, { kind: "Field", name: { kind: "Name", value: "lastChangedAt" } }, { kind: "Field", name: { kind: "Name", value: "channel" } }, { kind: "Field", name: { kind: "Name", value: "status" } }, { kind: "Field", name: { kind: "Name", value: "externalStatus" } }, { kind: "Field", name: { kind: "Name", value: "totalPrice" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }, { kind: "Field", name: { kind: "Name", value: "lineItems" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "items" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "quantity" } }, { kind: "Field", name: { kind: "Name", value: "totalPrice" } }, { kind: "Field", name: { kind: "Name", value: "article" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "sku" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "description" } }, { kind: "Field", name: { kind: "Name", value: "imageUri" } }, { kind: "Field", name: { kind: "Name", value: "targetUri" } }] } }] } }] } }] } }] } }] } }] } }] }, U3 = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getPoints" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "contactId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Voyado_UUID" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Voyado" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "PointAccountV_GetPointAccounts" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "contactId" }, value: { kind: "Variable", name: { kind: "Name", value: "contactId" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Voyado_PointAccountModelV3" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "balance" } }] } }] } }] } }] } }] }, M3 = {
  "\n  mutation updatePreferences(\n    $contactId: Voyado_UUID!\n    $input: Voyado_contactAttributes_Input!\n  ) {\n    Voyado {\n      ContactsV_ContactPatch(contactId: $contactId, input: $input) {\n        id\n      }\n    }\n  }\n": D3,
  "\n  mutation updatePoints($input: Voyado_AddPointTransactionRequestModel_Input!) {\n    Voyado {\n      PointTransaction_AddPointTransacion(input: $input)\n    }\n  }\n": R3,
  "\n  query getContactById($contactId: Voyado_UUID!) {\n    Voyado {\n      ContactsV_GetContactById(contactId: $contactId) {\n        id\n        attributes\n        meta\n        preferences\n        consents {\n          id\n          date\n          value\n          source\n          comment\n        }\n      }\n    }\n  }\n": O3,
  "\n  query getContactOverviewById($contactId: String!) {\n    Voyado {\n      ContactOverview_GetContactOverviewAsync(contactId: $contactId)\n    }\n  }\n": P3,
  "\n  query getContactId($email: String!, $mobilePhone: String!) {\n    Voyado {\n      ContactOverview_GetContactIdAsync(\n        email: $email\n        mobilePhone: $mobilePhone\n      ) {\n        ... on Voyado_ContactOverview_GetContactIdAsync_response {\n          ... on Voyado_String_container {\n            String\n          }\n          ... on Voyado_ApiExceptionMultipleMatchesResponse {\n            errorCode\n            message\n            requestId\n            messageDetails {\n              multipleMatchesFound\n            }\n          }\n        }\n      }\n    }\n  }\n": A3,
  "\n  query getLatestMessagesByContactId($contactId: Voyado_UUID!, $count: Int) {\n    Voyado {\n      ContactMessage_GetSmsMessagesByContactId(\n        contactId: $contactId\n        count: $count\n      ) {\n        ... on Voyado_ListResultOfApiMessage {\n          count\n          items {\n            messageId\n            name\n            sendDateTime\n            type\n            source\n            isTransactional\n            status\n            messageLink\n            messageText\n          }\n        }\n      }\n      ContactMessage_GetPostalMessagesByContactId(\n        contactId: $contactId\n        count: $count\n      ) {\n        ... on Voyado_ListResultOfApiMessage {\n          count\n          items {\n            messageId\n            name\n            sendDateTime\n            type\n            source\n            isTransactional\n            status\n            messageLink\n            messageText\n          }\n        }\n      }\n      ContactMessage_GetEmailMessagesByContactId(\n        contactId: $contactId\n        count: $count\n      ) {\n        ... on Voyado_ListResultOfApiMessage {\n          count\n          items {\n            messageId\n            name\n            sendDateTime\n            type\n            source\n            isTransactional\n            status\n            messageLink\n            messageText\n          }\n        }\n      }\n    }\n  }\n": L3,
  "\n  query getCustomerTransactions(\n    $contactId: Voyado_UUID!\n    $offset: Int\n    $count: Int\n  ) {\n    Voyado {\n      Transactions_GetTransactionsWithArticlesByContactId(\n        contactId: $contactId\n        offset: $offset\n        count: $count\n      ) {\n        count\n        totalCount\n        items {\n          id\n          createdDate\n          transactionNumber\n          storeName\n          numberOfItems\n          netPriceSum\n          localNetPriceSum\n          localCurrency\n          lineItems {\n            quantity\n            article {\n              name\n            }\n            localPrice\n            type\n          }\n        }\n      }\n    }\n  }\n": V3,
  "\n  query getOrdersByContactId(\n    $contactId: Voyado_UUID!\n    $offset: Int\n    $count: Int\n  ) {\n    Voyado {\n      Orders_GetAllByContact(\n        contactId: $contactId\n        offset: $offset\n        count: $count\n      ) {\n        totalCount\n        items {\n          orderId\n          createdAt\n          lastChangedAt\n          channel\n          status\n          externalStatus\n          totalPrice\n          currencyCode\n          lineItems {\n            items {\n              id\n              quantity\n              totalPrice\n              article {\n                sku\n                name\n                description\n                imageUri\n                targetUri\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n": z3,
  "\n  query getPoints($contactId: Voyado_UUID!) {\n    Voyado {\n      PointAccountV_GetPointAccounts(contactId: $contactId) {\n        ... on Voyado_PointAccountModelV3 {\n          id\n          balance\n        }\n      }\n    }\n  }\n": U3
};
function Kr(e) {
  return M3[e] ?? {};
}
const B3 = Kr(
  /* GraphQL */
  `
  query getContactById($contactId: Voyado_UUID!) {
    Voyado {
      ContactsV_GetContactById(contactId: $contactId) {
        id
        attributes
        meta
        preferences
        consents {
          id
          date
          value
          source
          comment
        }
      }
    }
  }
`
), q3 = Kr(
  /* GraphQL */
  `
  query getContactOverviewById($contactId: String!) {
    Voyado {
      ContactOverview_GetContactOverviewAsync(contactId: $contactId)
    }
  }
`
), H3 = Kr(
  /* GraphQL */
  `
  query getContactId($email: String!, $mobilePhone: String!) {
    Voyado {
      ContactOverview_GetContactIdAsync(
        email: $email
        mobilePhone: $mobilePhone
      ) {
        ... on Voyado_ContactOverview_GetContactIdAsync_response {
          ... on Voyado_String_container {
            String
          }
          ... on Voyado_ApiExceptionMultipleMatchesResponse {
            errorCode
            message
            requestId
            messageDetails {
              multipleMatchesFound
            }
          }
        }
      }
    }
  }
`
), W3 = Kr(
  /* GraphQL */
  `
  query getLatestMessagesByContactId($contactId: Voyado_UUID!, $count: Int) {
    Voyado {
      ContactMessage_GetSmsMessagesByContactId(
        contactId: $contactId
        count: $count
      ) {
        ... on Voyado_ListResultOfApiMessage {
          count
          items {
            messageId
            name
            sendDateTime
            type
            source
            isTransactional
            status
            messageLink
            messageText
          }
        }
      }
      ContactMessage_GetPostalMessagesByContactId(
        contactId: $contactId
        count: $count
      ) {
        ... on Voyado_ListResultOfApiMessage {
          count
          items {
            messageId
            name
            sendDateTime
            type
            source
            isTransactional
            status
            messageLink
            messageText
          }
        }
      }
      ContactMessage_GetEmailMessagesByContactId(
        contactId: $contactId
        count: $count
      ) {
        ... on Voyado_ListResultOfApiMessage {
          count
          items {
            messageId
            name
            sendDateTime
            type
            source
            isTransactional
            status
            messageLink
            messageText
          }
        }
      }
    }
  }
`
), K3 = Kr(
  /* GraphQL */
  `
  query getCustomerTransactions(
    $contactId: Voyado_UUID!
    $offset: Int
    $count: Int
  ) {
    Voyado {
      Transactions_GetTransactionsWithArticlesByContactId(
        contactId: $contactId
        offset: $offset
        count: $count
      ) {
        count
        totalCount
        items {
          id
          createdDate
          transactionNumber
          storeName
          numberOfItems
          netPriceSum
          localNetPriceSum
          localCurrency
          lineItems {
            quantity
            article {
              name
            }
            localPrice
            type
          }
        }
      }
    }
  }
`
), G3 = Kr(
  /* GraphQL */
  `
  query getOrdersByContactId(
    $contactId: Voyado_UUID!
    $offset: Int
    $count: Int
  ) {
    Voyado {
      Orders_GetAllByContact(
        contactId: $contactId
        offset: $offset
        count: $count
      ) {
        totalCount
        items {
          orderId
          createdAt
          lastChangedAt
          channel
          status
          externalStatus
          totalPrice
          currencyCode
          lineItems {
            items {
              id
              quantity
              totalPrice
              article {
                sku
                name
                description
                imageUri
                targetUri
              }
            }
          }
        }
      }
    }
  }
`
), Y3 = Kr(
  /* GraphQL */
  `
  query getPoints($contactId: Voyado_UUID!) {
    Voyado {
      PointAccountV_GetPointAccounts(contactId: $contactId) {
        ... on Voyado_PointAccountModelV3 {
          id
          balance
        }
      }
    }
  }
`
), Q3 = Kr(
  /* GraphQL */
  `
  mutation updatePreferences(
    $contactId: Voyado_UUID!
    $input: Voyado_contactAttributes_Input!
  ) {
    Voyado {
      ContactsV_ContactPatch(contactId: $contactId, input: $input) {
        id
      }
    }
  }
`
), J3 = Kr(
  /* GraphQL */
  `
  mutation updatePoints($input: Voyado_AddPointTransactionRequestModel_Input!) {
    Voyado {
      PointTransaction_AddPointTransacion(input: $input)
    }
  }
`
), X3 = ({
  contactId: e
}) => {
  const { useQuery: n } = mn(), { track: r } = bn(), [i, a] = se(), [o, s] = se(), [l, d] = se(), {
    loading: m,
    error: u,
    data: f,
    refetch: h
  } = n(B3, {
    skip: !e,
    variables: { contactId: e }
  });
  return He(() => {
    const v = f?.Voyado?.ContactsV_GetContactById;
    !m && v && typeof v == "object" && ("id" in v && r("voyado:profile:received", { hasProfile: !0 }), "attributes" in v && a(v.attributes), "preferences" in v && s(v.preferences), "consents" in v && d(
      v?.consents?.filter(
        (C) => C !== null
      ) || void 0
    )), !m && (!v || typeof v != "object") && r("voyado:profile:received", { hasProfile: !1 });
  }, [f?.Voyado, m]), Bn(
    () => ({
      isLoading: m,
      error: u,
      refetch: h,
      attributes: i,
      preferences: o,
      consents: l
    }),
    [u, i, o, l]
  );
};
function ls(e = !1, n) {
  const [r, i] = se(e);
  return He(() => {
    const a = r ? window.setTimeout(() => i(!1), 2e3) : void 0;
    return () => window.clearTimeout(a);
  }, [n, r]), { isCopied: r, copy: (a) => {
    navigator.clipboard.writeText(a), i(!0);
  } };
}
const Z3 = {
  count: 0,
  items: []
}, eU = ({
  contactId: e
}) => {
  const { useQuery: n } = mn(), { track: r } = bn(), [i, a] = se(Z3), {
    loading: o,
    error: s,
    data: l
  } = n(W3, {
    skip: !e,
    variables: { contactId: e, count: 5 }
  });
  return He(() => {
    if (!o && (l?.Voyado?.ContactMessage_GetSmsMessagesByContactId || l?.Voyado?.ContactMessage_GetPostalMessagesByContactId || l?.Voyado?.ContactMessage_GetEmailMessagesByContactId)) {
      const d = l?.Voyado?.ContactMessage_GetEmailMessagesByContactId, m = l?.Voyado?.ContactMessage_GetSmsMessagesByContactId, u = l?.Voyado?.ContactMessage_GetPostalMessagesByContactId, f = {
        count: (m?.count ?? 0) + (u?.count ?? 0) + (d?.count ?? 0),
        items: [
          ...m.items ?? [],
          ...d.items ?? [],
          ...u.items ?? []
        ]
      };
      a(f), r("voyado:messages:received", {
        emailsReceived: d.count ?? 0,
        smsReceived: m.count ?? 0,
        postalReceived: u.count ?? 0,
        total: f.count ?? 0
      });
    }
  }, [l?.Voyado, o]), {
    isLoading: o,
    error: s,
    lastMessages: i
  };
}, nU = {
  count: 0,
  totalCount: 0,
  items: []
}, tU = ({
  contactId: e
}) => {
  const { useQuery: n } = mn(), { track: r } = bn(), [i, a] = se(
    nU
  ), {
    loading: o,
    error: s,
    data: l
  } = n(K3, {
    skip: !e,
    variables: { contactId: e, count: 5 }
  });
  return He(() => {
    const d = l?.Voyado?.Transactions_GetTransactionsWithArticlesByContactId;
    if (!o && d) {
      a(
        d
      );
      const { count: m } = d;
      m && r("voyado:transactions:received", { count: m });
    }
  }, [l?.Voyado, o]), {
    isLoading: o,
    error: s,
    transactions: i
  };
}, rU = ({
  conversationContext: e
}) => {
  const { useQuery: n } = mn(), [r, i] = se(void 0), [a, o] = se(!1), { customer: s } = e, l = !!s?.email || !!s?.phone_number, {
    loading: d,
    error: m,
    data: u,
    refetch: f
  } = n(H3, {
    skip: !l,
    variables: {
      email: s?.email ?? "",
      mobilePhone: s?.phone_number ?? ""
    }
  });
  return He(() => {
    const h = u?.Voyado?.ContactOverview_GetContactIdAsync;
    h?.__typename === "Voyado_ApiExceptionMultipleMatchesResponse" && h?.messageDetails?.multipleMatchesFound && h?.messageDetails?.multipleMatchesFound.length > 0 && (o(!0), i(void 0)), h?.__typename === "Voyado_String_container" && h?.String && (o(!1), i(h.String));
  }, [u?.Voyado, d]), {
    isLoading: d,
    contactId: r,
    hasMultipleContacts: a,
    error: m,
    refetch: f
  };
}, iU = ({
  contactId: e,
  skip: n
}) => {
  const { useQuery: r } = mn(), [i, a] = se(
    void 0
  ), {
    loading: o,
    error: s,
    data: l,
    refetch: d
  } = r(q3, {
    skip: !e || n,
    variables: { contactId: e }
  });
  return He(() => {
    const m = l?.Voyado?.ContactOverview_GetContactOverviewAsync;
    if (!o && m && Object.hasOwn(m, "memberlevel")) {
      const u = m?.memberlevel;
      a({
        levelName: u?.levelName,
        remainingToUpgrade: u?.remainingToUpgrade,
        basedOnRewardPoints: u?.basedOnRewardPoints,
        levelId: u?.levelId,
        latestChange: u?.latestChange,
        expires: u?.expires
      });
    } else
      a(void 0);
  }, [l?.Voyado, o]), Bn(
    () => ({
      isLoading: o,
      error: s,
      memberLevel: i,
      refetch: d
    }),
    [o, s, i, d]
  );
}, aU = "_pointer_ls8kj_48", oU = "_list_ls8kj_53", sU = "_listItem_ls8kj_63", nt = {
  pointer: aU,
  list: oU,
  listItem: sU
};
var go = (e) => e.type === "checkbox", di = (e) => e instanceof Date, Lt = (e) => e == null;
const mS = (e) => typeof e == "object";
var ct = (e) => !Lt(e) && !Array.isArray(e) && mS(e) && !di(e), pS = (e) => ct(e) && e.target ? go(e.target) ? e.target.checked : e.target.value : e, lU = (e) => e.substring(0, e.search(/\.\d+(\.|$)/)) || e, fS = (e, n) => e.has(lU(n)), cU = (e) => {
  const n = e.constructor && e.constructor.prototype;
  return ct(n) && n.hasOwnProperty("isPrototypeOf");
}, Bp = typeof window < "u" && typeof window.HTMLElement < "u" && typeof document < "u";
function St(e) {
  let n;
  const r = Array.isArray(e), i = typeof FileList < "u" ? e instanceof FileList : !1;
  if (e instanceof Date)
    n = new Date(e);
  else if (e instanceof Set)
    n = new Set(e);
  else if (!(Bp && (e instanceof Blob || i)) && (r || ct(e)))
    if (n = r ? [] : {}, !r && !cU(e))
      n = e;
    else
      for (const a in e)
        e.hasOwnProperty(a) && (n[a] = St(e[a]));
  else
    return e;
  return n;
}
var el = (e) => Array.isArray(e) ? e.filter(Boolean) : [], at = (e) => e === void 0, Qe = (e, n, r) => {
  if (!n || !ct(e))
    return r;
  const i = el(n.split(/[,[\].]+?/)).reduce((a, o) => Lt(a) ? a : a[o], e);
  return at(i) || i === e ? at(e[n]) ? r : e[n] : i;
}, Zt = (e) => typeof e == "boolean", qp = (e) => /^\w*$/.test(e), hS = (e) => el(e.replace(/["|']|\]/g, "").split(/\.|\[/)), Yn = (e, n, r) => {
  let i = -1;
  const a = qp(n) ? [n] : hS(n), o = a.length, s = o - 1;
  for (; ++i < o; ) {
    const l = a[i];
    let d = r;
    if (i !== s) {
      const m = e[l];
      d = ct(m) || Array.isArray(m) ? m : isNaN(+a[i + 1]) ? {} : [];
    }
    if (l === "__proto__" || l === "constructor" || l === "prototype")
      return;
    e[l] = d, e = e[l];
  }
};
const js = {
  BLUR: "blur",
  FOCUS_OUT: "focusout",
  CHANGE: "change"
}, gr = {
  onBlur: "onBlur",
  onChange: "onChange",
  onSubmit: "onSubmit",
  onTouched: "onTouched",
  all: "all"
}, Ur = {
  max: "max",
  min: "min",
  maxLength: "maxLength",
  minLength: "minLength",
  pattern: "pattern",
  required: "required",
  validate: "validate"
}, dU = je.createContext(null), Hp = () => je.useContext(dU);
var yS = (e, n, r, i = !0) => {
  const a = {
    defaultValues: n._defaultValues
  };
  for (const o in e)
    Object.defineProperty(a, o, {
      get: () => {
        const s = o;
        return n._proxyFormState[s] !== gr.all && (n._proxyFormState[s] = !i || gr.all), r && (r[s] = !0), e[s];
      }
    });
  return a;
};
function uU(e) {
  const n = Hp(), { control: r = n.control, disabled: i, name: a, exact: o } = e || {}, [s, l] = je.useState(r._formState), d = je.useRef({
    isDirty: !1,
    isLoading: !1,
    dirtyFields: !1,
    touchedFields: !1,
    validatingFields: !1,
    isValidating: !1,
    isValid: !1,
    errors: !1
  }), m = je.useRef(a);
  return m.current = a, je.useEffect(() => r._subscribe({
    name: m.current,
    formState: d.current,
    exact: o,
    callback: (u) => {
      !i && l({
        ...r._formState,
        ...u
      });
    }
  }), [r, i, o]), je.useEffect(() => {
    d.current.isValid && r._setValid(!0);
  }, [r]), je.useMemo(() => yS(s, r, d.current, !1), [s, r]);
}
var $r = (e) => typeof e == "string", gS = (e, n, r, i, a) => $r(e) ? (i && n.watch.add(e), Qe(r, e, a)) : Array.isArray(e) ? e.map((o) => (i && n.watch.add(o), Qe(r, o))) : (i && (n.watchAll = !0), r);
function vS(e) {
  const n = Hp(), { control: r = n.control, name: i, defaultValue: a, disabled: o, exact: s } = e || {}, l = je.useRef(i), d = je.useRef(a);
  l.current = i, je.useEffect(() => r._subscribe({
    name: l.current,
    formState: {
      values: !0
    },
    exact: s,
    callback: (f) => !o && u(gS(l.current, r._names, f.values || r._formValues, !1, d.current))
  }), [r, o, s]);
  const [m, u] = je.useState(r._getWatch(i, a));
  return je.useEffect(() => r._removeUnmounted()), m;
}
function mU(e) {
  const n = Hp(), { name: r, disabled: i, control: a = n.control, shouldUnregister: o } = e, s = fS(a._names.array, r), l = vS({
    control: a,
    name: r,
    defaultValue: Qe(a._formValues, r, Qe(a._defaultValues, r, e.defaultValue)),
    exact: !0
  }), d = uU({
    control: a,
    name: r,
    exact: !0
  }), m = je.useRef(e), u = je.useRef(a.register(r, {
    ...e.rules,
    value: l,
    ...Zt(e.disabled) ? { disabled: e.disabled } : {}
  })), f = je.useMemo(() => Object.defineProperties({}, {
    invalid: {
      enumerable: !0,
      get: () => !!Qe(d.errors, r)
    },
    isDirty: {
      enumerable: !0,
      get: () => !!Qe(d.dirtyFields, r)
    },
    isTouched: {
      enumerable: !0,
      get: () => !!Qe(d.touchedFields, r)
    },
    isValidating: {
      enumerable: !0,
      get: () => !!Qe(d.validatingFields, r)
    },
    error: {
      enumerable: !0,
      get: () => Qe(d.errors, r)
    }
  }), [d, r]), h = je.useCallback((j) => u.current.onChange({
    target: {
      value: pS(j),
      name: r
    },
    type: js.CHANGE
  }), [r]), v = je.useCallback(() => u.current.onBlur({
    target: {
      value: Qe(a._formValues, r),
      name: r
    },
    type: js.BLUR
  }), [r, a._formValues]), C = je.useCallback((j) => {
    const F = Qe(a._fields, r);
    F && j && (F._f.ref = {
      focus: () => j.focus(),
      select: () => j.select(),
      setCustomValidity: (y) => j.setCustomValidity(y),
      reportValidity: () => j.reportValidity()
    });
  }, [a._fields, r]), S = je.useMemo(() => ({
    name: r,
    value: l,
    ...Zt(i) || d.disabled ? { disabled: d.disabled || i } : {},
    onChange: h,
    onBlur: v,
    ref: C
  }), [r, i, d.disabled, h, v, C, l]);
  return je.useEffect(() => {
    const j = a._options.shouldUnregister || o;
    a.register(r, {
      ...m.current.rules,
      ...Zt(m.current.disabled) ? { disabled: m.current.disabled } : {}
    });
    const F = (y, q) => {
      const T = Qe(a._fields, y);
      T && T._f && (T._f.mount = q);
    };
    if (F(r, !0), j) {
      const y = St(Qe(a._options.defaultValues, r));
      Yn(a._defaultValues, r, y), at(Qe(a._formValues, r)) && Yn(a._formValues, r, y);
    }
    return !s && a.register(r), () => {
      (s ? j && !a._state.action : j) ? a.unregister(r) : F(r, !1);
    };
  }, [r, a, s, o]), je.useEffect(() => {
    a._setDisabledField({
      disabled: i,
      name: r
    });
  }, [i, r, a]), je.useMemo(() => ({
    field: S,
    formState: d,
    fieldState: f
  }), [S, d, f]);
}
const Wk = (e) => e.render(mU(e));
var pU = (e, n, r, i, a) => n ? {
  ...r[e],
  types: {
    ...r[e] && r[e].types ? r[e].types : {},
    [i]: a || !0
  }
} : {}, Ka = (e) => Array.isArray(e) ? e : [e], Kk = () => {
  let e = [];
  return {
    get observers() {
      return e;
    },
    next: (n) => {
      for (const r of e)
        r.next && r.next(n);
    },
    subscribe: (n) => (e.push(n), {
      unsubscribe: () => {
        e = e.filter((r) => r !== n);
      }
    }),
    unsubscribe: () => {
      e = [];
    }
  };
}, jm = (e) => Lt(e) || !mS(e);
function Xr(e, n) {
  if (jm(e) || jm(n))
    return e === n;
  if (di(e) && di(n))
    return e.getTime() === n.getTime();
  const r = Object.keys(e), i = Object.keys(n);
  if (r.length !== i.length)
    return !1;
  for (const a of r) {
    const o = e[a];
    if (!i.includes(a))
      return !1;
    if (a !== "ref") {
      const s = n[a];
      if (di(o) && di(s) || ct(o) && ct(s) || Array.isArray(o) && Array.isArray(s) ? !Xr(o, s) : o !== s)
        return !1;
    }
  }
  return !0;
}
var Ot = (e) => ct(e) && !Object.keys(e).length, Wp = (e) => e.type === "file", vr = (e) => typeof e == "function", ws = (e) => {
  if (!Bp)
    return !1;
  const n = e ? e.ownerDocument : 0;
  return e instanceof (n && n.defaultView ? n.defaultView.HTMLElement : HTMLElement);
}, kS = (e) => e.type === "select-multiple", Kp = (e) => e.type === "radio", fU = (e) => Kp(e) || go(e), Lu = (e) => ws(e) && e.isConnected;
function hU(e, n) {
  const r = n.slice(0, -1).length;
  let i = 0;
  for (; i < r; )
    e = at(e) ? i++ : e[n[i++]];
  return e;
}
function yU(e) {
  for (const n in e)
    if (e.hasOwnProperty(n) && !at(e[n]))
      return !1;
  return !0;
}
function ft(e, n) {
  const r = Array.isArray(n) ? n : qp(n) ? [n] : hS(n), i = r.length === 1 ? e : hU(e, r), a = r.length - 1, o = r[a];
  return i && delete i[o], a !== 0 && (ct(i) && Ot(i) || Array.isArray(i) && yU(i)) && ft(e, r.slice(0, -1)), e;
}
var bS = (e) => {
  for (const n in e)
    if (vr(e[n]))
      return !0;
  return !1;
};
function Cs(e, n = {}) {
  const r = Array.isArray(e);
  if (ct(e) || r)
    for (const i in e)
      Array.isArray(e[i]) || ct(e[i]) && !bS(e[i]) ? (n[i] = Array.isArray(e[i]) ? [] : {}, Cs(e[i], n[i])) : Lt(e[i]) || (n[i] = !0);
  return n;
}
function _S(e, n, r) {
  const i = Array.isArray(e);
  if (ct(e) || i)
    for (const a in e)
      Array.isArray(e[a]) || ct(e[a]) && !bS(e[a]) ? at(n) || jm(r[a]) ? r[a] = Array.isArray(e[a]) ? Cs(e[a], []) : { ...Cs(e[a]) } : _S(e[a], Lt(n) ? {} : n[a], r[a]) : r[a] = !Xr(e[a], n[a]);
  return r;
}
var $a = (e, n) => _S(e, n, Cs(n));
const Gk = {
  value: !1,
  isValid: !1
}, Yk = { value: !0, isValid: !0 };
var xS = (e) => {
  if (Array.isArray(e)) {
    if (e.length > 1) {
      const n = e.filter((r) => r && r.checked && !r.disabled).map((r) => r.value);
      return { value: n, isValid: !!n.length };
    }
    return e[0].checked && !e[0].disabled ? (
      // @ts-expect-error expected to work in the browser
      e[0].attributes && !at(e[0].attributes.value) ? at(e[0].value) || e[0].value === "" ? Yk : { value: e[0].value, isValid: !0 } : Yk
    ) : Gk;
  }
  return Gk;
}, SS = (e, { valueAsNumber: n, valueAsDate: r, setValueAs: i }) => at(e) ? e : n ? e === "" ? NaN : e && +e : r && $r(e) ? new Date(e) : i ? i(e) : e;
const Qk = {
  isValid: !1,
  value: null
};
var NS = (e) => Array.isArray(e) ? e.reduce((n, r) => r && r.checked && !r.disabled ? {
  isValid: !0,
  value: r.value
} : n, Qk) : Qk;
function Jk(e) {
  const n = e.ref;
  return Wp(n) ? n.files : Kp(n) ? NS(e.refs).value : kS(n) ? [...n.selectedOptions].map(({ value: r }) => r) : go(n) ? xS(e.refs).value : SS(at(n.value) ? e.ref.value : n.value, e);
}
var gU = (e, n, r, i) => {
  const a = {};
  for (const o of e) {
    const s = Qe(n, o);
    s && Yn(a, o, s._f);
  }
  return {
    criteriaMode: r,
    names: [...e],
    fields: a,
    shouldUseNativeValidation: i
  };
}, Fs = (e) => e instanceof RegExp, Da = (e) => at(e) ? e : Fs(e) ? e.source : ct(e) ? Fs(e.value) ? e.value.source : e.value : e, Xk = (e) => ({
  isOnSubmit: !e || e === gr.onSubmit,
  isOnBlur: e === gr.onBlur,
  isOnChange: e === gr.onChange,
  isOnAll: e === gr.all,
  isOnTouch: e === gr.onTouched
});
const Zk = "AsyncFunction";
var vU = (e) => !!e && !!e.validate && !!(vr(e.validate) && e.validate.constructor.name === Zk || ct(e.validate) && Object.values(e.validate).find((n) => n.constructor.name === Zk)), kU = (e) => e.mount && (e.required || e.min || e.max || e.maxLength || e.minLength || e.pattern || e.validate), eb = (e, n, r) => !r && (n.watchAll || n.watch.has(e) || [...n.watch].some((i) => e.startsWith(i) && /^\.\w+/.test(e.slice(i.length))));
const Ga = (e, n, r, i) => {
  for (const a of r || Object.keys(e)) {
    const o = Qe(e, a);
    if (o) {
      const { _f: s, ...l } = o;
      if (s) {
        if (s.refs && s.refs[0] && n(s.refs[0], a) && !i || s.ref && n(s.ref, s.name) && !i)
          return !0;
        if (Ga(l, n))
          break;
      } else if (ct(l) && Ga(l, n))
        break;
    }
  }
};
function nb(e, n, r) {
  const i = Qe(e, r);
  if (i || qp(r))
    return {
      error: i,
      name: r
    };
  const a = r.split(".");
  for (; a.length; ) {
    const o = a.join("."), s = Qe(n, o), l = Qe(e, o);
    if (s && !Array.isArray(s) && r !== o)
      return { name: r };
    if (l && l.type)
      return {
        name: o,
        error: l
      };
    a.pop();
  }
  return {
    name: r
  };
}
var bU = (e, n, r, i) => {
  r(e);
  const { name: a, ...o } = e;
  return Ot(o) || Object.keys(o).length >= Object.keys(n).length || Object.keys(o).find((s) => n[s] === (!i || gr.all));
}, _U = (e, n, r) => !e || !n || e === n || Ka(e).some((i) => i && (r ? i === n : i.startsWith(n) || n.startsWith(i))), xU = (e, n, r, i, a) => a.isOnAll ? !1 : !r && a.isOnTouch ? !(n || e) : (r ? i.isOnBlur : a.isOnBlur) ? !e : (r ? i.isOnChange : a.isOnChange) ? e : !0, SU = (e, n) => !el(Qe(e, n)).length && ft(e, n), NU = (e, n, r) => {
  const i = Ka(Qe(e, r));
  return Yn(i, "root", n[r]), Yn(e, r, i), e;
}, cs = (e) => $r(e);
function tb(e, n, r = "validate") {
  if (cs(e) || Array.isArray(e) && e.every(cs) || Zt(e) && !e)
    return {
      type: r,
      message: cs(e) ? e : "",
      ref: n
    };
}
var Ti = (e) => ct(e) && !Fs(e) ? e : {
  value: e,
  message: ""
}, rb = async (e, n, r, i, a, o) => {
  const { ref: s, refs: l, required: d, maxLength: m, minLength: u, min: f, max: h, pattern: v, validate: C, name: S, valueAsNumber: j, mount: F } = e._f, y = Qe(r, S);
  if (!F || n.has(S))
    return {};
  const q = l ? l[0] : s, T = (U) => {
    a && q.reportValidity && (q.setCustomValidity(Zt(U) ? "" : U || ""), q.reportValidity());
  }, E = {}, D = Kp(s), B = go(s), ee = D || B, J = (j || Wp(s)) && at(s.value) && at(y) || ws(s) && s.value === "" || y === "" || Array.isArray(y) && !y.length, ae = pU.bind(null, S, i, E), Q = (U, O, H, Z = Ur.maxLength, ye = Ur.minLength) => {
    const ce = U ? O : H;
    E[S] = {
      type: U ? Z : ye,
      message: ce,
      ref: s,
      ...ae(U ? Z : ye, ce)
    };
  };
  if (o ? !Array.isArray(y) || !y.length : d && (!ee && (J || Lt(y)) || Zt(y) && !y || B && !xS(l).isValid || D && !NS(l).isValid)) {
    const { value: U, message: O } = cs(d) ? { value: !!d, message: d } : Ti(d);
    if (U && (E[S] = {
      type: Ur.required,
      message: O,
      ref: q,
      ...ae(Ur.required, O)
    }, !i))
      return T(O), E;
  }
  if (!J && (!Lt(f) || !Lt(h))) {
    let U, O;
    const H = Ti(h), Z = Ti(f);
    if (!Lt(y) && !isNaN(y)) {
      const ye = s.valueAsNumber || y && +y;
      Lt(H.value) || (U = ye > H.value), Lt(Z.value) || (O = ye < Z.value);
    } else {
      const ye = s.valueAsDate || new Date(y), ce = (W) => /* @__PURE__ */ new Date((/* @__PURE__ */ new Date()).toDateString() + " " + W), le = s.type == "time", ue = s.type == "week";
      $r(H.value) && y && (U = le ? ce(y) > ce(H.value) : ue ? y > H.value : ye > new Date(H.value)), $r(Z.value) && y && (O = le ? ce(y) < ce(Z.value) : ue ? y < Z.value : ye < new Date(Z.value));
    }
    if ((U || O) && (Q(!!U, H.message, Z.message, Ur.max, Ur.min), !i))
      return T(E[S].message), E;
  }
  if ((m || u) && !J && ($r(y) || o && Array.isArray(y))) {
    const U = Ti(m), O = Ti(u), H = !Lt(U.value) && y.length > +U.value, Z = !Lt(O.value) && y.length < +O.value;
    if ((H || Z) && (Q(H, U.message, O.message), !i))
      return T(E[S].message), E;
  }
  if (v && !J && $r(y)) {
    const { value: U, message: O } = Ti(v);
    if (Fs(U) && !y.match(U) && (E[S] = {
      type: Ur.pattern,
      message: O,
      ref: s,
      ...ae(Ur.pattern, O)
    }, !i))
      return T(O), E;
  }
  if (C) {
    if (vr(C)) {
      const U = await C(y, r), O = tb(U, q);
      if (O && (E[S] = {
        ...O,
        ...ae(Ur.validate, O.message)
      }, !i))
        return T(O.message), E;
    } else if (ct(C)) {
      let U = {};
      for (const O in C) {
        if (!Ot(U) && !i)
          break;
        const H = tb(await C[O](y, r), q, O);
        H && (U = {
          ...H,
          ...ae(O, H.message)
        }, T(H.message), i && (E[S] = U));
      }
      if (!Ot(U) && (E[S] = {
        ref: q,
        ...U
      }, !i))
        return E;
    }
  }
  return T(!0), E;
};
const jU = {
  mode: gr.onSubmit,
  reValidateMode: gr.onChange,
  shouldFocusError: !0
};
function wU(e = {}) {
  let n = {
    ...jU,
    ...e
  }, r = {
    submitCount: 0,
    isDirty: !1,
    isLoading: vr(n.defaultValues),
    isValidating: !1,
    isSubmitted: !1,
    isSubmitting: !1,
    isSubmitSuccessful: !1,
    isValid: !1,
    touchedFields: {},
    dirtyFields: {},
    validatingFields: {},
    errors: n.errors || {},
    disabled: n.disabled || !1
  };
  const i = {};
  let a = ct(n.defaultValues) || ct(n.values) ? St(n.values || n.defaultValues) || {} : {}, o = n.shouldUnregister ? {} : St(a), s = {
    action: !1,
    mount: !1,
    watch: !1
  }, l = {
    mount: /* @__PURE__ */ new Set(),
    disabled: /* @__PURE__ */ new Set(),
    unMount: /* @__PURE__ */ new Set(),
    array: /* @__PURE__ */ new Set(),
    watch: /* @__PURE__ */ new Set()
  }, d, m = 0;
  const u = {
    isDirty: !1,
    dirtyFields: !1,
    validatingFields: !1,
    touchedFields: !1,
    isValidating: !1,
    isValid: !1,
    errors: !1
  };
  let f = {
    ...u
  };
  const h = {
    array: Kk(),
    state: Kk()
  }, v = Xk(n.mode), C = Xk(n.reValidateMode), S = n.criteriaMode === gr.all, j = (w) => (_) => {
    clearTimeout(m), m = setTimeout(w, _);
  }, F = async (w) => {
    if (!n.disabled && (u.isValid || f.isValid || w)) {
      const _ = n.resolver ? Ot((await J()).errors) : await Q(i, !0);
      _ !== r.isValid && h.state.next({
        isValid: _
      });
    }
  }, y = (w, _) => {
    !n.disabled && (u.isValidating || u.validatingFields || f.isValidating || f.validatingFields) && ((w || Array.from(l.mount)).forEach(($) => {
      $ && (_ ? Yn(r.validatingFields, $, _) : ft(r.validatingFields, $));
    }), h.state.next({
      validatingFields: r.validatingFields,
      isValidating: !Ot(r.validatingFields)
    }));
  }, q = (w, _ = [], $, G, Y = !0, R = !0) => {
    if (G && $ && !n.disabled) {
      if (s.action = !0, R && Array.isArray(Qe(i, w))) {
        const z = $(Qe(i, w), G.argA, G.argB);
        Y && Yn(i, w, z);
      }
      if (R && Array.isArray(Qe(r.errors, w))) {
        const z = $(Qe(r.errors, w), G.argA, G.argB);
        Y && Yn(r.errors, w, z), SU(r.errors, w);
      }
      if ((u.touchedFields || f.touchedFields) && R && Array.isArray(Qe(r.touchedFields, w))) {
        const z = $(Qe(r.touchedFields, w), G.argA, G.argB);
        Y && Yn(r.touchedFields, w, z);
      }
      (u.dirtyFields || f.dirtyFields) && (r.dirtyFields = $a(a, o)), h.state.next({
        name: w,
        isDirty: O(w, _),
        dirtyFields: r.dirtyFields,
        errors: r.errors,
        isValid: r.isValid
      });
    } else
      Yn(o, w, _);
  }, T = (w, _) => {
    Yn(r.errors, w, _), h.state.next({
      errors: r.errors
    });
  }, E = (w) => {
    r.errors = w, h.state.next({
      errors: r.errors,
      isValid: !1
    });
  }, D = (w, _, $, G) => {
    const Y = Qe(i, w);
    if (Y) {
      const R = Qe(o, w, at($) ? Qe(a, w) : $);
      at(R) || G && G.defaultChecked || _ ? Yn(o, w, _ ? R : Jk(Y._f)) : ye(w, R), s.mount && F();
    }
  }, B = (w, _, $, G, Y) => {
    let R = !1, z = !1;
    const ie = {
      name: w
    };
    if (!n.disabled) {
      if (!$ || G) {
        (u.isDirty || f.isDirty) && (z = r.isDirty, r.isDirty = ie.isDirty = O(), R = z !== ie.isDirty);
        const pe = Xr(Qe(a, w), _);
        z = !!Qe(r.dirtyFields, w), pe ? ft(r.dirtyFields, w) : Yn(r.dirtyFields, w, !0), ie.dirtyFields = r.dirtyFields, R = R || (u.dirtyFields || f.dirtyFields) && z !== !pe;
      }
      if ($) {
        const pe = Qe(r.touchedFields, w);
        pe || (Yn(r.touchedFields, w, $), ie.touchedFields = r.touchedFields, R = R || (u.touchedFields || f.touchedFields) && pe !== $);
      }
      R && Y && h.state.next(ie);
    }
    return R ? ie : {};
  }, ee = (w, _, $, G) => {
    const Y = Qe(r.errors, w), R = (u.isValid || f.isValid) && Zt(_) && r.isValid !== _;
    if (n.delayError && $ ? (d = j(() => T(w, $)), d(n.delayError)) : (clearTimeout(m), d = null, $ ? Yn(r.errors, w, $) : ft(r.errors, w)), ($ ? !Xr(Y, $) : Y) || !Ot(G) || R) {
      const z = {
        ...G,
        ...R && Zt(_) ? { isValid: _ } : {},
        errors: r.errors,
        name: w
      };
      r = {
        ...r,
        ...z
      }, h.state.next(z);
    }
  }, J = async (w) => {
    y(w, !0);
    const _ = await n.resolver(o, n.context, gU(w || l.mount, i, n.criteriaMode, n.shouldUseNativeValidation));
    return y(w), _;
  }, ae = async (w) => {
    const { errors: _ } = await J(w);
    if (w)
      for (const $ of w) {
        const G = Qe(_, $);
        G ? Yn(r.errors, $, G) : ft(r.errors, $);
      }
    else
      r.errors = _;
    return _;
  }, Q = async (w, _, $ = {
    valid: !0
  }) => {
    for (const G in w) {
      const Y = w[G];
      if (Y) {
        const { _f: R, ...z } = Y;
        if (R) {
          const ie = l.array.has(R.name), pe = Y._f && vU(Y._f);
          pe && u.validatingFields && y([G], !0);
          const _e = await rb(Y, l.disabled, o, S, n.shouldUseNativeValidation && !_, ie);
          if (pe && u.validatingFields && y([G]), _e[R.name] && ($.valid = !1, _))
            break;
          !_ && (Qe(_e, R.name) ? ie ? NU(r.errors, _e, R.name) : Yn(r.errors, R.name, _e[R.name]) : ft(r.errors, R.name));
        }
        !Ot(z) && await Q(z, _, $);
      }
    }
    return $.valid;
  }, U = () => {
    for (const w of l.unMount) {
      const _ = Qe(i, w);
      _ && (_._f.refs ? _._f.refs.every(($) => !Lu($)) : !Lu(_._f.ref)) && Ae(w);
    }
    l.unMount = /* @__PURE__ */ new Set();
  }, O = (w, _) => !n.disabled && (w && _ && Yn(o, w, _), !Xr(Ee(), a)), H = (w, _, $) => gS(w, l, {
    ...s.mount ? o : at(_) ? a : $r(w) ? { [w]: _ } : _
  }, $, _), Z = (w) => el(Qe(s.mount ? o : a, w, n.shouldUnregister ? Qe(a, w, []) : [])), ye = (w, _, $ = {}) => {
    const G = Qe(i, w);
    let Y = _;
    if (G) {
      const R = G._f;
      R && (!R.disabled && Yn(o, w, SS(_, R)), Y = ws(R.ref) && Lt(_) ? "" : _, kS(R.ref) ? [...R.ref.options].forEach((z) => z.selected = Y.includes(z.value)) : R.refs ? go(R.ref) ? R.refs.length > 1 ? R.refs.forEach((z) => (!z.defaultChecked || !z.disabled) && (z.checked = Array.isArray(Y) ? !!Y.find((ie) => ie === z.value) : Y === z.value)) : R.refs[0] && (R.refs[0].checked = !!Y) : R.refs.forEach((z) => z.checked = z.value === Y) : Wp(R.ref) ? R.ref.value = "" : (R.ref.value = Y, R.ref.type || h.state.next({
        name: w,
        values: St(o)
      })));
    }
    ($.shouldDirty || $.shouldTouch) && B(w, Y, $.shouldTouch, $.shouldDirty, !0), $.shouldValidate && ke(w);
  }, ce = (w, _, $) => {
    for (const G in _) {
      const Y = _[G], R = `${w}.${G}`, z = Qe(i, R);
      (l.array.has(w) || ct(Y) || z && !z._f) && !di(Y) ? ce(R, Y, $) : ye(R, Y, $);
    }
  }, le = (w, _, $ = {}) => {
    const G = Qe(i, w), Y = l.array.has(w), R = St(_);
    Yn(o, w, R), Y ? (h.array.next({
      name: w,
      values: St(o)
    }), (u.isDirty || u.dirtyFields || f.isDirty || f.dirtyFields) && $.shouldDirty && h.state.next({
      name: w,
      dirtyFields: $a(a, o),
      isDirty: O(w, R)
    })) : G && !G._f && !Lt(R) ? ce(w, R, $) : ye(w, R, $), eb(w, l) && h.state.next({ ...r }), h.state.next({
      name: s.mount ? w : void 0,
      values: St(o)
    });
  }, ue = async (w) => {
    s.mount = !0;
    const _ = w.target;
    let $ = _.name, G = !0;
    const Y = Qe(i, $), R = (z) => {
      G = Number.isNaN(z) || di(z) && isNaN(z.getTime()) || Xr(z, Qe(o, $, z));
    };
    if (Y) {
      let z, ie;
      const pe = _.type ? Jk(Y._f) : pS(w), _e = w.type === js.BLUR || w.type === js.FOCUS_OUT, en = !kU(Y._f) && !n.resolver && !Qe(r.errors, $) && !Y._f.deps || xU(_e, Qe(r.touchedFields, $), r.isSubmitted, C, v), un = eb($, l, _e);
      Yn(o, $, pe), _e ? (Y._f.onBlur && Y._f.onBlur(w), d && d(0)) : Y._f.onChange && Y._f.onChange(w);
      const rn = B($, pe, _e), dn = !Ot(rn) || un;
      if (!_e && h.state.next({
        name: $,
        type: w.type,
        values: St(o)
      }), en)
        return (u.isValid || f.isValid) && (n.mode === "onBlur" ? _e && F() : _e || F()), dn && h.state.next({ name: $, ...un ? {} : rn });
      if (!_e && un && h.state.next({ ...r }), n.resolver) {
        const { errors: pn } = await J([$]);
        if (R(pe), G) {
          const ln = nb(r.errors, i, $), kn = nb(pn, i, ln.name || $);
          z = kn.error, $ = kn.name, ie = Ot(pn);
        }
      } else
        y([$], !0), z = (await rb(Y, l.disabled, o, S, n.shouldUseNativeValidation))[$], y([$]), R(pe), G && (z ? ie = !1 : (u.isValid || f.isValid) && (ie = await Q(i, !0)));
      G && (Y._f.deps && ke(Y._f.deps), ee($, ie, z, rn));
    }
  }, W = (w, _) => {
    if (Qe(r.errors, _) && w.focus)
      return w.focus(), 1;
  }, ke = async (w, _ = {}) => {
    let $, G;
    const Y = Ka(w);
    if (n.resolver) {
      const R = await ae(at(w) ? w : Y);
      $ = Ot(R), G = w ? !Y.some((z) => Qe(R, z)) : $;
    } else w ? (G = (await Promise.all(Y.map(async (R) => {
      const z = Qe(i, R);
      return await Q(z && z._f ? { [R]: z } : z);
    }))).every(Boolean), !(!G && !r.isValid) && F()) : G = $ = await Q(i);
    return h.state.next({
      ...!$r(w) || (u.isValid || f.isValid) && $ !== r.isValid ? {} : { name: w },
      ...n.resolver || !w ? { isValid: $ } : {},
      errors: r.errors
    }), _.shouldFocus && !G && Ga(i, W, w ? Y : l.mount), G;
  }, Ee = (w) => {
    const _ = {
      ...s.mount ? o : a
    };
    return at(w) ? _ : $r(w) ? Qe(_, w) : w.map(($) => Qe(_, $));
  }, K = (w, _) => ({
    invalid: !!Qe((_ || r).errors, w),
    isDirty: !!Qe((_ || r).dirtyFields, w),
    error: Qe((_ || r).errors, w),
    isValidating: !!Qe(r.validatingFields, w),
    isTouched: !!Qe((_ || r).touchedFields, w)
  }), qe = (w) => {
    w && Ka(w).forEach((_) => ft(r.errors, _)), h.state.next({
      errors: w ? r.errors : {}
    });
  }, Be = (w, _, $) => {
    const G = (Qe(i, w, { _f: {} })._f || {}).ref, Y = Qe(r.errors, w) || {}, { ref: R, message: z, type: ie, ...pe } = Y;
    Yn(r.errors, w, {
      ...pe,
      ..._,
      ref: G
    }), h.state.next({
      name: w,
      errors: r.errors,
      isValid: !1
    }), $ && $.shouldFocus && G && G.focus && G.focus();
  }, Pe = (w, _) => vr(w) ? h.state.subscribe({
    next: ($) => w(H(void 0, _), $)
  }) : H(w, _, !0), Me = (w) => h.state.subscribe({
    next: (_) => {
      _U(w.name, _.name, w.exact) && bU(_, w.formState || u, Re, w.reRenderRoot) && w.callback({
        values: { ...o },
        ...r,
        ..._
      });
    }
  }).unsubscribe, Fe = (w) => (s.mount = !0, f = {
    ...f,
    ...w.formState
  }, Me({
    ...w,
    formState: f
  })), Ae = (w, _ = {}) => {
    for (const $ of w ? Ka(w) : l.mount)
      l.mount.delete($), l.array.delete($), _.keepValue || (ft(i, $), ft(o, $)), !_.keepError && ft(r.errors, $), !_.keepDirty && ft(r.dirtyFields, $), !_.keepTouched && ft(r.touchedFields, $), !_.keepIsValidating && ft(r.validatingFields, $), !n.shouldUnregister && !_.keepDefaultValue && ft(a, $);
    h.state.next({
      values: St(o)
    }), h.state.next({
      ...r,
      ..._.keepDirty ? { isDirty: O() } : {}
    }), !_.keepIsValid && F();
  }, $e = ({ disabled: w, name: _ }) => {
    (Zt(w) && s.mount || w || l.disabled.has(_)) && (w ? l.disabled.add(_) : l.disabled.delete(_));
  }, tn = (w, _ = {}) => {
    let $ = Qe(i, w);
    const G = Zt(_.disabled) || Zt(n.disabled);
    return Yn(i, w, {
      ...$ || {},
      _f: {
        ...$ && $._f ? $._f : { ref: { name: w } },
        name: w,
        mount: !0,
        ..._
      }
    }), l.mount.add(w), $ ? $e({
      disabled: Zt(_.disabled) ? _.disabled : n.disabled,
      name: w
    }) : D(w, !0, _.value), {
      ...G ? { disabled: _.disabled || n.disabled } : {},
      ...n.progressive ? {
        required: !!_.required,
        min: Da(_.min),
        max: Da(_.max),
        minLength: Da(_.minLength),
        maxLength: Da(_.maxLength),
        pattern: Da(_.pattern)
      } : {},
      name: w,
      onChange: ue,
      onBlur: ue,
      ref: (Y) => {
        if (Y) {
          tn(w, _), $ = Qe(i, w);
          const R = at(Y.value) && Y.querySelectorAll && Y.querySelectorAll("input,select,textarea")[0] || Y, z = fU(R), ie = $._f.refs || [];
          if (z ? ie.find((pe) => pe === R) : R === $._f.ref)
            return;
          Yn(i, w, {
            _f: {
              ...$._f,
              ...z ? {
                refs: [
                  ...ie.filter(Lu),
                  R,
                  ...Array.isArray(Qe(a, w)) ? [{}] : []
                ],
                ref: { type: R.type, name: w }
              } : { ref: R }
            }
          }), D(w, !1, void 0, R);
        } else
          $ = Qe(i, w, {}), $._f && ($._f.mount = !1), (n.shouldUnregister || _.shouldUnregister) && !(fS(l.array, w) && s.action) && l.unMount.add(w);
      }
    };
  }, Ie = () => n.shouldFocusError && Ga(i, W, l.mount), We = (w) => {
    Zt(w) && (h.state.next({ disabled: w }), Ga(i, (_, $) => {
      const G = Qe(i, $);
      G && (_.disabled = G._f.disabled || w, Array.isArray(G._f.refs) && G._f.refs.forEach((Y) => {
        Y.disabled = G._f.disabled || w;
      }));
    }, 0, !1));
  }, Ze = (w, _) => async ($) => {
    let G;
    $ && ($.preventDefault && $.preventDefault(), $.persist && $.persist());
    let Y = St(o);
    if (h.state.next({
      isSubmitting: !0
    }), n.resolver) {
      const { errors: R, values: z } = await J();
      r.errors = R, Y = z;
    } else
      await Q(i);
    if (l.disabled.size)
      for (const R of l.disabled)
        Yn(Y, R, void 0);
    if (ft(r.errors, "root"), Ot(r.errors)) {
      h.state.next({
        errors: {}
      });
      try {
        await w(Y, $);
      } catch (R) {
        G = R;
      }
    } else
      _ && await _({ ...r.errors }, $), Ie(), setTimeout(Ie);
    if (h.state.next({
      isSubmitted: !0,
      isSubmitting: !1,
      isSubmitSuccessful: Ot(r.errors) && !G,
      submitCount: r.submitCount + 1,
      errors: r.errors
    }), G)
      throw G;
  }, de = (w, _ = {}) => {
    Qe(i, w) && (at(_.defaultValue) ? le(w, St(Qe(a, w))) : (le(w, _.defaultValue), Yn(a, w, St(_.defaultValue))), _.keepTouched || ft(r.touchedFields, w), _.keepDirty || (ft(r.dirtyFields, w), r.isDirty = _.defaultValue ? O(w, St(Qe(a, w))) : O()), _.keepError || (ft(r.errors, w), u.isValid && F()), h.state.next({ ...r }));
  }, fe = (w, _ = {}) => {
    const $ = w ? St(w) : a, G = St($), Y = Ot(w), R = Y ? a : G;
    if (_.keepDefaultValues || (a = $), !_.keepValues) {
      if (_.keepDirtyValues) {
        const z = /* @__PURE__ */ new Set([
          ...l.mount,
          ...Object.keys($a(a, o))
        ]);
        for (const ie of Array.from(z))
          Qe(r.dirtyFields, ie) ? Yn(R, ie, Qe(o, ie)) : le(ie, Qe(R, ie));
      } else {
        if (Bp && at(w))
          for (const z of l.mount) {
            const ie = Qe(i, z);
            if (ie && ie._f) {
              const pe = Array.isArray(ie._f.refs) ? ie._f.refs[0] : ie._f.ref;
              if (ws(pe)) {
                const _e = pe.closest("form");
                if (_e) {
                  _e.reset();
                  break;
                }
              }
            }
          }
        for (const z of l.mount)
          le(z, Qe(R, z));
      }
      o = St(R), h.array.next({
        values: { ...R }
      }), h.state.next({
        values: { ...R }
      });
    }
    l = {
      mount: _.keepDirtyValues ? l.mount : /* @__PURE__ */ new Set(),
      unMount: /* @__PURE__ */ new Set(),
      array: /* @__PURE__ */ new Set(),
      disabled: /* @__PURE__ */ new Set(),
      watch: /* @__PURE__ */ new Set(),
      watchAll: !1,
      focus: ""
    }, s.mount = !u.isValid || !!_.keepIsValid || !!_.keepDirtyValues, s.watch = !!n.shouldUnregister, h.state.next({
      submitCount: _.keepSubmitCount ? r.submitCount : 0,
      isDirty: Y ? !1 : _.keepDirty ? r.isDirty : !!(_.keepDefaultValues && !Xr(w, a)),
      isSubmitted: _.keepIsSubmitted ? r.isSubmitted : !1,
      dirtyFields: Y ? {} : _.keepDirtyValues ? _.keepDefaultValues && o ? $a(a, o) : r.dirtyFields : _.keepDefaultValues && w ? $a(a, w) : _.keepDirty ? r.dirtyFields : {},
      touchedFields: _.keepTouched ? r.touchedFields : {},
      errors: _.keepErrors ? r.errors : {},
      isSubmitSuccessful: _.keepIsSubmitSuccessful ? r.isSubmitSuccessful : !1,
      isSubmitting: !1
    });
  }, Te = (w, _) => fe(vr(w) ? w(o) : w, _), Le = (w, _ = {}) => {
    const $ = Qe(i, w), G = $ && $._f;
    if (G) {
      const Y = G.refs ? G.refs[0] : G.ref;
      Y.focus && (Y.focus(), _.shouldSelect && vr(Y.select) && Y.select());
    }
  }, Re = (w) => {
    r = {
      ...r,
      ...w
    };
  }, sn = {
    control: {
      register: tn,
      unregister: Ae,
      getFieldState: K,
      handleSubmit: Ze,
      setError: Be,
      _subscribe: Me,
      _runSchema: J,
      _getWatch: H,
      _getDirty: O,
      _setValid: F,
      _setFieldArray: q,
      _setDisabledField: $e,
      _setErrors: E,
      _getFieldArray: Z,
      _reset: fe,
      _resetDefaultValues: () => vr(n.defaultValues) && n.defaultValues().then((w) => {
        Te(w, n.resetOptions), h.state.next({
          isLoading: !1
        });
      }),
      _removeUnmounted: U,
      _disableForm: We,
      _subjects: h,
      _proxyFormState: u,
      get _fields() {
        return i;
      },
      get _formValues() {
        return o;
      },
      get _state() {
        return s;
      },
      set _state(w) {
        s = w;
      },
      get _defaultValues() {
        return a;
      },
      get _names() {
        return l;
      },
      set _names(w) {
        l = w;
      },
      get _formState() {
        return r;
      },
      get _options() {
        return n;
      },
      set _options(w) {
        n = {
          ...n,
          ...w
        };
      }
    },
    subscribe: Fe,
    trigger: ke,
    register: tn,
    handleSubmit: Ze,
    watch: Pe,
    setValue: le,
    getValues: Ee,
    reset: Te,
    resetField: de,
    clearErrors: qe,
    unregister: Ae,
    setError: Be,
    setFocus: Le,
    getFieldState: K
  };
  return {
    ...sn,
    formControl: sn
  };
}
function CU(e = {}) {
  const n = je.useRef(void 0), r = je.useRef(void 0), [i, a] = je.useState({
    isDirty: !1,
    isValidating: !1,
    isLoading: vr(e.defaultValues),
    isSubmitted: !1,
    isSubmitting: !1,
    isSubmitSuccessful: !1,
    isValid: !1,
    submitCount: 0,
    dirtyFields: {},
    touchedFields: {},
    validatingFields: {},
    errors: e.errors || {},
    disabled: e.disabled || !1,
    defaultValues: vr(e.defaultValues) ? void 0 : e.defaultValues
  });
  n.current || (n.current = {
    ...e.formControl ? e.formControl : wU(e),
    formState: i
  }, e.formControl && e.defaultValues && !vr(e.defaultValues) && e.formControl.reset(e.defaultValues, e.resetOptions));
  const o = n.current.control;
  return o._options = e, je.useLayoutEffect(() => o._subscribe({
    formState: o._proxyFormState,
    callback: () => a({ ...o._formState }),
    reRenderRoot: !0
  }), [o]), je.useEffect(() => o._disableForm(e.disabled), [o, e.disabled]), je.useEffect(() => {
    if (o._proxyFormState.isDirty) {
      const s = o._getDirty();
      s !== i.isDirty && o._subjects.state.next({
        isDirty: s
      });
    }
  }, [o, i.isDirty]), je.useEffect(() => {
    e.values && !Xr(e.values, r.current) ? (o._reset(e.values, o._options.resetOptions), r.current = e.values, a((s) => ({ ...s }))) : o._resetDefaultValues();
  }, [e.values, o]), je.useEffect(() => {
    e.errors && !Ot(e.errors) && o._setErrors(e.errors);
  }, [e.errors, o]), je.useEffect(() => {
    o._state.mount || (o._setValid(), o._state.mount = !0), o._state.watch && (o._state.watch = !1, o._subjects.state.next({ ...o._formState })), o._removeUnmounted();
  }), je.useEffect(() => {
    e.shouldUnregister && o._subjects.state.next({
      values: o._getWatch()
    });
  }, [e.shouldUnregister, o]), n.current.formState = yS(i, o), n.current;
}
const FU = "_modalBody_1clhs_1", IU = {
  modalBody: FU
}, EU = ({
  isOpen: e,
  onClose: n,
  pointsAccount: r,
  setHasPointsBeenUpdated: i,
  refetchPointsQuery: a
}) => {
  const { useMutation: o, showNotification: s } = mn(), { track: l } = bn(), d = r?.id, m = r?.balance ?? 0, u = {
    balance: m?.toString() ?? "0",
    description: "",
    transactionType: null
  }, { control: f, setValue: h, reset: v } = CU({
    defaultValues: u,
    mode: "onChange"
  }), C = vS({ control: f }), S = parseInt(C?.balance ?? "0", 10), j = m === S, F = j ? "Change the value to update the points" : "", y = S < 0, q = y ? "Points can not be negative" : "", T = C.description === "", E = T ? "Description can not be empty" : "";
  He(() => {
    S > m ? h(
      "transactionType",
      Nm.Addition
    ) : S < m && h(
      "transactionType",
      Nm.Deduction
    );
  }, [m, S, h]);
  const [D, { loading: B, error: ee, reset: J }] = o(J3, {
    onCompleted: () => {
      s({
        title: "Success",
        text: "Points updated successfully",
        icon: "check-circle-filled",
        severity: "success"
      });
    }
  }), ae = () => {
    if (d) {
      const U = I3();
      D({
        variables: {
          input: {
            accountId: d,
            transactionId: U,
            amount: Math.abs(S - m),
            transactionType: C.transactionType,
            description: C.description,
            source: uS.UpdateBalance
          }
        }
      }).then(async (O) => {
        O?.errors ? l("voyado:update:points:failed") : (l("voyado:update:points:succeeded"), i(!0), await a(), Q());
      }).catch(() => {
        l("voyado:update:points:failed");
      });
    }
  }, Q = () => {
    v(u), J(), n();
  };
  return /* @__PURE__ */ M.jsxs(
    wt,
    {
      isOpen: e,
      onClose: Q,
      "data-testid": "change-points-modal",
      children: [
        /* @__PURE__ */ M.jsx(Ct, { title: "Update points balance", onClose: Q }),
        /* @__PURE__ */ M.jsxs(Ft, { className: IU.modalBody, children: [
          /* @__PURE__ */ M.jsxs(vt, { children: [
            /* @__PURE__ */ M.jsx(ze, { span: 6, children: /* @__PURE__ */ M.jsx(
              Wk,
              {
                name: "balance",
                control: f,
                render: ({ field: U }) => /* @__PURE__ */ M.jsx(
                  cr,
                  {
                    label: "New points balance",
                    type: "number",
                    placeholder: "Insert new points",
                    min: 0,
                    max: 1e5,
                    meta: {
                      warning: F || q
                    },
                    input: {
                      ...U,
                      value: U.value.toString(),
                      onChange: (O) => U.onChange(O)
                    }
                  }
                )
              }
            ) }),
            /* @__PURE__ */ M.jsx(ze, { span: 6, children: /* @__PURE__ */ M.jsx(
              Wk,
              {
                name: "description",
                control: f,
                render: ({ field: U }) => /* @__PURE__ */ M.jsx(
                  cr,
                  {
                    required: !0,
                    label: "Description",
                    placeholder: "Insert a description",
                    input: U,
                    meta: {
                      warning: E
                    }
                  }
                )
              }
            ) })
          ] }),
          ee && /* @__PURE__ */ M.jsx(Fn, { error: ee })
        ] }),
        /* @__PURE__ */ M.jsx(
          Tt,
          {
            confirmName: "Save",
            confirmOnClick: () => ae(),
            confirmProps: {
              isLoading: B,
              disabled: j || y || T,
              loadingIndicator: /* @__PURE__ */ M.jsx(cn, { size: 16 })
            },
            cancelOnClick: Q
          }
        )
      ]
    }
  );
}, TU = "_wrapper_1ge6c_1", $U = "_block_1ge6c_12", ib = {
  wrapper: TU,
  block: $U
}, DU = ({
  contactAttributes: e,
  contactId: n
}) => {
  const { useQuery: r } = mn(), { isCopied: i, copy: a } = ls(), { isCopied: o, copy: s } = ls(), { isCopied: l, copy: d } = ls(), [m, u] = se(!1), [f, h] = se(), [v, C] = se(!1), {
    loading: S,
    data: j,
    refetch: F
  } = r(Y3, {
    variables: {
      contactId: n
    },
    skip: !n
  });
  He(() => {
    if (j) {
      const Z = j?.Voyado?.PointAccountV_GetPointAccounts;
      Z && Z?.length > 0 && h(Z[0]);
    }
  }, [j]);
  const y = !!f?.id, q = f?.balance ?? 0;
  if (!e)
    return null;
  const {
    firstName: T,
    lastName: E,
    street: D,
    zipCode: B,
    city: ee,
    country: J,
    isRegistrationCompleted: ae,
    email: Q,
    mobilePhone: U
  } = e, O = 14, H = `${T || ""} ${E || ""}`.trim() || "Anonymous";
  return /* @__PURE__ */ M.jsxs(b, { flexDirection: "column", className: ib.wrapper, children: [
    /* @__PURE__ */ M.jsxs(
      b,
      {
        justifyContent: "space-between",
        className: ib.block,
        alignItems: "center",
        children: [
          /* @__PURE__ */ M.jsx(A.Heading, { variant: "heading-2", children: H }),
          S && /* @__PURE__ */ M.jsx(cn, { size: 12 }),
          y && !S && /* @__PURE__ */ M.jsxs(b, { gap: "100", alignItems: "center", children: [
            /* @__PURE__ */ M.jsxs(Pn, { size: "small", variant: "warning", children: [
              q,
              " points"
            ] }),
            /* @__PURE__ */ M.jsx(Ge, { content: "Update points balance", children: /* @__PURE__ */ M.jsx(
              me,
              {
                name: "pen",
                size: 12,
                onClick: () => u(!0),
                className: nt.pointer
              }
            ) }),
            v && /* @__PURE__ */ M.jsx(Ge, { content: "It might take a while until the updated points are available. Please refresh the integration by collapsing and expanding the widget in the sidebar.", children: /* @__PURE__ */ M.jsx(
              me,
              {
                name: "info",
                size: 12,
                className: nt.pointer
              }
            ) })
          ] })
        ]
      }
    ),
    (D || ee || B || J || U || Q) && /* @__PURE__ */ M.jsxs(b, { gap: "200", flexDirection: "column", children: [
      U && /* @__PURE__ */ M.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
        /* @__PURE__ */ M.jsxs(b, { gap: "200", alignItems: "center", children: [
          /* @__PURE__ */ M.jsx(me, { size: O, name: "phone" }),
          /* @__PURE__ */ M.jsx(A.Paragraph, { variant: "4", children: U })
        ] }),
        /* @__PURE__ */ M.jsx(
          me,
          {
            size: O,
            name: o ? "done" : "copy",
            onClick: () => s(U),
            className: nt.pointer
          }
        )
      ] }),
      Q && /* @__PURE__ */ M.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
        /* @__PURE__ */ M.jsxs(b, { gap: "200", alignItems: "center", children: [
          /* @__PURE__ */ M.jsx(me, { size: O, name: "mail" }),
          /* @__PURE__ */ M.jsx(A.Paragraph, { variant: "4", children: Q })
        ] }),
        /* @__PURE__ */ M.jsx(
          me,
          {
            size: O,
            name: i ? "done" : "copy",
            onClick: () => a(Q),
            className: nt.pointer
          }
        )
      ] }),
      (D || ee || B || J) && /* @__PURE__ */ M.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
        /* @__PURE__ */ M.jsxs(b, { gap: "200", children: [
          /* @__PURE__ */ M.jsx(me, { size: O, name: "home" }),
          /* @__PURE__ */ M.jsxs(A.Paragraph, { variant: "4", color: "secondary", children: [
            /* @__PURE__ */ M.jsx(Zn, { children: D }),
            /* @__PURE__ */ M.jsxs(Zn, { children: [
              B,
              " ",
              ee
            ] }),
            /* @__PURE__ */ M.jsx(Zn, { children: J })
          ] })
        ] }),
        /* @__PURE__ */ M.jsx(
          me,
          {
            size: O,
            name: l ? "done" : "copy",
            onClick: () => d(`${D}, ${B} ${ee}, ${J}`),
            className: nt.pointer
          }
        )
      ] }),
      /* @__PURE__ */ M.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
        /* @__PURE__ */ M.jsxs(b, { gap: "200", alignItems: "center", children: [
          /* @__PURE__ */ M.jsx(me, { size: O, name: "sign-in" }),
          /* @__PURE__ */ M.jsx(A.Paragraph, { variant: "4", children: "Is registration completed" })
        ] }),
        /* @__PURE__ */ M.jsx(
          me,
          {
            name: ae ? "check-circle-filled" : "close-circle-filled",
            color: ae ? "green.500" : "neutral.500"
          }
        )
      ] })
    ] }),
    y && /* @__PURE__ */ M.jsx(
      EU,
      {
        isOpen: m,
        pointsAccount: f,
        onClose: () => u(!1),
        setHasPointsBeenUpdated: C,
        refetchPointsQuery: F
      }
    )
  ] });
}, RU = "_list_yud4a_7", OU = "_listItem_yud4a_11", PU = "_listItemTooltip_yud4a_15", AU = "_listItemTimestamp_yud4a_18", Ho = {
  list: RU,
  listItem: OU,
  listItemTooltip: PU,
  listItemTimestamp: AU
}, LU = ({
  contactConsents: e
}) => !e || e.length === 0 ? null : /* @__PURE__ */ M.jsxs(b, { gap: "200", flexDirection: "column", children: [
  /* @__PURE__ */ M.jsx(A.Heading, { variant: "heading-3", children: "Consents" }),
  /* @__PURE__ */ M.jsx(Ke, { className: Ho.list, children: e.map((n, r) => /* @__PURE__ */ M.jsx(Ke.Text, { variant: "dense", className: Ho.listItem, children: /* @__PURE__ */ M.jsxs(b, { justifyContent: "space-between", alignItems: "center", children: [
    /* @__PURE__ */ M.jsx(Ge, { content: n?.comment, children: /* @__PURE__ */ M.jsxs(
      b,
      {
        gap: "200",
        alignItems: "center",
        className: rt({
          [Ho.listItemTooltip]: n?.comment
        }),
        children: [
          /* @__PURE__ */ M.jsx(A.Paragraph, { variant: "4", children: n.id }),
          /* @__PURE__ */ M.jsx(A.Paragraph, { className: Ho.listItemTimestamp, children: Ln(n.date).format(yt) }),
          n?.comment && /* @__PURE__ */ M.jsx(me, { name: "info", color: "neutral.400" })
        ]
      }
    ) }),
    /* @__PURE__ */ M.jsx(
      me,
      {
        name: n.value ? "check-circle-filled" : "close-circle-filled",
        color: n.value ? "green.500" : "red.500"
      }
    )
  ] }) }, r)) })
] }), VU = ({
  memberLevel: e
}) => {
  const n = e?.levelName ?? null, r = e?.remainingToUpgrade ?? null, i = e?.basedOnRewardPoints ?? null, a = e?.latestChange ? Ln(e.latestChange).format(yt) : null, o = e?.expires ? `${Ln(e.expires).fromNow()} (${Ln(e.expires).format(yt)})` : null, s = !n && !a && !r && !i && !o;
  return /* @__PURE__ */ M.jsx(b, { gap: "200", flexDirection: "column", children: /* @__PURE__ */ M.jsxs(b, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ M.jsxs(b, { alignItems: "center", gap: "100", children: [
      /* @__PURE__ */ M.jsx(A.Heading, { variant: "heading-3", children: "Member level" }),
      /* @__PURE__ */ M.jsx(Ge, { content: "Voyado updates the member level data in a nightly batch process", children: /* @__PURE__ */ M.jsx(
        me,
        {
          name: "question",
          size: 14,
          className: nt.pointer
        }
      ) })
    ] }),
    /* @__PURE__ */ M.jsx(b, { flexDirection: "column", children: /* @__PURE__ */ M.jsxs(Ke, { className: nt.list, children: [
      s && /* @__PURE__ */ M.jsx(Ke.Text, { variant: "dense", className: nt.listItem, children: /* @__PURE__ */ M.jsx(A.Paragraph, { variant: "4", color: "secondary", children: "No member level properties found" }) }),
      n && /* @__PURE__ */ M.jsx(Ke.Text, { variant: "dense", className: nt.listItem, children: /* @__PURE__ */ M.jsx(Ge, { content: "", children: /* @__PURE__ */ M.jsxs(b, { justifyContent: "space-between", alignItems: "center", children: [
        /* @__PURE__ */ M.jsx(A.Paragraph, { variant: "4", children: "Level" }),
        /* @__PURE__ */ M.jsx(Pn, { variant: "info", size: "small", children: e?.levelName ?? "" })
      ] }) }) }),
      i && /* @__PURE__ */ M.jsx(Ke.Text, { variant: "dense", className: nt.listItem, children: /* @__PURE__ */ M.jsx(Ge, { content: "Voyado updates the member level data once a day in a nightly job", children: /* @__PURE__ */ M.jsxs(b, { justifyContent: "space-between", alignItems: "center", children: [
        /* @__PURE__ */ M.jsx(A.Paragraph, { variant: "4", children: "Based on reward points" }),
        /* @__PURE__ */ M.jsx(Pn, { variant: "success", size: "small", children: i })
      ] }) }) }),
      r && /* @__PURE__ */ M.jsx(Ke.Text, { variant: "dense", className: nt.listItem, children: /* @__PURE__ */ M.jsx(Ge, { content: "", children: /* @__PURE__ */ M.jsxs(b, { justifyContent: "space-between", alignItems: "center", children: [
        /* @__PURE__ */ M.jsx(A.Paragraph, { variant: "4", children: "Remaining to upgrade" }),
        /* @__PURE__ */ M.jsx(Pn, { variant: "success", size: "small", children: r })
      ] }) }) }),
      a && /* @__PURE__ */ M.jsx(Ke.Text, { variant: "dense", className: nt.listItem, children: /* @__PURE__ */ M.jsx(Ge, { content: "", children: /* @__PURE__ */ M.jsxs(b, { justifyContent: "space-between", alignItems: "center", children: [
        /* @__PURE__ */ M.jsx(A.Paragraph, { variant: "4", children: "Latest change" }),
        /* @__PURE__ */ M.jsx(A.Paragraph, { variant: "5", color: "secondary", children: a })
      ] }) }) }),
      o && /* @__PURE__ */ M.jsx(Ke.Text, { variant: "dense", className: nt.listItem, children: /* @__PURE__ */ M.jsx(Ge, { content: "", children: /* @__PURE__ */ M.jsxs(b, { justifyContent: "space-between", alignItems: "center", children: [
        /* @__PURE__ */ M.jsx(A.Paragraph, { variant: "4", children: "Expires" }),
        /* @__PURE__ */ M.jsx(A.Paragraph, { variant: "5", color: "secondary", children: o })
      ] }) }) })
    ] }) })
  ] }) });
}, zU = "_tagHover_kzbzk_1", UU = "_channelUnsubscribed_kzbzk_6", ab = {
  tagHover: zU,
  channelUnsubscribed: UU
}, Vu = ({
  isSubscribed: e,
  channelName: n,
  channelIcon: r,
  contactId: i,
  contactPreferences: a,
  refetchContact: o
}) => {
  const { track: s } = bn(), { useMutation: l } = mn(), [d, m] = se(!1), [u, { loading: f }] = l(Q3), h = async ({
    newPreference: C,
    isSubscribed: S,
    channelType: j
  }) => {
    m(!0), (await u({
      variables: {
        contactId: i,
        input: {
          preferences: {
            ...a,
            ...C
          }
        }
      }
    }))?.data?.Voyado.ContactsV_ContactPatch?.id ? S ? s("voyado:channel:unsubscribe:succeeded", { channel: j }) : s("voyado:channel:subscribe:succeeded", { channel: j }) : S ? s("voyado:channel:unsubscribe:failed", { channel: j }) : s("voyado:channel:subscribe:failed", { channel: j }), setTimeout(async () => {
      await o().finally(() => m(!1));
    }, 1e3);
  }, v = d || f;
  return /* @__PURE__ */ M.jsx(Ge, { content: e ? "Unsubscribe" : "Subscribe", children: /* @__PURE__ */ M.jsx(
    An,
    {
      className: ab.tagHover,
      color: e ? "green.500" : "neutral.200",
      children: /* @__PURE__ */ M.jsxs(
        b,
        {
          "data-testid": `widget-preference-${e ? "subscribed" : "unsubscribed"}`,
          gap: "200",
          alignItems: "center",
          className: rt({
            [ab.channelUnsubscribed]: !e
          }),
          onClick: () => {
            e ? s("voyado:channel:unsubscribe:clicked", {
              channel: n.toUpperCase()
            }) : s("voyado:channel:subscribe:clicked", {
              channel: n.toUpperCase()
            }), h({
              newPreference: { [`accepts${n}`]: !e },
              isSubscribed: e,
              channelType: n.toUpperCase()
            });
          },
          children: [
            v ? /* @__PURE__ */ M.jsx(cn, { size: 16 }) : /* @__PURE__ */ M.jsx(me, { size: 16, name: r }),
            n
          ]
        }
      )
    }
  ) });
}, MU = ({
  contactPreferences: e,
  contactId: n,
  refetchContact: r
}) => {
  if (!e || !n)
    return null;
  const { acceptsEmail: i, acceptsPostal: a, acceptsSms: o } = e;
  return /* @__PURE__ */ M.jsx(b, { gap: "200", flexDirection: "column", children: /* @__PURE__ */ M.jsxs(b, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ M.jsx(A.Heading, { variant: "heading-3", children: "Subscriptions" }),
    /* @__PURE__ */ M.jsxs(b, { gap: "100", flexDirection: "row", children: [
      /* @__PURE__ */ M.jsx(
        Vu,
        {
          channelName: "Email",
          channelIcon: "mail",
          isSubscribed: i,
          contactId: n,
          contactPreferences: e,
          refetchContact: r
        }
      ),
      /* @__PURE__ */ M.jsx(
        Vu,
        {
          channelName: "Sms",
          channelIcon: "sms",
          isSubscribed: o,
          contactId: n,
          contactPreferences: e,
          refetchContact: r
        }
      ),
      /* @__PURE__ */ M.jsx(
        Vu,
        {
          channelName: "Postal",
          channelIcon: "paper-plane",
          isSubscribed: a,
          contactId: n,
          contactPreferences: e,
          refetchContact: r
        }
      )
    ] })
  ] }) });
}, BU = ({
  contactId: e,
  settings: n
}) => {
  const {
    showCustomerAttributes: r,
    showPreferences: i,
    showAudiences: a,
    showConsents: o,
    showMemberLevel: s
  } = n, {
    isLoading: l,
    error: d,
    refetch: m,
    attributes: u,
    preferences: f,
    consents: h
  } = X3({ contactId: e }), {
    isLoading: v,
    error: C,
    memberLevel: S
  } = iU({ contactId: e, skip: !s }), j = v || l, F = Bn(
    () => h?.filter(
      (y) => y !== null
    ),
    [h]
  );
  return d || C ? io({
    errors: d?.graphQLErrors || C?.graphQLErrors || []
  }) ? /* @__PURE__ */ M.jsx(b, { justifyContent: "center", children: /* @__PURE__ */ M.jsx(A.Paragraph, { color: "secondary", children: "No contact informations found" }) }) : /* @__PURE__ */ M.jsx(Fn, { error: d || C }) : !r && !i && !a && !o && !s ? /* @__PURE__ */ M.jsx(b, { justifyContent: "center", children: /* @__PURE__ */ M.jsx(A.Paragraph, { color: "secondary", children: "All contact related features in the settings are disabled." }) }) : j ? /* @__PURE__ */ M.jsx(b, { justifyContent: "center", margin: "300", children: /* @__PURE__ */ M.jsx(cn, {}) }) : /* @__PURE__ */ M.jsxs(M.Fragment, { children: [
    r && /* @__PURE__ */ M.jsx(
      DU,
      {
        contactAttributes: u,
        contactId: e
      }
    ),
    s && /* @__PURE__ */ M.jsx(VU, { memberLevel: S }),
    i && /* @__PURE__ */ M.jsx(
      MU,
      {
        refetchContact: m,
        contactPreferences: f,
        contactId: e
      }
    ),
    o && /* @__PURE__ */ M.jsx(LU, { contactConsents: F })
  ] });
}, wm = (e, n) => `${e ? e.toFixed(2) : "0.00"} ${n}`, qU = "_list_zu4s7_1", HU = "_listItem_zu4s7_4", WU = "_listSum_zu4s7_7", Wo = {
  list: qU,
  listItem: HU,
  listSum: WU
}, KU = ({
  lineItems: e,
  localCurrency: n,
  localNetPriceSum: r
}) => /* @__PURE__ */ M.jsxs(Ke, { className: Wo.list, children: [
  e?.map(({ quantity: i, article: a, localPrice: o, type: s }, l) => /* @__PURE__ */ M.jsx(Ke.Text, { variant: "dense", className: Wo.listItem, children: /* @__PURE__ */ M.jsx(Ge, { content: s, children: /* @__PURE__ */ M.jsxs(b, { justifyContent: "space-between", gap: "200", children: [
    /* @__PURE__ */ M.jsxs(b, { flex: "0 0 auto", gap: "200", children: [
      /* @__PURE__ */ M.jsx(A.Paragraph, { variant: "4", children: i }),
      /* @__PURE__ */ M.jsx(A.Paragraph, { variant: "4", children: "×" })
    ] }),
    /* @__PURE__ */ M.jsx(b, { flex: "auto", children: /* @__PURE__ */ M.jsx(A.Paragraph, { variant: "4", children: a?.name }) }),
    o && n && /* @__PURE__ */ M.jsx(b, { flex: "0 0 auto", gap: "100", children: /* @__PURE__ */ M.jsx(A.Paragraph, { variant: "4", children: wm(o, n) }) })
  ] }) }) }, l)),
  /* @__PURE__ */ M.jsx(
    Ke.Text,
    {
      variant: "dense",
      className: rt(Wo.listItem, Wo.listSum),
      children: /* @__PURE__ */ M.jsxs(b, { gap: "100", justifyContent: "space-between", children: [
        /* @__PURE__ */ M.jsx(A.Paragraph, { variant: "3", children: "Sum" }),
        /* @__PURE__ */ M.jsx(A.Paragraph, { variant: "3", children: wm(r, n) })
      ] })
    },
    "theSumOfItAll"
  )
] }), GU = "_transaction_1kr8d_1", YU = "_transactionIsOpen_1kr8d_9", QU = "_transactionHeader_1kr8d_12", JU = "_transactionHeaderSubLine_1kr8d_15", XU = "_transactionHeaderAlignItemRight_1kr8d_19", $i = {
  transaction: GU,
  transactionIsOpen: YU,
  transactionHeader: QU,
  transactionHeaderSubLine: JU,
  transactionHeaderAlignItemRight: XU
}, ZU = ({
  transaction: e,
  openByDefault: n
}) => {
  const [r, i] = se(n), {
    transactionNumber: a,
    createdDate: o,
    storeName: s,
    numberOfItems: l,
    storeType: d,
    lineItems: m,
    localCurrency: u,
    localNetPriceSum: f
  } = e, h = u ?? "", v = f ?? 0, C = m?.length ? m : [];
  return /* @__PURE__ */ M.jsxs(
    b,
    {
      className: rt($i.transaction, {
        [$i.transactionIsOpen]: r
      }),
      gap: "300",
      flexDirection: "column",
      children: [
        /* @__PURE__ */ M.jsxs(
          b,
          {
            justifyContent: "space-between",
            alignItems: "center",
            className: $i.transactionHeader,
            onClick: () => i(!r),
            "data-testid": "contact-transaction-header",
            children: [
              /* @__PURE__ */ M.jsxs(b, { style: { flexGrow: 1 }, children: [
                /* @__PURE__ */ M.jsxs(b, { flexDirection: "column", gap: "100", children: [
                  o && /* @__PURE__ */ M.jsx(Pn, { size: "small", variant: "info", children: Ln(o).format(yt) }),
                  /* @__PURE__ */ M.jsxs(
                    A.Heading,
                    {
                      variant: "heading-4",
                      className: $i.transactionHeaderSubLine,
                      children: [
                        "ID: ",
                        a
                      ]
                    }
                  )
                ] }),
                /* @__PURE__ */ M.jsxs(
                  b,
                  {
                    flexDirection: "column",
                    gap: "100",
                    className: $i.transactionHeaderAlignItemRight,
                    children: [
                      /* @__PURE__ */ M.jsx(A.Heading, { variant: "heading-4", children: wm(v, h) }),
                      /* @__PURE__ */ M.jsxs(
                        A.Heading,
                        {
                          variant: "heading-4",
                          className: $i.transactionHeaderSubLine,
                          children: [
                            l,
                            " line ",
                            `${l === 1 ? "item" : "items"}`
                          ]
                        }
                      )
                    ]
                  }
                )
              ] }),
              /* @__PURE__ */ M.jsx(b, { flexDirection: "column", children: /* @__PURE__ */ M.jsx(
                Qt,
                {
                  variant: "tertiary",
                  icon: r ? "angle-up" : "angle-down"
                }
              ) })
            ]
          }
        ),
        r && /* @__PURE__ */ M.jsxs(
          b,
          {
            gap: "300",
            flexDirection: "column",
            "data-testid": "contact-transaction-content",
            children: [
              /* @__PURE__ */ M.jsx(Lm, {}),
              /* @__PURE__ */ M.jsxs(b, { gap: "100", flexDirection: "column", children: [
                s && /* @__PURE__ */ M.jsx(A.Heading, { variant: "heading-2", children: s }),
                d && /* @__PURE__ */ M.jsx(An, { children: /* @__PURE__ */ M.jsx(b, { alignItems: "center", children: d }) }),
                /* @__PURE__ */ M.jsx(
                  KU,
                  {
                    lineItems: C,
                    localCurrency: h,
                    localNetPriceSum: v
                  }
                )
              ] })
            ]
          }
        )
      ]
    }
  );
}, e4 = ({
  contactId: e
}) => {
  const {
    isLoading: n,
    error: r,
    transactions: i
  } = tU({ contactId: e });
  if (!e)
    return null;
  const { items: a, totalCount: o } = i, s = o ?? 0;
  return r ? /* @__PURE__ */ M.jsx(Fn, { error: r }) : /* @__PURE__ */ M.jsxs(
    b,
    {
      gap: "200",
      flexDirection: "column",
      "data-testid": "contact-transactions-wrapper",
      children: [
        /* @__PURE__ */ M.jsxs(b, { gap: "200", flexDirection: "row", alignItems: "center", children: [
          /* @__PURE__ */ M.jsx(A.Heading, { variant: "heading-3", children: "Transactions" }),
          !n && s > 0 && /* @__PURE__ */ M.jsx(Pn, { size: "small", variant: "success", children: s })
        ] }),
        n ? /* @__PURE__ */ M.jsx(b, { justifyContent: "center", margin: "300", children: /* @__PURE__ */ M.jsx(cn, {}) }) : /* @__PURE__ */ M.jsxs(M.Fragment, { children: [
          s === 0 && /* @__PURE__ */ M.jsx(b, { justifyContent: "center", padding: "200", children: /* @__PURE__ */ M.jsx(A.Paragraph, { variant: "4", color: "secondary", children: "There are no transactions for this contact" }) }),
          s > 0 && a?.map((l, d) => /* @__PURE__ */ M.jsx(
            ZU,
            {
              transaction: l,
              openByDefault: d === 0
            },
            d
          ))
        ] })
      ]
    }
  );
}, n4 = "_message_unsvt_48", t4 = "_messageIsOpen_unsvt_56", r4 = "_messageHeader_unsvt_60", i4 = "_messageText_unsvt_64", a4 = "_buttonLink_unsvt_86", Ra = {
  message: n4,
  messageIsOpen: t4,
  messageHeader: r4,
  messageText: i4,
  buttonLink: a4
}, zu = {
  status: {
    Delivered: "check-circle",
    Waiting: "clock",
    Hardbounce: "close-circle-filled",
    Softbounce: "close"
  },
  type: {
    EmailMessage: "mail",
    SmsMessage: "sms",
    PostalMessage: "paper-plane"
  },
  source: {
    Automation: "chat-bot",
    Manual: "user",
    System: "eye"
  }
}, Uu = (e, n) => n && e in zu && n in zu[e] ? zu[e][n] : null, o4 = ({
  message: e,
  openByDefault: n
}) => {
  const [r, i] = se(n), { track: a } = bn();
  if (!e)
    return null;
  const {
    name: o,
    sendDateTime: s,
    type: l,
    source: d,
    isTransactional: m,
    status: u,
    messageLink: f,
    messageText: h
  } = e, v = l ? Uu("type", l) : null, C = d ? Uu("source", d) : null, S = u ? Uu("status", u) : null, j = l?.replace("Message", "");
  return /* @__PURE__ */ M.jsxs(
    b,
    {
      className: rt(Ra.message, {
        [Ra.messageIsOpen]: r
      }),
      gap: "300",
      flexDirection: "column",
      children: [
        /* @__PURE__ */ M.jsxs(
          b,
          {
            justifyContent: "space-between",
            alignItems: "center",
            className: Ra.messageHeader,
            onClick: () => i(!r),
            children: [
              /* @__PURE__ */ M.jsxs(b, { gap: "100", flexDirection: "column", children: [
                /* @__PURE__ */ M.jsxs(b, { gap: "200", alignItems: "center", children: [
                  v && /* @__PURE__ */ M.jsxs(M.Fragment, { children: [
                    /* @__PURE__ */ M.jsx(me, { name: v, size: 16 }),
                    " ",
                    j
                  ] }),
                  s && /* @__PURE__ */ M.jsx(Pn, { size: "small", variant: "info", children: Ln(s).format(yt) })
                ] }),
                o
              ] }),
              /* @__PURE__ */ M.jsx(
                Qt,
                {
                  variant: "tertiary",
                  icon: r ? "angle-up" : "angle-down"
                }
              )
            ]
          }
        ),
        r && /* @__PURE__ */ M.jsxs(b, { gap: "300", flexDirection: "column", children: [
          /* @__PURE__ */ M.jsx(Lm, {}),
          /* @__PURE__ */ M.jsxs(b, { gap: "200", flexDirection: "row", flexWrap: "wrap", children: [
            S && /* @__PURE__ */ M.jsx(An, { children: /* @__PURE__ */ M.jsxs(b, { alignItems: "center", gap: "200", children: [
              /* @__PURE__ */ M.jsx(me, { name: S }),
              " ",
              u
            ] }) }),
            C && /* @__PURE__ */ M.jsx(An, { children: /* @__PURE__ */ M.jsxs(b, { alignItems: "center", gap: "200", children: [
              /* @__PURE__ */ M.jsx(me, { name: C }),
              " ",
              d
            ] }) }),
            m && /* @__PURE__ */ M.jsx(An, { children: /* @__PURE__ */ M.jsxs(b, { alignItems: "center", gap: "200", children: [
              /* @__PURE__ */ M.jsx(me, { name: "exchange" }),
              " Transactional"
            ] }) })
          ] }),
          /* @__PURE__ */ M.jsxs(b, { gap: "100", flexDirection: "column", children: [
            /* @__PURE__ */ M.jsx(A.Paragraph, { variant: "4", color: "secondary", children: "Message text" }),
            /* @__PURE__ */ M.jsx(A.Paragraph, { variant: "4", className: Ra.messageText, children: h })
          ] }),
          f && /* @__PURE__ */ M.jsx(
            jt,
            {
              slotEnd: /* @__PURE__ */ M.jsx(me, { name: "external-link" }),
              variant: "tertiary",
              className: Ra.buttonLink,
              navigate: () => {
                j && a("voyado:message:external-link:opened", {
                  channel: j.toUpperCase()
                }), window.open(f, "_blank")?.focus();
              },
              children: "Open message in new tab"
            }
          )
        ] })
      ]
    }
  );
}, s4 = ({
  contactId: e
}) => {
  const {
    isLoading: n,
    error: r,
    lastMessages: i
  } = eU({ contactId: e });
  if (!e)
    return null;
  if (r)
    return /* @__PURE__ */ M.jsx(Fn, { error: r });
  const { count: a, items: o } = i, s = (a && a) ?? 0, l = s > 0;
  return /* @__PURE__ */ M.jsxs(b, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ M.jsxs(b, { gap: "200", flexDirection: "row", alignItems: "center", children: [
      /* @__PURE__ */ M.jsx(A.Heading, { variant: "heading-3", children: "Last Messages" }),
      !n && l && /* @__PURE__ */ M.jsx(Pn, { variant: "success", size: "small", children: s })
    ] }),
    /* @__PURE__ */ M.jsx(b, { gap: "200", flexDirection: "column", children: n ? /* @__PURE__ */ M.jsx(b, { justifyContent: "center", margin: "300", children: /* @__PURE__ */ M.jsx(cn, {}) }) : /* @__PURE__ */ M.jsxs(M.Fragment, { children: [
      l && o?.map((d, m) => /* @__PURE__ */ M.jsx(
        o4,
        {
          message: d || void 0,
          openByDefault: m === 0
        },
        m
      )),
      !l && /* @__PURE__ */ M.jsx(b, { justifyContent: "center", margin: "200", children: /* @__PURE__ */ M.jsx(A.Paragraph, { variant: "4", color: "secondary", children: "No messages available" }) })
    ] }) })
  ] });
}, nl = ({
  value: e,
  currencyCode: n
}) => `${Number.parseFloat((e ?? 0).toString()).toFixed(2)} ${n ?? ""}`, ob = ({
  labelText: e,
  address: n,
  icon: r = "home"
}) => {
  const { isCopied: i, copy: a } = ls(), o = [n?.title, n?.firstname, n?.lastname].filter(Boolean).join(" "), s = tt(() => [
    o,
    n?.streetAddress,
    n?.streetAddress2,
    n?.postalCode,
    n?.region,
    n?.city,
    n?.country
  ].filter(Boolean).join(`
`), [n, o]);
  if (!n)
    return null;
  const l = 14;
  return /* @__PURE__ */ M.jsxs(b, { justifyContent: "space-between", children: [
    /* @__PURE__ */ M.jsxs(b, { gap: "250", flexDirection: "row", children: [
      /* @__PURE__ */ M.jsx(me, { size: l, name: r, color: "green.500" }),
      /* @__PURE__ */ M.jsxs(b, { gap: "200", flexDirection: "column", children: [
        /* @__PURE__ */ M.jsx(A.Paragraph, { variant: "3", children: e }),
        /* @__PURE__ */ M.jsxs(b, { gap: "100", flexDirection: "column", children: [
          o && /* @__PURE__ */ M.jsx(A.Paragraph, { variant: "4", children: o }),
          n?.streetAddress && /* @__PURE__ */ M.jsx(A.Paragraph, { variant: "4", children: n.streetAddress }),
          n?.streetAddress2 && /* @__PURE__ */ M.jsx(A.Paragraph, { variant: "4", children: n.streetAddress2 }),
          n?.postalCode && /* @__PURE__ */ M.jsx(A.Paragraph, { variant: "4", children: n?.postalCode }),
          n?.region && /* @__PURE__ */ M.jsx(A.Paragraph, { variant: "4", children: n.region }),
          n?.city && /* @__PURE__ */ M.jsx(A.Paragraph, { variant: "4", children: n.city }),
          n?.country && /* @__PURE__ */ M.jsx(A.Paragraph, { variant: "4", children: n.country })
        ] })
      ] })
    ] }),
    /* @__PURE__ */ M.jsx(Ge, { content: `Copy ${e.toLowerCase()}`, children: /* @__PURE__ */ M.jsx(
      me,
      {
        size: l,
        name: i ? "done" : "copy",
        onClick: () => a(s()),
        className: nt.pointer
      }
    ) })
  ] });
}, l4 = "_order_19t4p_1", c4 = "_orderIsOpen_19t4p_9", d4 = "_orderHeader_19t4p_12", u4 = "_orderIconColor_19t4p_15", Fr = {
  order: l4,
  orderIsOpen: c4,
  orderHeader: d4,
  orderIconColor: u4
}, m4 = "_delivery_1m9nb_1", p4 = "_deliveryCode_1m9nb_4", Mu = {
  delivery: m4,
  deliveryCode: p4
}, f4 = ({
  delivery: e
}) => {
  const { isCopied: n, copy: r } = nr();
  if (!e)
    return null;
  const { method: i, trackingNumber: a, trackingUri: o, deliveryDate: s } = e, l = 14;
  return /* @__PURE__ */ M.jsxs(b, { gap: "250", flexDirection: "row", children: [
    /* @__PURE__ */ M.jsx(
      me,
      {
        size: l,
        name: "eye",
        className: Fr.orderIconColor
      }
    ),
    /* @__PURE__ */ M.jsxs(b, { flexDirection: "column", gap: "200", width: "100%", children: [
      /* @__PURE__ */ M.jsx(A.Paragraph, { variant: "3", children: "Delivery" }),
      /* @__PURE__ */ M.jsx(
        Ge,
        {
          content: /* @__PURE__ */ M.jsxs(A.Paragraph, { variant: "4", color: "inherit", children: [
            "Arrives: ",
            Ln(s).format(yt)
          ] }),
          children: /* @__PURE__ */ M.jsxs(b, { gap: "100", flexDirection: "column", children: [
            o ? /* @__PURE__ */ M.jsx(
              A.ExternalLink,
              {
                href: o,
                target: "_blank",
                rel: "noreferrer",
                children: /* @__PURE__ */ M.jsxs(
                  b,
                  {
                    gap: "100",
                    alignItems: "center",
                    className: Mu.delivery,
                    children: [
                      /* @__PURE__ */ M.jsx(me, { name: "external-link", size: l }),
                      i
                    ]
                  }
                )
              }
            ) : i,
            /* @__PURE__ */ M.jsx(
              A.Paragraph,
              {
                variant: "4",
                className: rt(Mu.delivery, Mu.deliveryCode),
                children: a
              }
            )
          ] })
        }
      )
    ] }),
    a && /* @__PURE__ */ M.jsx(Ge, { content: "Copy tracking code", children: /* @__PURE__ */ M.jsx(
      me,
      {
        size: l,
        name: n ? "done" : "copy",
        onClick: () => r(a.toString()),
        className: nt.pointer
      }
    ) })
  ] });
}, h4 = ({
  fees: e,
  currencyCode: n
}) => {
  if (!e)
    return null;
  const r = e?.items ?? [];
  return /* @__PURE__ */ M.jsxs(b, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ M.jsxs(b, { gap: "250", flexDirection: "row", children: [
      /* @__PURE__ */ M.jsx(
        me,
        {
          size: 14,
          name: "file-text",
          className: Fr.orderIconColor
        }
      ),
      /* @__PURE__ */ M.jsx(A.Paragraph, { variant: "3", children: "Fees" })
    ] }),
    /* @__PURE__ */ M.jsx(Ke, { className: nt.list, children: r?.map((i, a) => /* @__PURE__ */ M.jsx(Ke.Item, { className: nt.listItem, children: /* @__PURE__ */ M.jsxs(
      b,
      {
        justifyContent: "space-between",
        alignItems: "center",
        width: "100%",
        children: [
          /* @__PURE__ */ M.jsxs(b, { flexDirection: "column", gap: "100", children: [
            /* @__PURE__ */ M.jsx(A.Paragraph, { variant: "5", children: i?.type }),
            /* @__PURE__ */ M.jsx(A.Paragraph, { variant: "4", children: i?.description })
          ] }),
          /* @__PURE__ */ M.jsx(b, { flexDirection: "column", gap: "100", children: i?.taxes?.items?.map((o, s) => /* @__PURE__ */ M.jsxs(
            b,
            {
              gap: "100",
              flexDirection: "column",
              className: nt.listItemAlignRight,
              children: [
                /* @__PURE__ */ M.jsx(A.Paragraph, { variant: "5", children: `${o?.description} ${o?.percent}%` }),
                /* @__PURE__ */ M.jsx(A.Paragraph, { variant: "4", children: nl({ value: o?.amount, currencyCode: n }) })
              ]
            },
            `tax-${s}`
          )) })
        ]
      }
    ) }, `fees-${a}`)) })
  ] });
}, y4 = ({
  lineItems: e,
  currencyCode: n
}) => {
  if (!e)
    return null;
  const r = e?.items ?? [];
  return /* @__PURE__ */ M.jsxs(b, { gap: "100", flexDirection: "column", children: [
    /* @__PURE__ */ M.jsxs(b, { gap: "250", flexDirection: "row", children: [
      /* @__PURE__ */ M.jsx(
        me,
        {
          size: 14,
          name: "tag",
          className: Fr.orderIconColor
        }
      ),
      /* @__PURE__ */ M.jsx(A.Paragraph, { variant: "3", children: "Line items" })
    ] }),
    /* @__PURE__ */ M.jsx(Ke, { className: nt.list, children: r?.map((i) => /* @__PURE__ */ M.jsx(
      Ke.Item,
      {
        className: nt.listItem,
        contentLeft: /* @__PURE__ */ M.jsxs(b, { gap: "200", children: [
          /* @__PURE__ */ M.jsx(A.Paragraph, { variant: "4", children: i?.quantity }),
          /* @__PURE__ */ M.jsx(A.Paragraph, { variant: "4", children: "×" })
        ] }),
        title: /* @__PURE__ */ M.jsx(
          Ge,
          {
            content: /* @__PURE__ */ M.jsx(A.Paragraph, { variant: "3", color: "inherit", children: i?.article?.sku }),
            children: /* @__PURE__ */ M.jsxs(b, { gap: "100", flexDirection: "column", children: [
              /* @__PURE__ */ M.jsx(A.Paragraph, { variant: "4", children: i?.article?.name }),
              /* @__PURE__ */ M.jsx(b, { children: /* @__PURE__ */ M.jsx(Pn, { size: "small", variant: "info", children: nl({
                value: i?.totalPrice,
                currencyCode: n
              }) }) })
            ] })
          }
        ),
        contentRight: i?.article?.imageUri && /* @__PURE__ */ M.jsx(
          Wi,
          {
            src: i?.article?.imageUri,
            alt: i?.article?.name,
            style: { height: "48px" }
          }
        )
      },
      `list-${i?.id}`
    )) })
  ] });
}, g4 = ({
  payments: e,
  currencyCode: n
}) => {
  if (!e)
    return null;
  const r = e?.items ?? [];
  return /* @__PURE__ */ M.jsxs(b, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ M.jsxs(b, { gap: "250", flexDirection: "row", children: [
      /* @__PURE__ */ M.jsx(
        me,
        {
          size: 14,
          name: "credit-card",
          className: Fr.orderIconColor
        }
      ),
      /* @__PURE__ */ M.jsx(A.Paragraph, { variant: "3", children: "Payment methods" })
    ] }),
    /* @__PURE__ */ M.jsx(Ke, { className: nt.list, children: r?.map((i, a) => /* @__PURE__ */ M.jsx(
      Ke.Item,
      {
        className: nt.listItem,
        children: /* @__PURE__ */ M.jsxs(
          b,
          {
            justifyContent: "space-between",
            alignItems: "center",
            width: "100%",
            children: [
              /* @__PURE__ */ M.jsxs(b, { flexDirection: "column", gap: "100", children: [
                /* @__PURE__ */ M.jsx(A.Paragraph, { variant: "5", children: i?.description }),
                /* @__PURE__ */ M.jsx(A.Paragraph, { variant: "4", children: i?.method })
              ] }),
              /* @__PURE__ */ M.jsxs(
                b,
                {
                  gap: "100",
                  flexDirection: "column",
                  className: nt.listItemAlignRight,
                  children: [
                    /* @__PURE__ */ M.jsx(A.Paragraph, { variant: "5", children: Ln(i?.paidAt).format(yt) }),
                    /* @__PURE__ */ M.jsx(A.Paragraph, { variant: "4", children: nl({ value: i?.amount, currencyCode: n }) })
                  ]
                }
              )
            ]
          }
        )
      },
      `payments-${a}`
    )) })
  ] });
}, v4 = ({
  order: e,
  openByDefault: n
}) => {
  const [r, i] = se(n);
  if (!e)
    return null;
  const {
    orderId: a,
    status: o,
    externalStatus: s,
    currencyCode: l,
    channel: d,
    createdAt: m,
    lastChangedAt: u,
    lineItems: f,
    billingAddress: h,
    deliveryAddress: v,
    totalPrice: C
  } = e, S = 14;
  return /* @__PURE__ */ M.jsxs(
    b,
    {
      className: rt(Fr.order, {
        [Fr.orderIsOpen]: r
      }),
      gap: "200",
      flexDirection: "column",
      children: [
        /* @__PURE__ */ M.jsxs(
          b,
          {
            justifyContent: "space-between",
            alignItems: "center",
            className: Fr.orderHeader,
            onClick: () => i(!r),
            children: [
              /* @__PURE__ */ M.jsxs(b, { gap: "100", flexDirection: "column", children: [
                m && /* @__PURE__ */ M.jsx(b, { alignItems: "center", children: /* @__PURE__ */ M.jsx(A.Paragraph, { variant: "4", children: Ln(m).format(yt) }) }),
                /* @__PURE__ */ M.jsx(A.Paragraph, { variant: "1", children: a })
              ] }),
              /* @__PURE__ */ M.jsx(
                Qt,
                {
                  variant: "tertiary",
                  icon: r ? "angle-down" : "angle-right"
                }
              )
            ]
          }
        ),
        r && /* @__PURE__ */ M.jsxs(b, { gap: "250", flexDirection: "column", margin: "200 0 0", children: [
          /* @__PURE__ */ M.jsxs(b, { gap: "250", children: [
            /* @__PURE__ */ M.jsx(
              me,
              {
                size: S,
                name: "activity",
                className: Fr.orderIconColor
              }
            ),
            /* @__PURE__ */ M.jsxs(b, { flexDirection: "column", gap: "200", children: [
              /* @__PURE__ */ M.jsx(A.Paragraph, { variant: "3", children: "Order status" }),
              /* @__PURE__ */ M.jsxs(b, { gap: "100", alignItems: "center", flexWrap: "wrap", children: [
                o && /* @__PURE__ */ M.jsx(Ge, { content: "Internal status", children: /* @__PURE__ */ M.jsx(Pn, { size: "small", variant: "info", children: /* @__PURE__ */ M.jsx(M.Fragment, { children: o }) }) }),
                s && /* @__PURE__ */ M.jsx(Ge, { content: "External status", children: /* @__PURE__ */ M.jsx(Pn, { size: "small", variant: "info", children: /* @__PURE__ */ M.jsx(M.Fragment, { children: s }) }) }),
                /* @__PURE__ */ M.jsx(Ge, { content: "Last updated at", children: /* @__PURE__ */ M.jsx(A.Paragraph, { as: "span", variant: "5", children: Ln(u).format(yt) }) })
              ] })
            ] })
          ] }),
          /* @__PURE__ */ M.jsxs(b, { gap: "250", children: [
            /* @__PURE__ */ M.jsx(
              me,
              {
                size: S,
                name: "chart-bar",
                className: Fr.orderIconColor
              }
            ),
            /* @__PURE__ */ M.jsxs(b, { flexDirection: "column", gap: "200", children: [
              /* @__PURE__ */ M.jsx(A.Paragraph, { variant: "3", children: "Order value" }),
              /* @__PURE__ */ M.jsx(A.Paragraph, { variant: "4", children: nl({
                value: C,
                currencyCode: l
              }) })
            ] })
          ] }),
          d && /* @__PURE__ */ M.jsxs(b, { gap: "250", children: [
            /* @__PURE__ */ M.jsx(
              me,
              {
                size: S,
                name: "channels",
                className: Fr.orderIconColor
              }
            ),
            /* @__PURE__ */ M.jsxs(b, { flexDirection: "column", gap: "200", children: [
              /* @__PURE__ */ M.jsx(A.Paragraph, { variant: "3", children: "Channel" }),
              /* @__PURE__ */ M.jsx(A.Paragraph, { variant: "4", children: /* @__PURE__ */ M.jsx(Pn, { size: "small", variant: "info", children: /* @__PURE__ */ M.jsx(M.Fragment, { children: d }) }) })
            ] })
          ] }),
          /* @__PURE__ */ M.jsx(ob, { labelText: "Billing address", address: h }),
          /* @__PURE__ */ M.jsx(
            ob,
            {
              icon: "map-pin",
              labelText: "Delivery address",
              address: v
            }
          ),
          /* @__PURE__ */ M.jsx(f4, { delivery: e.delivery }),
          /* @__PURE__ */ M.jsx(y4, { lineItems: f, currencyCode: l }),
          /* @__PURE__ */ M.jsx(h4, { fees: e.fees, currencyCode: l }),
          /* @__PURE__ */ M.jsx(
            g4,
            {
              payments: e.payments,
              currencyCode: l
            }
          )
        ] })
      ]
    }
  );
}, k4 = ({
  error: e,
  itemCount: n,
  children: r
}) => e ? n === 0 || io({
  errors: e.graphQLErrors
}) ? /* @__PURE__ */ M.jsx(b, { justifyContent: "center", children: /* @__PURE__ */ M.jsx(A.Paragraph, { variant: "4", color: "secondary", children: "There are no orders for this contact" }) }) : /* @__PURE__ */ M.jsx(Fn, { error: e }) : /* @__PURE__ */ M.jsx(M.Fragment, { children: r }), b4 = ({
  contactId: e
}) => {
  const { useQuery: n } = mn(), [r, i] = se([]), { track: a } = bn(), {
    loading: o,
    error: s,
    data: l
  } = n(G3, {
    skip: !e,
    variables: {
      contactId: e
    }
  });
  return He(() => {
    if (l?.Voyado) {
      const d = l?.Voyado.Orders_GetAllByContact;
      if (!o && d?.items) {
        i(d.items);
        const { totalCount: m } = d;
        m && a("voyado:orders:received", { count: m });
      }
    }
  }, [l?.Voyado]), e ? /* @__PURE__ */ M.jsxs(b, { gap: "200", flexDirection: "column", margin: "200 0 300 0", children: [
    /* @__PURE__ */ M.jsxs(b, { gap: "200", flexDirection: "row", alignItems: "center", children: [
      /* @__PURE__ */ M.jsx(A.Heading, { variant: "heading-3", children: "Orders" }),
      r.length > 0 && /* @__PURE__ */ M.jsx(Pn, { size: "small", variant: "success", children: r.length })
    ] }),
    o ? /* @__PURE__ */ M.jsx(b, { justifyContent: "center", children: /* @__PURE__ */ M.jsx(cn, {}) }) : /* @__PURE__ */ M.jsx(k4, { error: s, itemCount: r.length, children: r.map((d, m) => /* @__PURE__ */ M.jsx(
      v4,
      {
        order: d,
        openByDefault: m === 0
      },
      m
    )) })
  ] }) : null;
}, _4 = ({
  conversationContext: e,
  settings: n
}) => {
  const { isLoading: r, contactId: i, hasMultipleContacts: a, error: o } = rU({
    conversationContext: e
  }), s = !e?.customer?.email && !e?.customer?.phone_number, l = !!i, {
    showCustomerAttributes: d,
    showPreferences: m,
    showAudiences: u,
    showConsents: f,
    showLastMessages: h,
    showCustomerTransactions: v,
    showOrders: C
  } = n;
  return s ? /* @__PURE__ */ M.jsx(
    b,
    {
      justifyContent: "center",
      margin: "200 0 300 0",
      "data-testid": "widget-no-contact-message",
      children: /* @__PURE__ */ M.jsx(A.Paragraph, { variant: "4", color: "secondary", children: "No email nor phone number are available in this conversation to look up a profile." })
    }
  ) : a ? /* @__PURE__ */ M.jsx(
    b,
    {
      justifyContent: "center",
      margin: "200 0 300 0",
      "data-testid": "multiple-contacts-found-message",
      children: /* @__PURE__ */ M.jsx(A.Paragraph, { variant: "4", color: "secondary", children: "We found multiple profile IDs that match your email or phone number. To display customer informations, we need a unique profile id. Please make sure that the customers data is normalized." })
    }
  ) : o ? io({
    errors: o.graphQLErrors
  }) ? /* @__PURE__ */ M.jsx(b, { justifyContent: "center", margin: "200 0 300 0", children: /* @__PURE__ */ M.jsx(A.Paragraph, { variant: "4", color: "secondary", children: "No profile found" }) }) : /* @__PURE__ */ M.jsx(Fn, { error: o }) : !d && !m && !u && !f && !h && !v ? /* @__PURE__ */ M.jsx(b, { justifyContent: "center", margin: "200 0 300 0", children: /* @__PURE__ */ M.jsx(A.Paragraph, { variant: "4", color: "secondary", children: "All features toggles in the widget settings are disabled." }) }) : r ? /* @__PURE__ */ M.jsx(b, { justifyContent: "center", margin: "300", children: /* @__PURE__ */ M.jsx(cn, {}) }) : /* @__PURE__ */ M.jsxs(
    b,
    {
      gap: "300",
      flexDirection: "column",
      margin: "200 0 300 0",
      "data-testid": "widget-wrapper",
      children: [
        /* @__PURE__ */ M.jsx(BU, { contactId: i, settings: n }),
        h && /* @__PURE__ */ M.jsx(s4, { contactId: i }),
        v && /* @__PURE__ */ M.jsx(e4, { contactId: i }),
        C && /* @__PURE__ */ M.jsx(b4, { contactId: i }),
        !l && /* @__PURE__ */ M.jsx(b, { justifyContent: "center", padding: "200", children: /* @__PURE__ */ M.jsx(A.Paragraph, { variant: "4", color: "secondary", children: "No contact found." }) })
      ]
    }
  );
}, x4 = [
  {
    key: "voyadoApiKey",
    label: "API key",
    placeholder: "API key from Voyado",
    required: !0,
    secret: !0,
    type: "input"
  },
  {
    key: "apiHostName",
    label: "API URL",
    placeholder: "The URL of the Voyado API",
    required: !0,
    secret: !1,
    type: "input",
    prefix: "https://"
  },
  {
    key: "showCustomerAttributes",
    label: "Show the customer attributes",
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "showPreferences",
    label: "Show preferences",
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "showAudiences",
    label: "Show audiences",
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "showConsents",
    label: "Show consents",
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "showLastMessages",
    label: "Show the last 5 messages",
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "showCustomerTransactions",
    label: "Show customer transactions",
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "showOrders",
    label: "Show orders by contact",
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "showMemberLevel",
    label: "Show member level",
    secret: !1,
    type: "switch",
    defaultValue: !0
  }
];
(function() {
  try {
    if (typeof document < "u") {
      var e = document.createElement("style");
      e.appendChild(document.createTextNode("._copyIcon_11mz1_48{cursor:pointer;color:var(--dixa-typography-color-secondary)}._list_11mz1_53{padding:0;overflow-y:auto;max-height:230px;background:linear-gradient(var(--dixa-color-neutral-000) 33%,rgba(255,255,255,0)),linear-gradient(rgba(255,255,255,0),var(--dixa-color-neutral-000) 66%) 0 100%,radial-gradient(farthest-side at 50% 0,var(--dixa-color-neutral-200),rgba(0,0,0,0)),radial-gradient(farthest-side at 50% 100%,var(--dixa-color-neutral-200),rgba(0,0,0,0)) 0 100%;background-color:var(--dixa-color-neutral-000);background-repeat:no-repeat;background-attachment:local,local,scroll,scroll;background-size:100% var(--dixa-size-spacer-400),100% var(--dixa-size-spacer-400),100% var(--dixa-size-spacer-200),100% var(--dixa-size-spacer-200)}._listItem_11mz1_63{cursor:pointer;background-color:transparent;padding:var(--dixa-size-spacer-100);box-shadow:inset 0 calc(-1 * var(--dixa-size-border-100)) 0 var(--dixa-color-neutral-200)}._listItem_11mz1_63:last-child{box-shadow:none}._listItemHighlighted_11mz1_72{border-left:8px solid var(--dixa-color-orange-300)}._wrapper_1xucg_1{border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-300);background-color:var(--dixa-color-neutral-100)}._externalLink_1xucg_7{color:var(--dixa-typography-color-primary);font-size:var(--dixa-typography-size-200)}._settingsWrapper_1ycvy_1{border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);margin-bottom:var(--dixa-size-spacer-300)}._settingsWrapperHeader_1ycvy_6{cursor:pointer;padding:var(--dixa-size-spacer-300)}._settingsWrapperContent_1ycvy_10{border-top:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);padding:var(--dixa-size-spacer-300);line-height:var(--dixa-typography-line-height-400)}._settingsWrapperContent_1ycvy_10 ol{margin-bottom:0}._settingsWrapperContentCode_1ycvy_18{background-color:var(--dixa-color-neutral-200);border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-100);border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);font-family:var(--dixa-typography-family-code);font-size:var(--dixa-typography-size-200)}._settingsWrapperContentCURL_1ycvy_26{overflow:auto;padding:var(--dixa-size-spacer-100) var(--dixa-size-spacer-300);font-family:var(--dixa-typography-family-code);color:var(--dixa-typography-color-secondary);background-color:var(--dixa-color-neutral-100);border-radius:var(--dixa-size-border-radius-100);border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300)}")), document.head.appendChild(e);
    }
  } catch (n) {
    console.error("vite-plugin-css-injected-by-js", n);
  }
})();
var Bu = { exports: {} }, Oa = {}, sb;
function S4() {
  if (sb) return Oa;
  sb = 1;
  var e = je, n = Symbol.for("react.element"), r = Symbol.for("react.fragment"), i = Object.prototype.hasOwnProperty, a = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, o = { key: !0, ref: !0, __self: !0, __source: !0 };
  function s(l, d, m) {
    var u, f = {}, h = null, v = null;
    m !== void 0 && (h = "" + m), d.key !== void 0 && (h = "" + d.key), d.ref !== void 0 && (v = d.ref);
    for (u in d) i.call(d, u) && !o.hasOwnProperty(u) && (f[u] = d[u]);
    if (l && l.defaultProps) for (u in d = l.defaultProps, d) f[u] === void 0 && (f[u] = d[u]);
    return { $$typeof: n, type: l, key: h, ref: v, props: f, _owner: a.current };
  }
  return Oa.Fragment = r, Oa.jsx = s, Oa.jsxs = s, Oa;
}
var Ko = {}, lb;
function N4() {
  return lb || (lb = 1, process.env.NODE_ENV !== "production" && (function() {
    var e = je, n = Symbol.for("react.element"), r = Symbol.for("react.portal"), i = Symbol.for("react.fragment"), a = Symbol.for("react.strict_mode"), o = Symbol.for("react.profiler"), s = Symbol.for("react.provider"), l = Symbol.for("react.context"), d = Symbol.for("react.forward_ref"), m = Symbol.for("react.suspense"), u = Symbol.for("react.suspense_list"), f = Symbol.for("react.memo"), h = Symbol.for("react.lazy"), v = Symbol.for("react.offscreen"), C = Symbol.iterator, S = "@@iterator";
    function j(t) {
      if (t === null || typeof t != "object")
        return null;
      var c = C && t[C] || t[S];
      return typeof c == "function" ? c : null;
    }
    var F = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function y(t) {
      {
        for (var c = arguments.length, p = new Array(c > 1 ? c - 1 : 0), g = 1; g < c; g++)
          p[g - 1] = arguments[g];
        q("error", t, p);
      }
    }
    function q(t, c, p) {
      {
        var g = F.ReactDebugCurrentFrame, P = g.getStackAddendum();
        P !== "" && (c += "%s", p = p.concat([P]));
        var L = p.map(function(I) {
          return String(I);
        });
        L.unshift("Warning: " + c), Function.prototype.apply.call(console[t], console, L);
      }
    }
    var T = !1, E = !1, D = !1, B = !1, ee = !1, J;
    J = Symbol.for("react.module.reference");
    function ae(t) {
      return !!(typeof t == "string" || typeof t == "function" || t === i || t === o || ee || t === a || t === m || t === u || B || t === v || T || E || D || typeof t == "object" && t !== null && (t.$$typeof === h || t.$$typeof === f || t.$$typeof === s || t.$$typeof === l || t.$$typeof === d || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      t.$$typeof === J || t.getModuleId !== void 0));
    }
    function Q(t, c, p) {
      var g = t.displayName;
      if (g)
        return g;
      var P = c.displayName || c.name || "";
      return P !== "" ? p + "(" + P + ")" : p;
    }
    function U(t) {
      return t.displayName || "Context";
    }
    function O(t) {
      if (t == null)
        return null;
      if (typeof t.tag == "number" && y("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof t == "function")
        return t.displayName || t.name || null;
      if (typeof t == "string")
        return t;
      switch (t) {
        case i:
          return "Fragment";
        case r:
          return "Portal";
        case o:
          return "Profiler";
        case a:
          return "StrictMode";
        case m:
          return "Suspense";
        case u:
          return "SuspenseList";
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case l:
            var c = t;
            return U(c) + ".Consumer";
          case s:
            var p = t;
            return U(p._context) + ".Provider";
          case d:
            return Q(t, t.render, "ForwardRef");
          case f:
            var g = t.displayName || null;
            return g !== null ? g : O(t.type) || "Memo";
          case h: {
            var P = t, L = P._payload, I = P._init;
            try {
              return O(I(L));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var H = Object.assign, Z = 0, ye, ce, le, ue, W, ke, Ee;
    function K() {
    }
    K.__reactDisabledLog = !0;
    function qe() {
      {
        if (Z === 0) {
          ye = console.log, ce = console.info, le = console.warn, ue = console.error, W = console.group, ke = console.groupCollapsed, Ee = console.groupEnd;
          var t = {
            configurable: !0,
            enumerable: !0,
            value: K,
            writable: !0
          };
          Object.defineProperties(console, {
            info: t,
            log: t,
            warn: t,
            error: t,
            group: t,
            groupCollapsed: t,
            groupEnd: t
          });
        }
        Z++;
      }
    }
    function Be() {
      {
        if (Z--, Z === 0) {
          var t = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: H({}, t, {
              value: ye
            }),
            info: H({}, t, {
              value: ce
            }),
            warn: H({}, t, {
              value: le
            }),
            error: H({}, t, {
              value: ue
            }),
            group: H({}, t, {
              value: W
            }),
            groupCollapsed: H({}, t, {
              value: ke
            }),
            groupEnd: H({}, t, {
              value: Ee
            })
          });
        }
        Z < 0 && y("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var Pe = F.ReactCurrentDispatcher, Me;
    function Fe(t, c, p) {
      {
        if (Me === void 0)
          try {
            throw Error();
          } catch (P) {
            var g = P.stack.trim().match(/\n( *(at )?)/);
            Me = g && g[1] || "";
          }
        return `
` + Me + t;
      }
    }
    var Ae = !1, $e;
    {
      var tn = typeof WeakMap == "function" ? WeakMap : Map;
      $e = new tn();
    }
    function Ie(t, c) {
      if (!t || Ae)
        return "";
      {
        var p = $e.get(t);
        if (p !== void 0)
          return p;
      }
      var g;
      Ae = !0;
      var P = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var L;
      L = Pe.current, Pe.current = null, qe();
      try {
        if (c) {
          var I = function() {
            throw Error();
          };
          if (Object.defineProperty(I.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(I, []);
            } catch (ne) {
              g = ne;
            }
            Reflect.construct(t, [], I);
          } else {
            try {
              I.call();
            } catch (ne) {
              g = ne;
            }
            t.call(I.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (ne) {
            g = ne;
          }
          t();
        }
      } catch (ne) {
        if (ne && g && typeof ne.stack == "string") {
          for (var N = ne.stack.split(`
`), te = g.stack.split(`
`), x = N.length - 1, V = te.length - 1; x >= 1 && V >= 0 && N[x] !== te[V]; )
            V--;
          for (; x >= 1 && V >= 0; x--, V--)
            if (N[x] !== te[V]) {
              if (x !== 1 || V !== 1)
                do
                  if (x--, V--, V < 0 || N[x] !== te[V]) {
                    var X = `
` + N[x].replace(" at new ", " at ");
                    return t.displayName && X.includes("<anonymous>") && (X = X.replace("<anonymous>", t.displayName)), typeof t == "function" && $e.set(t, X), X;
                  }
                while (x >= 1 && V >= 0);
              break;
            }
        }
      } finally {
        Ae = !1, Pe.current = L, Be(), Error.prepareStackTrace = P;
      }
      var we = t ? t.displayName || t.name : "", Se = we ? Fe(we) : "";
      return typeof t == "function" && $e.set(t, Se), Se;
    }
    function We(t, c, p) {
      return Ie(t, !1);
    }
    function Ze(t) {
      var c = t.prototype;
      return !!(c && c.isReactComponent);
    }
    function de(t, c, p) {
      if (t == null)
        return "";
      if (typeof t == "function")
        return Ie(t, Ze(t));
      if (typeof t == "string")
        return Fe(t);
      switch (t) {
        case m:
          return Fe("Suspense");
        case u:
          return Fe("SuspenseList");
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case d:
            return We(t.render);
          case f:
            return de(t.type, c, p);
          case h: {
            var g = t, P = g._payload, L = g._init;
            try {
              return de(L(P), c, p);
            } catch {
            }
          }
        }
      return "";
    }
    var fe = Object.prototype.hasOwnProperty, Te = {}, Le = F.ReactDebugCurrentFrame;
    function Re(t) {
      if (t) {
        var c = t._owner, p = de(t.type, t._source, c ? c.type : null);
        Le.setExtraStackFrame(p);
      } else
        Le.setExtraStackFrame(null);
    }
    function sn(t, c, p, g, P) {
      {
        var L = Function.call.bind(fe);
        for (var I in t)
          if (L(t, I)) {
            var N = void 0;
            try {
              if (typeof t[I] != "function") {
                var te = Error((g || "React class") + ": " + p + " type `" + I + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof t[I] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw te.name = "Invariant Violation", te;
              }
              N = t[I](c, I, g, p, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (x) {
              N = x;
            }
            N && !(N instanceof Error) && (Re(P), y("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", g || "React class", p, I, typeof N), Re(null)), N instanceof Error && !(N.message in Te) && (Te[N.message] = !0, Re(P), y("Failed %s type: %s", p, N.message), Re(null));
          }
      }
    }
    var w = Array.isArray;
    function _(t) {
      return w(t);
    }
    function $(t) {
      {
        var c = typeof Symbol == "function" && Symbol.toStringTag, p = c && t[Symbol.toStringTag] || t.constructor.name || "Object";
        return p;
      }
    }
    function G(t) {
      try {
        return Y(t), !1;
      } catch {
        return !0;
      }
    }
    function Y(t) {
      return "" + t;
    }
    function R(t) {
      if (G(t))
        return y("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", $(t)), Y(t);
    }
    var z = F.ReactCurrentOwner, ie = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, pe, _e;
    function en(t) {
      if (fe.call(t, "ref")) {
        var c = Object.getOwnPropertyDescriptor(t, "ref").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.ref !== void 0;
    }
    function un(t) {
      if (fe.call(t, "key")) {
        var c = Object.getOwnPropertyDescriptor(t, "key").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.key !== void 0;
    }
    function rn(t, c) {
      typeof t.ref == "string" && z.current;
    }
    function dn(t, c) {
      {
        var p = function() {
          pe || (pe = !0, y("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "key", {
          get: p,
          configurable: !0
        });
      }
    }
    function pn(t, c) {
      {
        var p = function() {
          _e || (_e = !0, y("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "ref", {
          get: p,
          configurable: !0
        });
      }
    }
    var ln = function(t, c, p, g, P, L, I) {
      var N = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: n,
        // Built-in properties that belong on the element
        type: t,
        key: c,
        ref: p,
        props: I,
        // Record the component responsible for creating this element.
        _owner: L
      };
      return N._store = {}, Object.defineProperty(N._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(N, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: g
      }), Object.defineProperty(N, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: P
      }), Object.freeze && (Object.freeze(N.props), Object.freeze(N)), N;
    };
    function kn(t, c, p, g, P) {
      {
        var L, I = {}, N = null, te = null;
        p !== void 0 && (R(p), N = "" + p), un(c) && (R(c.key), N = "" + c.key), en(c) && (te = c.ref, rn(c));
        for (L in c)
          fe.call(c, L) && !ie.hasOwnProperty(L) && (I[L] = c[L]);
        if (t && t.defaultProps) {
          var x = t.defaultProps;
          for (L in x)
            I[L] === void 0 && (I[L] = x[L]);
        }
        if (N || te) {
          var V = typeof t == "function" ? t.displayName || t.name || "Unknown" : t;
          N && dn(I, V), te && pn(I, V);
        }
        return ln(t, N, te, P, g, z.current, I);
      }
    }
    var Xe = F.ReactCurrentOwner, Sn = F.ReactDebugCurrentFrame;
    function Oe(t) {
      if (t) {
        var c = t._owner, p = de(t.type, t._source, c ? c.type : null);
        Sn.setExtraStackFrame(p);
      } else
        Sn.setExtraStackFrame(null);
    }
    var an;
    an = !1;
    function on(t) {
      return typeof t == "object" && t !== null && t.$$typeof === n;
    }
    function yn() {
      {
        if (Xe.current) {
          var t = O(Xe.current.type);
          if (t)
            return `

Check the render method of \`` + t + "`.";
        }
        return "";
      }
    }
    function qn(t) {
      return "";
    }
    var Nn = {};
    function gn(t) {
      {
        var c = yn();
        if (!c) {
          var p = typeof t == "string" ? t : t.displayName || t.name;
          p && (c = `

Check the top-level render call using <` + p + ">.");
        }
        return c;
      }
    }
    function hn(t, c) {
      {
        if (!t._store || t._store.validated || t.key != null)
          return;
        t._store.validated = !0;
        var p = gn(c);
        if (Nn[p])
          return;
        Nn[p] = !0;
        var g = "";
        t && t._owner && t._owner !== Xe.current && (g = " It was passed a child from " + O(t._owner.type) + "."), Oe(t), y('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', p, g), Oe(null);
      }
    }
    function jn(t, c) {
      {
        if (typeof t != "object")
          return;
        if (_(t))
          for (var p = 0; p < t.length; p++) {
            var g = t[p];
            on(g) && hn(g, c);
          }
        else if (on(t))
          t._store && (t._store.validated = !0);
        else if (t) {
          var P = j(t);
          if (typeof P == "function" && P !== t.entries)
            for (var L = P.call(t), I; !(I = L.next()).done; )
              on(I.value) && hn(I.value, c);
        }
      }
    }
    function Un(t) {
      {
        var c = t.type;
        if (c == null || typeof c == "string")
          return;
        var p;
        if (typeof c == "function")
          p = c.propTypes;
        else if (typeof c == "object" && (c.$$typeof === d || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        c.$$typeof === f))
          p = c.propTypes;
        else
          return;
        if (p) {
          var g = O(c);
          sn(p, t.props, "prop", g, t);
        } else if (c.PropTypes !== void 0 && !an) {
          an = !0;
          var P = O(c);
          y("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", P || "Unknown");
        }
        typeof c.getDefaultProps == "function" && !c.getDefaultProps.isReactClassApproved && y("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function Vn(t) {
      {
        for (var c = Object.keys(t.props), p = 0; p < c.length; p++) {
          var g = c[p];
          if (g !== "children" && g !== "key") {
            Oe(t), y("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", g), Oe(null);
            break;
          }
        }
        t.ref !== null && (Oe(t), y("Invalid attribute `ref` supplied to `React.Fragment`."), Oe(null));
      }
    }
    var _n = {};
    function xn(t, c, p, g, P, L) {
      {
        var I = ae(t);
        if (!I) {
          var N = "";
          (t === void 0 || typeof t == "object" && t !== null && Object.keys(t).length === 0) && (N += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var te = qn();
          te ? N += te : N += yn();
          var x;
          t === null ? x = "null" : _(t) ? x = "array" : t !== void 0 && t.$$typeof === n ? (x = "<" + (O(t.type) || "Unknown") + " />", N = " Did you accidentally export a JSX literal instead of a component?") : x = typeof t, y("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", x, N);
        }
        var V = kn(t, c, p, P, L);
        if (V == null)
          return V;
        if (I) {
          var X = c.children;
          if (X !== void 0)
            if (g)
              if (_(X)) {
                for (var we = 0; we < X.length; we++)
                  jn(X[we], t);
                Object.freeze && Object.freeze(X);
              } else
                y("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              jn(X, t);
        }
        if (fe.call(c, "key")) {
          var Se = O(t), ne = Object.keys(c).filter(function(wn) {
            return wn !== "key";
          }), nn = ne.length > 0 ? "{key: someKey, " + ne.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!_n[Se + nn]) {
            var Tn = ne.length > 0 ? "{" + ne.join(": ..., ") + ": ...}" : "{}";
            y(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, nn, Se, Tn, Se), _n[Se + nn] = !0;
          }
        }
        return t === i ? Vn(V) : Un(V), V;
      }
    }
    function Hn(t, c, p) {
      return xn(t, c, p, !0);
    }
    function Dn(t, c, p) {
      return xn(t, c, p, !1);
    }
    var Rn = Dn, Mn = Hn;
    Ko.Fragment = i, Ko.jsx = Rn, Ko.jsxs = Mn;
  })()), Ko;
}
var cb;
function j4() {
  return cb || (cb = 1, process.env.NODE_ENV === "production" ? Bu.exports = S4() : Bu.exports = N4()), Bu.exports;
}
var Ce = j4();
const w4 = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getCustomerDetails" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "email" } }, type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "phone" } }, type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "limit" } }, type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "externalIds" } }, type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "storeId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "expand" } }, type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Yotpo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "getCustomers" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "email" }, value: { kind: "Variable", name: { kind: "Name", value: "email" } } }, { kind: "Argument", name: { kind: "Name", value: "phone_number" }, value: { kind: "Variable", name: { kind: "Name", value: "phone" } } }, { kind: "Argument", name: { kind: "Name", value: "limit" }, value: { kind: "Variable", name: { kind: "Name", value: "limit" } } }, { kind: "Argument", name: { kind: "Name", value: "external_ids" }, value: { kind: "Variable", name: { kind: "Name", value: "externalIds" } } }, { kind: "Argument", name: { kind: "Name", value: "store_id" }, value: { kind: "Variable", name: { kind: "Name", value: "storeId" } } }, { kind: "Argument", name: { kind: "Name", value: "expand" }, value: { kind: "Variable", name: { kind: "Name", value: "expand" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Yotpo_getCustomers_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Yotpo_Customers" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "customers" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "external_id" } }, { kind: "Field", name: { kind: "Name", value: "email" } }, { kind: "Field", name: { kind: "Name", value: "phone_number" } }, { kind: "Field", name: { kind: "Name", value: "first_name" } }, { kind: "Field", name: { kind: "Name", value: "last_name" } }, { kind: "Field", name: { kind: "Name", value: "gender" } }, { kind: "Field", name: { kind: "Name", value: "account_created_at" } }, { kind: "Field", name: { kind: "Name", value: "account_updated_at" } }, { kind: "Field", name: { kind: "Name", value: "default_language" } }, { kind: "Field", name: { kind: "Name", value: "dafault_currency" } }, { kind: "Field", name: { kind: "Name", value: "lists" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "since" } }] } }, { kind: "Field", name: { kind: "Name", value: "yotpo_ugc" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "total_reviews" } }, { kind: "Field", name: { kind: "Name", value: "avg_product_rating" } }, { kind: "Field", name: { kind: "Name", value: "avg_site_rating" } }, { kind: "Field", name: { kind: "Name", value: "total_avg_rating" } }, { kind: "Field", name: { kind: "Name", value: "sentiment_avg_product" } }, { kind: "Field", name: { kind: "Name", value: "sentiment_avg_site" } }, { kind: "Field", name: { kind: "Name", value: "total_avg_sentiment" } }, { kind: "Field", name: { kind: "Name", value: "top_topics" } }, { kind: "Field", name: { kind: "Name", value: "last_star_rating" } }, { kind: "Field", name: { kind: "Name", value: "last_review_date" } }, { kind: "Field", name: { kind: "Name", value: "last_sentiment" } }] } }, { kind: "Field", name: { kind: "Name", value: "yotpo_loyalty" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "points_earned" } }, { kind: "Field", name: { kind: "Name", value: "points_balance" } }, { kind: "Field", name: { kind: "Name", value: "last_seen_at" } }, { kind: "Field", name: { kind: "Name", value: "total_redemptions" } }, { kind: "Field", name: { kind: "Name", value: "total_points_redeemed" } }, { kind: "Field", name: { kind: "Name", value: "vip_tier_name" } }, { kind: "Field", name: { kind: "Name", value: "successful_referrals" } }, { kind: "Field", name: { kind: "Name", value: "referrals_made_and_clicked" } }, { kind: "Field", name: { kind: "Name", value: "is_referred_by_other_customer" } }, { kind: "Field", name: { kind: "Name", value: "points_expire_date" } }, { kind: "Field", name: { kind: "Name", value: "credit_balance_amount" } }, { kind: "Field", name: { kind: "Name", value: "credit_balance_customer_currency" } }, { kind: "Field", name: { kind: "Name", value: "is_opt_in" } }, { kind: "Field", name: { kind: "Name", value: "opt_in_date" } }, { kind: "Field", name: { kind: "Name", value: "opt_out_date" } }, { kind: "Field", name: { kind: "Name", value: "has_store_account" } }, { kind: "Field", name: { kind: "Name", value: "referred_by_customer" } }, { kind: "Field", name: { kind: "Name", value: "vip_entry_date" } }, { kind: "Field", name: { kind: "Name", value: "vip_expiration_date" } }] } }, { kind: "Field", name: { kind: "Name", value: "yotpo_subscriptions" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "active_subscriptions" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "externalProductId" } }, { kind: "Field", name: { kind: "Name", value: "externalVariantId" } }] } }, { kind: "Field", name: { kind: "Name", value: "paused_subscriptions" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "externalProductId" } }, { kind: "Field", name: { kind: "Name", value: "externalVariantId" } }] } }, { kind: "Field", name: { kind: "Name", value: "failed_subscriptions" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "externalProductId" } }, { kind: "Field", name: { kind: "Name", value: "externalVariantId" } }] } }, { kind: "Field", name: { kind: "Name", value: "expired_subscriptions" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "externalProductId" } }, { kind: "Field", name: { kind: "Name", value: "externalVariantId" } }] } }, { kind: "Field", name: { kind: "Name", value: "canceled_subscriptions" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "externalProductId" } }, { kind: "Field", name: { kind: "Name", value: "externalVariantId" } }] } }] } }] } }] } }] } }] } }] } }] } }] }, C4 = {
  "\n  query getCustomerDetails(\n    $email: String\n    $phone: String\n    $limit: Int\n    $externalIds: String\n    $storeId: String!\n    $expand: String\n  ) {\n    Yotpo {\n      getCustomers(\n        email: $email\n        phone_number: $phone\n        limit: $limit\n        external_ids: $externalIds\n        store_id: $storeId\n        expand: $expand\n      ) {\n        ... on Yotpo_getCustomers_response {\n          ... on Yotpo_Customers {\n            customers {\n              external_id\n              email\n              phone_number\n              first_name\n              last_name\n              gender\n              account_created_at\n              account_updated_at\n              default_language\n              dafault_currency\n              lists {\n                id\n                since\n              }\n              yotpo_ugc {\n                total_reviews\n                avg_product_rating\n                avg_site_rating\n                total_avg_rating\n                sentiment_avg_product\n                sentiment_avg_site\n                total_avg_sentiment\n                top_topics\n                last_star_rating\n                last_review_date\n                last_sentiment\n              }\n              yotpo_loyalty {\n                points_earned\n                points_balance\n                last_seen_at\n                total_redemptions\n                total_points_redeemed\n                vip_tier_name\n                successful_referrals\n                referrals_made_and_clicked\n                is_referred_by_other_customer\n                points_expire_date\n                credit_balance_amount\n                credit_balance_customer_currency\n                is_opt_in\n                opt_in_date\n                opt_out_date\n                has_store_account\n                referred_by_customer\n                vip_entry_date\n                vip_expiration_date\n              }\n              yotpo_subscriptions {\n                active_subscriptions {\n                  externalProductId\n                  externalVariantId\n                }\n                paused_subscriptions {\n                  externalProductId\n                  externalVariantId\n                }\n                failed_subscriptions {\n                  externalProductId\n                  externalVariantId\n                }\n                expired_subscriptions {\n                  externalProductId\n                  externalVariantId\n                }\n                canceled_subscriptions {\n                  externalProductId\n                  externalVariantId\n                }\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n": w4
};
function F4(e) {
  return C4[e] ?? {};
}
const I4 = F4(
  /* GraphQL */
  `
  query getCustomerDetails(
    $email: String
    $phone: String
    $limit: Int
    $externalIds: String
    $storeId: String!
    $expand: String
  ) {
    Yotpo {
      getCustomers(
        email: $email
        phone_number: $phone
        limit: $limit
        external_ids: $externalIds
        store_id: $storeId
        expand: $expand
      ) {
        ... on Yotpo_getCustomers_response {
          ... on Yotpo_Customers {
            customers {
              external_id
              email
              phone_number
              first_name
              last_name
              gender
              account_created_at
              account_updated_at
              default_language
              dafault_currency
              lists {
                id
                since
              }
              yotpo_ugc {
                total_reviews
                avg_product_rating
                avg_site_rating
                total_avg_rating
                sentiment_avg_product
                sentiment_avg_site
                total_avg_sentiment
                top_topics
                last_star_rating
                last_review_date
                last_sentiment
              }
              yotpo_loyalty {
                points_earned
                points_balance
                last_seen_at
                total_redemptions
                total_points_redeemed
                vip_tier_name
                successful_referrals
                referrals_made_and_clicked
                is_referred_by_other_customer
                points_expire_date
                credit_balance_amount
                credit_balance_customer_currency
                is_opt_in
                opt_in_date
                opt_out_date
                has_store_account
                referred_by_customer
                vip_entry_date
                vip_expiration_date
              }
              yotpo_subscriptions {
                active_subscriptions {
                  externalProductId
                  externalVariantId
                }
                paused_subscriptions {
                  externalProductId
                  externalVariantId
                }
                failed_subscriptions {
                  externalProductId
                  externalVariantId
                }
                expired_subscriptions {
                  externalProductId
                  externalVariantId
                }
                canceled_subscriptions {
                  externalProductId
                  externalVariantId
                }
              }
            }
          }
        }
      }
    }
  }
`
), E4 = "_copyIcon_11mz1_48", T4 = "_list_11mz1_53", $4 = "_listItem_11mz1_63", D4 = "_listItemHighlighted_11mz1_72", Hi = {
  copyIcon: E4,
  list: T4,
  listItem: $4,
  listItemHighlighted: D4
}, R4 = "_wrapper_1xucg_1", O4 = "_externalLink_1xucg_7", qu = {
  wrapper: R4,
  externalLink: O4
}, P4 = ({
  customerDetails: e
}) => {
  const { isCopied: n, copy: r } = nr(), { isCopied: i, copy: a } = nr();
  if (!e)
    return null;
  const {
    first_name: o,
    last_name: s,
    email: l,
    phone_number: d,
    account_created_at: m
  } = e, u = 14, f = `${o || ""} ${s || ""}`.trim() || "A customer has no name";
  return /* @__PURE__ */ Ce.jsx(b, { gap: "300", flexDirection: "column", children: /* @__PURE__ */ Ce.jsxs(b, { className: qu.wrapper, gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ Ce.jsx(
      b,
      {
        justifyContent: "space-between",
        className: qu.block,
        alignItems: "center",
        children: /* @__PURE__ */ Ce.jsx(A.Heading, { variant: "heading-2", children: f })
      }
    ),
    m && /* @__PURE__ */ Ce.jsxs(b, { gap: "200", justifyContent: "space-between", margin: "0 0 200", children: [
      /* @__PURE__ */ Ce.jsx(A.Paragraph, { variant: "4", children: "Member since" }),
      /* @__PURE__ */ Ce.jsx(A.Paragraph, { variant: "4", children: Ln(m).format(yt) })
    ] }),
    l && /* @__PURE__ */ Ce.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
      /* @__PURE__ */ Ce.jsxs(b, { gap: "200", alignItems: "center", children: [
        /* @__PURE__ */ Ce.jsx(me, { size: u, name: "mail" }),
        /* @__PURE__ */ Ce.jsx("span", { className: qu.externalLink, children: l })
      ] }),
      /* @__PURE__ */ Ce.jsx(Ge, { content: "Copy email", children: /* @__PURE__ */ Ce.jsx(b, { alignItems: "center", children: /* @__PURE__ */ Ce.jsx(
        me,
        {
          size: u,
          name: n ? "done" : "copy",
          onClick: () => r(l),
          className: Hi.copyIcon
        }
      ) }) })
    ] }),
    d && /* @__PURE__ */ Ce.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
      /* @__PURE__ */ Ce.jsxs(b, { gap: "200", alignItems: "center", children: [
        /* @__PURE__ */ Ce.jsx(me, { size: u, name: "phone" }),
        /* @__PURE__ */ Ce.jsx(A.Paragraph, { variant: "4", children: d })
      ] }),
      /* @__PURE__ */ Ce.jsx(Ge, { content: "Copy phone number", children: /* @__PURE__ */ Ce.jsx(b, { alignItems: "center", children: /* @__PURE__ */ Ce.jsx(
        me,
        {
          size: u,
          name: i ? "done" : "copy",
          onClick: () => a(d),
          className: Hi.copyIcon
        }
      ) }) })
    ] })
  ] }) });
}, Kn = ({
  description: e,
  content: n,
  tooltip: r,
  isHighlighted: i = !1
}) => {
  if (n == null)
    return null;
  const a = c0(n);
  return /* @__PURE__ */ Ce.jsx(
    Ke.Text,
    {
      variant: "dense",
      className: rt(Hi.listItem, {
        [Hi.listItemHighlighted]: i
      }),
      children: /* @__PURE__ */ Ce.jsx(Ge, { content: r, children: /* @__PURE__ */ Ce.jsxs(b, { justifyContent: "space-between", alignItems: "center", children: [
        /* @__PURE__ */ Ce.jsx(A.Paragraph, { variant: "4", children: e }),
        a ? n : Xa(n)
      ] }) })
    }
  );
}, A4 = ({
  loyalty: e
}) => /* @__PURE__ */ Ce.jsxs(b, { gap: "200", flexDirection: "column", children: [
  /* @__PURE__ */ Ce.jsx(A.Heading, { variant: "heading-3", children: "Loyalty" }),
  !e && /* @__PURE__ */ Ce.jsx(b, { justifyContent: "center", children: /* @__PURE__ */ Ce.jsx(A.Paragraph, { variant: "4", color: "secondary", children: "No loyalty data available" }) }),
  e && /* @__PURE__ */ Ce.jsxs(Ke, { className: Hi.list, children: [
    /* @__PURE__ */ Ce.jsx(
      Kn,
      {
        isHighlighted: !0,
        description: "Successful referrals",
        tooltip: "The total number of successful referrals made by the customer.",
        content: e.successful_referrals
      }
    ),
    /* @__PURE__ */ Ce.jsx(
      Kn,
      {
        isHighlighted: !0,
        description: "Referrals made and clicked",
        tooltip: "The total number of referrals made by the customer and clicked on by others.",
        content: e.referrals_made_and_clicked
      }
    ),
    /* @__PURE__ */ Ce.jsx(
      Kn,
      {
        description: "Points earned",
        tooltip: "The total number of loyalty points earned by the customer.",
        content: e.points_earned
      }
    ),
    /* @__PURE__ */ Ce.jsx(
      Kn,
      {
        description: "Points balance",
        tooltip: "The current balance of loyalty points for the customer.",
        content: e.points_balance
      }
    ),
    /* @__PURE__ */ Ce.jsx(
      Kn,
      {
        description: "Last seen",
        tooltip: "The timestamp when the customer was last seen or engaged with the loyalty program.",
        content: e.last_seen_at
      }
    ),
    /* @__PURE__ */ Ce.jsx(
      Kn,
      {
        description: "Total redemptions",
        tooltip: "The total number of times the customer has redeemed loyalty points.",
        content: e.total_redemptions
      }
    ),
    /* @__PURE__ */ Ce.jsx(
      Kn,
      {
        description: "Total points redeemed",
        tooltip: "The total number of loyalty points redeemed by the customer.",
        content: e.total_points_redeemed
      }
    ),
    /* @__PURE__ */ Ce.jsx(
      Kn,
      {
        description: "VIP tier",
        tooltip: "The name of the customer's current VIP tier status.",
        content: e.vip_tier_name
      }
    ),
    /* @__PURE__ */ Ce.jsx(
      Kn,
      {
        description: "Referred by other customer",
        tooltip: "Indicates whether the customer was referred by another customer.",
        content: e.is_referred_by_other_customer
      }
    ),
    /* @__PURE__ */ Ce.jsx(
      Kn,
      {
        description: "Points expire date",
        tooltip: "The timestamp when the customer's loyalty points are set to expire.",
        content: e.points_expire_date
      }
    ),
    /* @__PURE__ */ Ce.jsx(
      Kn,
      {
        description: "Credit balance amount",
        tooltip: "The amount of store credit available to the customer in the default currency of the store.",
        content: e.credit_balance_amount
      }
    ),
    /* @__PURE__ */ Ce.jsx(
      Kn,
      {
        description: "Credit balance customer currency",
        tooltip: "The store credit amount in the customer's preferred currency.",
        content: e.credit_balance_customer_currency
      }
    ),
    /* @__PURE__ */ Ce.jsx(
      Kn,
      {
        description: "Opt in",
        tooltip: "Indicates whether the customer has opted into the loyalty program.",
        content: e.is_opt_in
      }
    ),
    /* @__PURE__ */ Ce.jsx(
      Kn,
      {
        description: "Opt in date",
        tooltip: "The timestamp for when the customer opted into the loyalty program.",
        content: e.opt_in_date
      }
    ),
    /* @__PURE__ */ Ce.jsx(
      Kn,
      {
        description: "Opt out date",
        tooltip: "The timestamp for when the customer opted out of the loyalty program.",
        content: e.opt_out_date
      }
    ),
    /* @__PURE__ */ Ce.jsx(
      Kn,
      {
        description: "Has store account",
        tooltip: "Indicates whether the customer has a store account.",
        content: e.has_store_account
      }
    ),
    /* @__PURE__ */ Ce.jsx(
      Kn,
      {
        description: "Referred by customer",
        tooltip: "The email address of the customer who referred this customer to the loyalty program.",
        content: e.referred_by_customer
      }
    ),
    /* @__PURE__ */ Ce.jsx(
      Kn,
      {
        description: "VIP entry date",
        tooltip: "The timestamp for when the customer entered the VIP tier.",
        content: e.vip_entry_date
      }
    ),
    /* @__PURE__ */ Ce.jsx(
      Kn,
      {
        description: "VIP expiration date",
        tooltip: "The timestamp for when the customer's VIP tier membership is set to expire.",
        content: e.vip_expiration_date
      }
    )
  ] })
] }), L4 = 0.8, V4 = 0.4, db = (e) => {
  if (e != null)
    return e >= L4 ? /* @__PURE__ */ Ce.jsx(Pn, { variant: "success", size: "small", children: "Positive" }) : e <= V4 ? /* @__PURE__ */ Ce.jsx(Pn, { variant: "error", size: "small", children: "Negative" }) : /* @__PURE__ */ Ce.jsx(Pn, { variant: "warning", size: "small", children: "Neutral" });
}, z4 = ({
  userGeneratedContent: e
}) => /* @__PURE__ */ Ce.jsxs(b, { gap: "200", flexDirection: "column", children: [
  /* @__PURE__ */ Ce.jsx(A.Heading, { variant: "heading-3", children: "User generated content" }),
  !e && /* @__PURE__ */ Ce.jsx(b, { justifyContent: "center", children: /* @__PURE__ */ Ce.jsx(A.Paragraph, { variant: "4", color: "secondary", children: "No user generated content available" }) }),
  e && /* @__PURE__ */ Ce.jsxs(Ke, { className: Hi.list, children: [
    /* @__PURE__ */ Ce.jsx(
      Kn,
      {
        isHighlighted: !0,
        description: "Total reviews",
        tooltip: "The total number of reviews submitted by the customer.",
        content: e.total_reviews
      }
    ),
    /* @__PURE__ */ Ce.jsx(
      Kn,
      {
        isHighlighted: !0,
        description: "Total average rating",
        tooltip: "The total average rating given by the customer (combining products and site/store ratings).",
        content: e.total_avg_rating?.toFixed(2)
      }
    ),
    /* @__PURE__ */ Ce.jsx(
      Kn,
      {
        isHighlighted: !0,
        description: "Total average sentiment score",
        tooltip: "The total average sentiment score given by the customer (combining products and site/store scores).",
        content: db(e.total_avg_sentiment)
      }
    ),
    /* @__PURE__ */ Ce.jsx(
      Kn,
      {
        description: "Average product rating",
        tooltip: "The average product rating given by the customer.",
        content: e.avg_product_rating
      }
    ),
    /* @__PURE__ */ Ce.jsx(
      Kn,
      {
        description: "Average site rating",
        tooltip: "The average rating of the site/store given by the customer.",
        content: e.avg_site_rating?.toFixed(2)
      }
    ),
    /* @__PURE__ */ Ce.jsx(
      Kn,
      {
        description: "Last sentiment",
        tooltip: "The sentiment score of the customer's last review.",
        content: db(e.last_sentiment)
      }
    ),
    /* @__PURE__ */ Ce.jsx(
      Kn,
      {
        description: "Last star rating",
        tooltip: "The star rating of the customer's last review.",
        content: e.last_star_rating
      }
    ),
    /* @__PURE__ */ Ce.jsx(
      Kn,
      {
        description: "Last review date",
        tooltip: "The timestamp for when the customer last submitted a review.",
        content: Ln(e.last_review_date).format(
          yt
        )
      }
    ),
    /* @__PURE__ */ Ce.jsx(
      Kn,
      {
        description: "Topics",
        tooltip: "An list of top topics (themes) mentioned in all of the customer's reviews.",
        content: /* @__PURE__ */ Ce.jsx(
          b,
          {
            gap: "100",
            width: "80%",
            flexWrap: "wrap",
            justifyContent: "flex-end",
            children: e.top_topics?.map((n, r) => /* @__PURE__ */ Ce.jsx(Pn, { variant: "info", size: "small", children: /* @__PURE__ */ Ce.jsx(Ce.Fragment, { children: n }) }, r))
          }
        )
      }
    )
  ] })
] }), U4 = ({
  conversationContext: e,
  settings: n
}) => {
  const { useQuery: r } = mn(), { track: i } = bn(), [a, o] = se(), [s, l] = se(!1), d = e?.customer?.email, m = e?.customer?.phone_number, u = !d && !m, f = n?.yotpoStoreId, h = n?.showCustomerDetails ?? !1, v = n?.showUserGeneratedContent ?? !1, C = n?.displayLoyalty ?? !1, S = n?.displaySubscriptions ?? !1, j = !f, F = !h && !v && !C && !S, {
    loading: y,
    error: q,
    data: T
  } = r(I4, {
    skip: u || j,
    variables: {
      ...d && { email: d },
      ...!d && m && { phone: m },
      storeId: f,
      expand: "all"
    }
  });
  if (He(() => {
    const E = T?.Yotpo?.getCustomers?.customers?.[0];
    E ? (o(E), l(!1), i("yotpo:customer:received")) : l(!0);
  }, [T?.Yotpo, y]), j)
    return /* @__PURE__ */ Ce.jsx(b, { justifyContent: "center", margin: "200 0 300 0", children: /* @__PURE__ */ Ce.jsx(
      Fn,
      {
        error: new zb({
          graphQLErrors: [
            {
              message: "Integration needs to be re-/authorized in the settings."
            }
          ]
        }),
        hideCopyButton: !0
      }
    ) });
  if (u)
    return /* @__PURE__ */ Ce.jsx(
      b,
      {
        justifyContent: "center",
        margin: "200 0 300 0",
        "data-testid": "widget-no-contact-message",
        children: /* @__PURE__ */ Ce.jsx(A.Paragraph, { variant: "4", color: "secondary", children: "No email nor phone number are available in this conversation to look up a profile." })
      }
    );
  if (F)
    return /* @__PURE__ */ Ce.jsx(
      b,
      {
        justifyContent: "center",
        margin: "200 0 300 0",
        "data-testid": "widget-no-features",
        children: /* @__PURE__ */ Ce.jsx(A.Paragraph, { variant: "4", color: "secondary", children: "All features toggles in the widget settings are disabled." })
      }
    );
  if (y)
    return /* @__PURE__ */ Ce.jsx(b, { justifyContent: "center", margin: "300", children: /* @__PURE__ */ Ce.jsx(cn, {}) });
  if (s)
    return /* @__PURE__ */ Ce.jsx(b, { justifyContent: "center", margin: "200 0 300 0", children: /* @__PURE__ */ Ce.jsx(A.Paragraph, { variant: "4", color: "secondary", children: "No customer profile found." }) });
  if (q) {
    const E = q.graphQLErrors;
    return Fm({ errors: E }) ? /* @__PURE__ */ Ce.jsx(
      A.Paragraph,
      {
        margin: "200 0 300 0",
        color: "secondary",
        variant: "4",
        "data-testid": "widget-downstream-api-forbidden-error",
        children: "The API token used for the integration does not have the necessary access rights. Please contact your administrator."
      }
    ) : Im({ errors: E }) ? /* @__PURE__ */ Ce.jsx(
      A.Paragraph,
      {
        margin: "200 0 300 0",
        color: "secondary",
        variant: "4",
        "data-testid": "widget-downstream-api-authorization-error",
        children: "The integration could not authorize against Yotpo. Please contact your administrator."
      }
    ) : /* @__PURE__ */ Ce.jsx(Fn, { error: q });
  }
  return /* @__PURE__ */ Ce.jsxs(
    b,
    {
      gap: "300",
      flexDirection: "column",
      margin: "200 0 300 0",
      "data-testid": "widget-wrapper",
      children: [
        h && /* @__PURE__ */ Ce.jsx(P4, { customerDetails: a }),
        v && /* @__PURE__ */ Ce.jsx(
          z4,
          {
            userGeneratedContent: a?.yotpo_ugc
          }
        ),
        C && /* @__PURE__ */ Ce.jsx(A4, { loyalty: a?.yotpo_loyalty })
      ]
    }
  );
};
var vo = (e) => e.type === "checkbox", ui = (e) => e instanceof Date, Vt = (e) => e == null;
const jS = (e) => typeof e == "object";
var dt = (e) => !Vt(e) && !Array.isArray(e) && jS(e) && !ui(e), wS = (e) => dt(e) && e.target ? vo(e.target) ? e.target.checked : e.target.value : e, M4 = (e) => e.substring(0, e.search(/\.\d+(\.|$)/)) || e, CS = (e, n) => e.has(M4(n)), B4 = (e) => {
  const n = e.constructor && e.constructor.prototype;
  return dt(n) && n.hasOwnProperty("isPrototypeOf");
}, Gp = typeof window < "u" && typeof window.HTMLElement < "u" && typeof document < "u";
function Nt(e) {
  let n;
  const r = Array.isArray(e), i = typeof FileList < "u" ? e instanceof FileList : !1;
  if (e instanceof Date)
    n = new Date(e);
  else if (e instanceof Set)
    n = new Set(e);
  else if (!(Gp && (e instanceof Blob || i)) && (r || dt(e)))
    if (n = r ? [] : {}, !r && !B4(e))
      n = e;
    else
      for (const a in e)
        e.hasOwnProperty(a) && (n[a] = Nt(e[a]));
  else
    return e;
  return n;
}
var tl = (e) => Array.isArray(e) ? e.filter(Boolean) : [], ot = (e) => e === void 0, Je = (e, n, r) => {
  if (!n || !dt(e))
    return r;
  const i = tl(n.split(/[,[\].]+?/)).reduce((a, o) => Vt(a) ? a : a[o], e);
  return ot(i) || i === e ? ot(e[n]) ? r : e[n] : i;
}, er = (e) => typeof e == "boolean", Yp = (e) => /^\w*$/.test(e), FS = (e) => tl(e.replace(/["|']|\]/g, "").split(/\.|\[/)), Qn = (e, n, r) => {
  let i = -1;
  const a = Yp(n) ? [n] : FS(n), o = a.length, s = o - 1;
  for (; ++i < o; ) {
    const l = a[i];
    let d = r;
    if (i !== s) {
      const m = e[l];
      d = dt(m) || Array.isArray(m) ? m : isNaN(+a[i + 1]) ? {} : [];
    }
    if (l === "__proto__" || l === "constructor" || l === "prototype")
      return;
    e[l] = d, e = e[l];
  }
};
const Is = {
  BLUR: "blur",
  FOCUS_OUT: "focusout",
  CHANGE: "change"
}, kr = {
  onBlur: "onBlur",
  onChange: "onChange",
  onSubmit: "onSubmit",
  onTouched: "onTouched",
  all: "all"
}, Mr = {
  max: "max",
  min: "min",
  maxLength: "maxLength",
  minLength: "minLength",
  pattern: "pattern",
  required: "required",
  validate: "validate"
}, q4 = je.createContext(null), Qp = () => je.useContext(q4);
var IS = (e, n, r, i = !0) => {
  const a = {
    defaultValues: n._defaultValues
  };
  for (const o in e)
    Object.defineProperty(a, o, {
      get: () => {
        const s = o;
        return n._proxyFormState[s] !== kr.all && (n._proxyFormState[s] = !i || kr.all), r && (r[s] = !0), e[s];
      }
    });
  return a;
};
function H4(e) {
  const n = Qp(), { control: r = n.control, disabled: i, name: a, exact: o } = e || {}, [s, l] = je.useState(r._formState), d = je.useRef({
    isDirty: !1,
    isLoading: !1,
    dirtyFields: !1,
    touchedFields: !1,
    validatingFields: !1,
    isValidating: !1,
    isValid: !1,
    errors: !1
  }), m = je.useRef(a);
  return m.current = a, je.useEffect(() => r._subscribe({
    name: m.current,
    formState: d.current,
    exact: o,
    callback: (u) => {
      !i && l({
        ...r._formState,
        ...u
      });
    }
  }), [r, i, o]), je.useEffect(() => {
    d.current.isValid && r._setValid(!0);
  }, [r]), je.useMemo(() => IS(s, r, d.current, !1), [s, r]);
}
var Dr = (e) => typeof e == "string", ES = (e, n, r, i, a) => Dr(e) ? (i && n.watch.add(e), Je(r, e, a)) : Array.isArray(e) ? e.map((o) => (i && n.watch.add(o), Je(r, o))) : (i && (n.watchAll = !0), r);
function TS(e) {
  const n = Qp(), { control: r = n.control, name: i, defaultValue: a, disabled: o, exact: s } = e || {}, l = je.useRef(i), d = je.useRef(a);
  l.current = i, je.useEffect(() => r._subscribe({
    name: l.current,
    formState: {
      values: !0
    },
    exact: s,
    callback: (f) => !o && u(ES(l.current, r._names, f.values || r._formValues, !1, d.current))
  }), [r, o, s]);
  const [m, u] = je.useState(r._getWatch(i, a));
  return je.useEffect(() => r._removeUnmounted()), m;
}
function W4(e) {
  const n = Qp(), { name: r, disabled: i, control: a = n.control, shouldUnregister: o } = e, s = CS(a._names.array, r), l = TS({
    control: a,
    name: r,
    defaultValue: Je(a._formValues, r, Je(a._defaultValues, r, e.defaultValue)),
    exact: !0
  }), d = H4({
    control: a,
    name: r,
    exact: !0
  }), m = je.useRef(e), u = je.useRef(a.register(r, {
    ...e.rules,
    value: l,
    ...er(e.disabled) ? { disabled: e.disabled } : {}
  })), f = je.useMemo(() => Object.defineProperties({}, {
    invalid: {
      enumerable: !0,
      get: () => !!Je(d.errors, r)
    },
    isDirty: {
      enumerable: !0,
      get: () => !!Je(d.dirtyFields, r)
    },
    isTouched: {
      enumerable: !0,
      get: () => !!Je(d.touchedFields, r)
    },
    isValidating: {
      enumerable: !0,
      get: () => !!Je(d.validatingFields, r)
    },
    error: {
      enumerable: !0,
      get: () => Je(d.errors, r)
    }
  }), [d, r]), h = je.useCallback((j) => u.current.onChange({
    target: {
      value: wS(j),
      name: r
    },
    type: Is.CHANGE
  }), [r]), v = je.useCallback(() => u.current.onBlur({
    target: {
      value: Je(a._formValues, r),
      name: r
    },
    type: Is.BLUR
  }), [r, a._formValues]), C = je.useCallback((j) => {
    const F = Je(a._fields, r);
    F && j && (F._f.ref = {
      focus: () => j.focus(),
      select: () => j.select(),
      setCustomValidity: (y) => j.setCustomValidity(y),
      reportValidity: () => j.reportValidity()
    });
  }, [a._fields, r]), S = je.useMemo(() => ({
    name: r,
    value: l,
    ...er(i) || d.disabled ? { disabled: d.disabled || i } : {},
    onChange: h,
    onBlur: v,
    ref: C
  }), [r, i, d.disabled, h, v, C, l]);
  return je.useEffect(() => {
    const j = a._options.shouldUnregister || o;
    a.register(r, {
      ...m.current.rules,
      ...er(m.current.disabled) ? { disabled: m.current.disabled } : {}
    });
    const F = (y, q) => {
      const T = Je(a._fields, y);
      T && T._f && (T._f.mount = q);
    };
    if (F(r, !0), j) {
      const y = Nt(Je(a._options.defaultValues, r));
      Qn(a._defaultValues, r, y), ot(Je(a._formValues, r)) && Qn(a._formValues, r, y);
    }
    return !s && a.register(r), () => {
      (s ? j && !a._state.action : j) ? a.unregister(r) : F(r, !1);
    };
  }, [r, a, s, o]), je.useEffect(() => {
    a._setDisabledField({
      disabled: i,
      name: r
    });
  }, [i, r, a]), je.useMemo(() => ({
    field: S,
    formState: d,
    fieldState: f
  }), [S, d, f]);
}
const ub = (e) => e.render(W4(e));
var K4 = (e, n, r, i, a) => n ? {
  ...r[e],
  types: {
    ...r[e] && r[e].types ? r[e].types : {},
    [i]: a || !0
  }
} : {}, Ya = (e) => Array.isArray(e) ? e : [e], mb = () => {
  let e = [];
  return {
    get observers() {
      return e;
    },
    next: (n) => {
      for (const r of e)
        r.next && r.next(n);
    },
    subscribe: (n) => (e.push(n), {
      unsubscribe: () => {
        e = e.filter((r) => r !== n);
      }
    }),
    unsubscribe: () => {
      e = [];
    }
  };
}, Cm = (e) => Vt(e) || !jS(e);
function Zr(e, n) {
  if (Cm(e) || Cm(n))
    return e === n;
  if (ui(e) && ui(n))
    return e.getTime() === n.getTime();
  const r = Object.keys(e), i = Object.keys(n);
  if (r.length !== i.length)
    return !1;
  for (const a of r) {
    const o = e[a];
    if (!i.includes(a))
      return !1;
    if (a !== "ref") {
      const s = n[a];
      if (ui(o) && ui(s) || dt(o) && dt(s) || Array.isArray(o) && Array.isArray(s) ? !Zr(o, s) : o !== s)
        return !1;
    }
  }
  return !0;
}
var Pt = (e) => dt(e) && !Object.keys(e).length, Jp = (e) => e.type === "file", br = (e) => typeof e == "function", Es = (e) => {
  if (!Gp)
    return !1;
  const n = e ? e.ownerDocument : 0;
  return e instanceof (n && n.defaultView ? n.defaultView.HTMLElement : HTMLElement);
}, $S = (e) => e.type === "select-multiple", Xp = (e) => e.type === "radio", G4 = (e) => Xp(e) || vo(e), Hu = (e) => Es(e) && e.isConnected;
function Y4(e, n) {
  const r = n.slice(0, -1).length;
  let i = 0;
  for (; i < r; )
    e = ot(e) ? i++ : e[n[i++]];
  return e;
}
function Q4(e) {
  for (const n in e)
    if (e.hasOwnProperty(n) && !ot(e[n]))
      return !1;
  return !0;
}
function ht(e, n) {
  const r = Array.isArray(n) ? n : Yp(n) ? [n] : FS(n), i = r.length === 1 ? e : Y4(e, r), a = r.length - 1, o = r[a];
  return i && delete i[o], a !== 0 && (dt(i) && Pt(i) || Array.isArray(i) && Q4(i)) && ht(e, r.slice(0, -1)), e;
}
var DS = (e) => {
  for (const n in e)
    if (br(e[n]))
      return !0;
  return !1;
};
function Ts(e, n = {}) {
  const r = Array.isArray(e);
  if (dt(e) || r)
    for (const i in e)
      Array.isArray(e[i]) || dt(e[i]) && !DS(e[i]) ? (n[i] = Array.isArray(e[i]) ? [] : {}, Ts(e[i], n[i])) : Vt(e[i]) || (n[i] = !0);
  return n;
}
function RS(e, n, r) {
  const i = Array.isArray(e);
  if (dt(e) || i)
    for (const a in e)
      Array.isArray(e[a]) || dt(e[a]) && !DS(e[a]) ? ot(n) || Cm(r[a]) ? r[a] = Array.isArray(e[a]) ? Ts(e[a], []) : { ...Ts(e[a]) } : RS(e[a], Vt(n) ? {} : n[a], r[a]) : r[a] = !Zr(e[a], n[a]);
  return r;
}
var Pa = (e, n) => RS(e, n, Ts(n));
const pb = {
  value: !1,
  isValid: !1
}, fb = { value: !0, isValid: !0 };
var OS = (e) => {
  if (Array.isArray(e)) {
    if (e.length > 1) {
      const n = e.filter((r) => r && r.checked && !r.disabled).map((r) => r.value);
      return { value: n, isValid: !!n.length };
    }
    return e[0].checked && !e[0].disabled ? (
      // @ts-expect-error expected to work in the browser
      e[0].attributes && !ot(e[0].attributes.value) ? ot(e[0].value) || e[0].value === "" ? fb : { value: e[0].value, isValid: !0 } : fb
    ) : pb;
  }
  return pb;
}, PS = (e, { valueAsNumber: n, valueAsDate: r, setValueAs: i }) => ot(e) ? e : n ? e === "" ? NaN : e && +e : r && Dr(e) ? new Date(e) : i ? i(e) : e;
const hb = {
  isValid: !1,
  value: null
};
var AS = (e) => Array.isArray(e) ? e.reduce((n, r) => r && r.checked && !r.disabled ? {
  isValid: !0,
  value: r.value
} : n, hb) : hb;
function yb(e) {
  const n = e.ref;
  return Jp(n) ? n.files : Xp(n) ? AS(e.refs).value : $S(n) ? [...n.selectedOptions].map(({ value: r }) => r) : vo(n) ? OS(e.refs).value : PS(ot(n.value) ? e.ref.value : n.value, e);
}
var J4 = (e, n, r, i) => {
  const a = {};
  for (const o of e) {
    const s = Je(n, o);
    s && Qn(a, o, s._f);
  }
  return {
    criteriaMode: r,
    names: [...e],
    fields: a,
    shouldUseNativeValidation: i
  };
}, $s = (e) => e instanceof RegExp, Aa = (e) => ot(e) ? e : $s(e) ? e.source : dt(e) ? $s(e.value) ? e.value.source : e.value : e, gb = (e) => ({
  isOnSubmit: !e || e === kr.onSubmit,
  isOnBlur: e === kr.onBlur,
  isOnChange: e === kr.onChange,
  isOnAll: e === kr.all,
  isOnTouch: e === kr.onTouched
});
const vb = "AsyncFunction";
var X4 = (e) => !!e && !!e.validate && !!(br(e.validate) && e.validate.constructor.name === vb || dt(e.validate) && Object.values(e.validate).find((n) => n.constructor.name === vb)), Z4 = (e) => e.mount && (e.required || e.min || e.max || e.maxLength || e.minLength || e.pattern || e.validate), kb = (e, n, r) => !r && (n.watchAll || n.watch.has(e) || [...n.watch].some((i) => e.startsWith(i) && /^\.\w+/.test(e.slice(i.length))));
const Qa = (e, n, r, i) => {
  for (const a of r || Object.keys(e)) {
    const o = Je(e, a);
    if (o) {
      const { _f: s, ...l } = o;
      if (s) {
        if (s.refs && s.refs[0] && n(s.refs[0], a) && !i || s.ref && n(s.ref, s.name) && !i)
          return !0;
        if (Qa(l, n))
          break;
      } else if (dt(l) && Qa(l, n))
        break;
    }
  }
};
function bb(e, n, r) {
  const i = Je(e, r);
  if (i || Yp(r))
    return {
      error: i,
      name: r
    };
  const a = r.split(".");
  for (; a.length; ) {
    const o = a.join("."), s = Je(n, o), l = Je(e, o);
    if (s && !Array.isArray(s) && r !== o)
      return { name: r };
    if (l && l.type)
      return {
        name: o,
        error: l
      };
    a.pop();
  }
  return {
    name: r
  };
}
var eM = (e, n, r, i) => {
  r(e);
  const { name: a, ...o } = e;
  return Pt(o) || Object.keys(o).length >= Object.keys(n).length || Object.keys(o).find((s) => n[s] === (!i || kr.all));
}, nM = (e, n, r) => !e || !n || e === n || Ya(e).some((i) => i && (r ? i === n : i.startsWith(n) || n.startsWith(i))), tM = (e, n, r, i, a) => a.isOnAll ? !1 : !r && a.isOnTouch ? !(n || e) : (r ? i.isOnBlur : a.isOnBlur) ? !e : (r ? i.isOnChange : a.isOnChange) ? e : !0, rM = (e, n) => !tl(Je(e, n)).length && ht(e, n), iM = (e, n, r) => {
  const i = Ya(Je(e, r));
  return Qn(i, "root", n[r]), Qn(e, r, i), e;
}, ds = (e) => Dr(e);
function _b(e, n, r = "validate") {
  if (ds(e) || Array.isArray(e) && e.every(ds) || er(e) && !e)
    return {
      type: r,
      message: ds(e) ? e : "",
      ref: n
    };
}
var Di = (e) => dt(e) && !$s(e) ? e : {
  value: e,
  message: ""
}, xb = async (e, n, r, i, a, o) => {
  const { ref: s, refs: l, required: d, maxLength: m, minLength: u, min: f, max: h, pattern: v, validate: C, name: S, valueAsNumber: j, mount: F } = e._f, y = Je(r, S);
  if (!F || n.has(S))
    return {};
  const q = l ? l[0] : s, T = (U) => {
    a && q.reportValidity && (q.setCustomValidity(er(U) ? "" : U || ""), q.reportValidity());
  }, E = {}, D = Xp(s), B = vo(s), ee = D || B, J = (j || Jp(s)) && ot(s.value) && ot(y) || Es(s) && s.value === "" || y === "" || Array.isArray(y) && !y.length, ae = K4.bind(null, S, i, E), Q = (U, O, H, Z = Mr.maxLength, ye = Mr.minLength) => {
    const ce = U ? O : H;
    E[S] = {
      type: U ? Z : ye,
      message: ce,
      ref: s,
      ...ae(U ? Z : ye, ce)
    };
  };
  if (o ? !Array.isArray(y) || !y.length : d && (!ee && (J || Vt(y)) || er(y) && !y || B && !OS(l).isValid || D && !AS(l).isValid)) {
    const { value: U, message: O } = ds(d) ? { value: !!d, message: d } : Di(d);
    if (U && (E[S] = {
      type: Mr.required,
      message: O,
      ref: q,
      ...ae(Mr.required, O)
    }, !i))
      return T(O), E;
  }
  if (!J && (!Vt(f) || !Vt(h))) {
    let U, O;
    const H = Di(h), Z = Di(f);
    if (!Vt(y) && !isNaN(y)) {
      const ye = s.valueAsNumber || y && +y;
      Vt(H.value) || (U = ye > H.value), Vt(Z.value) || (O = ye < Z.value);
    } else {
      const ye = s.valueAsDate || new Date(y), ce = (W) => /* @__PURE__ */ new Date((/* @__PURE__ */ new Date()).toDateString() + " " + W), le = s.type == "time", ue = s.type == "week";
      Dr(H.value) && y && (U = le ? ce(y) > ce(H.value) : ue ? y > H.value : ye > new Date(H.value)), Dr(Z.value) && y && (O = le ? ce(y) < ce(Z.value) : ue ? y < Z.value : ye < new Date(Z.value));
    }
    if ((U || O) && (Q(!!U, H.message, Z.message, Mr.max, Mr.min), !i))
      return T(E[S].message), E;
  }
  if ((m || u) && !J && (Dr(y) || o && Array.isArray(y))) {
    const U = Di(m), O = Di(u), H = !Vt(U.value) && y.length > +U.value, Z = !Vt(O.value) && y.length < +O.value;
    if ((H || Z) && (Q(H, U.message, O.message), !i))
      return T(E[S].message), E;
  }
  if (v && !J && Dr(y)) {
    const { value: U, message: O } = Di(v);
    if ($s(U) && !y.match(U) && (E[S] = {
      type: Mr.pattern,
      message: O,
      ref: s,
      ...ae(Mr.pattern, O)
    }, !i))
      return T(O), E;
  }
  if (C) {
    if (br(C)) {
      const U = await C(y, r), O = _b(U, q);
      if (O && (E[S] = {
        ...O,
        ...ae(Mr.validate, O.message)
      }, !i))
        return T(O.message), E;
    } else if (dt(C)) {
      let U = {};
      for (const O in C) {
        if (!Pt(U) && !i)
          break;
        const H = _b(await C[O](y, r), q, O);
        H && (U = {
          ...H,
          ...ae(O, H.message)
        }, T(H.message), i && (E[S] = U));
      }
      if (!Pt(U) && (E[S] = {
        ref: q,
        ...U
      }, !i))
        return E;
    }
  }
  return T(!0), E;
};
const aM = {
  mode: kr.onSubmit,
  reValidateMode: kr.onChange,
  shouldFocusError: !0
};
function oM(e = {}) {
  let n = {
    ...aM,
    ...e
  }, r = {
    submitCount: 0,
    isDirty: !1,
    isLoading: br(n.defaultValues),
    isValidating: !1,
    isSubmitted: !1,
    isSubmitting: !1,
    isSubmitSuccessful: !1,
    isValid: !1,
    touchedFields: {},
    dirtyFields: {},
    validatingFields: {},
    errors: n.errors || {},
    disabled: n.disabled || !1
  };
  const i = {};
  let a = dt(n.defaultValues) || dt(n.values) ? Nt(n.values || n.defaultValues) || {} : {}, o = n.shouldUnregister ? {} : Nt(a), s = {
    action: !1,
    mount: !1,
    watch: !1
  }, l = {
    mount: /* @__PURE__ */ new Set(),
    disabled: /* @__PURE__ */ new Set(),
    unMount: /* @__PURE__ */ new Set(),
    array: /* @__PURE__ */ new Set(),
    watch: /* @__PURE__ */ new Set()
  }, d, m = 0;
  const u = {
    isDirty: !1,
    dirtyFields: !1,
    validatingFields: !1,
    touchedFields: !1,
    isValidating: !1,
    isValid: !1,
    errors: !1
  };
  let f = {
    ...u
  };
  const h = {
    array: mb(),
    state: mb()
  }, v = gb(n.mode), C = gb(n.reValidateMode), S = n.criteriaMode === kr.all, j = (w) => (_) => {
    clearTimeout(m), m = setTimeout(w, _);
  }, F = async (w) => {
    if (!n.disabled && (u.isValid || f.isValid || w)) {
      const _ = n.resolver ? Pt((await J()).errors) : await Q(i, !0);
      _ !== r.isValid && h.state.next({
        isValid: _
      });
    }
  }, y = (w, _) => {
    !n.disabled && (u.isValidating || u.validatingFields || f.isValidating || f.validatingFields) && ((w || Array.from(l.mount)).forEach(($) => {
      $ && (_ ? Qn(r.validatingFields, $, _) : ht(r.validatingFields, $));
    }), h.state.next({
      validatingFields: r.validatingFields,
      isValidating: !Pt(r.validatingFields)
    }));
  }, q = (w, _ = [], $, G, Y = !0, R = !0) => {
    if (G && $ && !n.disabled) {
      if (s.action = !0, R && Array.isArray(Je(i, w))) {
        const z = $(Je(i, w), G.argA, G.argB);
        Y && Qn(i, w, z);
      }
      if (R && Array.isArray(Je(r.errors, w))) {
        const z = $(Je(r.errors, w), G.argA, G.argB);
        Y && Qn(r.errors, w, z), rM(r.errors, w);
      }
      if ((u.touchedFields || f.touchedFields) && R && Array.isArray(Je(r.touchedFields, w))) {
        const z = $(Je(r.touchedFields, w), G.argA, G.argB);
        Y && Qn(r.touchedFields, w, z);
      }
      (u.dirtyFields || f.dirtyFields) && (r.dirtyFields = Pa(a, o)), h.state.next({
        name: w,
        isDirty: O(w, _),
        dirtyFields: r.dirtyFields,
        errors: r.errors,
        isValid: r.isValid
      });
    } else
      Qn(o, w, _);
  }, T = (w, _) => {
    Qn(r.errors, w, _), h.state.next({
      errors: r.errors
    });
  }, E = (w) => {
    r.errors = w, h.state.next({
      errors: r.errors,
      isValid: !1
    });
  }, D = (w, _, $, G) => {
    const Y = Je(i, w);
    if (Y) {
      const R = Je(o, w, ot($) ? Je(a, w) : $);
      ot(R) || G && G.defaultChecked || _ ? Qn(o, w, _ ? R : yb(Y._f)) : ye(w, R), s.mount && F();
    }
  }, B = (w, _, $, G, Y) => {
    let R = !1, z = !1;
    const ie = {
      name: w
    };
    if (!n.disabled) {
      if (!$ || G) {
        (u.isDirty || f.isDirty) && (z = r.isDirty, r.isDirty = ie.isDirty = O(), R = z !== ie.isDirty);
        const pe = Zr(Je(a, w), _);
        z = !!Je(r.dirtyFields, w), pe ? ht(r.dirtyFields, w) : Qn(r.dirtyFields, w, !0), ie.dirtyFields = r.dirtyFields, R = R || (u.dirtyFields || f.dirtyFields) && z !== !pe;
      }
      if ($) {
        const pe = Je(r.touchedFields, w);
        pe || (Qn(r.touchedFields, w, $), ie.touchedFields = r.touchedFields, R = R || (u.touchedFields || f.touchedFields) && pe !== $);
      }
      R && Y && h.state.next(ie);
    }
    return R ? ie : {};
  }, ee = (w, _, $, G) => {
    const Y = Je(r.errors, w), R = (u.isValid || f.isValid) && er(_) && r.isValid !== _;
    if (n.delayError && $ ? (d = j(() => T(w, $)), d(n.delayError)) : (clearTimeout(m), d = null, $ ? Qn(r.errors, w, $) : ht(r.errors, w)), ($ ? !Zr(Y, $) : Y) || !Pt(G) || R) {
      const z = {
        ...G,
        ...R && er(_) ? { isValid: _ } : {},
        errors: r.errors,
        name: w
      };
      r = {
        ...r,
        ...z
      }, h.state.next(z);
    }
  }, J = async (w) => {
    y(w, !0);
    const _ = await n.resolver(o, n.context, J4(w || l.mount, i, n.criteriaMode, n.shouldUseNativeValidation));
    return y(w), _;
  }, ae = async (w) => {
    const { errors: _ } = await J(w);
    if (w)
      for (const $ of w) {
        const G = Je(_, $);
        G ? Qn(r.errors, $, G) : ht(r.errors, $);
      }
    else
      r.errors = _;
    return _;
  }, Q = async (w, _, $ = {
    valid: !0
  }) => {
    for (const G in w) {
      const Y = w[G];
      if (Y) {
        const { _f: R, ...z } = Y;
        if (R) {
          const ie = l.array.has(R.name), pe = Y._f && X4(Y._f);
          pe && u.validatingFields && y([G], !0);
          const _e = await xb(Y, l.disabled, o, S, n.shouldUseNativeValidation && !_, ie);
          if (pe && u.validatingFields && y([G]), _e[R.name] && ($.valid = !1, _))
            break;
          !_ && (Je(_e, R.name) ? ie ? iM(r.errors, _e, R.name) : Qn(r.errors, R.name, _e[R.name]) : ht(r.errors, R.name));
        }
        !Pt(z) && await Q(z, _, $);
      }
    }
    return $.valid;
  }, U = () => {
    for (const w of l.unMount) {
      const _ = Je(i, w);
      _ && (_._f.refs ? _._f.refs.every(($) => !Hu($)) : !Hu(_._f.ref)) && Ae(w);
    }
    l.unMount = /* @__PURE__ */ new Set();
  }, O = (w, _) => !n.disabled && (w && _ && Qn(o, w, _), !Zr(Ee(), a)), H = (w, _, $) => ES(w, l, {
    ...s.mount ? o : ot(_) ? a : Dr(w) ? { [w]: _ } : _
  }, $, _), Z = (w) => tl(Je(s.mount ? o : a, w, n.shouldUnregister ? Je(a, w, []) : [])), ye = (w, _, $ = {}) => {
    const G = Je(i, w);
    let Y = _;
    if (G) {
      const R = G._f;
      R && (!R.disabled && Qn(o, w, PS(_, R)), Y = Es(R.ref) && Vt(_) ? "" : _, $S(R.ref) ? [...R.ref.options].forEach((z) => z.selected = Y.includes(z.value)) : R.refs ? vo(R.ref) ? R.refs.length > 1 ? R.refs.forEach((z) => (!z.defaultChecked || !z.disabled) && (z.checked = Array.isArray(Y) ? !!Y.find((ie) => ie === z.value) : Y === z.value)) : R.refs[0] && (R.refs[0].checked = !!Y) : R.refs.forEach((z) => z.checked = z.value === Y) : Jp(R.ref) ? R.ref.value = "" : (R.ref.value = Y, R.ref.type || h.state.next({
        name: w,
        values: Nt(o)
      })));
    }
    ($.shouldDirty || $.shouldTouch) && B(w, Y, $.shouldTouch, $.shouldDirty, !0), $.shouldValidate && ke(w);
  }, ce = (w, _, $) => {
    for (const G in _) {
      const Y = _[G], R = `${w}.${G}`, z = Je(i, R);
      (l.array.has(w) || dt(Y) || z && !z._f) && !ui(Y) ? ce(R, Y, $) : ye(R, Y, $);
    }
  }, le = (w, _, $ = {}) => {
    const G = Je(i, w), Y = l.array.has(w), R = Nt(_);
    Qn(o, w, R), Y ? (h.array.next({
      name: w,
      values: Nt(o)
    }), (u.isDirty || u.dirtyFields || f.isDirty || f.dirtyFields) && $.shouldDirty && h.state.next({
      name: w,
      dirtyFields: Pa(a, o),
      isDirty: O(w, R)
    })) : G && !G._f && !Vt(R) ? ce(w, R, $) : ye(w, R, $), kb(w, l) && h.state.next({ ...r }), h.state.next({
      name: s.mount ? w : void 0,
      values: Nt(o)
    });
  }, ue = async (w) => {
    s.mount = !0;
    const _ = w.target;
    let $ = _.name, G = !0;
    const Y = Je(i, $), R = (z) => {
      G = Number.isNaN(z) || ui(z) && isNaN(z.getTime()) || Zr(z, Je(o, $, z));
    };
    if (Y) {
      let z, ie;
      const pe = _.type ? yb(Y._f) : wS(w), _e = w.type === Is.BLUR || w.type === Is.FOCUS_OUT, en = !Z4(Y._f) && !n.resolver && !Je(r.errors, $) && !Y._f.deps || tM(_e, Je(r.touchedFields, $), r.isSubmitted, C, v), un = kb($, l, _e);
      Qn(o, $, pe), _e ? (Y._f.onBlur && Y._f.onBlur(w), d && d(0)) : Y._f.onChange && Y._f.onChange(w);
      const rn = B($, pe, _e), dn = !Pt(rn) || un;
      if (!_e && h.state.next({
        name: $,
        type: w.type,
        values: Nt(o)
      }), en)
        return (u.isValid || f.isValid) && (n.mode === "onBlur" ? _e && F() : _e || F()), dn && h.state.next({ name: $, ...un ? {} : rn });
      if (!_e && un && h.state.next({ ...r }), n.resolver) {
        const { errors: pn } = await J([$]);
        if (R(pe), G) {
          const ln = bb(r.errors, i, $), kn = bb(pn, i, ln.name || $);
          z = kn.error, $ = kn.name, ie = Pt(pn);
        }
      } else
        y([$], !0), z = (await xb(Y, l.disabled, o, S, n.shouldUseNativeValidation))[$], y([$]), R(pe), G && (z ? ie = !1 : (u.isValid || f.isValid) && (ie = await Q(i, !0)));
      G && (Y._f.deps && ke(Y._f.deps), ee($, ie, z, rn));
    }
  }, W = (w, _) => {
    if (Je(r.errors, _) && w.focus)
      return w.focus(), 1;
  }, ke = async (w, _ = {}) => {
    let $, G;
    const Y = Ya(w);
    if (n.resolver) {
      const R = await ae(ot(w) ? w : Y);
      $ = Pt(R), G = w ? !Y.some((z) => Je(R, z)) : $;
    } else w ? (G = (await Promise.all(Y.map(async (R) => {
      const z = Je(i, R);
      return await Q(z && z._f ? { [R]: z } : z);
    }))).every(Boolean), !(!G && !r.isValid) && F()) : G = $ = await Q(i);
    return h.state.next({
      ...!Dr(w) || (u.isValid || f.isValid) && $ !== r.isValid ? {} : { name: w },
      ...n.resolver || !w ? { isValid: $ } : {},
      errors: r.errors
    }), _.shouldFocus && !G && Qa(i, W, w ? Y : l.mount), G;
  }, Ee = (w) => {
    const _ = {
      ...s.mount ? o : a
    };
    return ot(w) ? _ : Dr(w) ? Je(_, w) : w.map(($) => Je(_, $));
  }, K = (w, _) => ({
    invalid: !!Je((_ || r).errors, w),
    isDirty: !!Je((_ || r).dirtyFields, w),
    error: Je((_ || r).errors, w),
    isValidating: !!Je(r.validatingFields, w),
    isTouched: !!Je((_ || r).touchedFields, w)
  }), qe = (w) => {
    w && Ya(w).forEach((_) => ht(r.errors, _)), h.state.next({
      errors: w ? r.errors : {}
    });
  }, Be = (w, _, $) => {
    const G = (Je(i, w, { _f: {} })._f || {}).ref, Y = Je(r.errors, w) || {}, { ref: R, message: z, type: ie, ...pe } = Y;
    Qn(r.errors, w, {
      ...pe,
      ..._,
      ref: G
    }), h.state.next({
      name: w,
      errors: r.errors,
      isValid: !1
    }), $ && $.shouldFocus && G && G.focus && G.focus();
  }, Pe = (w, _) => br(w) ? h.state.subscribe({
    next: ($) => w(H(void 0, _), $)
  }) : H(w, _, !0), Me = (w) => h.state.subscribe({
    next: (_) => {
      nM(w.name, _.name, w.exact) && eM(_, w.formState || u, Re, w.reRenderRoot) && w.callback({
        values: { ...o },
        ...r,
        ..._
      });
    }
  }).unsubscribe, Fe = (w) => (s.mount = !0, f = {
    ...f,
    ...w.formState
  }, Me({
    ...w,
    formState: f
  })), Ae = (w, _ = {}) => {
    for (const $ of w ? Ya(w) : l.mount)
      l.mount.delete($), l.array.delete($), _.keepValue || (ht(i, $), ht(o, $)), !_.keepError && ht(r.errors, $), !_.keepDirty && ht(r.dirtyFields, $), !_.keepTouched && ht(r.touchedFields, $), !_.keepIsValidating && ht(r.validatingFields, $), !n.shouldUnregister && !_.keepDefaultValue && ht(a, $);
    h.state.next({
      values: Nt(o)
    }), h.state.next({
      ...r,
      ..._.keepDirty ? { isDirty: O() } : {}
    }), !_.keepIsValid && F();
  }, $e = ({ disabled: w, name: _ }) => {
    (er(w) && s.mount || w || l.disabled.has(_)) && (w ? l.disabled.add(_) : l.disabled.delete(_));
  }, tn = (w, _ = {}) => {
    let $ = Je(i, w);
    const G = er(_.disabled) || er(n.disabled);
    return Qn(i, w, {
      ...$ || {},
      _f: {
        ...$ && $._f ? $._f : { ref: { name: w } },
        name: w,
        mount: !0,
        ..._
      }
    }), l.mount.add(w), $ ? $e({
      disabled: er(_.disabled) ? _.disabled : n.disabled,
      name: w
    }) : D(w, !0, _.value), {
      ...G ? { disabled: _.disabled || n.disabled } : {},
      ...n.progressive ? {
        required: !!_.required,
        min: Aa(_.min),
        max: Aa(_.max),
        minLength: Aa(_.minLength),
        maxLength: Aa(_.maxLength),
        pattern: Aa(_.pattern)
      } : {},
      name: w,
      onChange: ue,
      onBlur: ue,
      ref: (Y) => {
        if (Y) {
          tn(w, _), $ = Je(i, w);
          const R = ot(Y.value) && Y.querySelectorAll && Y.querySelectorAll("input,select,textarea")[0] || Y, z = G4(R), ie = $._f.refs || [];
          if (z ? ie.find((pe) => pe === R) : R === $._f.ref)
            return;
          Qn(i, w, {
            _f: {
              ...$._f,
              ...z ? {
                refs: [
                  ...ie.filter(Hu),
                  R,
                  ...Array.isArray(Je(a, w)) ? [{}] : []
                ],
                ref: { type: R.type, name: w }
              } : { ref: R }
            }
          }), D(w, !1, void 0, R);
        } else
          $ = Je(i, w, {}), $._f && ($._f.mount = !1), (n.shouldUnregister || _.shouldUnregister) && !(CS(l.array, w) && s.action) && l.unMount.add(w);
      }
    };
  }, Ie = () => n.shouldFocusError && Qa(i, W, l.mount), We = (w) => {
    er(w) && (h.state.next({ disabled: w }), Qa(i, (_, $) => {
      const G = Je(i, $);
      G && (_.disabled = G._f.disabled || w, Array.isArray(G._f.refs) && G._f.refs.forEach((Y) => {
        Y.disabled = G._f.disabled || w;
      }));
    }, 0, !1));
  }, Ze = (w, _) => async ($) => {
    let G;
    $ && ($.preventDefault && $.preventDefault(), $.persist && $.persist());
    let Y = Nt(o);
    if (h.state.next({
      isSubmitting: !0
    }), n.resolver) {
      const { errors: R, values: z } = await J();
      r.errors = R, Y = z;
    } else
      await Q(i);
    if (l.disabled.size)
      for (const R of l.disabled)
        Qn(Y, R, void 0);
    if (ht(r.errors, "root"), Pt(r.errors)) {
      h.state.next({
        errors: {}
      });
      try {
        await w(Y, $);
      } catch (R) {
        G = R;
      }
    } else
      _ && await _({ ...r.errors }, $), Ie(), setTimeout(Ie);
    if (h.state.next({
      isSubmitted: !0,
      isSubmitting: !1,
      isSubmitSuccessful: Pt(r.errors) && !G,
      submitCount: r.submitCount + 1,
      errors: r.errors
    }), G)
      throw G;
  }, de = (w, _ = {}) => {
    Je(i, w) && (ot(_.defaultValue) ? le(w, Nt(Je(a, w))) : (le(w, _.defaultValue), Qn(a, w, Nt(_.defaultValue))), _.keepTouched || ht(r.touchedFields, w), _.keepDirty || (ht(r.dirtyFields, w), r.isDirty = _.defaultValue ? O(w, Nt(Je(a, w))) : O()), _.keepError || (ht(r.errors, w), u.isValid && F()), h.state.next({ ...r }));
  }, fe = (w, _ = {}) => {
    const $ = w ? Nt(w) : a, G = Nt($), Y = Pt(w), R = Y ? a : G;
    if (_.keepDefaultValues || (a = $), !_.keepValues) {
      if (_.keepDirtyValues) {
        const z = /* @__PURE__ */ new Set([
          ...l.mount,
          ...Object.keys(Pa(a, o))
        ]);
        for (const ie of Array.from(z))
          Je(r.dirtyFields, ie) ? Qn(R, ie, Je(o, ie)) : le(ie, Je(R, ie));
      } else {
        if (Gp && ot(w))
          for (const z of l.mount) {
            const ie = Je(i, z);
            if (ie && ie._f) {
              const pe = Array.isArray(ie._f.refs) ? ie._f.refs[0] : ie._f.ref;
              if (Es(pe)) {
                const _e = pe.closest("form");
                if (_e) {
                  _e.reset();
                  break;
                }
              }
            }
          }
        for (const z of l.mount)
          le(z, Je(R, z));
      }
      o = Nt(R), h.array.next({
        values: { ...R }
      }), h.state.next({
        values: { ...R }
      });
    }
    l = {
      mount: _.keepDirtyValues ? l.mount : /* @__PURE__ */ new Set(),
      unMount: /* @__PURE__ */ new Set(),
      array: /* @__PURE__ */ new Set(),
      disabled: /* @__PURE__ */ new Set(),
      watch: /* @__PURE__ */ new Set(),
      watchAll: !1,
      focus: ""
    }, s.mount = !u.isValid || !!_.keepIsValid || !!_.keepDirtyValues, s.watch = !!n.shouldUnregister, h.state.next({
      submitCount: _.keepSubmitCount ? r.submitCount : 0,
      isDirty: Y ? !1 : _.keepDirty ? r.isDirty : !!(_.keepDefaultValues && !Zr(w, a)),
      isSubmitted: _.keepIsSubmitted ? r.isSubmitted : !1,
      dirtyFields: Y ? {} : _.keepDirtyValues ? _.keepDefaultValues && o ? Pa(a, o) : r.dirtyFields : _.keepDefaultValues && w ? Pa(a, w) : _.keepDirty ? r.dirtyFields : {},
      touchedFields: _.keepTouched ? r.touchedFields : {},
      errors: _.keepErrors ? r.errors : {},
      isSubmitSuccessful: _.keepIsSubmitSuccessful ? r.isSubmitSuccessful : !1,
      isSubmitting: !1
    });
  }, Te = (w, _) => fe(br(w) ? w(o) : w, _), Le = (w, _ = {}) => {
    const $ = Je(i, w), G = $ && $._f;
    if (G) {
      const Y = G.refs ? G.refs[0] : G.ref;
      Y.focus && (Y.focus(), _.shouldSelect && br(Y.select) && Y.select());
    }
  }, Re = (w) => {
    r = {
      ...r,
      ...w
    };
  }, sn = {
    control: {
      register: tn,
      unregister: Ae,
      getFieldState: K,
      handleSubmit: Ze,
      setError: Be,
      _subscribe: Me,
      _runSchema: J,
      _getWatch: H,
      _getDirty: O,
      _setValid: F,
      _setFieldArray: q,
      _setDisabledField: $e,
      _setErrors: E,
      _getFieldArray: Z,
      _reset: fe,
      _resetDefaultValues: () => br(n.defaultValues) && n.defaultValues().then((w) => {
        Te(w, n.resetOptions), h.state.next({
          isLoading: !1
        });
      }),
      _removeUnmounted: U,
      _disableForm: We,
      _subjects: h,
      _proxyFormState: u,
      get _fields() {
        return i;
      },
      get _formValues() {
        return o;
      },
      get _state() {
        return s;
      },
      set _state(w) {
        s = w;
      },
      get _defaultValues() {
        return a;
      },
      get _names() {
        return l;
      },
      set _names(w) {
        l = w;
      },
      get _formState() {
        return r;
      },
      get _options() {
        return n;
      },
      set _options(w) {
        n = {
          ...n,
          ...w
        };
      }
    },
    subscribe: Fe,
    trigger: ke,
    register: tn,
    handleSubmit: Ze,
    watch: Pe,
    setValue: le,
    getValues: Ee,
    reset: Te,
    resetField: de,
    clearErrors: qe,
    unregister: Ae,
    setError: Be,
    setFocus: Le,
    getFieldState: K
  };
  return {
    ...sn,
    formControl: sn
  };
}
function sM(e = {}) {
  const n = je.useRef(void 0), r = je.useRef(void 0), [i, a] = je.useState({
    isDirty: !1,
    isValidating: !1,
    isLoading: br(e.defaultValues),
    isSubmitted: !1,
    isSubmitting: !1,
    isSubmitSuccessful: !1,
    isValid: !1,
    submitCount: 0,
    dirtyFields: {},
    touchedFields: {},
    validatingFields: {},
    errors: e.errors || {},
    disabled: e.disabled || !1,
    defaultValues: br(e.defaultValues) ? void 0 : e.defaultValues
  });
  n.current || (n.current = {
    ...e.formControl ? e.formControl : oM(e),
    formState: i
  }, e.formControl && e.defaultValues && !br(e.defaultValues) && e.formControl.reset(e.defaultValues, e.resetOptions));
  const o = n.current.control;
  return o._options = e, je.useLayoutEffect(() => o._subscribe({
    formState: o._proxyFormState,
    callback: () => a({ ...o._formState }),
    reRenderRoot: !0
  }), [o]), je.useEffect(() => o._disableForm(e.disabled), [o, e.disabled]), je.useEffect(() => {
    if (o._proxyFormState.isDirty) {
      const s = o._getDirty();
      s !== i.isDirty && o._subjects.state.next({
        isDirty: s
      });
    }
  }, [o, i.isDirty]), je.useEffect(() => {
    e.values && !Zr(e.values, r.current) ? (o._reset(e.values, o._options.resetOptions), r.current = e.values, a((s) => ({ ...s }))) : o._resetDefaultValues();
  }, [e.values, o]), je.useEffect(() => {
    e.errors && !Pt(e.errors) && o._setErrors(e.errors);
  }, [e.errors, o]), je.useEffect(() => {
    o._state.mount || (o._setValid(), o._state.mount = !0), o._state.watch && (o._state.watch = !1, o._subjects.state.next({ ...o._formState })), o._removeUnmounted();
  }), je.useEffect(() => {
    e.shouldUnregister && o._subjects.state.next({
      values: o._getWatch()
    });
  }, [e.shouldUnregister, o]), n.current.formState = IS(i, o), n.current;
}
const lM = "_settingsWrapper_1ycvy_1", cM = "_settingsWrapperHeader_1ycvy_6", dM = "_settingsWrapperContent_1ycvy_10", uM = "_settingsWrapperContentCode_1ycvy_18", mM = "_settingsWrapperContentCURL_1ycvy_26", La = {
  settingsWrapper: lM,
  settingsWrapperHeader: cM,
  settingsWrapperContent: dM,
  settingsWrapperContentCode: uM,
  settingsWrapperContentCURL: mM
}, pM = ({
  handleChangeText: e
}) => {
  const [n, r] = se(!1), { isCopied: i, copy: a } = nr(), { control: o } = sM({
    defaultValues: {
      storeId: "",
      secret: ""
    },
    mode: "onChange"
  }), s = TS({
    control: o
  }), l = s.storeId !== "" && s.secret !== "", d = tt(() => {
    const m = s.storeId, u = s.secret;
    return `curl --request POST \\
  --url https://api.yotpo.com/core/v3/stores/${m || "store_id"}/access_tokens \\
  --header 'Content-Type: application/json' \\
  --header 'accept: application/json'${u ? ` \\
  --data '{"secret":"${u}"}'` : ""}`;
  }, [s.storeId, s.secret]);
  return /* @__PURE__ */ Ce.jsx(Ce.Fragment, { children: /* @__PURE__ */ Ce.jsx(ze, { span: 6, children: /* @__PURE__ */ Ce.jsxs(b, { flexDirection: "column", className: La.settingsWrapper, children: [
    /* @__PURE__ */ Ce.jsxs(
      b,
      {
        gap: "200",
        alignItems: "center",
        className: La.settingsWrapperHeader,
        onClick: () => r(!n),
        children: [
          /* @__PURE__ */ Ce.jsx(A.Heading, { variant: "heading-3", children: "How to get the Yotpo access token" }),
          /* @__PURE__ */ Ce.jsx(me, { name: n ? "angle-down" : "angle-right" })
        ]
      }
    ),
    n && /* @__PURE__ */ Ce.jsxs(
      b,
      {
        flexDirection: "column",
        className: La.settingsWrapperContent,
        children: [
          /* @__PURE__ */ Ce.jsx(b, { margin: "0 0 400", children: /* @__PURE__ */ Ce.jsx(
            Rs,
            {
              variant: "announcement",
              headline: "In order to get the Yotpo access token, you have to follow the steps below",
              description: /* @__PURE__ */ Ce.jsxs("ol", { children: [
                /* @__PURE__ */ Ce.jsx("li", { children: "Insert the Yotpo store ID and secret below in the input fields" }),
                /* @__PURE__ */ Ce.jsx("li", { children: "Once the fields are filled in, the CURL command will appear below and you can copy and run it in your terminal" }),
                /* @__PURE__ */ Ce.jsxs("li", { children: [
                  "The response should look like this",
                  " ",
                  /* @__PURE__ */ Ce.jsx("span", { className: La.settingsWrapperContentCode, children: '{ "access_token": "this-is-your-token" }' })
                ] }),
                /* @__PURE__ */ Ce.jsxs("li", { children: [
                  "Copy the token without quotes and paste it in the",
                  " ",
                  /* @__PURE__ */ Ce.jsx("i", { children: "Yotpo access token" }),
                  " input field below"
                ] }),
                /* @__PURE__ */ Ce.jsx("li", { children: "Click the save button" })
              ] })
            }
          ) }),
          /* @__PURE__ */ Ce.jsx(
            ub,
            {
              name: "storeId",
              control: o,
              render: ({ field: m }) => /* @__PURE__ */ Ce.jsx(
                cr,
                {
                  label: "Yotpo store ID",
                  placeholder: "Please insert the store ID",
                  input: {
                    ...m,
                    onChange: (u) => {
                      m.onChange(u), e({
                        target: {
                          name: "yotpoStoreId",
                          value: u?.target.value ?? ""
                        }
                      });
                    }
                  }
                }
              )
            }
          ),
          /* @__PURE__ */ Ce.jsx(
            ub,
            {
              name: "secret",
              control: o,
              render: ({ field: m }) => /* @__PURE__ */ Ce.jsx(
                cr,
                {
                  label: "Yotpo secret",
                  placeholder: "Please insert the secret",
                  input: m
                }
              )
            }
          ),
          l && /* @__PURE__ */ Ce.jsxs(Ce.Fragment, { children: [
            /* @__PURE__ */ Ce.jsx(En, { label: "Generated CURL command", noAlert: !0, children: /* @__PURE__ */ Ce.jsx(
              b,
              {
                as: "pre",
                gap: "200",
                margin: "100 0 250",
                className: La.settingsWrapperContentCURL,
                children: d()
              }
            ) }),
            /* @__PURE__ */ Ce.jsx(b, { alignContent: "start", children: /* @__PURE__ */ Ce.jsx(
              Ge,
              {
                content: i ? "Copied!" : "Copy CURL command",
                children: /* @__PURE__ */ Ce.jsx(
                  Wn,
                  {
                    variant: "secondary",
                    icon: i ? "check-circle" : "copy",
                    onClick: () => a(d()),
                    children: "Copy CURL"
                  }
                )
              }
            ) })
          ] })
        ]
      }
    )
  ] }) }) });
}, fM = [
  {
    key: "showCustomerDetails",
    label: "Show customer details",
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "showUserGeneratedContent",
    label: "Show user generated content",
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "displayLoyalty",
    label: "Show loyalty data",
    secret: !1,
    type: "switch",
    defaultValue: !0
  }
], hM = [
  /**
   * The store ID will be fetched through the OAuth flow, so there's no real
   * reason to show it
   */
  {
    key: "yotpoStoreId",
    label: "Yotpo store ID",
    placeholder: "",
    readOnly: !0,
    required: !1,
    secret: !1,
    type: "hidden",
    hideOnCreate: !0
  },
  {
    key: "authorizeWithOauth",
    label: "Authorize with OAuth",
    secret: !1,
    type: "custom",
    hideOnCreate: !0,
    component: vi
  }
], yM = [
  {
    key: "accessTokenComponent",
    label: "Retrieve Yotpo access token",
    secret: !1,
    type: "custom",
    component: pM
  },
  {
    key: "yotpoStoreId",
    label: "Yotpo store ID",
    placeholder: 'See "How to get the Yotpo access token" above.',
    readOnly: !0,
    required: !0,
    secret: !1,
    type: "input"
  },
  {
    key: "yotpoAccessToken",
    label: "Yotpo access token",
    placeholder: "Insert the Yotpo access token",
    required: !0,
    secret: !0,
    type: "input"
  }
], gM = (e) => {
  switch (e) {
    case "input":
    case "hidden":
      return "";
    case "switch":
      return !1;
    default:
      return;
  }
}, vM = (e, n) => {
  switch (n) {
    case "input":
    case "hidden":
    case "select":
      return e;
    case "switch":
      return e === "true" ? !0 : e === "false" ? !1 : void 0;
    default:
      return;
  }
}, kM = ({
  hasShopifyOAuth: e = !1,
  isShopifyMarketplaceApp: n = !1,
  isCreationMode: r = !1
}) => r ? {
  authSettings: bV,
  featureSettings: []
} : n ? {
  authSettings: _V,
  featureSettings: [...tS]
} : e ? {
  authSettings: [
    ...jk,
    ...vV
  ],
  featureSettings: [...wk]
} : {
  authSettings: [
    ...jk,
    ...kV
  ],
  featureSettings: [...wk]
}, LS = (e, n) => ({
  hasOAuth: r = !1,
  isCreationMode: i = !1
}) => r || i ? e : n, bM = LS(
  hM,
  yM
), _M = LS(
  P$,
  A$
), VS = ({
  key: e,
  configuration: n,
  settingType: r,
  settingDefault: i
}) => {
  const a = n?.find(
    (l) => l.key === e
  ), o = vM(a?.value, r), s = i !== void 0 ? i : gM(
    r
  );
  return o !== void 0 ? o : s;
}, Zp = (e = {
  SHOPIFY: {},
  YOTPO: {},
  KLAVIYO: {}
}) => {
  const { SHOPIFY: n, YOTPO: r, KLAVIYO: i } = e, {
    authSettings: a,
    featureSettings: o
  } = kM(n), s = bM(r), l = _M(i);
  return {
    SHOPIFY: {
      widget: N3,
      icon: "shopify",
      iconColors: {
        contentColor: "rgb(148, 190, 69)",
        backgroundColor: "rgba(148, 190, 69, 0.1)"
      },
      settingsConfiguration: [
        ...a,
        ...o
      ]
    },
    JIRA: {
      widget: mT,
      icon: "jira",
      iconColors: {
        contentColor: "rgb(38, 132, 255)",
        backgroundColor: "rgba(38, 132, 255, 0.075)"
      },
      settingsConfiguration: [
        ...tv ? [...tv] : []
      ]
    },
    GITHUB: {
      widget: b1,
      icon: "github",
      iconColors: {
        contentColor: "rgb(87, 96, 106)",
        backgroundColor: "rgba(221, 244, 255, 0.75)"
      },
      settingsConfiguration: [..._1]
    },
    MIUROS: {
      widget: TL,
      icon: "miuros",
      iconColors: {
        contentColor: "rgb(246, 135, 179)",
        backgroundColor: "rgba(246, 135, 179, 0.15)"
      },
      settingsConfiguration: [...$L]
    },
    KLAVIYO: {
      widget: R$,
      icon: "klaviyo",
      iconColors: {
        contentColor: "rgb(0, 0, 0)",
        backgroundColor: "rgba(0, 0, 0, 0.075)"
      },
      settingsConfiguration: [...l, ...O$]
    },
    LINEAR: {
      widget: l2,
      icon: "linear",
      iconColors: {
        contentColor: "rgb(94, 106, 210)",
        backgroundColor: "rgba(94, 106, 210, 0.15)"
      },
      settingsConfiguration: [...c2],
      WidgetSettings: u2
    },
    VOYADO: {
      widget: _4,
      icon: "voyado",
      iconColors: {
        contentColor: "rgb(0, 0, 0)",
        backgroundColor: "rgba(0, 0, 0, 0.075)"
      },
      settingsConfiguration: [...x4]
    },
    LOYALTYLION: {
      widget: M2,
      icon: "loyaltylion",
      iconColors: {
        contentColor: "rgb(36, 31, 79)",
        backgroundColor: "rgba(36, 31, 79, 0.075)"
      },
      settingsConfiguration: [...B2]
    },
    RECHARGE: {
      widget: rV,
      icon: "recharge",
      iconColors: {
        contentColor: "rgb(57, 1, 241)",
        backgroundColor: "rgba(57, 1, 241, 0.075)"
      },
      settingsConfiguration: [...iV],
      WidgetSettings: oV
    },
    BRAZE: {
      widget: Tw,
      icon: "braze",
      iconColors: {
        contentColor: "rgb(48, 2, 102)",
        backgroundColor: "rgba(48, 2, 102, 0.075)"
      },
      settingsConfiguration: [...$w]
    },
    YOTPO: {
      widget: U4,
      icon: "yotpo",
      iconColors: {
        contentColor: "rgb(0, 66, 228)",
        backgroundColor: "rgba(0, 66, 228, 0.075)"
      },
      settingsConfiguration: [...s, ...fM]
    },
    INGRID: {
      widget: MI,
      icon: "ingrid",
      iconColors: {
        contentColor: "rgb(0, 0, 0)",
        backgroundColor: "rgba(0, 0, 0, 0.075)"
      },
      settingsConfiguration: [...BI],
      WidgetSettings: HI
    }
  };
}, xM = (e) => {
  const n = Zp();
  return e.map(
    ({
      id: r,
      type: i,
      name: a,
      settings: o,
      misconfigured: s,
      integrationKey: l
    }) => {
      const m = n[i], { settingsConfiguration: u } = m, f = u?.filter(({ secret: h }) => !h)?.map(
        ({
          key: h,
          type: v,
          defaultValue: C
        }) => ({
          key: h,
          value: VS({
            key: h,
            configuration: o,
            settingType: v,
            settingDefault: C
          })
        })
      );
      return {
        id: r,
        type: i,
        name: a,
        settings: f,
        misconfigured: s,
        icon: m.icon,
        iconColors: m.iconColors,
        widget: m.widget,
        integrationKey: l
      };
    }
  );
}, gB = ({
  widgets: e,
  configuration: n,
  conversationContext: r,
  showNotification: i,
  onToggleFn: a,
  isOpenFn: o,
  isMinimized: s,
  renderVisibilityToggleElement: l,
  renderDragElement: d
}) => {
  const m = mi(
    {}
  ), u = (T) => (m.current[T] || (m.current[T] = { current: null }), m.current[T]), { track: f } = bn(), h = Bn(
    () => xM(e),
    [e]
  ), v = {
    headline: "",
    text: "",
    onConfirm: () => q(),
    confirmLabel: "Confirm",
    confirmVariant: "primary"
  }, [C, S] = se(v), [j, F] = se(!1), y = (T) => {
    F(!0), S(T);
  }, q = () => {
    F(!1), S(v);
  };
  return /* @__PURE__ */ Ue.jsxs(Ue.Fragment, { children: [
    h.map(
      ({
        id: T,
        name: E,
        type: D,
        widget: B,
        settings: ee,
        misconfigured: J,
        icon: ae,
        iconColors: Q,
        integrationKey: U
      }, O) => {
        const H = `partner-integration-${D}`, Z = /* @__PURE__ */ Ue.jsx(Vm, { icon: ae, color: Q }), ye = ee?.reduce(
          (ce, le) => (ce[le.key] = le.value, ce),
          {}
        );
        return s ? /* @__PURE__ */ Ue.jsx("div", { className: "icon-holder", children: Z }, `partner-icon-${T}`) : /* @__PURE__ */ Ue.jsxs(
          lr,
          {
            onToggle: () => {
              f(
                o(U) ? "widget:collapse:closed" : "widget:collapse:opened",
                {
                  widgetId: T,
                  widgetType: D.toLowerCase()
                }
              ), a(U);
            },
            isOpen: o(U),
            className: H,
            containerRef: (ce) => {
              u(U).current = ce;
            },
            children: [
              /* @__PURE__ */ Ue.jsx(
                lr.Header,
                {
                  wrap: "normal",
                  avatar: Z,
                  slotBeforeTitle: d?.(
                    U,
                    O,
                    u(U)
                  ),
                  slotAfterTitle: l?.(U),
                  children: E
                }
              ),
              /* @__PURE__ */ Ue.jsx(lr.Content, { children: J ? /* @__PURE__ */ Ue.jsx(Fn, { isMisconfigured: !0 }) : /* @__PURE__ */ Ue.jsx(
                Pb.Provider,
                {
                  value: {
                    onError: (ce, le) => console.warn(
                      `Something went wrong with a partner widget of type '${D}' and id '${T}'`,
                      ce,
                      le
                    )
                  },
                  children: /* @__PURE__ */ Ue.jsx(
                    y_,
                    {
                      integrationId: T,
                      type: D,
                      configuration: n,
                      showNotification: i,
                      showModal: y,
                      children: d0(B, {
                        conversationContext: r,
                        settings: ye
                      })
                    }
                  )
                }
              ) })
            ]
          },
          U
        );
      }
    ),
    /* @__PURE__ */ Ue.jsx(
      Rb,
      {
        isOpen: j,
        setIsOpen: F,
        headline: C.headline,
        text: C.text,
        confirmLabel: C.confirmLabel,
        confirmVariant: C.confirmVariant,
        cancelLabel: C.cancelLabel,
        cancelVariant: C.cancelVariant,
        onConfirm: C.onConfirm ? () => {
          try {
            C.onConfirm && C.onConfirm();
          } finally {
            F(!1), S(v);
          }
        } : void 0,
        onCancel: C.onCancel ? () => {
          try {
            C.onCancel && C.onCancel();
          } finally {
            F(!1), S(v);
          }
        } : void 0,
        children: C.children
      }
    )
  ] });
}, SM = Os`
  query getWidgetConfigurations {
    Management {
      widgetConfigurations {
        id
        type
        enabled
        name
        misconfigured
        settings {
          key
          value
        }
      }
    }
  }
`;
function vB(e, { skip: n = !1 } = {}) {
  const [r, i] = se([]), [a, o] = se(!1);
  return He(() => {
    if (n) {
      o(!1);
      return;
    }
    let s = !1;
    return o(!0), h_(e).query({
      query: SM
    }).then(({ data: l }) => {
      s || (i(
        (l?.Management?.widgetConfigurations ?? []).filter(
          (d) => d != null
        ).map((d) => ({
          ...d,
          integrationKey: `partner-integration-${d.id}`
        }))
      ), o(!1));
    }).catch(() => {
      s || o(!1);
    }), () => {
      s = !0;
    };
  }, [e, n]), {
    isLoading: a,
    widgets: r
  };
}
const NM = ({
  widgetConfiguration: e
}) => {
  const n = Bn(() => (e?.additionalProperties ?? {}).isUsingOAuth ?? !1, [e]), r = Bn(() => (e?.additionalProperties ?? {}).tokenSource === "marketplace_app", [e]);
  return {
    hasShopifyWidgetOAuth: n,
    isShopifyMarketplaceApp: r,
    initialValuesForShopify: []
  };
}, jM = "FULL_ACCESS", wM = "2", CM = ({
  type: e,
  baseUrl: n
}) => {
  const r = `${e}-partner-widget-${Date.now().toString()}`, i = n.replace("partner-integrations", "api"), a = () => {
    let l;
    try {
      l = JSON.parse(localStorage.authData);
    } catch {
    }
    return l?.access_token || "";
  };
  return {
    deleteDixaApiToken: (l) => fetch(`${i}/v1/auth/api-tokens/${l}`, {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Basic ${window.btoa(`token:${a()}`)}`
      }
    }).then((d) => d.json()),
    createDixaApiToken: () => fetch(`${i}/v1/auth/api-tokens-v2`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Basic ${window.btoa(`token:${a()}`)}`
      },
      body: JSON.stringify({
        name: r,
        scopes: [jM],
        version: wM
      })
    }).then((l) => l.json())
  };
}, FM = "dixaApiToken", ef = "dixaApiTokenId", zS = "dixaApiTokenName", Sb = (e) => [ef, zS].every(
  (r) => e.find((i) => i?.key === r)
);
function IM({
  token: e,
  settings: n
}) {
  if (n.length === 0)
    return [];
  const r = EM(e), i = (o, s) => o?.find((l) => l?.key === s);
  return n.map((o) => {
    const s = o && i(r, o.key);
    return i(n, o?.key) && s ? s : o;
  });
}
const EM = (e) => [
  {
    key: FM,
    value: e.value,
    secret: !0
  },
  {
    key: ef,
    value: e.id,
    secret: !1
  },
  {
    key: zS,
    value: e.name,
    secret: !1
  }
], TM = "_wrapper_1lmim_1", $M = "_wrapperBox_1lmim_4", DM = "_wrapperBoxErrorBorder_1lmim_9", Wu = {
  wrapper: TM,
  wrapperBox: $M,
  wrapperBoxErrorBorder: DM
}, RM = ({
  required: e,
  readOnly: n,
  isSecret: r,
  isCreationMode: i,
  label: a,
  settings: o,
  widgetSettingsKey: s,
  meta: l,
  handleEditSecret: d,
  handleChangeText: m
}) => {
  const f = o?.find(
    (q) => q.type === "basicAuthInput"
  )?.additionalProperties, { username: h, password: v } = f, C = `Insert your ${h.label.toLowerCase()}`, S = `Insert your ${v.label.toLowerCase()}`, [j, F] = se({
    username: "",
    password: ""
  }), y = tt(
    (q) => {
      m({
        target: {
          name: s,
          value: q
        }
      });
    },
    [s, m]
  );
  return He(() => {
    y(
      j.username !== "" && j.password !== "" ? window.btoa(`${j.username}:${j.password}`) : ""
    );
  }, [j]), /* @__PURE__ */ Ue.jsx(
    En,
    {
      required: e,
      label: a,
      meta: l,
      className: Wu.wrapper,
      children: /* @__PURE__ */ Ue.jsxs(
        b,
        {
          gap: "300",
          flexDirection: "column",
          className: rt(Wu.wrapperBox, {
            [Wu.wrapperBoxErrorBorder]: !!l?.error
          }),
          children: [
            /* @__PURE__ */ Ue.jsx(
              cr,
              {
                noAlert: !0,
                required: e,
                label: h.label,
                readOnly: n,
                placeholder: C,
                input: {
                  name: s,
                  value: j.username,
                  onChange: (q) => F({
                    username: q?.target.value ?? "",
                    password: j.password
                  })
                },
                ...r && !i && {
                  prefix: {
                    type: "button",
                    button: {
                      icon: "close",
                      onClick: () => d(!1, s)
                    }
                  }
                }
              }
            ),
            /* @__PURE__ */ Ue.jsx(
              cr,
              {
                noAlert: !0,
                required: e,
                label: v.label,
                readOnly: n,
                placeholder: S,
                input: {
                  name: s,
                  value: j.password,
                  onChange: (q) => F({
                    username: j.username,
                    password: q?.target.value ?? ""
                  })
                },
                ...r && !i && {
                  prefix: {
                    type: "button",
                    button: {
                      icon: "close",
                      onClick: () => d(!1, s)
                    }
                  }
                }
              }
            )
          ]
        }
      )
    }
  );
};
function Nb({
  isSecret: e,
  widgetSettingsKey: n,
  label: r,
  required: i,
  readOnly: a,
  placeholder: o,
  handleChangeText: s,
  handleChangeBoolean: l,
  handleChangeSelect: d,
  handleEditSecret: m,
  getValueByKey: u,
  isEditingField: f,
  errors: h,
  type: v,
  isCreationMode: C,
  prefix: S,
  integrationId: j,
  integrationType: F,
  configuration: y,
  settings: q,
  otherProps: T
}) {
  const E = v === "custom" && T?.component, D = u(n)?.value;
  return E ? /* @__PURE__ */ Ue.jsx(
    E,
    {
      configuration: y,
      integrationId: j,
      integrationType: F,
      label: r,
      settings: q,
      getValueByKey: u,
      widgetSettingsKey: n,
      handleChangeSelect: d,
      handleChangeText: s,
      handleChangeBoolean: l
    }
  ) : /* @__PURE__ */ Ue.jsxs(Ue.Fragment, { children: [
    /* @__PURE__ */ Ue.jsx(ze, { span: 3, children: /* @__PURE__ */ Ue.jsx(
      OM,
      {
        widgetSettingsKey: n,
        label: r,
        isEditingField: f,
        handleEditSecret: m,
        isCreationMode: C,
        children: v === "input" ? /* @__PURE__ */ Ue.jsx(
          cr,
          {
            required: i,
            readOnly: a,
            label: r,
            placeholder: o,
            input: {
              name: n,
              value: D,
              onChange: s
            },
            meta: { error: h[n] },
            prefix: S,
            ...e && !C && {
              prefix: {
                type: "button",
                button: {
                  icon: "close",
                  onClick: () => m(!1, n)
                }
              }
            }
          }
        ) : v === "basicAuthInput" ? /* @__PURE__ */ Ue.jsx(
          RM,
          {
            required: i,
            readOnly: a,
            isSecret: e,
            isCreationMode: C,
            label: r,
            widgetSettingsKey: n,
            settings: q,
            meta: { error: h[n] },
            handleEditSecret: m,
            handleChangeText: s
          }
        ) : v === "switch" ? /* @__PURE__ */ Ue.jsx(En, { label: r, children: /* @__PURE__ */ Ue.jsx(
          Ab,
          {
            input: {
              name: n,
              value: "",
              checked: D,
              onChange: l
            }
          }
        ) }) : v === "select" ? /* @__PURE__ */ Ue.jsx(En, { label: r, children: /* @__PURE__ */ Ue.jsx(
          Qr,
          {
            required: i,
            clearable: !0,
            placeholder: o,
            readOnly: a,
            onChange: (B) => d(n, B),
            getItemTitleByValue: (B) => B ? /* @__PURE__ */ Ue.jsx(A.Paragraph, { children: B.label }) : /* @__PURE__ */ Ue.jsx(Ue.Fragment, {}),
            value: D ? [
              {
                label: (T?.selectItems || []).find(
                  (B) => B.value === D
                )?.label,
                value: D
              }
            ] : [],
            equalityFn: (B, ee) => B.value === ee.value,
            children: (T?.selectItems || []).map((B) => /* @__PURE__ */ Ue.jsx(st.Item, { value: B, children: B.label }, B.value))
          }
        ) }) : /* @__PURE__ */ Ue.jsx(Ue.Fragment, {})
      }
    ) }),
    /* @__PURE__ */ Ue.jsx(ze, { span: 3 })
  ] });
}
function OM({
  widgetSettingsKey: e,
  label: n,
  isEditingField: r,
  handleEditSecret: i,
  children: a,
  isCreationMode: o
}) {
  return r || o ? a : /* @__PURE__ */ Ue.jsx(En, { label: n, children: /* @__PURE__ */ Ue.jsxs(
    Wn,
    {
      "data-testid": `secret-field-button-${e}`,
      variant: "secondary",
      icon: "pen",
      onClick: () => i(!0, e),
      children: [
        "Update ",
        n
      ]
    }
  ) });
}
const Ja = "partner-integrations-widget-name-form-field", jb = ({
  settingsFromBackend: e,
  settingsConfiguration: n,
  creating: r = !1
}) => n.filter(({ type: i }) => i !== "custom").map(
  ({
    key: i,
    required: a,
    secret: o,
    type: s,
    defaultValue: l,
    customValidation: d
  }) => ({
    key: i,
    value: VS({
      key: i,
      configuration: e,
      settingType: s,
      settingDefault: l
    }),
    required: a,
    secret: o,
    // The property `isEditing` is used in order to show/hide the input field in
    // case it is a secret setting. However, when we create a widget we _always_
    // want to show the input field because it will be the first time that the user
    // enters a value for it.
    //
    // We have two scenarios here:
    // 1) When initializing
    //   - the setting is secret=true so we set isEditing=false and hide the input.
    //   - the setting is secret=false, so we set isEditing=true and show the input.
    // 2) We create a widget (creating=true), so we set isEditing=true in
    //    order to show the input.
    isEditing: r ? !0 : !o,
    type: s,
    ...d && { customValidation: d }
  })
), PM = ({
  initialValues: e,
  onSubmit: n
}) => {
  const [r, i] = se(
    e || {
      enabled: !1,
      name: "",
      settings: []
    }
  ), [a, o] = se({}), s = (T) => i(T), l = (T) => !T || T === "", d = (T) => {
    const { [T]: E, ...D } = a;
    o(D);
  }, m = (T) => ({
    ...T,
    settings: T.settings.filter(({ isEditing: E }) => E).map(({ key: E, value: D, secret: B }) => ({
      key: E,
      value: D,
      secret: B
    }))
  }), u = {
    input: "This can not be empty",
    basicAuthInput: "Please insert a value for both fields"
  }, f = (T) => {
    if (!T)
      return;
    const {
      target: { name: E, value: D }
    } = T;
    a[E] && !l(D) && d(E), i({
      ...r,
      settings: r.settings.map(
        (B) => B.key === E ? { ...B, value: D } : B
      )
    });
  }, h = (T) => {
    if (!T)
      return;
    const {
      target: { name: E, checked: D }
    } = T;
    i({
      ...r,
      settings: r.settings.map(
        (B) => B.key === E ? { ...B, value: D } : B
      )
    });
  }, v = (T, E) => {
    if (!E)
      return;
    const { selectedValues: D } = E, B = D?.[0];
    if (B) {
      const ee = r.settings.map(
        (J) => J.key === T ? { ...J, value: B?.value } : J
      );
      i({
        ...r,
        settings: ee
      });
    } else {
      const ee = r.settings.filter(
        (J) => J.key !== T
      );
      i({
        ...r,
        settings: ee
      });
    }
  }, C = (T) => {
    i({
      ...r,
      enabled: T
    });
  }, S = (T) => {
    if (!T)
      return;
    const {
      target: { value: E }
    } = T;
    a[Ja] && !l(E) && d(Ja), i({
      ...r,
      name: E
    });
  }, j = (T, E) => {
    const { settings: D } = r, B = D.map((ee) => ee.key === E ? {
      ...ee,
      isEditing: T,
      ...!T && { value: "" }
    } : ee);
    a[E] && !T && d(E), i({
      ...r,
      settings: B
    });
  }, F = (T) => r.settings.find(
    (E) => E.key === T
  ), y = async (T) => {
    T.preventDefault(), q() && n(m(r));
  }, q = () => {
    const T = {}, { name: E, settings: D } = r;
    return l(E) && (T[Ja] = u.input), D.forEach(
      ({ key: B, value: ee, required: J, isEditing: ae, type: Q, customValidation: U }) => {
        if (J && ae)
          if (U) {
            const O = U(ee);
            typeof O == "string" && (T[B] = O);
          } else
            typeof ee == "string" && l(ee) && (T[B] = u[Q]);
      }
    ), o(T), !Object.keys(T)?.length;
  };
  return {
    formData: r,
    errors: a,
    handleIsEnabled: C,
    handleChangeText: f,
    handleChangeBoolean: h,
    handleChangeSelect: v,
    handleEditSecret: j,
    handleChangeName: S,
    handleSubmit: y,
    getSettingValueByKey: F,
    initializeFormData: s,
    validate: q
  };
}, AM = [
  "GITHUB",
  "JIRA",
  "LINEAR"
], wb = "The configuration of the integration is not correct. Please check the settings.", LM = (e) => {
  const n = Zp()[e.type]?.WidgetSettings;
  return n ? /* @__PURE__ */ Ue.jsx(n, { ...e }) : /* @__PURE__ */ Ue.jsx(VM, { ...e });
}, VM = ({
  integrationId: e,
  type: n,
  handleRedirect: r,
  showNotification: i,
  configuration: a,
  automationCouplingState: o
}) => {
  const { track: s } = bn(), { deleteDixaApiToken: l, createDixaApiToken: d } = CM({
    type: n,
    baseUrl: a.baseUrl
  }), u = F0().pathname.match(
    /^\/settings\/integrations\/partner-widget\/[a-zA-Z0-9]*\/create$/
  ), f = !e && !!n && !!u, h = AM.includes(n), [v, C] = se(), [S, j] = se(!1), [F, y] = se(!1), [q, T] = se(!1), [E, D] = se(null), [B, ee] = se(), { isInboundOAuth: J } = t0(), ae = J && f ? "Submit & Authorize" : "Submit", {
    hasShopifyWidgetOAuth: Q,
    isShopifyMarketplaceApp: U,
    initialValuesForShopify: O
  } = NM({
    featureFlags: a.featureFlags,
    widgetConfiguration: B
  }), H = n === "YOTPO" && !!B?.additionalProperties?.isUsingOAuth, Z = n === "KLAVIYO" && !!B?.additionalProperties?.isUsingOAuth, ye = f && n === "SHOPIFY", ue = Zp({
    SHOPIFY: {
      hasShopifyOAuth: Q,
      isShopifyMarketplaceApp: U,
      isCreationMode: f
    },
    YOTPO: {
      hasOAuth: H,
      isCreationMode: f
    },
    KLAVIYO: {
      hasOAuth: Z,
      isCreationMode: f
    }
  })[n].settingsConfiguration, W = ue.filter(({ type: w }) => w !== "hidden").filter(({ hideOnCreate: w }) => f ? !w : !0), ke = W.filter(
    ({ additionalProperties: w }) => w?.renderAboveForm === !0
  ), Ee = W.filter(
    ({ additionalProperties: w }) => w?.renderAboveForm !== !0
  ), {
    error: K,
    loading: qe,
    refetch: Be
  } = j0(r0, {
    variables: {
      id: e
    },
    // skip wants either `true` to literally skip the query,
    // or `undefined` to run the query. A simple `false` will
    // still run the query, therefore checking here for the
    // negated `integrationId` instead.
    skip: !e,
    onCompleted: (w) => {
      if (Object.keys(w).length === 0)
        T(!0);
      else {
        T(!1);
        const _ = w?.Management?.widgetConfigurations?.[0];
        _ && ee({
          ..._,
          // Not needed here, just to satisfy the type
          integrationKey: `partner-integration-${_.id}`,
          additionalProperties: _.additionalProperties ?? void 0
        });
      }
    }
  }), [Pe, { error: Me }] = rf(
    f ? i0 : a0,
    {
      onError: (w) => {
        C(w), j(!1), i({
          title: "Something went wrong",
          text: `The ${f ? "creation" : "update"} of the widget was not successful.`,
          icon: "exclamation-triangle-filled",
          severity: "warning"
        });
      },
      onCompleted: (w) => {
        if (j(!1), Object.keys(w).length !== 0) {
          if (f && r(
            w.Management?.createWidgetConfiguration?.id
          ), !f) {
            const $ = w.Management?.updateWidgetConfiguration;
            $?.misconfigured ? D(
              $.misconfigurationCause ?? wb
            ) : D(null);
          }
          i({
            title: `${f ? "Creating" : "Updating"} was successful`,
            text: `${f ? "Creating" : "Updating"} the widget was successful.`,
            icon: "check-circle-filled",
            severity: "success"
          });
        } else
          i({
            title: "Something went wrong",
            text: `The ${f ? "creation" : "update"} of the widget was not successful.`,
            icon: "exclamation-triangle-filled",
            severity: "warning"
          });
      }
    }
  ), [Fe] = rf(o0, {
    onError: (w) => {
      C(w), j(!1), i({
        title: "Something went wrong",
        text: "The deletion of the widget was not successful.",
        icon: "exclamation-triangle-filled",
        severity: "warning"
      });
    },
    onCompleted: () => {
      j(!1), r(), i({
        title: "Deletion was successful",
        text: "The deletion of the widget was successful.",
        icon: "check-circle-filled",
        severity: "success"
      });
    }
  }), {
    formData: Ae,
    handleIsEnabled: $e,
    errors: tn,
    handleChangeText: Ie,
    handleChangeBoolean: We,
    handleChangeSelect: Ze,
    handleEditSecret: de,
    handleChangeName: fe,
    handleSubmit: Te,
    getSettingValueByKey: Le,
    initializeFormData: Re
  } = PM({
    onSubmit: async (w) => {
      f ? s("settings:create:submitted", { widgetType: n }) : e && s("settings:view:change:submitted", {
        widgetId: e,
        widgetType: n
      }), j(!0);
      const _ = w.settings.map(
        (R) => typeof R.value == "boolean" ? { ...R, value: R.value.toString() } : R
      ), $ = Sb(_) && f;
      let G = [];
      if ($) {
        const R = await d().catch(
          (z) => {
            j(!1), console.warn("API-Token (creation) error resonse", z), i({
              title: "Something went wrong",
              text: "The creation of the API-Token was not successful and therefore the widget creation was aborted. Please try again later.",
              icon: "exclamation-triangle-filled",
              severity: "warning"
            });
          }
        );
        R?.data && (G = IM({
          token: R.data,
          settings: _
        }));
      }
      const Y = {
        ...w,
        settings: [
          ...G.length > 0 ? G : _
        ]
      };
      ($ && G.length > 1 || !$ && G.length === 0) && (Pe({
        variables: {
          ...!f && { id: e },
          ...f && { type: n },
          ...Y
        }
      }), _.forEach(
        (R) => R.secret && de(!1, R.key)
      ));
    },
    ...f && {
      initialValues: {
        enabled: !1,
        name: "",
        settings: jb({
          settingsFromBackend: O,
          settingsConfiguration: ue,
          creating: !0
        })
      }
    }
  });
  He(() => {
    if (B) {
      const w = jb({
        settingsFromBackend: B.settings,
        settingsConfiguration: ue
      });
      Re({
        enabled: !!B.enabled,
        name: B.name,
        settings: w
      }), B.misconfigured ? D(
        B?.misconfigurationCause ?? wb
      ) : D(null);
    }
  }, [B]);
  const sn = Bn(() => o ? !o.isCoupled : !0, [o]);
  return K || Me || v ? /* @__PURE__ */ Ue.jsx(
    Fn,
    {
      error: K || v,
      retry: K ? Be : void 0
    }
  ) : S || qe ? /* @__PURE__ */ Ue.jsx(cn, { "data-testid": "widget-settings-loading" }) : q ? /* @__PURE__ */ Ue.jsxs(A.Paragraph, { children: [
    "A widget with the id ",
    /* @__PURE__ */ Ue.jsx(An, { children: e }),
    " does not exist."
  ] }) : /* @__PURE__ */ Ue.jsxs("form", { children: [
    E && /* @__PURE__ */ Ue.jsx(b, { margin: "0 0 400", children: /* @__PURE__ */ Ue.jsx(
      Rs,
      {
        variant: "fail",
        headline: "This integration is misconfigured",
        description: /* @__PURE__ */ Ue.jsxs(b, { gap: "300", flexDirection: "column", children: [
          /* @__PURE__ */ Ue.jsx(A.Paragraph, { children: E }),
          /* @__PURE__ */ Ue.jsxs(b, { flexDirection: "column", gap: "100", children: [
            /* @__PURE__ */ Ue.jsx(A.Heading, { variant: "heading-3", children: "Additional information" }),
            /* @__PURE__ */ Ue.jsx(A.Paragraph, { children: "While the integration is in a misconfigured state, its content is not shown in the sidebar. Instead, we show a message that hints the agent to get in touch with the administrator." })
          ] })
        ] })
      }
    ) }),
    /* @__PURE__ */ Ue.jsxs(
      vt,
      {
        "data-testid": `widget-settings-form-${e ?? "create-new"}`,
        children: [
          ke.map(
            ({ key: w, label: _, ...$ }) => /* @__PURE__ */ Ue.jsx(
              Nb,
              {
                widgetSettingsKey: w,
                isEditingField: !1,
                handleEditSecret: () => {
                },
                handleChangeText: () => {
                },
                handleChangeBoolean: () => {
                },
                handleChangeSelect: () => {
                },
                getValueByKey: Le,
                isSecret: !1,
                label: _,
                placeholder: "",
                required: !1,
                errors: tn,
                type: "custom",
                isCreationMode: f,
                integrationId: e,
                integrationType: n,
                configuration: a,
                settings: ue,
                otherProps: $
              },
              w
            )
          ),
          !ye && /* @__PURE__ */ Ue.jsxs(Ue.Fragment, { children: [
            /* @__PURE__ */ Ue.jsx(ze, { children: /* @__PURE__ */ Ue.jsx(En, { label: "Show the widget in the conversation sidebar", children: /* @__PURE__ */ Ue.jsx(
              Ab,
              {
                input: {
                  name: "enabled",
                  checked: Ae.enabled,
                  value: "dummy",
                  onChange: (w) => $e(w.target.checked)
                }
              }
            ) }) }),
            /* @__PURE__ */ Ue.jsx(ze, { span: 3, children: /* @__PURE__ */ Ue.jsx(
              cr,
              {
                required: !0,
                label: "Widget name",
                placeholder: "Insert the name of the widget",
                input: {
                  name: Ja,
                  value: Ae.name,
                  onChange: fe
                },
                meta: {
                  error: tn[Ja]
                }
              }
            ) }),
            /* @__PURE__ */ Ue.jsx(ze, { span: 3 })
          ] }),
          Ee?.map(
            ({
              key: w,
              secret: _,
              label: $,
              placeholder: G = "",
              required: Y = !1,
              type: R,
              prefix: z,
              readOnly: ie,
              ...pe
            }) => {
              const { settings: _e } = Ae, en = _e.find(
                (un) => un.key === w
              );
              return /* @__PURE__ */ Ue.jsx(u0, { children: /* @__PURE__ */ Ue.jsx(
                Nb,
                {
                  widgetSettingsKey: w,
                  isEditingField: !!en?.isEditing,
                  handleEditSecret: de,
                  handleChangeText: Ie,
                  handleChangeBoolean: We,
                  handleChangeSelect: Ze,
                  getValueByKey: Le,
                  isSecret: _,
                  label: $,
                  placeholder: G,
                  required: Y,
                  errors: tn,
                  type: R,
                  isCreationMode: f,
                  prefix: z,
                  integrationId: e,
                  integrationType: n,
                  configuration: a,
                  readOnly: ie,
                  settings: ue,
                  otherProps: pe
                }
              ) }, w);
            }
          )
        ]
      }
    ),
    !ye && /* @__PURE__ */ Ue.jsxs(b, { margin: "300 0 0 0", children: [
      /* @__PURE__ */ Ue.jsx(Wn, { onClick: Te, children: ae }),
      !f && /* @__PURE__ */ Ue.jsx(
        Ge,
        {
          content: "The widget is used in automations",
          disabled: sn,
          children: /* @__PURE__ */ Ue.jsx(
            Wn,
            {
              style: { marginLeft: 20 },
              icon: "trash",
              variant: "secondary",
              onClick: () => {
                e && s("settings:view:delete:requested", {
                  widgetId: e,
                  widgetType: n
                }), y(!0);
              },
              disabled: !sn,
              isLoading: o?.isLoading,
              children: "Delete"
            }
          )
        }
      )
    ] }),
    /* @__PURE__ */ Ue.jsx(
      Rb,
      {
        isOpen: F,
        setIsOpen: y,
        confirmVariant: h ? "danger" : "primary",
        confirmLabel: "Yes",
        cancelLabel: "No",
        onCancel: () => {
          e && s("settings:view:delete:canceled", {
            widgetId: e,
            widgetType: n
          });
        },
        onConfirm: () => {
          if (e && s("settings:view:delete:confirmed", {
            widgetId: e,
            widgetType: n
          }), Sb(Ae.settings)) {
            const w = Ae.settings.find(
              ({ key: _ }) => _ === ef
            )?.value;
            w && l(w).catch((_) => {
              console.warn("API-Token (deletion) error response", _), i({
                title: "Something went wrong",
                text: "The deletion of the API-Token was not successful. Please have a look in Settings > Integrations > Api-Tokens to find your token and remove it manually.",
                icon: "exclamation-triangle-filled",
                severity: "warning"
              });
            });
          }
          Fe({
            variables: {
              id: e
            }
          });
        },
        children: /* @__PURE__ */ Ue.jsx(b, { children: h ? /* @__PURE__ */ Ue.jsxs(b, { gap: "400", children: [
          /* @__PURE__ */ Ue.jsx(
            me,
            {
              size: 24,
              name: "exclamation-triangle-filled",
              color: "red.500"
            }
          ),
          /* @__PURE__ */ Ue.jsxs(b, { gap: "200", flexDirection: "column", children: [
            /* @__PURE__ */ Ue.jsxs(A.Heading, { withMarginBottom: !0, children: [
              "By deleting the ",
              n,
              " integration, all links between Dixa and ",
              n,
              " are also deleted."
            ] }),
            /* @__PURE__ */ Ue.jsxs(A.Paragraph, { children: [
              "All data in ",
              n,
              " stays untouched."
            ] }),
            /* @__PURE__ */ Ue.jsxs(A.Paragraph, { children: [
              "Are you sure you want to delete the ",
              n,
              " ",
              'integration "',
              Ae.name,
              '"?'
            ] })
          ] })
        ] }) : /* @__PURE__ */ Ue.jsxs(Ue.Fragment, { children: [
          "Are you sure you want to delete the ",
          n,
          ' integration "',
          Ae.name,
          '"?'
        ] }) })
      }
    )
  ] });
}, kB = ({
  configuration: e,
  integrationId: n,
  type: r,
  handleRedirect: i,
  showNotification: a,
  automationCouplingState: o
}) => /* @__PURE__ */ Ue.jsx(
  Pb.Provider,
  {
    value: {
      onError: (s, l) => console.warn(
        `Something went wrong with the partner widget settings of type ${r} and id ${n}`,
        s,
        l
      )
    },
    children: /* @__PURE__ */ Ue.jsx(
      y_,
      {
        integrationId: n,
        type: r,
        configuration: e,
        showNotification: a,
        children: /* @__PURE__ */ Ue.jsx(
          LM,
          {
            configuration: e,
            integrationId: n,
            type: r,
            handleRedirect: i,
            showNotification: a,
            automationCouplingState: o
          }
        )
      }
    )
  }
), Cb = "__PairingContext__", US = globalThis[Cb] ?? (() => {
  const e = Ob({});
  return globalThis[Cb] = e, e;
})(), bB = () => Am(US), _B = ({
  value: e,
  children: n
}) => /* @__PURE__ */ Ue.jsx(US.Provider, { value: e, children: n });
var Go = { exports: {} }, Fb;
function zM() {
  if (Fb) return Go.exports;
  Fb = 1;
  var e = typeof Reflect == "object" ? Reflect : null, n = e && typeof e.apply == "function" ? e.apply : function(E, D, B) {
    return Function.prototype.apply.call(E, D, B);
  }, r;
  e && typeof e.ownKeys == "function" ? r = e.ownKeys : Object.getOwnPropertySymbols ? r = function(E) {
    return Object.getOwnPropertyNames(E).concat(Object.getOwnPropertySymbols(E));
  } : r = function(E) {
    return Object.getOwnPropertyNames(E);
  };
  function i(T) {
    console && console.warn && console.warn(T);
  }
  var a = Number.isNaN || function(E) {
    return E !== E;
  };
  function o() {
    o.init.call(this);
  }
  Go.exports = o, Go.exports.once = F, o.EventEmitter = o, o.prototype._events = void 0, o.prototype._eventsCount = 0, o.prototype._maxListeners = void 0;
  var s = 10;
  function l(T) {
    if (typeof T != "function")
      throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof T);
  }
  Object.defineProperty(o, "defaultMaxListeners", {
    enumerable: !0,
    get: function() {
      return s;
    },
    set: function(T) {
      if (typeof T != "number" || T < 0 || a(T))
        throw new RangeError('The value of "defaultMaxListeners" is out of range. It must be a non-negative number. Received ' + T + ".");
      s = T;
    }
  }), o.init = function() {
    (this._events === void 0 || this._events === Object.getPrototypeOf(this)._events) && (this._events = /* @__PURE__ */ Object.create(null), this._eventsCount = 0), this._maxListeners = this._maxListeners || void 0;
  }, o.prototype.setMaxListeners = function(E) {
    if (typeof E != "number" || E < 0 || a(E))
      throw new RangeError('The value of "n" is out of range. It must be a non-negative number. Received ' + E + ".");
    return this._maxListeners = E, this;
  };
  function d(T) {
    return T._maxListeners === void 0 ? o.defaultMaxListeners : T._maxListeners;
  }
  o.prototype.getMaxListeners = function() {
    return d(this);
  }, o.prototype.emit = function(E) {
    for (var D = [], B = 1; B < arguments.length; B++) D.push(arguments[B]);
    var ee = E === "error", J = this._events;
    if (J !== void 0)
      ee = ee && J.error === void 0;
    else if (!ee)
      return !1;
    if (ee) {
      var ae;
      if (D.length > 0 && (ae = D[0]), ae instanceof Error)
        throw ae;
      var Q = new Error("Unhandled error." + (ae ? " (" + ae.message + ")" : ""));
      throw Q.context = ae, Q;
    }
    var U = J[E];
    if (U === void 0)
      return !1;
    if (typeof U == "function")
      n(U, this, D);
    else
      for (var O = U.length, H = C(U, O), B = 0; B < O; ++B)
        n(H[B], this, D);
    return !0;
  };
  function m(T, E, D, B) {
    var ee, J, ae;
    if (l(D), J = T._events, J === void 0 ? (J = T._events = /* @__PURE__ */ Object.create(null), T._eventsCount = 0) : (J.newListener !== void 0 && (T.emit(
      "newListener",
      E,
      D.listener ? D.listener : D
    ), J = T._events), ae = J[E]), ae === void 0)
      ae = J[E] = D, ++T._eventsCount;
    else if (typeof ae == "function" ? ae = J[E] = B ? [D, ae] : [ae, D] : B ? ae.unshift(D) : ae.push(D), ee = d(T), ee > 0 && ae.length > ee && !ae.warned) {
      ae.warned = !0;
      var Q = new Error("Possible EventEmitter memory leak detected. " + ae.length + " " + String(E) + " listeners added. Use emitter.setMaxListeners() to increase limit");
      Q.name = "MaxListenersExceededWarning", Q.emitter = T, Q.type = E, Q.count = ae.length, i(Q);
    }
    return T;
  }
  o.prototype.addListener = function(E, D) {
    return m(this, E, D, !1);
  }, o.prototype.on = o.prototype.addListener, o.prototype.prependListener = function(E, D) {
    return m(this, E, D, !0);
  };
  function u() {
    if (!this.fired)
      return this.target.removeListener(this.type, this.wrapFn), this.fired = !0, arguments.length === 0 ? this.listener.call(this.target) : this.listener.apply(this.target, arguments);
  }
  function f(T, E, D) {
    var B = { fired: !1, wrapFn: void 0, target: T, type: E, listener: D }, ee = u.bind(B);
    return ee.listener = D, B.wrapFn = ee, ee;
  }
  o.prototype.once = function(E, D) {
    return l(D), this.on(E, f(this, E, D)), this;
  }, o.prototype.prependOnceListener = function(E, D) {
    return l(D), this.prependListener(E, f(this, E, D)), this;
  }, o.prototype.removeListener = function(E, D) {
    var B, ee, J, ae, Q;
    if (l(D), ee = this._events, ee === void 0)
      return this;
    if (B = ee[E], B === void 0)
      return this;
    if (B === D || B.listener === D)
      --this._eventsCount === 0 ? this._events = /* @__PURE__ */ Object.create(null) : (delete ee[E], ee.removeListener && this.emit("removeListener", E, B.listener || D));
    else if (typeof B != "function") {
      for (J = -1, ae = B.length - 1; ae >= 0; ae--)
        if (B[ae] === D || B[ae].listener === D) {
          Q = B[ae].listener, J = ae;
          break;
        }
      if (J < 0)
        return this;
      J === 0 ? B.shift() : S(B, J), B.length === 1 && (ee[E] = B[0]), ee.removeListener !== void 0 && this.emit("removeListener", E, Q || D);
    }
    return this;
  }, o.prototype.off = o.prototype.removeListener, o.prototype.removeAllListeners = function(E) {
    var D, B, ee;
    if (B = this._events, B === void 0)
      return this;
    if (B.removeListener === void 0)
      return arguments.length === 0 ? (this._events = /* @__PURE__ */ Object.create(null), this._eventsCount = 0) : B[E] !== void 0 && (--this._eventsCount === 0 ? this._events = /* @__PURE__ */ Object.create(null) : delete B[E]), this;
    if (arguments.length === 0) {
      var J = Object.keys(B), ae;
      for (ee = 0; ee < J.length; ++ee)
        ae = J[ee], ae !== "removeListener" && this.removeAllListeners(ae);
      return this.removeAllListeners("removeListener"), this._events = /* @__PURE__ */ Object.create(null), this._eventsCount = 0, this;
    }
    if (D = B[E], typeof D == "function")
      this.removeListener(E, D);
    else if (D !== void 0)
      for (ee = D.length - 1; ee >= 0; ee--)
        this.removeListener(E, D[ee]);
    return this;
  };
  function h(T, E, D) {
    var B = T._events;
    if (B === void 0)
      return [];
    var ee = B[E];
    return ee === void 0 ? [] : typeof ee == "function" ? D ? [ee.listener || ee] : [ee] : D ? j(ee) : C(ee, ee.length);
  }
  o.prototype.listeners = function(E) {
    return h(this, E, !0);
  }, o.prototype.rawListeners = function(E) {
    return h(this, E, !1);
  }, o.listenerCount = function(T, E) {
    return typeof T.listenerCount == "function" ? T.listenerCount(E) : v.call(T, E);
  }, o.prototype.listenerCount = v;
  function v(T) {
    var E = this._events;
    if (E !== void 0) {
      var D = E[T];
      if (typeof D == "function")
        return 1;
      if (D !== void 0)
        return D.length;
    }
    return 0;
  }
  o.prototype.eventNames = function() {
    return this._eventsCount > 0 ? r(this._events) : [];
  };
  function C(T, E) {
    for (var D = new Array(E), B = 0; B < E; ++B)
      D[B] = T[B];
    return D;
  }
  function S(T, E) {
    for (; E + 1 < T.length; E++)
      T[E] = T[E + 1];
    T.pop();
  }
  function j(T) {
    for (var E = new Array(T.length), D = 0; D < E.length; ++D)
      E[D] = T[D].listener || T[D];
    return E;
  }
  function F(T, E) {
    return new Promise(function(D, B) {
      function ee(ae) {
        T.removeListener(E, J), B(ae);
      }
      function J() {
        typeof T.removeListener == "function" && T.removeListener("error", ee), D([].slice.call(arguments));
      }
      q(T, E, J, { once: !0 }), E !== "error" && y(T, ee, { once: !0 });
    });
  }
  function y(T, E, D) {
    typeof T.on == "function" && q(T, "error", E, D);
  }
  function q(T, E, D, B) {
    if (typeof T.on == "function")
      B.once ? T.once(E, D) : T.on(E, D);
    else if (typeof T.addEventListener == "function")
      T.addEventListener(E, function ee(J) {
        B.once && T.removeEventListener(E, ee), D(J);
      });
    else
      throw new TypeError('The "emitter" argument must be of type EventEmitter. Received type ' + typeof T);
  }
  return Go.exports;
}
var UM = zM();
function xB() {
  const e = new UM.EventEmitter();
  return e && typeof window < "u" ? window._partner = {
    events: e
  } : console.warn(
    "Initialization of partner-integration events was not successfull."
  ), e;
}
export {
  ew as GraphQLClientProvider,
  US as PairingContext,
  _B as PairingProvider,
  gB as PartnerIntegrations,
  kB as PartnerIntegrationsSettings,
  Zp as getWidgetDefinitions,
  xB as initializePartnerEventEmitter,
  bB as usePairing,
  vB as usePartnerIntegrationWidgetConfigurations,
  NM as useShopifyConfiguration
};
